package xyz.qwewqa.relive.simulator.core.gen

/*
2243:
  _id_: 2243
  attribute_id: 6
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2244:
  _id_: 2244
  attribute_id: 6
  cost: 3
  description:
    en: High damage to front enemy. Act Power up to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体にACTパワーアップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的ACT力量
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Slash
    ja: 奮起の斬撃
    ko: 분기의 참격
    zh_hant: 奮起斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2245:
  _id_: 2245
  attribute_id: 6
  cost: 3
  description:
    en: High damage to front enemy. Low Brilliance recovery to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体のキラめきを少し回復する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 반짝임을 조금 회복
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並回復所有我方少許的光芒
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Synchro Slash
    ja: 呼応の斬撃
    ko: 호응의 참격
    zh_hant: 呼應斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 11
    - 12
    - 13
    - 15
2246:
  _id_: 2246
  attribute_id: 6
  cost: 2
  description:
    en: Perfect Aim High damage to all enemies, ignoring Aggro, Provoke, Barrier,
      Reflect and Invincible. Applies Stage Effect [We Are on the Stage (Cloud)] to
      allies' stage.
    ja: 敵全体に威力(大)の必中攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（雲）」を付与する この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する
    ko: 적 전체에게 타깃 고정, 도발, 배리어, 반사, 무적을 무시한 위력(대) 백발백중 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대
      위(구름)]을 부여
    zh_hant: 對所有敵人發動威力（大）的必中攻擊，並賦予我方的舞台舞台效果「我們已經站上舞台（雲）」 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵
  icon_id: 1006
  is_multiple_command_unique_skill: 0
  name:
    en: I will protect them! Forever... Again and again!
    ja: 私が守るの、ずっと何度でも
    ko: 내가 지키겠어, 언제까지고 몇 번이든
    zh_hant: 不管多少次我都會守護的。
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1470
  skill_field_effect_id: 10
  skill_options:
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
2290:
  _id_: 2290
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵を威力(小)で攻撃 自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1505
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2291:
  _id_: 2291
  attribute_id: 1
  cost: 3
  description:
    en: High damage to front enemy. Normal and Special Defense up to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体に通常防御力アップ、特殊防御力アップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 일반 방어력 증가, 특수 방어력 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的普通防禦力和特殊防禦力
  icon_id: 10
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Bravery
    ja: 剛勇の斬撃
    ko: 용감의 참격
    zh_hant: 勇猛斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
  - hit_rate: 100
    id: 12
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
2292:
  _id_: 2292
  attribute_id: 1
  cost: 3
  description:
    en: High damage to front enemy. Medium Brilliance recovery to 2 allies with the
      highest Act Power.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、ACTパワーが高い2体の味方のキラめきを(中)回復する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, ACT 파워가 높은 아군 2명의 반짝임(중) 회복
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並回復ACT力量較高的2名我方的光芒（中）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Glittering Slash
    ja: 煌星の斬撃
    ko: 기라성의 참격
    zh_hant: 閃耀之星斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1127
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 23
    - 25
    - 27
    - 30
2293:
  _id_: 2293
  attribute_id: 1
  cost: 2
  description:
    en: Very High damage to all enemies. Brilliance Recovery and Brilliance Regen
      to all allies. Applies Stage Effect [We Are on the Stage (Flower)] to allies'
      stage.
    ja: 敵全体に威力(大+)の攻撃を行い、味方全体のキラめきを回復、毎ターンキラめき回復を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（花）」を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 전체의 반짝임을 회복, 매 턴 반짝임 회복을 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대
      위(꽃)]을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，回復所有我方的光芒，並賦予每回合光芒回復效果，同時賦予我方的舞台舞台效果「我們已經站上舞台（花）」
  icon_id: 1001
  is_multiple_command_unique_skill: 0
  name:
    en: We will all do Starlight!
    ja: みんなを、スタァライト！しちゃいます！！
    ko: 모두를 스타라이트! 하겠습니다!!
    zh_hant: 我會令大家星光照耀的！！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1508
  skill_field_effect_id: 2
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 10
    - 10
    - 10
    - 10
2295:
  _id_: 2295
  attribute_id: 2
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1510
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2296:
  _id_: 2296
  attribute_id: 2
  cost: 3
  description:
    en: High damage to front enemy. Agility up to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体にすばやさアップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 민첩 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的敏捷
  icon_id: 14
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Slash
    ja: 疾風の斬撃
    ko: 질풍의 참격
    zh_hant: 疾風斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1511
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2297:
  _id_: 2297
  attribute_id: 2
  cost: 3
  description:
    en: High damage to front enemy. Evasion x1 to 3 front allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、前から3体の味方に回避を付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 앞에서 3명의 아군에게 회피를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並賦予前面3名我方迴避
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: Thunderclap Slash
    ja: 迅雷の斬撃
    ko: 우레의 참격
    zh_hant: 迅雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1512
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 34
    target_id: 1133
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2298:
  _id_: 2298
  attribute_id: 2
  cost: 3
  description:
    en: High damage & AP Up to all enemies. AP Down to all allies. Applies Stage Effect
      [We Are on the Stage (Wind)] to allies' stage.
    ja: 敵全体に威力(大)の攻撃を行いAP増加を付与し、味方全体にAP減少を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（風）」を付与する
    ko: 적 전체에게 위력(대) 공격, AP 증가 부여, 아군 전체에게 AP 감소를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(바람)]을
      부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予AP增加效果，以及給予所有我方AP減少效果，同時賦予我方的舞台舞台效果「我們已經站上舞台（風）」
  icon_id: 1002
  is_multiple_command_unique_skill: 0
  name:
    en: I'll have you follow me till the very end!
    ja: 最後までつきおうてもらうで！
    ko: 끝까지 저와 함께하도록 해요!
    zh_hant: 你就陪我到最後一刻吧！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1513
  skill_field_effect_id: 4
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2300:
  _id_: 2300
  attribute_id: 5
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1515
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2301:
  _id_: 2301
  attribute_id: 5
  cost: 2
  description:
    en: Low damage & HP recovery down to all enemies.
    ja: 敵全体に威力(小)の攻撃を行い、HP回復量ダウンを付与する
    ko: 적 전체에게 위력(소) 공격, HP 회복량 감소를 부여
    zh_hant: 對所有敵人發動威力（小）攻擊，並降低HP回復量
  icon_id: 65
  is_multiple_command_unique_skill: 0
  name:
    en: Cursed Slash
    ja: 呪歌の斬撃
    ko: 저주 노래의 참격
    zh_hant: 咒歌斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1516
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 42
    - 44
    - 47
    - 50
  - hit_rate: 100
    id: 65
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
2302:
  _id_: 2302
  attribute_id: 5
  cost: 3
  description:
    en: High damage to front enemy. Normal Defense down to all enemies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、敵全体に通常防御力ダウンを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 일반 방어력 감소를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並降低所有敵人的普通防禦力
  icon_id: 11
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Slash
    ja: 弛緩の斬撃
    ko: 이완의 참격
    zh_hant: 遲緩斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1517
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
2303:
  _id_: 2303
  attribute_id: 5
  cost: 2
  description:
    en: HP recovery down & High damage to all enemies. Applies Stage Effect [We Are
      on the Stage (Space)] to allies' stage.
    ja: 敵全体にHP回復量ダウンを付与し、威力(大)の攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（宙）」を付与する
    ko: 적 전체에게 HP 회복량 감소를 부여, 위력(대) 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(우주)]를 부여
    zh_hant: 降低所有敵人的HP回復量，並發動威力（大）攻擊，同時賦予我方的舞台舞台效果「我們已經站上舞台（宙）」
  icon_id: 1005
  is_multiple_command_unique_skill: 0
  name:
    en: I will dash forth with fighting spirit!
    ja: 気合入れて、突っ走ります！
    ko: 정신 바짝 차리고 달리겠습니다!
    zh_hant: 拿出幹勁向前衝！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1518
  skill_field_effect_id: 8
  skill_options:
  - hit_rate: 100
    id: 65
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
2419:
  _id_: 2419
  attribute_id: 3
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Snipe
    ja: 強撃
    ko: 강격
    zh_hant: 強擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1622
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2420:
  _id_: 2420
  attribute_id: 3
  cost: 3
  description:
    en: High damage to front enemy. Damage Received down to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体に被ダメージダウンを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 받는 대미지 감소를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並降低所有我方受到的傷害
  icon_id: 114
  is_multiple_command_unique_skill: 0
  name:
    en: Blessed Strike
    ja: 加護の一撃
    ko: 가호의 일격
    zh_hant: 加護一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1623
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 126
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
2421:
  _id_: 2421
  attribute_id: 3
  cost: 3
  description:
    en: High damage to front enemy. Low Brilliance recovery to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体のキラめきを少し回復する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 반짝임을 조금 회복
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並回復所有我方少許的光芒
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Synchro Strike
    ja: 呼応の一撃
    ko: 호응의 일격
    zh_hant: 呼應一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 11
    - 12
    - 13
    - 15
2422:
  _id_: 2422
  attribute_id: 3
  cost: 2
  description:
    en: Act Power up & Climax Act Power up to all allies. High damage to all enemies.
      Applies Stage Effect [We Are on the Stage (Snow)] to allies' stage.
    ja: 味方全体にACTパワーアップ、クライマックスACT威力アップを付与し、敵全体に威力(大)の攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（雪）」を付与する
    ko: 아군 전체에게 ACT 파워 증가, 클라이맥스 ACT 위력 증가를 부여, 적 전체에게 위력(대) 공격, 아군 쪽 무대에 무대 효과 [우리는
      이미 무대 위(눈)]을 부여
    zh_hant: 提升所有我方的ACT力量、CLIMAX ACT威力，並對所有敵人發動威力（大）攻擊，同時賦予我方的舞台舞台效果「我們已經站上舞台（雪）」
  icon_id: 1003
  is_multiple_command_unique_skill: 0
  name:
    en: I'll take hold of a star of my own!
    ja: 掴んでみせます、自分星！
    ko: 붙잡아 보이겠습니다, 자신별!
    zh_hant: 我會抓住，自己的星光！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1625
  skill_field_effect_id: 5
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 40
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
2424:
  _id_: 2424
  attribute_id: 1
  cost: 2
  description:
    en: Medium+ damage to front 3 enemies.
    ja: 前から3体の敵に威力(中+)の攻撃
    ko: 앞에서 3명의 적에게 위력(중+) 공격
    zh_hant: 對前方的3個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
2425:
  _id_: 2425
  attribute_id: 1
  cost: 3
  description:
    en: High damage to front enemy. Agility down to all enemies.
    ja: 前から1体の敵に威力(大)の攻撃を行い、敵全体にすばやさダウンを付与する
    ko: 앞에서 1명의 적에게 위력(대) 공격, 적 전체에게 민첩 감소를 부여
    zh_hant: 對前方的1個敵人發動威力（大）攻擊，並降低所有敵人的敏捷
  icon_id: 15
  is_multiple_command_unique_skill: 0
  name:
    en: Sluggish Smash
    ja: 鈍重の打撃
    ko: 둔중의 타격
    zh_hant: 沉重敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 15
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2426:
  _id_: 2426
  attribute_id: 1
  cost: 3
  description:
    en: High damage to front 3 enemies. Dexterity up & Critical up to 2 allies with
      the highest Act Power.
    ja: 前から3体の敵に威力(大)の攻撃を行い、ACTパワーの高い味方2体にクリティカル率アップ、クリティカル威力アップを付与する
    ko: 앞에서 3명의 적에게 위력(대) 공격, ACT 파워가 높은 아군 2명에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 對前方的3個敵人發動威力（大）攻擊，並提升ACT力量高的我方2名的會心率與會心威力
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 102
    - 106
    - 111
    - 116
  - hit_rate: 100
    id: 20
    target_id: 1127
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1127
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2427:
  _id_: 2427
  attribute_id: 1
  cost: 2
  description:
    en: Very High damage & Accuracy Rate Down to all enemies. Fortitude 1 hit to all
      allies. Applies Stage Effect [We Are on the Stage (Flower)] to allies' stage.
    ja: 敵全体に威力(大+)の攻撃を行い、命中率ダウンを付与し、味方全体に不屈を1付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（花）」を付与する
    ko: 적 전체에게 위력(대+) 공격, 명중률 감소를 부여, 아군 전체에게 불굴 1회를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대
      위(꽃)]을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予命中率降低。同時賦予所有我方不屈1次，並賦予我方的舞台舞台效果「我們已經站上舞台（花）」
  icon_id: 1001
  is_multiple_command_unique_skill: 0
  name:
    en: I was the one...who was always by your side.
    ja: ずっとそばに居たのは……わたしなんだよ？
    ko: 늘 곁에 있었던 사람은...나잖아?
    zh_hant: 一直陪在你身邊的……可是我啊？
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1630
  skill_field_effect_id: 3
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
  - hit_rate: 100
    id: 36
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2514:
  _id_: 2514
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1708
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2515:
  _id_: 2515
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1709
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2516:
  _id_: 2516
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1710
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2517:
  _id_: 2517
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1711
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2518:
  _id_: 2518
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 1 front enemies.
    ja: 前から1体の敵に強力な多段攻撃
    ko: 앞에서 1명의 적에게 강력한 다단 공격
    zh_hant: 對前方的1個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poison Slash
    ja: 猛斬撃
    ko: 용맹한 참격
    zh_hant: 猛斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1712
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
2519:
  _id_: 2519
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1713
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2520:
  _id_: 2520
  attribute_id: 7
  cost: 2
  description:
    en: Low damage & Poison to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃し、毒を付与
    ko: 앞에서 3명의 적에게 위력(소) 공격, 독을 부여
    zh_hant: 對前方的3個敵人發動威力（小）攻擊，並造成中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Jack-o-Lantern Ripper NEO
    ja: ジャックオランタン・リッパー  NEO
    ko: 잭오랜턴 리퍼 NEO
    zh_hant: 傑克南瓜燈撕裂斬  NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1714
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
2522:
  _id_: 2522
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1715
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2523:
  _id_: 2523
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1716
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2524:
  _id_: 2524
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1717
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2525:
  _id_: 2525
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1718
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2526:
  _id_: 2526
  attribute_id: 5
  cost: 2
  description:
    en: Set chance to inflict Burn to all enemies.
    ja: 敵全体に確率で火傷を付与
    ko: 적 전체에게 일정 확률로 화상을 부여
    zh_hant: 機率性賦予所有敵人燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1719
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
2527:
  _id_: 2527
  attribute_id: 5
  cost: 2
  description:
    en: Normal Barrier to self.
    ja: 自身に通常バリア付与
    ko: 자신에게 일반 배리어를 부여
    zh_hant: 賦予自己普通防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1720
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
2528:
  _id_: 2528
  attribute_id: 5
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1721
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2529:
  _id_: 2529
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 1 front enemy.
    ja: 自身に必中を付与し、前から1体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pumpkin Trick NEO
    ja: パンプキントリック NEO
    ko: 펌프킨 트릭 NEO
    zh_hant: 南瓜戲法 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1722
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2531:
  _id_: 2531
  attribute_id: 7
  cost: 1
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1723
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2532:
  _id_: 2532
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1724
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2533:
  _id_: 2533
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1725
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2534:
  _id_: 2534
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1726
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2535:
  _id_: 2535
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1727
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2536:
  _id_: 2536
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1728
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2537:
  _id_: 2537
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 rear enemies.
    ja: 後から3体の敵に多段攻撃
    ko: 뒤에서 3명의 적에게 다단 공격
    zh_hant: 對後方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1729
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2538:
  _id_: 2538
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to 3 rear enemies.
    ja: 後から3体の敵にACTパワーダウン付与
    ko: 뒤에서 3명의 적에게 ACT 파워 감소를 부여
    zh_hant: 降低後方3個敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1730
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2539:
  _id_: 2539
  attribute_id: 7
  cost: 3
  description:
    en: Multi-hit attack to 3 rear enemies.
    ja: 後から3体の敵に多段攻撃
    ko: 뒤에서 3명의 적에게 다단 공격
    zh_hant: 對後方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bat Shrine NEO
    ja: コウモリおみこし NEO
    ko: 박쥐 가마 NEO
    zh_hant: 蝙蝠神轎 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1731
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2541:
  _id_: 2541
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1732
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2542:
  _id_: 2542
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1733
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2543:
  _id_: 2543
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1734
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2544:
  _id_: 2544
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1735
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2545:
  _id_: 2545
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1736
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2546:
  _id_: 2546
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1737
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2547:
  _id_: 2547
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1738
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2548:
  _id_: 2548
  attribute_id: 5
  cost: 2
  description:
    en: Set chance to inflict Poison & Blindness to all enemies.
    ja: 敵全体に確率で毒と暗闇付与
    ko: 적 전체에게 일정 확률로 독, 암흑을 부여
    zh_hant: 機率性賦予所有敵人中毒和盲目
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Noxious Flower
    ja: 暗闇の毒花
    ko: 암흑의 독화
    zh_hant: 黑暗毒花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1739
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6000
    - 6000
    - 6000
    - 6000
    - 6000
  - hit_rate: 50
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2549:
  _id_: 2549
  attribute_id: 5
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1740
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2550:
  _id_: 2550
  attribute_id: 5
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1741
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2551:
  _id_: 2551
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪　NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪　NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1742
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2553:
  _id_: 2553
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1743
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2554:
  _id_: 2554
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1744
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2555:
  _id_: 2555
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1745
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2556:
  _id_: 2556
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1746
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2557:
  _id_: 2557
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に強力な多段攻撃
    ko: 앞에서 3명의 적에게 강력한 다단 공격
    zh_hant: 對前方的3個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poison Triple Slash
    ja: 猛参撃
    ko: 용맹한 삼격
    zh_hant: 猛參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1747
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 140
    - 140
    - 140
    - 140
    - 140
2558:
  _id_: 2558
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1748
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2559:
  _id_: 2559
  attribute_id: 7
  cost: 2
  description:
    en: Medium damage & Poison to all enemies.
    ja: 敵全体に威力(中)で攻撃し、毒を付与
    ko: 적 전체에게 위력(중) 공격, 독을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並造成中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Jack-o-Lantern Ripper NEO
    ja: ジャックオランタン・リッパー  NEO
    ko: 잭오랜턴 리퍼 NEO
    zh_hant: 傑克南瓜燈撕裂斬  NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1749
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
2561:
  _id_: 2561
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1750
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2562:
  _id_: 2562
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1751
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2563:
  _id_: 2563
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1752
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2564:
  _id_: 2564
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1753
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2565:
  _id_: 2565
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1754
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2566:
  _id_: 2566
  attribute_id: 5
  cost: 2
  description:
    en: Burn to all enemies.
    ja: 敵全体に火傷を付与
    ko: 적 전체에게 화상을 부여
    zh_hant: 賦予所有敵人燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1755
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
2567:
  _id_: 2567
  attribute_id: 5
  cost: 2
  description:
    en: Normal Barrier to self.
    ja: 自身に通常バリア付与
    ko: 자신에게 일반 배리어를 부여
    zh_hant: 賦予自己普通防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1756
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
2568:
  _id_: 2568
  attribute_id: 5
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1757
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2569:
  _id_: 2569
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pumpkin Trick NEO
    ja: パンプキントリック NEO
    ko: 펌프킨 트릭 NEO
    zh_hant: 南瓜戲法 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1758
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2571:
  _id_: 2571
  attribute_id: 7
  cost: 1
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1759
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2572:
  _id_: 2572
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1760
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2573:
  _id_: 2573
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1761
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2574:
  _id_: 2574
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1762
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2575:
  _id_: 2575
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1763
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2576:
  _id_: 2576
  attribute_id: 7
  cost: 3
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1764
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2577:
  _id_: 2577
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to all enemies.
    ja: 敵全体に多段攻撃
    ko: 적 전체에게 다단 공격
    zh_hant: 對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1765
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2578:
  _id_: 2578
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1766
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2579:
  _id_: 2579
  attribute_id: 7
  cost: 3
  description:
    en: Multi-hit attack to all enemies.
    ja: 敵全体に多段攻撃
    ko: 적 전체에게 다단 공격
    zh_hant: 對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bat Shrine NEO
    ja: コウモリおみこし NEO
    ko: 박쥐 가마 NEO
    zh_hant: 蝙蝠神轎 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1767
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2581:
  _id_: 2581
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1768
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2582:
  _id_: 2582
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1769
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2583:
  _id_: 2583
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1770
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2584:
  _id_: 2584
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1771
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2585:
  _id_: 2585
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1772
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2586:
  _id_: 2586
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1773
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2587:
  _id_: 2587
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1774
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2588:
  _id_: 2588
  attribute_id: 5
  cost: 2
  description:
    en: Poison & Blindness to all enemies.
    ja: 敵全体に毒と暗闇付与
    ko: 적 전체에게 독, 암흑을 부여
    zh_hant: 賦予所有敵人中毒與盲目效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Noxious Flower
    ja: 暗闇の毒花
    ko: 암흑의 독화
    zh_hant: 黑暗毒花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1775
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6000
    - 6000
    - 6000
    - 6000
    - 6000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2589:
  _id_: 2589
  attribute_id: 5
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1776
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2590:
  _id_: 2590
  attribute_id: 5
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1777
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2591:
  _id_: 2591
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪　NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪　NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1778
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2593:
  _id_: 2593
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1779
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2594:
  _id_: 2594
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1780
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2595:
  _id_: 2595
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1781
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2596:
  _id_: 2596
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1782
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2597:
  _id_: 2597
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poison Triple Slash
    ja: 猛参撃
    ko: 용맹한 삼격
    zh_hant: 猛參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1783
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2598:
  _id_: 2598
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1784
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2599:
  _id_: 2599
  attribute_id: 7
  cost: 2
  description:
    en: High damage & Heavy Poison to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高威力の毒を付与
    ko: 적 전체에게 위력(대) 공격, 높은 위력의 독을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並造成高威力的中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Jack-o-Lantern Ripper NEO
    ja: ジャックオランタン・リッパー  NEO
    ko: 잭오랜턴 리퍼 NEO
    zh_hant: 傑克南瓜燈撕裂斬  NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1785
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
2601:
  _id_: 2601
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1786
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2602:
  _id_: 2602
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1787
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2603:
  _id_: 2603
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1788
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2604:
  _id_: 2604
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1789
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2605:
  _id_: 2605
  attribute_id: 5
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1790
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2606:
  _id_: 2606
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1791
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2607:
  _id_: 2607
  attribute_id: 5
  cost: 2
  description:
    en: Strong Burn to all enemies.
    ja: 敵全体に高威力の火傷を付与
    ko: 적 전체에게 높은 위력의 화상을 부여
    zh_hant: 賦予所有敵人高威力的燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1792
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
2608:
  _id_: 2608
  attribute_id: 5
  cost: 2
  description:
    en: Normal Barrier to self.
    ja: 自身に通常バリア付与
    ko: 자신에게 일반 배리어를 부여
    zh_hant: 賦予自己普通防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1793
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 12000
    - 12000
    - 12000
    - 12000
    - 12000
2609:
  _id_: 2609
  attribute_id: 5
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1794
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2610:
  _id_: 2610
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pumpkin Trick NEO
    ja: パンプキントリック NEO
    ko: 펌프킨 트릭 NEO
    zh_hant: 南瓜戲法 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1795
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2612:
  _id_: 2612
  attribute_id: 7
  cost: 1
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1796
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2613:
  _id_: 2613
  attribute_id: 7
  cost: 1
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1797
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2614:
  _id_: 2614
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1798
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2615:
  _id_: 2615
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1799
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2616:
  _id_: 2616
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1800
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2617:
  _id_: 2617
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1801
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2618:
  _id_: 2618
  attribute_id: 7
  cost: 3
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1802
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2619:
  _id_: 2619
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Concerto
    ja: 連撃の協奏曲
    ko: 연격의 협주곡
    zh_hant: 連擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1803
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2620:
  _id_: 2620
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1804
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2621:
  _id_: 2621
  attribute_id: 7
  cost: 3
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bat Shrine NEO
    ja: コウモリおみこし NEO
    ko: 박쥐 가마 NEO
    zh_hant: 蝙蝠神轎 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1805
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2623:
  _id_: 2623
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1806
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2624:
  _id_: 2624
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1807
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2625:
  _id_: 2625
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1808
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2626:
  _id_: 2626
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1809
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2627:
  _id_: 2627
  attribute_id: 5
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1810
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2628:
  _id_: 2628
  attribute_id: 5
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1811
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2629:
  _id_: 2629
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1812
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2630:
  _id_: 2630
  attribute_id: 5
  cost: 2
  description:
    en: Poison & Blindness to all enemies.
    ja: 敵全体に毒と暗闇付与
    ko: 적 전체에게 독, 암흑을 부여
    zh_hant: 賦予所有敵人中毒與盲目效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Noxious Flower
    ja: 暗闇の毒花
    ko: 암흑의 독화
    zh_hant: 黑暗毒花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1813
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6000
    - 6000
    - 6000
    - 6000
    - 6000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2631:
  _id_: 2631
  attribute_id: 5
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1814
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2632:
  _id_: 2632
  attribute_id: 5
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1815
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2633:
  _id_: 2633
  attribute_id: 5
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪　NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪　NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1816
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2659:
  _id_: 2659
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵を威力(小)で攻撃 自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1840
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2660:
  _id_: 2660
  attribute_id: 4
  cost: 2
  description:
    en: Medium damage to all enemies. Evasion x1 to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体に回避1回を付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 회피 1회를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並賦予所有我方迴避1次
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: Secluded Feelings
    ja: 隠遁の思い
    ko: 은둔하는 생각
    zh_hant: 離群索居的回憶
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1841
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 34
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2661:
  _id_: 2661
  attribute_id: 4
  cost: 2
  description:
    en: Medium damage & Agility down to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、すばやさダウンを付与する
    ko: 적 전체에게 위력(중) 공격, 민첩 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並降低敏捷
  icon_id: 15
  is_multiple_command_unique_skill: 0
  name:
    en: Gentle Steps
    ja: ゆるやかな歩み
    ko: 느릿한 걸음
    zh_hant: 悠緩的步調
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1842
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 15
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2662:
  _id_: 2662
  attribute_id: 4
  cost: 2
  description:
    en: Very high damage & Act Power down & Normal Defense down & Blindness (Unremovable)
      to all enemies.
    ja: 敵全体に威力(大+)で攻撃し、ACTパワーダウン、通常防御力ダウン、解除不可の暗闇を付与する
    ko: 적 전체에게 위력(대+) 공격, ACT 파워 감소, 일반 방어력 감소, 해제 불가능한 암흑을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，降低ACT力量、普通防禦力，並賦予無法解除的盲目
  icon_id: 62
  is_multiple_command_unique_skill: 0
  name:
    en: Reach the Abyss
    ja: そして隠者は深淵に至る
    ko: 그리고 은자는 심연에 이르른다
    zh_hant: 於是隱士終將抵達深淵
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1843
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 302
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2696:
  _id_: 2696
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy. Normal Barrier to self.
    ja: 前から1番目の敵を威力(小)で攻撃し、自身に通常バリアを付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신에게 일반 배리어를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予自身普通防護罩
  icon_id: 30
  is_multiple_command_unique_skill: 0
  name:
    en: Walled Slash
    ja: 創壁の斬撃
    ko: 창벽의 참격
    zh_hant: 創壁斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
2697:
  _id_: 2697
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim & Dexterity up to all allies. High damage to front enemy.
    ja: 味方全体に必中、クリティカル率アップを付与し、前から1番目の敵に威力(大)で攻撃を行う
    ko: 아군 전체에게 백발백중, 크리티컬 확률 증가를 부여, 앞에서 첫 번째 적에게 위력(대) 공격
    zh_hant: 賦予所有我方必中並提升會心率，並對前面數來第1個敵人發動威力（大）攻擊
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Destruction Begins
    ja: 破壊の始まり
    ko: 파괴의 시작
    zh_hant: 破壞之始
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
2698:
  _id_: 2698
  attribute_id: 2
  cost: 3
  description:
    en: Marked & Medium damage to all enemies.
    ja: 敵全体に刻印を付与し、威力(中)で攻撃を行う
    ko: 적 전체에게 각인을 부여, 위력(중) 공격
    zh_hant: 賦予所有敵人刻印，並發動威力（中）攻擊
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Imminent Calamity
    ja: 迫る災害
    ko: 닥쳐오는 재해
    zh_hant: 災害逼近
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
2699:
  _id_: 2699
  attribute_id: 2
  cost: 2
  description:
    en: Very High damage to all enemies. Evasion x2 & Fortitude x1 to all allies.
    ja: 敵全体に威力(大+)で攻撃を行い、味方全体に回避2回、不屈1回を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 전체에게 회피 2회, 불굴 1회를 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予所有我方迴避2次、不屈1次
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction
    ja: 塔の断罪
    ko: 탑의 단죄
    zh_hant: 塔之定罪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 34
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2701:
  _id_: 2701
  attribute_id: 4
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1890
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2702:
  _id_: 2702
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 front enemies. Act Power up, Dexterity up to self.
    ja: 前から3体の敵に威力(大)の攻撃を行い、自身にACTパワーアップ、クリティカル率アップを付与する
    ko: 앞에서 3명의 적에게 위력(대) 공격, 자신에게 ACT 파워 증가, 크리티컬 확률 증가를 부여
    zh_hant: 對前面3個敵人發動威力（大）攻擊，並提升自己的ACT力量、會心率
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Mysterious Slash
    ja: 神気の斬撃
    ko: 신기의 참격
    zh_hant: 神氣斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1891
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 102
    - 106
    - 111
    - 116
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2703:
  _id_: 2703
  attribute_id: 4
  cost: 3
  description:
    en: High damage to front enemy. Removes Cont. Negative Effects from all allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Slash
    ja: 浄化の斬撃
    ko: 정화의 참격
    zh_hant: 淨化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1892
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2704:
  _id_: 2704
  attribute_id: 4
  cost: 2
  description:
    en: Set damage to 3 front enemies. If enemy's HP reaches 0 or below, they will
      Exit. Applies Stage Effect [We Are on the Stage (Moon)] to allies' stage.
    ja: 前から3体の敵に固定値ダメージを与え、舞台の味方側に舞台効果「私たちはもう舞台の上（月）」を付与する この攻撃で敵のHPが0以下になった場合、退場させる
    ko: 앞에서 3명의 적에게 적의 HP가 0 이하가 되면 퇴장시키는 고정 대미지 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(달)]을
      부여
    zh_hant: 對前方的3個敵人發動固定傷害攻擊，並賦予我方的舞台舞台效果「我們已經站上舞台（月）」 當敵人受到此攻擊後HP降到0以下時將退場
  icon_id: 1004
  is_multiple_command_unique_skill: 0
  name:
    en: Tonight, I will show you my brilliance!
    ja: 今宵、煌めきを、あなたに！
    ko: 오늘 밤, 반짝임을 당신에게!
    zh_hant: 今晚將閃耀獻給你！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1893
  skill_field_effect_id: 7
  skill_options:
  - hit_rate: 100
    id: 322
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 5000
    - 5500
    - 6000
    - 6500
    - 7500
2775:
  _id_: 2775
  attribute_id: 6
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1927
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
2776:
  _id_: 2776
  attribute_id: 6
  cost: 2
  description:
    en: Normal Barrier & Special Barrier & AP Down to all allies.
    ja: 味方全体に通常バリア、特殊バリア、AP減少を付与する
    ko: 아군 전체에게 일반 배리어, 특수 배리어, AP 감소를 부여
    zh_hant: 賦予所有我方普通防護罩、特殊防護罩及AP減少效果
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Bestowal
    ja: 堅守の附与
    ko: 굳은 수호의 부여
    zh_hant: 堅守恩賜
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1928
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2777:
  _id_: 2777
  attribute_id: 6
  cost: 1
  description:
    en: Aggro to all enemies. Evasion Rate Up & Dmg Received down to self.
    ja: 敵全体にターゲット固定を付与し、自身に回避率アップと被ダメージダウンを付与する
    ko: 적 전체에게 타깃 고정을 부여, 자신에게 회피 확률 증가와 받는 대미지 감소를 부여
    zh_hant: 賦予所有敵人目標鎖定，並提升自己的迴避率與降低自己受到的傷害
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Whole Protection
    ja: 全土の庇護
    ko: 전토의 비호
    zh_hant: 全境庇護
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1929
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2778:
  _id_: 2778
  attribute_id: 6
  cost: 2
  description:
    en: Flip Negative Effects x3 to all allies. Flip Positive Effects x3 & High damage
      to all enemies.
    ja: 味方全体に3回分のマイナス効果反転、敵全体に3回分のプラス効果反転を適用し、威力(大)で攻撃を行う
    ko: 아군 전체에 3회분의 마이너스 효과 반전, 적 전체에 3회분의 플러스 효과 반전을 적용하고 위력(대) 공격
    zh_hant: 對所有我方施加3次負面狀態效果反轉，且對所有敵人施加3次正面狀態效果反轉，並發動威力（大）攻擊
  icon_id: 151
  is_multiple_command_unique_skill: 0
  name:
    en: Empress's Gloom
    ja: 女帝陛下の憂鬱
    ko: 여제 폐하의 우울
    zh_hant: 女帝陛下的憂鬱
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1930
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 151
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 323
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
2785:
  _id_: 2785
  attribute_id: 6
  cost: 2
  description:
    en: Low damage & Mark to front enemy.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、刻印を付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 각인을 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予刻印
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Marked Slash
    ja: 刻印の斬撃
    ko: 각인의 참격
    zh_hant: 刻印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1937
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 150
    target_id: 2011
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2786:
  _id_: 2786
  attribute_id: 6
  cost: 2
  description:
    en: Medium damage to front enemy. Removes Cont. Negative Effects from 3 front
      allies.
    ja: 前から1番目の敵に威力(中)で攻撃を行い、前から3体の味方の継続マイナス効果を解除する
    ko: 앞에서 첫 번째 적에게 위력(중) 공격, 앞에서 3명의 아군의 지속 마이너스 효과를 해제
    zh_hant: 對前面數來第1個敵方發動威力（中）攻擊，並解除前面3名我方的持續性負面效果
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Flash
    ja: 浄化の一閃
    ko: 정화의 일섬
    zh_hant: 淨化閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1938
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 128
    target_id: 1133
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2787:
  _id_: 2787
  attribute_id: 6
  cost: 2
  description:
    en: Medium damage to front enemy. Low Brilliance recovery to all allies.
    ja: 前から1番目の敵に威力(中)で攻撃を行い、味方全体のキラめきを少し回復する
    ko: 앞에서 첫 번째 적에게 위력(중) 공격, 아군 전체의 반짝임을 조금 회복
    zh_hant: 對前面數來第1個敵人發動威力（中）攻擊，並回復所有我方少許的光芒
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Synchro of Brilliance
    ja: キラめきの呼応
    ko: 반짝임의 호응
    zh_hant: 光芒呼應
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1939
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 11
    - 12
    - 13
    - 15
2788:
  _id_: 2788
  attribute_id: 6
  cost: 1
  description:
    en: Removes Cont. Positive Effects & Extremely High damage to front enemy. Reflect
      Normal Damage & Reflect Special Damage to all allies. Applies Stage Effect [We
      Are on the Stage (Cloud)] to allies' stage.
    ja: 前から1番目の敵の継続プラス効果を解除し、威力(特大)で攻撃を行い、味方全体に通常ダメージ反射、特殊ダメージ反射を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（雲）」を付与する
    ko: 앞에서 첫 번째 적의 지속 플러스 효과를 해제하고 위력(특대) 공격, 아군 전체에게 일반 대미지 반사, 특수 대미지 반사를 부여, 아군
      쪽 무대에 무대 효과 [우리는 이미 무대 위(구름)]을 부여
    zh_hant: 解除前面數來第1個敵人的持續性正面效果，並發動威力（特大）攻擊。同時賦予所有我方反射普通傷害、反射特殊傷害，並賦予我方的舞台舞台效果「我們已經站上舞台（雲）」
  icon_id: 1006
  is_multiple_command_unique_skill: 0
  name:
    en: C'est moi! la star!
    ja: C'est moi！la star！
    ko: C'est moi! la star!
    zh_hant: C'est moi！la star！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1940
  skill_field_effect_id: 9
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
2795:
  _id_: 2795
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1947
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2796:
  _id_: 2796
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1948
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2797:
  _id_: 2797
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Double Smash
    ja: 双打撃
    ko: 쌍타격
    zh_hant: 雙敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1949
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2798:
  _id_: 2798
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Double Smash
    ja: 強双打撃
    ko: 강한 쌍타격
    zh_hant: 強雙敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1950
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2799:
  _id_: 2799
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1951
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2800:
  _id_: 2800
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参連打撃
    ko: 삼연타격
    zh_hant: 參連敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1952
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2801:
  _id_: 2801
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to 3 front enemies.
    ja: 前から3体の敵にACTパワーダウン付与
    ko: 앞에서 3명의 적에게 ACT 파워 감소를 부여
    zh_hant: 降低前方3個敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1953
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2802:
  _id_: 2802
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1954
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2803:
  _id_: 2803
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Present for You NEO
    ja: プレゼント・フォー・ユー NEO
    ko: 너를 위한 선물 NEO
    zh_hant: 好禮相送 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1955
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2805:
  _id_: 2805
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1956
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2806:
  _id_: 2806
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1957
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2807:
  _id_: 2807
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1958
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2808:
  _id_: 2808
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1959
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2809:
  _id_: 2809
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1960
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
2810:
  _id_: 2810
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 1 rear enemy.
    ja: 自身に必中を付与し、後から1体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1961
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
2811:
  _id_: 2811
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1962
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2812:
  _id_: 2812
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1963
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2813:
  _id_: 2813
  attribute_id: 4
  cost: 2
  description:
    en: High damage & Confusion to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、混乱を付与
    ko: 뒤에서부터 3명의 적에게 위력(대) 공격, 혼란을 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dreaming Bell NEO
    ja: 夢見るベル NEO
    ko: 꿈꾸는 벨 NEO
    zh_hant: 夢境鈴聲 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1964
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2815:
  _id_: 2815
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1965
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2816:
  _id_: 2816
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1966
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2817:
  _id_: 2817
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1967
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2818:
  _id_: 2818
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1968
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2819:
  _id_: 2819
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to 1 front enemy.
    ja: 自身に必中を付与し、前から1体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 1명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的1個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1969
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
2820:
  _id_: 2820
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1970
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2821:
  _id_: 2821
  attribute_id: 7
  cost: 2
  description:
    en: AP Up to 3 front enemies.
    ja: 前から3体の敵にAP増加を付与
    ko: 앞에서 3명의 적에게 AP 증가를 부여
    zh_hant: 賦予前方的3個敵人AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blast off, Dai-Banana! NEO
    ja: 大バナナ号、発進！ NEO
    ko: 대 바나나 호, 발진! NEO
    zh_hant: 大BANANA號，前進！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1971
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2823:
  _id_: 2823
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2824:
  _id_: 2824
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2825:
  _id_: 2825
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2826:
  _id_: 2826
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2827:
  _id_: 2827
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2828:
  _id_: 2828
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2829:
  _id_: 2829
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2830:
  _id_: 2830
  attribute_id: 4
  cost: 2
  description:
    en: Set chance to inflict Burn & Stun to all enemies.
    ja: 敵全体に確率で火傷とスタンを付与
    ko: 적 전체에게 일정 확률로 화상과 스턴을 부여
    zh_hant: 機率性賦予所有敵人燒傷與暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2831:
  _id_: 2831
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2832:
  _id_: 2832
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies. Reflect Normal Damage to self.
    ja: 後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2833:
  _id_: 2833
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies. Reflect Normal Damage to self.
    ja: 後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2835:
  _id_: 2835
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1983
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2836:
  _id_: 2836
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1984
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2837:
  _id_: 2837
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Double Smash
    ja: 双打撃
    ko: 쌍타격
    zh_hant: 雙敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1985
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2838:
  _id_: 2838
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Double Smash
    ja: 強双打撃
    ko: 강한 쌍타격
    zh_hant: 強雙敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1986
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2839:
  _id_: 2839
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1987
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2840:
  _id_: 2840
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参連打撃
    ko: 삼연타격
    zh_hant: 參連敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1988
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2841:
  _id_: 2841
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1989
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2842:
  _id_: 2842
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1990
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2843:
  _id_: 2843
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Present for You NEO
    ja: プレゼント・フォー・ユー NEO
    ko: 너를 위한 선물 NEO
    zh_hant: 好禮相送 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1991
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2845:
  _id_: 2845
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1992
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2846:
  _id_: 2846
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1993
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2847:
  _id_: 2847
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1994
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2848:
  _id_: 2848
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1995
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2849:
  _id_: 2849
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1996
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2850:
  _id_: 2850
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1997
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2851:
  _id_: 2851
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1998
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
2852:
  _id_: 2852
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1999
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2853:
  _id_: 2853
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2000
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2854:
  _id_: 2854
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2001
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2855:
  _id_: 2855
  attribute_id: 4
  cost: 2
  description:
    en: High damage & chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で混乱を付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dreaming Bell NEO
    ja: 夢見るベル NEO
    ko: 꿈꾸는 벨 NEO
    zh_hant: 夢境鈴聲 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2002
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2857:
  _id_: 2857
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2003
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2858:
  _id_: 2858
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2004
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2859:
  _id_: 2859
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2005
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2860:
  _id_: 2860
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2006
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2861:
  _id_: 2861
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 앞에서 3명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2007
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2862:
  _id_: 2862
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2008
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2863:
  _id_: 2863
  attribute_id: 7
  cost: 2
  description:
    en: High damage & AP Up to all enemies.
    ja: 敵全体に威力(大)で攻撃し、AP増加を付与
    ko: 적 전체에게 위력(대) 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blast off, Dai-Banana! NEO
    ja: 大バナナ号、発進！ NEO
    ko: 대 바나나 호, 발진! NEO
    zh_hant: 大BANANA號，前進！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2009
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2865:
  _id_: 2865
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2866:
  _id_: 2866
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2867:
  _id_: 2867
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2868:
  _id_: 2868
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2869:
  _id_: 2869
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2870:
  _id_: 2870
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2871:
  _id_: 2871
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2872:
  _id_: 2872
  attribute_id: 4
  cost: 2
  description:
    en: Burn & Stun to all enemies.
    ja: 敵全体に火傷とスタン付与
    ko: 적 전체에게 화상과 스턴을 부여
    zh_hant: 賦予所有敵人燒傷與暈眩效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2873:
  _id_: 2873
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2874:
  _id_: 2874
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2875:
  _id_: 2875
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
2877:
  _id_: 2877
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2021
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2878:
  _id_: 2878
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2022
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2879:
  _id_: 2879
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Double Smash
    ja: 強双打撃
    ko: 강한 쌍타격
    zh_hant: 強雙敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2023
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2880:
  _id_: 2880
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2024
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2881:
  _id_: 2881
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2025
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2882:
  _id_: 2882
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2026
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2883:
  _id_: 2883
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2027
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2884:
  _id_: 2884
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 필중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2028
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2885:
  _id_: 2885
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 필중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Present for You NEO
    ja: プレゼント・フォー・ユー NEO
    ko: 너를 위한 선물 NEO
    zh_hant: 好禮相送 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2029
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2887:
  _id_: 2887
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2030
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2888:
  _id_: 2888
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2031
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2889:
  _id_: 2889
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2032
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2890:
  _id_: 2890
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2033
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2891:
  _id_: 2891
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2034
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2892:
  _id_: 2892
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2035
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
2893:
  _id_: 2893
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2036
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2894:
  _id_: 2894
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2037
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2895:
  _id_: 2895
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2038
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2896:
  _id_: 2896
  attribute_id: 4
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2039
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2897:
  _id_: 2897
  attribute_id: 4
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dreaming Bell NEO
    ja: 夢見るベル NEO
    ko: 꿈꾸는 벨 NEO
    zh_hant: 夢境鈴聲 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2040
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2899:
  _id_: 2899
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2041
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2900:
  _id_: 2900
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2042
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2901:
  _id_: 2901
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2043
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2902:
  _id_: 2902
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2044
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2903:
  _id_: 2903
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 필중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2045
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
2904:
  _id_: 2904
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2046
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2905:
  _id_: 2905
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2047
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2906:
  _id_: 2906
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & AP Up to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、AP増加を付与
    ko: 적 전체에게 강력한 다단 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2048
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2907:
  _id_: 2907
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & AP Up to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、AP増加を付与
    ko: 적 전체에게 강력한 다단 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blast off, Dai-Banana! NEO
    ja: 大バナナ号、発進！ NEO
    ko: 대 바나나 호, 발진! NEO
    zh_hant: 大BANANA號，前進！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2049
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2909:
  _id_: 2909
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2910:
  _id_: 2910
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
2911:
  _id_: 2911
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
2912:
  _id_: 2912
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
2913:
  _id_: 2913
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2914:
  _id_: 2914
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
2915:
  _id_: 2915
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2916:
  _id_: 2916
  attribute_id: 4
  cost: 2
  description:
    en: Strong Burn & Stun to all enemies.
    ja: 敵全体に高威力の火傷とスタン付与
    ko: 적 전체에게 높은 위력의 화상과 스턴을 부여
    zh_hant: 賦予所有敵人高威力的燒傷與暈眩效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2917:
  _id_: 2917
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
2918:
  _id_: 2918
  attribute_id: 4
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2919:
  _id_: 2919
  attribute_id: 4
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
2928:
  _id_: 2928
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy. Agility up to all allies.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、味方全体にすばやさアップを付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 아군 전체에게 민첩 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並提升所有我方的敏捷
  icon_id: 14
  is_multiple_command_unique_skill: 0
  name:
    en: Quick Slash
    ja: 俊速の斬撃
    ko: 신속의 참격
    zh_hant: 神速斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2061
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
2929:
  _id_: 2929
  attribute_id: 5
  cost: 1
  description:
    en: Cont. Negative Effects Resistance to front 3 allies.
    ja: 前から3体の味方に継続マイナス効果耐性を付与する
    ko: 앞에서 3명의 아군에게 지속 마이너스 효과 저항을 부여
    zh_hant: 賦予前面3名我方持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Sacred Song
    ja: 聖域の歌
    ko: 성역의 노래
    zh_hant: 聖域之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2062
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1133
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2930:
  _id_: 2930
  attribute_id: 5
  cost: 3
  description:
    en: Medium damage & chance at Stun to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、一定確率でスタンを付与する
    ko: 적 전체에게 위력(중) 공격, 일정 확률로 스턴을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並在一定機率下賦予暈眩
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Concerto
    ja: 抑止の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑止協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2063
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2931:
  _id_: 2931
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim & Act Power up to self. Removes Cont. Negative Effects from all
      allies. Very High damage to all enemies (counts as Dream & extra damage to normal-type
      enemies). Applies [Concentration (Space)].
    ja: 自身に必中とACTパワーアップを付与、味方全体の継続マイナス効果を解除し、敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「本日も集中あるのみ（宙）」を付与する　この攻撃は夢属性の攻撃として扱い、通常タイプの敵に対して特攻
    ko: 자신에게 백발백중과 ACT 파워 증가를 부여, 아군 전체의 지속 마이너스 효과를 해제, 적 전체에게 위력(대+) 공격, 적 쪽 무대에
      무대 효과 [오늘도 집중할 뿐(우주)]을 부여, 이 공격은 꿈 속성으로 적용되며 일반 타입 적에게 특수 공격
    zh_hant: 賦予自己必中並提升自己的ACT力量，解除所有我方的持續性負面效果，對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「今天也要全神貫注（宙）」
      此攻擊為夢屬性，會對普通類型的敵方造成特攻效果
  icon_id: 1014
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Fire
    ja: ひしめく鼓動は青の炎
    ko: 술렁이는 고동은 푸른 불꽃
    zh_hant: 群起鼓動的湛藍之火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2064
  skill_field_effect_id: 19
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 306
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 125
    - 135
    - 145
    - 155
    - 170
2968:
  _id_: 2968
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy. Evasion x1 to 3 front allies.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、前から3体の味方に回避を1回付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 앞에서 3명의 아군에게 회피 1회를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予前面3名我方迴避1次
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Slash
    ja: 回避の斬撃
    ko: 회피의 참격
    zh_hant: 迴避斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2092
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 34
    target_id: 1133
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2969:
  _id_: 2969
  attribute_id: 2
  cost: 2
  description:
    en: Low damage & AP Up to 3 front enemies.
    ja: 前から3体の敵に威力(小)の攻撃を行い、AP増加を付与する
    ko: 앞에서 3명의 적에게 위력(소) 공격, AP 증가를 부여
    zh_hant: 對前面的3個敵人發動威力（小）攻擊，並賦予AP增加效果
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Rondo
    ja: 重圧の輪舞曲
    ko: 중압의 윤무곡
    zh_hant: 重壓圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2093
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2970:
  _id_: 2970
  attribute_id: 2
  cost: 2
  description:
    en: Low Brilliance recovery & Absorb to all allies.
    ja: 味方全体のキラめきを少し回復し、吸収を付与する
    ko: 아군 전체의 반짝임을 조금 회복, 흡수를 부여
    zh_hant: 回復所有我方少許的光芒，並賦予吸收效果
  icon_id: 44
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Dance
    ja: 吸収の舞
    ko: 흡수의 춤
    zh_hant: 吸收之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2094
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 11
    - 12
    - 13
    - 15
  - hit_rate: 100
    id: 44
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 23
    - 26
    - 29
    - 33
2971:
  _id_: 2971
  attribute_id: 7
  cost: 2
  description:
    en: Very High damage (counts as Dream & extra damage to enemies inflicted with
      Burn) & high chance at Stop to 3 front enemies. Applies [Concentration (Wind)].
    ja: 前から3体の敵に威力(大+)で攻撃を行い、高確率でストップを付与し、舞台の敵側に舞台効果「本日も集中あるのみ（風）」を付与する　この攻撃は夢属性の攻撃として扱い、火傷状態の敵に対して特攻
    ko: 앞에서 3명의 적에게 위력(대+) 공격, 높은 확률로 스톱을 부여, 적 쪽 무대에 무대 효과 [오늘도 집중할 뿐(바람)]을 부여, 이
      공격은 꿈 속성 공격으로 적용되며 화상 상태의 적에게 특수 공격
    zh_hant: 對前面的3個敵人發動威力（大+）攻擊，並以高機率造成停止，同時賦予敵方的舞台舞台效果「今天也要全神貫注（風）」 此攻擊為夢屬性，會對燒傷狀態的敵方造成特攻效果
  icon_id: 1015
  is_multiple_command_unique_skill: 0
  name:
    en: Dawn Storm
    ja: 吹き荒れる風は暁の印
    ko: 거친 바람은 새벽의 증거
    zh_hant: 呼嘯狂風為黎明之徵
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2095
  skill_field_effect_id: 20
  skill_options:
  - hit_rate: 100
    id: 277
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 170
    - 175
    - 180
    - 185
    - 200
  - hit_rate: 75
    id: 60
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2973:
  _id_: 2973
  attribute_id: 3
  cost: 1
  description:
    en: Aggro removal & Aggro immunity to all allies.
    ja: 味方全体のターゲット固定を解除し、ターゲット固定無効を付与する
    ko: 아군 전체의 타깃 고정을 해제, 타깃 고정 무효를 부여
    zh_hant: 解除所有我方的目標鎖定，並賦予目標鎖定無效
  icon_id: 153
  is_multiple_command_unique_skill: 0
  name:
    en: Target Immunity
    ja: 標的無効
    ko: 표적 무효
    zh_hant: 目標無效
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2098
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 154
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 153
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
2974:
  _id_: 2974
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy. Counter Heal to 3 rear allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、後ろから3体の味方にカウンターヒールを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 카운터 힐을 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並賦予後面3名我方還擊治療
  icon_id: 45
  is_multiple_command_unique_skill: 0
  name:
    en: Song of Healing
    ja: 癒しの歌
    ko: 치유의 노래
    zh_hant: 治癒之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2099
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 241
    target_id: 1143
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
2975:
  _id_: 2975
  attribute_id: 3
  cost: 3
  description:
    en: Low damage to front enemy. Fortitude 1 hit to all allies.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、味方全体に不屈を1回付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 아군 전체에게 불굴 1회를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予所有我方不屈1次
  icon_id: 36
  is_multiple_command_unique_skill: 0
  name:
    en: Fortitude Concerto
    ja: 不屈の協奏曲
    ko: 불굴의 협주곡
    zh_hant: 不屈協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2100
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 36
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
2976:
  _id_: 2976
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity up & Critical up to self. High damage to all enemies (counts as
      Dream & extra damage to enemies inflicted with Poison). Applies [Concentration
      (Snow)].
    ja: 自身にクリティカル率アップとクリティカル威力アップを付与し、敵全体に威力(大)で攻撃を行い、舞台の敵側に舞台効果「本日も集中あるのみ（雪）」を付与する　この攻撃は夢属性の攻撃として扱い、毒状態の敵に対して特攻
    ko: 자신에게 크리티컬 확률 증가와 크리티컬 위력 증가를 부여, 적 전체에게 위력(대) 공격, 적 쪽 무대에 무대 효과 [오늘도 집중할 뿐(눈)]을
      부여, 이 공격은 꿈 속성으로 적용되며 독 상태의 적에게 특수 공격
    zh_hant: 提升自己的會心率及會心威力，對所有敵人發動威力（大）攻擊，並賦予敵方的舞台舞台效果「今天也要全神貫注（雪）」 此攻擊為夢屬性，會對中毒的敵方造成特攻效果
  icon_id: 1016
  is_multiple_command_unique_skill: 0
  name:
    en: Let It Rain
    ja: ハジマリの雨を降らせましょう
    ko: 시작의 비를 내리게 해요
    zh_hant: 降下起始之雨吧
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2101
  skill_field_effect_id: 21
  skill_options:
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 276
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 105
    - 110
    - 115
    - 120
3005:
  _id_: 3005
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Brilliance
    ja: キラめきの一撃
    ko: 반짝임의 일격
    zh_hant: 光芒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2119
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3006:
  _id_: 3006
  attribute_id: 1
  cost: 2
  description:
    en: High damage to front enemy. Removes Cont. Positive Effects to all enemies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果を解除する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Purity of Wisdom
    ja: 英知の浄化
    ko: 영지의 정화
    zh_hant: 睿智的淨化
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2120
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3007:
  _id_: 3007
  attribute_id: 1
  cost: 2
  description:
    en: Medium damage to all enemies. Agility up to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体にすばやさアップを付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 민첩 증가를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並提升所有我方的敏捷
  icon_id: 14
  is_multiple_command_unique_skill: 0
  name:
    en: Rapid Pace
    ja: 迅速な歩み
    ko: 신속한 걸음
    zh_hant: 迅速的步調
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2121
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3008:
  _id_: 3008
  attribute_id: 1
  cost: 2
  description:
    en: Very high damage & Strong Poison (Unremovable) to all enemies. Act Power up
      & Normal Defense up to all allies.
    ja: 敵全体に威力(大+)で攻撃し、解除不可の猛毒を付与し、味方全体にACTパワーアップと通常防御力アップを付与する
    ko: 적 전체에게 위력(대+) 공격, 해제 불가능한 맹독을 부여, 아군 전체에게 ACT 파워 증가와 일반 방어력 증가를 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，賦予無法解除的猛毒，並提升所有我方的ACT力量、普通防禦力
  icon_id: 54
  is_multiple_command_unique_skill: 0
  name:
    en: High Judgement
    ja: 女教皇はかく裁けり
    ko: 여교황은 이렇게 판결했노라
    zh_hant: 女教皇如此裁斷
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2122
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 303
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6
    - 8
    - 10
    - 12
    - 15
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
3011:
  _id_: 3011
  attribute_id: 1
  cost: 2
  description:
    en: Medium+ damage to rear enemy.
    ja: 後ろから1番目の敵に威力(中+)の攻撃
    ko: 뒤에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對後面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ardent Slash
    ja: 烈斬撃
    ko: 열참격
    zh_hant: 烈焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2125
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3012:
  _id_: 3012
  attribute_id: 1
  cost: 2
  description:
    en: Act Power up & Dexterity up to self. Medium damage to rear enemy.
    ja: 自身にACTパワーアップ、クリティカル率アップを付与し、後ろから1番目の敵に威力(中)の攻撃を行う
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가를 부여, 뒤에서 첫 번째 적에게 위력(중) 공격
    zh_hant: 提升自己的ACT力量、會心率，並對後面數來第1個敵人發動威力（中）攻擊
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Shogun's Stance
    ja: 武将の構え
    ko: 무장의 자세
    zh_hant: 武將的架式
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2126
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
3013:
  _id_: 3013
  attribute_id: 1
  cost: 2
  description:
    en: Reflect Normal Damage & Reflect Special Damage to self. High damage to rear
      enemy.
    ja: 自身に通常ダメージ反射と特殊ダメージ反射を付与し、後ろから1番目の敵に威力(大)の攻撃を行う
    ko: 자신에게 일반 대미지 반사와 특수 대미지 반사를 부여, 뒤에서 첫 번째 적에게 위력(대) 공격
    zh_hant: 賦予自己反射普通傷害與反射特殊傷害，並對後面數來第1個敵人發動威力（大）攻擊
  icon_id: 32
  is_multiple_command_unique_skill: 0
  name:
    en: Nobunaga's Attack
    ja: 信長の応戦
    ko: 노부나가의 응전
    zh_hant: 信長的應戰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2127
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
3014:
  _id_: 3014
  attribute_id: 1
  cost: 2
  description:
    en: Very High damage to all enemies. Resilience & Fortitude x1 to all allies.
    ja: 敵全体に威力(大+)で攻撃を行い、味方全体に不倒と不屈1回を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 전체에게 불멸과 불굴 1회를 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予所有我方不倒與不屈1次
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Tenma Hell
    ja: 天魔の獄炎
    ko: 천마의 옥염
    zh_hant: 天魔的煉獄之火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2128
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 299
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3016:
  _id_: 3016
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2130
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3017:
  _id_: 3017
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim to self. High damage to front enemy.
    ja: 自身に必中を付与し、前から1番目の敵に威力(大)で攻撃を行う
    ko: 자신에게 백발백중을 부여, 앞에서 첫 번째 적에게 위력(대) 공격
    zh_hant: 賦予自己必中，並對前面數來第1個敵人發動威力（大）攻擊
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Bull's Eye
    ja: ブルズアイ
    ko: 불스아이
    zh_hant: 正中紅心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2131
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
3018:
  _id_: 3018
  attribute_id: 2
  cost: 3
  description:
    en: High damage to front enemy. Cont. Negative Effects Resistance & Special Barrier
      to all allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、味方全体に継続マイナス効果耐性と特殊バリアを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 지속 마이너스 효과 저항과 특수 배리어를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並賦予所有我方持續性負面效果耐性與特殊防護罩
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Miser's Safe
    ja: 守銭奴の金庫
    ko: 수전노의 금고
    zh_hant: 守財奴的金庫
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2132
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
3019:
  _id_: 3019
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies & chance to inflict Stun &
      Stop.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃を行い、一定確率でスタンとストップを付与する
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격, 일정 확률로 스턴과 스톱을 부여
    zh_hant: 賦予自己必中，對所有敵人發動威力（大）攻擊，並以一定機率造成暈眩和停止
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: Western Lasso
    ja: ウェスタン・ロープ・アクション
    ko: 웨스턴 로프 액션
    zh_hant: 西部・套索・絕技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2133
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3021:
  _id_: 3021
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2135
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3022:
  _id_: 3022
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2136
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3023:
  _id_: 3023
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to to front enemy.
    ja: 前から1体の敵に強力な多段攻撃
    ko: 앞에서 1명의 적에게 강력한 다단 공격
    zh_hant: 對前方的1個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2137
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3024:
  _id_: 3024
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2138
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3025:
  _id_: 3025
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2139
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3026:
  _id_: 3026
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2140
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3027:
  _id_: 3027
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2141
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3028:
  _id_: 3028
  attribute_id: 7
  cost: 2
  description:
    en: Chance (50%) at Confusion to all enemies.
    ja: 敵全体に確率（50％）で混乱を付与する
    ko: 적 전체에게 50% 확률로 혼란을 부여
    zh_hant: 有50％的機率對所有敵人賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Parasol Trick NEO
    ja: 新春晴傘かくし芸 NEO
    ko: 새해 양산 개인기 NEO
    zh_hant: 新春陽傘特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2142
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3030:
  _id_: 3030
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2143
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3031:
  _id_: 3031
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2144
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3032:
  _id_: 3032
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2145
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3033:
  _id_: 3033
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3034:
  _id_: 3034
  attribute_id: 3
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 1 rear enemy.
    ja: 自身に必中を付与し、後から1体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
3035:
  _id_: 3035
  attribute_id: 3
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3036:
  _id_: 3036
  attribute_id: 3
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3037:
  _id_: 3037
  attribute_id: 3
  cost: 2
  description:
    en: Chance (50%) at Burn to all enemies.
    ja: 敵全体に確率（50％）で火傷を付与
    ko: 적 전체에게 50% 확률로 화상을 부여
    zh_hant: 有50％的機率賦予所有敵人燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
3038:
  _id_: 3038
  attribute_id: 3
  cost: 2
  description:
    en: Chance (50%) at Burn to all enemies.
    ja: 敵全体に確率（50％）で火傷を付与
    ko: 적 전체에게 50% 확률로 화상을 부여
    zh_hant: 有50％的機率賦予所有敵人燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Hanetsuki Blackout NEO
    ja: 羽根突き墨汁打 NEO
    ko: 하고이타 먹물타 NEO
    zh_hant: 板羽墨汁殺球 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
3040:
  _id_: 3040
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3041:
  _id_: 3041
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3042:
  _id_: 3042
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3043:
  _id_: 3043
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2155
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3044:
  _id_: 3044
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2156
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3045:
  _id_: 3045
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to 3 front enemies.
    ja: 前から3体の敵にACTパワーダウン付与
    ko: 앞에서 3명의 적에게 ACT 파워 감소를 부여
    zh_hant: 降低前方3個敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2157
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3046:
  _id_: 3046
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to 3 front enemies.
    ja: 前から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 앞에서 3명의 적에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低前方3個敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2158
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3047:
  _id_: 3047
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2159
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3048:
  _id_: 3048
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Hammer Drop NEO
    ja: 賀正おとし槌 NEO
    ko: 근하신년 망치 NEO
    zh_hant: 謹賀新年槌擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2160
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3050:
  _id_: 3050
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2161
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3051:
  _id_: 3051
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2162
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3052:
  _id_: 3052
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2163
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3053:
  _id_: 3053
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2164
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3054:
  _id_: 3054
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2165
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3055:
  _id_: 3055
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies. Evasion Rate up to self.
    ja: 後から3体の敵に威力(大)で攻撃し、自身に回避率アップを付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 자신에게 회피 확률 증가를 부여
    zh_hant: 對後面的3個敵人發動威力（大）攻擊，並提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2166
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3056:
  _id_: 3056
  attribute_id: 3
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2167
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3057:
  _id_: 3057
  attribute_id: 3
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2168
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3058:
  _id_: 3058
  attribute_id: 3
  cost: 2
  description:
    en: Chance (50%) at Freeze to all enemies.
    ja: 敵全体に確率（50％）で凍結を付与
    ko: 적 전체에게 50% 확률로 동결을 부여
    zh_hant: 有50％的機率賦予所有敵人凍結
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2169
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3060:
  _id_: 3060
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2170
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3061:
  _id_: 3061
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2171
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3062:
  _id_: 3062
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2172
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3063:
  _id_: 3063
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2173
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3064:
  _id_: 3064
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2174
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3065:
  _id_: 3065
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に強力な多段攻撃
    ko: 앞에서 3명의 적에게 강력한 다단 공격
    zh_hant: 對前方的3個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2175
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3066:
  _id_: 3066
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2176
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3067:
  _id_: 3067
  attribute_id: 7
  cost: 2
  description:
    en: High damage & chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で混乱を付与する
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2177
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3068:
  _id_: 3068
  attribute_id: 7
  cost: 2
  description:
    en: High damage & chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で混乱を付与する
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Parasol Trick NEO
    ja: 新春晴傘かくし芸 NEO
    ko: 새해 양산 개인기 NEO
    zh_hant: 新春陽傘特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2178
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3070:
  _id_: 3070
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2179
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3071:
  _id_: 3071
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2180
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3072:
  _id_: 3072
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2181
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3073:
  _id_: 3073
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2182
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3074:
  _id_: 3074
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2183
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3075:
  _id_: 3075
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2184
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3076:
  _id_: 3076
  attribute_id: 3
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2185
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3077:
  _id_: 3077
  attribute_id: 3
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2186
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3078:
  _id_: 3078
  attribute_id: 3
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2187
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
3079:
  _id_: 3079
  attribute_id: 3
  cost: 2
  description:
    en: High damage & Burn to all enemies.
    ja: 敵全体に威力(大)で攻撃し、火傷を付与
    ko: 적 전체에게 위력(대) 공격, 화상을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並造成燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2188
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
3080:
  _id_: 3080
  attribute_id: 3
  cost: 2
  description:
    en: High damage & Burn to all enemies.
    ja: 敵全体に威力(大)で攻撃し、火傷を付与
    ko: 적 전체에게 위력(대) 공격, 화상을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並造成燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Hanetsuki Blackout NEO
    ja: 羽根突き墨汁打 NEO
    ko: 하고이타 먹물타 NEO
    zh_hant: 板羽墨汁殺球 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2189
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
3082:
  _id_: 3082
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2190
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3083:
  _id_: 3083
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2191
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3084:
  _id_: 3084
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2192
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3085:
  _id_: 3085
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2193
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3086:
  _id_: 3086
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2194
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3087:
  _id_: 3087
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2195
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3088:
  _id_: 3088
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to all enemies.
    ja: 敵全体に多段攻撃
    ko: 적 전체에게 다단 공격
    zh_hant: 對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Dance
    ja: 連撃の舞
    ko: 연격의 춤
    zh_hant: 連擊之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2196
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3089:
  _id_: 3089
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2197
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3090:
  _id_: 3090
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2198
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3091:
  _id_: 3091
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2199
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3092:
  _id_: 3092
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Hammer Drop NEO
    ja: 賀正おとし槌 NEO
    ko: 근하신년 망치 NEO
    zh_hant: 謹賀新年槌擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2200
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3094:
  _id_: 3094
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2201
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3095:
  _id_: 3095
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2202
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3096:
  _id_: 3096
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2203
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3097:
  _id_: 3097
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2204
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3098:
  _id_: 3098
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2205
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3099:
  _id_: 3099
  attribute_id: 3
  cost: 2
  description:
    en: High damage to all enemies. Evasion Rate up to self.
    ja: 敵全体に威力(大)で攻撃じ、自身に回避率アップを付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 회피 확률 증가를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2206
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
3100:
  _id_: 3100
  attribute_id: 3
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2207
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3101:
  _id_: 3101
  attribute_id: 3
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2208
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3102:
  _id_: 3102
  attribute_id: 3
  cost: 2
  description:
    en: High damage & High change (75%) at Freeze to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率（75％）で凍結を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률(75%)로 동결을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率（75％）造成凍結
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 氷結の協奏曲
    ko: 빙결의 협주곡
    zh_hant: 冰凍協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2209
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3103:
  _id_: 3103
  attribute_id: 3
  cost: 2
  description:
    en: High damage & High change (75%) at Freeze to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率（75％）で凍結を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률(75%)로 동결을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率（75％）造成凍結
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2210
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3105:
  _id_: 3105
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2211
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3106:
  _id_: 3106
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2212
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3107:
  _id_: 3107
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2213
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3108:
  _id_: 3108
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2214
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3109:
  _id_: 3109
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2215
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3110:
  _id_: 3110
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2216
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3111:
  _id_: 3111
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2217
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3112:
  _id_: 3112
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2218
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3113:
  _id_: 3113
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Parasol Trick NEO
    ja: 新春晴傘かくし芸 NEO
    ko: 새해 양산 개인기 NEO
    zh_hant: 新春陽傘特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2219
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3115:
  _id_: 3115
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2220
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3116:
  _id_: 3116
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3117:
  _id_: 3117
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3118:
  _id_: 3118
  attribute_id: 3
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3119:
  _id_: 3119
  attribute_id: 3
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3120:
  _id_: 3120
  attribute_id: 3
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3121:
  _id_: 3121
  attribute_id: 3
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3122:
  _id_: 3122
  attribute_id: 3
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Strong Burn to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、高威力の火傷を付与
    ko: 적 전체에게 강력한 다단 공격, 높은 위력의 화상을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予高威力的燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
3123:
  _id_: 3123
  attribute_id: 3
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Strong Burn to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、高威力の火傷を付与
    ko: 적 전체에게 강력한 다단 공격, 높은 위력의 화상을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予高威力的燒傷
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Hanetsuki Blackout NEO
    ja: 羽根突き墨汁打 NEO
    ko: 하고이타 먹물타 NEO
    zh_hant: 板羽墨汁殺球 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
3125:
  _id_: 3125
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3126:
  _id_: 3126
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2230
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3127:
  _id_: 3127
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2231
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3128:
  _id_: 3128
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2232
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3129:
  _id_: 3129
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2233
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3130:
  _id_: 3130
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Dance
    ja: 連撃の舞
    ko: 연격의 춤
    zh_hant: 連擊之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2234
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3131:
  _id_: 3131
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2235
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3132:
  _id_: 3132
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2236
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3133:
  _id_: 3133
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2237
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3134:
  _id_: 3134
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: New Year's Hammer Drop NEO
    ja: 賀正おとし槌 NEO
    ko: 근하신년 망치 NEO
    zh_hant: 謹賀新年槌擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2238
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3136:
  _id_: 3136
  attribute_id: 3
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3137:
  _id_: 3137
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3138:
  _id_: 3138
  attribute_id: 3
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3139:
  _id_: 3139
  attribute_id: 3
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3140:
  _id_: 3140
  attribute_id: 3
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Evasion Rate up to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に回避率アップを付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 회피 확률 증가를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3141:
  _id_: 3141
  attribute_id: 3
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3142:
  _id_: 3142
  attribute_id: 3
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3143:
  _id_: 3143
  attribute_id: 3
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Freeze to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、凍結を付与する
    ko: 적 전체에게 강력한 다단 공격, 동결을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予凍結
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 氷結の協奏曲
    ko: 빙결의 협주곡
    zh_hant: 冰凍協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3144:
  _id_: 3144
  attribute_id: 3
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Freeze to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、凍結を付与する
    ko: 적 전체에게 강력한 다단 공격, 동결을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予凍結
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3146:
  _id_: 3146
  attribute_id: 2
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3147:
  _id_: 3147
  attribute_id: 2
  cost: 2
  description:
    en: High damage to front enemy. Removes Cont. Negative Effects and applies Cont.
      Negative Effects Resistance to all allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除し、継続マイナス効果耐性を付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제, 아군 전체에게 지속 마이너스 효과 저항을 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果，且賦予持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purity of Strength
    ja: 力の浄化
    ko: 힘의 정화
    zh_hant: 力量的淨化
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2249
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3148:
  _id_: 3148
  attribute_id: 2
  cost: 1
  description:
    en: Aggro to all enemies. Counter Heal & Dmg Received down to self.
    ja: 敵全体にターゲット固定を付与し、自身にカウンターヒールと被ダメージダウンを付与する
    ko: 적 전체에게 타깃 고정을 부여, 자신에게 카운터 힐과 받는 대미지 감소를 부여
    zh_hant: 賦予所有敵人目標鎖定，並賦予自身還擊治療且降低受到的傷害
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Resilient Protection
    ja: 剛毅の庇護
    ko: 강직의 비호
    zh_hant: 剛毅庇護
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2250
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 241
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3149:
  _id_: 3149
  attribute_id: 2
  cost: 2
  description:
    en: Very high damage to front enemy. HP Regen & Evasion Rate up to all allies.
    ja: 前から1番目の敵に威力(大+)で攻撃を行い、味方全体に毎ターンHP回復と回避率アップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대+) 공격, 아군 전체에게 매 턴 HP 회복과 회피 확률 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大+）攻擊，並賦予所有我方每回合HP回復且提升迴避率
  icon_id: 28
  is_multiple_command_unique_skill: 0
  name:
    en: Lion's Roar
    ja: 獅子の咆哮
    ko: 사자의 포효
    zh_hant: 獅子咆哮
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2251
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 328
    - 345
    - 361
    - 378
    - 394
  - hit_rate: 100
    id: 28
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 12000
    - 14000
    - 16000
    - 20000
  - hit_rate: 100
    id: 18
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
3151:
  _id_: 3151
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to front enemy. Special Barrier to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身に特殊バリアを付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신에게 특수 배리어를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予自己特殊防護罩
  icon_id: 31
  is_multiple_command_unique_skill: 0
  name:
    en: Walled Slash
    ja: 造壁の斬撃
    ko: 조벽의 참격
    zh_hant: 造壁斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2253
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
3152:
  _id_: 3152
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage & Accuracy Rate Down & Dexterity down to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、命中率ダウンとクリティカル率ダウンを付与する
    ko: 적 전체에게 위력(중) 공격, 명중률 감소, 크리티컬 확률 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並降低命中率、會心率
  icon_id: 17
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzled Pupils
    ja: 眩む瞳
    ko: 어두워지는 눈동자
    zh_hant: 眩目之瞳
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2254
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
3153:
  _id_: 3153
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage & AP up & Reduced Brilliance Recovery to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、AP増加とキラめき獲得ダウンを付与する
    ko: 적 전체에게 위력(중) 공격, AP 증가, 반짝임 획득 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並賦予AP增加、獲得光芒減少
  icon_id: 192
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Blink
    ja: 減光の瞬き
    ko: 감광의 반짝임
    zh_hant: 減光之瞬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2255
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
3154:
  _id_: 3154
  attribute_id: 3
  cost: 2
  description:
    en: High damage & High chance at Freeze to all enemies. Exit Evasion to self.
    ja: 敵全体に威力(大)で攻撃を行い、高確率で凍結を付与し、自身に退場回避を付与する
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 동결을 부여, 자신에게 퇴장 회피를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並有高機率造成凍結，同時能賦予自己退場迴避
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World
    ja: 逆転世界の開眼
    ko: 역전세계의 개안
    zh_hant: 翻轉世界的領悟
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2256
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 75
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 155
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3156:
  _id_: 3156
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy. Agility down to all enemies.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、敵全体にすばやさダウンを付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 적 전체에게 민첩 감소를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並降低所有敵人的敏捷
  icon_id: 15
  is_multiple_command_unique_skill: 0
  name:
    en: Static Slash
    ja: 鈍足の斬撃
    ko: 둔화의 참격
    zh_hant: 慢行的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 15
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3157:
  _id_: 3157
  attribute_id: 6
  cost: 2
  description:
    en: Medium damage & Act Power down & Normal Defense down & Special Defense down
      to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、ACTパワーダウン、通常防御力ダウン、特殊防御力ダウンを付与する
    ko: 적 전체에게 위력(중) 공격, ACT 파워 감소, 일반 방어력 감소, 특수 방어력 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並降低ACT力量、普通防禦力、特殊防禦力
  icon_id: 9
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Magic
    ja: 脱力の魔術
    ko: 탈력의 마술
    zh_hant: 虛脫魔術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3158:
  _id_: 3158
  attribute_id: 6
  cost: 3
  description:
    en: Low Brilliance recovery & Special Barrier to all allies.
    ja: 味方全体のキラめきを少し回復し、特殊バリアを付与する
    ko: 아군 전체의 반짝임을 조금 회복, 특수 배리어를 부여
    zh_hant: 回復所有我方少許的光芒，並賦予特殊防護罩效果
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Protection of Brilliance
    ja: キラめきの加護
    ko: 반짝임의 가호
    zh_hant: 光芒加護
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 11
    - 12
    - 13
    - 15
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
3159:
  _id_: 3159
  attribute_id: 6
  cost: 2
  description:
    en: High damage & Confusion & Blindness & Heavy Burn & Marked to all enemies.
    ja: 敵全体に威力(大)の攻撃を行い、混乱、暗闇、大火傷、刻印を付与する
    ko: 적 전체에게 위력(대) 공격, 혼란, 암흑, 대화상, 각인을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並造成混亂、盲目、嚴重燒傷、刻印
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Arcanum Magicae
    ja: アルカナム・マジーケ
    ko: 아르카눔 마지케
    zh_hant: 阿爾克那・魔術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 246
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3161:
  _id_: 3161
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to front enemy. Evasion x1 to 3 rear allies.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、後から3体の味方に回避を1回付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 뒤에서 3명의 아군에게 회피 1회를 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予後面3名我方迴避1次
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 34
    target_id: 1143
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3162:
  _id_: 3162
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage to front enemy. Removes Cont. Positive Effects to all enemies.
    ja: 前から1番目の敵に威力(中)で攻撃を行い、敵全体の継続プラス効果を解除する
    ko: 앞에서 첫 번째 적에게 위력(중) 공격, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 對前面數來第1個敵人發動威力（中）攻擊，並解除所有敵人的持續性正面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Severing Blade
    ja: 断切の刃
    ko: 단절의 칼날
    zh_hant: 切斷之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3163:
  _id_: 3163
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage to front enemy. Cont. Negative Effects Resistance to all allies.
    ja: 前から1番目の敵に威力(中)で攻撃を行い、味方全体に継続マイナス効果耐性を付与する
    ko: 앞에서 1명의 적에게 위력(중) 공격, 아군 전체에게 지속 마이너스 효과 저항을 부여
    zh_hant: 對前面數來第1個敵人發動威力（中）攻擊，並賦予所有我方持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Sacred Blade
    ja: 聖域の刃
    ko: 성역의 칼날
    zh_hant: 聖域之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3164:
  _id_: 3164
  attribute_id: 3
  cost: 2
  description:
    en: Act Power up & Dexterity up to self. Removes Cont. Positive Effects & Very
      high damage to all enemies.
    ja: 自身にACTパワーアップとクリティカル率アップを付与し、敵全体の継続プラス効果を解除し、威力(大+)で攻撃を行う
    ko: 자신에게 ACT 파워 증가와 크리티컬 확률 증가를 부여, 적 전체의 지속 플러스 효과를 해제하고 위력(대+) 공격
    zh_hant: 提升自己的ACT力量和會心率，解除所有敵人的持續性正面效果，並發動威力（大+）攻擊
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Flying Dragon
    ja: 龍飛剣
    ko: 용비검
    zh_hant: 龍飛劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2266
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3171:
  _id_: 3171
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2273
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3172:
  _id_: 3172
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2274
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3173:
  _id_: 3173
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3174:
  _id_: 3174
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3175:
  _id_: 3175
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3176:
  _id_: 3176
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3177:
  _id_: 3177
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to 3 front enemies.
    ja: 前から3体の敵にACTパワーダウン付与
    ko: 앞에서 3명의 적에게 ACT 파워 감소를 부여
    zh_hant: 降低前方3個敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3178:
  _id_: 3178
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3179:
  _id_: 3179
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3181:
  _id_: 3181
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3182:
  _id_: 3182
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3183:
  _id_: 3183
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3184:
  _id_: 3184
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3185:
  _id_: 3185
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3186:
  _id_: 3186
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 1 rear enemy.
    ja: 自身に必中を付与し、後から1体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
3187:
  _id_: 3187
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3188:
  _id_: 3188
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3189:
  _id_: 3189
  attribute_id: 4
  cost: 2
  description:
    en: High damage & Confusion to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、混乱を付与
    ko: 뒤에서부터 3명의 적에게 위력(대) 공격, 혼란을 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3191:
  _id_: 3191
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2291
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3192:
  _id_: 3192
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3193:
  _id_: 3193
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2293
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3194:
  _id_: 3194
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3195:
  _id_: 3195
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to 1 front enemy.
    ja: 自身に必中を付与し、前から1体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 1명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的1個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
3196:
  _id_: 3196
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3197:
  _id_: 3197
  attribute_id: 7
  cost: 2
  description:
    en: AP Up to 3 front enemies.
    ja: 前から3体の敵にAP増加を付与
    ko: 앞에서 3명의 적에게 AP 증가를 부여
    zh_hant: 賦予前方的3個敵人AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3199:
  _id_: 3199
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3200:
  _id_: 3200
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3201:
  _id_: 3201
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2300
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3202:
  _id_: 3202
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3203:
  _id_: 3203
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3204:
  _id_: 3204
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2303
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3205:
  _id_: 3205
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2304
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3206:
  _id_: 3206
  attribute_id: 4
  cost: 2
  description:
    en: Set chance to inflict Burn & Stun to all enemies.
    ja: 敵全体に確率で火傷とスタンを付与
    ko: 적 전체에게 일정 확률로 화상과 스턴을 부여
    zh_hant: 機率性賦予所有敵人燒傷與暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2305
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3207:
  _id_: 3207
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2306
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3208:
  _id_: 3208
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies. Reflect Normal Damage to self.
    ja: 後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2307
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3209:
  _id_: 3209
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies. Reflect Normal Damage to self.
    ja: 後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2308
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3211:
  _id_: 3211
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2309
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3212:
  _id_: 3212
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2310
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3213:
  _id_: 3213
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2311
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3214:
  _id_: 3214
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2312
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3215:
  _id_: 3215
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2313
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3216:
  _id_: 3216
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3217:
  _id_: 3217
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3218:
  _id_: 3218
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3219:
  _id_: 3219
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3221:
  _id_: 3221
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3222:
  _id_: 3222
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3223:
  _id_: 3223
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3224:
  _id_: 3224
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3225:
  _id_: 3225
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3226:
  _id_: 3226
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3227:
  _id_: 3227
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
3228:
  _id_: 3228
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3229:
  _id_: 3229
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3230:
  _id_: 3230
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3231:
  _id_: 3231
  attribute_id: 4
  cost: 2
  description:
    en: High damage & chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で混乱を付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3233:
  _id_: 3233
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2329
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3234:
  _id_: 3234
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2330
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3235:
  _id_: 3235
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2331
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3236:
  _id_: 3236
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2332
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3237:
  _id_: 3237
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to 3 front enemies.
    ja: 自身に必中を付与し、前から3体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對前方的3個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2333
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3238:
  _id_: 3238
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2334
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3239:
  _id_: 3239
  attribute_id: 7
  cost: 2
  description:
    en: High damage & AP Up to all enemies.
    ja: 敵全体に威力(大)で攻撃し、AP増加を付与
    ko: 적 전체에게 위력(대) 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2335
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3241:
  _id_: 3241
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2336
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3242:
  _id_: 3242
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2337
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3243:
  _id_: 3243
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2338
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3244:
  _id_: 3244
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2339
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3245:
  _id_: 3245
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2340
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3246:
  _id_: 3246
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2341
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3247:
  _id_: 3247
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2342
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3248:
  _id_: 3248
  attribute_id: 4
  cost: 2
  description:
    en: Burn & Stun to all enemies.
    ja: 敵全体に火傷とスタン付与
    ko: 적 전체에게 화상과 스턴을 부여
    zh_hant: 賦予所有敵人燒傷與暈眩效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2343
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3249:
  _id_: 3249
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2344
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3250:
  _id_: 3250
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2345
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3251:
  _id_: 3251
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2346
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3253:
  _id_: 3253
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3254:
  _id_: 3254
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3255:
  _id_: 3255
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3256:
  _id_: 3256
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3257:
  _id_: 3257
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3258:
  _id_: 3258
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3259:
  _id_: 3259
  attribute_id: 7
  cost: 3
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3260:
  _id_: 3260
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2354
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3261:
  _id_: 3261
  attribute_id: 7
  cost: 3
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2355
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3263:
  _id_: 3263
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3264:
  _id_: 3264
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3265:
  _id_: 3265
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3266:
  _id_: 3266
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3267:
  _id_: 3267
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3268:
  _id_: 3268
  attribute_id: 4
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3269:
  _id_: 3269
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3270:
  _id_: 3270
  attribute_id: 4
  cost: 2
  description:
    en: Remove Negative Effects to self. Remove Positive Effects to all enemies.
    ja: 自身のマイナス効果を解除し、敵全体のプラス効果を解除する
    ko: 자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제
    zh_hant: 解除自己的負面效果，同時解除所有敵人的正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3271:
  _id_: 3271
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3272:
  _id_: 3272
  attribute_id: 4
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2365
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3273:
  _id_: 3273
  attribute_id: 4
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Confusion to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2366
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3275:
  _id_: 3275
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3276:
  _id_: 3276
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3277:
  _id_: 3277
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3278:
  _id_: 3278
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3279:
  _id_: 3279
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3280:
  _id_: 3280
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3281:
  _id_: 3281
  attribute_id: 7
  cost: 2
  description:
    en: Normal Defense down & Special Defense down to all enemies.
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: 적 전체에게 일반/특수 방어력 감소를 부여
    zh_hant: 降低所有敵人的普通防禦力與特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3282:
  _id_: 3282
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & AP Up to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、AP増加を付与
    ko: 적 전체에게 강력한 다단 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2374
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3283:
  _id_: 3283
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & AP Up to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、AP増加を付与
    ko: 적 전체에게 강력한 다단 공격, AP 증가를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予AP增加
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2375
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3285:
  _id_: 3285
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2376
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3286:
  _id_: 3286
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2377
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3287:
  _id_: 3287
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2378
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3288:
  _id_: 3288
  attribute_id: 4
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2379
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3289:
  _id_: 3289
  attribute_id: 4
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2380
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3290:
  _id_: 3290
  attribute_id: 4
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2381
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3291:
  _id_: 3291
  attribute_id: 4
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2382
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3292:
  _id_: 3292
  attribute_id: 4
  cost: 2
  description:
    en: Strong Burn & Stun to all enemies.
    ja: 敵全体に高威力の火傷とスタン付与
    ko: 적 전체에게 높은 위력의 화상과 스턴을 부여
    zh_hant: 賦予所有敵人高威力的燒傷與暈眩效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2383
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3293:
  _id_: 3293
  attribute_id: 4
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2384
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3294:
  _id_: 3294
  attribute_id: 4
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2385
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3295:
  _id_: 3295
  attribute_id: 4
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2386
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3314:
  _id_: 3314
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2397
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3315:
  _id_: 3315
  attribute_id: 5
  cost: 1
  description:
    en: Removes Cont. Positive Effects to 3 front enemies.
    ja: 前から3体の敵の継続プラス効果を解除する
    ko: 앞에서 3명의 적의 지속 플러스 효과를 해제
    zh_hant: 解除前面3名敵方的持續性正面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Victory Strategy
    ja: 勝機の戦法
    ko: 승기의 전법
    zh_hant: 致勝的戰術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2398
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3316:
  _id_: 3316
  attribute_id: 5
  cost: 2
  description:
    en: High damage to enemy with the highest Act Power. AP Down to 3 front allies.
    ja: ACTパワーが高い敵1体に威力(大)の攻撃を行い、前から3体の味方にAP減少を付与する
    ko: ACT 파워가 높은 적 1명에게 위력(대) 공격, 앞에서 3명의 아군에게 AP 감소를 부여
    zh_hant: 對1名ACT力量高的敵人發動威力（大）攻擊，並賦予前面3名我方AP減少
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Blade of Justice
    ja: 正義の太刀
    ko: 정의의 검
    zh_hant: 正義的太刀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2399
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1133
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3317:
  _id_: 3317
  attribute_id: 5
  cost: 2
  description:
    en: Very high damage & Stop to enemy with the highest Act Power, dealing extra
      damage to special-type enemies.
    ja: ACTパワーが高い敵1体に威力(大+)の攻撃を行い、ストップを付与する　この攻撃は特殊タイプの敵に特攻
    ko: ACT 파워가 높은 적 1명에게 위력(대+) 공격, 스톱을 부여, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對1名ACT力量高的敵人發動威力（大+）攻擊，並賦予停止　此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Purge Blade
    ja: 粛清の刃
    ko: 숙청의 칼날
    zh_hant: 肅清之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2400
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2051
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
  - hit_rate: 100
    id: 60
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3334:
  _id_: 3334
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2412
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3335:
  _id_: 3335
  attribute_id: 5
  cost: 2
  description:
    en: High damage to front enemy. Removes Cont. Positive Effects to all enemies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果を解除する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Purity of Heaven
    ja: 天命の浄化
    ko: 천명의 정화
    zh_hant: 天命的淨化
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2413
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3336:
  _id_: 3336
  attribute_id: 5
  cost: 3
  description:
    en: Medium damage to all enemies. Dexterity up & Effective element damage up to
      all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体にクリティカル率アップ、有利属性ダメージアップを付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전원에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並提升所有我方的會心率、對有利屬性的傷害
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Destiny Guidance
    ja: 運命の導き
    ko: 운명의 인도
    zh_hant: 命運之引導
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2414
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3337:
  _id_: 3337
  attribute_id: 5
  cost: 2
  description:
    en: Special Defense down & Perfect Aim Very High damage to 3 front enemies, ignoring
      Aggro, Provoke, Barrier, Reflect and Invincible.
    ja: 前から3体の敵に特殊防御力ダウンを付与し、威力(大+)の必中攻撃を行う この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する
    ko: 앞에서 3명의 적에게 특수 방어력 감소를 부여, 위력(대+)의 백발백중 공격, 이 공격은 타깃 고정, 도발, 배리어, 반사, 무적을
      무시
    zh_hant: 降低前方3名敵人的特殊防禦力，並發動威力（大+）的必中攻擊 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵
  icon_id: 198
  is_multiple_command_unique_skill: 0
  name:
    en: Destiny's End
    ja: エンド・オブ・ディスティニー
    ko: 엔드 오브 데스티니
    zh_hant: End Of Destiny
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2415
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 13
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 310
    target_id: 2177
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 186
    - 200
    - 214
    - 228
    - 243
3339:
  _id_: 3339
  attribute_id: 2
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Medium damage to rear enemy.
    ja: 後ろから1番目の敵の継続プラス効果を解除し、威力(中)の攻撃を行う
    ko: 뒤에서 첫 번째 적의 지속 플러스 효과를 해제, 위력(중) 공격
    zh_hant: 解除後面數來第1個敵人的持續性正面效果，並發動威力（中）攻擊
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Severing Flash
    ja: 断切の一閃
    ko: 단절의 일섬
    zh_hant: 切斷之閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2417
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
3340:
  _id_: 3340
  attribute_id: 2
  cost: 2
  description:
    en: High damage to rear enemy. Normal Barrier & Special Barrier to all allies.
    ja: 後ろから1番目の敵に威力(大)で攻撃し、味方全体に通常バリアと特殊バリアを付与する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 일반 배리어와 특수 배리어를 부여
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，並賦予所有我方普通防護罩、特殊防護罩
  icon_id: 30
  is_multiple_command_unique_skill: 0
  name:
    en: Sturdy Stance
    ja: 強堅の構え
    ko: 굳건한 자세
    zh_hant: 堅韌的架式
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2418
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 30
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
3341:
  _id_: 3341
  attribute_id: 2
  cost: 3
  description:
    en: High damage to rear enemy. High chance at Sleep to 3 rear enemies.
    ja: 後ろから1番目の敵に威力(大)で攻撃し、後ろから3体の敵に高確率で睡眠を付与する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 적에게 높은 확률로 수면을 부여
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，並高機率賦予後方3名敵人睡眠效果
  icon_id: 58
  is_multiple_command_unique_skill: 0
  name:
    en: Hypnotic Dance
    ja: 催眠の舞
    ko: 최면의 춤
    zh_hant: 催眠之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2419
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 75
    id: 58
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3342:
  _id_: 3342
  attribute_id: 2
  cost: 2
  description:
    en: Very High damage to 3 rear enemies. Evasion Rate up & Exit Evasion to 3 rear
      allies.
    ja: 後ろから3体の敵に威力(大+)で攻撃を行い、後ろから3体の味方に回避率アップと退場回避を付与する
    ko: 뒤에서 3명의 적에게 위력(대+) 공격, 뒤에서 3명의 아군에게 회피 확률 증가와 퇴장 회피를 부여
    zh_hant: 對後方的3個敵人發動威力（大+）攻擊，並提升後方3名我方的迴避率，同時賦予退場迴避
  icon_id: 155
  is_multiple_command_unique_skill: 0
  name:
    en: Ruler's War
    ja: 天下人の戦
    ko: 천하를 얻은 자의 싸움
    zh_hant: 天下霸主之戰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2420
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 186
    - 200
    - 214
    - 228
    - 243
  - hit_rate: 100
    id: 18
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
  - hit_rate: 100
    id: 155
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3344:
  _id_: 3344
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2422
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3345:
  _id_: 3345
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2423
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3346:
  _id_: 3346
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2424
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3347:
  _id_: 3347
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2425
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3348:
  _id_: 3348
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2426
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3349:
  _id_: 3349
  attribute_id: 7
  cost: 2
  description:
    en: Powerful Multi-hit attack to 1 rear enemy.
    ja: 後から1体の敵に強力な多段攻撃
    ko: 뒤에서 1명의 적에게 강력한 다단 공격
    zh_hant: 對後方的1個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flurry
    ja: 強連撃
    ko: 강한 연격
    zh_hant: 強連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2427
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
3350:
  _id_: 3350
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2428
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3351:
  _id_: 3351
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2429
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3352:
  _id_: 3352
  attribute_id: 7
  cost: 2
  description:
    en: Set chance to inflict Stun to all enemies.
    ja: 敵全体に確率でスタンを付与する
    ko: 적 전체에게 일정 확률로 스턴을 부여
    zh_hant: 機率性賦予所有敵人暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Stay Away! NEO
    ja: こっちにこないで！ NEO
    ko: 가까이 오지 마! NEO
    zh_hant: 不要過來！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2430
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3354:
  _id_: 3354
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2431
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3355:
  _id_: 3355
  attribute_id: 6
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2432
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3356:
  _id_: 3356
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2433
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3357:
  _id_: 3357
  attribute_id: 6
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2434
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3358:
  _id_: 3358
  attribute_id: 6
  cost: 2
  description:
    en: Dexterity down & Critical down to 3 front enemies.
    ja: 前から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 앞에서 3명의 적에게 크리티컬 확률 감소를 부여, 크리티컬 위력 감소를 부여
    zh_hant: 降低前方3個敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2435
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3359:
  _id_: 3359
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2436
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3360:
  _id_: 3360
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.
    ja: 自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2437
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3362:
  _id_: 3362
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2438
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3363:
  _id_: 3363
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2439
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3364:
  _id_: 3364
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2440
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3365:
  _id_: 3365
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2441
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3366:
  _id_: 3366
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Powerful Multi-hit attack to 1 rear enemy.
    ja: 自身に必中を付与し、後から1体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여하고, 뒤에서 1명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對後方的1個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2442
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 170
    - 170
    - 170
    - 170
3367:
  _id_: 3367
  attribute_id: 7
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2443
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3368:
  _id_: 3368
  attribute_id: 7
  cost: 2
  description:
    en: Accuracy Rate Down to 3 rear enemies.
    ja: 後ろから3体に命中率ダウンを付与
    ko: 뒤에서 3명에게 명중률 감소를 부여
    zh_hant: 降低後方3名的命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzling Rondo
    ja: 眩惑の輪舞曲
    ko: 현혹의 윤무곡
    zh_hant: 眩目圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2444
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 17
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3369:
  _id_: 3369
  attribute_id: 7
  cost: 2
  description:
    en: High damage & Accuracy Rate down to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃を行い、命中率ダウンを付与
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 명중률 감소를 부여
    zh_hant: 對後方3個敵方發動威力（大）攻擊，並降低命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fuoco! NEO
    ja: Fuoco! NEO
    ko: Fuoco! NEO
    zh_hant: Fuoco！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2445
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 17
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3371:
  _id_: 3371
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2446
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3372:
  _id_: 3372
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2447
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3373:
  _id_: 3373
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2448
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3374:
  _id_: 3374
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2449
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3375:
  _id_: 3375
  attribute_id: 6
  cost: 2
  description:
    en: High damage to front 3 enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2450
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3376:
  _id_: 3376
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies. Dmg Received down to self.
    ja: 前から3体の敵に威力(大)で攻撃し、自身に被ダメージダウンを付与する
    ko: 앞에서 3명의 적에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여
    zh_hant: 對前面3名敵人發動威力（大）攻擊，並降低自身受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Protection
    ja: 加護の斬撃
    ko: 가호의 참격
    zh_hant: 加護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2451
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3377:
  _id_: 3377
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2452
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3378:
  _id_: 3378
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2453
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3379:
  _id_: 3379
  attribute_id: 6
  cost: 2
  description:
    en: Set chance to inflict Poison & Confusion to all enemies.
    ja: 敵全体に確率で毒と混乱を付与
    ko: 적 전체에게 일정 확률로 독, 혼란을 부여
    zh_hant: 機率性賦予所有敵人中毒和混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2454
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3381:
  _id_: 3381
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2455
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3382:
  _id_: 3382
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2456
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3383:
  _id_: 3383
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2457
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3384:
  _id_: 3384
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2458
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3385:
  _id_: 3385
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2459
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3386:
  _id_: 3386
  attribute_id: 7
  cost: 2
  description:
    en: Powerful Multi-hit attack to 3 rear enemies.
    ja: 後から3体の敵に強力な多段攻撃
    ko: 뒤에서 3명의 적에게 강력한 다단 공격
    zh_hant: 對後方的3個敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Tri-Slash
    ja: 強参連撃
    ko: 강한 삼연격
    zh_hant: 強参連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3387:
  _id_: 3387
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3388:
  _id_: 3388
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3389:
  _id_: 3389
  attribute_id: 7
  cost: 2
  description:
    en: High damage & High chance at Stun to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率でスタンを付与する
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Constraint Concerto
    ja: 抑制の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑制協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3390:
  _id_: 3390
  attribute_id: 7
  cost: 2
  description:
    en: High damage & High chance at Stun to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率でスタンを付与する
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Stay Away! NEO
    ja: こっちにこないで！ NEO
    ko: 가까이 오지 마! NEO
    zh_hant: 不要過來！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3392:
  _id_: 3392
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3393:
  _id_: 3393
  attribute_id: 6
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3394:
  _id_: 3394
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3395:
  _id_: 3395
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3396:
  _id_: 3396
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3397:
  _id_: 3397
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3398:
  _id_: 3398
  attribute_id: 6
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3399:
  _id_: 3399
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3400:
  _id_: 3400
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3402:
  _id_: 3402
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3403:
  _id_: 3403
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3404:
  _id_: 3404
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3405:
  _id_: 3405
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3406:
  _id_: 3406
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Powerful Multi-hit attack to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に強力な多段攻撃
    ko: 자신에게 백발백중을 부여하고, 뒤에서 3명의 적에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Tri-Slash
    ja: 必中の参連撃
    ko: 백발백중의 삼연격
    zh_hant: 必中參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3407:
  _id_: 3407
  attribute_id: 7
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3408:
  _id_: 3408
  attribute_id: 7
  cost: 2
  description:
    en: Accuracy Rate down to all enemies.
    ja: 敵全体に命中率ダウンを付与
    ko: 적 전체에게 명중률 감소를 부여
    zh_hant: 降低所有敵人的命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzling Concerto
    ja: 眩惑の協奏曲
    ko: 현혹의 협주곡
    zh_hant: 眩目協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3409:
  _id_: 3409
  attribute_id: 7
  cost: 2
  description:
    en: High damage & Accuracy Rate down to all enemies.
    ja: 敵全体に威力(大)で攻撃し、命中率ダウンを付与
    ko: 적 전체에게 위력(대) 공격, 명중률 감소를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並降低命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fuoco! NEO
    ja: Fuoco! NEO
    ko: Fuoco! NEO
    zh_hant: Fuoco！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3411:
  _id_: 3411
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3412:
  _id_: 3412
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3413:
  _id_: 3413
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3414:
  _id_: 3414
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3415:
  _id_: 3415
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3416:
  _id_: 3416
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies. Dmg Received down to self.
    ja: 敵全体に威力(大)で攻撃じ、自身に被ダメージダウンを付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並降低自身受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Protection
    ja: 加護の斬撃
    ko: 가호의 참격
    zh_hant: 加護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2487
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3417:
  _id_: 3417
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2488
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3418:
  _id_: 3418
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2489
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3419:
  _id_: 3419
  attribute_id: 6
  cost: 2
  description:
    en: High damage & High chance at Poison & Confusion to all enemies
    ja: 敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Slash
    ja: 毒惑の斬撃
    ko: 독혹의 참격
    zh_hant: 毒惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2490
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3420:
  _id_: 3420
  attribute_id: 6
  cost: 2
  description:
    en: High damage & High chance at Poison & Confusion to all enemies
    ja: 敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2491
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3422:
  _id_: 3422
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2492
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3423:
  _id_: 3423
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2493
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3424:
  _id_: 3424
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2494
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3425:
  _id_: 3425
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2495
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3426:
  _id_: 3426
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2496
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3427:
  _id_: 3427
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2497
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3428:
  _id_: 3428
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2498
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3429:
  _id_: 3429
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2499
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3430:
  _id_: 3430
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Stun to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、スタンを付与する
    ko: 적 전체에게 강력한 다단 공격, 스턴을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Constraint Concerto
    ja: 抑制の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑制協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2500
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3431:
  _id_: 3431
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Stun to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、スタンを付与する
    ko: 적 전체에게 강력한 다단 공격, 스턴을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予暈眩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Stay Away! NEO
    ja: こっちにこないで！ NEO
    ko: 가까이 오지 마! NEO
    zh_hant: 不要過來！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2501
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3433:
  _id_: 3433
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2502
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3434:
  _id_: 3434
  attribute_id: 6
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2503
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3435:
  _id_: 3435
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2504
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3436:
  _id_: 3436
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2505
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3437:
  _id_: 3437
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3438:
  _id_: 3438
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3439:
  _id_: 3439
  attribute_id: 6
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2508
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3440:
  _id_: 3440
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3441:
  _id_: 3441
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2510
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3443:
  _id_: 3443
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 1 rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2511
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3444:
  _id_: 3444
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 1 rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2512
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3445:
  _id_: 3445
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2513
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3446:
  _id_: 3446
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2514
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3447:
  _id_: 3447
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2515
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3448:
  _id_: 3448
  attribute_id: 7
  cost: 2
  description:
    en: Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Tri-Slash
    ja: 必中の参連撃
    ko: 백발백중의 삼연격
    zh_hant: 必中參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2516
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3449:
  _id_: 3449
  attribute_id: 7
  cost: 2
  description:
    en: Normal Barrier & Special Barrier to self.
    ja: 自身に通常バリア、特殊バリアを付与
    ko: 자신에게 일반 배리어, 특수 배리어를 부여
    zh_hant: 賦予自己普通防護罩、特殊防護罩
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2517
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3450:
  _id_: 3450
  attribute_id: 7
  cost: 2
  description:
    en: Accuracy Rate down to all enemies.
    ja: 敵全体に命中率ダウンを付与
    ko: 적 전체에게 명중률 감소를 부여
    zh_hant: 降低所有敵人的命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzling Concerto
    ja: 眩惑の協奏曲
    ko: 현혹의 협주곡
    zh_hant: 眩目協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2518
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3451:
  _id_: 3451
  attribute_id: 7
  cost: 2
  description:
    en: 'Strong Multi-hit attack & Accuracy Rate down to all enemies. '
    ja: 敵全体に強力な多段攻撃を行い、命中率ダウンを付与
    ko: 적 전체에게 강력한 다단 공격, 명중률 감소를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並降低命中率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fuoco! NEO
    ja: Fuoco! NEO
    ko: Fuoco! NEO
    zh_hant: Fuoco！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2519
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3453:
  _id_: 3453
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2520
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3454:
  _id_: 3454
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2521
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3455:
  _id_: 3455
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2522
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3456:
  _id_: 3456
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2523
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3457:
  _id_: 3457
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Strong Dmg Received down to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に強力な被ダメージダウンを付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 강력한 받는 대미지 감소를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並大幅降低自己受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Protection
    ja: 加護の斬撃
    ko: 가호의 참격
    zh_hant: 加護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2524
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3458:
  _id_: 3458
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2525
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3459:
  _id_: 3459
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2526
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3460:
  _id_: 3460
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack & Poison & Confusion to all enemies
    ja: 敵全体に強力な多段攻撃を行い、毒と混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 독, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Slash
    ja: 毒惑の斬撃
    ko: 독혹의 참격
    zh_hant: 毒惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2527
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3461:
  _id_: 3461
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack & Poison & Confusion to all enemies
    ja: 敵全体に強力な多段攻撃を行い、毒と混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 독, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2528
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3471:
  _id_: 3471
  attribute_id: 4
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2536
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3472:
  _id_: 3472
  attribute_id: 4
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Medium damage to front enemy.
    ja: 前から1番目の敵の継続プラス効果を解除し、威力(中)の攻撃を行う
    ko: '앞에서 첫 번째 적에게 지속 플러스 효과를 해제, 위력(중) 공격 '
    zh_hant: 解除前面數來第1個敵人的持續性正面效果，並發動威力（中）攻擊
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Severing Slash
    ja: 断切の斬撃
    ko: 단절의 참격
    zh_hant: 切斷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2537
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3473:
  _id_: 3473
  attribute_id: 4
  cost: 3
  description:
    en: High damage to front enemy & chance at Blindness to all enemies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、敵全体に一定確率で暗闇を付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 일정 확률로 암흑을 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並有一定機率賦予所有敵人盲目效果
  icon_id: 62
  is_multiple_command_unique_skill: 0
  name:
    en: Darkness Slash
    ja: 黒暗の斬撃
    ko: 암흑의 참격
    zh_hant: 黑闇斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2538
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 40
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3474:
  _id_: 3474
  attribute_id: 4
  cost: 2
  description:
    en: Perfect Aim to self. High damage & Blindness & Act Power down to all enemies.
      Applies Stage Effect [We Are on the Stage (Moon)] to allies' stage.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃を行い、暗闇とACTパワーダウンを付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（月）」を付与する
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격, 암흑과 ACT 파워 감소를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미
      무대 위(달)]을 부여
    zh_hant: 賦予自身必中效果，對所有敵人發動威力（大）攻擊，賦予盲目並降低ACT力量，同時賦予我方的舞台舞台效果「我們已經站上舞台（月）」
  icon_id: 1004
  is_multiple_command_unique_skill: 0
  name:
    en: All of this... is for the sake of "Starlight"!
    ja: 全ては、スタァライトのために！
    ko: 모든 것은 스타라이트를 위해!
    zh_hant: 一切都是為了Starlight！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2539
  skill_field_effect_id: 6
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3476:
  _id_: 3476
  attribute_id: 6
  cost: 2
  description:
    en: Low damage & Mark to front enemy.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、刻印を付与する
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 각인을 부여
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並賦予刻印
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Marked Slash
    ja: 刻印の斬撃
    ko: 각인의 참격
    zh_hant: 刻印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2541
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 150
    target_id: 2011
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3477:
  _id_: 3477
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies. Removes Cont. Negative Effects from all allies.
    ja: 敵全体に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除する
    ko: 적 전체에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제
    zh_hant: 對所有敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞踊
    ko: 정화의 무용
    zh_hant: 淨化舞蹈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2542
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3478:
  _id_: 3478
  attribute_id: 6
  cost: 3
  description:
    en: Agility up to all allies. Agility down to all enemies.
    ja: 味方全体にすばやさアップを付与し、敵全体にすばやさダウンを付与する
    ko: 아군 전체에게 민첩 증가를 부여, 적 전체에게 민첩 감소를 부여
    zh_hant: 提升所有我方的敏捷，並降低所有敵人的敏捷
  icon_id: 14
  is_multiple_command_unique_skill: 0
  name:
    en: Turnaround Move
    ja: 逆転の一手
    ko: 역전의 한 수
    zh_hant: 逆轉的一步
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2543
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 15
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3479:
  _id_: 3479
  attribute_id: 6
  cost: 2
  description:
    en: Dexterity down & Critical down & Special Defense down & Very High damage to
      all enemies, dealing more damage when own HP is lower.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン、特殊防御力ダウンを付与し、威力(大+)で攻撃を行う　この攻撃は自身のHPが低い程威力が増加する
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소, 특수 방어력 감소를 부여, 자신의 HP가 낮을수록 위력이 증가하는 위력(대+)
      공격
    zh_hant: 降低所有敵人的會心率、會心威力、特殊防禦力，並發動威力（大+）攻擊　此攻擊會在自己HP越低時威力越強
  icon_id: 5
  is_multiple_command_unique_skill: 0
  name:
    en: Peach Oath
    ja: 桃園の誓い
    ko: 도원의 맹세
    zh_hant: 桃園三結義
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2544
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 147
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 125
    - 135
    - 145
    - 155
    - 170
3496:
  _id_: 3496
  attribute_id: 1
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2558
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3497:
  _id_: 3497
  attribute_id: 1
  cost: 2
  description:
    en: Dexterity up & Critical up to self. Medium damage to front enemy.
    ja: 自身にクリティカル率アップ、クリティカル威力アップを付与し、前から1番目の敵に威力(中)の攻撃を行う
    ko: 자신에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여하고, 앞에서 첫 번째 적에게 위력(중) 공격
    zh_hant: 提升自己的會心率、會心威力，並對前面數來第1個敵人發動威力（中）攻擊
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Warrior's Pride
    ja: 武士の矜持
    ko: 무사의 긍지
    zh_hant: 武士的矜持
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2559
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
3498:
  _id_: 3498
  attribute_id: 1
  cost: 2
  description:
    en: Act Power up & Effective element damage up to self. High damage to front enemy.
    ja: 自身にACTパワーアップ、有利属性ダメージアップを付与し、前から1番目の敵に威力(大)の攻撃を行う
    ko: 자신에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여, 앞에서 첫 번째 적에게 위력(대) 공격
    zh_hant: 提升自己的ACT力量、對有利屬性的傷害，並對前面數來第1個敵人發動威力（大）攻擊
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Tough Blade
    ja: 強靭な刃
    ko: 강인한 칼날
    zh_hant: 堅韌之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2560
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 39
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
3499:
  _id_: 3499
  attribute_id: 1
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Very High damage to front enemy, dealing
      extra damage to normal-type enemies.
    ja: 前から1番目の敵の継続プラス効果を解除し、威力(大+)の攻撃を行う　この攻撃は通常タイプの敵に特攻
    ko: 앞에서 첫 번째 적의 지속 플러스 효과를 해제, 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격
    zh_hant: 解除前面數來第1個敵人的持續性正面效果，並發動威力（大+）攻擊　此攻擊會對普通類型的敵人造成特攻效果
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Kotetsu's Roar
    ja: 虎徹ノ轟咆
    ko: 코테츠의 포효
    zh_hant: 虎徹的轟咆
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2561
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 306
    target_id: 2011
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3532:
  _id_: 3532
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2592
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3533:
  _id_: 3533
  attribute_id: 2
  cost: 2
  description:
    en: Medium damage to all enemies. Removes Cont. Negative Effects from all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体の継続マイナス効果を解除する
    ko: 적 전체에게 위력(중) 공격, 아군 전체의 지속 마이너스 효과를 해제
    zh_hant: 對所有敵人發動威力（中）攻擊，並解除所有我方的持續性負面效果
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Weir Unleashing
    ja: しがらみの解放
    ko: 속박의 해방
    zh_hant: 解放束縛
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2593
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3534:
  _id_: 3534
  attribute_id: 2
  cost: 2
  description:
    en: Medium damage & Act Power down & Dexterity down to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、ACTパワーダウンとクリティカル率ダウンを付与する
    ko: 적 전체에게 위력(중) 공격, ACT 파워 감소, 크리티컬 확률 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並降低ACT力量、會心率
  icon_id: 21
  is_multiple_command_unique_skill: 0
  name:
    en: Belligerent Smile
    ja: 好戦的な笑み
    ko: 호전적인 웃음
    zh_hant: 好戰的笑容
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2594
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3535:
  _id_: 3535
  attribute_id: 2
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Climax Act Power down & Very High damage
      to all enemies.
    ja: 敵全体の継続プラス効果を解除し、クライマックスACT威力ダウンを付与し、威力(大+)で攻撃を行う
    ko: 적 전체의 지속 플러스 효과를 해제하고 클라이맥스 ACT 위력 감소를 부여, 위력(대+) 공격
    zh_hant: 解除所有敵人的持續性正面效果，降低CLIMAX ACT威力，並發動威力（大+）攻擊
  icon_id: 220
  is_multiple_command_unique_skill: 0
  name:
    en: Chariot Rampage
    ja: チャリオット・ランペイジ
    ko: 채리엇 램페이지
    zh_hant: 衝鋒馬車
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2595
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 339
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 42
    - 44
    - 47
    - 50
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3537:
  _id_: 3537
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2597
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3538:
  _id_: 3538
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2598
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3539:
  _id_: 3539
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2599
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3540:
  _id_: 3540
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2600
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3541:
  _id_: 3541
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Thrust
    ja: 連刺突
    ko: 연속 찌르기
    zh_hant: 連突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2601
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3542:
  _id_: 3542
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵にACTパワーダウン付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2602
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3543:
  _id_: 3543
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2603
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3544:
  _id_: 3544
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、後から3体の敵に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2604
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3545:
  _id_: 3545
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、後から3体の敵に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2605
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3547:
  _id_: 3547
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting
    ja: 狙撃
    ko: 저격
    zh_hant: 狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3548:
  _id_: 3548
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3549:
  _id_: 3549
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3550:
  _id_: 3550
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3551:
  _id_: 3551
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2610
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3552:
  _id_: 3552
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3553:
  _id_: 3553
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃し、火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Rondo
    ja: 闇炎の輪舞曲
    ko: 암흑 불꽃의 윤무곡
    zh_hant: 暗炎圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3554:
  _id_: 3554
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃し、火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3556:
  _id_: 3556
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3557:
  _id_: 3557
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2615
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3558:
  _id_: 3558
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3559:
  _id_: 3559
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2617
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3560:
  _id_: 3560
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3561:
  _id_: 3561
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 170
    - 170
    - 170
    - 170
3562:
  _id_: 3562
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に通常バリア、特殊バリアを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2620
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3563:
  _id_: 3563
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2621
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3564:
  _id_: 3564
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に確率で混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2622
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3565:
  _id_: 3565
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に確率で混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2623
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3567:
  _id_: 3567
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3568:
  _id_: 3568
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3569:
  _id_: 3569
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3570:
  _id_: 3570
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3571:
  _id_: 3571
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3572:
  _id_: 3572
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
3573:
  _id_: 3573
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3574:
  _id_: 3574
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に確率で睡眠を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3576:
  _id_: 3576
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2632
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3577:
  _id_: 3577
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2633
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3578:
  _id_: 3578
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2634
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3579:
  _id_: 3579
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2635
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3580:
  _id_: 3580
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Thrust
    ja: 連刺突
    ko: 연속 찌르기
    zh_hant: 連突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2636
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3581:
  _id_: 3581
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体にACTパワーダウン付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2637
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3582:
  _id_: 3582
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2638
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3583:
  _id_: 3583
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2639
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3584:
  _id_: 3584
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、敵全体に多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2640
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3586:
  _id_: 3586
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3587:
  _id_: 3587
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から2体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3588:
  _id_: 3588
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2643
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3589:
  _id_: 3589
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3590:
  _id_: 3590
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3591:
  _id_: 3591
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3592:
  _id_: 3592
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3593:
  _id_: 3593
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2648
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3594:
  _id_: 3594
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3596:
  _id_: 3596
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2650
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3597:
  _id_: 3597
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2651
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3598:
  _id_: 3598
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2652
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3599:
  _id_: 3599
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2653
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3600:
  _id_: 3600
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2654
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3601:
  _id_: 3601
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2655
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3602:
  _id_: 3602
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に通常バリア、特殊バリアを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3603:
  _id_: 3603
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3604:
  _id_: 3604
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、高確率で混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2658
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3605:
  _id_: 3605
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、高確率で混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3607:
  _id_: 3607
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3608:
  _id_: 3608
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3609:
  _id_: 3609
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3610:
  _id_: 3610
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3611:
  _id_: 3611
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3612:
  _id_: 3612
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
3613:
  _id_: 3613
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3614:
  _id_: 3614
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、確率で睡眠を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3615:
  _id_: 3615
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、確率で睡眠を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3617:
  _id_: 3617
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3618:
  _id_: 3618
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3619:
  _id_: 3619
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3620:
  _id_: 3620
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3621:
  _id_: 3621
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3622:
  _id_: 3622
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体にACTパワーダウン付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3623:
  _id_: 3623
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3624:
  _id_: 3624
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2676
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3625:
  _id_: 3625
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、敵全体に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2677
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3627:
  _id_: 3627
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3628:
  _id_: 3628
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3629:
  _id_: 3629
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3630:
  _id_: 3630
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3631:
  _id_: 3631
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3632:
  _id_: 3632
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3633:
  _id_: 3633
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、高威力の火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2684
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3634:
  _id_: 3634
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、高威力の火傷と暗闇を付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2685
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3636:
  _id_: 3636
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3637:
  _id_: 3637
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3638:
  _id_: 3638
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(小)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3639:
  _id_: 3639
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 前から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3640:
  _id_: 3640
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3641:
  _id_: 3641
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3642:
  _id_: 3642
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 自身に通常バリア、特殊バリアを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3643:
  _id_: 3643
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に通常防御力ダウン、特殊防御力ダウンを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3644:
  _id_: 3644
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2694
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3645:
  _id_: 3645
  attribute_id: 7
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2695
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3647:
  _id_: 3647
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から1体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3648:
  _id_: 3648
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から2体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3649:
  _id_: 3649
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 後から3体の敵に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3650:
  _id_: 3650
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3651:
  _id_: 3651
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3652:
  _id_: 3652
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
3653:
  _id_: 3653
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3654:
  _id_: 3654
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3655:
  _id_: 3655
  attribute_id: 1
  cost: 2
  description:
    en: ''
    ja: 敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する
    ko: ''
    zh_hant: ''
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3657:
  _id_: 3657
  attribute_id: 4
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2705
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3658:
  _id_: 3658
  attribute_id: 4
  cost: 3
  description:
    en: Very High damage & Heavy Poison & Strong Burn to all enemies.
    ja: 敵全体に威力(大+)で攻撃を行い、高威力の毒と高威力の火傷を付与する
    ko: 적 전체에게 위력(대+) 공격, 높은 위력의 독과 높은 위력의 화상을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並造成高威力的中毒與高威力的燒傷
  icon_id: 54
  is_multiple_command_unique_skill: 0
  name:
    en: Denunciation of Justice
    ja: 正義の糾弾
    ko: 정의의 규탄
    zh_hant: 正義的譴責
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2706
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 101
    - 106
    - 112
    - 116
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1000
    - 1500
    - 2000
    - 2500
    - 3000
3659:
  _id_: 3659
  attribute_id: 4
  cost: 3
  description:
    en: Medium damage & chance at Stop to 3 rear enemies.
    ja: 後ろから3体の敵に威力(中)で攻撃を行い、一定確率でストップを付与する
    ko: 뒤에서 3명의 적에게 위력(중) 공격, 일정 확률로 스톱을 부여
    zh_hant: 對後面的3個敵人發動威力（中）攻擊，並以一定機率造成停止
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure of Justice
    ja: 正義の重圧
    ko: 정의의 중압
    zh_hant: 正義的重壓
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2707
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 50
    id: 60
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3660:
  _id_: 3660
  attribute_id: 4
  cost: 1
  description:
    en: Strong Set damage to enemy with the highest Act Power.
    ja: ACTパワーが1番高い敵1体に高い固定値ダメージを与える
    ko: ACT 파워가 가장 높은 적 1명에게 높은 고정 대미지 공격
    zh_hant: 對1名ACT力量最高的敵人發動強大的固定傷害攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bullet of Justice
    ja: バレット・オブ・ジャスティス
    ko: 불릿 오브 저스티스
    zh_hant: Bullet of justice
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2708
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2146
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 60003
    - 70002
    - 80001
    - 90000
    - 99999
3662:
  _id_: 3662
  attribute_id: 3
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2710
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3663:
  _id_: 3663
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy. Dexterity up & Critical up to all allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、味方全体にクリティカル率アップ、クリティカル威力アップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的會心率、會心威力
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Trustworthy Light
    ja: 信頼の光
    ko: 신뢰의 빛
    zh_hant: 信賴之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2711
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
3664:
  _id_: 3664
  attribute_id: 3
  cost: 1
  description:
    en: Aggro to all enemies. Evasion Rate Up & Dmg Received down to self.
    ja: 敵全体にターゲット固定を付与し、自身に回避率アップと被ダメージダウンを付与する
    ko: 적 전체에게 타깃 고정을 부여, 자신에게 회피 확률 증가와 받는 대미지 감소를 부여
    zh_hant: 賦予所有敵人目標鎖定，並提升自己的迴避率與降低自己受到的傷害
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: King's Guidance
    ja: 王の導き
    ko: 왕의 인도
    zh_hant: 王之指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2712
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3665:
  _id_: 3665
  attribute_id: 3
  cost: 2
  description:
    en: 'Very High damage to enemy with the highest Act Power, dealing extra damage
      to enemies inflicted with Freeze. Removes Exit from 1 rear ally. '
    ja: ACTパワーの1番高い敵に威力(大+)の攻撃を行い、退場した中で後ろから1体の味方の退場状態を解除する　この攻撃は凍結状態の敵に特攻
    ko: ACT 파워가 가장 높은 적 1명에게 위력(대+) 공격, 퇴장한 아군 중 뒤에서 1명의 퇴장 상태를 해제, 이 공격은 동결 상태의 적에게
      특수 공격
    zh_hant: 對1名ACT力量最高的敵人發動威力（大+）攻擊，從已退場的舞台少女中解除後面1名我方的退場狀態　此攻擊會對凍結狀態的敵方造成特攻效果
  icon_id: 197
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Peace
    ja: 道に光を、戦場に花を
    ko: 길에 빛을, 전장에 꽃을
    zh_hant: 光綻放於道路，花盛開於戰場
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2713
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 283
    target_id: 2051
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
  - hit_rate: 100
    id: 309
    target_id: 11012
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 42
    - 44
    - 47
    - 50
3667:
  _id_: 3667
  attribute_id: 2
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2715
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3668:
  _id_: 3668
  attribute_id: 2
  cost: 2
  description:
    en: Medium damage to rear enemy. Act Power up & Effective element damage up to
      all allies.
    ja: 後ろから1番目の敵に威力(中)の攻撃を行い、味方全体にACTパワーアップ、有利属性ダメージアップを付与する
    ko: 뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여
    zh_hant: 對後面數來第1個敵人發動威力（中）攻擊，並提升所有我方的ACT力量、對有利屬性的傷害
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Victory Battle
    ja: 勝利の戦
    ko: 승리의 전쟁
    zh_hant: 勝利之戰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2716
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3669:
  _id_: 3669
  attribute_id: 2
  cost: 3
  description:
    en: High damage to rear enemy. Dexterity up & Effective element damage up to all
      allies.
    ja: 後ろから1番目の敵に威力(大)の攻撃を行い、味方全体にクリティカル率アップ、有利属性ダメージアップを付与する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，並提升所有我方的會心率、對有利屬性的傷害
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Furious War
    ja: 激情の乱
    ko: 격정의 난
    zh_hant: 激情之亂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2717
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3670:
  _id_: 3670
  attribute_id: 2
  cost: 2
  description:
    en: Flip Positive Effects x5 & Very High damage to rear enemy, dealing extra damage
      to normal-type enemies.
    ja: 後ろから1番目の敵に5回分のプラス効果反転を適用し、威力(大+)で攻撃を行う　この攻撃は通常タイプの敵に特攻
    ko: 뒤에서 첫 번째 적에게 5회분의 플러스 효과 반전을 적용, 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격
    zh_hant: 對後面數來第1個敵人施加5次正面狀態效果反轉，並發動威力（大+）攻擊 此攻擊會對普通類型的敵人造成特攻效果
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Invincible Spear
    ja: 天下無敵の槍
    ko: 천하무적의 창
    zh_hant: 天下無敵之槍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2718
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 323
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 306
    target_id: 2121
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3677:
  _id_: 3677
  attribute_id: 1
  cost: 2
  description:
    en: Medium+ damage to 3 front enemies.
    ja: 前から3体の敵に威力(中+)の攻撃
    ko: 앞에서 3명의 적에게 위력(중+) 공격
    zh_hant: 對前方的3個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2720
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
3678:
  _id_: 3678
  attribute_id: 1
  cost: 2
  description:
    en: Removes Cont. Positive Effects to all enemies. Removes Cont. Negative Effects
      from all allies.
    ja: 敵全体の継続プラス効果を解除し、味方全体の継続マイナス効果を解除する
    ko: 적 전체의 지속 플러스 효과를 해제하고, 아군 전체의 지속 마이너스 효과를 해제
    zh_hant: 解除所有敵人的持續性正面效果，並解除所有我方的持續性負面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Dream & Reality
    ja: 夢と現実
    ko: 꿈과 현실
    zh_hant: 夢與現實
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2721
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3679:
  _id_: 3679
  attribute_id: 1
  cost: 3
  description:
    en: Very High damage & chance at Sleep to all enemies.
    ja: 敵全体に威力(大+)の攻撃を行い、一定確率で睡眠を付与する
    ko: 적 전체에게 위력(대+) 공격, 일정 확률로 수면을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並在一定機率下造成睡眠
  icon_id: 58
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Dreams
    ja: 安らかな眠り
    ko: 편안한 잠
    zh_hant: 安詳的睡眠
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2722
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 101
    - 106
    - 112
    - 116
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3680:
  _id_: 3680
  attribute_id: 1
  cost: 2
  description:
    en: Very High damage to all enemies. Applies Stage Effect [Light of Courage] to
      allies' stage.
    ja: 敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「勇気の灯」を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [용기의 등불]을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「勇氣之燈」
  icon_id: 1000
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Dream
    ja: パーフェクトドリーム
    ko: 퍼펙트 드림
    zh_hant: 完美的夢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2723
  skill_field_effect_id: 1
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3682:
  _id_: 3682
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2725
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3683:
  _id_: 3683
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy, dealing extra damage to normal-type enemies.
    ja: 前から1番目の敵に威力(大)で攻撃 この攻撃は通常タイプの敵に特攻
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 일반 타입인 적에게 특수 공격
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對普通類型的敵人造成特攻效果
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Imagination Flash
    ja: 想像の一閃
    ko: 상상의 일섬
    zh_hant: 想像閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2726
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 306
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
3684:
  _id_: 3684
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy. AP Down to 3 rear allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、後ろから3体の味方にAP減少を付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 AP 감소를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並賦予後面3名我方AP減少
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Dream Song
    ja: 夢の歌
    ko: 꿈의 노래
    zh_hant: 夢之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2727
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3685:
  _id_: 3685
  attribute_id: 7
  cost: 2
  description:
    en: Very High damage to enemy with the highest Act Power, dealing extra damage
      to normal-type enemies.
    ja: ACTパワーが高い敵1体に威力(大+)の攻撃 この攻撃は通常タイプの敵に特攻
    ko: ACT 파워가 높은 적 1명에게 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격
    zh_hant: 對1名ACT力量高的敵人發動威力（大+）攻擊，此攻擊會對普通類型的敵方造成特攻效果
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Pillow Storm!
    ja: 高速マクラ！　乱れ投げ！
    ko: 고속 베개! 마구 던지기!
    zh_hant: 高速亂投枕！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2728
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 306
    target_id: 2051
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3703:
  _id_: 3703
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2743
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3704:
  _id_: 3704
  attribute_id: 7
  cost: 2
  description:
    en: Medium damage to all enemies. Perfect Aim & Damage Received down to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体に必中と被ダメージダウンを付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 백발백중, 받는 대미지 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，賦予所有我方必中，並降低所有我方受到的傷害
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Earnest Love
    ja: 一途な思い
    ko: 일편단심
    zh_hant: 專情
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2744
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 35
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 126
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3705:
  _id_: 3705
  attribute_id: 7
  cost: 2
  description:
    en: Medium damage to all enemies. Unremovable Cont. Negative Effects Resistance
      to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体に解除不可の継続マイナス効果耐性を付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 해제 불가능한 지속 마이너스 효과 저항을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並賦予所有我方無法解除的持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Fleeting Love
    ja: 淡い恋心
    ko: 아련한 연심
    zh_hant: 心懷戀慕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2745
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 346
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3706:
  _id_: 3706
  attribute_id: 7
  cost: 1
  description:
    en: High damage & Lovesickness to all enemies.
    ja: 敵全体に威力(大)で攻撃を行い、恋わずらいを付与する
    ko: 적 전체에게 위력(대) 공격, 상사병을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並造成苦戀
  icon_id: 221
  is_multiple_command_unique_skill: 0
  name:
    en: Labyrinthine Love
    ja: 恋は迷宮
    ko: 사랑은 미궁
    zh_hant: 戀愛迷宮
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2746
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 117
    - 123
    - 128
    - 134
    - 140
  - hit_rate: 100
    id: 340
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3708:
  _id_: 3708
  attribute_id: 5
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2748
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3709:
  _id_: 3709
  attribute_id: 5
  cost: 2
  description:
    en: Act Power up & Critical up to self. Medium damage to enemy with the highest
      Act Power.
    ja: 自身にACTパワーアップ、クリティカル威力アップを付与し、ACTパワーの1番高い敵に威力(中)の攻撃を行う
    ko: 자신에게 ACT 파워 증가, 크리티컬 위력 증가를 부여, ACT 파워가 가장 높은 적에게 위력(중) 공격
    zh_hant: 提升自己的ACT力量、會心威力，並對1名ACT力量最高的敵人發動威力（中）攻擊
  icon_id: 22
  is_multiple_command_unique_skill: 0
  name:
    en: Spearheading Blade
    ja: 先陣を切る刃
    ko: 선두를 달리는 칼날
    zh_hant: 先鋒之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2749
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
3710:
  _id_: 3710
  attribute_id: 5
  cost: 2
  description:
    en: Dexterity up & Effective element damage up to self. High damage to enemy with
      the highest Act Power
    ja: 自身にクリティカル率アップ、有利属性ダメージアップを付与し、ACTパワーの1番高い敵に威力(大)の攻撃を行う
    ko: 자신에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여,  ACT 파워가 가장 높은 적에게 위력(대) 공격
    zh_hant: 提升自己的會心率、有利屬性傷害，並對1名ACT力量最高的敵人發動威力（大）攻擊
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Dashing Blade
    ja: 颯爽たる刃
    ko: 씩씩한 칼날
    zh_hant: 颯爽之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2750
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 39
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
3711:
  _id_: 3711
  attribute_id: 5
  cost: 2
  description:
    en: Marked & Normal Defense down & Very High damage to enemy with the highest
      Act Power, dealing extra damage to special-type enemies.
    ja: ACTパワーの1番高い敵に刻印と通常防御力ダウンを付与し、威力(大+)の攻撃を行う　この攻撃は特殊タイプの敵に特攻
    ko: ACT 파워가 가장 높은 적에게 각인과 일반 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 賦予1名ACT力量最高的敵人刻印、降低普通防禦力，並發動威力（大+）攻擊　此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Greatest Spear
    ja: 日ノ本一の槍
    ko: 최고의 창
    zh_hant: 日本第一之槍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2751
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 150
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2051
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 308
    target_id: 2051
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3713:
  _id_: 3713
  attribute_id: 5
  cost: 2
  description:
    en: Low damage to rear enemy. Low Brilliance recovery to self.
    ja: 後ろから1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 뒤에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對後面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Slash
    ja: キラめきの剣撃
    ko: 반짝임의 검격
    zh_hant: 光芒劍擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2753
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3714:
  _id_: 3714
  attribute_id: 5
  cost: 2
  description:
    en: Medium damage to all enemies. Act Power up & AP Down to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体にACTパワーアップとAP減少を付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가와 AP 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並提升所有我方的ACT力量，同時賦予AP減少
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Justice
    ja: 正義の剣
    ko: 정의의 검
    zh_hant: 正義之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2754
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3715:
  _id_: 3715
  attribute_id: 5
  cost: 2
  description:
    en: High damage to rear enemy. Removes Cont. Negative Effects & HP recovery to
      all allies.
    ja: 後ろから1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除し、HPを回復する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제, HP를 회복
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，解除所有我方的持續性負面效果，並回復HP
  icon_id: 6
  is_multiple_command_unique_skill: 0
  name:
    en: Right Judgement
    ja: 正しき裁き
    ko: 올바른 심판
    zh_hant: 正當判決
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2755
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3716:
  _id_: 3716
  attribute_id: 5
  cost: 2
  description:
    en: Act Power up & Dexterity up & Critical up to self. Extremely High damage to
      all enemies.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与し、敵全体に威力(特大)で攻撃を行う
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여, 적 전체에게 위력(특대) 공격
    zh_hant: 提升自己的ACT力量＆會心率＆會心威力，並對所有敵人發動威力（特大）攻擊
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Absolute Justice
    ja: 絶対正義　強制断罪
    ko: 절대정의 강제단죄
    zh_hant: 絕對正義　強制定罪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2756
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
3718:
  _id_: 3718
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2758
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3719:
  _id_: 3719
  attribute_id: 1
  cost: 2
  description:
    en: Medium damage & Act Power down & Accuracy Rate down to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、ACTパワーダウンと命中率ダウンを付与する
    ko: 적 전체에게 위력(중) 공격, ACT 파워 감소, 명중률 감소를 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並降低ACT力量、命中率
  icon_id: 17
  is_multiple_command_unique_skill: 0
  name:
    en: Sun Glamor
    ja: 陽の幻惑
    ko: 태양의 환혹
    zh_hant: 陽之誘惑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2759
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 34
    - 37
    - 40
3720:
  _id_: 3720
  attribute_id: 1
  cost: 2
  description:
    en: Medium damage & Strong Burn to all enemies.
    ja: 敵全体に威力(中)で攻撃を行い、高威力の火傷を付与する
    ko: 적 전체에게 위력(중) 공격, 높은 위력의 화상을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並造成高威力的燒傷
  icon_id: 55
  is_multiple_command_unique_skill: 0
  name:
    en: Raging Sun
    ja: 猛炎の太陽
    ko: 맹염의 태양
    zh_hant: 猛炎之太陽
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2760
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1000
    - 1500
    - 2000
    - 2500
    - 3000
3721:
  _id_: 3721
  attribute_id: 1
  cost: 2
  description:
    en: Unremovable Heavy Burn & Special Defense down & Very High damage to all enemies.
      Deals extra damage to enemies inflicted with Burn.
    ja: 敵全体に解除不可の大火傷と特殊防御力ダウンを付与し、威力(大+)で攻撃を行う この攻撃は火傷状態の敵に対して特攻
    ko: 적 전체에게 해제 불가능한 대화상과 특수 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 화상 상태의 적에게 특수 공격
    zh_hant: 賦予所有敵人無法解除的嚴重燒傷並降低特殊防禦力，發動威力（大+）攻擊 此攻擊會對燒傷的敵人造成特攻效果
  icon_id: 55
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant☆Sunshine!
    ja: 燦々☆サンシャイン！
    ko: 눈부시게 빛나는 ☆선샤인!
    zh_hant: 燦爛☆陽光！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2761
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 304
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 277
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 125
    - 135
    - 145
    - 155
    - 170
3723:
  _id_: 3723
  attribute_id: 4
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2763
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3724:
  _id_: 3724
  attribute_id: 4
  cost: 2
  description:
    en: High damage to front enemy. Counter Heal to all allies.
    ja: 前から1番目の敵に威力(大)で攻撃を行い、味方全体にカウンターヒールを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 카운터 힐을 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並賦予所有我方還擊治療
  icon_id: 45
  is_multiple_command_unique_skill: 0
  name:
    en: Healing Prayer
    ja: 治癒の祈り
    ko: 치유의 기도
    zh_hant: 治癒的祈禱
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2764
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 241
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
3725:
  _id_: 3725
  attribute_id: 4
  cost: 1
  description:
    en: Aggro to all enemies. Normal Barrier & Special Barrier to self.
    ja: 敵全体にターゲット固定を付与し、自身に通常バリアと特殊バリアを付与する
    ko: 적 전체에게 타깃 고정을 부여, 자신에게 일반 배리어와 특수 배리어를 부여
    zh_hant: 賦予所有敵人目標鎖定，並賦予自身普通防護罩、特殊防護罩
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Solid Shield
    ja: 堅強の盾
    ko: 견고한 방패
    zh_hant: 堅強之盾
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2765
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
3726:
  _id_: 3726
  attribute_id: 4
  cost: 2
  description:
    en: Very High damage to enemy with the highest Act Power. Absorb & Damage Received
      down to all allies.
    ja: ACTパワーの一番高い敵に威力(大+)で攻撃を行い、味方全体に吸収と被ダメージダウンを付与する
    ko: ACT 파워가 가장 높은 적에게 위력(대+) 공격, 아군 전체에게 흡수와 받는 대미지 감소를 부여
    zh_hant: 對ACT力量最高的敵人發動威力（大+）攻擊，賦予所有我方吸收，並降低受到的傷害
  icon_id: 44
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament
    ja: 秘石が導く月光の秘蹟
    ko: 보석이 인도하는 달빛의 성례
    zh_hant: 由秘石所引導的月光秘蹟
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2766
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 328
    - 345
    - 361
    - 378
    - 394
  - hit_rate: 100
    id: 44
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 23
    - 26
    - 29
    - 33
  - hit_rate: 100
    id: 126
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3728:
  _id_: 3728
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2768
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3729:
  _id_: 3729
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2769
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3730:
  _id_: 3730
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2770
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3731:
  _id_: 3731
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2771
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3732:
  _id_: 3732
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2772
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3733:
  _id_: 3733
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies. Dmg Received down to self.
    ja: 前から3体の敵に威力(大)で攻撃し、自身に被ダメージダウンを付与する
    ko: 앞에서 3명의 적에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여
    zh_hant: 對前方的3個敵人發動威力（大）攻擊，並降低自身受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Protection
    ja: 加護の刺突
    ko: 가호의 찌르기
    zh_hant: 加護突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2773
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3734:
  _id_: 3734
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2774
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3735:
  _id_: 3735
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2775
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3736:
  _id_: 3736
  attribute_id: 6
  cost: 2
  description:
    en: Set chance to inflict Poison & Confusion to all enemies.
    ja: 敵全体に確率で毒と混乱を付与
    ko: 적 전체에게 일정 확률로 독, 혼란을 부여
    zh_hant: 機率性賦予所有敵人中毒和混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2776
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3738:
  _id_: 3738
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2777
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3739:
  _id_: 3739
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2778
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3740:
  _id_: 3740
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2779
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3741:
  _id_: 3741
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2780
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3742:
  _id_: 3742
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2781
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3743:
  _id_: 3743
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies. Dmg Received down to self.
    ja: 敵全体に威力(大)で攻撃じ、自身に被ダメージダウンを付与する
    ko: 적 전체에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並降低自身受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Protection
    ja: 加護の刺突
    ko: 가호의 찌르기
    zh_hant: 加護突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2782
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3744:
  _id_: 3744
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2783
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3745:
  _id_: 3745
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2784
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3746:
  _id_: 3746
  attribute_id: 6
  cost: 2
  description:
    en: High damage & High chance at Poison & Confusion to all enemies
    ja: 敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Thrust
    ja: 毒惑の刺突
    ko: 독혹의 찌르기
    zh_hant: 毒惑突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2785
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3747:
  _id_: 3747
  attribute_id: 6
  cost: 2
  description:
    en: High damage & High chance at Poison & Confusion to all enemies
    ja: 敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2786
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3749:
  _id_: 3749
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Thrust
    ja: 強襲の刺突
    ko: 강습의 찌르기
    zh_hant: 強襲突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2787
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3750:
  _id_: 3750
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2788
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3751:
  _id_: 3751
  attribute_id: 6
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2789
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3752:
  _id_: 3752
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2790
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3753:
  _id_: 3753
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies. Strong Dmg Received down to self.
    ja: 敵全体に強力な多段攻撃を行い、自身に強力な被ダメージダウンを付与する
    ko: 적 전체에게 강력한 다단 공격, 자신에게 강력한 받는 대미지 감소를 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並大幅降低自己受到的傷害
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Protection
    ja: 加護の刺突
    ko: 가호의 찌르기
    zh_hant: 加護突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2791
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3754:
  _id_: 3754
  attribute_id: 6
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2792
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3755:
  _id_: 3755
  attribute_id: 6
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2793
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3756:
  _id_: 3756
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack & Poison & Confusion to all enemies
    ja: 敵全体に強力な多段攻撃を行い、毒と混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 독, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Thrust
    ja: 毒惑の刺突
    ko: 독혹의 찌르기
    zh_hant: 毒惑突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2794
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3757:
  _id_: 3757
  attribute_id: 6
  cost: 2
  description:
    en: Strong Multi-hit attack & Poison & Confusion to all enemies
    ja: 敵全体に強力な多段攻撃を行い、毒と混乱を付与する
    ko: 적 전체에게 강력한 다단 공격, 독, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予中毒、混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2795
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3759:
  _id_: 3759
  attribute_id: 1
  cost: 2
  description:
    en: Removes Cont. Negative Effects and applies Cont. Negative Effects Resistance
      to 3 front allies. Medium damage to 3 front enemies.
    ja: 前から3体の味方の継続マイナス効果を解除し、継続マイナス効果耐性を付与し、前から3体の敵に威力(中)の攻撃を行う
    ko: 앞에서 3명의 아군의 지속 마이너스 효과를 해제, 지속 마이너스 효과 저항을 부여, 앞에서 3명의 적에게 위력(중) 공격
    zh_hant: 解除前面3名我方的持續性負面效果，賦予持續性負面效果耐性，並對前面的3個敵人發動威力（中）攻擊
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Holy Slash
    ja: 神域の斬撃
    ko: 신역의 참격
    zh_hant: 神域斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2796
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1133
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1133
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
3760:
  _id_: 3760
  attribute_id: 1
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Medium damage to 3 front enemies.
    ja: 前から3体の敵の継続プラス効果を解除し、威力(中)の攻撃を行う
    ko: 앞에서 3명의 적의 지속 플러스 효과를 해제, 위력(중) 공격
    zh_hant: 解除前面3個敵人的持續性正面效果，並發動威力（中）攻擊
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Severing Slash
    ja: 断切の斬撃
    ko: 단절의 참격
    zh_hant: 切斷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2797
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
3761:
  _id_: 3761
  attribute_id: 1
  cost: 2
  description:
    en: Dexterity up & Critical up to self. Medium damage to 3 front enemies.
    ja: 自身にクリティカル率アップ、クリティカル威力アップを付与し、前から3体の敵に威力(中)の攻撃を行う
    ko: 자신에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여하고, 앞에서 3명의 적에게 위력(중) 공격
    zh_hant: 提升自己的會心率、會心威力，並對前面3個敵人發動威力（中）攻擊
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Flash Slash
    ja: 閃光の斬撃
    ko: 섬광의 참격
    zh_hant: 閃光斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2798
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
3762:
  _id_: 3762
  attribute_id: 1
  cost: 2
  description:
    en: Normal Defense down & Perfect Aim Very High damage to 3 front enemies, ignoring
      Aggro, Provoke, Barrier, Reflect and Invincible.
    ja: 前から3体の敵に通常防御力ダウンを付与し、威力(大+)の必中攻撃を行う この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する
    ko: 앞에서 3명의 적에게 일반 방어력 감소를 부여, 위력(대+)의 백발백중 공격, 이 공격은 타깃 고정, 도발, 배리어, 반사, 무적을
      무시
    zh_hant: 降低前方3個敵人的普通防禦力，並發動威力（大+）的必中攻擊 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵
  icon_id: 198
  is_multiple_command_unique_skill: 0
  name:
    en: I spread my wings, to Frontier!
    ja: その羽広げてすすめフロンティア！
    ko: 날개를 펼치고 나아가라 프론티어!
    zh_hant: 展開雙翅飛向燦爛邊疆！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2799
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 310
    target_id: 2177
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 186
    - 200
    - 214
    - 228
    - 243
3770:
  _id_: 3770
  attribute_id: 2
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2802
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3771:
  _id_: 3771
  attribute_id: 2
  cost: 2
  description:
    en: High damage to front enemy, dealing extra damage to special-type enemies.
    ja: 前から1番目の敵に威力(大)で攻撃 この攻撃は特殊タイプの敵に特攻
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Creation Slash
    ja: 創造の斬撃
    ko: 창조의 참격
    zh_hant: 創造斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2803
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
3772:
  _id_: 3772
  attribute_id: 2
  cost: 2
  description:
    en: High damage to front enemy. Effective element damage up to 3 rear allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、後ろから3体の味方に有利属性ダメージアップを付与する
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 유리한 속성 대미지 증가를 부여
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升後面3名我方的有利屬性傷害
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: General's Oath
    ja: 騎士団長の誓い
    ko: 기사단장의 맹세
    zh_hant: 騎士團長的誓言
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2804
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 39
    target_id: 1143
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3773:
  _id_: 3773
  attribute_id: 2
  cost: 2
  description:
    en: Very High damage to enemy with the highest Act Power, dealing extra damage
      to special-type enemies.
    ja: ACTパワーが高い敵1体に威力(大+)の攻撃 この攻撃は特殊タイプの敵に特攻
    ko: ACT 파워가 높은 적 1명에게 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對1名ACT力量高的敵人發動威力（大+）攻擊 此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Black Lion's Scratch Encore
    ja: 黒獅子の爪痕 Encore
    ko: 흑사자의 조흔 Encore
    zh_hant: 黑獅子爪痕 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2805
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3775:
  _id_: 3775
  attribute_id: 3
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Medium damage to 3 front enemies.
    ja: 前から3体の敵の継続プラス効果を解除し、威力(中)の攻撃を行う
    ko: 앞에서 3명의 적의 지속 플러스 효과를 해제, 위력(중) 공격
    zh_hant: 解除前面3個敵人的持續性正面效果，並發動威力（中）攻擊
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Purity of Courage
    ja: 勇気の浄化
    ko: 용기의 정화
    zh_hant: 勇氣的淨化
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2807
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
3776:
  _id_: 3776
  attribute_id: 3
  cost: 2
  description:
    en: High damage & High chance at Confusion & Blindness to all enemies.
    ja: 敵全体に威力(大)で攻撃を行い、高確率で混乱と暗闇を付与する
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 혼란과 암흑을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率賦予混亂與盲目
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Repression
    ja: 抑圧の剣
    ko: 억압의 검
    zh_hant: 壓抑之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2808
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 75
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3777:
  _id_: 3777
  attribute_id: 3
  cost: 3
  description:
    en: High damage to all enemies. Special Barrier & Evasion x1 to all allies.
    ja: 敵全体に威力(大)で攻撃を行い、味方全体に特殊バリアと回避を1回付与する
    ko: 적 전체에게 위력(대) 공격, 아군 전체에게 특수 배리어와 회피 1회를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予所有我方特殊防護罩與迴避1次
  icon_id: 34
  is_multiple_command_unique_skill: 0
  name:
    en: General's Guidance
    ja: 騎士団長の導き
    ko: 기사단장의 인도
    zh_hant: 騎士團長的引導
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2809
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 6000
    - 7000
    - 8000
    - 10000
  - hit_rate: 100
    id: 34
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3778:
  _id_: 3778
  attribute_id: 3
  cost: 2
  description:
    en: Very High damage to all enemies. Applies Stage Effect [Sunset Tune] to enemies'
      stage.
    ja: 敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「落日の音色」を付与する
    ko: 적 전체에게 위력(대+) 공격, 적 쪽 무대에 무대 효과 [낙조의 음색]을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「落日音色」
  icon_id: 1007
  is_multiple_command_unique_skill: 0
  name:
    en: Celestial Truth Encore
    ja: 天道の理 Encore
    ko: 천도의 이치 Encore
    zh_hant: 天道之理 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2810
  skill_field_effect_id: 11
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3791:
  _id_: 3791
  attribute_id: 3
  cost: 2
  description:
    en: Medium+ damage to 3 front enemies.
    ja: 前から3体の敵に威力(中+)の攻撃
    ko: 앞에서 3명의 적에게 위력(중+) 공격
    zh_hant: 對前方的3個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Sharpshooting
    ja: 激化の狙撃
    ko: 격화의 저격
    zh_hant: 激化狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2813
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
3792:
  _id_: 3792
  attribute_id: 3
  cost: 2
  description:
    en: High damage & Brilliance Recovery down & Special Defense down to all enemies.
    ja: 敵全体に威力(大)で攻撃を行い、キラめき獲得ダウンと特殊防御力ダウンを付与する
    ko: 적 전체에게 위력(대) 공격, 반짝임 획득 감소와 특수 방어력 감소를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予獲得光芒減少效果，且降低特殊防禦力
  icon_id: 192
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Shooting
    ja: 減光の射撃
    ko: 감광의 사격
    zh_hant: 減光射擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2814
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3793:
  _id_: 3793
  attribute_id: 3
  cost: 3
  description:
    en: AP Up to all enemies. AP Down to all allies.
    ja: 敵全体にAP増加を付与し、味方全体にAP減少を付与する
    ko: 적 전체에게 AP 증가를 부여, 아군 전체에게 AP 감소를 부여
    zh_hant: 賦予所有敵人AP增加效果，並賦予所有我方AP減少效果
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Reverse Situation
    ja: 形勢逆転
    ko: 형세 역전
    zh_hant: 形勢逆轉
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2815
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3794:
  _id_: 3794
  attribute_id: 3
  cost: 2
  description:
    en: Very High damage to all enemies. Applies Stage Effect [Shadow Stupor] to enemies'
      stage.
    ja: 敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「昏迷の影」を付与する
    ko: 적 전체에게 위력(대+) 공격, 무대의 적에게 무대 효과 [혼미의 그림자]를 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「昏迷之影」
  icon_id: 1008
  is_multiple_command_unique_skill: 0
  name:
    en: Golden Duel
    ja: ゴールデン・デュエル
    ko: 골든 듀얼
    zh_hant: 黃金的決鬥
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2816
  skill_field_effect_id: 12
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3796:
  _id_: 3796
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to rear enemy. Low Brilliance recovery to self.
    ja: 後ろから1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 뒤에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對後面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Slash
    ja: キラめきの剣撃
    ko: 반짝임의 검격
    zh_hant: 光芒劍擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2818
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3797:
  _id_: 3797
  attribute_id: 1
  cost: 2
  description:
    en: Medium damage to rear enemy. Act Power up & Effective element damage up to
      all allies.
    ja: 後ろから1番目の敵に威力(中)で攻撃を行い、味方全体にACTパワーアップ、有利属性ダメージアップを付与する
    ko: 뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여
    zh_hant: 對後面數來第1個敵人發動威力（中）攻擊，並提升所有我方的ACT力量、對有利屬性的傷害
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Soul Contract
    ja: 魂の契約
    ko: 영혼의 계약
    zh_hant: 靈魂之契約
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2819
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3798:
  _id_: 3798
  attribute_id: 1
  cost: 3
  description:
    en: High damage to rear enemy. Removes Cont. & Count. Positive Effects to all
      enemies.
    ja: 後ろから1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果と回数プラス効果を解除する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과와 횟수 플러스 효과를 해제
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果與次數性正面效果
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Devil's Whisper
    ja: 悪魔の囁き
    ko: 악마의 속삭임
    zh_hant: 惡魔的低語
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2820
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 338
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3799:
  _id_: 3799
  attribute_id: 1
  cost: 2
  description:
    en: Removes Cont. Negative Effects from all allies. Removes Cont. Positive Effects
      & Extremely High damage to all enemies.
    ja: 味方全体の継続マイナス効果を解除し、敵全体の継続プラス効果を解除し、威力(特大)で攻撃を行う
    ko: 아군 전체의 지속 마이너스 효과를 해제하고, 적 전체의 지속 플러스 효과를 해제, 위력(특대) 공격
    zh_hant: 解除所有我方的持續性負面效果與所有敵方的持續性正面效果，並發動威力（特大）的攻擊
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Flames of Hell
    ja: 来たれ、地獄の業火よ
    ko: 오너라, 지옥의 업화여
    zh_hant: 來吧，地獄之火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2821
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
3801:
  _id_: 3801
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flash
    ja: 一閃
    ko: 일섬
    zh_hant: 閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2823
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3802:
  _id_: 3802
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2824
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3803:
  _id_: 3803
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Twin Flash
    ja: 双一閃
    ko: 쌍일섬
    zh_hant: 雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2825
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3804:
  _id_: 3804
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2826
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3805:
  _id_: 3805
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flash Flurry
    ja: 連一閃
    ko: 연일섬
    zh_hant: 連閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2827
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3806:
  _id_: 3806
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to 3 front enemies.
    ja: 前から3体の敵にACTパワーダウン付与
    ko: 앞에서 3명의 적에게 ACT 파워 감소를 부여
    zh_hant: 降低前方3個敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2828
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3807:
  _id_: 3807
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2829
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3808:
  _id_: 3808
  attribute_id: 7
  cost: 2
  description:
    en: Poison to all enemies.
    ja: 敵全体に毒を付与する
    ko: 적 전체에게 독을 부여
    zh_hant: 賦予所有敵人中毒效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2830
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3809:
  _id_: 3809
  attribute_id: 7
  cost: 2
  description:
    en: Poison to all enemies.
    ja: 敵全体に毒を付与する
    ko: 적 전체에게 독을 부여
    zh_hant: 賦予所有敵人中毒效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2831
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3811:
  _id_: 3811
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3812:
  _id_: 3812
  attribute_id: 2
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3813:
  _id_: 3813
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2834
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3814:
  _id_: 3814
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3815:
  _id_: 3815
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim to self. High damage to rear enemy.
    ja: 自身に必中を付与し、後から1体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3816:
  _id_: 3816
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3817:
  _id_: 3817
  attribute_id: 2
  cost: 2
  description:
    en: High damage & High chance at Confusion to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、高確率で混乱を付与
    ko: 뒤에서부터 3명의 적에게 위력(대) 공격, 높은 확률로 혼란을 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並以高機率造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3818:
  _id_: 3818
  attribute_id: 2
  cost: 2
  description:
    en: High damage & High chance at Confusion to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、高確率で混乱を付与
    ko: 뒤에서부터 3명의 적에게 위력(대) 공격, 높은 확률로 혼란을 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並以高機率造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2839
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3820:
  _id_: 3820
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2840
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3821:
  _id_: 3821
  attribute_id: 7
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2841
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3822:
  _id_: 3822
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2842
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3823:
  _id_: 3823
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 rear enemies.
    ja: 後から3体の敵に多段攻撃
    ko: 뒤에서 3명의 적에게 다단 공격
    zh_hant: 對後方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry
    ja: 連撃
    ko: 연격
    zh_hant: 連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2843
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3824:
  _id_: 3824
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to 3 rear enemies.
    ja: 後から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 뒤에서 3명의 적에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低後方3個敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2844
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3825:
  _id_: 3825
  attribute_id: 7
  cost: 2
  description:
    en: Evasion Rate up to self.
    ja: 自身に回避率アップを付与する
    ko: 자신에게 회피 확률 증가를 부여
    zh_hant: 提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2845
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3826:
  _id_: 3826
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 rear enemies.
    ja: 自身にACTパワーアップと必中を付与し、後から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 뒤에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對後方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2846
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3827:
  _id_: 3827
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to 3 rear enemies.
    ja: 自身にACTパワーアップと必中を付与し、後から3体の敵に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 뒤에서 3명의 적에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對後方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2847
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3829:
  _id_: 3829
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2848
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3830:
  _id_: 3830
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2849
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3831:
  _id_: 3831
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2850
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3832:
  _id_: 3832
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2851
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3833:
  _id_: 3833
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2852
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3834:
  _id_: 3834
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2853
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3835:
  _id_: 3835
  attribute_id: 2
  cost: 2
  description:
    en: High damage & Flip Positive Effects to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃し、プラス効果反転を適用する
    ko: 앞에서 3명의 적에게 위력(대) 공격, 플러스 효과 반전을 적용
    zh_hant: 對前方的3個敵人發動威力（大）攻擊，並施加正面狀態效果反轉
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flip Rondo
    ja: 反転の輪舞曲
    ko: 반전의 윤무곡
    zh_hant: 反轉圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2854
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 323
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
3836:
  _id_: 3836
  attribute_id: 2
  cost: 2
  description:
    en: Chance at Stop to all enemies.
    ja: 敵全体に確率でストップを付与
    ko: 적 전체에게 일정 확률로 스톱을 부여
    zh_hant: 機率性賦予所有敵人停止
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2855
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3838:
  _id_: 3838
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2856
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3839:
  _id_: 3839
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Twin Flash
    ja: 双一閃
    ko: 쌍일섬
    zh_hant: 雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2857
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3840:
  _id_: 3840
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2858
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3841:
  _id_: 3841
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2859
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3842:
  _id_: 3842
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack to 3 front enemies.
    ja: 前から3体の敵に多段攻撃
    ko: 앞에서 3명의 적에게 다단 공격
    zh_hant: 對前方的3個敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flash Flurry
    ja: 連一閃
    ko: 연일섬
    zh_hant: 連閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2860
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3843:
  _id_: 3843
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2861
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3844:
  _id_: 3844
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2862
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3845:
  _id_: 3845
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack & Poison to all enemies
    ja: 敵全体に多段攻撃を行い、毒を付与する
    ko: 적 전체에게 다단 공격, 독을 부여
    zh_hant: 對所有敵人發動多段攻擊，並造成中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2863
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3846:
  _id_: 3846
  attribute_id: 7
  cost: 2
  description:
    en: Multi-hit attack & Poison to all enemies
    ja: 敵全体に多段攻撃を行い、毒を付与する
    ko: 적 전체에게 다단 공격, 독을 부여
    zh_hant: 對所有敵人發動多段攻擊，並造成中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2864
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
3848:
  _id_: 3848
  attribute_id: 2
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3849:
  _id_: 3849
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Sharpshooting
    ja: 双狙撃
    ko: 쌍저격
    zh_hant: 雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2866
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3850:
  _id_: 3850
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Sharpshooting
    ja: 強襲の双狙撃
    ko: 강습의 쌍저격
    zh_hant: 強襲雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3851:
  _id_: 3851
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3852:
  _id_: 3852
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3853:
  _id_: 3853
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim to self. High damage to 3 rear enemies.
    ja: 自身に必中を付与し、後から3体の敵に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3854:
  _id_: 3854
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2871
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3855:
  _id_: 3855
  attribute_id: 2
  cost: 2
  description:
    en: High damage & High chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率で混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3856:
  _id_: 3856
  attribute_id: 2
  cost: 2
  description:
    en: High damage & High chance at Confusion to all enemies.
    ja: 敵全体に威力(大)で攻撃し、高確率で混乱を付与
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 혼란을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率造成混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3858:
  _id_: 3858
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2874
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3859:
  _id_: 3859
  attribute_id: 7
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2875
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3860:
  _id_: 3860
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2876
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3861:
  _id_: 3861
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2877
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3862:
  _id_: 3862
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2878
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3863:
  _id_: 3863
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2879
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3864:
  _id_: 3864
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2880
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3865:
  _id_: 3865
  attribute_id: 7
  cost: 2
  description:
    en: Evasion Rate up to self.
    ja: 自身に回避率アップを付与する
    ko: 자신에게 회피 확률 증가를 부여
    zh_hant: 提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2881
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3866:
  _id_: 3866
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2882
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3867:
  _id_: 3867
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2883
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3869:
  _id_: 3869
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy.
    ja: 前から1体の敵に威力(小)で攻撃
    ko: 앞에서 1명의 적에게 위력(소) 공격
    zh_hant: 對前方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2884
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3870:
  _id_: 3870
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 2 front enemies.
    ja: 前から2体の敵に威力(小)で攻撃
    ko: 앞에서 2명의 적에게 위력(소) 공격
    zh_hant: 對前方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2885
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
3871:
  _id_: 3871
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2886
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3872:
  _id_: 3872
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2887
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3873:
  _id_: 3873
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2888
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3874:
  _id_: 3874
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2889
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
3875:
  _id_: 3875
  attribute_id: 2
  cost: 2
  description:
    en: High damage & Flip Positive Effects x3 to all enemies.
    ja: 敵全体に威力(大)で攻撃じ、3回分のプラス効果反転を適用する
    ko: 적 전체에게 위력(대) 공격, 3회분의 플러스 효과 반전을 적용
    zh_hant: 對所有敵人發動威力（大）攻擊，並施加3次正面狀態效果反轉
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flip Fiery Concerto
    ja: 反転の協奏曲
    ko: 반전의 협주곡
    zh_hant: 反轉協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2890
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 323
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
3876:
  _id_: 3876
  attribute_id: 2
  cost: 2
  description:
    en: High damage & chance at Stop to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率でストップを付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 스톱을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成停止
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Concerto
    ja: 抑止の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑止協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2891
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3877:
  _id_: 3877
  attribute_id: 2
  cost: 2
  description:
    en: High damage & chance at Stop to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率でストップを付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 스톱을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成停止
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2892
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3879:
  _id_: 3879
  attribute_id: 7
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3880:
  _id_: 3880
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3881:
  _id_: 3881
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 front enemies.
    ja: 前から3体の敵に威力(小)で攻撃
    ko: 앞에서 3명의 적에게 위력(소) 공격
    zh_hant: 對前方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3882:
  _id_: 3882
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3883:
  _id_: 3883
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3884:
  _id_: 3884
  attribute_id: 7
  cost: 2
  description:
    en: Act Power down to all enemies.
    ja: 敵全体にACTパワーダウン付与
    ko: 적 전체에게 ACT 파워 감소를 부여
    zh_hant: 降低所有敵人的ACT力量
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3885:
  _id_: 3885
  attribute_id: 7
  cost: 2
  description:
    en: Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all
      enemies.
    ja: 自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する
    ko: 자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제
    zh_hant: 解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3886:
  _id_: 3886
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack & Heavy Poison to all enemies
    ja: 敵全体に強力な多段攻撃を行い、高威力の毒を付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 위력의 독을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並造成高威力的中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2900
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3887:
  _id_: 3887
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack & Heavy Poison to all enemies
    ja: 敵全体に強力な多段攻撃を行い、高威力の毒を付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 위력의 독을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並造成高威力的中毒
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2901
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
3889:
  _id_: 3889
  attribute_id: 2
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3890:
  _id_: 3890
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3891:
  _id_: 3891
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3892:
  _id_: 3892
  attribute_id: 2
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3893:
  _id_: 3893
  attribute_id: 2
  cost: 2
  description:
    en: Perfect Aim to self. High damage to all enemies.
    ja: 自身に必中を付与し、敵全体に威力(大)で攻撃
    ko: 자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격
    zh_hant: 賦予自身必中效果，並對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3894:
  _id_: 3894
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Normal Defense up & Special Defense up to self.
    ja: 自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与
    ko: 자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여
    zh_hant: 提升自身的ACT力量、普通防禦力、特殊防禦力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3895:
  _id_: 3895
  attribute_id: 2
  cost: 2
  description:
    en: Strong Multi-hit attack & Confusion to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2908
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3896:
  _id_: 3896
  attribute_id: 2
  cost: 2
  description:
    en: Strong Multi-hit attack & Confusion to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、混乱を付与
    ko: 적 전체에게 강력한 다단 공격, 혼란을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並賦予混亂
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2909
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3898:
  _id_: 3898
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3899:
  _id_: 3899
  attribute_id: 7
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3900:
  _id_: 3900
  attribute_id: 7
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
3901:
  _id_: 3901
  attribute_id: 7
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3902:
  _id_: 3902
  attribute_id: 7
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3903:
  _id_: 3903
  attribute_id: 7
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3904:
  _id_: 3904
  attribute_id: 7
  cost: 2
  description:
    en: Dexterity down & Critical down to all enemies.
    ja: 敵全体にクリティカル率ダウン、クリティカル威力ダウン付与
    ko: 적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여
    zh_hant: 降低所有敵人的會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3905:
  _id_: 3905
  attribute_id: 7
  cost: 2
  description:
    en: Evasion Rate up to self.
    ja: 自身に回避率アップを付与する
    ko: 자신에게 회피 확률 증가를 부여
    zh_hant: 提升自己的迴避率
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3906:
  _id_: 3906
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2918
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3907:
  _id_: 3907
  attribute_id: 7
  cost: 2
  description:
    en: Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.
    ja: 自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃
    ko: 자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격
    zh_hant: 提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2919
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
3909:
  _id_: 3909
  attribute_id: 2
  cost: 2
  description:
    en: High damage to front enemy.
    ja: 前から1体の敵に威力(大)で攻撃
    ko: 앞에서 1명의 적에게 위력(대) 공격
    zh_hant: 對前方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Thrust
    ja: 強襲の刺突
    ko: 강습의 찌르기
    zh_hant: 強襲突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2920
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
3910:
  _id_: 3910
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 2 front enemies.
    ja: 前から2体の敵に威力(大)で攻撃
    ko: 앞에서 2명의 적에게 위력(대) 공격
    zh_hant: 對前方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2921
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3911:
  _id_: 3911
  attribute_id: 2
  cost: 2
  description:
    en: High damage to 3 front enemies.
    ja: 前から3体の敵に威力(大)で攻撃
    ko: 앞에서 3명의 적에게 위력(대) 공격
    zh_hant: 對前方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2922
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3912:
  _id_: 3912
  attribute_id: 2
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2923
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
3913:
  _id_: 3913
  attribute_id: 2
  cost: 2
  description:
    en: Act Power up & Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2924
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3914:
  _id_: 3914
  attribute_id: 2
  cost: 2
  description:
    en: Strong Multi-hit attack & Flip Positive Effects x5 to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、5回分のプラス効果反転を付与する
    ko: 적 전체에게 강력한 다단 공격, 5회분의 플러스 효과 반전을 적용
    zh_hant: 對所有敵人發動強力的多段攻擊，並施加5次正面狀態效果反轉
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flip Fiery Concerto
    ja: 反転の協奏曲
    ko: 반전의 협주곡
    zh_hant: 反轉協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2925
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 323
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
3915:
  _id_: 3915
  attribute_id: 2
  cost: 2
  description:
    en: Strong Multi-hit attack & High chance at Sleep to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、高確率でストップを付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 확률로 스톱을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並以高機率賦予停止
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Concerto
    ja: 抑止の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑止協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2926
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3916:
  _id_: 3916
  attribute_id: 2
  cost: 2
  description:
    en: Strong Multi-hit attack & High chance at Sleep to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、高確率でストップを付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 확률로 스톱을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並以高機率賦予停止
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2927
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3918:
  _id_: 3918
  attribute_id: 4
  cost: 2
  description:
    en: Medium+ damage to 3 rear enemies.
    ja: 後ろから3体の敵に威力(中+)の攻撃
    ko: 뒤에서 3명의 적에게 위력(중+) 공격
    zh_hant: 對後面的3個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Profuse Strike
    ja: 繚乱の一撃
    ko: 요란의 일격
    zh_hant: 繚亂一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2928
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
3919:
  _id_: 3919
  attribute_id: 4
  cost: 2
  description:
    en: High damage & Special Defense down & Strong Poison to all enemies.
    ja: 敵全体に威力(大)で攻撃を行い、特殊防御力ダウンと猛毒を付与する
    ko: 적 전체에게 위력(대) 공격, 특수 방어력 감소와 맹독을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並降低特殊防禦力，且賦予猛毒
  icon_id: 54
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Invitation
    ja: 妖毒の誘い
    ko: 요독의 초대
    zh_hant: 妖毒的誘惑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2929
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 245
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6
    - 8
    - 10
    - 12
    - 15
3920:
  _id_: 3920
  attribute_id: 4
  cost: 3
  description:
    en: Act Power up & Dexterity up to self. High damage to all enemies, dealing extra
      damage to enemies inflicted with Poison.
    ja: 自身にACTパワーアップとクリティカル率アップを付与し、敵全体に威力(大)で攻撃を行う　この攻撃は毒状態の敵に対して特攻
    ko: 자신에게 ACT 파워 증가와 크리티컬 확률 증가를 부여, 적 전체에게 위력(대) 공격. 이 공격은 독 상태의 적에게 특수 공격
    zh_hant: 提升自己的ACT力量及會心率，並對所有敵人發動威力（大）攻擊 此攻擊會對中毒的敵方造成特攻效果
  icon_id: 158
  is_multiple_command_unique_skill: 0
  name:
    en: Life Blade
    ja: 命の刃
    ko: 생명의 칼날
    zh_hant: 命之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2930
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 276
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 74
    - 78
    - 82
    - 87
    - 91
3921:
  _id_: 3921
  attribute_id: 4
  cost: 2
  description:
    en: Very High damage to 3 rear enemies. Applies Stage Effect [Lightning Shade]
      to allies' stage.
    ja: 後ろから3体の敵に威力(大+)の攻撃を行い 、舞台の味方側に舞台効果「電光影裏」を付与する
    ko: 뒤에서 3명의 적에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [번갯불의 그림자]를 부여
    zh_hant: 對後面的3個敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「雷光影裏」
  icon_id: 1009
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 三段突き
    ko: 삼단 찌르기
    zh_hant: 三段突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2931
  skill_field_effect_id: 13
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 186
    - 200
    - 214
    - 228
    - 243
3943:
  _id_: 3943
  attribute_id: 1
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2948
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3944:
  _id_: 3944
  attribute_id: 1
  cost: 2
  description:
    en: Effective element damage up & Dexterity up to self. High damage to enemy with
      the highest Act Power.
    ja: 自身に有利属性ダメージアップとクリティカル率アップを付与し、ACTパワーの1番高い敵に威力(大)の攻撃を行う
    ko: 자신에게 유리한 속성 대미지 증가, 크리티컬 확률 증가를 부여, ACT 파워가 가장 높은 적에게 위력(대) 공격
    zh_hant: 提升自己對有利屬性的傷害與會心率，並對1名ACT力量最高的敵人發動威力（大）攻擊
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Determination
    ja: 決意の一閃
    ko: 결의의 일섬
    zh_hant: 決意的閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2949
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 39
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
3945:
  _id_: 3945
  attribute_id: 1
  cost: 2
  description:
    en: High damage to enemy with the highest Act Power. Act Power up & AP Down to
      all allies.
    ja: ACTパワーの1番高い敵に威力(大)の攻撃を行い、味方全体にACTパワーアップとAP減少を付与する
    ko: ACT 파워가 가장 높은 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가와 AP 감소를 부여
    zh_hant: 對1名ACT力量最高的敵人發動威力（大）攻擊，並提升所有我方的ACT力量，同時賦予AP減少
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Unwavering Passion
    ja: ゆるぎなき熱情
    ko: 확고한 열정
    zh_hant: 堅定的熱情
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2950
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3946:
  _id_: 3946
  attribute_id: 1
  cost: 2
  description:
    en: Act Power down & Normal Defense down & Very High damage to rear enemy, dealing
      extra damage to special-type enemies.
    ja: 後ろから1番目の敵にACTパワーダウンと通常防御力ダウンを付与し、威力(大+)の攻撃を行う　この攻撃は特殊タイプの敵に特攻
    ko: 뒤에서 첫 번째 적에게 ACT 파워 감소, 일반 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 降低後面數來第1個敵人的ACT力量與普通防禦力，並發動威力（大+）攻擊　此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: O king, my burning passion will create your noble path!
    ja: 情熱の炎で王道を作る！
    ko: 정열의 불꽃으로 왕도를 만든다!
    zh_hant: 燃燒吧激情烈焰，王道蕩蕩！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2951
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2121
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2121
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 308
    target_id: 2121
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
3948:
  _id_: 3948
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage to 3 front enemies. AP down to 3 front allies.
    ja: 前から3体の敵に威力(中)の攻撃を行い、前から3体の味方にAP減少を付与する
    ko: 앞에서 3명의 적에게 위력(중) 공격, 앞에서 3명의 아군에게 AP 감소를 부여
    zh_hant: 對前面的3個敵人發動威力（中）攻擊，並賦予前面3名我方AP減少
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Prayer Song
    ja: 祈りの歌
    ko: 기도의 노래
    zh_hant: 祈願之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2953
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 157
    target_id: 1133
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3949:
  _id_: 3949
  attribute_id: 3
  cost: 2
  description:
    en: High damage to all enemies. Act Power up & Dexterity up to all allies.
    ja: 敵全体に威力(大)の攻撃を行い、味方全体にACTパワーアップとクリティカル率アップを付与する
    ko: 적 전체에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가, 크리티컬 확률 증가를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並提升所有我方的ACT力量與會心率
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Goddess Smile
    ja: 女神の微笑み
    ko: 여신의 미소
    zh_hant: 女神的微笑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2954
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3950:
  _id_: 3950
  attribute_id: 3
  cost: 3
  description:
    en: Removes Cont. Positive Effects & AP up & Medium damage to all enemies.
    ja: 敵全体の継続プラス効果を解除し、AP増加を付与し、威力(中)の攻撃を行う
    ko: 적 전체의 지속 플러스 효과를 해제, AP 증가를 부여, 위력(중) 공격
    zh_hant: 解除所有敵人的持續性正面效果，賦予AP增加，並發動威力（中）攻擊
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Piercing Arrow
    ja: 貫きの矢
    ko: 관통 화살
    zh_hant: 貫穿之箭矢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2955
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
3951:
  _id_: 3951
  attribute_id: 3
  cost: 2
  description:
    en: Removes Cont. Positive Effects & Very High damage & Freeze to all enemies.
    ja: 敵全体の継続プラス効果を解除し、威力(大+)の攻撃を行い、凍結を付与する
    ko: 적 전체의 지속 플러스 효과를 해제, 위력(대+) 공격, 동결을 부여
    zh_hant: 解除所有敵人的持續性正面效果，發動威力（大+）攻擊，並造成凍結
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: This world is a stage. Even the king is a player!
    ja: この世は舞台 王すらも役者――ですよ？
    ko: 이 세상은 무대, 왕조차 배우――라고요?
    zh_hant: 整個世界是座舞台，當代王者也只是演員而已――唷？
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2956
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3953:
  _id_: 3953
  attribute_id: 6
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Swing of Brilliance
    ja: キラめきのスイング
    ko: 반짝임의 스윙
    zh_hant: 光芒搖曳
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2958
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3954:
  _id_: 3954
  attribute_id: 6
  cost: 2
  description:
    en: Medium damage to all enemies. Removes Cont. Negative Effects from all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体の継続マイナス効果を解除する
    ko: 적 전체에게 위력(중) 공격, 아군 전체의 지속 마이너스 효과를 해제
    zh_hant: 對所有敵人發動威力（中）攻擊，並解除所有我方的持續性負面效果
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Trick Play
    ja: トリックプレー
    ko: 트릭 플레이
    zh_hant: 假動作
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2959
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3955:
  _id_: 3955
  attribute_id: 6
  cost: 2
  description:
    en: High damage to all enemies, dealing extra damage to normal-type enemies. Evasion
      Rate up to all allies.
    ja: 敵全体に威力(大)で攻撃を行い、味方全体に回避率アップを付与する　この攻撃は通常タイプの敵に特攻
    ko: 적 전체에게 위력(대) 공격, 아군 전체에게 회피 확률 증가를 부여, 이 공격은 일반 타입인 적에게 특수 공격
    zh_hant: 對所有敵人發動威力（大）攻擊，並提升所有我方的迴避率　此攻擊會對普通類型的敵方造成特攻效果
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Team Cornerstone
    ja: 扇の要
    ko: 중심축
    zh_hant: 場上的司令塔
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2960
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 306
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 74
    - 78
    - 82
    - 87
    - 91
  - hit_rate: 100
    id: 18
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
3956:
  _id_: 3956
  attribute_id: 6
  cost: 2
  description:
    en: Very High damage to all enemies. Applies Stage Effect [Ironclad Guard] to
      allies' stage.
    ja: 敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「鉄壁の守備」を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [철벽 수비]를 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「鐵壁守備」
  icon_id: 1010
  is_multiple_command_unique_skill: 0
  name:
    en: Superb Play
    ja: 気迫のファインプレー
    ko: 기백의 파인 플레이
    zh_hant: 氣勢磅礡的精彩守備
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2961
  skill_field_effect_id: 14
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3958:
  _id_: 3958
  attribute_id: 3
  cost: 2
  description:
    en: Medium+ damage to front enemy.
    ja: 前から1番目の敵に威力(中+)の攻撃
    ko: 앞에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對前面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Full Swing
    ja: フルスイング
    ko: 풀 스윙
    zh_hant: 全力揮擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2963
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3959:
  _id_: 3959
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy, dealing extra damage to special-type enemies.
    ja: 前から1番目の敵に威力(大)で攻撃 この攻撃は特殊タイプの敵に特攻
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Here We Go!
    ja: しまっていこう！
    ko: 긴장 풀지 말자!
    zh_hant: 集中精神上吧！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2964
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
3960:
  _id_: 3960
  attribute_id: 3
  cost: 2
  description:
    en: High damage to front enemy, dealing extra damage to special-type enemies.
      Act Power up to all allies.
    ja: 前から1番目の敵に威力(大)の攻撃を行い、味方全体にACTパワーアップを付与する この攻撃は特殊タイプの敵に特攻
    ko: 앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가를 부여, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的ACT力量 此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Focus On Outs!
    ja: バッター集中！
    ko: 타자 집중!
    zh_hant: 專心對付打者！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2965
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3961:
  _id_: 3961
  attribute_id: 3
  cost: 2
  description:
    en: Very High damage to all enemies. Applies Stage Effect [Boldness] to allies'
      stage.
    ja: 敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「ガッツ」を付与する
    ko: 적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [근성]을 부여
    zh_hant: 對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「毅力」
  icon_id: 1011
  is_multiple_command_unique_skill: 0
  name:
    en: Home Run Spirit
    ja: 闘志のホームラン
    ko: 투지의 홈런
    zh_hant: 充滿鬥志的全壘打
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2966
  skill_field_effect_id: 15
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
3968:
  _id_: 3968
  attribute_id: 5
  cost: 2
  description:
    en: Medium+ damage to 3 front enemies.
    ja: 前から3体の敵に威力(中+)の攻撃
    ko: 앞에서 3명의 적에게 위력(중+) 공격
    zh_hant: 對前方的3個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2968
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
3969:
  _id_: 3969
  attribute_id: 5
  cost: 2
  description:
    en: High damage & High chance at Stun to all enemies.
    ja: 敵全体に威力(大)で攻撃を行い、高確率でスタンを付与する
    ko: 적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Thunderclap Blade
    ja: 迅雷の刃
    ko: 우레의 칼날
    zh_hant: 迅雷之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2969
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 75
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3970:
  _id_: 3970
  attribute_id: 5
  cost: 2
  description:
    en: Medium damage to all enemies. Unremovable Cont. Negative Effects Resistance
      to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体に解除不可の継続マイナス効果耐性を付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 해제 불가능한 지속 마이너스 효과 저항을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並賦予所有我方無法解除的持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Thundercloud Yell
    ja: 雷雲の呼声
    ko: 뇌운을 부르는 소리
    zh_hant: 雷雲之呼聲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2970
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 346
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3971:
  _id_: 3971
  attribute_id: 5
  cost: 2
  description:
    en: Very High damage to 3 front enemies. Applies Stage Effect [Thunder] to enemies'
      stage.
    ja: 前から3体の敵に威力(大+)の攻撃を行い 、舞台の敵側に舞台効果「雷鳴」を付与する
    ko: 앞에서 3명의 적에게 위력(대+) 공격, 적 쪽 무대에 무대 효과 [천둥]을 부여
    zh_hant: 對前面的3個敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「雷鳴」
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Justice Blitz
    ja: 正義の雷光
    ko: 정의의 번개
    zh_hant: 正義的雷光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2971
  skill_field_effect_id: 16
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 186
    - 200
    - 214
    - 228
    - 243
3988:
  _id_: 3988
  attribute_id: 2
  cost: 2
  description:
    en: Low damage to front enemy. Low Brilliance recovery to self.
    ja: 前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復
    ko: 앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복
    zh_hant: 對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Swing of Brilliance
    ja: キラめきのスイング
    ko: 반짝임의 스윙
    zh_hant: 光芒搖曳
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2985
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
3989:
  _id_: 3989
  attribute_id: 2
  cost: 2
  description:
    en: Medium damage to all enemies. Cont. Negative Effects Resistance to all allies.
    ja: 敵全体に威力(中)で攻撃を行い、味方全体に継続マイナス効果耐性を付与する
    ko: 적 전체에게 위력(중) 공격, 아군 전체에게 지속 마이너스 효과 저항을 부여
    zh_hant: 對所有敵人發動威力（中）攻擊，並賦予所有我方持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Sliding Catch
    ja: スライディングキャッチ
    ko: 슬라이딩 캐치
    zh_hant: 滑接
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2986
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3990:
  _id_: 3990
  attribute_id: 2
  cost: 2
  description:
    en: High damage to all enemies, dealing extra damage to special-type enemies.
      Evasion x1 to all allies.
    ja: 敵全体に威力(大)で攻撃を行い、味方全体に回避を1回付与する　この攻撃は特殊タイプの敵に特攻
    ko: 적 전체에게 위력(대) 공격, 아군 전체에게 회피 1회를 부여, 이 공격은 특수 타입인 적에게 특수 공격
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予所有我方迴避1次　此攻擊會對特殊類型的敵方造成特攻效果
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Backup
    ja: バックアップ
    ko: 백업
    zh_hant: 補位
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2987
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 74
    - 78
    - 82
    - 87
    - 91
  - hit_rate: 100
    id: 34
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
3991:
  _id_: 3991
  attribute_id: 2
  cost: 2
  description:
    en: Extremely High damage to all enemies. Applies Stage Effect [Winning Determination]
      to allies' stage.
    ja: 敵全体に威力(特大)で攻撃を行い、舞台の味方側に舞台効果「勝負根性」を付与する
    ko: 적 전체에게 위력(특대) 공격, 아군 쪽 무대에게 무대 효과 [승부 근성]을 부여
    zh_hant: 對所有敵人發動威力（特大）攻擊，並賦予我方的舞台舞台效果「勝負鬥志」
  icon_id: 1013
  is_multiple_command_unique_skill: 0
  name:
    en: Hot-Blooded Home Run
    ja: 熱血バックホーム
    ko: 열혈 백홈
    zh_hant: 熱血回傳
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2988
  skill_field_effect_id: 17
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
3993:
  _id_: 3993
  attribute_id: 3
  cost: 2
  description:
    en: Medium+ damage to rear enemy.
    ja: 後ろから1番目の敵に威力(中+)の攻撃
    ko: 뒤에서 첫 번째 적에게 위력(중+) 공격
    zh_hant: 對後面數來第1個敵人發動威力（中+）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ardent Slash
    ja: 烈斬撃
    ko: 열참격
    zh_hant: 烈焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2990
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
3994:
  _id_: 3994
  attribute_id: 3
  cost: 2
  description:
    en: Medium damage to rear enemy. Dexterity up & Cont. Negative Effects Resistance
      to all allies.
    ja: 後ろから1番目の敵に威力(中)で攻撃を行い、味方全体にクリティカル率アップと継続マイナス効果耐性を付与する
    ko: 뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 크리티컬 확률 증가와 지속 마이너스 효과 저항을 부여
    zh_hant: 對後面數來第1個敵人發動威力（中）攻擊，並提昇所有我方的會心率，且賦予持續性負面效果耐性
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Soul Rebirth
    ja: 魂の再生
    ko: 영혼의 재생
    zh_hant: 靈魂再生
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2991
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3995:
  _id_: 3995
  attribute_id: 3
  cost: 2
  description:
    en: High damage to rear enemy. Marked & Normal Defense down to all enemies.
    ja: 後ろから1番目の敵に威力(大)で攻撃を行い、敵全体に刻印と通常防御力ダウンを付与する
    ko: 뒤에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 각인과 일반 방어력 감소를 부여
    zh_hant: 對後面數來第1個敵人發動威力（大）攻擊，並降低所有敵人的普通防禦力，且賦予刻印
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Death's Whisper
    ja: 死神の囁き
    ko: 사신의 속삭임
    zh_hant: 死神的低語
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2992
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
3996:
  _id_: 3996
  attribute_id: 3
  cost: 2
  description:
    en: Perfect Aim Extremely High damage to all enemies, ignoring Aggro, Provoke,
      Barrier, Reflect and Invincible. Revive 1 time to 2 rear allies.
    ja: 敵全体に威力(特大)の必中攻撃を行い、後ろから2体の味方に起死回生を1回付与する　この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する
    ko: 적 전체에게 위력(특대) 백발백중 공격, 뒤에서 2명의 아군에게 기사회생을 1회 부여, 이 공격은 타깃 고정, 도발, 배리어, 반사,
      무적을 무시
    zh_hant: 對所有敵人發動威力（特大）的必中攻擊，並賦予後面的2名我方起死回生1次 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵
  icon_id: 228
  is_multiple_command_unique_skill: 0
  name:
    en: Memento Mori
    ja: 死、忘るなかれ
    ko: 죽음을 잊지 말라
    zh_hant: 莫忘死亡
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2993
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 360
    target_id: 1142
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
3998:
  _id_: 3998
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2995
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
3999:
  _id_: 3999
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2996
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4000:
  _id_: 4000
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2997
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4001:
  _id_: 4001
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2998
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4002:
  _id_: 4002
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2999
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4003:
  _id_: 4003
  attribute_id: 1
  cost: 2
  description:
    en: High damage & Reduced Brilliance Recovery to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 반짝임 획득 감소를 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並賦予獲得光芒減少效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3000
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4004:
  _id_: 4004
  attribute_id: 1
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3001
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4005:
  _id_: 4005
  attribute_id: 1
  cost: 2
  description:
    en: Set chance to inflict Sleep to all enemies.
    ja: 敵全体に確率で睡眠を付与
    ko: 적 전체에게 일정 확률로 수면을 부여
    zh_hant: 機率性賦予所有敵人睡眠
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3002
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4007:
  _id_: 4007
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to rear enemy.
    ja: 後から1体の敵に威力(小)で攻撃
    ko: 뒤에서 1명의 적에게 위력(소) 공격
    zh_hant: 對後方的1個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3003
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4008:
  _id_: 4008
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to 2 rear enemies.
    ja: 後から2体の敵に威力(小)で攻撃
    ko: 뒤에서 2명의 적에게 위력(소) 공격
    zh_hant: 對後方的2個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3004
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4009:
  _id_: 4009
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3005
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4010:
  _id_: 4010
  attribute_id: 1
  cost: 2
  description:
    en: Low damage to 3 rear enemies.
    ja: 後から3体の敵に威力(小)で攻撃
    ko: 뒤에서 3명의 적에게 위력(소) 공격
    zh_hant: 對後方的3個敵人發動威力（小）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3006
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4011:
  _id_: 4011
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3007
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4012:
  _id_: 4012
  attribute_id: 1
  cost: 2
  description:
    en: High damage & Reduced Brilliance Recovery to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: 뒤에서 3명의 적에게 위력(대) 공격, 반짝임 획득 감소를 부여
    zh_hant: 對後方的3個敵人發動威力（大）攻擊，並賦予獲得光芒減少效果
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3008
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4013:
  _id_: 4013
  attribute_id: 1
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3009
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4014:
  _id_: 4014
  attribute_id: 1
  cost: 2
  description:
    en: High damage & chance at Sleep to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で睡眠を付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 수면을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成睡眠
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4015:
  _id_: 4015
  attribute_id: 1
  cost: 2
  description:
    en: High damage & chance at Sleep to all enemies.
    ja: 敵全体に威力(大)で攻撃し、確率で睡眠を付与
    ko: 적 전체에게 위력(대) 공격, 일정 확률로 수면을 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並在一定機率下造成睡眠
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4017:
  _id_: 4017
  attribute_id: 1
  cost: 2
  description:
    en: High damage to rear enemy.
    ja: 後から1体の敵に威力(大)で攻撃
    ko: 뒤에서 1명의 적에게 위력(대) 공격
    zh_hant: 對後方的1個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Thrust
    ja: 強襲の刺突
    ko: 강습의 찌르기
    zh_hant: 強襲突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4018:
  _id_: 4018
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 2 rear enemies.
    ja: 後から2体の敵に威力(大)で攻撃
    ko: 뒤에서 2명의 적에게 위력(대) 공격
    zh_hant: 對後方的2個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4019:
  _id_: 4019
  attribute_id: 1
  cost: 2
  description:
    en: High damage to 3 rear enemies.
    ja: 後から3体の敵に威力(大)で攻撃
    ko: 뒤에서 3명의 적에게 위력(대) 공격
    zh_hant: 對後方的3個敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4020:
  _id_: 4020
  attribute_id: 1
  cost: 2
  description:
    en: High damage to all enemies.
    ja: 敵全体に威力(大)で攻撃
    ko: 적 전체에게 위력(대) 공격
    zh_hant: 對所有敵人發動威力（大）攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4021:
  _id_: 4021
  attribute_id: 1
  cost: 2
  description:
    en: Strong Multi-hit attack to all enemies.
    ja: 敵全体に強力な多段攻撃
    ko: 적 전체에게 강력한 다단 공격
    zh_hant: 對所有敵人發動強力的多段攻擊
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4022:
  _id_: 4022
  attribute_id: 1
  cost: 2
  description:
    en: High damage & Brilliance Recovery down to all enemies.
    ja: 敵全体に威力(大)で攻撃し、キラめき獲得ダウンを付与する
    ko: 적 전체에게 위력(대) 공격, 반짝임 획득 감소를 부여
    zh_hant: 對所有敵人發動威力（大）攻擊，並賦予獲得光芒減少
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4023:
  _id_: 4023
  attribute_id: 1
  cost: 2
  description:
    en: Act Power up, Dexterity up & Critical up to self.
    ja: 自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与
    ko: 자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여
    zh_hant: 提升自己的ACT力量、會心率、會心威力
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4024:
  _id_: 4024
  attribute_id: 1
  cost: 2
  description:
    en: Strong Multi-hit attack & high chance at Sleep to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 확률로 수면을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並以高機率賦予睡眠
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4025:
  _id_: 4025
  attribute_id: 1
  cost: 2
  description:
    en: Strong Multi-hit attack & high chance at Sleep to all enemies.
    ja: 敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する
    ko: 적 전체에게 강력한 다단 공격, 높은 확률로 수면을 부여
    zh_hant: 對所有敵人發動強力的多段攻擊，並以高機率賦予睡眠
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4027:
  _id_: 4027
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3021
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4028:
  _id_: 4028
  attribute_id: 2
  cost: 2
  icon_id: 58
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Song
    ja: 眠りの歌
    ko: 잠의 노래
    zh_hant: 睡眠之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3022
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4029:
  _id_: 4029
  attribute_id: 2
  cost: 3
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Mad Dance
    ja: 狂惑の舞
    ko: 광란의 춤
    zh_hant: 狂惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3023
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4030:
  _id_: 4030
  attribute_id: 2
  cost: 2
  icon_id: 232
  is_multiple_command_unique_skill: 0
  name:
    en: To a new life, to a new stage!
    ja: 謳いあげます命の夢を！！
    ko: 노래하지요 생의 꿈을!!
    zh_hant: 謳歌而上！人生夢想！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3024
  skill_field_effect_id: 18
  skill_options:
  - hit_rate: 100
    id: 364
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 125
    - 135
    - 145
    - 155
    - 170
4032:
  _id_: 4032
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3026
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4033:
  _id_: 4033
  attribute_id: 5
  cost: 2
  icon_id: 229
  is_multiple_command_unique_skill: 0
  name:
    en: Fresh Wind
    ja: 時代の新風
    ko: 시대의 새바람
    zh_hant: 時代的新風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3027
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 74
    - 78
    - 82
    - 87
    - 91
4034:
  _id_: 4034
  attribute_id: 5
  cost: 2
  icon_id: 229
  is_multiple_command_unique_skill: 0
  name:
    en: Final Battle
    ja: 決戦の幕開け
    ko: 결전의 개막
    zh_hant: 決戰即將開始
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3028
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 47
    - 50
    - 53
    - 56
    - 58
4035:
  _id_: 4035
  attribute_id: 5
  cost: 2
  icon_id: 1017
  is_multiple_command_unique_skill: 0
  name:
    en: Hitotsu no Tachi
    ja: 奥義　一之太刀
    ko: 오의 일지태도
    zh_hant: 奧義 一之太刀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3029
  skill_field_effect_id: 22
  skill_options:
  - hit_rate: 100
    id: 361
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
4037:
  _id_: 4037
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ardent Slash
    ja: 烈斬撃
    ko: 열참격
    zh_hant: 烈焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3031
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4038:
  _id_: 4038
  attribute_id: 3
  cost: 2
  icon_id: 196
  is_multiple_command_unique_skill: 0
  name:
    en: Resolute Blade
    ja: 覚悟の刃
    ko: 각오의 칼날
    zh_hant: 覺悟之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3032
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 308
    target_id: 2021
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4039:
  _id_: 4039
  attribute_id: 3
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Determination
    ja: 決意の一撃
    ko: 결의의 일격
    zh_hant: 決意一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3033
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4040:
  _id_: 4040
  attribute_id: 3
  cost: 2
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: My life is on this stage!
    ja: 命の在処この舞台に見つけたり！
    ko: 생을 둘 곳 이 무대에서 찾으리!
    zh_hant: 命之所處即為舞台！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3034
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 371
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4042:
  _id_: 4042
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3036
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4043:
  _id_: 4043
  attribute_id: 4
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Rhythm of Dawn
    ja: 夜明けの奏
    ko: 새벽의 음률
    zh_hant: 黎明的音色
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3037
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4044:
  _id_: 4044
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Beginning of Story
    ja: はじまりの物語
    ko: 이야기의 시작
    zh_hant: 起始的故事
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3038
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4045:
  _id_: 4045
  attribute_id: 4
  cost: 2
  icon_id: 234
  is_multiple_command_unique_skill: 0
  name:
    en: 1001 Illusions
    ja: 千夜一夜の幻想
    ko: 천일야화의 환상
    zh_hant: 一千零一夜的幻想
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3039
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 377
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 2222
    - 3333
    - 4444
    - 5555
    - 6666
4052:
  _id_: 4052
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Reverse Flash
    ja: 裏一閃
    ko: 이일섬
    zh_hant: 裏閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3041
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4053:
  _id_: 4053
  attribute_id: 6
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Lightning Speed
    ja: 電光石火
    ko: 전광석화
    zh_hant: 雷光石火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3042
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 34
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4054:
  _id_: 4054
  attribute_id: 6
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Skyward Leap
    ja: 大空への跳躍
    ko: 드넓은 하늘로의 도약
    zh_hant: 邁向高空的跳躍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3043
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4055:
  _id_: 4055
  attribute_id: 6
  cost: 2
  icon_id: 235
  is_multiple_command_unique_skill: 0
  name:
    en: Aiming for that sky, to Frontier!
    ja: あの空目指してすすめフロンティア！
    ko: 저 하늘을 향해 나아가라 프론티어!
    zh_hant: 朝向那片天空　前進無垠邊疆！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3044
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 382
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4057:
  _id_: 4057
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Profuse Slash
    ja: 繚乱の斬撃
    ko: 요란의 참격
    zh_hant: 繚亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3046
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4058:
  _id_: 4058
  attribute_id: 2
  cost: 2
  icon_id: 6
  is_multiple_command_unique_skill: 0
  name:
    en: Swift as Wind
    ja: 風の如く
    ko: 바람처럼
    zh_hant: 宛如風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3047
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4059:
  _id_: 4059
  attribute_id: 2
  cost: 2
  icon_id: 33
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce as Fire
    ja: 火の如く
    ko: 불처럼
    zh_hant: 宛如火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3048
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4060:
  _id_: 4060
  attribute_id: 2
  cost: 2
  icon_id: 1008
  is_multiple_command_unique_skill: 0
  name:
    en: Furinkazan
    ja: 風林火山
    ko: 풍림화산
    zh_hant: 風林火山
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3049
  skill_field_effect_id: 23
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
4065:
  _id_: 4065
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4066:
  _id_: 4066
  attribute_id: 4
  cost: 2
  icon_id: 62
  is_multiple_command_unique_skill: 0
  name:
    en: Twilight Dance
    ja: 宵闇の舞
    ko: 초저녁의 춤
    zh_hant: 宵暗之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 102
    - 106
    - 111
    - 116
  - hit_rate: 100
    id: 302
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4067:
  _id_: 4067
  attribute_id: 4
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Dragon Thunder
    ja: 龍の雷
    ko: 용의 불호령
    zh_hant: 龍之雷
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4068:
  _id_: 4068
  attribute_id: 4
  cost: 2
  icon_id: 1018
  is_multiple_command_unique_skill: 0
  name:
    en: War God's Flash
    ja: 軍神の一閃
    ko: 군신의 일섬
    zh_hant: 軍神閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3054
  skill_field_effect_id: 24
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4070:
  _id_: 4070
  attribute_id: 2
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4071:
  _id_: 4071
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Heart
    ja: 自由な心
    ko: 자유로운 마음
    zh_hant: 自由之心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4072:
  _id_: 4072
  attribute_id: 2
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Limitless Radiance
    ja: 永遠の輝き
    ko: 영원한 반짝임
    zh_hant: 永恆光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4073:
  _id_: 4073
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Possibility∞Infinity
    ja: Possibility∞Infinity
    ko: Possibility∞Infinity
    zh_hant: 無限∞可能
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 384
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4075:
  _id_: 4075
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3061
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4076:
  _id_: 4076
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3062
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4077:
  _id_: 4077
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3063
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4078:
  _id_: 4078
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3064
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4079:
  _id_: 4079
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3065
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4080:
  _id_: 4080
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3066
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4081:
  _id_: 4081
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3067
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4082:
  _id_: 4082
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Midnight NEO
    ja: ブラッディ・ミッドナイト NEO
    ko: 블러디 미드나이트 NEO
    zh_hant: 血腥午夜 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3068
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4084:
  _id_: 4084
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3069
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4085:
  _id_: 4085
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3070
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4086:
  _id_: 4086
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3071
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4087:
  _id_: 4087
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3072
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4088:
  _id_: 4088
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3073
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4089:
  _id_: 4089
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3074
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4090:
  _id_: 4090
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3075
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4091:
  _id_: 4091
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3076
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4092:
  _id_: 4092
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3077
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4094:
  _id_: 4094
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3078
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4095:
  _id_: 4095
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3079
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4096:
  _id_: 4096
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3080
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4097:
  _id_: 4097
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3081
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4098:
  _id_: 4098
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3082
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4099:
  _id_: 4099
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Rondo
    ja: 脱力の輪舞曲
    ko: 탈력의 윤무곡
    zh_hant: 虛脫圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3083
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4100:
  _id_: 4100
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3084
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4101:
  _id_: 4101
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3085
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4102:
  _id_: 4102
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cross of Retribution NEO
    ja: 聖罰の十字架 NEO
    ko: 성벌의 십자가 NEO
    zh_hant: 聖罰十字架 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3086
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4104:
  _id_: 4104
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3087
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4105:
  _id_: 4105
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3088
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4106:
  _id_: 4106
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3089
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4107:
  _id_: 4107
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3090
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4108:
  _id_: 4108
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3091
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4109:
  _id_: 4109
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3092
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4110:
  _id_: 4110
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3093
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4111:
  _id_: 4111
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3094
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4112:
  _id_: 4112
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3095
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4114:
  _id_: 4114
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3096
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4115:
  _id_: 4115
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3097
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4116:
  _id_: 4116
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3098
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4117:
  _id_: 4117
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3099
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4118:
  _id_: 4118
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3100
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4119:
  _id_: 4119
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3101
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4120:
  _id_: 4120
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3102
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4121:
  _id_: 4121
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3103
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4122:
  _id_: 4122
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Midnight NEO
    ja: ブラッディ・ミッドナイト NEO
    ko: 블러디 미드나이트 NEO
    zh_hant: 血腥午夜 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3104
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4124:
  _id_: 4124
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3105
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4125:
  _id_: 4125
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3106
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4126:
  _id_: 4126
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3107
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4127:
  _id_: 4127
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3108
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4128:
  _id_: 4128
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3109
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4129:
  _id_: 4129
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3110
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4130:
  _id_: 4130
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3111
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4131:
  _id_: 4131
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3112
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4132:
  _id_: 4132
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3113
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4133:
  _id_: 4133
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3114
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4134:
  _id_: 4134
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3115
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4136:
  _id_: 4136
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3116
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4137:
  _id_: 4137
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3117
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4138:
  _id_: 4138
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3118
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4139:
  _id_: 4139
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3119
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4140:
  _id_: 4140
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3120
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4141:
  _id_: 4141
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3121
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4142:
  _id_: 4142
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Dance
    ja: 連撃の舞
    ko: 연격의 춤
    zh_hant: 連擊之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3122
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4143:
  _id_: 4143
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3123
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4144:
  _id_: 4144
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3124
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4145:
  _id_: 4145
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3125
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4146:
  _id_: 4146
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cross of Retribution NEO
    ja: 聖罰の十字架 NEO
    ko: 성벌의 십자가 NEO
    zh_hant: 聖罰十字架 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3126
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4148:
  _id_: 4148
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust
    ja: 刺突
    ko: 찌르기
    zh_hant: 突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3127
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4149:
  _id_: 4149
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Thrust
    ja: 双刺突
    ko: 두번 찌르기
    zh_hant: 雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3128
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4150:
  _id_: 4150
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3129
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4151:
  _id_: 4151
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3130
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4152:
  _id_: 4152
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3131
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4153:
  _id_: 4153
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3132
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
4154:
  _id_: 4154
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3133
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4155:
  _id_: 4155
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3134
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4156:
  _id_: 4156
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 氷結の協奏曲
    ko: 빙결의 협주곡
    zh_hant: 冰凍協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3135
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4157:
  _id_: 4157
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3136
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4159:
  _id_: 4159
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3137
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4160:
  _id_: 4160
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3138
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4161:
  _id_: 4161
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3139
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4162:
  _id_: 4162
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3140
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4163:
  _id_: 4163
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3141
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4164:
  _id_: 4164
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3142
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4165:
  _id_: 4165
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3143
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4166:
  _id_: 4166
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3144
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4167:
  _id_: 4167
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Midnight NEO
    ja: ブラッディ・ミッドナイト NEO
    ko: 블러디 미드나이트 NEO
    zh_hant: 血腥午夜 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3145
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4169:
  _id_: 4169
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4170:
  _id_: 4170
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4171:
  _id_: 4171
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4172:
  _id_: 4172
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4173:
  _id_: 4173
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4174:
  _id_: 4174
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4175:
  _id_: 4175
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4176:
  _id_: 4176
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4177:
  _id_: 4177
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4179:
  _id_: 4179
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3155
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4180:
  _id_: 4180
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3156
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4181:
  _id_: 4181
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3157
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4182:
  _id_: 4182
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3158
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4183:
  _id_: 4183
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3159
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4184:
  _id_: 4184
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Dance
    ja: 連撃の舞
    ko: 연격의 춤
    zh_hant: 連擊之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3160
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4185:
  _id_: 4185
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3161
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4186:
  _id_: 4186
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3162
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4187:
  _id_: 4187
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3163
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4188:
  _id_: 4188
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cross of Retribution NEO
    ja: 聖罰の十字架 NEO
    ko: 성벌의 십자가 NEO
    zh_hant: 聖罰十字架 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3164
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4190:
  _id_: 4190
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Thrust
    ja: 強襲の刺突
    ko: 강습의 찌르기
    zh_hant: 強襲突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3165
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4191:
  _id_: 4191
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Thrust
    ja: 強襲の双刺突
    ko: 강습의 두번 찌르기
    zh_hant: 強襲雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3166
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4192:
  _id_: 4192
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Thrust
    ja: 強襲の参刺突
    ko: 강습의 세번 찌르기
    zh_hant: 強襲參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3167
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4193:
  _id_: 4193
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3168
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4194:
  _id_: 4194
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Strike
    ja: 回避の一撃
    ko: 회피의 일격
    zh_hant: 迴避一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3169
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4195:
  _id_: 4195
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3170
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4196:
  _id_: 4196
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3171
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4197:
  _id_: 4197
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 氷結の協奏曲
    ko: 빙결의 협주곡
    zh_hant: 冰凍協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3172
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4198:
  _id_: 4198
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟 NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3173
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4206:
  _id_: 4206
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3174
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4207:
  _id_: 4207
  attribute_id: 2
  cost: 2
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Poetic Murmur
    ja: 歌人の呟き
    ko: 가인의 독백
    zh_hant: 歌人的細語
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3175
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 306
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4208:
  _id_: 4208
  attribute_id: 2
  cost: 2
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Sorrowful Song
    ja: 悲哀の歌
    ko: 비애의 노래
    zh_hant: 悲哀之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3176
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4209:
  _id_: 4209
  attribute_id: 2
  cost: 2
  icon_id: 1007
  is_multiple_command_unique_skill: 0
  name:
    en: Esthetics of Subtlety
    ja: あはれの美学
    ko: 정취의 미학
    zh_hant: 物哀美學
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3177
  skill_field_effect_id: 25
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 306
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 307
    - 323
    - 338
    - 353
    - 369
4216:
  _id_: 4216
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ardent Slash
    ja: 烈斬撃
    ko: 열참격
    zh_hant: 烈焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3179
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4217:
  _id_: 4217
  attribute_id: 5
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Heart of Affection
    ja: 慈悲の心
    ko: 자비의 마음
    zh_hant: 慈悲之心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3180
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 30
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
4218:
  _id_: 4218
  attribute_id: 5
  cost: 1
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Relief of Light
    ja: 光の救済
    ko: 빛의 구원
    zh_hant: 光之救贖
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3181
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 241
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4219:
  _id_: 4219
  attribute_id: 5
  cost: 1
  icon_id: 32
  is_multiple_command_unique_skill: 0
  name:
    en: Show Me the Right Path, Mirror
    ja: 鏡よ照らせ 正しき道を
    ko: 거울아 바른 길을 비춰다오
    zh_hant: 鏡子啊！照映出正確的道路吧！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3182
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 150
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 328
    - 345
    - 361
    - 378
    - 394
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
4221:
  _id_: 4221
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Aggravating Slash
    ja: 激化の斬撃
    ko: 격화의 참격
    zh_hant: 激化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3184
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4222:
  _id_: 4222
  attribute_id: 3
  cost: 2
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Dusk Horizon
    ja: 夕闇の地平線
    ko: 초저녁의 지평선
    zh_hant: 薄暮的地平線
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3185
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 75
    id: 232
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4223:
  _id_: 4223
  attribute_id: 3
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Twilight Sky
    ja: 夕暮れの空
    ko: 해질녘 하늘
    zh_hant: 黃昏天色
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3186
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4224:
  _id_: 4224
  attribute_id: 3
  cost: 2
  icon_id: 1019
  is_multiple_command_unique_skill: 0
  name:
    en: Twilight Bodyguard
    ja: 黄昏の用心棒
    ko: 황혼의 호위꾼
    zh_hant: 垂暮的保鑣
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3187
  skill_field_effect_id: 26
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4233:
  _id_: 4233
  attribute_id: 6
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Purity of Courage
    ja: 勇気の浄化
    ko: 용기의 정화
    zh_hant: 勇氣的淨化
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3191
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4234:
  _id_: 4234
  attribute_id: 6
  cost: 2
  icon_id: 58
  is_multiple_command_unique_skill: 0
  name:
    en: Poetic Ecstasy
    ja: 歌人の夢心地
    ko: 가인의 황홀경
    zh_hant: 歌人的夢境
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3192
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4235:
  _id_: 4235
  attribute_id: 6
  cost: 2
  icon_id: 28
  is_multiple_command_unique_skill: 0
  name:
    en: Delightful Song
    ja: 歓喜の歌
    ko: 환희의 노래
    zh_hant: 歡喜之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3193
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 101
    - 106
    - 112
    - 116
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 28
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5500
    - 6000
    - 6500
    - 7000
4236:
  _id_: 4236
  attribute_id: 6
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Esthetics of Beauty
    ja: をかしの美学
    ko: 흥취의 미학
    zh_hant: 明快美學
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3194
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 385
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
4253:
  _id_: 4253
  attribute_id: 3
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3208
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4254:
  _id_: 4254
  attribute_id: 3
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Dance
    ja: 疾風の舞
    ko: 질풍의 춤
    zh_hant: 疾風之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3209
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4255:
  _id_: 4255
  attribute_id: 3
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Motivated Strike
    ja: 気合の一撃
    ko: 기합의 일격
    zh_hant: 氣勢一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3210
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 101
    - 106
    - 112
    - 116
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4256:
  _id_: 4256
  attribute_id: 3
  cost: 2
  icon_id: 1020
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce War Cry
    ja: 猛将の雄叫び
    ko: 용맹한 장수의 외침
    zh_hant: 猛將的怒吼
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3211
  skill_field_effect_id: 27
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 155
    target_id: 1135
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4258:
  _id_: 4258
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3213
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4259:
  _id_: 4259
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3214
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4260:
  _id_: 4260
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3215
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4261:
  _id_: 4261
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3216
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4262:
  _id_: 4262
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poison Slash
    ja: 猛斬撃
    ko: 용맹한 참격
    zh_hant: 猛斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3217
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4263:
  _id_: 4263
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3218
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
  - hit_rate: 100
    id: 54
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4264:
  _id_: 4264
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3219
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4265:
  _id_: 4265
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3220
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4267:
  _id_: 4267
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4268:
  _id_: 4268
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4269:
  _id_: 4269
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4270:
  _id_: 4270
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4271:
  _id_: 4271
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4272:
  _id_: 4272
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4273:
  _id_: 4273
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4274:
  _id_: 4274
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4275:
  _id_: 4275
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4277:
  _id_: 4277
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3230
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4278:
  _id_: 4278
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3231
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4279:
  _id_: 4279
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3232
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4280:
  _id_: 4280
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3233
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4281:
  _id_: 4281
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3234
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4282:
  _id_: 4282
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3235
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4283:
  _id_: 4283
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3236
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4284:
  _id_: 4284
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3237
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4285:
  _id_: 4285
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3238
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 57
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4287:
  _id_: 4287
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4288:
  _id_: 4288
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4289:
  _id_: 4289
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4290:
  _id_: 4290
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4291:
  _id_: 4291
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4292:
  _id_: 4292
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4293:
  _id_: 4293
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4294:
  _id_: 4294
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4295:
  _id_: 4295
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4296:
  _id_: 4296
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4298:
  _id_: 4298
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3249
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4299:
  _id_: 4299
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3250
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4300:
  _id_: 4300
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3251
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4301:
  _id_: 4301
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3252
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4302:
  _id_: 4302
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Poison Triple Slash
    ja: 猛参撃
    ko: 용맹한 삼격
    zh_hant: 猛參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3253
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 140
    - 140
    - 140
    - 140
    - 140
4303:
  _id_: 4303
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3254
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4304:
  _id_: 4304
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3255
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4305:
  _id_: 4305
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3256
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4307:
  _id_: 4307
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3257
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4308:
  _id_: 4308
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4309:
  _id_: 4309
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4310:
  _id_: 4310
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4311:
  _id_: 4311
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4312:
  _id_: 4312
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3262
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4313:
  _id_: 4313
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4314:
  _id_: 4314
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4315:
  _id_: 4315
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4317:
  _id_: 4317
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3266
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4318:
  _id_: 4318
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3267
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4319:
  _id_: 4319
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3268
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4320:
  _id_: 4320
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3269
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4321:
  _id_: 4321
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3270
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4322:
  _id_: 4322
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3271
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4323:
  _id_: 4323
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3272
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4324:
  _id_: 4324
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3273
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4325:
  _id_: 4325
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3274
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4327:
  _id_: 4327
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4328:
  _id_: 4328
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4329:
  _id_: 4329
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4330:
  _id_: 4330
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4331:
  _id_: 4331
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4332:
  _id_: 4332
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4333:
  _id_: 4333
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4334:
  _id_: 4334
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4335:
  _id_: 4335
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4336:
  _id_: 4336
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4337:
  _id_: 4337
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4339:
  _id_: 4339
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4340:
  _id_: 4340
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4341:
  _id_: 4341
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4342:
  _id_: 4342
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4343:
  _id_: 4343
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4344:
  _id_: 4344
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3291
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4345:
  _id_: 4345
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4346:
  _id_: 4346
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3293
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4348:
  _id_: 4348
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4349:
  _id_: 4349
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4350:
  _id_: 4350
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4351:
  _id_: 4351
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4352:
  _id_: 4352
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4353:
  _id_: 4353
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4354:
  _id_: 4354
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3300
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4355:
  _id_: 4355
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4356:
  _id_: 4356
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4357:
  _id_: 4357
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3303
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4359:
  _id_: 4359
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4360:
  _id_: 4360
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4361:
  _id_: 4361
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4362:
  _id_: 4362
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4363:
  _id_: 4363
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4364:
  _id_: 4364
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4365:
  _id_: 4365
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4366:
  _id_: 4366
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3311
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4367:
  _id_: 4367
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4368:
  _id_: 4368
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3313
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4370:
  _id_: 4370
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4371:
  _id_: 4371
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4372:
  _id_: 4372
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4373:
  _id_: 4373
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4374:
  _id_: 4374
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4375:
  _id_: 4375
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4376:
  _id_: 4376
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4377:
  _id_: 4377
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4378:
  _id_: 4378
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4379:
  _id_: 4379
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4380:
  _id_: 4380
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4382:
  _id_: 4382
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Slash
    ja: キラめきの剣撃
    ko: 반짝임의 검격
    zh_hant: 光芒劍擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4383:
  _id_: 4383
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Land and Sky
    ja: 空と大地
    ko: 하늘과 대지
    zh_hant: 天空與大地
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4384:
  _id_: 4384
  attribute_id: 4
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Light and Darkness
    ja: 光と闇
    ko: 빛과 어둠
    zh_hant: 光與暗
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4385:
  _id_: 4385
  attribute_id: 4
  cost: 2
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Genesis
    ja: 独煌のゲネシス
    ko: 눈부신 제네시스
    zh_hant: 獨尊創世紀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 75
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4387:
  _id_: 4387
  attribute_id: 6
  cost: 1
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Adjustment
    ja: 調整
    ko: 조정
    zh_hant: 調整
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3330
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4388:
  _id_: 4388
  attribute_id: 6
  cost: 2
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Clumsy Handling
    ja: 稚拙な運用
    ko: 치졸한 운용
    zh_hant: 拙劣的運用
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3331
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4389:
  _id_: 4389
  attribute_id: 6
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Skillful Management
    ja: 巧みな管理
    ko: 정교한 관리
    zh_hant: 巧妙的管理
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3332
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4390:
  _id_: 4390
  attribute_id: 6
  cost: 2
  icon_id: 234
  is_multiple_command_unique_skill: 0
  name:
    en: 'Article 14: Forceful Removal'
    ja: 幸福都市検察法第14条『強攻排除』
    ko: 행복 도시 검찰법 제14조 [강공배제]
    zh_hant: 幸福都市檢查法第14條『強攻排除』
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3333
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 197
    - 205
    - 210
    - 215
    - 230
  - hit_rate: 100
    id: 377
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 2222
    - 3333
    - 4444
    - 5555
    - 6666
4392:
  _id_: 4392
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Dance
    ja: 疾風の舞
    ko: 질풍의 춤
    zh_hant: 疾風之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3335
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4393:
  _id_: 4393
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Forced Breakthrough
    ja: 強行突破
    ko: 강행돌파
    zh_hant: 強行突破
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3336
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4394:
  _id_: 4394
  attribute_id: 4
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Limitless Radiance
    ja: 永遠の輝き
    ko: 영원한 반짝임
    zh_hant: 永恆光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3337
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4395:
  _id_: 4395
  attribute_id: 4
  cost: 2
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: Oni's Fist
    ja: 鬼の鉄拳
    ko: 악마의 철권
    zh_hant: 鬼之鐵拳
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3338
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 371
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4397:
  _id_: 4397
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Prayer
    ja: 祈りの剣
    ko: 기도의 검
    zh_hant: 祈願之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3340
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 157
    target_id: 1133
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4398:
  _id_: 4398
  attribute_id: 2
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Divinity
    ja: 女神の剣
    ko: 여신의 검
    zh_hant: 女神之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3341
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4399:
  _id_: 4399
  attribute_id: 2
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Piercing Sword
    ja: 貫きの剣
    ko: 관통의 검
    zh_hant: 貫穿之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3342
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4400:
  _id_: 4400
  attribute_id: 2
  cost: 2
  icon_id: 198
  is_multiple_command_unique_skill: 0
  name:
    en: Haja Kensei - Ouka Houshin
    ja: 破邪剣征・桜花放神
    ko: 파사검정 앵화방신
    zh_hant: 破邪劍征・櫻花放神
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3343
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
4402:
  _id_: 4402
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3345
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4403:
  _id_: 4403
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Dance
    ja: 疾風の舞
    ko: 질풍의 춤
    zh_hant: 疾風之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3346
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4404:
  _id_: 4404
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Motivated Strike
    ja: 気合の一撃
    ko: 기합의 일격
    zh_hant: 氣勢一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3347
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 97
    - 101
    - 106
    - 112
    - 116
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4405:
  _id_: 4405
  attribute_id: 4
  cost: 2
  icon_id: 1021
  is_multiple_command_unique_skill: 0
  name:
    en: Sacre de Lumiere
    ja: サクレ・デ・リュミエール
    ko: 사크레 드 뤼미에르
    zh_hant: 神聖之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3348
  skill_field_effect_id: 28
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 360
    target_id: 1142
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4407:
  _id_: 4407
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3350
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4408:
  _id_: 4408
  attribute_id: 1
  cost: 2
  icon_id: 195
  is_multiple_command_unique_skill: 0
  name:
    en: Creation Slash
    ja: 創造の斬撃
    ko: 창조의 참격
    zh_hant: 創造斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3351
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 306
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
4409:
  _id_: 4409
  attribute_id: 1
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Victory Oath
    ja: 勝利の誓い
    ko: 승리의 맹세
    zh_hant: 勝利誓約
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3352
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 39
    target_id: 1143
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4410:
  _id_: 4410
  attribute_id: 1
  cost: 2
  icon_id: 62
  is_multiple_command_unique_skill: 0
  name:
    en: Rambling Wheel
    ja: ランブリング・ホイール
    ko: 럼블링 휠
    zh_hant: 水車斬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3353
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 376
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4412:
  _id_: 4412
  attribute_id: 2
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Blade
    ja: 浄化の刃
    ko: 정화의 칼날
    zh_hant: 淨化之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3355
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4413:
  _id_: 4413
  attribute_id: 2
  cost: 2
  icon_id: 192
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Blink
    ja: 減光の瞬き
    ko: 감광의 반짝임
    zh_hant: 減光之瞬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4414:
  _id_: 4414
  attribute_id: 2
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Skyward Leap
    ja: 大空への跳躍
    ko: 드넓은 하늘로의 도약
    zh_hant: 邁向高空的跳躍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4415:
  _id_: 4415
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Nostalgic Cherry Blossoms
    ja: 想い出の桜花
    ko: 추억의 벚꽃
    zh_hant: 回憶的櫻花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 384
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4417:
  _id_: 4417
  attribute_id: 6
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Limitless Radiance
    ja: 永遠の輝き
    ko: 영원한 반짝임
    zh_hant: 永恆光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4418:
  _id_: 4418
  attribute_id: 6
  cost: 2
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Cloud Piercing
    ja: 雲射る刃
    ko: 구름을 찌르는 칼날
    zh_hant: 穿雲之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 35
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4419:
  _id_: 4419
  attribute_id: 6
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Blade
    ja: 疾風の刃
    ko: 질풍의 칼날
    zh_hant: 疾風之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3365
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4420:
  _id_: 4420
  attribute_id: 6
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Flames of Justice
    ja: 正義の業火
    ko: 정의의 업화
    zh_hant: 正義的業火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3366
  skill_field_effect_id: 29
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 299
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4447:
  _id_: 4447
  attribute_id: 1
  cost: 2
  icon_id: 6
  is_multiple_command_unique_skill: 0
  name:
    en: One Arrow
    ja: 一の矢
    ko: 첫 번째 화살
    zh_hant: 第一箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3380
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4448:
  _id_: 4448
  attribute_id: 1
  cost: 2
  icon_id: 33
  is_multiple_command_unique_skill: 0
  name:
    en: Two Arrows
    ja: 二の矢
    ko: 두 번째 화살
    zh_hant: 第二箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3381
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4449:
  _id_: 4449
  attribute_id: 1
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Three Arrows
    ja: 三の矢
    ko: 세 번째 화살
    zh_hant: 第三箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3382
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 30
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
4450:
  _id_: 4450
  attribute_id: 1
  cost: 2
  icon_id: 1023
  is_multiple_command_unique_skill: 0
  name:
    en: Three Arrows' Bond
    ja: 三矢の絆
    ko: 세 화살의 인연
    zh_hant: 三箭的羈絆
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3383
  skill_field_effect_id: 30
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4452:
  _id_: 4452
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3385
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4453:
  _id_: 4453
  attribute_id: 6
  cost: 2
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Decision Time
    ja: 決断の時
    ko: 결단의 시간
    zh_hant: 決斷之時
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3386
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4454:
  _id_: 4454
  attribute_id: 6
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Judgement Time
    ja: 審判の時
    ko: 심판의 시간
    zh_hant: 審判之時
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3387
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4455:
  _id_: 4455
  attribute_id: 6
  cost: 2
  icon_id: 229
  is_multiple_command_unique_skill: 0
  name:
    en: Love & Rebirth Judgement
    ja: Love＆Rebirth Judgment
    ko: Love & Rebirth Judgment
    zh_hant: Love＆Rebirth Judgment
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3388
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 386
    target_id: 22002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 7
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 42
    - 44
    - 47
    - 50
4457:
  _id_: 4457
  attribute_id: 6
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Dance
    ja: 疾風の舞
    ko: 질풍의 춤
    zh_hant: 疾風之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3390
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4458:
  _id_: 4458
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Forced Breakthrough
    ja: 強行突破
    ko: 강행돌파
    zh_hant: 強行突破
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3391
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4459:
  _id_: 4459
  attribute_id: 6
  cost: 2
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Limitless Radiance
    ja: 永遠の輝き
    ko: 영원한 반짝임
    zh_hant: 永恆光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3392
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4460:
  _id_: 4460
  attribute_id: 6
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Gatling Typhoon
    ja: 乱れ撃ちタイフーン
    ko: 난사 타이푼
    zh_hant: 亂射颱風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3393
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4462:
  _id_: 4462
  attribute_id: 5
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3395
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4463:
  _id_: 4463
  attribute_id: 5
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Song
    ja: 浄化の歌
    ko: 정화의 노래
    zh_hant: 淨化之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3396
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4464:
  _id_: 4464
  attribute_id: 5
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Voice
    ja: 浄化の声
    ko: 정화의 목소리
    zh_hant: 淨化之聲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3397
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4465:
  _id_: 4465
  attribute_id: 5
  cost: 2
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Listen to the Sound of My Soul!
    ja: 聞かせて魅せます命の響！
    ko: 들려드리지요 생의 울림을!
    zh_hant: 響徹雲霄，生命迴響！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3398
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 164
    - 172
    - 181
    - 189
    - 197
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4467:
  _id_: 4467
  attribute_id: 1
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3400
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4468:
  _id_: 4468
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Heart
    ja: 自由な心
    ko: 자유로운 마음
    zh_hant: 自由之心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3401
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4469:
  _id_: 4469
  attribute_id: 1
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Piercing Sword
    ja: 貫きの剣
    ko: 관통의 검
    zh_hant: 貫穿之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3402
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4470:
  _id_: 4470
  attribute_id: 1
  cost: 2
  icon_id: 1024
  is_multiple_command_unique_skill: 0
  name:
    en: Rose Escape
    ja: 薔薇の逃避行
    ko: 장미의 도피행
    zh_hant: 玫瑰的逃世
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3403
  skill_field_effect_id: 31
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4472:
  _id_: 4472
  attribute_id: 5
  cost: 2
  icon_id: 239
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Power
    ja: 恋の力
    ko: 애정의 힘
    zh_hant: 戀的力量
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3405
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 345
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
4473:
  _id_: 4473
  attribute_id: 5
  cost: 2
  icon_id: 221
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Anguish
    ja: 恋の苦しみ
    ko: 애정의 고통
    zh_hant: 戀的苦澀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3406
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 75
    id: 341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4474:
  _id_: 4474
  attribute_id: 5
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Warmth
    ja: 恋の暖かみ
    ko: 애정의 온기
    zh_hant: 戀的溫暖
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3407
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4475:
  _id_: 4475
  attribute_id: 5
  cost: 2
  icon_id: 239
  is_multiple_command_unique_skill: 0
  name:
    en: One Drop of Love
    ja: 一滴の愛
    ko: 한 방울의 사랑
    zh_hant: 一滴的愛
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3408
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
  - hit_rate: 100
    id: 156
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 345
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
4477:
  _id_: 4477
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3069
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4478:
  _id_: 4478
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3070
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4479:
  _id_: 4479
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3071
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4480:
  _id_: 4480
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3072
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4481:
  _id_: 4481
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3073
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4482:
  _id_: 4482
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3074
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4483:
  _id_: 4483
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3075
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4484:
  _id_: 4484
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3076
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4485:
  _id_: 4485
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3077
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4487:
  _id_: 4487
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3105
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4488:
  _id_: 4488
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3106
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4489:
  _id_: 4489
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3107
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4490:
  _id_: 4490
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3108
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4491:
  _id_: 4491
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3109
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4492:
  _id_: 4492
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3110
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4493:
  _id_: 4493
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3111
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4494:
  _id_: 4494
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3112
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4495:
  _id_: 4495
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3113
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4496:
  _id_: 4496
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3114
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4497:
  _id_: 4497
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3115
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4499:
  _id_: 4499
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4500:
  _id_: 4500
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4501:
  _id_: 4501
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4502:
  _id_: 4502
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4503:
  _id_: 4503
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4504:
  _id_: 4504
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4505:
  _id_: 4505
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4506:
  _id_: 4506
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4507:
  _id_: 4507
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4524:
  _id_: 4524
  attribute_id: 1
  cost: 2
  icon_id: 189
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Strength
    ja: 愛の力
    ko: 사랑의 힘
    zh_hant: 愛的力量
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3415
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 284
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
4525:
  _id_: 4525
  attribute_id: 1
  cost: 2
  icon_id: 62
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Suffering
    ja: 愛の苦しみ
    ko: 사랑의 고통
    zh_hant: 愛的苦澀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3416
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 75
    id: 302
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4526:
  _id_: 4526
  attribute_id: 1
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Affection
    ja: 愛の暖かみ
    ko: 사랑의 온기
    zh_hant: 愛的溫暖
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3417
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4527:
  _id_: 4527
  attribute_id: 1
  cost: 2
  icon_id: 151
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom of Tragedy
    ja: 悲劇の花吹雪
    ko: 비극의 꽃보라
    zh_hant: 悲劇的花吹雪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3418
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 151
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 284
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
4529:
  _id_: 4529
  attribute_id: 3
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3420
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4530:
  _id_: 4530
  attribute_id: 3
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Path of Hope
    ja: 希望への道
    ko: 희망으로의 길
    zh_hant: 通往希望的道路
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3421
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4531:
  _id_: 4531
  attribute_id: 3
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Skyward Leap
    ja: 大空への跳躍
    ko: 드넓은 하늘로의 도약
    zh_hant: 邁向高空的跳躍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3422
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4532:
  _id_: 4532
  attribute_id: 3
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Light of Hope
    ja: 希望は光になりて
    ko: 희망은 빛이 될 자
    zh_hant: 希望終將成為光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3423
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 392
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4534:
  _id_: 4534
  attribute_id: 5
  cost: 2
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Proof
    ja: 愛の証明
    ko: 사랑의 증명
    zh_hant: 愛的證明
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3425
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4535:
  _id_: 4535
  attribute_id: 5
  cost: 2
  icon_id: 1025
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Lament
    ja: 愛の嘆き
    ko: 사랑의 비탄
    zh_hant: 愛的慨嘆
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3426
  skill_field_effect_id: 32
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4536:
  _id_: 4536
  attribute_id: 5
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Love's Affection
    ja: 愛の暖かみ
    ko: 사랑의 온기
    zh_hant: 愛的溫暖
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3427
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4537:
  _id_: 4537
  attribute_id: 5
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Tragedy
    ja: 美しき悲劇
    ko: 아름다운 비극
    zh_hant: 淒美的悲劇
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3428
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 384
    target_id: 4068
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4539:
  _id_: 4539
  attribute_id: 5
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Lovely Arrow
    ja: 麗しの矢
    ko: 아름다운 화살
    zh_hant: 美麗之箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3430
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4540:
  _id_: 4540
  attribute_id: 5
  cost: 2
  icon_id: 6
  is_multiple_command_unique_skill: 0
  name:
    en: Love Arrow
    ja: 愛の矢
    ko: 사랑의 화살
    zh_hant: 愛之箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3431
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4541:
  _id_: 4541
  attribute_id: 5
  cost: 2
  icon_id: 33
  is_multiple_command_unique_skill: 0
  name:
    en: Arrow of Freedom
    ja: 自由の矢
    ko: 자유의 화살
    zh_hant: 自由之箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3432
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4542:
  _id_: 4542
  attribute_id: 5
  cost: 2
  icon_id: 1021
  is_multiple_command_unique_skill: 0
  name:
    en: Aggressive Coyote
    ja: 牙剝くコヨーテ
    ko: 사나운 코요테
    zh_hant: 露出獠牙的郊狼
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3433
  skill_field_effect_id: 33
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 384
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4549:
  _id_: 4549
  attribute_id: 3
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Mow
    ja: 浄化の薙払
    ko: 정화의 베어넘기기
    zh_hant: 淨化之橫掃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3435
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4550:
  _id_: 4550
  attribute_id: 3
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Strategic Prank
    ja: 策略家のいたずら
    ko: 책략가의 장난
    zh_hant: 謀略家的惡作劇
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3436
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4551:
  _id_: 4551
  attribute_id: 3
  cost: 2
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Limitless Radiance
    ja: 永遠の輝き
    ko: 영원한 반짝임
    zh_hant: 永恆光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3437
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4552:
  _id_: 4552
  attribute_id: 3
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Together with the King!
    ja: わが宿命は、王と共に！
    ko: 나의 숙명은 왕과 함께!
    zh_hant: 吾之宿命，與王同在！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3438
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4554:
  _id_: 4554
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3440
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4555:
  _id_: 4555
  attribute_id: 4
  cost: 2
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Dynamic Attack
    ja: ダイナミックアタック
    ko: 다이내믹 어택
    zh_hant: 舞動攻擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3441
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 232
    target_id: 2121
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4556:
  _id_: 4556
  attribute_id: 4
  cost: 3
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Pinpoint Clutch
    ja: ピンポイントクラッチ
    ko: 핀포인트 클러치
    zh_hant: 重點式固定技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3442
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 394
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4557:
  _id_: 4557
  attribute_id: 4
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Nightmare Show
    ja: Nightmare Show
    ko: Nightmare Show
    zh_hant: 夢魘表演
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3443
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 232
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4559:
  _id_: 4559
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ardent Thrust
    ja: 烈刺突
    ko: 강렬한 찌르기
    zh_hant: 烈焰突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3445
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
4560:
  _id_: 4560
  attribute_id: 1
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Emperor's Authority
    ja: 皇帝の威厳
    ko: 황제의 위엄
    zh_hant: 皇帝的威嚴
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3446
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
4561:
  _id_: 4561
  attribute_id: 1
  cost: 1
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Emperor's Prestige
    ja: 皇帝の威信
    ko: 황제의 위신
    zh_hant: 皇帝的威信
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3447
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4562:
  _id_: 4562
  attribute_id: 1
  cost: 2
  icon_id: 33
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer
    ja: 威光堂々　～銀河皇帝円舞曲～
    ko: 위풍당당 ~은하 황제 원무곡~
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3448
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 150
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 328
    - 345
    - 361
    - 378
    - 394
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
4564:
  _id_: 4564
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Profuse Strike
    ja: 繚乱の一撃
    ko: 요란의 일격
    zh_hant: 繚亂一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3450
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 91
    - 95
    - 99
    - 104
    - 109
4565:
  _id_: 4565
  attribute_id: 4
  cost: 2
  icon_id: 54
  is_multiple_command_unique_skill: 0
  name:
    en: Poisonous Invitation
    ja: 妖毒の誘い
    ko: 요독의 초대
    zh_hant: 妖毒的誘惑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3451
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 245
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 6
    - 8
    - 10
    - 12
    - 15
4566:
  _id_: 4566
  attribute_id: 4
  cost: 3
  icon_id: 158
  is_multiple_command_unique_skill: 0
  name:
    en: Life Blade
    ja: 命の刃
    ko: 생명의 칼날
    zh_hant: 命之刃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3452
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 276
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 74
    - 78
    - 82
    - 87
    - 91
4567:
  _id_: 4567
  attribute_id: 4
  cost: 2
  icon_id: 197
  is_multiple_command_unique_skill: 0
  name:
    en: Invincible Sword
    ja: 無敵の剣
    ko: 무적의 검
    zh_hant: 無敵之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3453
  skill_field_effect_id: 34
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
  - hit_rate: 100
    id: 309
    target_id: 11011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
4569:
  _id_: 4569
  attribute_id: 3
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3455
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4570:
  _id_: 4570
  attribute_id: 3
  cost: 2
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Madness Attack
    ja: マッドネスアタック
    ko: 매드니스 어택
    zh_hant: 瘋狂攻擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3456
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 298
    target_id: 2121
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4571:
  _id_: 4571
  attribute_id: 3
  cost: 3
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Pinpoint Clutch
    ja: ピンポイントクラッチ
    ko: 핀포인트 클러치
    zh_hant: 重點式固定技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3457
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 394
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4572:
  _id_: 4572
  attribute_id: 3
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: PONZU Toxic Mist
    ja: PONZU毒霧
    ko: PONZU 독안개
    zh_hant: 柚子醋毒霧
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3458
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4574:
  _id_: 4574
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4575:
  _id_: 4575
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4576:
  _id_: 4576
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4577:
  _id_: 4577
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4578:
  _id_: 4578
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4579:
  _id_: 4579
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4580:
  _id_: 4580
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4581:
  _id_: 4581
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4582:
  _id_: 4582
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4584:
  _id_: 4584
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4585:
  _id_: 4585
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4586:
  _id_: 4586
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4587:
  _id_: 4587
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4588:
  _id_: 4588
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4589:
  _id_: 4589
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4590:
  _id_: 4590
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4591:
  _id_: 4591
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4592:
  _id_: 4592
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4593:
  _id_: 4593
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4595:
  _id_: 4595
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4596:
  _id_: 4596
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4597:
  _id_: 4597
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4598:
  _id_: 4598
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4599:
  _id_: 4599
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4600:
  _id_: 4600
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4601:
  _id_: 4601
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4602:
  _id_: 4602
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4604:
  _id_: 4604
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4605:
  _id_: 4605
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4606:
  _id_: 4606
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4607:
  _id_: 4607
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4608:
  _id_: 4608
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4609:
  _id_: 4609
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4610:
  _id_: 4610
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4611:
  _id_: 4611
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4613:
  _id_: 4613
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4614:
  _id_: 4614
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4615:
  _id_: 4615
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2834
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4616:
  _id_: 4616
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4617:
  _id_: 4617
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4618:
  _id_: 4618
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4619:
  _id_: 4619
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4620:
  _id_: 4620
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2839
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4622:
  _id_: 4622
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4623:
  _id_: 4623
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Sharpshooting
    ja: 双狙撃
    ko: 쌍저격
    zh_hant: 雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2866
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4624:
  _id_: 4624
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Sharpshooting
    ja: 強襲の双狙撃
    ko: 강습의 쌍저격
    zh_hant: 強襲雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4625:
  _id_: 4625
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4626:
  _id_: 4626
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4627:
  _id_: 4627
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4628:
  _id_: 4628
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2871
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4629:
  _id_: 4629
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4630:
  _id_: 4630
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4632:
  _id_: 4632
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4633:
  _id_: 4633
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4634:
  _id_: 4634
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4635:
  _id_: 4635
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4636:
  _id_: 4636
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4637:
  _id_: 4637
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4638:
  _id_: 4638
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2908
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4639:
  _id_: 4639
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2909
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4641:
  _id_: 4641
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4642:
  _id_: 4642
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4643:
  _id_: 4643
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4644:
  _id_: 4644
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4645:
  _id_: 4645
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4646:
  _id_: 4646
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4647:
  _id_: 4647
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4648:
  _id_: 4648
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2900
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4649:
  _id_: 4649
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2901
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4660:
  _id_: 4660
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4661:
  _id_: 4661
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4662:
  _id_: 4662
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4663:
  _id_: 4663
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4664:
  _id_: 4664
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4665:
  _id_: 4665
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4666:
  _id_: 4666
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4667:
  _id_: 4667
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4668:
  _id_: 4668
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2918
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4669:
  _id_: 4669
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2919
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4687:
  _id_: 4687
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Brilliance
    ja: 月光のキラめき
    ko: 달빛의 반짝임
    zh_hant: 月光的光芒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3501
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4688:
  _id_: 4688
  attribute_id: 4
  cost: 3
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Insanity
    ja: 月光の狂気
    ko: 달빛의 광기
    zh_hant: 月光的瘋狂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3502
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 240
    - 260
    - 280
    - 300
  - hit_rate: 100
    id: 59
    target_id: 2146
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4689:
  _id_: 4689
  attribute_id: 4
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Ring
    ja: 月光環
    ko: 월광환
    zh_hant: 月光環
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3503
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4690:
  _id_: 4690
  attribute_id: 4
  cost: 2
  icon_id: 235
  is_multiple_command_unique_skill: 0
  name:
    en: Rising Moon☆Rampage!
    ja: Rising Moon☆Rampage！
    ko: Rising Moon☆Rampage!
    zh_hant: Rising Moon☆Rampage！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3504
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 382
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4692:
  _id_: 4692
  attribute_id: 4
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Mow
    ja: 浄化の薙払
    ko: 정화의 베어넘기기
    zh_hant: 淨化之橫掃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4693:
  _id_: 4693
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4694:
  _id_: 4694
  attribute_id: 4
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Unconventional Sword
    ja: 型破りの剣
    ko: 파격의 검
    zh_hant: 打破常規之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3508
  skill_field_effect_id: 35
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4695:
  _id_: 4695
  attribute_id: 4
  cost: 2
  icon_id: 60
  is_multiple_command_unique_skill: 0
  name:
    en: Baragaki
    ja: 茨掻き
    ko: 마구 할퀴기
    zh_hant: 爪痕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 75
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4697:
  _id_: 4697
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Strike
    ja: 浄化の一撃
    ko: 정화의 일격
    zh_hant: 浄化一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3511
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4698:
  _id_: 4698
  attribute_id: 4
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Strike
    ja: 弛緩の一撃
    ko: 이완의 일격
    zh_hant: 遲緩一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3512
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4699:
  _id_: 4699
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Strike
    ja: 自由な一撃
    ko: 자유로운 일격
    zh_hant: 自由一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3513
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4700:
  _id_: 4700
  attribute_id: 4
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Flower of Recollection
    ja: 追憶の銀花
    ko: 추억의 은꽃
    zh_hant: 追憶的銀花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3514
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
4702:
  _id_: 4702
  attribute_id: 6
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Mow
    ja: 浄化の薙払
    ko: 정화의 베어넘기기
    zh_hant: 淨化之橫掃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3516
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4703:
  _id_: 4703
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3517
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4704:
  _id_: 4704
  attribute_id: 6
  cost: 2
  icon_id: 1025
  is_multiple_command_unique_skill: 0
  name:
    en: Day Lamp Shadow
    ja: 昼行燈の影
    ko: 한낮의 등불 그림자
    zh_hant: 晝行燈之影
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3518
  skill_field_effect_id: 36
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4705:
  _id_: 4705
  attribute_id: 6
  cost: 2
  icon_id: 6
  is_multiple_command_unique_skill: 0
  name:
    en: Snow Melting
    ja: 雪解
    ko: 눈석임
    zh_hant: 融雪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3519
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
  - hit_rate: 100
    id: 34
    target_id: 1135
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4707:
  _id_: 4707
  attribute_id: 7
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Victory Present
    ja: 勝利の贈り物
    ko: 승리의 선물
    zh_hant: 勝利的餽贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3521
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4708:
  _id_: 4708
  attribute_id: 7
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Present
    ja: 自由な贈り物
    ko: 자유로운 선물
    zh_hant: 自由的餽贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3522
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4709:
  _id_: 4709
  attribute_id: 7
  cost: 2
  icon_id: 33
  is_multiple_command_unique_skill: 0
  name:
    en: Counterattack Present
    ja: 反撃の贈り物
    ko: 반격의 선물
    zh_hant: 反擊的饋贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3523
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4710:
  _id_: 4710
  attribute_id: 7
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Black Santa's Present
    ja: ブラックサンタのプレゼント
    ko: 블랙 산타의 선물
    zh_hant: 黑色聖誕老人的禮物
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3524
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
  - hit_rate: 100
    id: 156
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
4712:
  _id_: 4712
  attribute_id: 6
  cost: 2
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Present
    ja: 凍てつく贈り物
    ko: 얼어붙은 선물
    zh_hant: 凍結的餽贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3526
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 61
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4713:
  _id_: 4713
  attribute_id: 6
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Selfish Present
    ja: わがままな贈り物
    ko: 제멋대로인 선물
    zh_hant: 任性的餽贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3527
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
4714:
  _id_: 4714
  attribute_id: 6
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Disorderly Present
    ja: 取り乱す贈り物
    ko: 흐트러진 선물
    zh_hant: 雜亂無章的餽贈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3528
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 384
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4715:
  _id_: 4715
  attribute_id: 6
  cost: 2
  icon_id: 241
  is_multiple_command_unique_skill: 0
  name:
    en: White Santa's Present
    ja: ホワイトサンタのプレゼント
    ko: 화이트 산타의 선물
    zh_hant: 白色聖誕老人的禮物
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3529
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 398
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
4717:
  _id_: 4717
  attribute_id: 6
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Gale Dance
    ja: 疾風の舞
    ko: 질풍의 춤
    zh_hant: 疾風之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3531
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 84
    - 88
    - 92
    - 97
    - 101
4718:
  _id_: 4718
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Gust of Brilliance
    ja: キラめきの風
    ko: 반짝임의 바람
    zh_hant: 光芒之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3532
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 15
    - 16
    - 17
    - 18
    - 20
4719:
  _id_: 4719
  attribute_id: 6
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Lightning Mow
    ja: 雷撃の薙払
    ko: 뇌격의 베어넘기기
    zh_hant: 雷擊橫掃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3533
  skill_field_effect_id: 38
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
4720:
  _id_: 4720
  attribute_id: 6
  cost: 2
  icon_id: 1010
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 青龍炎舞
    ko: 청룡염무
    zh_hant: 青龍炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3534
  skill_field_effect_id: 39
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4722:
  _id_: 4722
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4723:
  _id_: 4723
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4724:
  _id_: 4724
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4725:
  _id_: 4725
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4726:
  _id_: 4726
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4727:
  _id_: 4727
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4728:
  _id_: 4728
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4729:
  _id_: 4729
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4730:
  _id_: 4730
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4732:
  _id_: 4732
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4733:
  _id_: 4733
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4734:
  _id_: 4734
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4735:
  _id_: 4735
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4736:
  _id_: 4736
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4737:
  _id_: 4737
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4738:
  _id_: 4738
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4739:
  _id_: 4739
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4740:
  _id_: 4740
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4742:
  _id_: 4742
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4743:
  _id_: 4743
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4744:
  _id_: 4744
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4745:
  _id_: 4745
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4746:
  _id_: 4746
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4747:
  _id_: 4747
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4748:
  _id_: 4748
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4749:
  _id_: 4749
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4750:
  _id_: 4750
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4751:
  _id_: 4751
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4752:
  _id_: 4752
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4754:
  _id_: 4754
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4755:
  _id_: 4755
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4756:
  _id_: 4756
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4757:
  _id_: 4757
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4758:
  _id_: 4758
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4759:
  _id_: 4759
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4760:
  _id_: 4760
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4761:
  _id_: 4761
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4762:
  _id_: 4762
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4763:
  _id_: 4763
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4765:
  _id_: 4765
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4766:
  _id_: 4766
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4767:
  _id_: 4767
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4768:
  _id_: 4768
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4769:
  _id_: 4769
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4770:
  _id_: 4770
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4771:
  _id_: 4771
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4772:
  _id_: 4772
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4773:
  _id_: 4773
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4774:
  _id_: 4774
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2365
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4775:
  _id_: 4775
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2366
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4777:
  _id_: 4777
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4778:
  _id_: 4778
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4779:
  _id_: 4779
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4780:
  _id_: 4780
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4781:
  _id_: 4781
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4782:
  _id_: 4782
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4783:
  _id_: 4783
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4784:
  _id_: 4784
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4786:
  _id_: 4786
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4787:
  _id_: 4787
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4788:
  _id_: 4788
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4789:
  _id_: 4789
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4790:
  _id_: 4790
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4791:
  _id_: 4791
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4792:
  _id_: 4792
  attribute_id: 7
  cost: 3
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4793:
  _id_: 4793
  attribute_id: 7
  cost: 3
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2354
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4794:
  _id_: 4794
  attribute_id: 7
  cost: 3
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2355
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4796:
  _id_: 4796
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4797:
  _id_: 4797
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4798:
  _id_: 4798
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4799:
  _id_: 4799
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4800:
  _id_: 4800
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4801:
  _id_: 4801
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4802:
  _id_: 4802
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4803:
  _id_: 4803
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4804:
  _id_: 4804
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4805:
  _id_: 4805
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2365
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4806:
  _id_: 4806
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2366
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4808:
  _id_: 4808
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4809:
  _id_: 4809
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4810:
  _id_: 4810
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4811:
  _id_: 4811
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4812:
  _id_: 4812
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4813:
  _id_: 4813
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4814:
  _id_: 4814
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4815:
  _id_: 4815
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2374
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4816:
  _id_: 4816
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2375
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4818:
  _id_: 4818
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4819:
  _id_: 4819
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4820:
  _id_: 4820
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4821:
  _id_: 4821
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4822:
  _id_: 4822
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4823:
  _id_: 4823
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4824:
  _id_: 4824
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4825:
  _id_: 4825
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4843:
  _id_: 4843
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Bright Flower
    ja: 光花
    ko: 광화
    zh_hant: 光芒之花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3544
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4844:
  _id_: 4844
  attribute_id: 1
  cost: 2
  icon_id: 59
  is_multiple_command_unique_skill: 0
  name:
    en: Scattered Flower
    ja: 散花
    ko: 산화
    zh_hant: 凋零之花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3545
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 59
    target_id: 2146
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4845:
  _id_: 4845
  attribute_id: 1
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Budding Flower
    ja: 芽吹花
    ko: 싹트는 꽃
    zh_hant: 萌芽之花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3546
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4846:
  _id_: 4846
  attribute_id: 1
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Daybreak Petals
    ja: 東雲の飛花
    ko: 새벽의 비화
    zh_hant: 東雲飛花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3547
  skill_field_effect_id: 37
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4848:
  _id_: 4848
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Life Sword
    ja: 生大刀
    ko: 생명의 대도
    zh_hant: 生大刀
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3549
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4849:
  _id_: 4849
  attribute_id: 5
  cost: 2
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Life Bow
    ja: 生弓矢
    ko: 생명의 궁시
    zh_hant: 生弓矢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3550
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 57
    target_id: 2146
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4850:
  _id_: 4850
  attribute_id: 5
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Life Koto
    ja: 沼琴
    ko: 하늘의 거문고
    zh_hant: 沼琴
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3551
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4851:
  _id_: 4851
  attribute_id: 5
  cost: 2
  icon_id: 1027
  is_multiple_command_unique_skill: 0
  name:
    en: Dawn of Compassion
    ja: 慈愛の曙
    ko: 자애의 새벽
    zh_hant: 慈愛曙光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3552
  skill_field_effect_id: 40
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4853:
  _id_: 4853
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Brilliance
    ja: キラめきのいちげき
    ko: 반짝임의 일격
    zh_hant: 光芒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3554
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4854:
  _id_: 4854
  attribute_id: 6
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Weakness
    ja: きゅうしょのいちげき
    ko: 급소의 일격
    zh_hant: 要害一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3555
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 394
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4855:
  _id_: 4855
  attribute_id: 6
  cost: 3
  icon_id: 220
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Strike
    ja: じゃくたいかのいちげき
    ko: 약체화의 일격
    zh_hant: 弱化一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3556
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 339
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 42
    - 44
    - 47
    - 50
4856:
  _id_: 4856
  attribute_id: 6
  cost: 2
  icon_id: 45
  is_multiple_command_unique_skill: 0
  name:
    en: Legendary Hero
    ja: 伝説の勇者
    ko: 전설의 용사
    zh_hant: 傳說的勇者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3557
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 241
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 5
    - 6
    - 7
    - 8
    - 10
4863:
  _id_: 4863
  attribute_id: 3
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3563
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4864:
  _id_: 4864
  attribute_id: 3
  cost: 2
  icon_id: 8
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Victory
    ja: 勝利への一閃
    ko: 승리를 향한 일섬
    zh_hant: 前往勝利的閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3564
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2041
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
4865:
  _id_: 4865
  attribute_id: 3
  cost: 3
  icon_id: 18
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Evasion
    ja: 回避の一閃
    ko: 회피의 일섬
    zh_hant: 迴避閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3565
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2041
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 18
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
4866:
  _id_: 4866
  attribute_id: 3
  cost: 2
  icon_id: 151
  is_multiple_command_unique_skill: 0
  name:
    en: Yellow Tornado
    ja: イエローファイントルネード
    ko: 옐로우 파인 토네이도
    zh_hant: 燦黃龍捲風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3566
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 151
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4868:
  _id_: 4868
  attribute_id: 1
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Smash
    ja: 浄化の打撃
    ko: 정화의 타격
    zh_hant: 淨化敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3568
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4869:
  _id_: 4869
  attribute_id: 1
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Smash
    ja: 弛緩の打撃
    ko: 이완의 타격
    zh_hant: 遲緩敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3569
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
4870:
  _id_: 4870
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Smash
    ja: 自由な打撃
    ko: 자유로운 타격
    zh_hant: 自由敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3570
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
4871:
  _id_: 4871
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: With love and courage, to Frontier!
    ja: 愛と勇気ですすめフロンティア！
    ko: 사랑과 용기로 나아가라 프론티어!
    zh_hant: 貫徹愛與勇氣　邁向嶄新邊疆！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3571
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4873:
  _id_: 4873
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4874:
  _id_: 4874
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4875:
  _id_: 4875
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4876:
  _id_: 4876
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4877:
  _id_: 4877
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
4878:
  _id_: 4878
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4879:
  _id_: 4879
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4880:
  _id_: 4880
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4881:
  _id_: 4881
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
4883:
  _id_: 4883
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4884:
  _id_: 4884
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4885:
  _id_: 4885
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4886:
  _id_: 4886
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4887:
  _id_: 4887
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4888:
  _id_: 4888
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4889:
  _id_: 4889
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4890:
  _id_: 4890
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4891:
  _id_: 4891
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4892:
  _id_: 4892
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4893:
  _id_: 4893
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4895:
  _id_: 4895
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3257
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4896:
  _id_: 4896
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4897:
  _id_: 4897
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4898:
  _id_: 4898
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4899:
  _id_: 4899
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4900:
  _id_: 4900
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3262
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4901:
  _id_: 4901
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4902:
  _id_: 4902
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4903:
  _id_: 4903
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
4905:
  _id_: 4905
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4906:
  _id_: 4906
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4907:
  _id_: 4907
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4908:
  _id_: 4908
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4909:
  _id_: 4909
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4910:
  _id_: 4910
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4911:
  _id_: 4911
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4912:
  _id_: 4912
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4913:
  _id_: 4913
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4914:
  _id_: 4914
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4915:
  _id_: 4915
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4917:
  _id_: 4917
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4918:
  _id_: 4918
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4919:
  _id_: 4919
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4920:
  _id_: 4920
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4921:
  _id_: 4921
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4922:
  _id_: 4922
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4923:
  _id_: 4923
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3300
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4924:
  _id_: 4924
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4925:
  _id_: 4925
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4926:
  _id_: 4926
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3303
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
4928:
  _id_: 4928
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4929:
  _id_: 4929
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4930:
  _id_: 4930
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4931:
  _id_: 4931
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4932:
  _id_: 4932
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4933:
  _id_: 4933
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4934:
  _id_: 4934
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4935:
  _id_: 4935
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4936:
  _id_: 4936
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4937:
  _id_: 4937
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4938:
  _id_: 4938
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4940:
  _id_: 4940
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4941:
  _id_: 4941
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4942:
  _id_: 4942
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4943:
  _id_: 4943
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4944:
  _id_: 4944
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4945:
  _id_: 4945
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3291
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4946:
  _id_: 4946
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4947:
  _id_: 4947
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3293
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4949:
  _id_: 4949
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4950:
  _id_: 4950
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4951:
  _id_: 4951
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4952:
  _id_: 4952
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4953:
  _id_: 4953
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4954:
  _id_: 4954
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4955:
  _id_: 4955
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3300
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4956:
  _id_: 4956
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
4957:
  _id_: 4957
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4958:
  _id_: 4958
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3303
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
4960:
  _id_: 4960
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4961:
  _id_: 4961
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
4962:
  _id_: 4962
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4963:
  _id_: 4963
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4964:
  _id_: 4964
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4965:
  _id_: 4965
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4966:
  _id_: 4966
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4967:
  _id_: 4967
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3311
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4968:
  _id_: 4968
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4969:
  _id_: 4969
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3313
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4971:
  _id_: 4971
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4972:
  _id_: 4972
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
4973:
  _id_: 4973
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
4974:
  _id_: 4974
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
4975:
  _id_: 4975
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
4976:
  _id_: 4976
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
4977:
  _id_: 4977
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4978:
  _id_: 4978
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4979:
  _id_: 4979
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
4980:
  _id_: 4980
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4981:
  _id_: 4981
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
4988:
  _id_: 4988
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3573
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2161
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4989:
  _id_: 4989
  attribute_id: 2
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Mei Houwang's Strike
    ja: 美猴王の一撃
    ko: 미후왕의 일격
    zh_hant: 美猴王的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3574
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2161
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 394
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4990:
  _id_: 4990
  attribute_id: 2
  cost: 3
  icon_id: 150
  is_multiple_command_unique_skill: 0
  name:
    en: Qitian Dasheng's Strike
    ja: 斉天大聖の一撃
    ko: 제천대성의 일격
    zh_hant: 齊天大聖的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3575
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2161
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 150
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
4991:
  _id_: 4991
  attribute_id: 2
  cost: 2
  icon_id: 32
  is_multiple_command_unique_skill: 0
  name:
    en: Ruyi Jingu Bang
    ja: 如意金箍棒
    ko: 여의금고봉
    zh_hant: 如意金箍棒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3576
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
4993:
  _id_: 4993
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3578
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2141
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
4994:
  _id_: 4994
  attribute_id: 6
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Divine Fire
    ja: 怪火
    ko: 괴화
    zh_hant: 怪火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3579
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2141
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 394
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
4995:
  _id_: 4995
  attribute_id: 6
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Fire of Light
    ja: 灯火
    ko: 등불
    zh_hant: 燈火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3580
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2141
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
4996:
  _id_: 4996
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flames of Birth
    ja: 炎の降誕祭
    ko: 불의 성탄제
    zh_hant: 炎之降生祭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3581
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
  - hit_rate: 100
    id: 302
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5008:
  _id_: 5008
  attribute_id: 5
  cost: 1
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Power Flash
    ja: 渾身の一閃
    ko: 혼신의 일섬
    zh_hant: 全力閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3591
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
5009:
  _id_: 5009
  attribute_id: 5
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Hopeful Flash
    ja: 希望の一閃
    ko: 희망의 일섬
    zh_hant: 希望閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3592
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5010:
  _id_: 5010
  attribute_id: 5
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Leap
    ja: キラめきの跳躍
    ko: 반짝임의 도약
    zh_hant: 光芒跳躍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3593
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
5011:
  _id_: 5011
  attribute_id: 5
  cost: 2
  icon_id: 229
  is_multiple_command_unique_skill: 0
  name:
    en: To You...a Beautiful End
    ja: 今君に 美しい最期を
    ko: 지금 너에게 아름다운 최후를
    zh_hant: 現在就讓妳迎接最美的結局
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3594
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 386
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5013:
  _id_: 5013
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3596
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2171
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5014:
  _id_: 5014
  attribute_id: 4
  cost: 2
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Sorrowful Tune
    ja: 悲哀の音色
    ko: 비애의 음색
    zh_hant: 悲哀的音色
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3597
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2171
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 57
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5015:
  _id_: 5015
  attribute_id: 4
  cost: 3
  icon_id: 20
  is_multiple_command_unique_skill: 0
  name:
    en: Tune of Encouragement
    ja: 激励の音色
    ko: 격려의 음색
    zh_hant: 激勵的音色
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3598
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2171
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5016:
  _id_: 5016
  attribute_id: 4
  cost: 2
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Orpheus's Melody
    ja: オルフェウスの調べ
    ko: 오르페우스의 멜로디
    zh_hant: 奧菲斯的旋律
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3599
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
  - hit_rate: 100
    id: 232
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5018:
  _id_: 5018
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3601
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5019:
  _id_: 5019
  attribute_id: 1
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Impact Drop
    ja: インパクトドロップ
    ko: 임팩트 드롭
    zh_hant: 強力墜擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3602
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 50
    id: 431
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5020:
  _id_: 5020
  attribute_id: 1
  cost: 3
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Bombardier Saijo Buster
    ja: 西條式ボンバルディエバスター
    ko: 사이조식 봄바디어 버스터
    zh_hant: 西條式炮擊炸彈摔
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3603
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5021:
  _id_: 5021
  attribute_id: 1
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Update Purge
    ja: 粛清のアップデート
    ko: 숙청의 업데이트
    zh_hant: 肅清的更新
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3604
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 75
    id: 431
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5025:
  _id_: 5025
  attribute_id: 3
  cost: 1
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Collect Clutch
    ja: コレクトクラッチ
    ko: 컬렉트 클러치
    zh_hant: 珍藏式固定技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5026:
  _id_: 5026
  attribute_id: 3
  cost: 2
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Light Hold
    ja: ライトホールド
    ko: 라이트 홀드
    zh_hant: 正義鎖定技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 32
    - 35
    - 40
    - 50
5027:
  _id_: 5027
  attribute_id: 3
  cost: 3
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Heavy Sleeper
    ja: ヘビースリーパー
    ko: 헤비 슬리퍼
    zh_hant: 沉重鎖喉技
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5028:
  _id_: 5028
  attribute_id: 3
  cost: 2
  icon_id: 32
  is_multiple_command_unique_skill: 0
  name:
    en: BLOODY TEA TIME
    ja: BLOODY TEA TIME
    ko: BLOODY TEA TIME
    zh_hant: BLOODY TEA TIME
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 150
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
5030:
  _id_: 5030
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5031:
  _id_: 5031
  attribute_id: 4
  cost: 2
  icon_id: 227
  is_multiple_command_unique_skill: 0
  name:
    en: Incantation
    ja: 呪術
    ko: 주술
    zh_hant: 咒術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 75
    id: 354
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 7500
    - 7500
    - 7500
    - 7500
    - 7500
  - hit_rate: 75
    id: 298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5032:
  _id_: 5032
  attribute_id: 4
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Divination
    ja: 占術
    ko: 점술
    zh_hant: 占卜術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 15
    - 20
    - 25
    - 30
5033:
  _id_: 5033
  attribute_id: 4
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Shikigami
    ja: 清めの式神
    ko: 정화의 식신
    zh_hant: 淨化的式神
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
  - hit_rate: 100
    id: 156
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 35
    target_id: 1135
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 359
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
5035:
  _id_: 5035
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Brilliance
    ja: キラめきの一撃
    ko: 반짝임의 일격
    zh_hant: 光芒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5036:
  _id_: 5036
  attribute_id: 1
  cost: 2
  icon_id: 1024
  is_multiple_command_unique_skill: 0
  name:
    en: Mischief
    ja: 悪ふざけ
    ko: 못된 장난
    zh_hant: 整人
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3617
  skill_field_effect_id: 41
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5037:
  _id_: 5037
  attribute_id: 1
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Prank
    ja: イタズラ
    ko: 장난
    zh_hant: 惡作劇
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5038:
  _id_: 5038
  attribute_id: 1
  cost: 2
  icon_id: 178
  is_multiple_command_unique_skill: 0
  name:
    en: Trickster
    ja: Trickster
    ko: Trickster
    zh_hant: 搗蛋鬼
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 349
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 435
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5040:
  _id_: 5040
  attribute_id: 5
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Strike
    ja: 浄化の一撃
    ko: 정화의 일격
    zh_hant: 浄化一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3621
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5041:
  _id_: 5041
  attribute_id: 5
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Strike
    ja: 弛緩の一撃
    ko: 이완의 일격
    zh_hant: 遲緩一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3622
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5042:
  _id_: 5042
  attribute_id: 5
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Strike
    ja: 自由な一撃
    ko: 자유로운 일격
    zh_hant: 自由一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3623
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5043:
  _id_: 5043
  attribute_id: 5
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: I will put my life on the line!
    ja: 命かけたる正念場いざご覧あれ！
    ko: 생을 건 중대한 장면 자 보아라!
    zh_hant: 賭上性命的危機一刻，敬請觀賞！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3624
  skill_field_effect_id: 42
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5045:
  _id_: 5045
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5046:
  _id_: 5046
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5047:
  _id_: 5047
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5048:
  _id_: 5048
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5049:
  _id_: 5049
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5050:
  _id_: 5050
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5051:
  _id_: 5051
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5052:
  _id_: 5052
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5054:
  _id_: 5054
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5055:
  _id_: 5055
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5056:
  _id_: 5056
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5057:
  _id_: 5057
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5058:
  _id_: 5058
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5059:
  _id_: 5059
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5060:
  _id_: 5060
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5061:
  _id_: 5061
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5062:
  _id_: 5062
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5064:
  _id_: 5064
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5065:
  _id_: 5065
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5066:
  _id_: 5066
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5067:
  _id_: 5067
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5068:
  _id_: 5068
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5069:
  _id_: 5069
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5070:
  _id_: 5070
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5071:
  _id_: 5071
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5072:
  _id_: 5072
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5074:
  _id_: 5074
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2492
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5075:
  _id_: 5075
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2493
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5076:
  _id_: 5076
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2494
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5077:
  _id_: 5077
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2495
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5078:
  _id_: 5078
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2496
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5079:
  _id_: 5079
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2497
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5080:
  _id_: 5080
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2498
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5081:
  _id_: 5081
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2499
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5082:
  _id_: 5082
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Constraint Concerto
    ja: 抑制の協奏曲
    ko: 억제의 협주곡
    zh_hant: 抑制協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2500
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5083:
  _id_: 5083
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Stay Away! NEO
    ja: こっちにこないで！ NEO
    ko: 가까이 오지 마! NEO
    zh_hant: 不要過來！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2501
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5085:
  _id_: 5085
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2502
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5086:
  _id_: 5086
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2503
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5087:
  _id_: 5087
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2504
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5088:
  _id_: 5088
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2505
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5089:
  _id_: 5089
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5090:
  _id_: 5090
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5091:
  _id_: 5091
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2508
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5092:
  _id_: 5092
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5093:
  _id_: 5093
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5094:
  _id_: 5094
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2510
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5096:
  _id_: 5096
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2511
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5097:
  _id_: 5097
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2512
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5098:
  _id_: 5098
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2513
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5099:
  _id_: 5099
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2514
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5100:
  _id_: 5100
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2515
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5101:
  _id_: 5101
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Tri-Slash
    ja: 必中の参連撃
    ko: 백발백중의 삼연격
    zh_hant: 必中參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2516
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5102:
  _id_: 5102
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2517
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5103:
  _id_: 5103
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzling Concerto
    ja: 眩惑の協奏曲
    ko: 현혹의 협주곡
    zh_hant: 眩目協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2518
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5104:
  _id_: 5104
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Tri-Slash
    ja: 必中の参連撃
    ko: 백발백중의 삼연격
    zh_hant: 必中參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2516
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5105:
  _id_: 5105
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fuoco! NEO
    ja: Fuoco! NEO
    ko: Fuoco! NEO
    zh_hant: Fuoco！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2519
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 17
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5107:
  _id_: 5107
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5108:
  _id_: 5108
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5109:
  _id_: 5109
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5110:
  _id_: 5110
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5111:
  _id_: 5111
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5112:
  _id_: 5112
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5113:
  _id_: 5113
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5114:
  _id_: 5114
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5115:
  _id_: 5115
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5140:
  _id_: 5140
  attribute_id: 3
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Brilliance
    ja: キラめきの一撃
    ko: 반짝임의 일격
    zh_hant: 光芒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3634
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5141:
  _id_: 5141
  attribute_id: 3
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Protection Strike
    ja: 圧力の一撃
    ko: 압력의 일격
    zh_hant: 壓力一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3635
  skill_field_effect_id: 43
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5142:
  _id_: 5142
  attribute_id: 3
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Light Arrow
    ja: 光の矢
    ko: 빛의 화살
    zh_hant: 光之箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3636
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5143:
  _id_: 5143
  attribute_id: 3
  cost: 2
  icon_id: 1028
  is_multiple_command_unique_skill: 1
  name:
    en: Try and kill me, Nana Daiba
    ja: 殺してみせろよ 大場なな
    ko: 어디 한번 죽여봐 다이바 나나
    zh_hant: 來殺我啊，大場奈奈！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3637
  skill_field_effect_id: 44
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5145:
  _id_: 5145
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3639
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5146:
  _id_: 5146
  attribute_id: 5
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Flash
    ja: 浄化の一閃
    ko: 정화의 일섬
    zh_hant: 淨化閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3640
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5147:
  _id_: 5147
  attribute_id: 5
  cost: 3
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Merchant's Wallet
    ja: 商人の財布
    ko: 상인의 지갑
    zh_hant: 商人的錢包
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 61
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5148:
  _id_: 5148
  attribute_id: 5
  cost: 2
  icon_id: 30
  is_multiple_command_unique_skill: 0
  name:
    en: Trade Secrets
    ja: 商いの極意
    ko: 장사의 비법
    zh_hant: 商人的秘訣
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 436
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 300000
    - 350000
    - 400000
    - 450000
    - 500000
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5155:
  _id_: 5155
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5156:
  _id_: 5156
  attribute_id: 4
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Seeker of Truth
    ja: 真理を解く者
    ko: 진리를 말하는 자
    zh_hant: 揭開真理者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5157:
  _id_: 5157
  attribute_id: 4
  cost: 3
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Beacon of the Abyss
    ja: 深淵を照らす者
    ko: 심연을 비추는 자
    zh_hant: 照耀深淵者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 5
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 61
    target_id: 2121
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5158:
  _id_: 5158
  attribute_id: 4
  cost: 2
  icon_id: 247
  is_multiple_command_unique_skill: 0
  name:
    en: Runic Principles
    ja: ルーンの理
    ko: 룬의 이치
    zh_hant: 盧恩字母的法則
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 439
    target_id: 1142
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 440
    target_id: 1142
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 441
    target_id: 1142
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5160:
  _id_: 5160
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5161:
  _id_: 5161
  attribute_id: 2
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Delicious Apple
    ja: おいしい林檎
    ko: 맛있는 사과
    zh_hant: 美味的蘋果
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3650
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 361
    target_id: 2141
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5162:
  _id_: 5162
  attribute_id: 2
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Wonderful Dream
    ja: 素敵な夢
    ko: 멋진 꿈
    zh_hant: 美妙的夢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3651
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 361
    target_id: 2141
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 156
    - 163
    - 171
    - 178
    - 187
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
5163:
  _id_: 5163
  attribute_id: 2
  cost: 2
  icon_id: 248
  is_multiple_command_unique_skill: 0
  name:
    en: Shackles of Poison
    ja: 毒林檎の枷
    ko: 독사과의 족쇄
    zh_hant: 毒蘋果的枷鎖
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3652
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
  - hit_rate: 100
    id: 302
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 443
    target_id: 4073
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5165:
  _id_: 5165
  attribute_id: 3
  cost: 1
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Questioning
    ja: 職務質問
    ko: 불심검문
    zh_hant: 進行盤問
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3654
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
5166:
  _id_: 5166
  attribute_id: 3
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: All-Points Bulletin
    ja: 緊急配備
    ko: 긴급 배치
    zh_hant: 緊急調派
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3655
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5167:
  _id_: 5167
  attribute_id: 3
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: On-Site Express
    ja: 現場急行
    ko: 현장 급행
    zh_hant: 馳赴現場
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5168:
  _id_: 5168
  attribute_id: 3
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Officer Akikaze's Emergency Arrest
    ja: 秋風巡査の緊急逮捕劇
    ko: 아키카제 순경의 긴급 체포극
    zh_hant: 秋風警員的緊急追捕劇
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
5170:
  _id_: 5170
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 88
    - 92
    - 96
    - 101
    - 105
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5171:
  _id_: 5171
  attribute_id: 5
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Loyal Subject
    ja: 忠実なるしもべ
    ko: 충실한 심복
    zh_hant: 忠誠的僕人
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5172:
  _id_: 5172
  attribute_id: 5
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Devour
    ja: 喰らい尽くす
    ko: 먹어치우기
    zh_hant: 啃食殆盡
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5173:
  _id_: 5173
  attribute_id: 5
  cost: 2
  icon_id: 1023
  is_multiple_command_unique_skill: 0
  name:
    en: Infernal Gnawing
    ja: 冥獣の噛砕
    ko: 저승 맹수의 깨물어부수기
    zh_hant: 冥獸的撕咬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3662
  skill_field_effect_id: 45
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1143
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1143
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 300
    - 325
    - 350
    - 375
    - 400
5175:
  _id_: 5175
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Reaching Out
    ja: 寄り添う心
    ko: 다가서는 마음
    zh_hant: 關愛之心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5176:
  _id_: 5176
  attribute_id: 2
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sense of Justice
    ja: 強い正義感
    ko: 강한 정의감
    zh_hant: 強烈的正義感
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2146
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5177:
  _id_: 5177
  attribute_id: 2
  cost: 3
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Healthy Body
    ja: 健康な体
    ko: 건강한 몸
    zh_hant: 健康的身體
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2146
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5178:
  _id_: 5178
  attribute_id: 2
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Officer Aijo's Traffic Safety
    ja: 愛城巡査の交通安全指導
    ko: 아이조 순경의 교통안전 교육
    zh_hant: 愛城警員的交通安全指導
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 84
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5180:
  _id_: 5180
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3069
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5181:
  _id_: 5181
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3070
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5182:
  _id_: 5182
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3071
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5183:
  _id_: 5183
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3072
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5184:
  _id_: 5184
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3073
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
5185:
  _id_: 5185
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3074
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5186:
  _id_: 5186
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3075
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
5187:
  _id_: 5187
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3076
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5188:
  _id_: 5188
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3077
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5190:
  _id_: 5190
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3105
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5191:
  _id_: 5191
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3106
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5192:
  _id_: 5192
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3107
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5193:
  _id_: 5193
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3108
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5194:
  _id_: 5194
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3109
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5195:
  _id_: 5195
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3110
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5196:
  _id_: 5196
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3111
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5197:
  _id_: 5197
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3112
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5198:
  _id_: 5198
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3113
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5199:
  _id_: 5199
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3114
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5200:
  _id_: 5200
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3115
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5202:
  _id_: 5202
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5203:
  _id_: 5203
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5204:
  _id_: 5204
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5205:
  _id_: 5205
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5206:
  _id_: 5206
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5207:
  _id_: 5207
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5208:
  _id_: 5208
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5209:
  _id_: 5209
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5210:
  _id_: 5210
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5212:
  _id_: 5212
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5213:
  _id_: 5213
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5214:
  _id_: 5214
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5215:
  _id_: 5215
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5216:
  _id_: 5216
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5217:
  _id_: 5217
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5218:
  _id_: 5218
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5219:
  _id_: 5219
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5220:
  _id_: 5220
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5221:
  _id_: 5221
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5223:
  _id_: 5223
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5224:
  _id_: 5224
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
5225:
  _id_: 5225
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5226:
  _id_: 5226
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5227:
  _id_: 5227
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5228:
  _id_: 5228
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5229:
  _id_: 5229
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5230:
  _id_: 5230
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5231:
  _id_: 5231
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5232:
  _id_: 5232
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5233:
  _id_: 5233
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5235:
  _id_: 5235
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5236:
  _id_: 5236
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5237:
  _id_: 5237
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5238:
  _id_: 5238
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5239:
  _id_: 5239
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5240:
  _id_: 5240
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5241:
  _id_: 5241
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5242:
  _id_: 5242
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5243:
  _id_: 5243
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5244:
  _id_: 5244
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5245:
  _id_: 5245
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5247:
  _id_: 5247
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3137
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5248:
  _id_: 5248
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3138
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5249:
  _id_: 5249
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3139
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5250:
  _id_: 5250
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3140
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5251:
  _id_: 5251
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3141
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5252:
  _id_: 5252
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3142
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5253:
  _id_: 5253
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3143
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5254:
  _id_: 5254
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3144
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5255:
  _id_: 5255
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Midnight NEO
    ja: ブラッディ・ミッドナイト NEO
    ko: 블러디 미드나이트 NEO
    zh_hant: 血腥午夜 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3145
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5257:
  _id_: 5257
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5258:
  _id_: 5258
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5259:
  _id_: 5259
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5260:
  _id_: 5260
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5261:
  _id_: 5261
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5262:
  _id_: 5262
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5263:
  _id_: 5263
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5264:
  _id_: 5264
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5265:
  _id_: 5265
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5267:
  _id_: 5267
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3155
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5268:
  _id_: 5268
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3156
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5269:
  _id_: 5269
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3157
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5270:
  _id_: 5270
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3158
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5271:
  _id_: 5271
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3159
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5272:
  _id_: 5272
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry Dance
    ja: 連撃の舞
    ko: 연격의 춤
    zh_hant: 連擊之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3160
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5273:
  _id_: 5273
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3161
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5274:
  _id_: 5274
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3162
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5275:
  _id_: 5275
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3163
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5276:
  _id_: 5276
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cross of Retribution NEO
    ja: 聖罰の十字架 NEO
    ko: 성벌의 십자가 NEO
    zh_hant: 聖罰十字架 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3164
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5278:
  _id_: 5278
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5279:
  _id_: 5279
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5280:
  _id_: 5280
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5281:
  _id_: 5281
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5282:
  _id_: 5282
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5283:
  _id_: 5283
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5284:
  _id_: 5284
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5285:
  _id_: 5285
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5286:
  _id_: 5286
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5287:
  _id_: 5287
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5288:
  _id_: 5288
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5290:
  _id_: 5290
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3669
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5291:
  _id_: 5291
  attribute_id: 4
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunderous Slash
    ja: 轟雷の斬撃
    ko: 굉뢰의 참격
    zh_hant: 轟雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3670
  skill_field_effect_id: 46
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5292:
  _id_: 5292
  attribute_id: 4
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Genius Conduct
    ja: 天才の振る舞い
    ko: 천재의 행동
    zh_hant: 天才的舉止
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3671
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5293:
  _id_: 5293
  attribute_id: 4
  cost: 2
  icon_id: 1029
  is_multiple_command_unique_skill: 1
  name:
    en: Watch Me from Hell. I'm the Star
    ja: 奈落で見上げろ 私がスタァだ
    ko: 나락에서 올려다봐라 내가 스타다
    zh_hant: 在地獄抬頭望吧，我才是STAR！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3672
  skill_field_effect_id: 47
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5295:
  _id_: 5295
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3674
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5296:
  _id_: 5296
  attribute_id: 2
  cost: 2
  icon_id: 1019
  is_multiple_command_unique_skill: 0
  name:
    en: Hope Smash
    ja: 希望の打撃
    ko: 희망의 타격
    zh_hant: 希望敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3675
  skill_field_effect_id: 48
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5297:
  _id_: 5297
  attribute_id: 2
  cost: 3
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Faint Smash
    ja: 昏倒の打撃
    ko: 혼절의 타격
    zh_hant: 昏倒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3676
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 57
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5298:
  _id_: 5298
  attribute_id: 7
  cost: 2
  icon_id: 248
  is_multiple_command_unique_skill: 0
  name:
    en: Quintet Prominence Breaker
    ja: クインテット・プロミネンスブレイカー
    ko: 퀸텟 프로미넌스 브레이커
    zh_hant: 五重奏・熾焰日珥粉碎擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3677
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 308
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
  - hit_rate: 100
    id: 442
    target_id: 2031
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5300:
  _id_: 5300
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Thrust
    ja: 浄化の刺突
    ko: 정화의 찌르기
    zh_hant: 淨化突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3679
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5301:
  _id_: 5301
  attribute_id: 4
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Thrust
    ja: 弛緩の刺突
    ko: 이완의 찌르기
    zh_hant: 遲緩突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3680
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5302:
  _id_: 5302
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Severe Thrust
    ja: 厳格なる刺突
    ko: 엄격한 찌르기
    zh_hant: 嚴厲突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3681
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5303:
  _id_: 5303
  attribute_id: 4
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: The King Shines His Light on the Hollow Stage!
    ja: 神無き舞台に王者の光を！
    ko: 신이 없는 무대에 왕의 빛을!
    zh_hant: 在無主舞台上，降下王者之光！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3682
  skill_field_effect_id: 49
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5305:
  _id_: 5305
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3684
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5306:
  _id_: 5306
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Cake Rooftop
    ja: ケーキの屋根
    ko: 케이크 지붕
    zh_hant: 蛋糕屋頂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3685
  skill_field_effect_id: 50
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5307:
  _id_: 5307
  attribute_id: 2
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Bread Window
    ja: パンの窓
    ko: 빵 창문
    zh_hant: 麵包窗戶
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3686
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5308:
  _id_: 5308
  attribute_id: 2
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Helping Gretel
    ja: グレーテルのお手伝い
    ko: 그레텔의 도움
    zh_hant: 小幫手葛麗特
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3687
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5310:
  _id_: 5310
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting
    ja: 狙撃
    ko: 저격
    zh_hant: 狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5311:
  _id_: 5311
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5312:
  _id_: 5312
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5313:
  _id_: 5313
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5314:
  _id_: 5314
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2610
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5315:
  _id_: 5315
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5316:
  _id_: 5316
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Rondo
    ja: 闇炎の輪舞曲
    ko: 암흑 불꽃의 윤무곡
    zh_hant: 暗炎圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5317:
  _id_: 5317
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5319:
  _id_: 5319
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5320:
  _id_: 5320
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5321:
  _id_: 5321
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2643
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5322:
  _id_: 5322
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5323:
  _id_: 5323
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5324:
  _id_: 5324
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5325:
  _id_: 5325
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5326:
  _id_: 5326
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2648
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5327:
  _id_: 5327
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5329:
  _id_: 5329
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5330:
  _id_: 5330
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5331:
  _id_: 5331
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5332:
  _id_: 5332
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5333:
  _id_: 5333
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5334:
  _id_: 5334
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5335:
  _id_: 5335
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2684
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5336:
  _id_: 5336
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2685
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5338:
  _id_: 5338
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5339:
  _id_: 5339
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5340:
  _id_: 5340
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5341:
  _id_: 5341
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5342:
  _id_: 5342
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5343:
  _id_: 5343
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5344:
  _id_: 5344
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5345:
  _id_: 5345
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2676
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5346:
  _id_: 5346
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2677
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5348:
  _id_: 5348
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5349:
  _id_: 5349
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5350:
  _id_: 5350
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5351:
  _id_: 5351
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5352:
  _id_: 5352
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5353:
  _id_: 5353
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5354:
  _id_: 5354
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2684
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5355:
  _id_: 5355
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2685
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5357:
  _id_: 5357
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5358:
  _id_: 5358
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5359:
  _id_: 5359
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5360:
  _id_: 5360
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5361:
  _id_: 5361
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5362:
  _id_: 5362
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5363:
  _id_: 5363
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5364:
  _id_: 5364
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5365:
  _id_: 5365
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2694
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5366:
  _id_: 5366
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2695
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5373:
  _id_: 5373
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Skilled Qigong
    ja: 練気功
    ko: 연기공
    zh_hant: 練氣功
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3689
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5374:
  _id_: 5374
  attribute_id: 6
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Point
    ja: 点穴
    ko: 점혈
    zh_hant: 點穴
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3690
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
5375:
  _id_: 5375
  attribute_id: 6
  cost: 3
  icon_id: 235
  is_multiple_command_unique_skill: 0
  name:
    en: Fa Jin
    ja: 発勁
    ko: 발경
    zh_hant: 發勁
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3691
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 382
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5376:
  _id_: 5376
  attribute_id: 7
  cost: 2
  icon_id: 248
  is_multiple_command_unique_skill: 0
  name:
    en: Blazedance Finisher
    ja: 焔舞殺法
    ko: 화무살법
    zh_hant: 焰舞殺法
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3692
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 306
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 442
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5378:
  _id_: 5378
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3694
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5379:
  _id_: 5379
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Cake Rooftop
    ja: ケーキの屋根
    ko: 케이크 지붕
    zh_hant: 蛋糕屋頂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3695
  skill_field_effect_id: 51
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5380:
  _id_: 5380
  attribute_id: 6
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Chocolate Chair
    ja: チョコレートの椅子
    ko: 초콜릿 의자
    zh_hant: 巧克力椅子
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
5381:
  _id_: 5381
  attribute_id: 6
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Temptation
    ja: お菓子な誘惑
    ko: 과자의 유혹
    zh_hant: 零食的誘惑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 449
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5383:
  _id_: 5383
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5384:
  _id_: 5384
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Cotton Candy Blanket
    ja: コットンキャンディーの毛布
    ko: 코튼캔디로 만든 담요
    zh_hant: 棉花糖毛毯
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3700
  skill_field_effect_id: 52
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5385:
  _id_: 5385
  attribute_id: 1
  cost: 3
  icon_id: 61
  is_multiple_command_unique_skill: 0
  name:
    en: Ice Cream Desk
    ja: アイスクリームの机
    ko: 아이스크림으로 만든 책상
    zh_hant: 冰淇淋書桌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 61
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5386:
  _id_: 5386
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Hansel's Wit
    ja: ヘンゼルの知恵
    ko: 헨젤의 지혜
    zh_hant: 漢賽爾的智慧
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3702
  skill_field_effect_id: 53
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
5388:
  _id_: 5388
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5389:
  _id_: 5389
  attribute_id: 2
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Megingjord
    ja: メギンギョルズ
    ko: 메긴기요르드
    zh_hant: 梅金吉奧德
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3705
  skill_field_effect_id: 54
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5390:
  _id_: 5390
  attribute_id: 2
  cost: 3
  icon_id: 114
  is_multiple_command_unique_skill: 0
  name:
    en: Jarngreipr
    ja: ヤールングレイプル
    ko: 야른그레이프르
    zh_hant: 雅恩格利佩爾
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3706
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 126
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
5391:
  _id_: 5391
  attribute_id: 2
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Mjolnir
    ja: 雷鳴のミョルニル
    ko: 천둥의 묠니르
    zh_hant: 雷鳴的妙爾尼爾
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3707
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 156
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5393:
  _id_: 5393
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3709
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5394:
  _id_: 5394
  attribute_id: 2
  cost: 2
  icon_id: 252
  is_multiple_command_unique_skill: 0
  name:
    en: Soul Lacking
    ja: 魂の欠落
    ko: 영혼의 결핍
    zh_hant: 缺乏靈魂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3710
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 453
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5395:
  _id_: 5395
  attribute_id: 2
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Talent
    ja: 輝く才能
    ko: 반짝이는 재능
    zh_hant: 輝煌才能
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3711
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5396:
  _id_: 5396
  attribute_id: 2
  cost: 2
  icon_id: 1031
  is_multiple_command_unique_skill: 0
  name:
    en: I will defeat you with my brilliance
    ja: 今宵 キラめきで あんたを
    ko: 오늘밤 반짝임으로 당신을
    zh_hant: 今晚以閃耀將妳——
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3712
  skill_field_effect_id: 55
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5398:
  _id_: 5398
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3714
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5399:
  _id_: 5399
  attribute_id: 5
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Enchanting Pride
    ja: エンチャントプライド
    ko: 인챈트 프라이드
    zh_hant: 傲慢附魔
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3715
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5400:
  _id_: 5400
  attribute_id: 5
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Gravity Field
    ja: グラビティフィールド
    ko: 그래비티 필드
    zh_hant: 重力領域
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3716
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5401:
  _id_: 5401
  attribute_id: 5
  cost: 2
  icon_id: 31
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Darkness
    ja: Flash of darkness
    ko: Flash of darkness
    zh_hant: Flash of darkness
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3717
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 437
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 300000
    - 350000
    - 400000
    - 450000
    - 500000
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5408:
  _id_: 5408
  attribute_id: 2
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Flash
    ja: 浄化の一閃
    ko: 정화의 일섬
    zh_hant: 淨化閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3719
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 80
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5409:
  _id_: 5409
  attribute_id: 2
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Relaxing Flash
    ja: 弛緩の一閃
    ko: 이완의 일섬
    zh_hant: 遲緩閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3720
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 11
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2021
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10
    - 12
    - 14
    - 17
    - 20
  - hit_rate: 100
    id: 81
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5410:
  _id_: 5410
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Accelerating Flash
    ja: 加速する一閃
    ko: 가속하는 일섬
    zh_hant: 加速閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3721
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5411:
  _id_: 5411
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Hearts aflutter, to Frontier!
    ja: 胸ときめかせてすすめフロンティア！
    ko: 가슴 설레며 나아가라 프론티어!
    zh_hant: 胸懷怦然心動，攜手前進邊疆！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3722
  skill_field_effect_id: 56
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5428:
  _id_: 5428
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Attack
    ja: キラめきのアタック
    ko: 반짝임의 어택
    zh_hant: 光芒之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3732
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5429:
  _id_: 5429
  attribute_id: 4
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Courageous Attack
    ja: 勇気のアタック
    ko: 용기의 어택
    zh_hant: 勇氣之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3733
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 444
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5430:
  _id_: 5430
  attribute_id: 4
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Attack
    ja: 鼓舞するアタック
    ko: 고무의 어택
    zh_hant: 鼓舞之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3734
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 22
    - 24
    - 26
    - 30
5431:
  _id_: 5431
  attribute_id: 4
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Boisterous Attack
    ja: 乱舞アタック
    ko: 난무 어택
    zh_hant: 亂舞之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3735
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
5433:
  _id_: 5433
  attribute_id: 1
  cost: 1
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Intense Attack
    ja: 強烈なアタック
    ko: 강렬한 어택
    zh_hant: 強烈之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3737
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 147
    - 154
    - 161
    - 168
    - 176
5434:
  _id_: 5434
  attribute_id: 1
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Hopeful Attack
    ja: 希望のアタック
    ko: 희망의 어택
    zh_hant: 希望之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3738
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5435:
  _id_: 5435
  attribute_id: 1
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Oppressive Attack
    ja: 重圧のアタック
    ko: 중압의 어택
    zh_hant: 重壓之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3739
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5436:
  _id_: 5436
  attribute_id: 1
  cost: 2
  icon_id: 252
  is_multiple_command_unique_skill: 0
  name:
    en: Passionate Attack
    ja: 情熱アタック
    ko: 열정의 어택
    zh_hant: 熱情之擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3740
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 453
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 224
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 62
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 300
    - 325
    - 350
    - 375
    - 400
  - hit_rate: 100
    id: 349
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5438:
  _id_: 5438
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5439:
  _id_: 5439
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5440:
  _id_: 5440
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2834
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5441:
  _id_: 5441
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5442:
  _id_: 5442
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5443:
  _id_: 5443
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5444:
  _id_: 5444
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5445:
  _id_: 5445
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2839
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5447:
  _id_: 5447
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5448:
  _id_: 5448
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Sharpshooting
    ja: 双狙撃
    ko: 쌍저격
    zh_hant: 雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2866
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5449:
  _id_: 5449
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Sharpshooting
    ja: 強襲の双狙撃
    ko: 강습의 쌍저격
    zh_hant: 強襲雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5450:
  _id_: 5450
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5451:
  _id_: 5451
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5452:
  _id_: 5452
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5453:
  _id_: 5453
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2871
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5454:
  _id_: 5454
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5455:
  _id_: 5455
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5457:
  _id_: 5457
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5458:
  _id_: 5458
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5459:
  _id_: 5459
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5460:
  _id_: 5460
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5461:
  _id_: 5461
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5462:
  _id_: 5462
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5463:
  _id_: 5463
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2908
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5464:
  _id_: 5464
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2909
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5466:
  _id_: 5466
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5467:
  _id_: 5467
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5468:
  _id_: 5468
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5469:
  _id_: 5469
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5470:
  _id_: 5470
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5471:
  _id_: 5471
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5472:
  _id_: 5472
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2908
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5473:
  _id_: 5473
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2909
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5475:
  _id_: 5475
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5476:
  _id_: 5476
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5477:
  _id_: 5477
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5478:
  _id_: 5478
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5479:
  _id_: 5479
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5480:
  _id_: 5480
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5481:
  _id_: 5481
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5482:
  _id_: 5482
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5483:
  _id_: 5483
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5484:
  _id_: 5484
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5485:
  _id_: 5485
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5487:
  _id_: 5487
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5488:
  _id_: 5488
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5489:
  _id_: 5489
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5490:
  _id_: 5490
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5491:
  _id_: 5491
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5492:
  _id_: 5492
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5493:
  _id_: 5493
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5494:
  _id_: 5494
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5495:
  _id_: 5495
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5496:
  _id_: 5496
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5497:
  _id_: 5497
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5499:
  _id_: 5499
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5500:
  _id_: 5500
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5501:
  _id_: 5501
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5502:
  _id_: 5502
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5503:
  _id_: 5503
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5504:
  _id_: 5504
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5505:
  _id_: 5505
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5506:
  _id_: 5506
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5507:
  _id_: 5507
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5508:
  _id_: 5508
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5509:
  _id_: 5509
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5511:
  _id_: 5511
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5512:
  _id_: 5512
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5513:
  _id_: 5513
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5514:
  _id_: 5514
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5515:
  _id_: 5515
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5516:
  _id_: 5516
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5517:
  _id_: 5517
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5518:
  _id_: 5518
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5519:
  _id_: 5519
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5520:
  _id_: 5520
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5521:
  _id_: 5521
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5523:
  _id_: 5523
  attribute_id: 7
  cost: 1
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Power Sharpshooting
    ja: 渾身の狙撃
    ko: 혼신의 저격
    zh_hant: 全力狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3742
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
5524:
  _id_: 5524
  attribute_id: 7
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Sharpshooting
    ja: 浄化の狙撃
    ko: 정화의 저격
    zh_hant: 淨化狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3743
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5525:
  _id_: 5525
  attribute_id: 7
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Carefree Sharpshooting
    ja: 自由な狙撃
    ko: 자유로운 저격
    zh_hant: 自由狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3744
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5526:
  _id_: 5526
  attribute_id: 7
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Rising White Blaster
    ja: ライジングホワイトブラスター
    ko: 라이징 화이트 블래스터
    zh_hant: 冉升純白衝擊波
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3745
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 156
    target_id: 1135
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 61
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5528:
  _id_: 5528
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3747
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5529:
  _id_: 5529
  attribute_id: 6
  cost: 2
  icon_id: 36
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Fortitude
    ja: 不屈の一閃
    ko: 불굴의 일섬
    zh_hant: 不屈閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3748
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 36
    target_id: 1141
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5530:
  _id_: 5530
  attribute_id: 6
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Blooming Blood
    ja: 花咲く血潮
    ko: 꽃피는 핏줄기
    zh_hant: 如花盛開的熱情
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3749
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5531:
  _id_: 5531
  attribute_id: 6
  cost: 2
  icon_id: 1032
  is_multiple_command_unique_skill: 1
  name:
    en: This Road Is Where We Part
    ja: ここが別れの一本道
    ko: 이곳이 이별의 외길
    zh_hant: 此處即為離別的一人道
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3750
  skill_field_effect_id: 57
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 36
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5533:
  _id_: 5533
  attribute_id: 2
  cost: 1
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Power Strike
    ja: 渾身の一撃
    ko: 혼신의 일격
    zh_hant: 全力一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3752
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 129
    - 136
    - 141
    - 148
    - 155
5534:
  _id_: 5534
  attribute_id: 2
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Strike
    ja: 浄化の一撃
    ko: 정화의 일격
    zh_hant: 浄化一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3753
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5535:
  _id_: 5535
  attribute_id: 2
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Promise with the Stars
    ja: 万象との約束
    ko: 만물과의 약속
    zh_hant: 與萬象的約定
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3754
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5536:
  _id_: 5536
  attribute_id: 2
  cost: 2
  icon_id: 247
  is_multiple_command_unique_skill: 0
  name:
    en: Light of Compassion
    ja: 慈愛の光
    ko: 자애의 빛
    zh_hant: 慈愛光輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3755
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 439
    target_id: 1001
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 440
    target_id: 1001
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 441
    target_id: 1001
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 240
    - 260
    - 280
    - 300
5538:
  _id_: 5538
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Brilliance
    ja: キラめきの一撃
    ko: 반짝임의 일격
    zh_hant: 光芒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3757
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5539:
  _id_: 5539
  attribute_id: 1
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Strength of Awaiting
    ja: 待つ者の強さ
    ko: 기다리는 자의 강함
    zh_hant: 等待者的堅強
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3758
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 4002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 444
    target_id: 4002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5540:
  _id_: 5540
  attribute_id: 1
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Power to Believe
    ja: 信じる力
    ko: 믿는 힘
    zh_hant: 信仰之力
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3759
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 4002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 4002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 4002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5541:
  _id_: 5541
  attribute_id: 1
  cost: 2
  icon_id: 265
  is_multiple_command_unique_skill: 0
  name:
    en: Empty Prayer
    ja: 空虚な祈り
    ko: 공허한 기도
    zh_hant: 空虛的祈禱
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3760
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5547:
  _id_: 5547
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3767
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5548:
  _id_: 5548
  attribute_id: 5
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Honest
    ja: 実直
    ko: 정직함
    zh_hant: 誠實
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3768
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 4012
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 444
    target_id: 4012
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5549:
  _id_: 5549
  attribute_id: 5
  cost: 3
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Earnest
    ja: 真面目
    ko: 성실함
    zh_hant: 正經
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3769
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5550:
  _id_: 5550
  attribute_id: 5
  cost: 2
  icon_id: 228
  is_multiple_command_unique_skill: 0
  name:
    en: Mad Love
    ja: 狂気の愛
    ko: 광기의 사랑
    zh_hant: 瘋狂的愛
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3770
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5552:
  _id_: 5552
  attribute_id: 3
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3762
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5553:
  _id_: 5553
  attribute_id: 3
  cost: 3
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Fiery Dance
    ja: 情熱のステップ
    ko: 정열의 스텝
    zh_hant: 熱情步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3763
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 54
    - 56
    - 59
    - 62
    - 64
5554:
  _id_: 5554
  attribute_id: 3
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Captivating Dance
    ja: 魅惑のステップ
    ko: 매혹의 스텝
    zh_hant: 魅惑步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3764
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5555:
  _id_: 5555
  attribute_id: 3
  cost: 2
  icon_id: 221
  is_multiple_command_unique_skill: 0
  name:
    en: Habanera
    ja: 恋は鳥のように
    ko: 사랑은 새처럼
    zh_hant: 愛情是一隻自由的鳥兒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3765
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
  - hit_rate: 100
    id: 341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5557:
  _id_: 5557
  attribute_id: 6
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Slash
    ja: 浄化の斬撃
    ko: 정화의 참격
    zh_hant: 淨化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3772
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5558:
  _id_: 5558
  attribute_id: 6
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Tension
    ja: 緊張の斬撃
    ko: 긴장의 참격
    zh_hant: 緊張斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3773
  skill_field_effect_id: 58
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5559:
  _id_: 5559
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Encouragement
    ja: 激励の斬撃
    ko: 격려의 참격
    zh_hant: 激勵斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3774
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5560:
  _id_: 5560
  attribute_id: 6
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: I Will Blossom until There's No Life in Me!
    ja: 凛と咲きます命果つまで！
    ko: 늠름히 피겠습니다 이 생이 다할 때까지!
    zh_hant: 直至命盡，凜冽綻放！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3775
  skill_field_effect_id: 59
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5562:
  _id_: 5562
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3777
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5563:
  _id_: 5563
  attribute_id: 1
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Strike
    ja: 浄化の一撃
    ko: 정화의 일격
    zh_hant: 浄化一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3778
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5564:
  _id_: 5564
  attribute_id: 1
  cost: 3
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Profusion of Flowers
    ja: 千紅万紫
    ko: 천홍만자
    zh_hant: 千紅萬紫
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3779
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 431
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5565:
  _id_: 5565
  attribute_id: 1
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Nocturne Game
    ja: 紅月夜遊戯
    ko: 붉은 달밤의 유희
    zh_hant: 紅月夜遊戲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3780
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 50
    id: 431
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5567:
  _id_: 5567
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5568:
  _id_: 5568
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5569:
  _id_: 5569
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5570:
  _id_: 5570
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5571:
  _id_: 5571
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5572:
  _id_: 5572
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5573:
  _id_: 5573
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5574:
  _id_: 5574
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5575:
  _id_: 5575
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5576:
  _id_: 5576
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2365
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5577:
  _id_: 5577
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2366
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5579:
  _id_: 5579
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5580:
  _id_: 5580
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5581:
  _id_: 5581
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5582:
  _id_: 5582
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5583:
  _id_: 5583
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5584:
  _id_: 5584
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5585:
  _id_: 5585
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5586:
  _id_: 5586
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5588:
  _id_: 5588
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5589:
  _id_: 5589
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5590:
  _id_: 5590
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5591:
  _id_: 5591
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5592:
  _id_: 5592
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5593:
  _id_: 5593
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5594:
  _id_: 5594
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5595:
  _id_: 5595
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5596:
  _id_: 5596
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5598:
  _id_: 5598
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5599:
  _id_: 5599
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5600:
  _id_: 5600
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5601:
  _id_: 5601
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5602:
  _id_: 5602
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5603:
  _id_: 5603
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5604:
  _id_: 5604
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5605:
  _id_: 5605
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5606:
  _id_: 5606
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5608:
  _id_: 5608
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5609:
  _id_: 5609
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5610:
  _id_: 5610
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5611:
  _id_: 5611
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5612:
  _id_: 5612
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5613:
  _id_: 5613
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5614:
  _id_: 5614
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5615:
  _id_: 5615
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5616:
  _id_: 5616
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5618:
  _id_: 5618
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3782
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5619:
  _id_: 5619
  attribute_id: 6
  cost: 3
  icon_id: 192
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Slash
    ja: 減光の斬撃
    ko: 감광의 참격
    zh_hant: 減光斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3783
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2081
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5620:
  _id_: 5620
  attribute_id: 6
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Fruits of Labor
    ja: 努力の結晶
    ko: 노력의 결정
    zh_hant: 努力結晶
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3784
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5621:
  _id_: 5621
  attribute_id: 6
  cost: 2
  icon_id: 1033
  is_multiple_command_unique_skill: 0
  name:
    en: This Road Is Where We Part
    ja: ここが別れの一本道
    ko: 이곳이 이별의 외길
    zh_hant: 此處即為離別的一人道
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3785
  skill_field_effect_id: 60
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 346
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5623:
  _id_: 5623
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3787
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5624:
  _id_: 5624
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Passionate Slash
    ja: 熱情の斬撃
    ko: 열정의 참격
    zh_hant: 熱情斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3788
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 4001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 4001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
5625:
  _id_: 5625
  attribute_id: 1
  cost: 3
  icon_id: 1020
  is_multiple_command_unique_skill: 0
  name:
    en: Unseen Play
    ja: まだ見ぬ戯曲
    ko: 아직 보지 못한 희곡
    zh_hant: 前所未見的戲碼
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3789
  skill_field_effect_id: 61
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5626:
  _id_: 5626
  attribute_id: 1
  cost: 2
  icon_id: 1034
  is_multiple_command_unique_skill: 1
  name:
    en: Karen Aijo—to the next stage!
    ja: 愛城華恋は次の舞台へ
    ko: 아이조 카렌은 다음 무대로
    zh_hant: 愛城華戀即將邁向下一個舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3790
  skill_field_effect_id: 62
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5633:
  _id_: 5633
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3797
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5634:
  _id_: 5634
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Slash
    ja: 鼓舞の斬撃
    ko: 고무의 참격
    zh_hant: 鼓舞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3798
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 4011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 4011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
5635:
  _id_: 5635
  attribute_id: 4
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Stalemate Slash
    ja: 膠着の斬撃
    ko: 교착의 참격
    zh_hant: 膠著斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3799
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5636:
  _id_: 5636
  attribute_id: 4
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Anastrophe
    ja: Anastrophe
    ko: Anastrophe
    zh_hant: Anastrophe
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3800
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5643:
  _id_: 5643
  attribute_id: 2
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Brilliance
    ja: キラめきの打撃
    ko: 반짝임의 타격
    zh_hant: 光芒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3807
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5644:
  _id_: 5644
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Cumulative Smash
    ja: 累加の打撃
    ko: 누적의 타격
    zh_hant: 累加敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3808
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5645:
  _id_: 5645
  attribute_id: 2
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Exuberant Smash
    ja: 充溢の打撃
    ko: 흘러넘침의 타격
    zh_hant: 洋溢敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3809
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
5646:
  _id_: 5646
  attribute_id: 2
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Schnee & Glockchen
    ja: Schnee & Glockchen
    ko: Schnee & Glockchen
    zh_hant: Schnee & Glockchen
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3810
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 346
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5648:
  _id_: 5648
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3812
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5649:
  _id_: 5649
  attribute_id: 6
  cost: 2
  icon_id: 252
  is_multiple_command_unique_skill: 0
  name:
    en: Abyss Nightmare
    ja: アビス・ナイトメア
    ko: 어비스 나이트메어
    zh_hant: 深淵夢魘
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3813
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 453
    target_id: 2401
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
5650:
  _id_: 5650
  attribute_id: 6
  cost: 3
  icon_id: 57
  is_multiple_command_unique_skill: 0
  name:
    en: Soul Possession
    ja: ソウル・テイク
    ko: 소울 테이크
    zh_hant: 掠奪靈魂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3814
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2401
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 232
    target_id: 2401
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5651:
  _id_: 5651
  attribute_id: 6
  cost: 2
  icon_id: 229
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Feast
    ja: Dark feast
    ko: Dark feast
    zh_hant: Dark feast
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3815
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 386
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 384
    target_id: 2401
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5653:
  _id_: 5653
  attribute_id: 1
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Sharpshooting
    ja: 浄化の狙撃
    ko: 정화의 저격
    zh_hant: 淨化狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3819
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5654:
  _id_: 5654
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting Blitz
    ja: 雷光の狙撃
    ko: 뇌광의 저격
    zh_hant: 雷光狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3820
  skill_field_effect_id: 63
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5655:
  _id_: 5655
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Encouragement
    ja: 激励の狙撃
    ko: 격려의 저격
    zh_hant: 激勵狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3821
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5656:
  _id_: 5656
  attribute_id: 1
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Against the wind, to Frontier!
    ja: いどめ向かい風すすめフロンティア！
    ko: 달려들어라 맞바람에 나아가라 프론티어!
    zh_hant: 不畏迎面強風，挺身前進邊疆！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3822
  skill_field_effect_id: 64
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5663:
  _id_: 5663
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3830
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5664:
  _id_: 5664
  attribute_id: 4
  cost: 2
  icon_id: 269
  is_multiple_command_unique_skill: 0
  name:
    en: Deceptive Flash
    ja: 欺瞞の一閃
    ko: 기만의 일섬
    zh_hant: 欺瞞閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3831
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 460
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5665:
  _id_: 5665
  attribute_id: 4
  cost: 3
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Ostentatious Flash
    ja: 虚飾の一閃
    ko: 허식의 일섬
    zh_hant: 虛飾閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5666:
  _id_: 5666
  attribute_id: 4
  cost: 2
  icon_id: 269
  is_multiple_command_unique_skill: 0
  name:
    en: Wild Chaser
    ja: Wild chaser
    ko: Wild chaser
    zh_hant: Wild chaser
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 462
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 460
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5668:
  _id_: 5668
  attribute_id: 4
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5669:
  _id_: 5669
  attribute_id: 4
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Hope
    ja: 希望の剣
    ko: 희망의 검
    zh_hant: 希望之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5670:
  _id_: 5670
  attribute_id: 4
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Recovery
    ja: 再起の剣
    ko: 재기의 검
    zh_hant: 再起之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5671:
  _id_: 5671
  attribute_id: 4
  cost: 2
  icon_id: 228
  is_multiple_command_unique_skill: 0
  name:
    en: Glory of Rebirth
    ja: 蘇る栄光
    ko: 되살아나는 영광
    zh_hant: 重拾榮光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5678:
  _id_: 5678
  attribute_id: 1
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3840
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5679:
  _id_: 5679
  attribute_id: 1
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Utsusemi Dance
    ja: 空蝉の舞踏
    ko: 허물의 무도
    zh_hant: 空蟬的舞步
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3841
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 463
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5680:
  _id_: 5680
  attribute_id: 1
  cost: 3
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Bubble Dance
    ja: 泡沫の舞踏
    ko: 포말의 무도
    zh_hant: 泡沫的舞步
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3842
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5681:
  _id_: 5681
  attribute_id: 1
  cost: 2
  icon_id: 1023
  is_multiple_command_unique_skill: 0
  name:
    en: Regenerating Dance
    ja: 回生の舞踊
    ko: 회생의 무용
    zh_hant: 重生的舞步
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3843
  skill_field_effect_id: 65
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5698:
  _id_: 5698
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Enchanting Pose
    ja: 魅惑のポーズ
    ko: 매혹적인 포즈
    zh_hant: 魅惑的姿勢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3857
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5699:
  _id_: 5699
  attribute_id: 5
  cost: 3
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Enchanting Walk
    ja: 魅惑のウォーキング
    ko: 매혹적인 워킹
    zh_hant: 魅惑的步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3858
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5700:
  _id_: 5700
  attribute_id: 5
  cost: 4
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Enchanting Smile
    ja: 魅惑のスマイル
    ko: 매혹적인 스마일
    zh_hant: 魅惑的笑容
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3859
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5701:
  _id_: 5701
  attribute_id: 5
  cost: 2
  icon_id: 272
  is_multiple_command_unique_skill: 1
  name:
    en: Yachiyo Tsuruhime's Runway
    ja: 鶴姫やちよのランウェイ
    ko: 츠루히메 야치요의 런웨이
    zh_hant: 鶴姬八千代的伸展台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3860
  skill_field_effect_id: 66
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5703:
  _id_: 5703
  attribute_id: 1
  cost: 1
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Adorable Pose
    ja: 可憐なポーズ
    ko: 가련한 포즈
    zh_hant: 動人的姿勢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3862
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5704:
  _id_: 5704
  attribute_id: 1
  cost: 2
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Adorable Walk
    ja: 可憐なウォーキング
    ko: 가련한 워킹
    zh_hant: 動人的步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3863
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5705:
  _id_: 5705
  attribute_id: 1
  cost: 3
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Adorable Smile
    ja: 可憐なスマイル
    ko: 가련한 스마일
    zh_hant: 動人的笑容
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3864
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 241
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10
    - 12
    - 14
    - 16
    - 20
5706:
  _id_: 5706
  attribute_id: 1
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Yuyuko Tanaka's Runway
    ja: 田中ゆゆ子のランウェイ
    ko: 타나카 유유코의 런웨이
    zh_hant: 田中悠悠子的伸展台
  optional_description:
    en: 'Guest Use: Aggro Not Applied'
    ja: ゲスト使用時、ターゲット固定は適用外
    ko: 게스트 사용 시, 타깃 고정은 적용되지 않음
    zh_hant: 使用來賓時，目標鎖定無效
  sequence_id: 3865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5709:
  _id_: 5709
  attribute_id: 5
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Slash
    ja: 浄化の斬撃
    ko: 정화의 참격
    zh_hant: 淨化斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5710:
  _id_: 5710
  attribute_id: 5
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Bitter Slash
    ja: 甘苦の斬撃
    ko: 고락의 참격
    zh_hant: 甘苦斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3868
  skill_field_effect_id: 67
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5711:
  _id_: 5711
  attribute_id: 5
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Encouragement
    ja: 激励の斬撃
    ko: 격려의 참격
    zh_hant: 激勵斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
5712:
  _id_: 5712
  attribute_id: 5
  cost: 2
  icon_id: 1020
  is_multiple_command_unique_skill: 0
  name:
    en: We Shall Conquer the King's Summit Together!
    ja: 共に征きます 王の頂！
    ko: 함께 가겠습니다, 왕의 정점으로!
    zh_hant: 與君一同出征，前往王之巔峰！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3870
  skill_field_effect_id: 68
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5714:
  _id_: 5714
  attribute_id: 3
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Humble Slash
    ja: 卑下の斬撃
    ko: 비하의 참격
    zh_hant: 卑下斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5715:
  _id_: 5715
  attribute_id: 3
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Slash
    ja: 苦悶の斬撃
    ko: 고민의 참격
    zh_hant: 苦悶斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 431
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5716:
  _id_: 5716
  attribute_id: 3
  cost: 3
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Mortifying Slash
    ja: 憂悶の斬撃
    ko: 번민의 참격
    zh_hant: 憂悶斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3874
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 431
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5717:
  _id_: 5717
  attribute_id: 3
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Black Tempest Break
    ja: ブラックテンペストブレイク
    ko: 블랙 템페스트 브레이크
    zh_hant: 漆黑・暴風雨斷擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3875
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 431
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5719:
  _id_: 5719
  attribute_id: 5
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Brilliance
    ja: キラめきの刺突
    ko: 반짝임의 찌르기
    zh_hant: 光芒突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3877
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5720:
  _id_: 5720
  attribute_id: 5
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Nervous Thrust
    ja: 緊張の刺突
    ko: 긴장의 찌르기
    zh_hant: 緊張突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3878
  skill_field_effect_id: 69
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5721:
  _id_: 5721
  attribute_id: 5
  cost: 3
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Thrust
    ja: 衰光の刺突
    ko: 쇠광의 찌르기
    zh_hant: 衰光突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3879
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
5722:
  _id_: 5722
  attribute_id: 5
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Delight - King's Majesty
    ja: Delight ～王の威光～
    ko: Delight ~왕의 위광~
    zh_hant: Delight ～王之威風～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3880
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
5724:
  _id_: 5724
  attribute_id: 6
  cost: 2
  icon_id: 241
  is_multiple_command_unique_skill: 0
  name:
    en: Vanilla
    ja: バニラ
    ko: 바닐라
    zh_hant: 香草
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3882
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 398
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
5725:
  _id_: 5725
  attribute_id: 6
  cost: 2
  icon_id: 241
  is_multiple_command_unique_skill: 0
  name:
    en: Strawberry
    ja: ストロベリー
    ko: 스트로베리
    zh_hant: 草莓
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3883
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 398
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
5726:
  _id_: 5726
  attribute_id: 6
  cost: 3
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Chocolate
    ja: チョコレート
    ko: 초콜릿
    zh_hant: 巧克力
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3884
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5727:
  _id_: 5727
  attribute_id: 6
  cost: 2
  icon_id: 241
  is_multiple_command_unique_skill: 0
  name:
    en: SWEET BOMB
    ja: SWEET BOMB
    ko: SWEET BOMB
    zh_hant: SWEET BOMB
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3885
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 398
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 55555
    - 66666
    - 77777
    - 88888
    - 99999
5756:
  _id_: 5756
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3069
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5757:
  _id_: 5757
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3070
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5758:
  _id_: 5758
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3071
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5759:
  _id_: 5759
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3072
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5760:
  _id_: 5760
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3073
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
5761:
  _id_: 5761
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3074
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5762:
  _id_: 5762
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3075
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
5763:
  _id_: 5763
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3076
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5764:
  _id_: 5764
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3077
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5766:
  _id_: 5766
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3105
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5767:
  _id_: 5767
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3106
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5768:
  _id_: 5768
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3107
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5769:
  _id_: 5769
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3108
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5770:
  _id_: 5770
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3109
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5771:
  _id_: 5771
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3110
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5772:
  _id_: 5772
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3111
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5773:
  _id_: 5773
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3112
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5774:
  _id_: 5774
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3113
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5775:
  _id_: 5775
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3114
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5776:
  _id_: 5776
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3115
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
5778:
  _id_: 5778
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5779:
  _id_: 5779
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5780:
  _id_: 5780
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5781:
  _id_: 5781
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5782:
  _id_: 5782
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5783:
  _id_: 5783
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5784:
  _id_: 5784
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5785:
  _id_: 5785
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5786:
  _id_: 5786
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
5788:
  _id_: 5788
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5789:
  _id_: 5789
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5790:
  _id_: 5790
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5791:
  _id_: 5791
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5792:
  _id_: 5792
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5793:
  _id_: 5793
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5794:
  _id_: 5794
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
5795:
  _id_: 5795
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5796:
  _id_: 5796
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5798:
  _id_: 5798
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5799:
  _id_: 5799
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5800:
  _id_: 5800
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5801:
  _id_: 5801
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5802:
  _id_: 5802
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5803:
  _id_: 5803
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5804:
  _id_: 5804
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5805:
  _id_: 5805
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5806:
  _id_: 5806
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5807:
  _id_: 5807
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5809:
  _id_: 5809
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5810:
  _id_: 5810
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
5811:
  _id_: 5811
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5812:
  _id_: 5812
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5813:
  _id_: 5813
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5814:
  _id_: 5814
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5815:
  _id_: 5815
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5816:
  _id_: 5816
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5817:
  _id_: 5817
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5818:
  _id_: 5818
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5819:
  _id_: 5819
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5821:
  _id_: 5821
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5822:
  _id_: 5822
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5823:
  _id_: 5823
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5824:
  _id_: 5824
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5825:
  _id_: 5825
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5826:
  _id_: 5826
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5827:
  _id_: 5827
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5828:
  _id_: 5828
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5829:
  _id_: 5829
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5830:
  _id_: 5830
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5831:
  _id_: 5831
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5833:
  _id_: 5833
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5834:
  _id_: 5834
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5835:
  _id_: 5835
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5836:
  _id_: 5836
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5837:
  _id_: 5837
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5838:
  _id_: 5838
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5839:
  _id_: 5839
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5840:
  _id_: 5840
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5841:
  _id_: 5841
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5842:
  _id_: 5842
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5843:
  _id_: 5843
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5845:
  _id_: 5845
  attribute_id: 6
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: More than Anything in the World
    ja: 世界中のなによりも
    ko: 세상에서 제일
    zh_hant: 愛妳勝過世間萬物
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3903
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5846:
  _id_: 5846
  attribute_id: 6
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: By My Side Forever
    ja: 永遠に私のそばに
    ko: 영원히 제 곁에
    zh_hant: 永遠留在我的身邊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3904
  skill_field_effect_id: 72
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5847:
  _id_: 5847
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 0
  name:
    en: For Her
    ja: 彼女のために
    ko: 그녀를 위해
    zh_hant: 一切都是為了她
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3905
  skill_field_effect_id: 73
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5848:
  _id_: 5848
  attribute_id: 6
  cost: 2
  icon_id: 248
  is_multiple_command_unique_skill: 0
  name:
    en: Kiss of Detoxification
    ja: 解毒の接吻
    ko: 해독의 입맞춤
    zh_hant: 解毒之吻
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3906
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
  - hit_rate: 100
    id: 443
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5850:
  _id_: 5850
  attribute_id: 3
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Hermetic Smash
    ja: 厳封の打撃
    ko: 엄봉의 타격
    zh_hant: 密封敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3910
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5851:
  _id_: 5851
  attribute_id: 3
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunderous Smash
    ja: 轟雷の打撃
    ko: 굉뢰의 타격
    zh_hant: 轟雷敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3911
  skill_field_effect_id: 74
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5852:
  _id_: 5852
  attribute_id: 3
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Ready to Stand on Stage
    ja: 舞台に立つ覚悟
    ko: 무대에 설 각오
    zh_hant: 站上舞台的覺悟
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3912
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1132
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5853:
  _id_: 5853
  attribute_id: 3
  cost: 2
  icon_id: 1042
  is_multiple_command_unique_skill: 1
  name:
    en: My Dreams Will Come True on Stage
    ja: 夢咲く舞台に 輝け 私
    ko: 꿈이 꽃피는 무대에서 난 빛나리
    zh_hant: 我要在綻放夢想的舞台上熠熠生輝
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3913
  skill_field_effect_id: 75
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5855:
  _id_: 5855
  attribute_id: 3
  cost: 2
  icon_id: 1038
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Applauses
    ja: 喝采の斬撃
    ko: 갈채의 참격
    zh_hant: 喝采斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3915
  skill_field_effect_id: 77
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5856:
  _id_: 5856
  attribute_id: 3
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Tension
    ja: 緊張の斬撃
    ko: 긴장의 참격
    zh_hant: 緊張斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3916
  skill_field_effect_id: 78
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5857:
  _id_: 5857
  attribute_id: 3
  cost: 2
  icon_id: 273
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Disaster
    ja: 厄災の斬撃
    ko: 재앙의 참격
    zh_hant: 災厄斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3917
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 470
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5858:
  _id_: 5858
  attribute_id: 3
  cost: 2
  icon_id: 1020
  is_multiple_command_unique_skill: 0
  name:
    en: Delight - Yell of Passion
    ja: Delight ～激情の叫び～
    ko: Delight ~격정의 외침~
    zh_hant: Delight ～激情的吶喊～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3918
  skill_field_effect_id: 76
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5860:
  _id_: 5860
  attribute_id: 2
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Weak Point Slash
    ja: 搦手の斬撃
    ko: 허점의 참격
    zh_hant: 搦手斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3920
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2031
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2031
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2031
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
5861:
  _id_: 5861
  attribute_id: 2
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Ostentatious Slash
    ja: 虚飾の斬撃
    ko: 허식의 참격
    zh_hant: 虛榮斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3921
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
5862:
  _id_: 5862
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 狼藉の斬撃
    ko: 행패의 참격
    zh_hant: 狼藉斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3922
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5863:
  _id_: 5863
  attribute_id: 2
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Delight - Sword of Mediation
    ja: Delight ～仲裁の剣～
    ko: Delight ~중재의 검~
    zh_hant: Delight ～仲裁之劍～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3923
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 50
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5865:
  _id_: 5865
  attribute_id: 5
  cost: 2
  icon_id: 238
  is_multiple_command_unique_skill: 0
  name:
    en: Bear Slayer
    ja: 熊をも倒す一撃
    ko: 곰마저 쓰러뜨리는 일격
    zh_hant: 能打倒熊的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3925
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5866:
  _id_: 5866
  attribute_id: 5
  cost: 3
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Earth Spider Slayer
    ja: 蜘蛛をも倒す一撃
    ko: 거미마저 쓰러뜨리는 일격
    zh_hant: 能打倒蜘蛛的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3926
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5867:
  _id_: 5867
  attribute_id: 5
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Axe-Bearer
    ja: 鉞担いで
    ko: 큰 도끼를 짊어지고
    zh_hant: 肩上扛著斧頭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3927
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1133
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5868:
  _id_: 5868
  attribute_id: 5
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Contest of Strength
    ja: 剛腕力比べ
    ko: 힘겨루기
    zh_hant: 以強勁臂彎比力氣
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3928
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5892:
  _id_: 5892
  attribute_id: 6
  cost: 1
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Brilliance
    ja: キラめきの一閃
    ko: 반짝임의 일섬
    zh_hant: 光芒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3946
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5893:
  _id_: 5893
  attribute_id: 6
  cost: 2
  icon_id: 250
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Flash
    ja: 純化の一閃
    ko: 순화의 일섬
    zh_hant: 純化閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3947
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 444
    target_id: 1133
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5894:
  _id_: 5894
  attribute_id: 6
  cost: 3
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorbing Flash
    ja: 吸光の一閃
    ko: 흡광의 일섬
    zh_hant: 吸光閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3948
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5895:
  _id_: 5895
  attribute_id: 6
  cost: 2
  icon_id: 32
  is_multiple_command_unique_skill: 0
  name:
    en: Circle of Connect
    ja: Circle of Connect
    ko: Circle of Connect
    zh_hant: Circle of Connect
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3949
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 32
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 33
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 346
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5897:
  _id_: 5897
  attribute_id: 5
  cost: 2
  icon_id: 273
  is_multiple_command_unique_skill: 0
  name:
    en: Light of Hope
    ja: 希望の光
    ko: 희망의 빛
    zh_hant: 希望之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3952
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 470
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5898:
  _id_: 5898
  attribute_id: 5
  cost: 2
  icon_id: 1040
  is_multiple_command_unique_skill: 0
  name:
    en: Fight Together
    ja: 共に戦う力
    ko: 함께 싸울 힘
    zh_hant: 並肩作戰之力
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3953
  skill_field_effect_id: 80
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5899:
  _id_: 5899
  attribute_id: 5
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Dominate Evil
    ja: 魔を怯ませる力
    ko: 마를 압도할 힘
    zh_hant: 震懾魔物之力
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3954
  skill_field_effect_id: 81
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5900:
  _id_: 5900
  attribute_id: 5
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Light of Rescue
    ja: 救いの光
    ko: 구원의 빛
    zh_hant: 救贖之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3955
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5902:
  _id_: 5902
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2431
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5903:
  _id_: 5903
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2432
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5904:
  _id_: 5904
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2433
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5905:
  _id_: 5905
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tri-Slash
    ja: 参連撃
    ko: 삼연격
    zh_hant: 參連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2434
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5906:
  _id_: 5906
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2435
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5907:
  _id_: 5907
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2436
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5908:
  _id_: 5908
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2437
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
5910:
  _id_: 5910
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5911:
  _id_: 5911
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5912:
  _id_: 5912
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5913:
  _id_: 5913
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5914:
  _id_: 5914
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5915:
  _id_: 5915
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5916:
  _id_: 5916
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5917:
  _id_: 5917
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5918:
  _id_: 5918
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5920:
  _id_: 5920
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2502
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5921:
  _id_: 5921
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2503
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5922:
  _id_: 5922
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2504
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5923:
  _id_: 5923
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2505
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5924:
  _id_: 5924
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5925:
  _id_: 5925
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5926:
  _id_: 5926
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2508
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5927:
  _id_: 5927
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5928:
  _id_: 5928
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2510
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
5930:
  _id_: 5930
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2502
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5931:
  _id_: 5931
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2503
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5932:
  _id_: 5932
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2504
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5933:
  _id_: 5933
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2505
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5934:
  _id_: 5934
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2506
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5935:
  _id_: 5935
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2507
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5936:
  _id_: 5936
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2508
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
5937:
  _id_: 5937
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
5938:
  _id_: 5938
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2509
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5939:
  _id_: 5939
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette NEO
    ja: メイドのたしなみ NEO
    ko: 메이드의 소양 NEO
    zh_hant: 女僕的特技 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2510
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
5941:
  _id_: 5941
  attribute_id: 3
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Hermetic Slash
    ja: 厳封の斬撃
    ko: 엄봉의 참격
    zh_hant: 密封斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3957
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5942:
  _id_: 5942
  attribute_id: 3
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Exuberant Slash
    ja: 充溢の斬撃
    ko: 흘러넘침의 참격
    zh_hant: 洋溢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3958
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 463
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5943:
  _id_: 5943
  attribute_id: 3
  cost: 3
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Elaborate Slash
    ja: 絢爛の斬撃
    ko: 현란의 참격
    zh_hant: 絢爛斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3959
  skill_field_effect_id: 82
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5944:
  _id_: 5944
  attribute_id: 3
  cost: 2
  icon_id: 275
  is_multiple_command_unique_skill: 0
  name:
    en: Swear by Heaven and Earth
    ja: 俯仰天地
    ko: 부앙천지
    zh_hant: 俯仰天地
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3960
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 472
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5956:
  _id_: 5956
  attribute_id: 2
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Wise Guidance
    ja: 賢慮の導き
    ko: 현려의 인도
    zh_hant: 賢明指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5957:
  _id_: 5957
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Talented Guidance
    ja: 才気の導き
    ko: 재기의 인도
    zh_hant: 才華指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5958:
  _id_: 5958
  attribute_id: 2
  cost: 3
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Future Guidance
    ja: 未来への導き
    ko: 미래로의 인도
    zh_hant: 未來指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
5959:
  _id_: 5959
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 1
  name:
    en: Tome of Wisdom
    ja: 叡智の書
    ko: 예지의 서
    zh_hant: 睿智之書
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5961:
  _id_: 5961
  attribute_id: 4
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Graceful Pose
    ja: 優雅なポーズ
    ko: 우아한 포즈
    zh_hant: 優雅的姿勢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5962:
  _id_: 5962
  attribute_id: 4
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Graceful Walk
    ja: 優雅なウォーキング
    ko: 우아한 워킹
    zh_hant: 優雅的步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3979
  skill_field_effect_id: 84
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
5963:
  _id_: 5963
  attribute_id: 4
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Graceful Smile
    ja: 優雅なスマイル
    ko: 우아한 스마일
    zh_hant: 優雅的笑容
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1132
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5964:
  _id_: 5964
  attribute_id: 4
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 1
  name:
    en: Kaoruko Hanayagi's Runway
    ja: 花柳香子のランウェイ
    ko: 하나야기 카오루코의 런웨이
    zh_hant: 花柳香子的伸展台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3981
  skill_field_effect_id: 85
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
5971:
  _id_: 5971
  attribute_id: 4
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Wisdom Flash
    ja: 英気の一閃
    ko: 영기의 일섬
    zh_hant: 英氣閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3983
  skill_field_effect_id: 86
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5972:
  _id_: 5972
  attribute_id: 4
  cost: 2
  icon_id: 1019
  is_multiple_command_unique_skill: 0
  name:
    en: Lively Flash
    ja: 溌剌な一閃
    ko: 발랄한 일섬
    zh_hant: 活潑閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3984
  skill_field_effect_id: 87
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5973:
  _id_: 5973
  attribute_id: 4
  cost: 3
  icon_id: 1039
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance Flash
    ja: 旺然たる一閃
    ko: 왕성한 일섬
    zh_hant: 朝氣閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3985
  skill_field_effect_id: 88
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
5974:
  _id_: 5974
  attribute_id: 4
  cost: 2
  icon_id: 1023
  is_multiple_command_unique_skill: 0
  name:
    en: Sky Blue Combo Shooting
    ja: スカイブルーコンビシューティング
    ko: 스카이블루 콤비 슈팅
    zh_hant: 天藍劇團組合射擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3986
  skill_field_effect_id: 89
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
5976:
  _id_: 5976
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5977:
  _id_: 5977
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5978:
  _id_: 5978
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5979:
  _id_: 5979
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5980:
  _id_: 5980
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5981:
  _id_: 5981
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5982:
  _id_: 5982
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
5983:
  _id_: 5983
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5985:
  _id_: 5985
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5986:
  _id_: 5986
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
5987:
  _id_: 5987
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5988:
  _id_: 5988
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
5989:
  _id_: 5989
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5990:
  _id_: 5990
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
5991:
  _id_: 5991
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
5992:
  _id_: 5992
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5993:
  _id_: 5993
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
5995:
  _id_: 5995
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5996:
  _id_: 5996
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5997:
  _id_: 5997
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
5998:
  _id_: 5998
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
5999:
  _id_: 5999
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6000:
  _id_: 6000
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6001:
  _id_: 6001
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6002:
  _id_: 6002
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6003:
  _id_: 6003
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6005:
  _id_: 6005
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6006:
  _id_: 6006
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6007:
  _id_: 6007
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6008:
  _id_: 6008
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6009:
  _id_: 6009
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6010:
  _id_: 6010
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6011:
  _id_: 6011
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6012:
  _id_: 6012
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6013:
  _id_: 6013
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6015:
  _id_: 6015
  attribute_id: 6
  cost: 3
  icon_id: 192
  is_multiple_command_unique_skill: 0
  name:
    en: Exquisite Pose
    ja: 華麗なポーズ
    ko: 화려한 포즈
    zh_hant: 華麗的姿勢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3988
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6016:
  _id_: 6016
  attribute_id: 6
  cost: 3
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Exquisite Walk
    ja: 華麗なウォーキング
    ko: 화려한 워킹
    zh_hant: 華麗的步伐
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3989
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 384
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 474
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
6017:
  _id_: 6017
  attribute_id: 6
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Exquisite Smile
    ja: 華麗なスマイル
    ko: 화려한 스마일
    zh_hant: 華麗的笑容
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3990
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1145
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6018:
  _id_: 6018
  attribute_id: 6
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Futaba Isurugi's Runway
    ja: 石動双葉のランウェイ
    ko: 이스루기 후타바의 런웨이
    zh_hant: 石動雙葉的伸展台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3991
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 442
    target_id: 2404
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6020:
  _id_: 6020
  attribute_id: 2
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Valkyrie Prayer
    ja: 戦乙女の祈り
    ko: 발키리의 기도
    zh_hant: 女武神的祈禱
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3993
  skill_field_effect_id: 91
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6021:
  _id_: 6021
  attribute_id: 2
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Valkyrie Constraint
    ja: 戦乙女の制約
    ko: 발키리의 제약
    zh_hant: 女武神的約束
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3994
  skill_field_effect_id: 92
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 10
    - 10
    - 10
    - 10
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6022:
  _id_: 6022
  attribute_id: 2
  cost: 3
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Valkyrie Pupils
    ja: 戦乙女の瞳
    ko: 발키리의 눈동자
    zh_hant: 女武神的眼眸
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3995
  skill_field_effect_id: 93
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
6023:
  _id_: 6023
  attribute_id: 2
  cost: 2
  icon_id: 1045
  is_multiple_command_unique_skill: 0
  name:
    en: Fire Awakening
    ja: 蒼炎の目覚め
    ko: 푸른 불꽃의 각성
    zh_hant: 蒼焰的覺醒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3996
  skill_field_effect_id: 90
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6030:
  _id_: 6030
  attribute_id: 9
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Desire
    ja: 宿望の剣
    ko: 숙원의 검
    zh_hant: 宿願之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4002
  skill_field_effect_id: 96
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6031:
  _id_: 6031
  attribute_id: 9
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Courage
    ja: 勇気の剣
    ko: 용기의 검
    zh_hant: 勇氣之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4003
  skill_field_effect_id: 97
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6032:
  _id_: 6032
  attribute_id: 9
  cost: 3
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Evil Slayer
    ja: 悪を討つ剣
    ko: 악을 처단하는 검
    zh_hant: 討惡之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4004
  skill_field_effect_id: 98
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6033:
  _id_: 6033
  attribute_id: 9
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 1
  name:
    en: Balmung
    ja: 愛のバルムンク
    ko: 사랑의 발뭉
    zh_hant: 愛之巴爾蒙克
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4005
  skill_field_effect_id: 99
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 479
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 476
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 86
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
6035:
  _id_: 6035
  attribute_id: 4
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: Priority
    ja: 譲り合い
    ko: 양보
    zh_hant: 互相禮讓
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4007
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6036:
  _id_: 6036
  attribute_id: 4
  cost: 2
  icon_id: 240
  is_multiple_command_unique_skill: 0
  name:
    en: Safety
    ja: 安全第一
    ko: 안전제일
    zh_hant: 安全第一
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4008
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 394
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
6037:
  _id_: 6037
  attribute_id: 4
  cost: 2
  icon_id: 1039
  is_multiple_command_unique_skill: 0
  name:
    en: Signal
    ja: 進行合図
    ko: 진행신호
    zh_hant: 通行手勢
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4009
  skill_field_effect_id: 94
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6038:
  _id_: 6038
  attribute_id: 4
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Officer Otonashi's Traffic Control
    ja: 音無巡査の交通整理
    ko: 오토나시 순경의 교통정리
    zh_hant: 音無警員的交通指揮
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4010
  skill_field_effect_id: 95
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 650
    - 660
    - 670
    - 680
    - 700
6045:
  _id_: 6045
  attribute_id: 2
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Hope
    ja: 希望の斬撃
    ko: 희망의 참격
    zh_hant: 希望斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4012
  skill_field_effect_id: 100
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6046:
  _id_: 6046
  attribute_id: 2
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Enchanting Slash
    ja: 魅惑の斬撃
    ko: 매혹의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4013
  skill_field_effect_id: 101
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6047:
  _id_: 6047
  attribute_id: 2
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Desired Stage
    ja: 望まれた舞台
    ko: 바라던 무대
    zh_hant: 期望的舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 473
    target_id: 1143
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
6048:
  _id_: 6048
  attribute_id: 2
  cost: 2
  icon_id: 1047
  is_multiple_command_unique_skill: 1
  name:
    en: Hikari Kagura—I'm the Star!
    ja: 神楽ひかり 私がスタァだ！
    ko: 카구라 히카리 내가 스타다!
    zh_hant: 神樂光 我正是Star！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4015
  skill_field_effect_id: 102
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 4136
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6050:
  _id_: 6050
  attribute_id: 4
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Awakening Song
    ja: 目覚めの歌
    ko: 각성의 노래
    zh_hant: 喚醒之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 231
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6051:
  _id_: 6051
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: All-Knowing Song
    ja: 全知の歌
    ko: 전지의 노래
    zh_hant: 全知之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6052:
  _id_: 6052
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Earth Song
    ja: 大地の歌
    ko: 대지의 노래
    zh_hant: 大地之歌
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 14
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6053:
  _id_: 6053
  attribute_id: 4
  cost: 1
  icon_id: 284
  is_multiple_command_unique_skill: 0
  name:
    en: Leading Song
    ja: 歌声の道標
    ko: 노랫소리의 길잡이
    zh_hant: 歌聲的指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 485
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 486
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6055:
  _id_: 6055
  attribute_id: 2
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Constraint Strike
    ja: 制約の一撃
    ko: 제약의 일격
    zh_hant: 制約一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4022
  skill_field_effect_id: 103
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 224
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6056:
  _id_: 6056
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Encouragement
    ja: 激励の一撃
    ko: 격려의 일격
    zh_hant: 激勵一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4023
  skill_field_effect_id: 104
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6057:
  _id_: 6057
  attribute_id: 2
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Victory
    ja: 勝利の一撃
    ko: 승리의 일격
    zh_hant: 勝利一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4024
  skill_field_effect_id: 105
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6058:
  _id_: 6058
  attribute_id: 2
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Moon Slayer
    ja: 月夜の退魔
    ko: 달밤의 퇴마
    zh_hant: 月夜之退魔
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4025
  skill_field_effect_id: 106
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6072:
  _id_: 6072
  attribute_id: 3
  cost: 2
  icon_id: 249
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Virility
    ja: 精悍な剣
    ko: 정한한 검
    zh_hant: 精悍之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4038
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 251
    target_id: 2051
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6073:
  _id_: 6073
  attribute_id: 3
  cost: 2
  icon_id: 273
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Loyalty
    ja: 忠義の剣
    ko: 충의의 검
    zh_hant: 忠義之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4039
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 462
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 470
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6074:
  _id_: 6074
  attribute_id: 3
  cost: 3
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Compassion
    ja: 慈愛の剣
    ko: 자애의 검
    zh_hant: 慈愛之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4040
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6075:
  _id_: 6075
  attribute_id: 3
  cost: 2
  icon_id: 1048
  is_multiple_command_unique_skill: 0
  name:
    en: Rose of Sincerity
    ja: 誠心のばら
    ko: 성심의 장미
    zh_hant: 忠誠玫瑰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4041
  skill_field_effect_id: 107
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6077:
  _id_: 6077
  attribute_id: 6
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Passion
    ja: 情熱の剣
    ko: 정열의 검
    zh_hant: 熱情之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4043
  skill_field_effect_id: 108
  skill_options:
  - hit_rate: 100
    id: 473
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6078:
  _id_: 6078
  attribute_id: 6
  cost: 3
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Nobility
    ja: 高潔な剣
    ko: 고결한 검
    zh_hant: 高潔之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4044
  skill_field_effect_id: 109
  skill_options:
  - hit_rate: 100
    id: 34
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6079:
  _id_: 6079
  attribute_id: 6
  cost: 4
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Beauty
    ja: 美しき剣
    ko: 아름다운 검
    zh_hant: 美艷之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4045
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1145
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6080:
  _id_: 6080
  attribute_id: 6
  cost: 2
  icon_id: 236
  is_multiple_command_unique_skill: 0
  name:
    en: Rose of Beauty
    ja: 麗しきばら
    ko: 아름다운 장미
    zh_hant: 艷麗玫瑰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4046
  skill_field_effect_id: 110
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6082:
  _id_: 6082
  attribute_id: 7
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Brilliance
    ja: キラめきの斬撃
    ko: 반짝임의 참격
    zh_hant: 光芒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4048
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 93
    - 98
    - 102
    - 107
    - 112
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6083:
  _id_: 6083
  attribute_id: 7
  cost: 2
  icon_id: 269
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Grace
    ja: 麗しの剣
    ko: 아름다운 검
    zh_hant: 美麗之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4049
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 394
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 460
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6084:
  _id_: 6084
  attribute_id: 7
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of Fury
    ja: 激情の剣
    ko: 격정의 검
    zh_hant: 激情之劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6085:
  _id_: 6085
  attribute_id: 7
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Rose of Beauty Respect Ver.
    ja: 麗しきばら Respect Ver.
    ko: 아름다운 장미 Respect Ver.
    zh_hant: 艷麗玫瑰 Respect Ver.
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4051
  skill_field_effect_id: 116
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6087:
  _id_: 6087
  attribute_id: 8
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Suppression Slash
    ja: 制圧の斬撃
    ko: 제압의 참격
    zh_hant: 鎮壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4053
  skill_field_effect_id: 114
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6088:
  _id_: 6088
  attribute_id: 8
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Graceful Slash
    ja: 優雅な斬撃
    ko: 우아한 참격
    zh_hant: 優雅斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4054
  skill_field_effect_id: 115
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
6089:
  _id_: 6089
  attribute_id: 8
  cost: 3
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorbing Slash
    ja: 吸光の斬撃
    ko: 흡광의 참격
    zh_hant: 吸光斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6090:
  _id_: 6090
  attribute_id: 8
  cost: 2
  icon_id: 1050
  is_multiple_command_unique_skill: 1
  name:
    en: Rose of Nobility
    ja: 気高きばら
    ko: 고귀한 장미
    zh_hant: 高貴玫瑰
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4056
  skill_field_effect_id: 113
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 473
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 225
    - 236
    - 247
    - 258
    - 270
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6092:
  _id_: 6092
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6093:
  _id_: 6093
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6094:
  _id_: 6094
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6095:
  _id_: 6095
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6096:
  _id_: 6096
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6097:
  _id_: 6097
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6098:
  _id_: 6098
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6099:
  _id_: 6099
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6100:
  _id_: 6100
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6101:
  _id_: 6101
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6103:
  _id_: 6103
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6104:
  _id_: 6104
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
6105:
  _id_: 6105
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6106:
  _id_: 6106
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6107:
  _id_: 6107
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6108:
  _id_: 6108
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6109:
  _id_: 6109
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6110:
  _id_: 6110
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6111:
  _id_: 6111
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6112:
  _id_: 6112
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6113:
  _id_: 6113
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6115:
  _id_: 6115
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6116:
  _id_: 6116
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6117:
  _id_: 6117
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6118:
  _id_: 6118
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6119:
  _id_: 6119
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6120:
  _id_: 6120
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6121:
  _id_: 6121
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6122:
  _id_: 6122
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6123:
  _id_: 6123
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6124:
  _id_: 6124
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6125:
  _id_: 6125
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6127:
  _id_: 6127
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6128:
  _id_: 6128
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6129:
  _id_: 6129
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6130:
  _id_: 6130
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6131:
  _id_: 6131
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6132:
  _id_: 6132
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6133:
  _id_: 6133
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6134:
  _id_: 6134
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6135:
  _id_: 6135
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6136:
  _id_: 6136
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6137:
  _id_: 6137
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6149:
  _id_: 6149
  attribute_id: 3
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Cold-Blooded King
    ja: 冷血な王
    ko: 냉혹한 왕
    zh_hant: 冷血的王
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4062
  skill_field_effect_id: 117
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6150:
  _id_: 6150
  attribute_id: 3
  cost: 2
  icon_id: 1052
  is_multiple_command_unique_skill: 0
  name:
    en: Merciless King
    ja: 無慈悲な王
    ko: 무자비한 왕
    zh_hant: 無情的王
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4063
  skill_field_effect_id: 118
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6151:
  _id_: 6151
  attribute_id: 3
  cost: 3
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Stern King
    ja: 峻厳な王
    ko: 준엄한 왕
    zh_hant: 嚴苛的王
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4064
  skill_field_effect_id: 122
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6152:
  _id_: 6152
  attribute_id: 3
  cost: 2
  icon_id: 287
  is_multiple_command_unique_skill: 0
  name:
    en: Hades's Conviction
    ja: 冥王の断罪
    ko: 명왕의 단죄
    zh_hant: 冥王之定罪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4065
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 489
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
  - hit_rate: 100
    id: 442
    target_id: 2021
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6166:
  _id_: 6166
  attribute_id: 1
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Mint
    ja: ミント
    ko: 민트
    zh_hant: 薄荷
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4078
  skill_field_effect_id: 123
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6167:
  _id_: 6167
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Chocolate Sauce
    ja: チョコレートソース
    ko: 초콜릿 소스
    zh_hant: 巧克力醬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4079
  skill_field_effect_id: 124
  skill_options:
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6168:
  _id_: 6168
  attribute_id: 1
  cost: 3
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Whipped Cream
    ja: ホイップクリーム
    ko: 휘핑크림
    zh_hant: 鮮奶油
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4080
  skill_field_effect_id: 125
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6169:
  _id_: 6169
  attribute_id: 1
  cost: 2
  icon_id: 288
  is_multiple_command_unique_skill: 0
  name:
    en: Pudding Press♪
    ja: ぷるるん♪プリンプレス
    ko: 탱글탱글♪ 푸딩 대소동
    zh_hant: 軟嫩Q彈♪布丁壓頂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4081
  skill_field_effect_id: 126
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6171:
  _id_: 6171
  attribute_id: 5
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: King's Castle Walls
    ja: 王の城壁
    ko: 왕의 성벽
    zh_hant: 王的城牆
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4083
  skill_field_effect_id: 128
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6172:
  _id_: 6172
  attribute_id: 5
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: King's Imposing Figure
    ja: 王の雄姿
    ko: 왕의 용맹함
    zh_hant: 王的英姿
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4084
  skill_field_effect_id: 129
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 10
    - 10
    - 10
    - 10
    - 10
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6173:
  _id_: 6173
  attribute_id: 5
  cost: 3
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Eternal Life
    ja: 永遠の命
    ko: 영원한 생명
    zh_hant: 永恆生命
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4085
  skill_field_effect_id: 130
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
6174:
  _id_: 6174
  attribute_id: 5
  cost: 2
  icon_id: 289
  is_multiple_command_unique_skill: 0
  name:
    en: King of Uruk
    ja: ウルクの王
    ko: 우르크의 왕
    zh_hant: 烏魯克之王
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4086
  skill_field_effect_id: 131
  skill_options:
  - hit_rate: 100
    id: 299
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 495
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6176:
  _id_: 6176
  attribute_id: 1
  cost: 2
  icon_id: 1024
  is_multiple_command_unique_skill: 0
  name:
    en: Laws of the Underworld
    ja: 冥府の掟
    ko: 저승의 규칙
    zh_hant: 冥府的律法
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4093
  skill_field_effect_id: 133
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6177:
  _id_: 6177
  attribute_id: 1
  cost: 2
  icon_id: 237
  is_multiple_command_unique_skill: 0
  name:
    en: Peace of the Underworld
    ja: 冥府の安寧
    ko: 저승의 안녕
    zh_hant: 冥府的安寧
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4094
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 496
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6178:
  _id_: 6178
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Quiet of the Underworld
    ja: 冥府の静寂
    ko: 저승의 고요
    zh_hant: 冥府的寂靜
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4095
  skill_field_effect_id: 134
  skill_options:
  - hit_rate: 100
    id: 440
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6179:
  _id_: 6179
  attribute_id: 1
  cost: 2
  icon_id: 287
  is_multiple_command_unique_skill: 1
  name:
    en: Adverse Fate
    ja: 数奇な運命
    ko: 기구한 운명
    zh_hant: 曲折的命運
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4096
  skill_field_effect_id: 135
  skill_options:
  - hit_rate: 100
    id: 462
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6181:
  _id_: 6181
  attribute_id: 6
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Arrow of Revelation
    ja: 示しの矢
    ko: 계시의 활
    zh_hant: 啟示之箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4088
  skill_field_effect_id: 137
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6182:
  _id_: 6182
  attribute_id: 6
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: The One Who Stops
    ja: 止める者
    ko: 멈추는 자
    zh_hant: 遏止之人
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4089
  skill_field_effect_id: 138
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6183:
  _id_: 6183
  attribute_id: 6
  cost: 3
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Sagittarius' Brilliance
    ja: いて座のキラめき
    ko: 궁수자리의 반짝임
    zh_hant: 人馬座的光芒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4090
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 30
    - 40
    - 50
    - 60
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6184:
  _id_: 6184
  attribute_id: 6
  cost: 2
  icon_id: 1058
  is_multiple_command_unique_skill: 1
  name:
    en: Arrow of the Sage
    ja: 賢者の弓
    ko: 현자의 활
    zh_hant: 賢者之弓
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4091
  skill_field_effect_id: 139
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6186:
  _id_: 6186
  attribute_id: 6
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Heresy
    ja: 邪道
    ko: 사도
    zh_hant: 邪道
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4098
  skill_field_effect_id: 141
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6187:
  _id_: 6187
  attribute_id: 6
  cost: 2
  icon_id: 178
  is_multiple_command_unique_skill: 0
  name:
    en: Curse
    ja: 呪詛
    ko: 저주
    zh_hant: 詛咒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4099
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 251
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6188:
  _id_: 6188
  attribute_id: 6
  cost: 2
  icon_id: 1060
  is_multiple_command_unique_skill: 0
  name:
    en: Evil Offering
    ja: 悪へ供奉
    ko: 악을 따르는 자
    zh_hant: 邪惡的供養
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4100
  skill_field_effect_id: 142
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 252
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6189:
  _id_: 6189
  attribute_id: 6
  cost: 2
  icon_id: 1051
  is_multiple_command_unique_skill: 0
  name:
    en: Doman the Accursed
    ja: 厭魅のドーマン
    ko: 염매의 도만
    zh_hant: 厭魅九字紋
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4101
  skill_field_effect_id: 143
  skill_options:
  - hit_rate: 100
    id: 156
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 501
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6191:
  _id_: 6191
  attribute_id: 1
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Abundant Crops
    ja: 豊穣の務め
    ko: 풍요의 책무
    zh_hant: 豐饒的職責
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4103
  skill_field_effect_id: 145
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6192:
  _id_: 6192
  attribute_id: 1
  cost: 2
  icon_id: 26
  is_multiple_command_unique_skill: 0
  name:
    en: First Strike
    ja: 開戦の打撃
    ko: 개전의 타격
    zh_hant: 開戰敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4104
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 462
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
6193:
  _id_: 6193
  attribute_id: 1
  cost: 2
  icon_id: 293
  is_multiple_command_unique_skill: 0
  name:
    en: Impetus of Beauty
    ja: 美の衝動
    ko: 아름다움의 충동
    zh_hant: 美的衝動
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4105
  skill_field_effect_id: 146
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 499
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6194:
  _id_: 6194
  attribute_id: 1
  cost: 2
  icon_id: 293
  is_multiple_command_unique_skill: 0
  name:
    en: Love Beast
    ja: 愛の魔物
    ko: 사랑의 마물
    zh_hant: 愛的魔物
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4106
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 60
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 499
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6196:
  _id_: 6196
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4108
  skill_field_effect_id: 149
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1142
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6197:
  _id_: 6197
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Slash
    ja: 碧き斬撃
    ko: 푸른 참격
    zh_hant: 碧綠斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4109
  skill_field_effect_id: 150
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 508
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 350
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6198:
  _id_: 6198
  attribute_id: 6
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4110
  skill_field_effect_id: 151
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6199:
  _id_: 6199
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 1
  name:
    en: Delight - My Thoughts
    ja: Delight ～我が想い～
    ko: Delight ~나의 마음~
    zh_hant: Delight ～我的心意～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4111
  skill_field_effect_id: 152
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6201:
  _id_: 6201
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6202:
  _id_: 6202
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6203:
  _id_: 6203
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6204:
  _id_: 6204
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6205:
  _id_: 6205
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6206:
  _id_: 6206
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6207:
  _id_: 6207
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6208:
  _id_: 6208
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6209:
  _id_: 6209
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
6211:
  _id_: 6211
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6212:
  _id_: 6212
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6213:
  _id_: 6213
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6214:
  _id_: 6214
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6215:
  _id_: 6215
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6216:
  _id_: 6216
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6217:
  _id_: 6217
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6218:
  _id_: 6218
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
6219:
  _id_: 6219
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6220:
  _id_: 6220
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
6222:
  _id_: 6222
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6223:
  _id_: 6223
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6224:
  _id_: 6224
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6225:
  _id_: 6225
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6226:
  _id_: 6226
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6227:
  _id_: 6227
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
6228:
  _id_: 6228
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6229:
  _id_: 6229
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
6231:
  _id_: 6231
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6232:
  _id_: 6232
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6233:
  _id_: 6233
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6234:
  _id_: 6234
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6235:
  _id_: 6235
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6236:
  _id_: 6236
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3484
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
6237:
  _id_: 6237
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6238:
  _id_: 6238
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3486
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
6240:
  _id_: 6240
  attribute_id: 9
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Good Deeds
    ja: 善行を積む
    ko: 선행 쌓기
    zh_hant: 日行一善
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4113
  skill_field_effect_id: 153
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6241:
  _id_: 6241
  attribute_id: 9
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Admonition and Charity
    ja: 訓戒と施し
    ko: 훈계와 시혜
    zh_hant: 訓誡與施捨
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4114
  skill_field_effect_id: 154
  skill_options:
  - hit_rate: 100
    id: 509
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6242:
  _id_: 6242
  attribute_id: 9
  cost: 2
  icon_id: 295
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Reversal
    ja: 逆転の一閃
    ko: 역전의 일섬
    zh_hant: 逆轉閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4115
  skill_field_effect_id: 155
  skill_options:
  - hit_rate: 100
    id: 509
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6243:
  _id_: 6243
  attribute_id: 9
  cost: 2
  icon_id: 295
  is_multiple_command_unique_skill: 1
  name:
    en: Xmas Prayer
    ja: 聖夜の祈り
    ko: 성야의 기도
    zh_hant: 聖夜的祈禱
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4116
  skill_field_effect_id: 156
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 509
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 225
    - 236
    - 247
    - 258
    - 270
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6245:
  _id_: 6245
  attribute_id: 2
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Cold Glance
    ja: 冷酷な眼差し
    ko: 냉혹한 눈빛
    zh_hant: 冷酷的眼神
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4118
  skill_field_effect_id: 157
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6246:
  _id_: 6246
  attribute_id: 2
  cost: 2
  icon_id: 1037
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Sorcery
    ja: 黒魔術
    ko: 흑마술
    zh_hant: 黑魔法
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4119
  skill_field_effect_id: 158
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6247:
  _id_: 6247
  attribute_id: 2
  cost: 2
  icon_id: 1061
  is_multiple_command_unique_skill: 0
  name:
    en: Jealousy and Envy
    ja: 嫉妬と羨望
    ko: 질투와 선망
    zh_hant: 嫉妒與羨慕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4120
  skill_field_effect_id: 159
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6248:
  _id_: 6248
  attribute_id: 2
  cost: 2
  icon_id: 1023
  is_multiple_command_unique_skill: 0
  name:
    en: Giftigen Apfel
    ja: giftigen Apfel
    ko: Giftiger Apfel
    zh_hant: Giftiger Apfel
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4121
  skill_field_effect_id: 160
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 371
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 650
    - 660
    - 670
    - 680
    - 700
6254:
  _id_: 6254
  attribute_id: 8
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Flash
    ja: 煌めく一閃
    ko: 빛나는 일섬
    zh_hant: 輝煌閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4123
  skill_field_effect_id: 162
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6255:
  _id_: 6255
  attribute_id: 8
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Flash
    ja: 吸収の一閃
    ko: 흡수의 일섬
    zh_hant: 吸收閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4124
  skill_field_effect_id: 163
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6256:
  _id_: 6256
  attribute_id: 8
  cost: 2
  icon_id: 297
  is_multiple_command_unique_skill: 0
  name:
    en: Overwhelm Flash
    ja: 圧倒の一閃
    ko: 압도의 일섬
    zh_hant: 壓倒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4125
  skill_field_effect_id: 164
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 131
    - 137
    - 143
    - 150
    - 157
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6257:
  _id_: 6257
  attribute_id: 8
  cost: 2
  icon_id: 298
  is_multiple_command_unique_skill: 0
  name:
    en: Starting Jump!
    ja: 始まりのジャンプ！
    ko: 시작의 점프!
    zh_hant: 起始之跳躍！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4126
  skill_field_effect_id: 165
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 512
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 225
    - 236
    - 247
    - 258
    - 270
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
6259:
  _id_: 6259
  attribute_id: 3
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4128
  skill_field_effect_id: 166
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6260:
  _id_: 6260
  attribute_id: 3
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Hope
    ja: 希望の斬撃
    ko: 희망의 참격
    zh_hant: 希望斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4129
  skill_field_effect_id: 167
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 224
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6261:
  _id_: 6261
  attribute_id: 3
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Slash
    ja: 雷鳴の斬撃
    ko: 천둥의 참격
    zh_hant: 雷鳴斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4130
  skill_field_effect_id: 168
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2021
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6262:
  _id_: 6262
  attribute_id: 3
  cost: 2
  icon_id: 1038
  is_multiple_command_unique_skill: 1
  name:
    en: Fruits Co-Performance
    ja: フルーツたちの共演
    ko: 과일들의 합동 공연
    zh_hant: 各式水果的共演
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4131
  skill_field_effect_id: 169
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6264:
  _id_: 6264
  attribute_id: 3
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Hope
    ja: 希望の斬撃
    ko: 희망의 참격
    zh_hant: 希望斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4133
  skill_field_effect_id: 170
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6265:
  _id_: 6265
  attribute_id: 3
  cost: 2
  icon_id: 1057
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Vitality
    ja: 活力の斬撃
    ko: 활력의 참격
    zh_hant: 活力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4134
  skill_field_effect_id: 171
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6266:
  _id_: 6266
  attribute_id: 3
  cost: 3
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Slash
    ja: 煌めく斬撃
    ko: 빛나는 참격
    zh_hant: 輝煌斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4135
  skill_field_effect_id: 172
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1132
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6267:
  _id_: 6267
  attribute_id: 3
  cost: 2
  icon_id: 1064
  is_multiple_command_unique_skill: 1
  name:
    en: Pan's Flute
    ja: 牧神パーンの笛
    ko: 목신 판의 피리
    zh_hant: 牧神潘的潘笛
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4136
  skill_field_effect_id: 173
  skill_options:
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 548
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 197
    - 210
    - 220
    - 230
    - 240
6291:
  _id_: 6291
  attribute_id: 4
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Tango
    ja: 魅了のタンゴ
    ko: 매료의 탱고
    zh_hant: 魅惑的探戈
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4153
  skill_field_effect_id: 180
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6292:
  _id_: 6292
  attribute_id: 4
  cost: 2
  icon_id: 293
  is_multiple_command_unique_skill: 0
  name:
    en: La Caña of Sealing
    ja: 封印のカーニャ
    ko: 봉인의 카냐
    zh_hant: 封印的坎亞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 462
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 500
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 385
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
6293:
  _id_: 6293
  attribute_id: 4
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Solea of Freedom
    ja: 自由のソレア
    ko: 자유의 솔레아
    zh_hant: 自由的孤調
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4155
  skill_field_effect_id: 181
  skill_options:
  - hit_rate: 100
    id: 488
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 499
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6294:
  _id_: 6294
  attribute_id: 4
  cost: 2
  icon_id: 284
  is_multiple_command_unique_skill: 0
  name:
    en: Red Passion Flamenco
    ja: 紅き情熱のフラメンコ
    ko: 붉은 열정의 플라멩코
    zh_hant: 熱情如火的佛朗明哥
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4156
  skill_field_effect_id: 182
  skill_options:
  - hit_rate: 100
    id: 485
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 486
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 499
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6296:
  _id_: 6296
  attribute_id: 5
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4158
  skill_field_effect_id: 183
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6297:
  _id_: 6297
  attribute_id: 5
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4159
  skill_field_effect_id: 184
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6298:
  _id_: 6298
  attribute_id: 5
  cost: 3
  icon_id: 1069
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4160
  skill_field_effect_id: 185
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6299:
  _id_: 6299
  attribute_id: 5
  cost: 2
  icon_id: 1069
  is_multiple_command_unique_skill: 0
  name:
    en: Macaron Dream Encore
    ja: マカロン・ドリーム Encore
    ko: 마카롱 드림 Encore
    zh_hant: 馬卡龍幻夢 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4161
  skill_field_effect_id: 186
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6301:
  _id_: 6301
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Charm
    ja: 魅了の一閃
    ko: 매료의 일섬
    zh_hant: 魅惑閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4163
  skill_field_effect_id: 189
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6302:
  _id_: 6302
  attribute_id: 1
  cost: 2
  icon_id: 1036
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Arrest
    ja: 捕縛の一閃
    ko: 포박의 일섬
    zh_hant: 綁縛閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4164
  skill_field_effect_id: 190
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6303:
  _id_: 6303
  attribute_id: 1
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Swirling Flash
    ja: 渦巻く一閃
    ko: 소용돌이치는 일섬
    zh_hant: 螺旋閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4165
  skill_field_effect_id: 191
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6304:
  _id_: 6304
  attribute_id: 1
  cost: 2
  icon_id: 287
  is_multiple_command_unique_skill: 0
  name:
    en: Raise the Sails!
    ja: 出航！宝船
    ko: 출항! 보물선
    zh_hant: 出航！寶船
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4166
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 495
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 551
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6306:
  _id_: 6306
  attribute_id: 2
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Charm
    ja: 魅了の一閃
    ko: 매료의 일섬
    zh_hant: 魅惑閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4168
  skill_field_effect_id: 193
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6307:
  _id_: 6307
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Flash
    ja: 甘美な一閃
    ko: 감미로운 일섬
    zh_hant: 甘美閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4169
  skill_field_effect_id: 194
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6308:
  _id_: 6308
  attribute_id: 2
  cost: 3
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Ovation
    ja: 万雷の一閃
    ko: 만뢰의 일섬
    zh_hant: 萬雷閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4170
  skill_field_effect_id: 195
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6309:
  _id_: 6309
  attribute_id: 2
  cost: 2
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Pumpkin Trick Encore
    ja: パンプキントリック Encore
    ko: 펌프킨 트릭 Encore
    zh_hant: 南瓜戲法 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4171
  skill_field_effect_id: 196
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6323:
  _id_: 6323
  attribute_id: 4
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Nightmare Slash
    ja: 悪夢の斬撃
    ko: 악몽의 참격
    zh_hant: 惡夢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4184
  skill_field_effect_id: 200
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 470
    target_id: 2051
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6324:
  _id_: 6324
  attribute_id: 4
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4185
  skill_field_effect_id: 201
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6325:
  _id_: 6325
  attribute_id: 4
  cost: 2
  icon_id: 1057
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Vitality
    ja: 活力の斬撃
    ko: 활력의 참격
    zh_hant: 活力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4186
  skill_field_effect_id: 202
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
6326:
  _id_: 6326
  attribute_id: 4
  cost: 2
  icon_id: 1039
  is_multiple_command_unique_skill: 1
  name:
    en: Love Dripping Magic
    ja: 滴る恋の魔法
    ko: 싱그러운 사랑의 마법
    zh_hant: 滴答的戀愛魔法
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4187
  skill_field_effect_id: 203
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 548
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6328:
  _id_: 6328
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6329:
  _id_: 6329
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6330:
  _id_: 6330
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6331:
  _id_: 6331
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6332:
  _id_: 6332
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6333:
  _id_: 6333
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6334:
  _id_: 6334
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6335:
  _id_: 6335
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6336:
  _id_: 6336
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6337:
  _id_: 6337
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6338:
  _id_: 6338
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6340:
  _id_: 6340
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6341:
  _id_: 6341
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6342:
  _id_: 6342
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6343:
  _id_: 6343
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6344:
  _id_: 6344
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6345:
  _id_: 6345
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6346:
  _id_: 6346
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6347:
  _id_: 6347
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6348:
  _id_: 6348
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6349:
  _id_: 6349
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6350:
  _id_: 6350
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6352:
  _id_: 6352
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6353:
  _id_: 6353
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6354:
  _id_: 6354
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6355:
  _id_: 6355
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6356:
  _id_: 6356
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6357:
  _id_: 6357
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6358:
  _id_: 6358
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6359:
  _id_: 6359
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6360:
  _id_: 6360
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6361:
  _id_: 6361
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6362:
  _id_: 6362
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6364:
  _id_: 6364
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6365:
  _id_: 6365
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6366:
  _id_: 6366
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6367:
  _id_: 6367
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6368:
  _id_: 6368
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6369:
  _id_: 6369
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6370:
  _id_: 6370
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6371:
  _id_: 6371
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6372:
  _id_: 6372
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6373:
  _id_: 6373
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6374:
  _id_: 6374
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6376:
  _id_: 6376
  attribute_id: 2
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Smash
    ja: 魅了の打撃
    ko: 매료의 타격
    zh_hant: 魅惑敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4189
  skill_field_effect_id: 205
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6377:
  _id_: 6377
  attribute_id: 2
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Smash
    ja: 重圧の打撃
    ko: 중압의 타격
    zh_hant: 重壓敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4190
  skill_field_effect_id: 206
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6378:
  _id_: 6378
  attribute_id: 2
  cost: 2
  icon_id: 1057
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Vitality
    ja: 活力の打撃
    ko: 활력의 타격
    zh_hant: 活力敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4191
  skill_field_effect_id: 207
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6379:
  _id_: 6379
  attribute_id: 2
  cost: 2
  icon_id: 301
  is_multiple_command_unique_skill: 1
  name:
    en: End of the Dream
    ja: 夢の終わりに
    ko: 꿈의 끝으로
    zh_hant: 夢想的終焉
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4192
  skill_field_effect_id: 208
  skill_options:
  - hit_rate: 100
    id: 557
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6381:
  _id_: 6381
  attribute_id: 5
  cost: 1
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Smash
    ja: 封印の打撃
    ko: 봉인의 타격
    zh_hant: 封印敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4194
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6382:
  _id_: 6382
  attribute_id: 5
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4195
  skill_field_effect_id: 211
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6383:
  _id_: 6383
  attribute_id: 5
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4196
  skill_field_effect_id: 212
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6384:
  _id_: 6384
  attribute_id: 5
  cost: 2
  icon_id: 1071
  is_multiple_command_unique_skill: 1
  name:
    en: Torrent of Beauty
    ja: 美しき奔流
    ko: 아름다운 분류
    zh_hant: 美麗激流
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4197
  skill_field_effect_id: 213
  skill_options:
  - hit_rate: 100
    id: 7
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 462
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 385
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 3000
    - 3500
    - 4000
    - 4500
    - 5000
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6386:
  _id_: 6386
  attribute_id: 9
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4199
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 447
    target_id: 1132
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6387:
  _id_: 6387
  attribute_id: 9
  cost: 2
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Resolute Slash
    ja: 覚悟の斬撃
    ko: 각오의 참격
    zh_hant: 覺悟斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4200
  skill_field_effect_id: 216
  skill_options:
  - hit_rate: 100
    id: 447
    target_id: 1132
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6388:
  _id_: 6388
  attribute_id: 9
  cost: 2
  icon_id: 1054
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4201
  skill_field_effect_id: 217
  skill_options:
  - hit_rate: 100
    id: 447
    target_id: 1132
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6389:
  _id_: 6389
  attribute_id: 9
  cost: 1
  icon_id: 1074
  is_multiple_command_unique_skill: 0
  name:
    en: Flowers of Evil
    ja: Flowers of Evil
    ko: Flowers of Evil
    zh_hant: Flowers of Evil
  optional_description:
    en: 'Guest Use: Aggro Not Applied'
    ja: ゲスト使用時、ターゲット固定は適用外
    ko: 게스트 사용 시, 타깃 고정은 적용되지 않음
    zh_hant: 使用來賓時，目標鎖定無效
  sequence_id: 4202
  skill_field_effect_id: 218
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 225
    - 234
    - 243
    - 252
    - 270
  - hit_rate: 100
    id: 432
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6392:
  _id_: 6392
  attribute_id: 1
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4204
  skill_field_effect_id: 221
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6393:
  _id_: 6393
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4205
  skill_field_effect_id: 222
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6394:
  _id_: 6394
  attribute_id: 1
  cost: 3
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4206
  skill_field_effect_id: 223
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6395:
  _id_: 6395
  attribute_id: 1
  cost: 2
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Inferno Shadow Art Encore
    ja: 火影の術 Encore
    ko: 화영의 술법 Encore
    zh_hant: 火影之術 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4207
  skill_field_effect_id: 224
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6397:
  _id_: 6397
  attribute_id: 6
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Slash
    ja: 雷鳴の斬撃
    ko: 천둥의 참격
    zh_hant: 雷鳴斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4209
  skill_field_effect_id: 226
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 565
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6398:
  _id_: 6398
  attribute_id: 6
  cost: 2
  icon_id: 1060
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4210
  skill_field_effect_id: 227
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6399:
  _id_: 6399
  attribute_id: 6
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4211
  skill_field_effect_id: 228
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6400:
  _id_: 6400
  attribute_id: 6
  cost: 2
  icon_id: 1075
  is_multiple_command_unique_skill: 1
  name:
    en: Toys - Psychokinesis
    ja: トイズ～サイコキネシス～
    ko: 토이즈 ~사이코키네시스~
    zh_hant: TOYS～念動力～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4212
  skill_field_effect_id: 229
  skill_options:
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 31
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 500000
    - 500000
    - 500000
    - 500000
    - 500000
6402:
  _id_: 6402
  attribute_id: 1
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4219
  skill_field_effect_id: 237
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 35
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6403:
  _id_: 6403
  attribute_id: 1
  cost: 2
  icon_id: 1046
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4220
  skill_field_effect_id: 238
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6404:
  _id_: 6404
  attribute_id: 1
  cost: 2
  icon_id: 1009
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4221
  skill_field_effect_id: 239
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6405:
  _id_: 6405
  attribute_id: 1
  cost: 2
  icon_id: 194
  is_multiple_command_unique_skill: 0
  name:
    en: Toys - Tri-Ascend
    ja: トイズ～トライアセンド～
    ko: 토이즈 ~트라이어센드~
    zh_hant: TOYS～三重上升～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4222
  skill_field_effect_id: 240
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 8
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 431
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
6407:
  _id_: 6407
  attribute_id: 5
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4214
  skill_field_effect_id: 231
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6408:
  _id_: 6408
  attribute_id: 5
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Sharpshooting
    ja: 魅了の狙撃
    ko: 매료의 저격
    zh_hant: 魅惑狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4215
  skill_field_effect_id: 232
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 347
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6409:
  _id_: 6409
  attribute_id: 5
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Sharpshooting
    ja: 雷鳴の狙撃
    ko: 천둥의 저격
    zh_hant: 雷鳴狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4216
  skill_field_effect_id: 233
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6410:
  _id_: 6410
  attribute_id: 5
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 1
  name:
    en: Toys - Hyper Sensitive
    ja: トイズ～ハイパーセンシティブ～
    ko: 토이즈 ~하이퍼 센서티브~
    zh_hant: TOYS～五感強化～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4217
  skill_field_effect_id: 234
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6412:
  _id_: 6412
  attribute_id: 4
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4224
  skill_field_effect_id: 244
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6413:
  _id_: 6413
  attribute_id: 4
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4225
  skill_field_effect_id: 245
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6414:
  _id_: 6414
  attribute_id: 4
  cost: 2
  icon_id: 1039
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4226
  skill_field_effect_id: 246
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 570
    target_id: 1701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6415:
  _id_: 6415
  attribute_id: 4
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Tornado of Beginning
    ja: はじまりの竜巻
    ko: 시작의 회오리
    zh_hant: 起始的龍捲風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4227
  skill_field_effect_id: 247
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 551
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6417:
  _id_: 6417
  attribute_id: 6
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4229
  skill_field_effect_id: 250
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6418:
  _id_: 6418
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4230
  skill_field_effect_id: 251
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6419:
  _id_: 6419
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4231
  skill_field_effect_id: 252
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6420:
  _id_: 6420
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Cross of Retribution Encore
    ja: 聖罰の十字架 Encore
    ko: 성벌의 십자가 Encore
    zh_hant: 聖罰十字架 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4232
  skill_field_effect_id: 253
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6422:
  _id_: 6422
  attribute_id: 7
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4234
  skill_field_effect_id: 255
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6423:
  _id_: 6423
  attribute_id: 7
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4235
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 36
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 231
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6424:
  _id_: 6424
  attribute_id: 7
  cost: 2
  icon_id: 1057
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Vitality
    ja: 活力の斬撃
    ko: 활력의 참격
    zh_hant: 活力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4236
  skill_field_effect_id: 256
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1132
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6425:
  _id_: 6425
  attribute_id: 7
  cost: 2
  icon_id: 1077
  is_multiple_command_unique_skill: 1
  name:
    en: Toys - Direct Hack
    ja: トイズ～ダイレクトハック～
    ko: 토이즈 ~다이렉트 핵~
    zh_hant: TOYS～電子入侵～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4237
  skill_field_effect_id: 257
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 571
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6439:
  _id_: 6439
  attribute_id: 8
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4250
  skill_field_effect_id: 259
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6440:
  _id_: 6440
  attribute_id: 8
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4251
  skill_field_effect_id: 260
  skill_options:
  - hit_rate: 100
    id: 548
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6441:
  _id_: 6441
  attribute_id: 8
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Slash
    ja: 吸収の斬撃
    ko: 흡수의 참격
    zh_hant: 吸收斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4252
  skill_field_effect_id: 261
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6442:
  _id_: 6442
  attribute_id: 8
  cost: 2
  icon_id: 1056
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Beliefs
    ja: 信念の照らすもの
    ko: 신념을 비추는 것
    zh_hant: 照亮信念者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4253
  skill_field_effect_id: 262
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 480
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 477
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 86
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
6459:
  _id_: 6459
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Flash
    ja: 輝く一閃
    ko: 반짝이는 일섬
    zh_hant: 輝耀閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4263
  skill_field_effect_id: 265
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6460:
  _id_: 6460
  attribute_id: 1
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Charm
    ja: 魅了の一閃
    ko: 매료의 일섬
    zh_hant: 魅惑閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4264
  skill_field_effect_id: 266
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 251
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6461:
  _id_: 6461
  attribute_id: 1
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Flash
    ja: 封印の一閃
    ko: 봉인의 일섬
    zh_hant: 封印閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4265
  skill_field_effect_id: 267
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 252
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6462:
  _id_: 6462
  attribute_id: 1
  cost: 2
  icon_id: 1079
  is_multiple_command_unique_skill: 0
  name:
    en: Snow Footprints
    ja: 雪の足跡
    ko: 눈의 발자취
    zh_hant: 雪的腳印
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4266
  skill_field_effect_id: 268
  skill_options:
  - hit_rate: 100
    id: 156
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6464:
  _id_: 6464
  attribute_id: 3
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Charm
    ja: 魅了の一閃
    ko: 매료의 일섬
    zh_hant: 魅惑閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4268
  skill_field_effect_id: 271
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6465:
  _id_: 6465
  attribute_id: 3
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Flash
    ja: 甘美な一閃
    ko: 감미로운 일섬
    zh_hant: 甘美閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4269
  skill_field_effect_id: 272
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6466:
  _id_: 6466
  attribute_id: 3
  cost: 2
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Ovation
    ja: 万雷の一閃
    ko: 만뢰의 일섬
    zh_hant: 萬雷閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4270
  skill_field_effect_id: 273
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6467:
  _id_: 6467
  attribute_id: 3
  cost: 2
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Fuoco! Encore
    ja: Fuoco! Encore
    ko: Fuoco! Encore
    zh_hant: Fuoco! Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4271
  skill_field_effect_id: 274
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6469:
  _id_: 6469
  attribute_id: 1
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4273
  skill_field_effect_id: 276
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6470:
  _id_: 6470
  attribute_id: 1
  cost: 2
  icon_id: 1071
  is_multiple_command_unique_skill: 0
  name:
    en: Elegant Slash
    ja: 風雅な斬撃
    ko: 고상한 참격
    zh_hant: 文雅斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4274
  skill_field_effect_id: 277
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6471:
  _id_: 6471
  attribute_id: 1
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Slash
    ja: 灰色の斬撃
    ko: 잿빛의 참격
    zh_hant: 灰色斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4275
  skill_field_effect_id: 278
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6472:
  _id_: 6472
  attribute_id: 1
  cost: 2
  icon_id: 1078
  is_multiple_command_unique_skill: 1
  name:
    en: Pisces' Bubbles
    ja: 双魚の水沫
    ko: 쌍어의 물보라
    zh_hant: 雙魚的水花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4276
  skill_field_effect_id: 279
  skill_options:
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 123
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6478:
  _id_: 6478
  attribute_id: 1
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Dynamic Strike
    ja: 豪快な一撃
    ko: 호쾌한 일격
    zh_hant: 豪爽一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4278
  skill_field_effect_id: 282
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6479:
  _id_: 6479
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Hope
    ja: 希望の一撃
    ko: 희망의 일격
    zh_hant: 希望一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4279
  skill_field_effect_id: 283
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 462
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6480:
  _id_: 6480
  attribute_id: 1
  cost: 2
  icon_id: 313
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Strike
    ja: 猛攻の一撃
    ko: 맹공의 일격
    zh_hant: 猛攻一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4280
  skill_field_effect_id: 284
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 580
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 22
    - 24
    - 27
    - 30
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6481:
  _id_: 6481
  attribute_id: 1
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Passion
    ja: 情熱の照らすもの
    ko: 정열을 비추는 것
    zh_hant: 照亮熱情者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4281
  skill_field_effect_id: 285
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 391
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6483:
  _id_: 6483
  attribute_id: 6
  cost: 2
  icon_id: 293
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4283
  skill_field_effect_id: 288
  skill_options:
  - hit_rate: 100
    id: 500
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6484:
  _id_: 6484
  attribute_id: 6
  cost: 2
  icon_id: 314
  is_multiple_command_unique_skill: 0
  name:
    en: Cursed Slash
    ja: 呪いの斬撃
    ko: 저주의 참격
    zh_hant: 詛咒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4284
  skill_field_effect_id: 289
  skill_options:
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 251
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6485:
  _id_: 6485
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4285
  skill_field_effect_id: 290
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 252
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6486:
  _id_: 6486
  attribute_id: 6
  cost: 2
  icon_id: 284
  is_multiple_command_unique_skill: 0
  name:
    en: Myriad of Flowers
    ja: 百花斉放、華うらら
    ko: 백화제방, 화려한 꽃
    zh_hant: 百花爭妍、萬紫千紅
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4286
  skill_field_effect_id: 291
  skill_options:
  - hit_rate: 100
    id: 485
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 486
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6488:
  _id_: 6488
  attribute_id: 4
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4288
  skill_field_effect_id: 293
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6489:
  _id_: 6489
  attribute_id: 4
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4289
  skill_field_effect_id: 294
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6490:
  _id_: 6490
  attribute_id: 4
  cost: 2
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4290
  skill_field_effect_id: 295
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6491:
  _id_: 6491
  attribute_id: 4
  cost: 2
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Peach Oath Encore
    ja: 桃園の誓い Encore
    ko: 도원의 맹세 Encore
    zh_hant: 桃園三結義 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4291
  skill_field_effect_id: 296
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6493:
  _id_: 6493
  attribute_id: 4
  cost: 1
  icon_id: 305
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Slash
    ja: 反攻の斬撃
    ko: 반격의 참격
    zh_hant: 反攻斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4293
  skill_field_effect_id: 300
  skill_options:
  - hit_rate: 100
    id: 565
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6494:
  _id_: 6494
  attribute_id: 4
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4294
  skill_field_effect_id: 301
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6495:
  _id_: 6495
  attribute_id: 4
  cost: 2
  icon_id: 306
  is_multiple_command_unique_skill: 0
  name:
    en: Dynamic Slash
    ja: 豪快な斬撃
    ko: 호쾌한 참격
    zh_hant: 豪爽斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4295
  skill_field_effect_id: 302
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 445
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6496:
  _id_: 6496
  attribute_id: 4
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliance of Guidance
    ja: 導きのキラめき
    ko: 인도의 반짝임
    zh_hant: 引導的光芒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4296
  skill_field_effect_id: 303
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 462
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6498:
  _id_: 6498
  attribute_id: 2
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Flash
    ja: 灰色の一閃
    ko: 잿빛의 일섬
    zh_hant: 灰色閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4298
  skill_field_effect_id: 306
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6499:
  _id_: 6499
  attribute_id: 2
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Swirling Flash
    ja: 渦巻く一閃
    ko: 소용돌이치는 일섬
    zh_hant: 螺旋閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4299
  skill_field_effect_id: 307
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6500:
  _id_: 6500
  attribute_id: 2
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Support
    ja: 支援の一閃
    ko: 지원의 일섬
    zh_hant: 支援閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4300
  skill_field_effect_id: 308
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6501:
  _id_: 6501
  attribute_id: 2
  cost: 2
  icon_id: 1081
  is_multiple_command_unique_skill: 0
  name:
    en: Absurd Joke
    ja: 不条理な戯れ
    ko: 부조리한 장난
    zh_hant: 荒誕的打鬧
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4301
  skill_field_effect_id: 309
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6503:
  _id_: 6503
  attribute_id: 6
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Flash
    ja: 軽快な一閃
    ko: 경쾌한 일섬
    zh_hant: 輕快閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4303
  skill_field_effect_id: 312
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6504:
  _id_: 6504
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Flash
    ja: 甘美な一閃
    ko: 감미로운 일섬
    zh_hant: 甘美閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4304
  skill_field_effect_id: 313
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6505:
  _id_: 6505
  attribute_id: 6
  cost: 3
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Ovation
    ja: 万雷の一閃
    ko: 만뢰의 일섬
    zh_hant: 萬雷閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4305
  skill_field_effect_id: 314
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6506:
  _id_: 6506
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Hop Hip★ Attack Encore
    ja: ホップヒップ★アタック Encore
    ko: 합힙★어택 Encore
    zh_hant: 躍進★攻擊 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4306
  skill_field_effect_id: 315
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6520:
  _id_: 6520
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6521:
  _id_: 6521
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6522:
  _id_: 6522
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6523:
  _id_: 6523
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6524:
  _id_: 6524
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6525:
  _id_: 6525
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6526:
  _id_: 6526
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6527:
  _id_: 6527
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6528:
  _id_: 6528
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6529:
  _id_: 6529
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6530:
  _id_: 6530
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6532:
  _id_: 6532
  attribute_id: 9
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Slash
    ja: 雷鳴の斬撃
    ko: 천둥의 참격
    zh_hant: 雷鳴斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4308
  skill_field_effect_id: 317
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6533:
  _id_: 6533
  attribute_id: 9
  cost: 2
  icon_id: 1044
  is_multiple_command_unique_skill: 0
  name:
    en: Charming Slash
    ja: 魅了の斬撃
    ko: 매료의 참격
    zh_hant: 魅惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4309
  skill_field_effect_id: 318
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6534:
  _id_: 6534
  attribute_id: 9
  cost: 2
  icon_id: 1054
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4310
  skill_field_effect_id: 319
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2051
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6535:
  _id_: 6535
  attribute_id: 9
  cost: 2
  icon_id: 298
  is_multiple_command_unique_skill: 0
  name:
    en: Noble Baumkuchen
    ja: 高貴なるバウムクーヘン
    ko: 고귀한 바움쿠헨
    zh_hant: 高貴的年輪蛋糕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4311
  skill_field_effect_id: 320
  skill_options:
  - hit_rate: 100
    id: 512
    target_id: 4157
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 123
    target_id: 4157
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 393
    target_id: 6010
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6537:
  _id_: 6537
  attribute_id: 4
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4324
  skill_field_effect_id: 323
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6538:
  _id_: 6538
  attribute_id: 4
  cost: 2
  icon_id: 1071
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4325
  skill_field_effect_id: 324
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6539:
  _id_: 6539
  attribute_id: 4
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Slash
    ja: 苦悶の斬撃
    ko: 고민의 참격
    zh_hant: 苦悶斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4326
  skill_field_effect_id: 325
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6540:
  _id_: 6540
  attribute_id: 4
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 1
  name:
    en: Dreaming Sheep
    ja: Dreaming sheep
    ko: Dreaming sheep
    zh_hant: Dreaming sheep
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4327
  skill_field_effect_id: 326
  skill_options:
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 580
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6542:
  _id_: 6542
  attribute_id: 3
  cost: 1
  icon_id: 3001
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Smash
    ja: 反撃の打撃
    ko: 반격의 타격
    zh_hant: 反擊敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4329
  skill_field_effect_id: 329
  skill_options:
  - hit_rate: 100
    id: 565
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6543:
  _id_: 6543
  attribute_id: 3
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Smash
    ja: 重圧の打撃
    ko: 중압의 타격
    zh_hant: 重壓敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4330
  skill_field_effect_id: 330
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6544:
  _id_: 6544
  attribute_id: 3
  cost: 2
  icon_id: 178
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Smash
    ja: 封印の打撃
    ko: 봉인의 타격
    zh_hant: 封印敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4331
  skill_field_effect_id: 331
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 251
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 252
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6545:
  _id_: 6545
  attribute_id: 3
  cost: 2
  icon_id: 321
  is_multiple_command_unique_skill: 0
  name:
    en: Blessed Wind
    ja: 祝福の南風
    ko: 축복의 남풍
    zh_hant: 祝福之南風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4332
  skill_field_effect_id: 332
  skill_options:
  - hit_rate: 100
    id: 156
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6547:
  _id_: 6547
  attribute_id: 2
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4334
  skill_field_effect_id: 335
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6548:
  _id_: 6548
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Smash
    ja: 甘美な打撃
    ko: 감미로운 타격
    zh_hant: 甘美敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4335
  skill_field_effect_id: 336
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6549:
  _id_: 6549
  attribute_id: 2
  cost: 2
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Ovation
    ja: 万雷の打撃
    ko: 만뢰의 타격
    zh_hant: 萬雷敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4336
  skill_field_effect_id: 337
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6550:
  _id_: 6550
  attribute_id: 2
  cost: 2
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Raise the Flag! Encore
    ja: 旗揚げ号令！ Encore
    ko: 깃발 들기 호령! Encore
    zh_hant: 舉旗號令！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4337
  skill_field_effect_id: 338
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6552:
  _id_: 6552
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Thrust
    ja: 軽快な刺突
    ko: 경쾌한 찌르기
    zh_hant: 輕快突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4339
  skill_field_effect_id: 340
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6553:
  _id_: 6553
  attribute_id: 4
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4340
  skill_field_effect_id: 341
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6554:
  _id_: 6554
  attribute_id: 4
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Thrust
    ja: 雷鳴の刺突
    ko: 천둥의 찌르기
    zh_hant: 雷鳴突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4341
  skill_field_effect_id: 342
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6555:
  _id_: 6555
  attribute_id: 4
  cost: 2
  icon_id: 316
  is_multiple_command_unique_skill: 1
  name:
    en: Snow Melting Encore
    ja: 雪解 Encore
    ko: 눈석임 Encore
    zh_hant: 融雪 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4342
  skill_field_effect_id: 343
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 363
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6557:
  _id_: 6557
  attribute_id: 8
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4344
  skill_field_effect_id: 346
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6558:
  _id_: 6558
  attribute_id: 8
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4345
  skill_field_effect_id: 347
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6559:
  _id_: 6559
  attribute_id: 8
  cost: 3
  icon_id: 1083
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Applauses
    ja: 喝采の斬撃
    ko: 갈채의 참격
    zh_hant: 喝采斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4346
  skill_field_effect_id: 348
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6560:
  _id_: 6560
  attribute_id: 8
  cost: 2
  icon_id: 1083
  is_multiple_command_unique_skill: 0
  name:
    en: Justice Blitz Encore
    ja: 正義の雷光 Encore
    ko: 정의의 번개 Encore
    zh_hant: 正義的雷光 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4347
  skill_field_effect_id: 349
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6562:
  _id_: 6562
  attribute_id: 3
  cost: 1
  icon_id: 3001
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Strike
    ja: 反攻の一撃
    ko: 반격의 일격
    zh_hant: 反攻一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4349
  skill_field_effect_id: 351
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6563:
  _id_: 6563
  attribute_id: 3
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Strike
    ja: 重圧の一撃
    ko: 중압의 일격
    zh_hant: 重壓一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4350
  skill_field_effect_id: 352
  skill_options:
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6564:
  _id_: 6564
  attribute_id: 3
  cost: 2
  icon_id: 1056
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Strike
    ja: 苦悶の一撃
    ko: 고민의 일격
    zh_hant: 苦悶一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4351
  skill_field_effect_id: 353
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6565:
  _id_: 6565
  attribute_id: 3
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Aggressive Coyote Encore
    ja: 牙剝くコヨーテ Encore
    ko: 사나운 코요테 Encore
    zh_hant: 露出獠牙的郊狼 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4352
  skill_field_effect_id: 354
  skill_options:
  - hit_rate: 100
    id: 123
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6567:
  _id_: 6567
  attribute_id: 6
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Slash
    ja: 灰色の斬撃
    ko: 잿빛의 참격
    zh_hant: 灰色斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4354
  skill_field_effect_id: 357
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6568:
  _id_: 6568
  attribute_id: 6
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Profuse Slash
    ja: 繚乱の斬撃
    ko: 요란의 참격
    zh_hant: 繚亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4355
  skill_field_effect_id: 358
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6569:
  _id_: 6569
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Applauses
    ja: 喝采の斬撃
    ko: 갈채의 참격
    zh_hant: 喝采斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4356
  skill_field_effect_id: 359
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6570:
  _id_: 6570
  attribute_id: 6
  cost: 2
  icon_id: 1072
  is_multiple_command_unique_skill: 0
  name:
    en: Spark That Illuminates the Truth
    ja: 真実を照らし出す、一筋の閃き
    ko: 진실을 비추는 한 줄기의 섬광
    zh_hant: 點亮真相的一閃
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4357
  skill_field_effect_id: 360
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6572:
  _id_: 6572
  attribute_id: 3
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4359
  skill_field_effect_id: 363
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6573:
  _id_: 6573
  attribute_id: 3
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4360
  skill_field_effect_id: 364
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6574:
  _id_: 6574
  attribute_id: 3
  cost: 3
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4361
  skill_field_effect_id: 365
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6575:
  _id_: 6575
  attribute_id: 3
  cost: 2
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Fan Rosette Encore
    ja: 扇の花結び Encore
    ko: 부채 꽃매듭 Encore
    zh_hant: 花結之扇 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4362
  skill_field_effect_id: 366
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6629:
  _id_: 6629
  attribute_id: 9
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Flash
    ja: 雷鳴の一閃
    ko: 천둥의 일섬
    zh_hant: 雷鳴閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4375
  skill_field_effect_id: 376
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6630:
  _id_: 6630
  attribute_id: 9
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Flash
    ja: 輝く一閃
    ko: 반짝이는 일섬
    zh_hant: 輝耀閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4376
  skill_field_effect_id: 377
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6631:
  _id_: 6631
  attribute_id: 9
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Flash
    ja: 苦悶の一閃
    ko: 고민의 일섬
    zh_hant: 苦悶閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4377
  skill_field_effect_id: 378
  skill_options:
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6632:
  _id_: 6632
  attribute_id: 9
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 1
  name:
    en: Sea God's Majesty
    ja: 海神の威
    ko: 해신의 위엄
    zh_hant: 海神之威
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4378
  skill_field_effect_id: 379
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 250
    - 260
    - 270
    - 280
    - 300
6634:
  _id_: 6634
  attribute_id: 8
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Slash
    ja: 雷鳴の斬撃
    ko: 천둥의 참격
    zh_hant: 雷鳴斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4380
  skill_field_effect_id: 382
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6635:
  _id_: 6635
  attribute_id: 8
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4381
  skill_field_effect_id: 383
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6636:
  _id_: 6636
  attribute_id: 8
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Slash
    ja: 苦悶の斬撃
    ko: 고민의 참격
    zh_hant: 苦悶斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4382
  skill_field_effect_id: 384
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 1
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6637:
  _id_: 6637
  attribute_id: 8
  cost: 2
  icon_id: 324
  is_multiple_command_unique_skill: 1
  name:
    en: Cup of Paradise
    ja: 極楽の盞
    ko: 극락의 술잔
    zh_hant: 極樂杯盞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4383
  skill_field_effect_id: 385
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 596
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 250
    - 260
    - 270
    - 280
    - 300
6654:
  _id_: 6654
  attribute_id: 2
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Slash
    ja: 雷鳴の斬撃
    ko: 천둥의 참격
    zh_hant: 雷鳴斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4389
  skill_field_effect_id: 388
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 565
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6655:
  _id_: 6655
  attribute_id: 2
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4390
  skill_field_effect_id: 389
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6656:
  _id_: 6656
  attribute_id: 2
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Slash
    ja: 苦悶の斬撃
    ko: 고민의 참격
    zh_hant: 苦悶斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4391
  skill_field_effect_id: 390
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6657:
  _id_: 6657
  attribute_id: 2
  cost: 2
  icon_id: 1085
  is_multiple_command_unique_skill: 1
  name:
    en: Charging Ahead in a Starry Night
    ja: 星夜の猛進
    ko: 성야의 맹진
    zh_hant: 星夜突進
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4392
  skill_field_effect_id: 391
  skill_options:
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 88
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6659:
  _id_: 6659
  attribute_id: 8
  cost: 1
  icon_id: 152
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Slash
    ja: 守護の斬撃
    ko: 수호의 참격
    zh_hant: 守護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4394
  skill_field_effect_id: 394
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6660:
  _id_: 6660
  attribute_id: 8
  cost: 1
  icon_id: 1083
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Applauses
    ja: 喝采の斬撃
    ko: 갈채의 참격
    zh_hant: 喝采斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4395
  skill_field_effect_id: 395
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 152
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6661:
  _id_: 6661
  attribute_id: 8
  cost: 1
  icon_id: 1074
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Control
    ja: 支配の斬撃
    ko: 지배의 참격
    zh_hant: 支配斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4396
  skill_field_effect_id: 396
  skill_options:
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 152
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6662:
  _id_: 6662
  attribute_id: 8
  cost: 1
  icon_id: 1079
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope Encore
    ja: 希望の乱舞 Encore
    ko: 희망의 난무 Encore
    zh_hant: 希望亂舞 Encore
  optional_description:
    en: 'Guest Use: Aggro Not Applied'
    ja: ゲスト使用時、ターゲット固定は適用外
    ko: 게스트 사용 시, 타깃 고정은 적용되지 않음
    zh_hant: 使用來賓時，目標鎖定無效
  sequence_id: 4397
  skill_field_effect_id: 397
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 432
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6674:
  _id_: 6674
  attribute_id: 2
  cost: 1
  icon_id: 3004
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Smash
    ja: 反射の打撃
    ko: 반사의 타격
    zh_hant: 反射敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4399
  skill_field_effect_id: 400
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6675:
  _id_: 6675
  attribute_id: 2
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Smash
    ja: 重圧の打撃
    ko: 중압의 타격
    zh_hant: 重壓敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4400
  skill_field_effect_id: 401
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6676:
  _id_: 6676
  attribute_id: 2
  cost: 2
  icon_id: 314
  is_multiple_command_unique_skill: 0
  name:
    en: Demolition Strike
    ja: 解体の打撃
    ko: 해체의 타격
    zh_hant: 解體敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4401
  skill_field_effect_id: 402
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6677:
  _id_: 6677
  attribute_id: 2
  cost: 2
  icon_id: 45
  is_multiple_command_unique_skill: 0
  name:
    en: Love Heart Impact
    ja: ラブハート・インパクト
    ko: 러브 하트 임팩트
    zh_hant: 愛心衝擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4402
  skill_field_effect_id: 403
  skill_options:
  - hit_rate: 100
    id: 241
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6679:
  _id_: 6679
  attribute_id: 5
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4404
  skill_field_effect_id: 407
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6680:
  _id_: 6680
  attribute_id: 5
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Smash
    ja: 甘美な打撃
    ko: 감미로운 타격
    zh_hant: 甘美敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4405
  skill_field_effect_id: 408
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6681:
  _id_: 6681
  attribute_id: 5
  cost: 3
  icon_id: 1069
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Ovation
    ja: 万雷の打撃
    ko: 만뢰의 타격
    zh_hant: 萬雷敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4406
  skill_field_effect_id: 409
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6682:
  _id_: 6682
  attribute_id: 5
  cost: 2
  icon_id: 1069
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Crime at Night Encore
    ja: 闇夜の完全犯罪 Encore
    ko: 암야의 완전범죄 Encore
    zh_hant: 暗夜的完美犯罪 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4407
  skill_field_effect_id: 410
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6684:
  _id_: 6684
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Thrust
    ja: 甘美な刺突
    ko: 감미로운 찌르기
    zh_hant: 甘美突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4409
  skill_field_effect_id: 412
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 367
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6685:
  _id_: 6685
  attribute_id: 2
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4410
  skill_field_effect_id: 413
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 367
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6686:
  _id_: 6686
  attribute_id: 2
  cost: 2
  icon_id: 1037
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Applauses
    ja: 喝采の刺突
    ko: 갈채의 찌르기
    zh_hant: 喝采突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4411
  skill_field_effect_id: 414
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 471
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 367
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6687:
  _id_: 6687
  attribute_id: 2
  cost: 2
  icon_id: 1087
  is_multiple_command_unique_skill: 1
  name:
    en: Oni's Fist Encore
    ja: 鬼の鉄拳 Encore
    ko: 악마의 철권 Encore
    zh_hant: 鬼之鐵拳 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4412
  skill_field_effect_id: 415
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 367
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6689:
  _id_: 6689
  attribute_id: 1
  cost: 1
  icon_id: 3003
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4414
  skill_field_effect_id: 418
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6690:
  _id_: 6690
  attribute_id: 1
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4415
  skill_field_effect_id: 419
  skill_options:
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6691:
  _id_: 6691
  attribute_id: 1
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4416
  skill_field_effect_id: 420
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 463
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6692:
  _id_: 6692
  attribute_id: 1
  cost: 2
  icon_id: 1089
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Pride
    ja: 誇りの照らすもの
    ko: 긍지가 비추는 것
    zh_hant: 照亮榮耀者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4417
  skill_field_effect_id: 421
  skill_options:
  - hit_rate: 100
    id: 123
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6694:
  _id_: 6694
  attribute_id: 5
  cost: 1
  icon_id: 3005
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4419
  skill_field_effect_id: 424
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6695:
  _id_: 6695
  attribute_id: 5
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4420
  skill_field_effect_id: 425
  skill_options:
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6696:
  _id_: 6696
  attribute_id: 5
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4421
  skill_field_effect_id: 426
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6697:
  _id_: 6697
  attribute_id: 5
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Hope
    ja: 希望の照らすもの
    ko: 희망이 비추는 것
    zh_hant: 照亮希望者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4422
  skill_field_effect_id: 427
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6700:
  _id_: 6700
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6701:
  _id_: 6701
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6702:
  _id_: 6702
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6703:
  _id_: 6703
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6704:
  _id_: 6704
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6705:
  _id_: 6705
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6706:
  _id_: 6706
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6707:
  _id_: 6707
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6709:
  _id_: 6709
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6710:
  _id_: 6710
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6711:
  _id_: 6711
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6712:
  _id_: 6712
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6713:
  _id_: 6713
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6714:
  _id_: 6714
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6715:
  _id_: 6715
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6716:
  _id_: 6716
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6717:
  _id_: 6717
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6719:
  _id_: 6719
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6720:
  _id_: 6720
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6721:
  _id_: 6721
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6722:
  _id_: 6722
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6723:
  _id_: 6723
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6724:
  _id_: 6724
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6725:
  _id_: 6725
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6726:
  _id_: 6726
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6727:
  _id_: 6727
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6729:
  _id_: 6729
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6730:
  _id_: 6730
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6731:
  _id_: 6731
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6732:
  _id_: 6732
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6733:
  _id_: 6733
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6734:
  _id_: 6734
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 259
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
6735:
  _id_: 6735
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6736:
  _id_: 6736
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2703
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6737:
  _id_: 6737
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2704
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 75
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6739:
  _id_: 6739
  attribute_id: 3
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Support
    ja: 支援の打撃
    ko: 지원의 타격
    zh_hant: 支援敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4424
  skill_field_effect_id: 430
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6740:
  _id_: 6740
  attribute_id: 3
  cost: 2
  icon_id: 39
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4425
  skill_field_effect_id: 431
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6741:
  _id_: 6741
  attribute_id: 3
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Smash
    ja: 増強の打撃
    ko: 증강의 타격
    zh_hant: 增強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4426
  skill_field_effect_id: 432
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6742:
  _id_: 6742
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Mission
    ja: パーフェクト・ミッション
    ko: 퍼펙트 미션
    zh_hant: 完美任務
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4427
  skill_field_effect_id: 433
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6756:
  _id_: 6756
  attribute_id: 1
  cost: 1
  icon_id: 3004
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4429
  skill_field_effect_id: 436
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6757:
  _id_: 6757
  attribute_id: 1
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4430
  skill_field_effect_id: 437
  skill_options:
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6758:
  _id_: 6758
  attribute_id: 1
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4431
  skill_field_effect_id: 438
  skill_options:
  - hit_rate: 100
    id: 440
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 234
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6759:
  _id_: 6759
  attribute_id: 1
  cost: 2
  icon_id: 1049
  is_multiple_command_unique_skill: 1
  name:
    en: Purge Blade Encore
    ja: 粛清の刃 Encore
    ko: 숙청의 칼날 Encore
    zh_hant: 肅清之刃 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4432
  skill_field_effect_id: 439
  skill_options:
  - hit_rate: 100
    id: 444
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 234
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6761:
  _id_: 6761
  attribute_id: 3
  cost: 1
  icon_id: 3005
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Sharpshooting
    ja: 反射の狙撃
    ko: 반사의 저격
    zh_hant: 反射狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4434
  skill_field_effect_id: 442
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6762:
  _id_: 6762
  attribute_id: 3
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Sharpshooting
    ja: 重圧の狙撃
    ko: 중압의 저격
    zh_hant: 重壓狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4435
  skill_field_effect_id: 443
  skill_options:
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6763:
  _id_: 6763
  attribute_id: 3
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Support Shooting
    ja: 援護射撃
    ko: 엄호사격
    zh_hant: 掩護射擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4436
  skill_field_effect_id: 444
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6764:
  _id_: 6764
  attribute_id: 3
  cost: 2
  icon_id: 1088
  is_multiple_command_unique_skill: 0
  name:
    en: Longing for the Outside World
    ja: 広がる世界への憧憬
    ko: 펼쳐지는 세계에 대한 동경
    zh_hant: 對廣闊世界的憧憬
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4437
  skill_field_effect_id: 445
  skill_options:
  - hit_rate: 100
    id: 596
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6766:
  _id_: 6766
  attribute_id: 4
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Sharpshooting
    ja: 軽快な狙撃
    ko: 경쾌한 저격
    zh_hant: 輕快狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4439
  skill_field_effect_id: 448
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6767:
  _id_: 6767
  attribute_id: 4
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Sharpshooting
    ja: 甘美な狙撃
    ko: 감미로운 저격
    zh_hant: 甘美狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4440
  skill_field_effect_id: 449
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6768:
  _id_: 6768
  attribute_id: 4
  cost: 3
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Ovation
    ja: 万雷の狙撃
    ko: 만뢰의 저격
    zh_hant: 萬雷狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4441
  skill_field_effect_id: 450
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6769:
  _id_: 6769
  attribute_id: 4
  cost: 2
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! Encore
    ja: Eat me！ Encore
    ko: Eat me! Encore
    zh_hant: Eat me！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4442
  skill_field_effect_id: 451
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6771:
  _id_: 6771
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6772:
  _id_: 6772
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6773:
  _id_: 6773
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6774:
  _id_: 6774
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6775:
  _id_: 6775
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6776:
  _id_: 6776
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6777:
  _id_: 6777
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6778:
  _id_: 6778
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6779:
  _id_: 6779
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6780:
  _id_: 6780
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6782:
  _id_: 6782
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6783:
  _id_: 6783
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
6784:
  _id_: 6784
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6785:
  _id_: 6785
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6786:
  _id_: 6786
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6787:
  _id_: 6787
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6788:
  _id_: 6788
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6789:
  _id_: 6789
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6790:
  _id_: 6790
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6791:
  _id_: 6791
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6792:
  _id_: 6792
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6794:
  _id_: 6794
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6795:
  _id_: 6795
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6796:
  _id_: 6796
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6797:
  _id_: 6797
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6798:
  _id_: 6798
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6799:
  _id_: 6799
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6800:
  _id_: 6800
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6801:
  _id_: 6801
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6802:
  _id_: 6802
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6803:
  _id_: 6803
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6804:
  _id_: 6804
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6806:
  _id_: 6806
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6807:
  _id_: 6807
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6808:
  _id_: 6808
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6809:
  _id_: 6809
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6810:
  _id_: 6810
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6811:
  _id_: 6811
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6812:
  _id_: 6812
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6813:
  _id_: 6813
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6814:
  _id_: 6814
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6815:
  _id_: 6815
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6816:
  _id_: 6816
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6828:
  _id_: 6828
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Strike
    ja: 輝く一撃
    ko: 반짝이는 일격
    zh_hant: 輝耀一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4448
  skill_field_effect_id: 453
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6829:
  _id_: 6829
  attribute_id: 6
  cost: 2
  icon_id: 318
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4449
  skill_field_effect_id: 454
  skill_options:
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6830:
  _id_: 6830
  attribute_id: 6
  cost: 2
  icon_id: 242
  is_multiple_command_unique_skill: 0
  name:
    en: Anguish Strike
    ja: 苦悶の一撃
    ko: 고민의 일격
    zh_hant: 苦悶一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4450
  skill_field_effect_id: 455
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6831:
  _id_: 6831
  attribute_id: 6
  cost: 2
  icon_id: 248
  is_multiple_command_unique_skill: 1
  name:
    en: Twin Stars
    ja: ふたつの明星
    ko: 두 개의 샛별
    zh_hant: 兩顆明星
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4451
  skill_field_effect_id: 456
  skill_options:
  - hit_rate: 100
    id: 29
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 442
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6833:
  _id_: 6833
  attribute_id: 5
  cost: 1
  icon_id: 325
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Strike
    ja: 堅守の一撃
    ko: 굳은 수호의 일격
    zh_hant: 堅守一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4453
  skill_field_effect_id: 459
  skill_options:
  - hit_rate: 100
    id: 598
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6834:
  _id_: 6834
  attribute_id: 5
  cost: 2
  icon_id: 314
  is_multiple_command_unique_skill: 0
  name:
    en: Obstructing Strike
    ja: 阻害の一撃
    ko: 방해의 일격
    zh_hant: 妨礙一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4454
  skill_field_effect_id: 460
  skill_options:
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6835:
  _id_: 6835
  attribute_id: 5
  cost: 2
  icon_id: 58
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsiness Strike
    ja: 睡魔の一撃
    ko: 수마의 일격
    zh_hant: 睡魔一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4455
  skill_field_effect_id: 461
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6836:
  _id_: 6836
  attribute_id: 5
  cost: 2
  icon_id: 297
  is_multiple_command_unique_skill: 0
  name:
    en: The Freed Shadow
    ja: 解放されし影
    ko: 해방된 그림자
    zh_hant: 被解放的影子
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4456
  skill_field_effect_id: 462
  skill_options:
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 22002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6838:
  _id_: 6838
  attribute_id: 1
  cost: 2
  icon_id: 1022
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4458
  skill_field_effect_id: 465
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6839:
  _id_: 6839
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Strike
    ja: 甘美な一撃
    ko: 감미로운 일격
    zh_hant: 甘美一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4459
  skill_field_effect_id: 466
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6840:
  _id_: 6840
  attribute_id: 1
  cost: 3
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Ovation
    ja: 万雷の一撃
    ko: 만뢰의 일격
    zh_hant: 萬雷一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4460
  skill_field_effect_id: 467
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6841:
  _id_: 6841
  attribute_id: 1
  cost: 2
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Help Me, Wolf! Encore
    ja: 助けて！オオカミさん Encore
    ko: 늑대야, 살려 줘! Encore
    zh_hant: 救救我！大野狼先生 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4461
  skill_field_effect_id: 468
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6843:
  _id_: 6843
  attribute_id: 9
  cost: 1
  icon_id: 3005
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4463
  skill_field_effect_id: 474
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6844:
  _id_: 6844
  attribute_id: 9
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Slash
    ja: 灰色の斬撃
    ko: 잿빛의 참격
    zh_hant: 灰色斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4464
  skill_field_effect_id: 475
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 463
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6845:
  _id_: 6845
  attribute_id: 9
  cost: 2
  icon_id: 271
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4465
  skill_field_effect_id: 476
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 464
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 608
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6846:
  _id_: 6846
  attribute_id: 9
  cost: 2
  icon_id: 332
  is_multiple_command_unique_skill: 1
  name:
    en: Strongest Music - Key.
    ja: 最強の音楽～Key.～
    ko: 최강의 음악 ~Key.~
    zh_hant: 最強音樂～Key.～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4466
  skill_field_effect_id: 477
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 502
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 608
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6848:
  _id_: 6848
  attribute_id: 1
  cost: 1
  icon_id: 3005
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4468
  skill_field_effect_id: 478
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6849:
  _id_: 6849
  attribute_id: 1
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Slash
    ja: 灰色の斬撃
    ko: 잿빛의 참격
    zh_hant: 灰色斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4469
  skill_field_effect_id: 479
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6850:
  _id_: 6850
  attribute_id: 1
  cost: 2
  icon_id: 173
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4470
  skill_field_effect_id: 480
  skill_options:
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 607
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6851:
  _id_: 6851
  attribute_id: 1
  cost: 2
  icon_id: 331
  is_multiple_command_unique_skill: 1
  name:
    en: Strongest Music - DJ
    ja: 最強の音楽～DJ～
    ko: 최강의 음악 ~DJ~
    zh_hant: 最強音樂～DJ～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4471
  skill_field_effect_id: 481
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 607
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6853:
  _id_: 6853
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Flash
    ja: 甘美な一閃
    ko: 감미로운 일섬
    zh_hant: 甘美閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4473
  skill_field_effect_id: 482
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6854:
  _id_: 6854
  attribute_id: 6
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Flash
    ja: 灰色の一閃
    ko: 잿빛의 일섬
    zh_hant: 灰色閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4474
  skill_field_effect_id: 483
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6855:
  _id_: 6855
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Applauses
    ja: 喝采の一閃
    ko: 갈채의 일섬
    zh_hant: 喝采閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4475
  skill_field_effect_id: 484
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6856:
  _id_: 6856
  attribute_id: 6
  cost: 2
  icon_id: 316
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Courage
    ja: 勇気の照らすもの
    ko: 용기가 비추는 것
    zh_hant: 照亮勇氣者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4476
  skill_field_effect_id: 485
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 364
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6858:
  _id_: 6858
  attribute_id: 5
  cost: 1
  icon_id: 3004
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4478
  skill_field_effect_id: 486
  skill_options:
  - hit_rate: 100
    id: 591
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6859:
  _id_: 6859
  attribute_id: 5
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Slash
    ja: 灰色の斬撃
    ko: 잿빛의 참격
    zh_hant: 灰色斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4479
  skill_field_effect_id: 487
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6860:
  _id_: 6860
  attribute_id: 5
  cost: 2
  icon_id: 321
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Reduction
    ja: 減少の斬撃
    ko: 감소의 참격
    zh_hant: 降低斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4480
  skill_field_effect_id: 488
  skill_options:
  - hit_rate: 100
    id: 454
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 590
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 350
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6861:
  _id_: 6861
  attribute_id: 5
  cost: 1
  icon_id: 318
  is_multiple_command_unique_skill: 1
  name:
    en: Wonderland Time Limit
    ja: 不思議の国のタイムリミット
    ko: 이상한 나라의 타임리밋
    zh_hant: 仙境的時限
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4481
  skill_field_effect_id: 489
  skill_options:
  - hit_rate: 100
    id: 606
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6863:
  _id_: 6863
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4483
  skill_field_effect_id: 490
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6864:
  _id_: 6864
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4484
  skill_field_effect_id: 491
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6865:
  _id_: 6865
  attribute_id: 6
  cost: 3
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4485
  skill_field_effect_id: 492
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6866:
  _id_: 6866
  attribute_id: 6
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Sacrifice Chain Encore
    ja: 生贄の鎖 Encore
    ko: 제물의 사슬 Encore
    zh_hant: 祭品之鎖 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4486
  skill_field_effect_id: 493
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6868:
  _id_: 6868
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6869:
  _id_: 6869
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6870:
  _id_: 6870
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6871:
  _id_: 6871
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6872:
  _id_: 6872
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6873:
  _id_: 6873
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6874:
  _id_: 6874
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6875:
  _id_: 6875
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 抑止の炎舞
  optional_description:
    ja: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6876:
  _id_: 6876
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 脱力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6877:
  _id_: 6877
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 反撃の独奏
  optional_description:
    ja: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6878:
  _id_: 6878
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 塔の断罪 NEO
  optional_description:
    ja: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6880:
  _id_: 6880
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6881:
  _id_: 6881
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6882:
  _id_: 6882
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6883:
  _id_: 6883
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6884:
  _id_: 6884
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6885:
  _id_: 6885
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6886:
  _id_: 6886
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6887:
  _id_: 6887
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 抑止の炎舞
  optional_description:
    ja: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6888:
  _id_: 6888
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 脱力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6889:
  _id_: 6889
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 反撃の独奏
  optional_description:
    ja: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6890:
  _id_: 6890
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 塔の断罪 NEO
  optional_description:
    ja: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
6892:
  _id_: 6892
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6893:
  _id_: 6893
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6894:
  _id_: 6894
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6895:
  _id_: 6895
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6896:
  _id_: 6896
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6897:
  _id_: 6897
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6898:
  _id_: 6898
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6899:
  _id_: 6899
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 抑止の炎舞
  optional_description:
    ja: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6900:
  _id_: 6900
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 脱力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6901:
  _id_: 6901
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 反撃の独奏
  optional_description:
    ja: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6902:
  _id_: 6902
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 塔の断罪 NEO
  optional_description:
    ja: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6904:
  _id_: 6904
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6905:
  _id_: 6905
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
6906:
  _id_: 6906
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6907:
  _id_: 6907
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6908:
  _id_: 6908
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6909:
  _id_: 6909
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6910:
  _id_: 6910
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6911:
  _id_: 6911
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 抑止の炎舞
  optional_description:
    ja: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6912:
  _id_: 6912
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 脱力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
6913:
  _id_: 6913
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 反撃の独奏
  optional_description:
    ja: ''
  sequence_id: 2059
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6914:
  _id_: 6914
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 塔の断罪 NEO
  optional_description:
    ja: ''
  sequence_id: 2060
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
6916:
  _id_: 6916
  attribute_id: 5
  cost: 2
  icon_id: 1076
  is_multiple_command_unique_skill: 0
  name:
    en: Gray Flash
    ja: 灰色の一閃
    ko: 잿빛의 일섬
    zh_hant: 灰色閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4488
  skill_field_effect_id: 498
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6917:
  _id_: 6917
  attribute_id: 5
  cost: 2
  icon_id: 1026
  is_multiple_command_unique_skill: 0
  name:
    en: Profuse Flash
    ja: 繚乱の一閃
    ko: 요란의 일섬
    zh_hant: 繚亂閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4489
  skill_field_effect_id: 499
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 465
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6918:
  _id_: 6918
  attribute_id: 5
  cost: 2
  icon_id: 1040
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Applauses
    ja: 喝采の一閃
    ko: 갈채의 일섬
    zh_hant: 喝采閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4490
  skill_field_effect_id: 500
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 26
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6919:
  _id_: 6919
  attribute_id: 5
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Lupin's Brilliant Work
    ja: 大怪盗の華麗なる仕事
    ko: 대괴도의 화려한 활약
    zh_hant: 大怪盜的華麗工作
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4491
  skill_field_effect_id: 501
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6931:
  _id_: 6931
  attribute_id: 3
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Support
    ja: 援護の刺突
    ko: 엄호의 찌르기
    zh_hant: 掩護突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4493
  skill_field_effect_id: 503
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6932:
  _id_: 6932
  attribute_id: 3
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Thrust
    ja: 雷鳴の刺突
    ko: 천둥의 찌르기
    zh_hant: 雷鳴突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4494
  skill_field_effect_id: 504
  skill_options:
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6933:
  _id_: 6933
  attribute_id: 3
  cost: 2
  icon_id: 1074
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Control
    ja: 支配の刺突
    ko: 지배의 찌르기
    zh_hant: 支配突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4495
  skill_field_effect_id: 505
  skill_options:
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6934:
  _id_: 6934
  attribute_id: 3
  cost: 2
  icon_id: 336
  is_multiple_command_unique_skill: 1
  name:
    en: Belief Scissors
    ja: Belief Scissors
    ko: Belief Scissors
    zh_hant: Belief Scissors
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4496
  skill_field_effect_id: 506
  skill_options:
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6936:
  _id_: 6936
  attribute_id: 4
  cost: 1
  icon_id: 3006
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Flash
    ja: 反射の一閃
    ko: 반사의 일섬
    zh_hant: 反射閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4498
  skill_field_effect_id: 509
  skill_options:
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6937:
  _id_: 6937
  attribute_id: 4
  cost: 2
  icon_id: 1012
  is_multiple_command_unique_skill: 0
  name:
    en: Thunder Flash
    ja: 雷鳴の一閃
    ko: 천둥의 일섬
    zh_hant: 雷鳴閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4499
  skill_field_effect_id: 510
  skill_options:
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6938:
  _id_: 6938
  attribute_id: 4
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Flash
    ja: 火炎の一閃
    ko: 화염의 일섬
    zh_hant: 火焰閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4500
  skill_field_effect_id: 511
  skill_options:
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6939:
  _id_: 6939
  attribute_id: 4
  cost: 2
  icon_id: 1085
  is_multiple_command_unique_skill: 0
  name:
    en: Final Light
    ja: 最後の灯火
    ko: 마지막 등불
    zh_hant: 最後的火光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4501
  skill_field_effect_id: 512
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6941:
  _id_: 6941
  attribute_id: 3
  cost: 2
  icon_id: 336
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Blindness
    ja: 暗闇の打撃
    ko: 암흑의 타격
    zh_hant: 盲目敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4503
  skill_field_effect_id: 515
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6942:
  _id_: 6942
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Smash
    ja: 増強の打撃
    ko: 증강의 타격
    zh_hant: 增強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4504
  skill_field_effect_id: 516
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6943:
  _id_: 6943
  attribute_id: 3
  cost: 2
  icon_id: 1089
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Vitality
    ja: 活力の打撃
    ko: 활력의 타격
    zh_hant: 活力敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4505
  skill_field_effect_id: 517
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6944:
  _id_: 6944
  attribute_id: 3
  cost: 2
  icon_id: 336
  is_multiple_command_unique_skill: 1
  name:
    en: Illumination of Compassion
    ja: 慈愛の照らすもの
    ko: 자애가 비추는 것
    zh_hant: 照亮慈愛者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4506
  skill_field_effect_id: 518
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
6946:
  _id_: 6946
  attribute_id: 2
  cost: 1
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4508
  skill_field_effect_id: 520
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 4068
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6947:
  _id_: 6947
  attribute_id: 2
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Plundering
    ja: 略奪の斬撃
    ko: 약탈의 참격
    zh_hant: 掠奪斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4509
  skill_field_effect_id: 521
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6948:
  _id_: 6948
  attribute_id: 2
  cost: 2
  icon_id: 324
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Usurpation
    ja: 収奪の斬撃
    ko: 수탈의 참격
    zh_hant: 強奪斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4510
  skill_field_effect_id: 522
  skill_options:
  - hit_rate: 100
    id: 596
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6949:
  _id_: 6949
  attribute_id: 2
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Martial Dance
    ja: 功夫大乱舞
    ko: 쿵푸 대난무
    zh_hant: 功夫大亂舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4511
  skill_field_effect_id: 523
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10020
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6951:
  _id_: 6951
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4513
  skill_field_effect_id: 526
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6952:
  _id_: 6952
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4514
  skill_field_effect_id: 527
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6953:
  _id_: 6953
  attribute_id: 2
  cost: 3
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4515
  skill_field_effect_id: 528
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
6954:
  _id_: 6954
  attribute_id: 2
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Phantom Tears Encore
    ja: ファントムの涙 Encore
    ko: 팬텀의 눈물 Encore
    zh_hant: 魅影之淚 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4516
  skill_field_effect_id: 529
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6971:
  _id_: 6971
  attribute_id: 4
  cost: 1
  icon_id: 3006
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Smash
    ja: 反射の打撃
    ko: 반사의 타격
    zh_hant: 反射敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4523
  skill_field_effect_id: 531
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6972:
  _id_: 6972
  attribute_id: 4
  cost: 2
  icon_id: 308
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Support
    ja: 援護の打撃
    ko: 엄호의 타격
    zh_hant: 掩護敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4524
  skill_field_effect_id: 532
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6973:
  _id_: 6973
  attribute_id: 4
  cost: 2
  icon_id: 1064
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Calamity
    ja: 凶変の打撃
    ko: 흉변의 타격
    zh_hant: 變故敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4525
  skill_field_effect_id: 533
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6974:
  _id_: 6974
  attribute_id: 4
  cost: 2
  icon_id: 324
  is_multiple_command_unique_skill: 0
  name:
    en: Guardian of Dazzling Sunshine
    ja: 眩陽の守護者
    ko: 눈부신 태양의 수호자
    zh_hant: 炫陽守護者
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4526
  skill_field_effect_id: 534
  skill_options:
  - hit_rate: 100
    id: 596
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 383
    target_id: 2124
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
6976:
  _id_: 6976
  attribute_id: 9
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4528
  skill_field_effect_id: 537
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6977:
  _id_: 6977
  attribute_id: 9
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4529
  skill_field_effect_id: 538
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6978:
  _id_: 6978
  attribute_id: 9
  cost: 2
  icon_id: 1082
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4530
  skill_field_effect_id: 539
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6979:
  _id_: 6979
  attribute_id: 9
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Black Lion's Roar Encore
    ja: 黒獅子の咆哮 Encore
    ko: 흑사자의 포효 Encore
    zh_hant: 黑獅子咆哮 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4531
  skill_field_effect_id: 540
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
6981:
  _id_: 6981
  attribute_id: 2
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4533
  skill_field_effect_id: 542
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6982:
  _id_: 6982
  attribute_id: 2
  cost: 2
  icon_id: 324
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Usurpation
    ja: 収奪の斬撃
    ko: 수탈의 참격
    zh_hant: 強奪斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4534
  skill_field_effect_id: 543
  skill_options:
  - hit_rate: 100
    id: 596
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6983:
  _id_: 6983
  attribute_id: 2
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Plundering
    ja: 略奪の斬撃
    ko: 약탈의 참격
    zh_hant: 掠奪斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4535
  skill_field_effect_id: 544
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6984:
  _id_: 6984
  attribute_id: 2
  cost: 2
  icon_id: 284
  is_multiple_command_unique_skill: 0
  name:
    en: Sword of the Sun
    ja: 陽煌覇剣
    ko: 눈부신 태양의 패검
    zh_hant: 陽煌霸劍
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4536
  skill_field_effect_id: 545
  skill_options:
  - hit_rate: 100
    id: 485
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 486
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 586
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 580
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
6986:
  _id_: 6986
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3146
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
6987:
  _id_: 6987
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3147
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
6988:
  _id_: 6988
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3148
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
6989:
  _id_: 6989
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3149
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6990:
  _id_: 6990
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3150
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
6991:
  _id_: 6991
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3151
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
6992:
  _id_: 6992
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3152
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
6993:
  _id_: 6993
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Blazedance
    ja: 猛焔舞
    ko: 맹화무
    zh_hant: 猛焰舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3153
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
6994:
  _id_: 6994
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bloody Full Moon NEO
    ja: ブラッディ・フルムーン NEO
    ko: 블러디 풀 문 NEO
    zh_hant: 血腥滿月 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3154
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
6996:
  _id_: 6996
  attribute_id: 9
  cost: 2
  icon_id: 339
  is_multiple_command_unique_skill: 0
  name:
    en: Provoke Slash
    ja: 挑発の斬撃
    ko: 도발의 참격
    zh_hant: 挑釁斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4538
  skill_field_effect_id: 548
  skill_options:
  - hit_rate: 100
    id: 10060
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6997:
  _id_: 6997
  attribute_id: 9
  cost: 2
  icon_id: 342
  is_multiple_command_unique_skill: 0
  name:
    en: Luminous Slash
    ja: 光明の斬撃
    ko: 광명의 참격
    zh_hant: 光明斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4539
  skill_field_effect_id: 549
  skill_options:
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10060
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6998:
  _id_: 6998
  attribute_id: 9
  cost: 2
  icon_id: 340
  is_multiple_command_unique_skill: 0
  name:
    en: Fireproof Slash
    ja: 耐火の斬撃
    ko: 내화의 참격
    zh_hant: 耐火斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4540
  skill_field_effect_id: 550
  skill_options:
  - hit_rate: 100
    id: 20001
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10070
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10060
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
6999:
  _id_: 6999
  attribute_id: 9
  cost: 1
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce Encore
    ja: ブルーデイズの一刺し Encore
    ko: 블루 데이즈의 일격찌르기 Encore
    zh_hant: 藍天刺擊 Encore
  optional_description:
    en: 'Guest Use: Greater Provoke Not Applied'
    ja: ゲスト使用時、上位挑発は適用外
    ko: 게스트 사용 시, 상위 도발은 게스트적용되지 않음
    zh_hant: 使用來賓時，高級挑釁無效
  sequence_id: 4541
  skill_field_effect_id: 551
  skill_options:
  - hit_rate: 100
    id: 448
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 448
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10060
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7001:
  _id_: 7001
  attribute_id: 1
  cost: 1
  icon_id: 341
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Order
    ja: 秩序の斬撃
    ko: 질서의 참격
    zh_hant: 秩序斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4543
  skill_field_effect_id: 554
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20002
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10090
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7002:
  _id_: 7002
  attribute_id: 1
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Slash
    ja: 火炎の斬撃
    ko: 화염의 참격
    zh_hant: 火焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4544
  skill_field_effect_id: 555
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7003:
  _id_: 7003
  attribute_id: 1
  cost: 2
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4545
  skill_field_effect_id: 556
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 508
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7004:
  _id_: 7004
  attribute_id: 1
  cost: 2
  icon_id: 336
  is_multiple_command_unique_skill: 0
  name:
    en: Execution of the Ruthless Queen
    ja: 冷酷なる女王の処刑
    ko: 냉혹한 여왕의 처형
    zh_hant: 冷血皇后的處刑
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4546
  skill_field_effect_id: 557
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7006:
  _id_: 7006
  attribute_id: 3
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4548
  skill_field_effect_id: 560
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7007:
  _id_: 7007
  attribute_id: 3
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4549
  skill_field_effect_id: 561
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7008:
  _id_: 7008
  attribute_id: 3
  cost: 3
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4550
  skill_field_effect_id: 562
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7009:
  _id_: 7009
  attribute_id: 3
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Maid's Etiquette Encore
    ja: メイドのたしなみ Encore
    ko: 메이드의 소양 Encore
    zh_hant: 女僕的特技 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4551
  skill_field_effect_id: 563
  skill_options:
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7023:
  _id_: 7023
  attribute_id: 6
  cost: 1
  icon_id: 3006
  is_multiple_command_unique_skill: 0
  name:
    en: Reflect Slash
    ja: 反射の斬撃
    ko: 반사의 참격
    zh_hant: 反射斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4553
  skill_field_effect_id: 565
  skill_options:
  - hit_rate: 100
    id: 568
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7024:
  _id_: 7024
  attribute_id: 6
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Slash
    ja: 火炎の斬撃
    ko: 화염의 참격
    zh_hant: 火焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4554
  skill_field_effect_id: 566
  skill_options:
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7025:
  _id_: 7025
  attribute_id: 6
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Plundering
    ja: 略奪の斬撃
    ko: 약탈의 참격
    zh_hant: 掠奪斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4555
  skill_field_effect_id: 567
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 384
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7026:
  _id_: 7026
  attribute_id: 6
  cost: 2
  icon_id: 10006
  is_multiple_command_unique_skill: 0
  name:
    en: Black Lion's Cleave
    ja: 黒獅子の爪裂き
    ko: 흑사자의 발톱 찢기
    zh_hant: 黑獅子利爪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4556
  skill_field_effect_id: 568
  skill_options:
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 577
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7028:
  _id_: 7028
  attribute_id: 5
  cost: 1
  icon_id: 342
  is_multiple_command_unique_skill: 0
  name:
    en: Luminous Slash
    ja: 光明の斬撃
    ko: 광명의 참격
    zh_hant: 光明斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4558
  skill_field_effect_id: 571
  skill_options:
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7029:
  _id_: 7029
  attribute_id: 5
  cost: 2
  icon_id: 346
  is_multiple_command_unique_skill: 0
  name:
    en: Defensive Slash
    ja: 防護の斬撃
    ko: 방호의 참격
    zh_hant: 防護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4559
  skill_field_effect_id: 572
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 618
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7030:
  _id_: 7030
  attribute_id: 5
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4560
  skill_field_effect_id: 573
  skill_options:
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7031:
  _id_: 7031
  attribute_id: 5
  cost: 2
  icon_id: 298
  is_multiple_command_unique_skill: 0
  name:
    en: Scarlet Moon
    ja: 緋月散華
    ko: 비월산화
    zh_hant: 緋月散花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4561
  skill_field_effect_id: 574
  skill_options:
  - hit_rate: 100
    id: 512
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10040
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7033:
  _id_: 7033
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4563
  skill_field_effect_id: 577
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7034:
  _id_: 7034
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4564
  skill_field_effect_id: 578
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7035:
  _id_: 7035
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4565
  skill_field_effect_id: 579
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7036:
  _id_: 7036
  attribute_id: 6
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Yoru-no-osukuni Encore
    ja: 夜之食国 Encore
    ko: 밤을 먹는 나라 Encore
    zh_hant: 夜之食國 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4566
  skill_field_effect_id: 580
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7048:
  _id_: 7048
  attribute_id: 5
  cost: 1
  icon_id: 341
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Order
    ja: 秩序の斬撃
    ko: 질서의 참격
    zh_hant: 秩序斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4568
  skill_field_effect_id: 582
  skill_options:
  - hit_rate: 100
    id: 20002
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10090
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7049:
  _id_: 7049
  attribute_id: 5
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Slash
    ja: 輝く斬撃
    ko: 반짝이는 참격
    zh_hant: 光輝斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4569
  skill_field_effect_id: 583
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7050:
  _id_: 7050
  attribute_id: 5
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4570
  skill_field_effect_id: 584
  skill_options:
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7051:
  _id_: 7051
  attribute_id: 5
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 1
  name:
    en: True Strength
    ja: True Strength
    ko: True Strength
    zh_hant: True Strength
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4571
  skill_field_effect_id: 585
  skill_options:
  - hit_rate: 100
    id: 10120
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7053:
  _id_: 7053
  attribute_id: 8
  cost: 1
  icon_id: 346
  is_multiple_command_unique_skill: 0
  name:
    en: Defensive Slash
    ja: 防護の斬撃
    ko: 방호의 참격
    zh_hant: 防護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4573
  skill_field_effect_id: 588
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 618
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7054:
  _id_: 7054
  attribute_id: 8
  cost: 2
  icon_id: 335
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Slash
    ja: 惑いの斬撃
    ko: 미혹의 참격
    zh_hant: 迷惑斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4574
  skill_field_effect_id: 589
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7055:
  _id_: 7055
  attribute_id: 8
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4575
  skill_field_effect_id: 590
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7056:
  _id_: 7056
  attribute_id: 8
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Strongest Music - Ba. & Vo.
    ja: 最強の音楽～Ba.&Vo.～
    ko: 최강의 음악 ~Ba.&Vo.~
    zh_hant: 最強音樂～Ba.&Vo.～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4576
  skill_field_effect_id: 591
  skill_options:
  - hit_rate: 100
    id: 383
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7058:
  _id_: 7058
  attribute_id: 9
  cost: 1
  icon_id: 348
  is_multiple_command_unique_skill: 0
  name:
    en: Iceproof Strike
    ja: 耐氷の一撃
    ko: 내빙의 일격
    zh_hant: 耐冰一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4578
  skill_field_effect_id: 594
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10140
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7059:
  _id_: 7059
  attribute_id: 9
  cost: 2
  icon_id: 323
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Plundering
    ja: 略奪の一撃
    ko: 약탈의 일격
    zh_hant: 掠奪一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4579
  skill_field_effect_id: 595
  skill_options:
  - hit_rate: 100
    id: 595
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7060:
  _id_: 7060
  attribute_id: 9
  cost: 2
  icon_id: 324
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Usurpation
    ja: 収奪の一撃
    ko: 수탈의 일격
    zh_hant: 強奪一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4580
  skill_field_effect_id: 596
  skill_options:
  - hit_rate: 100
    id: 596
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7061:
  _id_: 7061
  attribute_id: 9
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Strongest Music - Gt.
    ja: 最強の音楽～Gt.～
    ko: 최강의 음악 ~Gt.~
    zh_hant: 最強音樂～Gt.～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4581
  skill_field_effect_id: 597
  skill_options:
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 595
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 596
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 6
    - 6
    - 6
    - 6
    - 6
  - hit_rate: 100
    id: 10120
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7064:
  _id_: 7064
  attribute_id: 5
  cost: 2
  icon_id: 336
  is_multiple_command_unique_skill: 0
  name:
    en: Blindness Slash
    ja: 暗闇の斬撃
    ko: 암흑의 참격
    zh_hant: 盲目斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4583
  skill_field_effect_id: 600
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7065:
  _id_: 7065
  attribute_id: 5
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4584
  skill_field_effect_id: 601
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7066:
  _id_: 7066
  attribute_id: 5
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Slash
    ja: 吸収の斬撃
    ko: 흡수의 참격
    zh_hant: 吸收斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4585
  skill_field_effect_id: 602
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7067:
  _id_: 7067
  attribute_id: 5
  cost: 2
  icon_id: 1020
  is_multiple_command_unique_skill: 1
  name:
    en: Peculiar Cauldron
    ja: 奇妙な大釜
    ko: 기묘한 가마솥
    zh_hant: 奇妙的大鍋
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4586
  skill_field_effect_id: 603
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 361
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7069:
  _id_: 7069
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4588
  skill_field_effect_id: 605
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7070:
  _id_: 7070
  attribute_id: 4
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4589
  skill_field_effect_id: 606
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7071:
  _id_: 7071
  attribute_id: 4
  cost: 2
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4590
  skill_field_effect_id: 607
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7072:
  _id_: 7072
  attribute_id: 4
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Jet-Black Arabesque Encore
    ja: 漆黒のアラベスク Encore
    ko: 칠흑의 아라베스크 Encore
    zh_hant: 漆黑之阿拉貝斯舞 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4591
  skill_field_effect_id: 608
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7074:
  _id_: 7074
  attribute_id: 8
  cost: 1
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Flash
    ja: 必中の一閃
    ko: 백발백중의 일섬
    zh_hant: 必中閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4593
  skill_field_effect_id: 610
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 508
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7075:
  _id_: 7075
  attribute_id: 8
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Freeze Flash
    ja: 凍結の一閃
    ko: 동결의 일섬
    zh_hant: 凍結閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4594
  skill_field_effect_id: 611
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7076:
  _id_: 7076
  attribute_id: 8
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Flash
    ja: 停止の一閃
    ko: 정지의 일섬
    zh_hant: 停止閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4595
  skill_field_effect_id: 612
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7077:
  _id_: 7077
  attribute_id: 8
  cost: 2
  icon_id: 348
  is_multiple_command_unique_skill: 0
  name:
    en: Strongest Music - Dr.
    ja: 最強の音楽～Dr.～
    ko: 최강의 음악 ~Dr.~
    zh_hant: 最強音樂～Dr.～
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4596
  skill_field_effect_id: 613
  skill_options:
  - hit_rate: 100
    id: 10140
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 383
    target_id: 4069
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7079:
  _id_: 7079
  attribute_id: 9
  cost: 1
  icon_id: 341
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Order
    ja: 秩序の斬撃
    ko: 질서의 참격
    zh_hant: 秩序斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4598
  skill_field_effect_id: 616
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20002
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10090
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7080:
  _id_: 7080
  attribute_id: 9
  cost: 2
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4599
  skill_field_effect_id: 617
  skill_options:
  - hit_rate: 100
    id: 508
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7081:
  _id_: 7081
  attribute_id: 9
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Invincibility
    ja: 無敵の斬撃
    ko: 무적의 참격
    zh_hant: 無敵斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4600
  skill_field_effect_id: 618
  skill_options:
  - hit_rate: 100
    id: 558
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7082:
  _id_: 7082
  attribute_id: 9
  cost: 2
  icon_id: 156
  is_multiple_command_unique_skill: 0
  name:
    en: Fate and the Stars
    ja: 運命と星
    ko: 운명과 별
    zh_hant: 命運與星星
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4601
  skill_field_effect_id: 619
  skill_options:
  - hit_rate: 100
    id: 558
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7084:
  _id_: 7084
  attribute_id: 4
  cost: 1
  icon_id: 340
  is_multiple_command_unique_skill: 0
  name:
    en: Fireproof Slash
    ja: 耐火の斬撃
    ko: 내화의 참격
    zh_hant: 耐火斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4603
  skill_field_effect_id: 621
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20001
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10070
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7085:
  _id_: 7085
  attribute_id: 4
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Slash
    ja: 火炎の斬撃
    ko: 화염의 참격
    zh_hant: 火焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4604
  skill_field_effect_id: 622
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7086:
  _id_: 7086
  attribute_id: 4
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Slash
    ja: 停止の斬撃
    ko: 정지의 참격
    zh_hant: 停止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4605
  skill_field_effect_id: 623
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 508
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10120
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7087:
  _id_: 7087
  attribute_id: 4
  cost: 2
  icon_id: 351
  is_multiple_command_unique_skill: 0
  name:
    en: Sacred Light
    ja: 聖なる光
    ko: 성스러운 빛
    zh_hant: 神聖之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4606
  skill_field_effect_id: 624
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 488
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7089:
  _id_: 7089
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4608
  skill_field_effect_id: 627
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7090:
  _id_: 7090
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4609
  skill_field_effect_id: 628
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7091:
  _id_: 7091
  attribute_id: 1
  cost: 2
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4610
  skill_field_effect_id: 629
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7092:
  _id_: 7092
  attribute_id: 1
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce War Cry Encore
    ja: 猛将の雄叫び Encore
    ko: 용맹한 장수의 외침 Encore
    zh_hant: 猛將的怒吼 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4611
  skill_field_effect_id: 630
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7094:
  _id_: 7094
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7095:
  _id_: 7095
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7096:
  _id_: 7096
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7097:
  _id_: 7097
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7098:
  _id_: 7098
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7099:
  _id_: 7099
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7100:
  _id_: 7100
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7101:
  _id_: 7101
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7102:
  _id_: 7102
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7104:
  _id_: 7104
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7105:
  _id_: 7105
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7106:
  _id_: 7106
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7107:
  _id_: 7107
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7108:
  _id_: 7108
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7109:
  _id_: 7109
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7110:
  _id_: 7110
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7111:
  _id_: 7111
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7112:
  _id_: 7112
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7114:
  _id_: 7114
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7115:
  _id_: 7115
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7116:
  _id_: 7116
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7117:
  _id_: 7117
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7118:
  _id_: 7118
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7119:
  _id_: 7119
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7120:
  _id_: 7120
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7121:
  _id_: 7121
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7122:
  _id_: 7122
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7123:
  _id_: 7123
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7124:
  _id_: 7124
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7126:
  _id_: 7126
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7127:
  _id_: 7127
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7128:
  _id_: 7128
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7129:
  _id_: 7129
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7130:
  _id_: 7130
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7131:
  _id_: 7131
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7132:
  _id_: 7132
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7133:
  _id_: 7133
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7134:
  _id_: 7134
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7135:
  _id_: 7135
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7136:
  _id_: 7136
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7138:
  _id_: 7138
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7139:
  _id_: 7139
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7140:
  _id_: 7140
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7141:
  _id_: 7141
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7142:
  _id_: 7142
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7143:
  _id_: 7143
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7144:
  _id_: 7144
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7145:
  _id_: 7145
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7146:
  _id_: 7146
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7148:
  _id_: 7148
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7149:
  _id_: 7149
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7150:
  _id_: 7150
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7151:
  _id_: 7151
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7152:
  _id_: 7152
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7153:
  _id_: 7153
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7154:
  _id_: 7154
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7155:
  _id_: 7155
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7156:
  _id_: 7156
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7158:
  _id_: 7158
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7159:
  _id_: 7159
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7160:
  _id_: 7160
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7161:
  _id_: 7161
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7162:
  _id_: 7162
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7163:
  _id_: 7163
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7164:
  _id_: 7164
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7165:
  _id_: 7165
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7166:
  _id_: 7166
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7167:
  _id_: 7167
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7168:
  _id_: 7168
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7170:
  _id_: 7170
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7171:
  _id_: 7171
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7172:
  _id_: 7172
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7173:
  _id_: 7173
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7174:
  _id_: 7174
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7175:
  _id_: 7175
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7176:
  _id_: 7176
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7177:
  _id_: 7177
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7178:
  _id_: 7178
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7179:
  _id_: 7179
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7180:
  _id_: 7180
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 33
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7182:
  _id_: 7182
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7183:
  _id_: 7183
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7184:
  _id_: 7184
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7185:
  _id_: 7185
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7186:
  _id_: 7186
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
7187:
  _id_: 7187
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
7188:
  _id_: 7188
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7189:
  _id_: 7189
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7190:
  _id_: 7190
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7192:
  _id_: 7192
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7193:
  _id_: 7193
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7194:
  _id_: 7194
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7195:
  _id_: 7195
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7196:
  _id_: 7196
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7197:
  _id_: 7197
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7198:
  _id_: 7198
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
7199:
  _id_: 7199
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7200:
  _id_: 7200
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7201:
  _id_: 7201
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7202:
  _id_: 7202
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7204:
  _id_: 7204
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7205:
  _id_: 7205
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7206:
  _id_: 7206
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7207:
  _id_: 7207
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7208:
  _id_: 7208
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7209:
  _id_: 7209
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7210:
  _id_: 7210
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7211:
  _id_: 7211
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7212:
  _id_: 7212
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7213:
  _id_: 7213
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7214:
  _id_: 7214
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7216:
  _id_: 7216
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7217:
  _id_: 7217
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7218:
  _id_: 7218
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7219:
  _id_: 7219
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7220:
  _id_: 7220
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7221:
  _id_: 7221
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7222:
  _id_: 7222
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7223:
  _id_: 7223
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7224:
  _id_: 7224
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7225:
  _id_: 7225
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7226:
  _id_: 7226
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7255:
  _id_: 7255
  attribute_id: 1
  cost: 1
  icon_id: 342
  is_multiple_command_unique_skill: 0
  name:
    en: Luminous Flash
    ja: 光明の一閃
    ko: 광명의 일섬
    zh_hant: 光明閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4626
  skill_field_effect_id: 633
  skill_options:
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 508
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7256:
  _id_: 7256
  attribute_id: 1
  cost: 2
  icon_id: 351
  is_multiple_command_unique_skill: 0
  name:
    en: Electric Flash
    ja: 感電の一閃
    ko: 감전의 일섬
    zh_hant: 感電閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4627
  skill_field_effect_id: 634
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10120
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7257:
  _id_: 7257
  attribute_id: 1
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Flash
    ja: 停止の一閃
    ko: 정지의 일섬
    zh_hant: 停止閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4628
  skill_field_effect_id: 635
  skill_options:
  - hit_rate: 100
    id: 453
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10120
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7258:
  _id_: 7258
  attribute_id: 1
  cost: 2
  icon_id: 298
  is_multiple_command_unique_skill: 0
  name:
    en: Blessings of Spring Light
    ja: 春光の恩恵
    ko: 봄빛의 은혜
    zh_hant: 春光的恩惠
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4629
  skill_field_effect_id: 636
  skill_options:
  - hit_rate: 100
    id: 512
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7260:
  _id_: 7260
  attribute_id: 3
  cost: 1
  icon_id: 340
  is_multiple_command_unique_skill: 0
  name:
    en: Fireproof Slash
    ja: 耐火の斬撃
    ko: 내화의 참격
    zh_hant: 耐火斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4631
  skill_field_effect_id: 639
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20001
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10070
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7261:
  _id_: 7261
  attribute_id: 3
  cost: 2
  icon_id: 351
  is_multiple_command_unique_skill: 0
  name:
    en: Electric Slash
    ja: 感電の斬撃
    ko: 감전의 참격
    zh_hant: 感電斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4632
  skill_field_effect_id: 640
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 581
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7262:
  _id_: 7262
  attribute_id: 3
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Slash
    ja: 停止の斬撃
    ko: 정지의 참격
    zh_hant: 停止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4633
  skill_field_effect_id: 641
  skill_options:
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 4069
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7263:
  _id_: 7263
  attribute_id: 3
  cost: 2
  icon_id: 347
  is_multiple_command_unique_skill: 0
  name:
    en: Lovesick Monologue
    ja: 恋わずらいのモノローグ
    ko: 상사병의 모놀로그
    zh_hant: 苦戀的獨白
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4634
  skill_field_effect_id: 642
  skill_options:
  - hit_rate: 100
    id: 10130
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 4069
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7265:
  _id_: 7265
  attribute_id: 8
  cost: 1
  icon_id: 349
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Time Keeping
    ja: 時守の斬撃
    ko: 시간 수호자의 참격
    zh_hant: 時守斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4636
  skill_field_effect_id: 645
  skill_options:
  - hit_rate: 100
    id: 20004
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10150
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10060
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7266:
  _id_: 7266
  attribute_id: 8
  cost: 1
  icon_id: 359
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4637
  skill_field_effect_id: 646
  skill_options:
  - hit_rate: 100
    id: 10250
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10230
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7267:
  _id_: 7267
  attribute_id: 8
  cost: 1
  icon_id: 357
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Slash
    ja: 守護の斬撃
    ko: 수호의 참격
    zh_hant: 守護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4638
  skill_field_effect_id: 647
  skill_options:
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10230
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7268:
  _id_: 7268
  attribute_id: 8
  cost: 2
  icon_id: 357
  is_multiple_command_unique_skill: 0
  name:
    en: Stars and Fate
    ja: 星と運命
    ko: 별과 운명
    zh_hant: 星星與命運
  optional_description:
    en: 'Guest Use: Greater Aggro Not Applied'
    ja: ゲスト使用時、上位ターゲット固定は適用外
    ko: 게스트 사용 시, 상위 타깃 고정은 적용되지 않음
    zh_hant: 使用來賓時，高級目標鎖定無效
  sequence_id: 4639
  skill_field_effect_id: 648
  skill_options:
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10250
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7270:
  _id_: 7270
  attribute_id: 1
  cost: 2
  icon_id: 335
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Blindness
    ja: 暗闇の刺突
    ko: 암흑의 찌르기
    zh_hant: 盲目突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4641
  skill_field_effect_id: 651
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7271:
  _id_: 7271
  attribute_id: 1
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Strengthening
    ja: 増強の刺突
    ko: 증강의 찌르기
    zh_hant: 增強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4642
  skill_field_effect_id: 652
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7272:
  _id_: 7272
  attribute_id: 1
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Absorption
    ja: 吸収の刺突
    ko: 흡수의 찌르기
    zh_hant: 吸收突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4643
  skill_field_effect_id: 653
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7273:
  _id_: 7273
  attribute_id: 1
  cost: 2
  icon_id: 1020
  is_multiple_command_unique_skill: 1
  name:
    en: Happy Surprise Egg
    ja: ハッピーサプライズエッグ
    ko: 해피 서프라이즈 에그
    zh_hant: 歡樂驚喜彩蛋
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4644
  skill_field_effect_id: 654
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 583
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 364
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7275:
  _id_: 7275
  attribute_id: 5
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Thrust
    ja: 軽快な刺突
    ko: 경쾌한 찌르기
    zh_hant: 輕快突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4646
  skill_field_effect_id: 656
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7276:
  _id_: 7276
  attribute_id: 5
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Thrust
    ja: 甘美な刺突
    ko: 감미로운 찌르기
    zh_hant: 甘美突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4647
  skill_field_effect_id: 657
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7277:
  _id_: 7277
  attribute_id: 5
  cost: 2
  icon_id: 1069
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Ovation
    ja: 万雷の刺突
    ko: 만뢰의 찌르기
    zh_hant: 萬雷突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4648
  skill_field_effect_id: 658
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7278:
  _id_: 7278
  attribute_id: 5
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Flying Dragon Kick Encore
    ja: 竜翔脚 Encore
    ko: 용상각 Encore
    zh_hant: 龍翔腳 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4649
  skill_field_effect_id: 659
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7280:
  _id_: 7280
  attribute_id: 2
  cost: 1
  icon_id: 348
  is_multiple_command_unique_skill: 0
  name:
    en: Resistance Strike
    ja: 耐性の一撃
    ko: 저항의 일격
    zh_hant: 耐性一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4651
  skill_field_effect_id: 661
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20005
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10140
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7281:
  _id_: 7281
  attribute_id: 2
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Strike
    ja: 重圧の一撃
    ko: 중압의 일격
    zh_hant: 重壓一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4652
  skill_field_effect_id: 662
  skill_options:
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7282:
  _id_: 7282
  attribute_id: 2
  cost: 2
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4653
  skill_field_effect_id: 663
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7283:
  _id_: 7283
  attribute_id: 2
  cost: 2
  icon_id: 361
  is_multiple_command_unique_skill: 0
  name:
    en: Fantastic Show
    ja: Fantastic show
    ko: Fantastic show
    zh_hant: Fantastic show
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4654
  skill_field_effect_id: 664
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10270
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10120
    target_id: 2124
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7296:
  _id_: 7296
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7297:
  _id_: 7297
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7298:
  _id_: 7298
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7299:
  _id_: 7299
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7300:
  _id_: 7300
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7301:
  _id_: 7301
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7302:
  _id_: 7302
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7303:
  _id_: 7303
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7304:
  _id_: 7304
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
7306:
  _id_: 7306
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7307:
  _id_: 7307
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7308:
  _id_: 7308
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7309:
  _id_: 7309
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7310:
  _id_: 7310
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7311:
  _id_: 7311
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7312:
  _id_: 7312
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7313:
  _id_: 7313
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
7314:
  _id_: 7314
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7315:
  _id_: 7315
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
7317:
  _id_: 7317
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7318:
  _id_: 7318
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7319:
  _id_: 7319
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7320:
  _id_: 7320
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7321:
  _id_: 7321
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7322:
  _id_: 7322
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7323:
  _id_: 7323
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7324:
  _id_: 7324
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7326:
  _id_: 7326
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7327:
  _id_: 7327
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7328:
  _id_: 7328
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7329:
  _id_: 7329
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7330:
  _id_: 7330
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7331:
  _id_: 7331
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7332:
  _id_: 7332
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7333:
  _id_: 7333
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7335:
  _id_: 7335
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7336:
  _id_: 7336
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7337:
  _id_: 7337
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7338:
  _id_: 7338
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7339:
  _id_: 7339
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7340:
  _id_: 7340
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7341:
  _id_: 7341
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7342:
  _id_: 7342
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7344:
  _id_: 7344
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7345:
  _id_: 7345
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7346:
  _id_: 7346
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7347:
  _id_: 7347
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7348:
  _id_: 7348
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7349:
  _id_: 7349
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7350:
  _id_: 7350
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7351:
  _id_: 7351
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7352:
  _id_: 7352
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7353:
  _id_: 7353
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7355:
  _id_: 7355
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7356:
  _id_: 7356
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7357:
  _id_: 7357
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7358:
  _id_: 7358
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7359:
  _id_: 7359
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7360:
  _id_: 7360
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7361:
  _id_: 7361
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7362:
  _id_: 7362
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7363:
  _id_: 7363
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7364:
  _id_: 7364
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7366:
  _id_: 7366
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7367:
  _id_: 7367
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7368:
  _id_: 7368
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7369:
  _id_: 7369
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7370:
  _id_: 7370
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7371:
  _id_: 7371
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7372:
  _id_: 7372
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7373:
  _id_: 7373
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 54
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7375:
  _id_: 7375
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7376:
  _id_: 7376
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7377:
  _id_: 7377
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7378:
  _id_: 7378
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7379:
  _id_: 7379
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7380:
  _id_: 7380
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7381:
  _id_: 7381
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7382:
  _id_: 7382
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7383:
  _id_: 7383
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7384:
  _id_: 7384
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7386:
  _id_: 7386
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7387:
  _id_: 7387
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7388:
  _id_: 7388
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7389:
  _id_: 7389
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7390:
  _id_: 7390
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7391:
  _id_: 7391
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7392:
  _id_: 7392
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7393:
  _id_: 7393
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7394:
  _id_: 7394
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7395:
  _id_: 7395
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7397:
  _id_: 7397
  attribute_id: 6
  cost: 1
  icon_id: 342
  is_multiple_command_unique_skill: 0
  name:
    en: Luminous Flash
    ja: 光明の一閃
    ko: 광명의 일섬
    zh_hant: 光明閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4664
  skill_field_effect_id: 668
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7398:
  _id_: 7398
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Flash
    ja: 輝く一閃
    ko: 반짝이는 일섬
    zh_hant: 輝耀閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4665
  skill_field_effect_id: 669
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10130
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7399:
  _id_: 7399
  attribute_id: 6
  cost: 2
  icon_id: 197
  is_multiple_command_unique_skill: 0
  name:
    en: Restorative Flash
    ja: 再起の一閃
    ko: 재기의 일섬
    zh_hant: 再起閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4666
  skill_field_effect_id: 670
  skill_options:
  - hit_rate: 100
    id: 309
    target_id: 11011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7400:
  _id_: 7400
  attribute_id: 6
  cost: 2
  icon_id: 363
  is_multiple_command_unique_skill: 1
  name:
    en: It’s Showtime!
    ja: It's showtime！
    ko: It's showtime!
    zh_hant: It's showtime！
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4667
  skill_field_effect_id: 671
  skill_options:
  - hit_rate: 100
    id: 309
    target_id: 11012
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10281
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7402:
  _id_: 7402
  attribute_id: 5
  cost: 1
  icon_id: 340
  is_multiple_command_unique_skill: 0
  name:
    en: Fireproof Slash
    ja: 耐火の斬撃
    ko: 내화의 참격
    zh_hant: 耐火斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4669
  skill_field_effect_id: 674
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20001
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10070
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7403:
  _id_: 7403
  attribute_id: 5
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4670
  skill_field_effect_id: 675
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
7404:
  _id_: 7404
  attribute_id: 5
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4671
  skill_field_effect_id: 676
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 508
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10040
    target_id: 4069
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7405:
  _id_: 7405
  attribute_id: 5
  cost: 2
  icon_id: 366
  is_multiple_command_unique_skill: 0
  name:
    en: Senji Ryakketsu - Summon Shikigami
    ja: 占事略决・式神召喚
    ko: 점사약결 식신 소환
    zh_hant: 占事略決・式神召喚
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4672
  skill_field_effect_id: 677
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7407:
  _id_: 7407
  attribute_id: 2
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4674
  skill_field_effect_id: 680
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7408:
  _id_: 7408
  attribute_id: 2
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4675
  skill_field_effect_id: 681
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7409:
  _id_: 7409
  attribute_id: 2
  cost: 2
  icon_id: 1066
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4676
  skill_field_effect_id: 682
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7410:
  _id_: 7410
  attribute_id: 2
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: 1001 Illusions Encore
    ja: 千夜一夜の幻想 Encore
    ko: 천일야화의 환상 Encore
    zh_hant: 一千零一夜的幻想 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4677
  skill_field_effect_id: 683
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7412:
  _id_: 7412
  attribute_id: 3
  cost: 1
  icon_id: 367
  is_multiple_command_unique_skill: 0
  name:
    en: Antistatic Strike
    ja: 耐電の一撃
    ko: 내전의 일격
    zh_hant: 耐電一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4679
  skill_field_effect_id: 685
  skill_options:
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10285
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7413:
  _id_: 7413
  attribute_id: 3
  cost: 2
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4680
  skill_field_effect_id: 686
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7414:
  _id_: 7414
  attribute_id: 3
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Strike
    ja: 重圧の一撃
    ko: 중압의 일격
    zh_hant: 重壓一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4681
  skill_field_effect_id: 687
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
7415:
  _id_: 7415
  attribute_id: 3
  cost: 2
  icon_id: 1096
  is_multiple_command_unique_skill: 1
  name:
    en: Gift for My Master
    ja: ささやかなるご主人様への贈り物
    ko: 주인님을 위한 소소한 선물
    zh_hant: 送給主人的小小心意
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4682
  skill_field_effect_id: 688
  skill_options:
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7417:
  _id_: 7417
  attribute_id: 3
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4684
  skill_field_effect_id: 691
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7418:
  _id_: 7418
  attribute_id: 3
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Strike
    ja: 甘美な一撃
    ko: 감미로운 일격
    zh_hant: 甘美一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4685
  skill_field_effect_id: 692
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7419:
  _id_: 7419
  attribute_id: 3
  cost: 2
  icon_id: 1067
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Ovation
    ja: 万雷の一撃
    ko: 만뢰의 일격
    zh_hant: 萬雷一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4686
  skill_field_effect_id: 693
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7420:
  _id_: 7420
  attribute_id: 3
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Christine's Song Encore
    ja: クリスティーヌの歌声 Encore
    ko: 크리스틴의 노랫소리 Encore
    zh_hant: 克莉絲汀的歌聲 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4687
  skill_field_effect_id: 694
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7444:
  _id_: 7444
  attribute_id: 4
  cost: 1
  icon_id: 341
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Order
    ja: 秩序の一撃
    ko: 질서의 일격
    zh_hant: 秩序一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4690
  skill_field_effect_id: 697
  skill_options:
  - hit_rate: 100
    id: 20002
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10090
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7445:
  _id_: 7445
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Strike
    ja: 煌めく一撃
    ko: 빛나는 일격
    zh_hant: 輝煌一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4691
  skill_field_effect_id: 698
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7446:
  _id_: 7446
  attribute_id: 4
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Freeze Strike
    ja: 氷結の一撃
    ko: 빙결의 일격
    zh_hant: 冰凍一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4692
  skill_field_effect_id: 699
  skill_options:
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 165
    - 173
    - 181
    - 189
    - 198
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7447:
  _id_: 7447
  attribute_id: 4
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 1
  name:
    en: Libra's Conviction
    ja: 天秤の断罪
    ko: 천칭의 단죄
    zh_hant: 天秤之定罪
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4693
  skill_field_effect_id: 700
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7449:
  _id_: 7449
  attribute_id: 2
  cost: 1
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Flash
    ja: 軽快な一閃
    ko: 경쾌한 일섬
    zh_hant: 輕快閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4695
  skill_field_effect_id: 703
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20005
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10140
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7450:
  _id_: 7450
  attribute_id: 2
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Flash
    ja: 致命の一閃
    ko: 치명의 일섬
    zh_hant: 致命閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4696
  skill_field_effect_id: 704
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7451:
  _id_: 7451
  attribute_id: 2
  cost: 2
  icon_id: 35
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Flash
    ja: 必中の一閃
    ko: 백발백중의 일섬
    zh_hant: 必中閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4697
  skill_field_effect_id: 705
  skill_options:
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 508
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7452:
  _id_: 7452
  attribute_id: 2
  cost: 2
  icon_id: 369
  is_multiple_command_unique_skill: 0
  name:
    en: Chasing the White Rabbit
    ja: 白うさぎを追いかけて
    ko: 흰토끼를 쫓아서
    zh_hant: 追逐白兔
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4698
  skill_field_effect_id: 706
  skill_options:
  - hit_rate: 100
    id: 620
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 619
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 450
    - 460
    - 470
    - 480
    - 500
7454:
  _id_: 7454
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Flash
    ja: 軽快な一閃
    ko: 경쾌한 일섬
    zh_hant: 輕快閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4700
  skill_field_effect_id: 709
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7455:
  _id_: 7455
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Flash
    ja: 甘美な一閃
    ko: 감미로운 일섬
    zh_hant: 甘美閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4701
  skill_field_effect_id: 710
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7456:
  _id_: 7456
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Ovation
    ja: 万雷の一閃
    ko: 만뢰의 일섬
    zh_hant: 萬雷閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4702
  skill_field_effect_id: 711
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7457:
  _id_: 7457
  attribute_id: 6
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Pandora's Box Encore
    ja: パンドラの箱 Encore
    ko: 판도라의 상자 Encore
    zh_hant: 潘朵拉的盒子 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4703
  skill_field_effect_id: 712
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7471:
  _id_: 7471
  attribute_id: 3
  cost: 1
  icon_id: 371
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4706
  skill_field_effect_id: 714
  skill_options:
  - hit_rate: 100
    id: 20005
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20004
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10290
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7472:
  _id_: 7472
  attribute_id: 3
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Slash
    ja: 煌めく斬撃
    ko: 빛나는 참격
    zh_hant: 輝煌斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4707
  skill_field_effect_id: 715
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7473:
  _id_: 7473
  attribute_id: 3
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4708
  skill_field_effect_id: 716
  skill_options:
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7474:
  _id_: 7474
  attribute_id: 3
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 1
  name:
    en: Petals of Fate
    ja: 運命の花弁
    ko: 운명의 꽃잎
    zh_hant: 命運花瓣
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4709
  skill_field_effect_id: 717
  skill_options:
  - hit_rate: 100
    id: 10290
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7476:
  _id_: 7476
  attribute_id: 1
  cost: 1
  icon_id: 367
  is_multiple_command_unique_skill: 0
  name:
    en: Antistatic Slash
    ja: 耐電の斬撃
    ko: 내전의 참격
    zh_hant: 耐電斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4711
  skill_field_effect_id: 720
  skill_options:
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10285
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7477:
  _id_: 7477
  attribute_id: 1
  cost: 2
  icon_id: 363
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Slumber
    ja: 睡眠の斬撃
    ko: 수면의 참격
    zh_hant: 睡眠斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4712
  skill_field_effect_id: 721
  skill_options:
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7478:
  _id_: 7478
  attribute_id: 1
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Confusion
    ja: 混乱の斬撃
    ko: 혼란의 참격
    zh_hant: 混亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4713
  skill_field_effect_id: 722
  skill_options:
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7479:
  _id_: 7479
  attribute_id: 1
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 1
  name:
    en: Chosen King Encore
    ja: 選ばれし王 Encore
    ko: 선택받은 왕 Encore
    zh_hant: 天選之王 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4714
  skill_field_effect_id: 723
  skill_options:
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 10281
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7481:
  _id_: 7481
  attribute_id: 4
  cost: 1
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4716
  skill_field_effect_id: 726
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
7482:
  _id_: 7482
  attribute_id: 4
  cost: 2
  icon_id: 347
  is_multiple_command_unique_skill: 0
  name:
    en: Fortitude Slash
    ja: 不屈の斬撃
    ko: 불굴의 참격
    zh_hant: 不屈斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4717
  skill_field_effect_id: 727
  skill_options:
  - hit_rate: 100
    id: 10130
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
7483:
  _id_: 7483
  attribute_id: 4
  cost: 2
  icon_id: 344
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Slash
    ja: 回避の斬撃
    ko: 회피의 참격
    zh_hant: 迴避斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4718
  skill_field_effect_id: 728
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
7484:
  _id_: 7484
  attribute_id: 4
  cost: 2
  icon_id: 1034
  is_multiple_command_unique_skill: 0
  name:
    en: We Will All Do Starlight! Encore
    ja: みんなを、スタァライト！しちゃいます！！ Encore
    ko: 모두를 스타라이트! 하겠습니다!! Encore
    zh_hant: 我會令大家星光照耀的！！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4719
  skill_field_effect_id: 729
  skill_options:
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7486:
  _id_: 7486
  attribute_id: 6
  cost: 1
  icon_id: 375
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Liberation
    ja: 解放の斬撃
    ko: 해방의 참격
    zh_hant: 解放斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4721
  skill_field_effect_id: 731
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20010
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10294
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7487:
  _id_: 7487
  attribute_id: 6
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Slash
    ja: 吸収の斬撃
    ko: 흡수의 참격
    zh_hant: 吸收斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4722
  skill_field_effect_id: 732
  skill_options:
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7488:
  _id_: 7488
  attribute_id: 6
  cost: 2
  icon_id: 10005
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Boost
    ja: 特効の斬撃
    ko: 특효의 참격
    zh_hant: 特效斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4723
  skill_field_effect_id: 733
  skill_options:
  - hit_rate: 100
    id: 20010
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 571
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7489:
  _id_: 7489
  attribute_id: 6
  cost: 2
  icon_id: 376
  is_multiple_command_unique_skill: 1
  name:
    en: Scattering of Fate
    ja: 運命の散花
    ko: 운명의 산화
    zh_hant: 命運花落
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4724
  skill_field_effect_id: 734
  skill_options:
  - hit_rate: 100
    id: 10295
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 571
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7491:
  _id_: 7491
  attribute_id: 4
  cost: 2
  icon_id: 359
  is_multiple_command_unique_skill: 0
  name:
    en: Antistatic Slash
    ja: 耐電の斬撃
    ko: 내전의 참격
    zh_hant: 耐電斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4726
  skill_field_effect_id: 737
  skill_options:
  - hit_rate: 100
    id: 10250
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7492:
  _id_: 7492
  attribute_id: 4
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4727
  skill_field_effect_id: 738
  skill_options:
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7493:
  _id_: 7493
  attribute_id: 4
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4728
  skill_field_effect_id: 739
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7494:
  _id_: 7494
  attribute_id: 4
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Two Dragon's Prophecy Encore
    ja: 二頭の竜の予言 Encore
    ko: 쌍두룡의 예언 Encore
    zh_hant: 兩頭龍的預言 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4729
  skill_field_effect_id: 740
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
7496:
  _id_: 7496
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7497:
  _id_: 7497
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7498:
  _id_: 7498
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7499:
  _id_: 7499
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7500:
  _id_: 7500
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7501:
  _id_: 7501
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7502:
  _id_: 7502
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7503:
  _id_: 7503
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4731
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7504:
  _id_: 7504
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4732
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7506:
  _id_: 7506
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7507:
  _id_: 7507
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7508:
  _id_: 7508
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7509:
  _id_: 7509
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7510:
  _id_: 7510
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7511:
  _id_: 7511
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7512:
  _id_: 7512
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4733
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7513:
  _id_: 7513
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4734
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7515:
  _id_: 7515
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7516:
  _id_: 7516
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7517:
  _id_: 7517
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7518:
  _id_: 7518
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7519:
  _id_: 7519
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7520:
  _id_: 7520
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7521:
  _id_: 7521
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7522:
  _id_: 7522
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7523:
  _id_: 7523
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4735
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7524:
  _id_: 7524
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4736
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7526:
  _id_: 7526
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7527:
  _id_: 7527
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7528:
  _id_: 7528
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7529:
  _id_: 7529
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7530:
  _id_: 7530
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7531:
  _id_: 7531
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7532:
  _id_: 7532
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7533:
  _id_: 7533
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4737
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7534:
  _id_: 7534
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7535:
  _id_: 7535
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7536:
  _id_: 7536
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4738
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7538:
  _id_: 7538
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7539:
  _id_: 7539
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7540:
  _id_: 7540
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7541:
  _id_: 7541
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7542:
  _id_: 7542
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7543:
  _id_: 7543
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7544:
  _id_: 7544
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7545:
  _id_: 7545
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4731
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7546:
  _id_: 7546
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4732
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7548:
  _id_: 7548
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7549:
  _id_: 7549
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7550:
  _id_: 7550
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7551:
  _id_: 7551
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7552:
  _id_: 7552
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7553:
  _id_: 7553
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7554:
  _id_: 7554
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4733
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7555:
  _id_: 7555
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4734
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7557:
  _id_: 7557
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7558:
  _id_: 7558
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7559:
  _id_: 7559
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7560:
  _id_: 7560
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7561:
  _id_: 7561
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7562:
  _id_: 7562
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7563:
  _id_: 7563
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7564:
  _id_: 7564
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7565:
  _id_: 7565
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4735
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7566:
  _id_: 7566
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with her head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4736
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7568:
  _id_: 7568
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7569:
  _id_: 7569
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7570:
  _id_: 7570
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7571:
  _id_: 7571
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7572:
  _id_: 7572
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7573:
  _id_: 7573
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7574:
  _id_: 7574
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7575:
  _id_: 7575
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4737
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7576:
  _id_: 7576
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7577:
  _id_: 7577
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7578:
  _id_: 7578
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4738
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10210
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7580:
  _id_: 7580
  attribute_id: 2
  cost: 1
  icon_id: 374
  is_multiple_command_unique_skill: 0
  name:
    en: Awakening Slash
    ja: 目覚めの斬撃
    ko: 각성의 참격
    zh_hant: 喚醒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4739
  skill_field_effect_id: 743
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20011
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10293
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7581:
  _id_: 7581
  attribute_id: 2
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4740
  skill_field_effect_id: 744
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7582:
  _id_: 7582
  attribute_id: 2
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Freeze Slash
    ja: 氷結の斬撃
    ko: 빙결의 참격
    zh_hant: 冰凍斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4741
  skill_field_effect_id: 745
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20009
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7583:
  _id_: 7583
  attribute_id: 2
  cost: 2
  icon_id: 377
  is_multiple_command_unique_skill: 1
  name:
    en: Bud of Fate
    ja: 運命の蕾
    ko: 운명의 꽃봉오리
    zh_hant: 命運花蕾
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4742
  skill_field_effect_id: 746
  skill_options:
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7585:
  _id_: 7585
  attribute_id: 5
  cost: 1
  icon_id: 379
  is_multiple_command_unique_skill: 0
  name:
    en: Swift Flash
    ja: 速攻の一閃
    ko: 속공의 일섬
    zh_hant: 速攻閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4744
  skill_field_effect_id: 749
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10285
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7586:
  _id_: 7586
  attribute_id: 5
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Flash
    ja: 火炎の一閃
    ko: 화염의 일섬
    zh_hant: 火焰閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4745
  skill_field_effect_id: 750
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10040
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7587:
  _id_: 7587
  attribute_id: 5
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Flash
    ja: 必中の一閃
    ko: 백발백중의 일섬
    zh_hant: 必中閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4746
  skill_field_effect_id: 751
  skill_options:
  - hit_rate: 100
    id: 10130
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7588:
  _id_: 7588
  attribute_id: 5
  cost: 1
  icon_id: 379
  is_multiple_command_unique_skill: 1
  name:
    en: Majestic Clarent Encore
    ja: 光砕くクラレント Encore
    ko: 빛을 부수는 클라렌트 Encore
    zh_hant: 碎光之Clarent Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4747
  skill_field_effect_id: 752
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7590:
  _id_: 7590
  attribute_id: 3
  cost: 1
  icon_id: 367
  is_multiple_command_unique_skill: 0
  name:
    en: Antistatic Slash
    ja: 耐電の斬撃
    ko: 내전의 참격
    zh_hant: 耐電斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4749
  skill_field_effect_id: 755
  skill_options:
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10285
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 471
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
7591:
  _id_: 7591
  attribute_id: 3
  cost: 2
  icon_id: 380
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Degradation
    ja: 堕落の斬撃
    ko: 타락의 참격
    zh_hant: 墮落斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4750
  skill_field_effect_id: 756
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
7592:
  _id_: 7592
  attribute_id: 3
  cost: 2
  icon_id: 197
  is_multiple_command_unique_skill: 0
  name:
    en: Restorative Slash
    ja: 再起の斬撃
    ko: 재기의 참격
    zh_hant: 再起斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4751
  skill_field_effect_id: 757
  skill_options:
  - hit_rate: 100
    id: 309
    target_id: 11013
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
  - hit_rate: 100
    id: 10301
    target_id: 1001
    times:
    - 99
    - 99
    - 99
    - 99
    - 99
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10295
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7593:
  _id_: 7593
  attribute_id: 3
  cost: 2
  icon_id: 380
  is_multiple_command_unique_skill: 0
  name:
    en: Sunlight Impale
    ja: サンライト・インペイル
    ko: 선라이트 임페일
    zh_hant: 陽光刺穿
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4752
  skill_field_effect_id: 758
  skill_options:
  - hit_rate: 100
    id: 10240
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7610:
  _id_: 7610
  attribute_id: 2
  cost: 1
  icon_id: 371
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Resistance
    ja: 耐性の狙撃
    ko: 저항의 저격
    zh_hant: 耐性狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4754
  skill_field_effect_id: 761
  skill_options:
  - hit_rate: 100
    id: 10290
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20012
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7611:
  _id_: 7611
  attribute_id: 2
  cost: 2
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Hope
    ja: 希望の狙撃
    ko: 희망의 저격
    zh_hant: 希望狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4755
  skill_field_effect_id: 762
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20012
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7612:
  _id_: 7612
  attribute_id: 2
  cost: 2
  icon_id: 368
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Restoration
    ja: 挽回の狙撃
    ko: 만회의 저격
    zh_hant: 挽救狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4756
  skill_field_effect_id: 763
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20012
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7613:
  _id_: 7613
  attribute_id: 2
  cost: 2
  icon_id: 382
  is_multiple_command_unique_skill: 1
  name:
    en: Scorpion's Devotion
    ja: 大蠍の真心
    ko: 전갈의 진심
    zh_hant: 大蠍子的真心
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4757
  skill_field_effect_id: 764
  skill_options:
  - hit_rate: 100
    id: 10302
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 85
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 20012
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7615:
  _id_: 7615
  attribute_id: 8
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4759
  skill_field_effect_id: 767
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10120
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7616:
  _id_: 7616
  attribute_id: 8
  cost: 2
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Hope
    ja: 希望の斬撃
    ko: 희망의 참격
    zh_hant: 希望斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4760
  skill_field_effect_id: 768
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7617:
  _id_: 7617
  attribute_id: 8
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4761
  skill_field_effect_id: 769
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10040
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7618:
  _id_: 7618
  attribute_id: 8
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Cat's Revenge Encore
    ja: 猫のお返し Encore
    ko: 고양이의 보은 Encore
    zh_hant: 貓的還擊 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4762
  skill_field_effect_id: 770
  skill_options:
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 85
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7620:
  _id_: 7620
  attribute_id: 1
  cost: 1
  icon_id: 378
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Resistance
    ja: 耐性の打撃
    ko: 저항의 타격
    zh_hant: 耐性敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4764
  skill_field_effect_id: 772
  skill_options:
  - hit_rate: 100
    id: 20013
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10297
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7621:
  _id_: 7621
  attribute_id: 1
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Love
    ja: 恋の打撃
    ko: 사랑의 타격
    zh_hant: 戀的敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4765
  skill_field_effect_id: 773
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7622:
  _id_: 7622
  attribute_id: 1
  cost: 2
  icon_id: 351
  is_multiple_command_unique_skill: 0
  name:
    en: Electric Smash
    ja: 感電の打撃
    ko: 감전의 타격
    zh_hant: 感電敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4766
  skill_field_effect_id: 774
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7623:
  _id_: 7623
  attribute_id: 1
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 1
  name:
    en: Brilliant Mahiru
    ja: キラめくまひるの舞台
    ko: 반짝이는 마히루의 무대
    zh_hant: 真晝的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4767
  skill_field_effect_id: 775
  skill_options:
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7625:
  _id_: 7625
  attribute_id: 2
  cost: 2
  icon_id: 359
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4769
  skill_field_effect_id: 778
  skill_options:
  - hit_rate: 100
    id: 10250
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7626:
  _id_: 7626
  attribute_id: 2
  cost: 2
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Hope
    ja: 希望の斬撃
    ko: 희망의 참격
    zh_hant: 希望斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4770
  skill_field_effect_id: 779
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7627:
  _id_: 7627
  attribute_id: 2
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4771
  skill_field_effect_id: 780
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7628:
  _id_: 7628
  attribute_id: 2
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Brilliant Suzu
    ja: キラめく涼の舞台
    ko: 반짝이는 스즈의 무대
    zh_hant: 涼的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4772
  skill_field_effect_id: 781
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
7640:
  _id_: 7640
  attribute_id: 9
  cost: 2
  icon_id: 351
  is_multiple_command_unique_skill: 0
  name:
    en: Electric Strike
    ja: 感電の一撃
    ko: 감전의 일격
    zh_hant: 感電一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4774
  skill_field_effect_id: 784
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7641:
  _id_: 7641
  attribute_id: 9
  cost: 2
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Hope
    ja: 希望の一撃
    ko: 희망의 일격
    zh_hant: 希望一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4775
  skill_field_effect_id: 785
  skill_options:
  - hit_rate: 100
    id: 451
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 567
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7642:
  _id_: 7642
  attribute_id: 9
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Strike
    ja: 致命の一撃
    ko: 치명의 일격
    zh_hant: 致命一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4776
  skill_field_effect_id: 786
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7643:
  _id_: 7643
  attribute_id: 9
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Blossom Dance Encore
    ja: 烈開花の舞踏 Encore
    ko: 세찬 개화의 무도 Encore
    zh_hant: 盛綻的舞步 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4777
  skill_field_effect_id: 787
  skill_options:
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 390
    - 410
    - 430
    - 460
    - 490
7645:
  _id_: 7645
  attribute_id: 4
  cost: 1
  icon_id: 375
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Liberation
    ja: 解放の一撃
    ko: 해방의 일격
    zh_hant: 解放一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4779
  skill_field_effect_id: 789
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1143
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 20010
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10294
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7646:
  _id_: 7646
  attribute_id: 4
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Love
    ja: 恋の一撃
    ko: 사랑의 일격
    zh_hant: 戀的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4780
  skill_field_effect_id: 790
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
7647:
  _id_: 7647
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Strike
    ja: 煌めく一撃
    ko: 빛나는 일격
    zh_hant: 輝煌一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4781
  skill_field_effect_id: 791
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 1001
    times:
    - 99
    - 99
    - 99
    - 99
    - 99
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7648:
  _id_: 7648
  attribute_id: 4
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Weaving Gratitude
    ja: 恩返しの機織り
    ko: 보은의 길쌈
    zh_hant: 織布以報恩
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4782
  skill_field_effect_id: 792
  skill_options:
  - hit_rate: 100
    id: 10311
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 20012
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7650:
  _id_: 7650
  attribute_id: 4
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4784
  skill_field_effect_id: 795
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7651:
  _id_: 7651
  attribute_id: 4
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Strike
    ja: 甘美な一撃
    ko: 감미로운 일격
    zh_hant: 甘美一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4785
  skill_field_effect_id: 796
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7652:
  _id_: 7652
  attribute_id: 4
  cost: 2
  icon_id: 1068
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Ovation
    ja: 万雷の一撃
    ko: 만뢰의 일격
    zh_hant: 萬雷一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4786
  skill_field_effect_id: 797
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7653:
  _id_: 7653
  attribute_id: 4
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Phantom Thief Encore
    ja: 神出鬼没の大怪盗 Encore
    ko: 신출귀몰의 대괴도 Encore
    zh_hant: 神出鬼沒的大怪盜 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4787
  skill_field_effect_id: 798
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7655:
  _id_: 7655
  attribute_id: 9
  cost: 1
  icon_id: 389
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4789
  skill_field_effect_id: 800
  skill_options:
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20011
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10309
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7656:
  _id_: 7656
  attribute_id: 9
  cost: 1
  icon_id: 357
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Slash
    ja: 守護の斬撃
    ko: 수호의 참격
    zh_hant: 守護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4790
  skill_field_effect_id: 801
  skill_options:
  - hit_rate: 100
    id: 10309
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10230
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7657:
  _id_: 7657
  attribute_id: 9
  cost: 1
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4791
  skill_field_effect_id: 802
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10230
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7658:
  _id_: 7658
  attribute_id: 9
  cost: 1
  icon_id: 390
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Maya
    ja: キラめく真矢の舞台
    ko: 반짝이는 마야의 무대
    zh_hant: 真矢的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4792
  skill_field_effect_id: 803
  skill_options:
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10310
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7660:
  _id_: 7660
  attribute_id: 7
  cost: 1
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4794
  skill_field_effect_id: 806
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20003
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10080
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
7661:
  _id_: 7661
  attribute_id: 7
  cost: 2
  icon_id: 347
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Fortitude
    ja: 不屈の打撃
    ko: 불굴의 타격
    zh_hant: 不屈敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4795
  skill_field_effect_id: 807
  skill_options:
  - hit_rate: 100
    id: 10130
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
  - hit_rate: 100
    id: 10281
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7662:
  _id_: 7662
  attribute_id: 7
  cost: 2
  icon_id: 344
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Smash
    ja: 回避の打撃
    ko: 회피의 타격
    zh_hant: 迴避敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4796
  skill_field_effect_id: 808
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 190
    - 200
    - 210
    - 220
  - hit_rate: 100
    id: 10281
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7663:
  _id_: 7663
  attribute_id: 7
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Shiro
    ja: キラめく詩呂の舞台
    ko: 반짝이는 시로의 무대
    zh_hant: 詩呂的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4797
  skill_field_effect_id: 809
  skill_options:
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
7665:
  _id_: 7665
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7666:
  _id_: 7666
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7667:
  _id_: 7667
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7668:
  _id_: 7668
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7669:
  _id_: 7669
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7670:
  _id_: 7670
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7671:
  _id_: 7671
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7672:
  _id_: 7672
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fire Flower Dance
    ja: 炎花の舞
    ko: 염화의 춤
    zh_hant: 炎花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4799
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7673:
  _id_: 7673
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4800
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7675:
  _id_: 7675
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7676:
  _id_: 7676
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7677:
  _id_: 7677
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7678:
  _id_: 7678
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7679:
  _id_: 7679
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7680:
  _id_: 7680
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7681:
  _id_: 7681
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7682:
  _id_: 7682
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7684:
  _id_: 7684
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7685:
  _id_: 7685
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7686:
  _id_: 7686
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7687:
  _id_: 7687
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7688:
  _id_: 7688
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7689:
  _id_: 7689
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7690:
  _id_: 7690
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7691:
  _id_: 7691
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7692:
  _id_: 7692
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7693:
  _id_: 7693
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7695:
  _id_: 7695
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7696:
  _id_: 7696
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7697:
  _id_: 7697
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7698:
  _id_: 7698
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7699:
  _id_: 7699
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7700:
  _id_: 7700
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
7701:
  _id_: 7701
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7702:
  _id_: 7702
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7703:
  _id_: 7703
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7705:
  _id_: 7705
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7706:
  _id_: 7706
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7707:
  _id_: 7707
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7708:
  _id_: 7708
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7709:
  _id_: 7709
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7710:
  _id_: 7710
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7711:
  _id_: 7711
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7712:
  _id_: 7712
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fire Flower Dance
    ja: 炎花の舞
    ko: 염화의 춤
    zh_hant: 炎花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4799
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7713:
  _id_: 7713
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4800
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7715:
  _id_: 7715
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7716:
  _id_: 7716
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7717:
  _id_: 7717
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7718:
  _id_: 7718
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7719:
  _id_: 7719
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7720:
  _id_: 7720
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7721:
  _id_: 7721
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7722:
  _id_: 7722
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7724:
  _id_: 7724
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7725:
  _id_: 7725
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7726:
  _id_: 7726
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7727:
  _id_: 7727
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7728:
  _id_: 7728
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7729:
  _id_: 7729
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7730:
  _id_: 7730
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7731:
  _id_: 7731
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7732:
  _id_: 7732
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7733:
  _id_: 7733
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7735:
  _id_: 7735
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7736:
  _id_: 7736
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7737:
  _id_: 7737
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7738:
  _id_: 7738
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7739:
  _id_: 7739
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7740:
  _id_: 7740
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
7741:
  _id_: 7741
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7742:
  _id_: 7742
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7743:
  _id_: 7743
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7745:
  _id_: 7745
  attribute_id: 6
  cost: 1
  icon_id: 367
  is_multiple_command_unique_skill: 0
  name:
    en: Antistatic Flash
    ja: 耐電の一閃
    ko: 내전의 일섬
    zh_hant: 耐電閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4807
  skill_field_effect_id: 813
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20006
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10285
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7746:
  _id_: 7746
  attribute_id: 6
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Love
    ja: 恋の一閃
    ko: 사랑의 일섬
    zh_hant: 戀的閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4808
  skill_field_effect_id: 814
  skill_options:
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7747:
  _id_: 7747
  attribute_id: 6
  cost: 2
  icon_id: 392
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Reduction
    ja: 減少の一閃
    ko: 감소의 일섬
    zh_hant: 減少閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4809
  skill_field_effect_id: 815
  skill_options:
  - hit_rate: 100
    id: 10312
    target_id: 4193
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7748:
  _id_: 7748
  attribute_id: 6
  cost: 2
  icon_id: 393
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Ichie
    ja: キラめくいちえの舞台
    ko: 반짝이는 이치에의 무대
    zh_hant: 一愛的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4810
  skill_field_effect_id: 816
  skill_options:
  - hit_rate: 100
    id: 621
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 99
    - 99
    - 99
    - 99
    - 99
  - hit_rate: 100
    id: 10312
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 85
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7750:
  _id_: 7750
  attribute_id: 1
  cost: 1
  icon_id: 378
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4812
  skill_field_effect_id: 819
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20013
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10297
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7751:
  _id_: 7751
  attribute_id: 1
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4813
  skill_field_effect_id: 820
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7752:
  _id_: 7752
  attribute_id: 1
  cost: 2
  icon_id: 395
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Protection
    ja: 加護の斬撃
    ko: 가호의 참격
    zh_hant: 加護斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4814
  skill_field_effect_id: 821
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10315
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7753:
  _id_: 7753
  attribute_id: 1
  cost: 2
  icon_id: 395
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Claudine
    ja: キラめくクロディーヌの舞台
    ko: 반짝이는 클로딘의 무대
    zh_hant: 克洛迪娜的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4815
  skill_field_effect_id: 822
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10315
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7755:
  _id_: 7755
  attribute_id: 3
  cost: 1
  icon_id: 397
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4817
  skill_field_effect_id: 825
  skill_options:
  - hit_rate: 100
    id: 20014
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10318
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7756:
  _id_: 7756
  attribute_id: 3
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4818
  skill_field_effect_id: 826
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7757:
  _id_: 7757
  attribute_id: 3
  cost: 2
  icon_id: 1093
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Slumber
    ja: 睡眠の斬撃
    ko: 수면의 참격
    zh_hant: 睡眠斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4819
  skill_field_effect_id: 827
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10170
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 15000
    - 15000
    - 15000
    - 15000
    - 15000
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7758:
  _id_: 7758
  attribute_id: 3
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Unclouded Love
    ja: 曇りなき愛の情動
    ko: 투명한 사랑의 감정
    zh_hant: 純粹的愛意
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4820
  skill_field_effect_id: 828
  skill_options:
  - hit_rate: 100
    id: 20014
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20012
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7760:
  _id_: 7760
  attribute_id: 1
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4822
  skill_field_effect_id: 831
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7761:
  _id_: 7761
  attribute_id: 1
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4823
  skill_field_effect_id: 832
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7762:
  _id_: 7762
  attribute_id: 1
  cost: 2
  icon_id: 1065
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4824
  skill_field_effect_id: 833
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7763:
  _id_: 7763
  attribute_id: 1
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Scarlet Moon Blade Encore
    ja: 緋色斬月 Encore
    ko: 비색참월 Encore
    zh_hant: 緋色斬月 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4825
  skill_field_effect_id: 834
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7765:
  _id_: 7765
  attribute_id: 6
  cost: 1
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4827
  skill_field_effect_id: 836
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10309
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
7766:
  _id_: 7766
  attribute_id: 6
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4828
  skill_field_effect_id: 837
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20007
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
7767:
  _id_: 7767
  attribute_id: 6
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4829
  skill_field_effect_id: 838
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10292
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20012
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
7768:
  _id_: 7768
  attribute_id: 6
  cost: 2
  icon_id: 399
  is_multiple_command_unique_skill: 0
  name:
    en: Unmovable Star
    ja: 不動の星
    ko: 부동의 별
    zh_hant: 不動之星
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4830
  skill_field_effect_id: 839
  skill_options:
  - hit_rate: 100
    id: 622
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 619
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
7770:
  _id_: 7770
  attribute_id: 5
  cost: 1
  icon_id: 402
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Resistance
    ja: 耐性の打撃
    ko: 저항의 타격
    zh_hant: 耐性敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4832
  skill_field_effect_id: 842
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20015
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10322
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7771:
  _id_: 7771
  attribute_id: 5
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Fainting
    ja: 失神の打撃
    ko: 실신의 타격
    zh_hant: 昏厥敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4833
  skill_field_effect_id: 843
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7772:
  _id_: 7772
  attribute_id: 5
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Freezing
    ja: 凍結の打撃
    ko: 동결의 타격
    zh_hant: 凍結敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4834
  skill_field_effect_id: 844
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7773:
  _id_: 7773
  attribute_id: 5
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Lalafin
    ja: キラめくララフィンの舞台
    ko: 반짝이는 라라핀의 무대
    zh_hant: 菈樂菲的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4835
  skill_field_effect_id: 845
  skill_options:
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7802:
  _id_: 7802
  attribute_id: 6
  cost: 1
  icon_id: 378
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4842
  skill_field_effect_id: 848
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20013
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10297
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7803:
  _id_: 7803
  attribute_id: 6
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Surprise Slash
    ja: 奇襲の斬撃
    ko: 기습의 참격
    zh_hant: 奇襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4843
  skill_field_effect_id: 849
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7804:
  _id_: 7804
  attribute_id: 6
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4844
  skill_field_effect_id: 850
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7805:
  _id_: 7805
  attribute_id: 6
  cost: 2
  icon_id: 407
  is_multiple_command_unique_skill: 0
  name:
    en: Supreme Medicine
    ja: 至高の医術
    ko: 최고의 의술
    zh_hant: 頂級醫術
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4845
  skill_field_effect_id: 851
  skill_options:
  - hit_rate: 100
    id: 10328
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 85
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7807:
  _id_: 7807
  attribute_id: 2
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4847
  skill_field_effect_id: 854
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7808:
  _id_: 7808
  attribute_id: 2
  cost: 2
  icon_id: 1094
  is_multiple_command_unique_skill: 0
  name:
    en: Hindering Slash
    ja: 妨害の斬撃
    ko: 방해의 참격
    zh_hant: 妨礙斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4848
  skill_field_effect_id: 855
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20016
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7809:
  _id_: 7809
  attribute_id: 2
  cost: 2
  icon_id: 1093
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4849
  skill_field_effect_id: 856
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20016
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7810:
  _id_: 7810
  attribute_id: 2
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Overflowing Blessing
    ja: 溢れる女神の祝福
    ko: 넘치는 여신의 축복
    zh_hant: 滿溢的女神祝福
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4850
  skill_field_effect_id: 857
  skill_options:
  - hit_rate: 100
    id: 20016
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 20012
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7812:
  _id_: 7812
  attribute_id: 6
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4852
  skill_field_effect_id: 860
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7813:
  _id_: 7813
  attribute_id: 6
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Slash
    ja: 甘美な斬撃
    ko: 감미로운 참격
    zh_hant: 甘美斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4853
  skill_field_effect_id: 861
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7814:
  _id_: 7814
  attribute_id: 6
  cost: 2
  icon_id: 1070
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Ovation
    ja: 万雷の斬撃
    ko: 만뢰의 참격
    zh_hant: 萬雷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4854
  skill_field_effect_id: 862
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7815:
  _id_: 7815
  attribute_id: 6
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Parting Tamatebako Encore
    ja: 別離の玉手箱 Encore
    ko: 이별의 보물상자 Encore
    zh_hant: 離別的玉手箱 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4855
  skill_field_effect_id: 863
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7817:
  _id_: 7817
  attribute_id: 3
  cost: 2
  icon_id: 371
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4857
  skill_field_effect_id: 865
  skill_options:
  - hit_rate: 100
    id: 10290
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7818:
  _id_: 7818
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4858
  skill_field_effect_id: 866
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7819:
  _id_: 7819
  attribute_id: 3
  cost: 2
  icon_id: 364
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4859
  skill_field_effect_id: 867
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10120
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7820:
  _id_: 7820
  attribute_id: 3
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Brilliant Michiru
    ja: キラめくミチルの舞台
    ko: 반짝이는 미치루의 무대
    zh_hant: 未知留的閃耀舞台
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4860
  skill_field_effect_id: 868
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10324
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
7847:
  _id_: 7847
  attribute_id: 3
  cost: 1
  icon_id: 402
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4882
  skill_field_effect_id: 877
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20015
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10322
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10312
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7848:
  _id_: 7848
  attribute_id: 3
  cost: 2
  icon_id: 363
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Slumber
    ja: 睡眠の斬撃
    ko: 수면의 참격
    zh_hant: 睡眠斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4883
  skill_field_effect_id: 878
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10312
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7849:
  _id_: 7849
  attribute_id: 3
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4884
  skill_field_effect_id: 879
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10312
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7850:
  _id_: 7850
  attribute_id: 3
  cost: 2
  icon_id: 409
  is_multiple_command_unique_skill: 0
  name:
    en: Sun's Pride
    ja: 天道の誇り
    ko: 태양의 긍지
    zh_hant: 太陽的驕傲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4885
  skill_field_effect_id: 880
  skill_options:
  - hit_rate: 100
    id: 10330
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10312
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7852:
  _id_: 7852
  attribute_id: 6
  cost: 2
  icon_id: 359
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4887
  skill_field_effect_id: 883
  skill_options:
  - hit_rate: 100
    id: 10250
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7853:
  _id_: 7853
  attribute_id: 6
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4888
  skill_field_effect_id: 884
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7854:
  _id_: 7854
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Applauses
    ja: 喝采の斬撃
    ko: 갈채의 참격
    zh_hant: 喝采斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4889
  skill_field_effect_id: 885
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7855:
  _id_: 7855
  attribute_id: 6
  cost: 2
  icon_id: 1041
  is_multiple_command_unique_skill: 1
  name:
    en: Feelings for Isolde Encore
    ja: イゾルデへの想い Encore
    ko: 이졸데를 향한 마음 Encore
    zh_hant: 對伊索德的思念 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4890
  skill_field_effect_id: 886
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
7867:
  _id_: 7867
  attribute_id: 2
  cost: 2
  icon_id: 363
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Sleep
    ja: 睡眠の刺突
    ko: 수면의 찌르기
    zh_hant: 睡眠突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4892
  skill_field_effect_id: 889
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7868:
  _id_: 7868
  attribute_id: 2
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Fainting
    ja: 失神の刺突
    ko: 실신의 찌르기
    zh_hant: 昏厥突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4893
  skill_field_effect_id: 890
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7869:
  _id_: 7869
  attribute_id: 2
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Love
    ja: 恋の刺突
    ko: 사랑의 찌르기
    zh_hant: 戀的突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4894
  skill_field_effect_id: 891
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7870:
  _id_: 7870
  attribute_id: 2
  cost: 2
  icon_id: 412
  is_multiple_command_unique_skill: 0
  name:
    en: Lightning of Blessing
    ja: Lightning of Blessing
    ko: Lightning of Blessing
    zh_hant: Lightning of Blessing
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4895
  skill_field_effect_id: 892
  skill_options:
  - hit_rate: 100
    id: 10339
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
  - hit_rate: 100
    id: 10340
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
  - hit_rate: 100
    id: 10130
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7872:
  _id_: 7872
  attribute_id: 8
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Thrust
    ja: 軽快な刺突
    ko: 경쾌한 찌르기
    zh_hant: 輕快突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4897
  skill_field_effect_id: 895
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7873:
  _id_: 7873
  attribute_id: 8
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Thrust
    ja: 甘美な刺突
    ko: 감미로운 찌르기
    zh_hant: 甘美突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4898
  skill_field_effect_id: 896
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7874:
  _id_: 7874
  attribute_id: 8
  cost: 2
  icon_id: 1097
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Ovation
    ja: 万雷の刺突
    ko: 만뢰의 찌르기
    zh_hant: 萬雷突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4899
  skill_field_effect_id: 897
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
7875:
  _id_: 7875
  attribute_id: 8
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Secret Mission Encore
    ja: シークレット・ミッション Encore
    ko: 시크릿 미션 Encore
    zh_hant: Secret Mission Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4900
  skill_field_effect_id: 898
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
7877:
  _id_: 7877
  attribute_id: 4
  cost: 1
  icon_id: 378
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4902
  skill_field_effect_id: 900
  skill_options:
  - hit_rate: 100
    id: 20013
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10297
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10329
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7878:
  _id_: 7878
  attribute_id: 4
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4903
  skill_field_effect_id: 901
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7879:
  _id_: 7879
  attribute_id: 4
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4904
  skill_field_effect_id: 902
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
7880:
  _id_: 7880
  attribute_id: 4
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Crossbones Slash Encore
    ja: クロスボーンスラッシュ Encore
    ko: 크로스 본 슬래시 Encore
    zh_hant: 海盜斜斬 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4905
  skill_field_effect_id: 903
  skill_options:
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
7882:
  _id_: 7882
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7883:
  _id_: 7883
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7884:
  _id_: 7884
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7885:
  _id_: 7885
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7886:
  _id_: 7886
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
7887:
  _id_: 7887
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
7888:
  _id_: 7888
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7889:
  _id_: 7889
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7890:
  _id_: 7890
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7892:
  _id_: 7892
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7893:
  _id_: 7893
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7894:
  _id_: 7894
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7895:
  _id_: 7895
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7896:
  _id_: 7896
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7897:
  _id_: 7897
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7898:
  _id_: 7898
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7899:
  _id_: 7899
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7900:
  _id_: 7900
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7901:
  _id_: 7901
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7902:
  _id_: 7902
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7904:
  _id_: 7904
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7905:
  _id_: 7905
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7906:
  _id_: 7906
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7907:
  _id_: 7907
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7908:
  _id_: 7908
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7909:
  _id_: 7909
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7910:
  _id_: 7910
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
7911:
  _id_: 7911
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7912:
  _id_: 7912
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7913:
  _id_: 7913
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7914:
  _id_: 7914
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7916:
  _id_: 7916
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7917:
  _id_: 7917
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7918:
  _id_: 7918
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7919:
  _id_: 7919
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7920:
  _id_: 7920
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7921:
  _id_: 7921
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7922:
  _id_: 7922
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7923:
  _id_: 7923
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7924:
  _id_: 7924
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7925:
  _id_: 7925
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7926:
  _id_: 7926
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
7928:
  _id_: 7928
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7929:
  _id_: 7929
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7930:
  _id_: 7930
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7931:
  _id_: 7931
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7932:
  _id_: 7932
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7933:
  _id_: 7933
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7934:
  _id_: 7934
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7935:
  _id_: 7935
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7936:
  _id_: 7936
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7937:
  _id_: 7937
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7938:
  _id_: 7938
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7940:
  _id_: 7940
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7941:
  _id_: 7941
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7942:
  _id_: 7942
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7943:
  _id_: 7943
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7944:
  _id_: 7944
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7945:
  _id_: 7945
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7946:
  _id_: 7946
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7947:
  _id_: 7947
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7948:
  _id_: 7948
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7949:
  _id_: 7949
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7950:
  _id_: 7950
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7952:
  _id_: 7952
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7953:
  _id_: 7953
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7954:
  _id_: 7954
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7955:
  _id_: 7955
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7956:
  _id_: 7956
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7957:
  _id_: 7957
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
7958:
  _id_: 7958
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7959:
  _id_: 7959
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7960:
  _id_: 7960
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7961:
  _id_: 7961
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7962:
  _id_: 7962
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7964:
  _id_: 7964
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7965:
  _id_: 7965
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
7966:
  _id_: 7966
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7967:
  _id_: 7967
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7968:
  _id_: 7968
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7969:
  _id_: 7969
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7970:
  _id_: 7970
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7971:
  _id_: 7971
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
7972:
  _id_: 7972
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7973:
  _id_: 7973
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7974:
  _id_: 7974
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
7976:
  _id_: 7976
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7977:
  _id_: 7977
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7978:
  _id_: 7978
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7979:
  _id_: 7979
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7980:
  _id_: 7980
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7981:
  _id_: 7981
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7982:
  _id_: 7982
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7983:
  _id_: 7983
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4613
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7984:
  _id_: 7984
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4614
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7986:
  _id_: 7986
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7987:
  _id_: 7987
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7988:
  _id_: 7988
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
7989:
  _id_: 7989
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7990:
  _id_: 7990
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
7991:
  _id_: 7991
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7992:
  _id_: 7992
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
7993:
  _id_: 7993
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7994:
  _id_: 7994
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
7996:
  _id_: 7996
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2347
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
7997:
  _id_: 7997
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2348
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
7998:
  _id_: 7998
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2349
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
7999:
  _id_: 7999
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2350
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8000:
  _id_: 8000
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2351
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8001:
  _id_: 8001
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2352
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8002:
  _id_: 8002
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2353
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8003:
  _id_: 8003
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4613
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8004:
  _id_: 8004
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dance of Hope NEO
    ja: 希望の乱舞 NEO
    ko: 희망의 난무 NEO
    zh_hant: 希望亂舞 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4614
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8006:
  _id_: 8006
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8007:
  _id_: 8007
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8008:
  _id_: 8008
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8009:
  _id_: 8009
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8010:
  _id_: 8010
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8011:
  _id_: 8011
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8012:
  _id_: 8012
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8013:
  _id_: 8013
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8014:
  _id_: 8014
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8016:
  _id_: 8016
  attribute_id: 1
  cost: 1
  icon_id: 402
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Resistance
    ja: 耐性の狙撃
    ko: 저항의 저격
    zh_hant: 耐性狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4907
  skill_field_effect_id: 906
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20015
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10322
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8017:
  _id_: 8017
  attribute_id: 1
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Poison
    ja: 毒の狙撃
    ko: 독의 저격
    zh_hant: 中毒狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4908
  skill_field_effect_id: 907
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20017
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8018:
  _id_: 8018
  attribute_id: 1
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Love
    ja: 恋の狙撃
    ko: 사랑의 저격
    zh_hant: 戀的狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4909
  skill_field_effect_id: 908
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20017
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8019:
  _id_: 8019
  attribute_id: 1
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Chest of Glory Encore
    ja: チェストオブグローリー Encore
    ko: 체스트 오브 글로리 Encore
    zh_hant: 榮耀之箱 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4910
  skill_field_effect_id: 909
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8021:
  _id_: 8021
  attribute_id: 8
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Slash
    ja: 煌めく斬撃
    ko: 빛나는 참격
    zh_hant: 輝煌斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4912
  skill_field_effect_id: 912
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8022:
  _id_: 8022
  attribute_id: 8
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Surprise Slash
    ja: 奇襲の斬撃
    ko: 기습의 참격
    zh_hant: 奇襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4913
  skill_field_effect_id: 913
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8023:
  _id_: 8023
  attribute_id: 8
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4914
  skill_field_effect_id: 914
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10302
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8024:
  _id_: 8024
  attribute_id: 8
  cost: 2
  icon_id: 1100
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Log
    ja: 甘い切り株
    ko: 달콤한 통나무
    zh_hant: 甜蜜的樹幹蛋糕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4915
  skill_field_effect_id: 915
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10330
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8026:
  _id_: 8026
  attribute_id: 5
  cost: 1
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4917
  skill_field_effect_id: 918
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10338
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8027:
  _id_: 8027
  attribute_id: 5
  cost: 2
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Hope
    ja: 希望の打撃
    ko: 희망의 타격
    zh_hant: 希望敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4918
  skill_field_effect_id: 919
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10338
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8028:
  _id_: 8028
  attribute_id: 5
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Superstrength
    ja: 怪力の打撃
    ko: 괴력의 타격
    zh_hant: 怪力敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4919
  skill_field_effect_id: 920
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10338
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8029:
  _id_: 8029
  attribute_id: 5
  cost: 2
  icon_id: 344
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet Encore
    ja: 金鳳花の絨毯 Encore
    ko: 미나리아재비의 양탄자 Encore
    zh_hant: 毛茛地毯 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4920
  skill_field_effect_id: 921
  skill_options:
  - hit_rate: 100
    id: 10110
    target_id: 1002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8031:
  _id_: 8031
  attribute_id: 4
  cost: 1
  icon_id: 383
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Hope
    ja: 希望の打撃
    ko: 희망의 타격
    zh_hant: 希望敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4922
  skill_field_effect_id: 923
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10290
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8032:
  _id_: 8032
  attribute_id: 4
  cost: 2
  icon_id: 364
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4923
  skill_field_effect_id: 924
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8033:
  _id_: 8033
  attribute_id: 4
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Smash
    ja: 封印の打撃
    ko: 봉인의 타격
    zh_hant: 封印敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4924
  skill_field_effect_id: 925
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
  - hit_rate: 100
    id: 20009
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8034:
  _id_: 8034
  attribute_id: 4
  cost: 2
  icon_id: 409
  is_multiple_command_unique_skill: 0
  name:
    en: Flickering Bubbles
    ja: 泡沫のゆらめき
    ko: 거품의 반짝임
    zh_hant: 搖曳泡沫
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4925
  skill_field_effect_id: 926
  skill_options:
  - hit_rate: 100
    id: 622
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10330
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8036:
  _id_: 8036
  attribute_id: 9
  cost: 2
  icon_id: 157
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Smash
    ja: 軽快な打撃
    ko: 경쾌한 타격
    zh_hant: 輕快敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4927
  skill_field_effect_id: 929
  skill_options:
  - hit_rate: 100
    id: 157
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
8037:
  _id_: 8037
  attribute_id: 9
  cost: 2
  icon_id: 1030
  is_multiple_command_unique_skill: 0
  name:
    en: Sweet Smash
    ja: 甘美な打撃
    ko: 감미로운 타격
    zh_hant: 甘美敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4928
  skill_field_effect_id: 930
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
8038:
  _id_: 8038
  attribute_id: 9
  cost: 2
  icon_id: 1099
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Ovation
    ja: 万雷の打撃
    ko: 만뢰의 타격
    zh_hant: 萬雷敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4929
  skill_field_effect_id: 931
  skill_options:
  - hit_rate: 100
    id: 22
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 39
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 180
    - 190
    - 200
    - 210
8039:
  _id_: 8039
  attribute_id: 9
  cost: 2
  icon_id: 1035
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance Encore
    ja: 青龍炎舞 Encore
    ko: 청룡염무 Encore
    zh_hant: 青龍炎舞 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4930
  skill_field_effect_id: 932
  skill_options:
  - hit_rate: 100
    id: 494
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 360
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 392
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 350
    - 370
    - 390
    - 420
    - 450
8053:
  _id_: 8053
  attribute_id: 5
  cost: 2
  icon_id: 420
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Resistance
    ja: 耐性の打撃
    ko: 저항의 타격
    zh_hant: 耐性敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4933
  skill_field_effect_id: 934
  skill_options:
  - hit_rate: 100
    id: 20015
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10348
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8054:
  _id_: 8054
  attribute_id: 5
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Fainting
    ja: 失神の打撃
    ko: 실신의 타격
    zh_hant: 昏厥敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4934
  skill_field_effect_id: 935
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8055:
  _id_: 8055
  attribute_id: 5
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4935
  skill_field_effect_id: 936
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8056:
  _id_: 8056
  attribute_id: 5
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 1
  name:
    en: Thunderclap
    ja: 闇戯雷鳴
    ko: 암희뇌명
    zh_hant: 暗戲雷鳴
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4936
  skill_field_effect_id: 937
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8058:
  _id_: 8058
  attribute_id: 2
  cost: 1
  icon_id: 378
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4938
  skill_field_effect_id: 940
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20013
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10297
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8059:
  _id_: 8059
  attribute_id: 2
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4939
  skill_field_effect_id: 941
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 20009
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8060:
  _id_: 8060
  attribute_id: 2
  cost: 2
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4940
  skill_field_effect_id: 942
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 20009
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8061:
  _id_: 8061
  attribute_id: 2
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Pure Knight Encore
    ja: 穢れなき騎士 Encore
    ko: 고결한 기사 Encore
    zh_hant: 無垢的騎士 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4941
  skill_field_effect_id: 943
  skill_options:
  - hit_rate: 100
    id: 10299
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8063:
  _id_: 8063
  attribute_id: 1
  cost: 2
  icon_id: 423
  is_multiple_command_unique_skill: 0
  name:
    en: Resistance Strike
    ja: 耐性の一撃
    ko: 저항의 일격
    zh_hant: 耐性一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4943
  skill_field_effect_id: 946
  skill_options:
  - hit_rate: 100
    id: 20018
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10351
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8064:
  _id_: 8064
  attribute_id: 1
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4944
  skill_field_effect_id: 947
  skill_options:
  - hit_rate: 100
    id: 10303
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8065:
  _id_: 8065
  attribute_id: 1
  cost: 2
  icon_id: 274
  is_multiple_command_unique_skill: 0
  name:
    en: Absorb Strike
    ja: 吸収の一撃
    ko: 흡수의 일격
    zh_hant: 吸收一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4945
  skill_field_effect_id: 948
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8066:
  _id_: 8066
  attribute_id: 1
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Avalon's Invitation Encore
    ja: アヴァロンへの誘い Encore
    ko: 아발론으로의 초대 Encore
    zh_hant: 阿瓦隆的邀請 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4946
  skill_field_effect_id: 949
  skill_options:
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10324
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8068:
  _id_: 8068
  attribute_id: 9
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4948
  skill_field_effect_id: 952
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8069:
  _id_: 8069
  attribute_id: 9
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Impudence
    ja: 慢心の斬撃
    ko: 방심의 참격
    zh_hant: 傲慢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4949
  skill_field_effect_id: 953
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8070:
  _id_: 8070
  attribute_id: 9
  cost: 2
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4950
  skill_field_effect_id: 954
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8071:
  _id_: 8071
  attribute_id: 9
  cost: 2
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Legendary Hero Encore
    ja: 伝説の勇者 Encore
    ko: 전설의 용사 Encore
    zh_hant: 傳說的勇者 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4951
  skill_field_effect_id: 955
  skill_options:
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8113:
  _id_: 8113
  attribute_id: 3
  cost: 1
  icon_id: 423
  is_multiple_command_unique_skill: 0
  name:
    en: Resistance Flash
    ja: 耐性の一閃
    ko: 저항의 일섬
    zh_hant: 耐性閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4973
  skill_field_effect_id: 958
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20018
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10351
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8114:
  _id_: 8114
  attribute_id: 3
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Poison
    ja: 毒の一閃
    ko: 독의 일섬
    zh_hant: 中毒閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4974
  skill_field_effect_id: 959
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20019
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8115:
  _id_: 8115
  attribute_id: 3
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Love
    ja: 恋の一閃
    ko: 사랑의 일섬
    zh_hant: 戀的閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4975
  skill_field_effect_id: 960
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20019
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8116:
  _id_: 8116
  attribute_id: 3
  cost: 2
  icon_id: 426
  is_multiple_command_unique_skill: 0
  name:
    en: The World Is Rosy
    ja: The world is rosy
    ko: The world is rosy
    zh_hant: The world is rosy
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4976
  skill_field_effect_id: 961
  skill_options:
  - hit_rate: 100
    id: 623
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 20019
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8118:
  _id_: 8118
  attribute_id: 2
  cost: 1
  icon_id: 420
  is_multiple_command_unique_skill: 0
  name:
    en: Resistance Flash
    ja: 耐性の一閃
    ko: 저항의 일섬
    zh_hant: 耐性閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4978
  skill_field_effect_id: 964
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 570
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10348
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8119:
  _id_: 8119
  attribute_id: 2
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Impudence
    ja: 慢心の一閃
    ko: 방심의 일섬
    zh_hant: 傲慢閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4979
  skill_field_effect_id: 965
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8120:
  _id_: 8120
  attribute_id: 2
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Flash
    ja: 軽快な一閃
    ko: 경쾌한 일섬
    zh_hant: 輕快閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4980
  skill_field_effect_id: 966
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
  - hit_rate: 100
    id: 20017
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8121:
  _id_: 8121
  attribute_id: 2
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Yellow Tornado Encore
    ja: イエローファイントルネード Encore
    ko: 옐로우 파인 토네이도 Encore
    zh_hant: 燦黃龍捲風 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4981
  skill_field_effect_id: 967
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10330
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 383
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 587
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8123:
  _id_: 8123
  attribute_id: 5
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Strike
    ja: 封印の一撃
    ko: 봉인의 일격
    zh_hant: 封印一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4983
  skill_field_effect_id: 970
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8124:
  _id_: 8124
  attribute_id: 5
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4984
  skill_field_effect_id: 971
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8125:
  _id_: 8125
  attribute_id: 5
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4985
  skill_field_effect_id: 972
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8126:
  _id_: 8126
  attribute_id: 5
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 1
  name:
    en: Conflagration of the Black Lion
    ja: 黒獅子の劫火
    ko: 흑사자의 겁화
    zh_hant: 黑獅子劫火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4986
  skill_field_effect_id: 973
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8140:
  _id_: 8140
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8141:
  _id_: 8141
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8142:
  _id_: 8142
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8143:
  _id_: 8143
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8144:
  _id_: 8144
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
8145:
  _id_: 8145
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
8146:
  _id_: 8146
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
8147:
  _id_: 8147
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8148:
  _id_: 8148
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
8150:
  _id_: 8150
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8151:
  _id_: 8151
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8152:
  _id_: 8152
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8153:
  _id_: 8153
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8154:
  _id_: 8154
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8155:
  _id_: 8155
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8156:
  _id_: 8156
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8157:
  _id_: 8157
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8158:
  _id_: 8158
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
8160:
  _id_: 8160
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3257
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8161:
  _id_: 8161
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8162:
  _id_: 8162
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8163:
  _id_: 8163
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8164:
  _id_: 8164
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8165:
  _id_: 8165
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3262
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
8166:
  _id_: 8166
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
8167:
  _id_: 8167
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8168:
  _id_: 8168
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
8170:
  _id_: 8170
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8171:
  _id_: 8171
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8172:
  _id_: 8172
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8173:
  _id_: 8173
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8174:
  _id_: 8174
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8175:
  _id_: 8175
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8176:
  _id_: 8176
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8177:
  _id_: 8177
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
8178:
  _id_: 8178
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8179:
  _id_: 8179
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
8181:
  _id_: 8181
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8182:
  _id_: 8182
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8183:
  _id_: 8183
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8184:
  _id_: 8184
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8185:
  _id_: 8185
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8186:
  _id_: 8186
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8187:
  _id_: 8187
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8188:
  _id_: 8188
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8190:
  _id_: 8190
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8191:
  _id_: 8191
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8192:
  _id_: 8192
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8193:
  _id_: 8193
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8194:
  _id_: 8194
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8195:
  _id_: 8195
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8196:
  _id_: 8196
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8197:
  _id_: 8197
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8198:
  _id_: 8198
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8199:
  _id_: 8199
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8201:
  _id_: 8201
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8202:
  _id_: 8202
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8203:
  _id_: 8203
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8204:
  _id_: 8204
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8205:
  _id_: 8205
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8206:
  _id_: 8206
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8207:
  _id_: 8207
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8208:
  _id_: 8208
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8209:
  _id_: 8209
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8210:
  _id_: 8210
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8212:
  _id_: 8212
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8213:
  _id_: 8213
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8214:
  _id_: 8214
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8215:
  _id_: 8215
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8216:
  _id_: 8216
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8217:
  _id_: 8217
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8218:
  _id_: 8218
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8219:
  _id_: 8219
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8221:
  _id_: 8221
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8222:
  _id_: 8222
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8223:
  _id_: 8223
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8224:
  _id_: 8224
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8225:
  _id_: 8225
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8226:
  _id_: 8226
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8227:
  _id_: 8227
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8228:
  _id_: 8228
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8230:
  _id_: 8230
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8231:
  _id_: 8231
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8232:
  _id_: 8232
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8233:
  _id_: 8233
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8234:
  _id_: 8234
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8235:
  _id_: 8235
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8236:
  _id_: 8236
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8237:
  _id_: 8237
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8238:
  _id_: 8238
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8239:
  _id_: 8239
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8241:
  _id_: 8241
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8242:
  _id_: 8242
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8243:
  _id_: 8243
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8244:
  _id_: 8244
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8245:
  _id_: 8245
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8246:
  _id_: 8246
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8247:
  _id_: 8247
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8248:
  _id_: 8248
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8249:
  _id_: 8249
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8250:
  _id_: 8250
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8252:
  _id_: 8252
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8253:
  _id_: 8253
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8254:
  _id_: 8254
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8255:
  _id_: 8255
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8256:
  _id_: 8256
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8257:
  _id_: 8257
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8258:
  _id_: 8258
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8259:
  _id_: 8259
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8261:
  _id_: 8261
  attribute_id: 9
  cost: 1
  icon_id: 434
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4989
  skill_field_effect_id: 976
  skill_options:
  - hit_rate: 100
    id: 10362
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8262:
  _id_: 8262
  attribute_id: 9
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Slash
    ja: 煌めく斬撃
    ko: 빛나는 참격
    zh_hant: 輝煌斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4990
  skill_field_effect_id: 977
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8263:
  _id_: 8263
  attribute_id: 9
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4991
  skill_field_effect_id: 978
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8264:
  _id_: 8264
  attribute_id: 9
  cost: 2
  icon_id: 407
  is_multiple_command_unique_skill: 1
  name:
    en: Arrow of Heaven
    ja: 天上の光矢
    ko: 천상의 빛 화살
    zh_hant: 天上光箭
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4992
  skill_field_effect_id: 979
  skill_options:
  - hit_rate: 100
    id: 10328
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8266:
  _id_: 8266
  attribute_id: 4
  cost: 1
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Poison
    ja: 毒の斬撃
    ko: 독의 참격
    zh_hant: 中毒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4994
  skill_field_effect_id: 982
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20018
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 276
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8267:
  _id_: 8267
  attribute_id: 4
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4995
  skill_field_effect_id: 983
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20019
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 276
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8268:
  _id_: 8268
  attribute_id: 4
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4996
  skill_field_effect_id: 984
  skill_options:
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 276
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8269:
  _id_: 8269
  attribute_id: 4
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Piercing Evil Encore
    ja: 破邪の貫き Encore
    ko: 퇴마의 꿰뚫기 Encore
    zh_hant: 貫穿邪惡 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4997
  skill_field_effect_id: 985
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20008
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 276
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8271:
  _id_: 8271
  attribute_id: 1
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Poison
    ja: 毒の斬撃
    ko: 독의 참격
    zh_hant: 中毒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4999
  skill_field_effect_id: 988
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8272:
  _id_: 8272
  attribute_id: 1
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5000
  skill_field_effect_id: 989
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8273:
  _id_: 8273
  attribute_id: 1
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5001
  skill_field_effect_id: 990
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8274:
  _id_: 8274
  attribute_id: 1
  cost: 2
  icon_id: 435
  is_multiple_command_unique_skill: 0
  name:
    en: Love Is Rosy
    ja: The love is rosy
    ko: The love is rosy
    zh_hant: The love is rosy
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5002
  skill_field_effect_id: 991
  skill_options:
  - hit_rate: 100
    id: 10363
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8291:
  _id_: 8291
  attribute_id: 3
  cost: 2
  icon_id: 439
  is_multiple_command_unique_skill: 0
  name:
    en: Hindering Slash
    ja: 妨害の斬撃
    ko: 방해의 참격
    zh_hant: 妨礙斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5008
  skill_field_effect_id: 994
  skill_options:
  - hit_rate: 100
    id: 20016
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10367
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8292:
  _id_: 8292
  attribute_id: 3
  cost: 2
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5009
  skill_field_effect_id: 995
  skill_options:
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8293:
  _id_: 8293
  attribute_id: 3
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5010
  skill_field_effect_id: 996
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8294:
  _id_: 8294
  attribute_id: 3
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 1
  name:
    en: Healing Guidance
    ja: 癒しの導き
    ko: 치유의 인도
    zh_hant: 治癒指引
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5011
  skill_field_effect_id: 997
  skill_options:
  - hit_rate: 100
    id: 20016
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8296:
  _id_: 8296
  attribute_id: 4
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5013
  skill_field_effect_id: 1000
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8297:
  _id_: 8297
  attribute_id: 4
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5014
  skill_field_effect_id: 1001
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8298:
  _id_: 8298
  attribute_id: 4
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5015
  skill_field_effect_id: 1002
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8299:
  _id_: 8299
  attribute_id: 4
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Orpheus's Melody Encore
    ja: オルフェウスの調べ Encore
    ko: 오르페우스의 멜로디 Encore
    zh_hant: 奧菲斯的旋律 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5016
  skill_field_effect_id: 1003
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8326:
  _id_: 8326
  attribute_id: 6
  cost: 2
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Slash
    ja: 火炎の斬撃
    ko: 화염의 참격
    zh_hant: 火焰斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5038
  skill_field_effect_id: 1006
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8327:
  _id_: 8327
  attribute_id: 6
  cost: 2
  icon_id: 337
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Frost
    ja: 凍結の斬撃
    ko: 동결의 참격
    zh_hant: 凍結斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5039
  skill_field_effect_id: 1007
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10040
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8328:
  _id_: 8328
  attribute_id: 6
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5040
  skill_field_effect_id: 1008
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8329:
  _id_: 8329
  attribute_id: 6
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 1
  name:
    en: Toys - Psychokinesis Encore
    ja: トイズ～サイコキネシス～ Encore
    ko: 토이즈 ~사이코키네시스~ Encore
    zh_hant: TOYS～念動力～ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5041
  skill_field_effect_id: 1009
  skill_options:
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8331:
  _id_: 8331
  attribute_id: 8
  cost: 1
  icon_id: 436
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5043
  skill_field_effect_id: 1012
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10364
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10362
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8332:
  _id_: 8332
  attribute_id: 8
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fainting
    ja: 失神の斬撃
    ko: 실신의 참격
    zh_hant: 昏厥斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5044
  skill_field_effect_id: 1013
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8333:
  _id_: 8333
  attribute_id: 8
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5045
  skill_field_effect_id: 1014
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8334:
  _id_: 8334
  attribute_id: 8
  cost: 2
  icon_id: 426
  is_multiple_command_unique_skill: 1
  name:
    en: Toys "Psychokinesis"
    ja: トイズ『サイコキネシス』
    ko: 토이즈 [사이코키네시스]
    zh_hant: TOYS『念動力』
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5046
  skill_field_effect_id: 1015
  skill_options:
  - hit_rate: 100
    id: 511
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 623
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 3
    - 3
    - 3
    - 3
    - 3
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 88
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8336:
  _id_: 8336
  attribute_id: 8
  cost: 1
  icon_id: 440
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Clarity
    ja: 耐錯の斬撃
    ko: 내착의 참격
    zh_hant: 耐錯斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5048
  skill_field_effect_id: 1018
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20020
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10371
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8337:
  _id_: 8337
  attribute_id: 8
  cost: 1
  icon_id: 423
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Humility
    ja: 耐慢の斬撃
    ko: 내만의 참격
    zh_hant: 耐慢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5049
  skill_field_effect_id: 1019
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20018
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10351
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8338:
  _id_: 8338
  attribute_id: 8
  cost: 1
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5050
  skill_field_effect_id: 1020
  skill_options:
  - hit_rate: 100
    id: 10302
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8339:
  _id_: 8339
  attribute_id: 8
  cost: 1
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Toys "Tri-Ascend"
    ja: トイズ『トライアセンド』
    ko: 토이즈 [트라이어센드]
    zh_hant: TOYS『三重上升』
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5051
  skill_field_effect_id: 1021
  skill_options:
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20020
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10230
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8341:
  _id_: 8341
  attribute_id: 3
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Superstrength
    ja: 怪力の狙撃
    ko: 괴력의 저격
    zh_hant: 怪力狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5053
  skill_field_effect_id: 1024
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8342:
  _id_: 8342
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Sharpshooting
    ja: 増強の狙撃
    ko: 증강의 저격
    zh_hant: 增強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5054
  skill_field_effect_id: 1025
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8343:
  _id_: 8343
  attribute_id: 3
  cost: 2
  icon_id: 373
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5055
  skill_field_effect_id: 1026
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8344:
  _id_: 8344
  attribute_id: 3
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Toys "Hyper Sensitive"
    ja: トイズ『ハイパーセンシティブ』
    ko: 토이즈 [하이퍼 센서티브]
    zh_hant: TOYS『五感強化』
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5056
  skill_field_effect_id: 1027
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8346:
  _id_: 8346
  attribute_id: 6
  cost: 1
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5061
  skill_field_effect_id: 1030
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8347:
  _id_: 8347
  attribute_id: 6
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5062
  skill_field_effect_id: 1031
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8348:
  _id_: 8348
  attribute_id: 6
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5063
  skill_field_effect_id: 1032
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8349:
  _id_: 8349
  attribute_id: 6
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Shikigami Encore
    ja: 清めの式神 Encore
    ko: 정화의 식신 Encore
    zh_hant: 淨化的式神 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5064
  skill_field_effect_id: 1033
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8351:
  _id_: 8351
  attribute_id: 2
  cost: 1
  icon_id: 377
  is_multiple_command_unique_skill: 0
  name:
    en: Marked Slash
    ja: 刻印の斬撃
    ko: 각인의 참격
    zh_hant: 刻印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5066
  skill_field_effect_id: 1036
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10298
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8352:
  _id_: 8352
  attribute_id: 2
  cost: 2
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5067
  skill_field_effect_id: 1037
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8353:
  _id_: 8353
  attribute_id: 2
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5068
  skill_field_effect_id: 1038
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10302
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8354:
  _id_: 8354
  attribute_id: 2
  cost: 2
  icon_id: 442
  is_multiple_command_unique_skill: 0
  name:
    en: Toys "Direct Hack"
    ja: トイズ『ダイレクトハック』
    ko: 토이즈 [다이렉트 핵]
    zh_hant: TOYS『電子入侵』
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5069
  skill_field_effect_id: 1039
  skill_options:
  - hit_rate: 100
    id: 10375
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8356:
  _id_: 8356
  attribute_id: 1
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Daze
    ja: 錯乱の一閃
    ko: 착란의 일섬
    zh_hant: 錯亂閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5072
  skill_field_effect_id: 1042
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8357:
  _id_: 8357
  attribute_id: 1
  cost: 2
  icon_id: 444
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Impudence
    ja: 慢心の一閃
    ko: 방심의 일섬
    zh_hant: 傲慢閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5073
  skill_field_effect_id: 1043
  skill_options:
  - hit_rate: 100
    id: 10378
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8358:
  _id_: 8358
  attribute_id: 1
  cost: 2
  icon_id: 435
  is_multiple_command_unique_skill: 0
  name:
    en: Fierce Flash
    ja: 猛攻の一閃
    ko: 맹공의 일섬
    zh_hant: 猛攻閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5074
  skill_field_effect_id: 1044
  skill_options:
  - hit_rate: 100
    id: 10363
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8359:
  _id_: 8359
  attribute_id: 1
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Sun's Guidance
    ja: お日様の導き
    ko: 햇님의 인도
    zh_hant: 太陽的引導
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5075
  skill_field_effect_id: 1045
  skill_options:
  - hit_rate: 100
    id: 20021
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10379
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 10
    - 10
    - 10
    - 10
    - 10
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8373:
  _id_: 8373
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting
    ja: 狙撃
    ko: 저격
    zh_hant: 狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8374:
  _id_: 8374
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8375:
  _id_: 8375
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8376:
  _id_: 8376
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8377:
  _id_: 8377
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2610
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8378:
  _id_: 8378
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8379:
  _id_: 8379
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Rondo
    ja: 闇炎の輪舞曲
    ko: 암흑 불꽃의 윤무곡
    zh_hant: 暗炎圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8380:
  _id_: 8380
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8382:
  _id_: 8382
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8383:
  _id_: 8383
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8384:
  _id_: 8384
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8385:
  _id_: 8385
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8386:
  _id_: 8386
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8387:
  _id_: 8387
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8388:
  _id_: 8388
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8389:
  _id_: 8389
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8390:
  _id_: 8390
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8391:
  _id_: 8391
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8393:
  _id_: 8393
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8394:
  _id_: 8394
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8395:
  _id_: 8395
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2643
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8396:
  _id_: 8396
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8397:
  _id_: 8397
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8398:
  _id_: 8398
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8399:
  _id_: 8399
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8400:
  _id_: 8400
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2648
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8401:
  _id_: 8401
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8403:
  _id_: 8403
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8404:
  _id_: 8404
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
8405:
  _id_: 8405
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8406:
  _id_: 8406
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8407:
  _id_: 8407
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8408:
  _id_: 8408
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8409:
  _id_: 8409
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8410:
  _id_: 8410
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8411:
  _id_: 8411
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8412:
  _id_: 8412
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8413:
  _id_: 8413
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8415:
  _id_: 8415
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8416:
  _id_: 8416
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8417:
  _id_: 8417
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8418:
  _id_: 8418
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8419:
  _id_: 8419
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8420:
  _id_: 8420
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8421:
  _id_: 8421
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8422:
  _id_: 8422
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5078
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8423:
  _id_: 8423
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5079
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8425:
  _id_: 8425
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8426:
  _id_: 8426
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8427:
  _id_: 8427
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8428:
  _id_: 8428
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8429:
  _id_: 8429
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8430:
  _id_: 8430
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8431:
  _id_: 8431
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8432:
  _id_: 8432
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8434:
  _id_: 8434
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8435:
  _id_: 8435
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8436:
  _id_: 8436
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8437:
  _id_: 8437
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8438:
  _id_: 8438
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8439:
  _id_: 8439
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8440:
  _id_: 8440
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8441:
  _id_: 8441
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8442:
  _id_: 8442
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8443:
  _id_: 8443
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8445:
  _id_: 8445
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8446:
  _id_: 8446
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8447:
  _id_: 8447
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8448:
  _id_: 8448
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8449:
  _id_: 8449
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8450:
  _id_: 8450
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8451:
  _id_: 8451
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8452:
  _id_: 8452
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8453:
  _id_: 8453
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8454:
  _id_: 8454
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8455:
  _id_: 8455
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8457:
  _id_: 8457
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Thrust
    ja: 強刺突
    ko: 강한 찌르기
    zh_hant: 強突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2669
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8458:
  _id_: 8458
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Thrust
    ja: 強双刺突
    ko: 강한 두번 찌르기
    zh_hant: 強雙突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2670
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8459:
  _id_: 8459
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Thrust
    ja: 参刺突
    ko: 세번 찌르기
    zh_hant: 參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2671
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8460:
  _id_: 8460
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Thrust
    ja: 強参刺突
    ko: 강한 세번 찌르기
    zh_hant: 強參突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2672
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8461:
  _id_: 8461
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2673
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8462:
  _id_: 8462
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2674
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8463:
  _id_: 8463
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2675
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8464:
  _id_: 8464
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Thrust
    ja: 必中の刺突
    ko: 백발백중의 찌르기
    zh_hant: 必中突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5078
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8465:
  _id_: 8465
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: I'm Late! NEO
    ja: 遅刻しちゃう！ NEO
    ko: 지각하겠어! NEO
    zh_hant: 要遲到了！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5079
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8467:
  _id_: 8467
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8468:
  _id_: 8468
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8469:
  _id_: 8469
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8470:
  _id_: 8470
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8471:
  _id_: 8471
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8472:
  _id_: 8472
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8473:
  _id_: 8473
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8474:
  _id_: 8474
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8476:
  _id_: 8476
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8477:
  _id_: 8477
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8478:
  _id_: 8478
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8479:
  _id_: 8479
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8480:
  _id_: 8480
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8481:
  _id_: 8481
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8482:
  _id_: 8482
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8483:
  _id_: 8483
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8484:
  _id_: 8484
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8485:
  _id_: 8485
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8487:
  _id_: 8487
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8488:
  _id_: 8488
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8489:
  _id_: 8489
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8490:
  _id_: 8490
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8491:
  _id_: 8491
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8492:
  _id_: 8492
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8493:
  _id_: 8493
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8494:
  _id_: 8494
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8495:
  _id_: 8495
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8496:
  _id_: 8496
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8497:
  _id_: 8497
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8499:
  _id_: 8499
  attribute_id: 5
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Poison
    ja: 毒の打撃
    ko: 독의 타격
    zh_hant: 中毒敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5086
  skill_field_effect_id: 1054
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8500:
  _id_: 8500
  attribute_id: 5
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Love
    ja: 恋の打撃
    ko: 사랑의 타격
    zh_hant: 戀的敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5087
  skill_field_effect_id: 1055
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8501:
  _id_: 8501
  attribute_id: 5
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Daze
    ja: 錯乱の打撃
    ko: 착란의 타격
    zh_hant: 錯亂敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5088
  skill_field_effect_id: 1056
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8502:
  _id_: 8502
  attribute_id: 5
  cost: 2
  icon_id: 448
  is_multiple_command_unique_skill: 0
  name:
    en: Aroundight Flash Encore
    ja: アロンダイトの一閃 Encore
    ko: 아론다이트의 일섬 Encore
    zh_hant: 阿隆戴特的一閃 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5089
  skill_field_effect_id: 1057
  skill_options:
  - hit_rate: 100
    id: 10381
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8504:
  _id_: 8504
  attribute_id: 1
  cost: 1
  icon_id: 449
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5091
  skill_field_effect_id: 1060
  skill_options:
  - hit_rate: 100
    id: 20022
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10382
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8505:
  _id_: 8505
  attribute_id: 1
  cost: 2
  icon_id: 1091
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of the Goddess
    ja: 女神の斬撃
    ko: 여신의 참격
    zh_hant: 女神斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5092
  skill_field_effect_id: 1061
  skill_options:
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8506:
  _id_: 8506
  attribute_id: 1
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5093
  skill_field_effect_id: 1062
  skill_options:
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8507:
  _id_: 8507
  attribute_id: 1
  cost: 2
  icon_id: 451
  is_multiple_command_unique_skill: 1
  name:
    en: Lily of Revelation
    ja: Lily of revelation
    ko: Lily of revelation
    zh_hant: Lily of revelation
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5094
  skill_field_effect_id: 1063
  skill_options:
  - hit_rate: 100
    id: 10385
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8519:
  _id_: 8519
  attribute_id: 2
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Superstrength
    ja: 怪力の一閃
    ko: 괴력의 일섬
    zh_hant: 怪力閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5096
  skill_field_effect_id: 1066
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8520:
  _id_: 8520
  attribute_id: 2
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Flash
    ja: 増強の一閃
    ko: 증강의 일섬
    zh_hant: 增強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5097
  skill_field_effect_id: 1067
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8521:
  _id_: 8521
  attribute_id: 2
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Flash
    ja: 封印の一閃
    ko: 봉인의 일섬
    zh_hant: 封印閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5098
  skill_field_effect_id: 1068
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8522:
  _id_: 8522
  attribute_id: 2
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Trade Secrets Encore
    ja: 商いの極意 Encore
    ko: 장사의 비법 Encore
    zh_hant: 商人的秘訣 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5099
  skill_field_effect_id: 1069
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8524:
  _id_: 8524
  attribute_id: 1
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Superstrength
    ja: 怪力の一撃
    ko: 괴력의 일격
    zh_hant: 怪力一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5101
  skill_field_effect_id: 1072
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8525:
  _id_: 8525
  attribute_id: 1
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5102
  skill_field_effect_id: 1073
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8526:
  _id_: 8526
  attribute_id: 1
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Strike
    ja: 致命の一撃
    ko: 치명의 일격
    zh_hant: 致命一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5103
  skill_field_effect_id: 1074
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8527:
  _id_: 8527
  attribute_id: 1
  cost: 2
  icon_id: 1103
  is_multiple_command_unique_skill: 1
  name:
    en: Fruchtbarkeit Encore
    ja: フルフトバーカイト Encore
    ko: 프루흐트바카이트 Encore
    zh_hant: 豐饒 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5104
  skill_field_effect_id: 1075
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8559:
  _id_: 8559
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8560:
  _id_: 8560
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8561:
  _id_: 8561
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2834
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8562:
  _id_: 8562
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8563:
  _id_: 8563
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8564:
  _id_: 8564
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8565:
  _id_: 8565
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8566:
  _id_: 8566
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2839
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8568:
  _id_: 8568
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8569:
  _id_: 8569
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8570:
  _id_: 8570
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8571:
  _id_: 8571
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8572:
  _id_: 8572
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8573:
  _id_: 8573
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
8574:
  _id_: 8574
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8575:
  _id_: 8575
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8577:
  _id_: 8577
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8578:
  _id_: 8578
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Sharpshooting
    ja: 双狙撃
    ko: 쌍저격
    zh_hant: 雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2866
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8579:
  _id_: 8579
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Sharpshooting
    ja: 強襲の双狙撃
    ko: 강습의 쌍저격
    zh_hant: 強襲雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8580:
  _id_: 8580
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8581:
  _id_: 8581
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8582:
  _id_: 8582
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8583:
  _id_: 8583
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2871
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8584:
  _id_: 8584
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8585:
  _id_: 8585
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8587:
  _id_: 8587
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8588:
  _id_: 8588
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8589:
  _id_: 8589
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8590:
  _id_: 8590
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8591:
  _id_: 8591
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8592:
  _id_: 8592
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
8593:
  _id_: 8593
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8594:
  _id_: 8594
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8595:
  _id_: 8595
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8597:
  _id_: 8597
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8598:
  _id_: 8598
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8599:
  _id_: 8599
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8600:
  _id_: 8600
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8601:
  _id_: 8601
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8602:
  _id_: 8602
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8603:
  _id_: 8603
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8604:
  _id_: 8604
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fire Flower Dance
    ja: 炎花の舞
    ko: 염화의 춤
    zh_hant: 炎花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4799
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8605:
  _id_: 8605
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4800
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8607:
  _id_: 8607
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8608:
  _id_: 8608
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8609:
  _id_: 8609
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8610:
  _id_: 8610
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8611:
  _id_: 8611
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8612:
  _id_: 8612
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8613:
  _id_: 8613
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8614:
  _id_: 8614
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8616:
  _id_: 8616
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8617:
  _id_: 8617
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8618:
  _id_: 8618
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8619:
  _id_: 8619
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8620:
  _id_: 8620
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8621:
  _id_: 8621
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8622:
  _id_: 8622
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8623:
  _id_: 8623
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8624:
  _id_: 8624
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8625:
  _id_: 8625
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8627:
  _id_: 8627
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8628:
  _id_: 8628
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8629:
  _id_: 8629
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8630:
  _id_: 8630
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8631:
  _id_: 8631
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8632:
  _id_: 8632
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
8633:
  _id_: 8633
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8634:
  _id_: 8634
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8635:
  _id_: 8635
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8637:
  _id_: 8637
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Flash
    ja: 強一閃
    ko: 강일섬
    zh_hant: 強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2893
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8638:
  _id_: 8638
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Twin Flash
    ja: 強襲の双一閃
    ko: 강습의 쌍일섬
    zh_hant: 強襲雙閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2894
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8639:
  _id_: 8639
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Flash
    ja: 参一閃
    ko: 삼일섬
    zh_hant: 參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2895
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8640:
  _id_: 8640
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Flash
    ja: 強襲の参一閃
    ko: 강습의 삼일섬
    zh_hant: 強襲參閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2896
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8641:
  _id_: 8641
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2897
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8642:
  _id_: 8642
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2898
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8643:
  _id_: 8643
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2899
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8644:
  _id_: 8644
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Fire Flower Dance
    ja: 炎花の舞
    ko: 염화의 춤
    zh_hant: 炎花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4799
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8645:
  _id_: 8645
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flower Festival Type 3 NEO
    ja: 百花繚乱　其の参 NEO
    ko: 백화요란 3 NEO
    zh_hant: 百花繚亂　其三 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4800
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8647:
  _id_: 8647
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8648:
  _id_: 8648
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8649:
  _id_: 8649
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8650:
  _id_: 8650
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8651:
  _id_: 8651
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8652:
  _id_: 8652
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8653:
  _id_: 8653
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8654:
  _id_: 8654
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8656:
  _id_: 8656
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8657:
  _id_: 8657
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8658:
  _id_: 8658
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8659:
  _id_: 8659
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8660:
  _id_: 8660
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8661:
  _id_: 8661
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8662:
  _id_: 8662
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8663:
  _id_: 8663
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8664:
  _id_: 8664
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8665:
  _id_: 8665
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8667:
  _id_: 8667
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8668:
  _id_: 8668
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8669:
  _id_: 8669
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8670:
  _id_: 8670
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8671:
  _id_: 8671
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8672:
  _id_: 8672
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
8673:
  _id_: 8673
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8674:
  _id_: 8674
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8675:
  _id_: 8675
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8677:
  _id_: 8677
  attribute_id: 3
  cost: 1
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Impudence
    ja: 慢心の斬撃
    ko: 방심의 참격
    zh_hant: 傲慢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5114
  skill_field_effect_id: 1078
  skill_options:
  - hit_rate: 100
    id: 10311
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8678:
  _id_: 8678
  attribute_id: 3
  cost: 2
  icon_id: 381
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5115
  skill_field_effect_id: 1079
  skill_options:
  - hit_rate: 100
    id: 10311
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8679:
  _id_: 8679
  attribute_id: 3
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5116
  skill_field_effect_id: 1080
  skill_options:
  - hit_rate: 100
    id: 10311
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10379
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8680:
  _id_: 8680
  attribute_id: 3
  cost: 2
  icon_id: 452
  is_multiple_command_unique_skill: 1
  name:
    en: Shackles of Poison Encore
    ja: 毒林檎の枷 Encore
    ko: 독사과의 족쇄 Encore
    zh_hant: 毒蘋果的枷鎖 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5117
  skill_field_effect_id: 1081
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10376
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10388
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8682:
  _id_: 8682
  attribute_id: 4
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Poison
    ja: 毒の斬撃
    ko: 독의 참격
    zh_hant: 中毒斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5119
  skill_field_effect_id: 1084
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8683:
  _id_: 8683
  attribute_id: 4
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5120
  skill_field_effect_id: 1085
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8684:
  _id_: 8684
  attribute_id: 4
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5121
  skill_field_effect_id: 1086
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8685:
  _id_: 8685
  attribute_id: 4
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 1
  name:
    en: Urgewalt Encore
    ja: ウーア・ゲヴァルト Encore
    ko: 우어게발트 Encore
    zh_hant: 根源之力 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5122
  skill_field_effect_id: 1087
  skill_options:
  - hit_rate: 100
    id: 10302
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
8687:
  _id_: 8687
  attribute_id: 7
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Poison
    ja: 毒の刺突
    ko: 독의 찌르기
    zh_hant: 中毒突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5124
  skill_field_effect_id: 1090
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10110
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8688:
  _id_: 8688
  attribute_id: 7
  cost: 2
  icon_id: 363
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Sleep
    ja: 睡眠の刺突
    ko: 수면의 찌르기
    zh_hant: 睡眠突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5125
  skill_field_effect_id: 1091
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10110
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10281
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8689:
  _id_: 8689
  attribute_id: 7
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Superstrength
    ja: 怪力の刺突
    ko: 괴력의 찌르기
    zh_hant: 怪力突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5126
  skill_field_effect_id: 1092
  skill_options:
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10305
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8690:
  _id_: 8690
  attribute_id: 7
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Auflodern Encore
    ja: アオフ・ローダーン Encore
    ko: 아우프로데른 Encore
    zh_hant: 熱焰燃燒 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5127
  skill_field_effect_id: 1093
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8692:
  _id_: 8692
  attribute_id: 9
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Impudence
    ja: 慢心の斬撃
    ko: 방심의 참격
    zh_hant: 傲慢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5129
  skill_field_effect_id: 1097
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
8693:
  _id_: 8693
  attribute_id: 9
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5130
  skill_field_effect_id: 1098
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8694:
  _id_: 8694
  attribute_id: 9
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5131
  skill_field_effect_id: 1099
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8695:
  _id_: 8695
  attribute_id: 9
  cost: 2
  icon_id: 454
  is_multiple_command_unique_skill: 0
  name:
    en: Zufrieren Encore
    ja: ツー・フリーレン Encore
    ko: 추프리렌 Encore
    zh_hant: 凍結冰雪 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5132
  skill_field_effect_id: 1100
  skill_options:
  - hit_rate: 100
    id: 10328
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10393
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10379
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8697:
  _id_: 8697
  attribute_id: 5
  cost: 1
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Support
    ja: 支援の一閃
    ko: 지원의 일섬
    zh_hant: 支援閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5134
  skill_field_effect_id: 1103
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8698:
  _id_: 8698
  attribute_id: 5
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Flash
    ja: 致命の一閃
    ko: 치명의 일섬
    zh_hant: 致命閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5135
  skill_field_effect_id: 1104
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8699:
  _id_: 8699
  attribute_id: 5
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Flash
    ja: 封印の一閃
    ko: 봉인의 일섬
    zh_hant: 封印閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5136
  skill_field_effect_id: 1105
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8700:
  _id_: 8700
  attribute_id: 5
  cost: 2
  icon_id: 455
  is_multiple_command_unique_skill: 0
  name:
    en: Infernal Gnawing Encore
    ja: 冥獣の噛砕 Encore
    ko: 저승 맹수의 깨물어부수기 Encore
    zh_hant: 冥獸的撕咬 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5137
  skill_field_effect_id: 1106
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10396
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8719:
  _id_: 8719
  attribute_id: 6
  cost: 1
  icon_id: 456
  is_multiple_command_unique_skill: 0
  name:
    en: Resistance Flash
    ja: 耐性の一閃
    ko: 저항의 일섬
    zh_hant: 耐性閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5140
  skill_field_effect_id: 1109
  skill_options:
  - hit_rate: 100
    id: 10397
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8720:
  _id_: 8720
  attribute_id: 6
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Flash
    ja: 重圧の一閃
    ko: 중압의 일섬
    zh_hant: 重壓閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5141
  skill_field_effect_id: 1110
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8721:
  _id_: 8721
  attribute_id: 6
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Impudence
    ja: 慢心の一閃
    ko: 방심의 일섬
    zh_hant: 傲慢閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5142
  skill_field_effect_id: 1111
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8722:
  _id_: 8722
  attribute_id: 6
  cost: 2
  icon_id: 457
  is_multiple_command_unique_skill: 0
  name:
    en: Justice of the Black Lion
    ja: 黒獅子の正義
    ko: 흑사자의 정의
    zh_hant: 黑獅子正義
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5143
  skill_field_effect_id: 1112
  skill_options:
  - hit_rate: 100
    id: 309
    target_id: 11013
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
  - hit_rate: 100
    id: 10398
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8724:
  _id_: 8724
  attribute_id: 8
  cost: 2
  icon_id: 444
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Impudence
    ja: 慢心の刺突
    ko: 방심의 찌르기
    zh_hant: 傲慢突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5145
  skill_field_effect_id: 1115
  skill_options:
  - hit_rate: 100
    id: 10384
    target_id: 1132
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10378
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8725:
  _id_: 8725
  attribute_id: 8
  cost: 2
  icon_id: 435
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Daze
    ja: 錯乱の刺突
    ko: 착란의 찌르기
    zh_hant: 錯亂突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5146
  skill_field_effect_id: 1116
  skill_options:
  - hit_rate: 100
    id: 10384
    target_id: 1143
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10363
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8726:
  _id_: 8726
  attribute_id: 8
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Thrust
    ja: 煌めく刺突
    ko: 빛나는 찌르기
    zh_hant: 輝煌突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5147
  skill_field_effect_id: 1117
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8727:
  _id_: 8727
  attribute_id: 8
  cost: 1
  icon_id: 450
  is_multiple_command_unique_skill: 1
  name:
    en: Meteor Strahl Encore
    ja: メテオール・シュトラール Encore
    ko: 메테오르 슈트랄 Encore
    zh_hant: 流星之光 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5148
  skill_field_effect_id: 1118
  skill_options:
  - hit_rate: 100
    id: 20025
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10384
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8739:
  _id_: 8739
  attribute_id: 4
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Versatile Slash
    ja: 万能の斬撃
    ko: 만능의 참격
    zh_hant: 萬能斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5150
  skill_field_effect_id: 1121
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8740:
  _id_: 8740
  attribute_id: 4
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5151
  skill_field_effect_id: 1122
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8741:
  _id_: 8741
  attribute_id: 4
  cost: 2
  icon_id: 362
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5152
  skill_field_effect_id: 1123
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8742:
  _id_: 8742
  attribute_id: 4
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Thunderbolt of Judgment
    ja: 裁きの雷火
    ko: 심판의 번갯불
    zh_hant: 制裁的雷火
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5153
  skill_field_effect_id: 1124
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8744:
  _id_: 8744
  attribute_id: 6
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Superstrength
    ja: 怪力の打撃
    ko: 괴력의 타격
    zh_hant: 怪力敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5155
  skill_field_effect_id: 1127
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10329
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8745:
  _id_: 8745
  attribute_id: 6
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Smash
    ja: 増強の打撃
    ko: 증강의 타격
    zh_hant: 增強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5156
  skill_field_effect_id: 1128
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8746:
  _id_: 8746
  attribute_id: 6
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Smash
    ja: 封印の打撃
    ko: 봉인의 타격
    zh_hant: 封印敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5157
  skill_field_effect_id: 1129
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 366
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8747:
  _id_: 8747
  attribute_id: 6
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Quintet Prominence Breaker Encore
    ja: クインテット・プロミネンスブレイカー Encore
    ko: 퀸텟 프로미넌스 브레이커 Encore
    zh_hant: 五重奏・熾焰日珥粉碎擊 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5158
  skill_field_effect_id: 1130
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 366
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8749:
  _id_: 8749
  attribute_id: 3
  cost: 2
  icon_id: 408
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Impudence
    ja: 慢心の斬撃
    ko: 방심의 참격
    zh_hant: 傲慢斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5160
  skill_field_effect_id: 1133
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8750:
  _id_: 8750
  attribute_id: 3
  cost: 2
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Daze
    ja: 錯乱の斬撃
    ko: 착란의 참격
    zh_hant: 錯亂斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5161
  skill_field_effect_id: 1134
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8751:
  _id_: 8751
  attribute_id: 3
  cost: 2
  icon_id: 1109
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Shortening
    ja: 短縮の斬撃
    ko: 단축의 참격
    zh_hant: 縮短斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5162
  skill_field_effect_id: 1135
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8752:
  _id_: 8752
  attribute_id: 3
  cost: 2
  icon_id: 1109
  is_multiple_command_unique_skill: 1
  name:
    en: Reborn with Light in My Heart
    ja: 生まれ変わった光を胸に
    ko: 다시 태어난 빛을 가슴에 품고
    zh_hant: 胸懷重生之光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5163
  skill_field_effect_id: 1136
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
8754:
  _id_: 8754
  attribute_id: 8
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Superstrength
    ja: 怪力の打撃
    ko: 괴력의 타격
    zh_hant: 怪力敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5165
  skill_field_effect_id: 1139
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8755:
  _id_: 8755
  attribute_id: 8
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Support
    ja: 支援の打撃
    ko: 지원의 타격
    zh_hant: 支援敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5166
  skill_field_effect_id: 1140
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10280
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8756:
  _id_: 8756
  attribute_id: 8
  cost: 2
  icon_id: 368
  is_multiple_command_unique_skill: 0
  name:
    en: Restorative Smash
    ja: 再起の打撃
    ko: 재기의 타격
    zh_hant: 再起敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5167
  skill_field_effect_id: 1141
  skill_options:
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8757:
  _id_: 8757
  attribute_id: 8
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: My Dreams Will Come True on Stage Encore
    ja: 夢咲く舞台に 輝け 私 Encore
    ko: 꿈이 꽃피는 무대에서 난 빛나리 Encore
    zh_hant: 我要在綻放夢想的舞台上熠熠生輝 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5168
  skill_field_effect_id: 1142
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8799:
  _id_: 8799
  attribute_id: 2
  cost: 1
  icon_id: 441
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Inactivity
    ja: 沈滞の斬撃
    ko: 침체의 참격
    zh_hant: 沉滯斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5178
  skill_field_effect_id: 1144
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10407
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8800:
  _id_: 8800
  attribute_id: 2
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5179
  skill_field_effect_id: 1145
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10407
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8801:
  _id_: 8801
  attribute_id: 2
  cost: 2
  icon_id: 464
  is_multiple_command_unique_skill: 0
  name:
    en: Overpower Slash
    ja: 威圧の斬撃
    ko: 위압의 참격
    zh_hant: 威壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5180
  skill_field_effect_id: 1146
  skill_options:
  - hit_rate: 100
    id: 10363
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10407
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2124
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8802:
  _id_: 8802
  attribute_id: 2
  cost: 2
  icon_id: 464
  is_multiple_command_unique_skill: 1
  name:
    en: Watch Me from Hell. I'm the Star Encore
    ja: 奈落で見上げろ 私がスタァだ Encore
    ko: 나락에서 올려다봐라 내가 스타다 Encore
    zh_hant: 在地獄抬頭望吧，我才是STAR Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5181
  skill_field_effect_id: 1147
  skill_options:
  - hit_rate: 100
    id: 10363
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8804:
  _id_: 8804
  attribute_id: 4
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Superstrength
    ja: 怪力の一撃
    ko: 괴력의 일격
    zh_hant: 怪力一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5183
  skill_field_effect_id: 1150
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8805:
  _id_: 8805
  attribute_id: 4
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5184
  skill_field_effect_id: 1151
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8806:
  _id_: 8806
  attribute_id: 4
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Strike
    ja: 致命の一撃
    ko: 치명의 일격
    zh_hant: 致命一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5185
  skill_field_effect_id: 1152
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8807:
  _id_: 8807
  attribute_id: 4
  cost: 2
  icon_id: 1106
  is_multiple_command_unique_skill: 1
  name:
    en: Arcanum Magicae Encore
    ja: アルカナム・マジーケ Encore
    ko: 아르카눔 마지케 Encore
    zh_hant: 阿爾克那・魔術 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5186
  skill_field_effect_id: 1153
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8809:
  _id_: 8809
  attribute_id: 3
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5188
  skill_field_effect_id: 1156
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8810:
  _id_: 8810
  attribute_id: 3
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5189
  skill_field_effect_id: 1157
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8811:
  _id_: 8811
  attribute_id: 3
  cost: 2
  icon_id: 418
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5190
  skill_field_effect_id: 1158
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10346
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8812:
  _id_: 8812
  attribute_id: 3
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Blazedance Finisher Encore
    ja: 焔舞殺法 Encore
    ko: 화무살법 Encore
    zh_hant: 焰舞殺法 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5191
  skill_field_effect_id: 1159
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10396
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8814:
  _id_: 8814
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8815:
  _id_: 8815
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8816:
  _id_: 8816
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8817:
  _id_: 8817
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8818:
  _id_: 8818
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
8819:
  _id_: 8819
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
8820:
  _id_: 8820
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8821:
  _id_: 8821
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8822:
  _id_: 8822
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8824:
  _id_: 8824
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8825:
  _id_: 8825
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8826:
  _id_: 8826
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8827:
  _id_: 8827
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8828:
  _id_: 8828
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8829:
  _id_: 8829
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8830:
  _id_: 8830
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8831:
  _id_: 8831
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8832:
  _id_: 8832
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8833:
  _id_: 8833
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8834:
  _id_: 8834
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8836:
  _id_: 8836
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8837:
  _id_: 8837
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8838:
  _id_: 8838
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8839:
  _id_: 8839
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8840:
  _id_: 8840
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8841:
  _id_: 8841
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8842:
  _id_: 8842
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
8843:
  _id_: 8843
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8844:
  _id_: 8844
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8845:
  _id_: 8845
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8846:
  _id_: 8846
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8848:
  _id_: 8848
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8849:
  _id_: 8849
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8850:
  _id_: 8850
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8851:
  _id_: 8851
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8852:
  _id_: 8852
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8853:
  _id_: 8853
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8854:
  _id_: 8854
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8855:
  _id_: 8855
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8856:
  _id_: 8856
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8857:
  _id_: 8857
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8858:
  _id_: 8858
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8860:
  _id_: 8860
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8861:
  _id_: 8861
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8862:
  _id_: 8862
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8863:
  _id_: 8863
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8864:
  _id_: 8864
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8865:
  _id_: 8865
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8866:
  _id_: 8866
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8867:
  _id_: 8867
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8868:
  _id_: 8868
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8869:
  _id_: 8869
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8870:
  _id_: 8870
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8872:
  _id_: 8872
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8873:
  _id_: 8873
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8874:
  _id_: 8874
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8875:
  _id_: 8875
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8876:
  _id_: 8876
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8877:
  _id_: 8877
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8878:
  _id_: 8878
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8879:
  _id_: 8879
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8880:
  _id_: 8880
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8881:
  _id_: 8881
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8882:
  _id_: 8882
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8884:
  _id_: 8884
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8885:
  _id_: 8885
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8886:
  _id_: 8886
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8887:
  _id_: 8887
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8888:
  _id_: 8888
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8889:
  _id_: 8889
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
8890:
  _id_: 8890
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8891:
  _id_: 8891
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8892:
  _id_: 8892
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8893:
  _id_: 8893
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8894:
  _id_: 8894
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
8896:
  _id_: 8896
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8897:
  _id_: 8897
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
8898:
  _id_: 8898
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
8899:
  _id_: 8899
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
8900:
  _id_: 8900
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
8901:
  _id_: 8901
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
8902:
  _id_: 8902
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8903:
  _id_: 8903
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
8904:
  _id_: 8904
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
8905:
  _id_: 8905
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8906:
  _id_: 8906
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
8920:
  _id_: 8920
  attribute_id: 6
  cost: 2
  icon_id: 443
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5194
  skill_field_effect_id: 1162
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10376
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8921:
  _id_: 8921
  attribute_id: 6
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5195
  skill_field_effect_id: 1163
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8922:
  _id_: 8922
  attribute_id: 6
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5196
  skill_field_effect_id: 1164
  skill_options:
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
8923:
  _id_: 8923
  attribute_id: 6
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: King Solomon's Ring
    ja: ソロモンの指輪
    ko: 솔로몬의 반지
    zh_hant: 所羅門的戒指
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5197
  skill_field_effect_id: 1165
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10375
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
8925:
  _id_: 8925
  attribute_id: 4
  cost: 1
  icon_id: 334
  is_multiple_command_unique_skill: 0
  name:
    en: Flame Strike
    ja: 炎の一撃
    ko: 불꽃의 일격
    zh_hant: 火焰一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5199
  skill_field_effect_id: 1168
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8926:
  _id_: 8926
  attribute_id: 4
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5200
  skill_field_effect_id: 1169
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8927:
  _id_: 8927
  attribute_id: 4
  cost: 2
  icon_id: 414
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Poison
    ja: 毒の一撃
    ko: 독의 일격
    zh_hant: 中毒一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5201
  skill_field_effect_id: 1170
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8928:
  _id_: 8928
  attribute_id: 4
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: High Judgement Encore
    ja: 女教皇はかく裁けり Encore
    ko: 여교황은 이렇게 판결했노라 Encore
    zh_hant: 女教皇如此裁斷 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5202
  skill_field_effect_id: 1171
  skill_options:
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 280
    - 290
    - 300
    - 310
    - 320
8930:
  _id_: 8930
  attribute_id: 9
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5209
  skill_field_effect_id: 1173
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
8931:
  _id_: 8931
  attribute_id: 9
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5210
  skill_field_effect_id: 1174
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
8932:
  _id_: 8932
  attribute_id: 9
  cost: 2
  icon_id: 368
  is_multiple_command_unique_skill: 0
  name:
    en: Restorative Slash
    ja: 再起の斬撃
    ko: 재기의 참격
    zh_hant: 再起斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5211
  skill_field_effect_id: 1175
  skill_options:
  - hit_rate: 100
    id: 10286
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
8933:
  _id_: 8933
  attribute_id: 9
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Dazzling Galatine Encore
    ja: まばゆきガラティーン Encore
    ko: 눈부신 가라틴 Encore
    zh_hant: 光耀勝利之劍 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5212
  skill_field_effect_id: 1176
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 260
    - 270
    - 280
    - 290
    - 300
8935:
  _id_: 8935
  attribute_id: 1
  cost: 1
  icon_id: 450
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Resistance
    ja: 耐性の打撃
    ko: 저항의 타격
    zh_hant: 耐性敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5204
  skill_field_effect_id: 1178
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10384
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8936:
  _id_: 8936
  attribute_id: 1
  cost: 2
  icon_id: 1110
  is_multiple_command_unique_skill: 0
  name:
    en: Golden Smash
    ja: 黄金の打撃
    ko: 황금의 타격
    zh_hant: 黃金敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5205
  skill_field_effect_id: 1179
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8937:
  _id_: 8937
  attribute_id: 1
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Smash
    ja: 重圧の打撃
    ko: 중압의 타격
    zh_hant: 重壓敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5206
  skill_field_effect_id: 1180
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10379
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8938:
  _id_: 8938
  attribute_id: 1
  cost: 2
  icon_id: 466
  is_multiple_command_unique_skill: 0
  name:
    en: Gilded Riddle
    ja: 金色の謎かけ
    ko: 황금빛 수수께끼
    zh_hant: 金色的謎題
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5207
  skill_field_effect_id: 1181
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
8940:
  _id_: 8940
  attribute_id: 9
  cost: 1
  icon_id: 443
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Resistance
    ja: 耐性の刺突
    ko: 저항의 찌르기
    zh_hant: 耐性突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5214
  skill_field_effect_id: 1184
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10376
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8941:
  _id_: 8941
  attribute_id: 9
  cost: 2
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Thrust of Contraction
    ja: 狭窄の刺突
    ko: 협착의 찌르기
    zh_hant: 視野收窄突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5215
  skill_field_effect_id: 1185
  skill_options:
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20029
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8942:
  _id_: 8942
  attribute_id: 9
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Thrust
    ja: 軽快な刺突
    ko: 경쾌한 찌르기
    zh_hant: 輕快突刺
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5216
  skill_field_effect_id: 1186
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20029
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8943:
  _id_: 8943
  attribute_id: 9
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 1
  name:
    en: Empress's Gloom Encore
    ja: 女帝陛下の憂鬱 Encore
    ko: 여제 폐하의 우울 Encore
    zh_hant: 女帝陛下的憂鬱 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5217
  skill_field_effect_id: 1187
  skill_options:
  - hit_rate: 100
    id: 309
    target_id: 11013
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 55
    - 60
    - 65
    - 70
  - hit_rate: 100
    id: 10398
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
8945:
  _id_: 8945
  attribute_id: 2
  cost: 1
  icon_id: 443
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5219
  skill_field_effect_id: 1190
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10376
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8946:
  _id_: 8946
  attribute_id: 2
  cost: 1
  icon_id: 450
  is_multiple_command_unique_skill: 0
  name:
    en: Golden Slash
    ja: 黄金の斬撃
    ko: 황금의 참격
    zh_hant: 黃金斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5220
  skill_field_effect_id: 1191
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10384
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8947:
  _id_: 8947
  attribute_id: 2
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Dispel
    ja: 解除の斬撃
    ko: 해제의 참격
    zh_hant: 解除斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5221
  skill_field_effect_id: 1192
  skill_options:
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
8948:
  _id_: 8948
  attribute_id: 2
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Glamorous Invitation
    ja: 艶やかなる女王のいざない
    ko: 요염한 여왕의 유혹
    zh_hant: 美艷女王的邀約
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5222
  skill_field_effect_id: 1193
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 364
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
8950:
  _id_: 8950
  attribute_id: 5
  cost: 1
  icon_id: 469
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Expertise
    ja: 達人の打撃
    ko: 달인의 타격
    zh_hant: 精通敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5224
  skill_field_effect_id: 1198
  skill_options:
  - hit_rate: 100
    id: 10422
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8951:
  _id_: 8951
  attribute_id: 5
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Smash
    ja: 増強の打撃
    ko: 증강의 타격
    zh_hant: 增強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5225
  skill_field_effect_id: 1199
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8952:
  _id_: 8952
  attribute_id: 5
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5226
  skill_field_effect_id: 1200
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10413
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
8953:
  _id_: 8953
  attribute_id: 5
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 1
  name:
    en: Flash of Darkness Encore
    ja: Flash of darkness Encore
    ko: Flash of darkness Encore
    zh_hant: Flash of darkness Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5227
  skill_field_effect_id: 1201
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10413
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 361
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8955:
  _id_: 8955
  attribute_id: 2
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5229
  skill_field_effect_id: 1204
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8956:
  _id_: 8956
  attribute_id: 2
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5230
  skill_field_effect_id: 1205
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8957:
  _id_: 8957
  attribute_id: 2
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5231
  skill_field_effect_id: 1206
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
8958:
  _id_: 8958
  attribute_id: 2
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: 'Article 14: Forceful Removal Encore'
    ja: 幸福都市検察法第14条『強攻排除』 Encore
    ko: 행복 도시 검찰법 제14조 [강공배제] Encore
    zh_hant: 幸福都市檢查法第14條『強攻排除』 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5232
  skill_field_effect_id: 1207
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
8960:
  _id_: 8960
  attribute_id: 1
  cost: 2
  icon_id: 391
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Flash
    ja: キラめく一閃
    ko: 반짝이는 일섬
    zh_hant: 輝煌閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5234
  skill_field_effect_id: 1210
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10311
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
8961:
  _id_: 8961
  attribute_id: 1
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Flash
    ja: 気絶の一閃
    ko: 기절의 일섬
    zh_hant: 昏迷閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5235
  skill_field_effect_id: 1211
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10407
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
8962:
  _id_: 8962
  attribute_id: 1
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Dispel
    ja: 解除の一閃
    ko: 해제의 일섬
    zh_hant: 解除閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5236
  skill_field_effect_id: 1212
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
8963:
  _id_: 8963
  attribute_id: 1
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Show Me the Right Path, Mirror Encore
    ja: 鏡よ照らせ 正しき道を Encore
    ko: 거울아 바른 길을 비춰다오 Encore
    zh_hant: 鏡子啊！照映出正確的道路吧！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5237
  skill_field_effect_id: 1213
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9000:
  _id_: 9000
  attribute_id: 5
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Slash
    ja: 気絶の斬撃
    ko: 기절의 참격
    zh_hant: 昏迷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5243
  skill_field_effect_id: 1215
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9001:
  _id_: 9001
  attribute_id: 5
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5244
  skill_field_effect_id: 1216
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9002:
  _id_: 9002
  attribute_id: 5
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Dispel
    ja: 解除の斬撃
    ko: 해제의 참격
    zh_hant: 解除斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5245
  skill_field_effect_id: 1217
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9003:
  _id_: 9003
  attribute_id: 5
  cost: 2
  icon_id: 464
  is_multiple_command_unique_skill: 0
  name:
    en: Labyrinthine Love Encore
    ja: 恋は迷宮 Encore
    ko: 사랑은 미궁 Encore
    zh_hant: 戀愛迷宮 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5246
  skill_field_effect_id: 1218
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10426
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
9005:
  _id_: 9005
  attribute_id: 2
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Strike
    ja: キラめく一撃
    ko: 반짝이는 일격
    zh_hant: 輝煌一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5248
  skill_field_effect_id: 1221
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9006:
  _id_: 9006
  attribute_id: 2
  cost: 2
  icon_id: 1090
  is_multiple_command_unique_skill: 0
  name:
    en: Tearful Strike
    ja: 涙の一撃
    ko: 눈물의 일격
    zh_hant: 眼淚一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5249
  skill_field_effect_id: 1222
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9007:
  _id_: 9007
  attribute_id: 2
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Dispel
    ja: 解除の一撃
    ko: 해제의 일격
    zh_hant: 解除一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5250
  skill_field_effect_id: 1223
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9008:
  _id_: 9008
  attribute_id: 2
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Possibility∞Infinity Encore
    ja: Possibility∞Infinity Encore
    ko: Possibility∞Infinity Encore
    zh_hant: 無限∞可能 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5251
  skill_field_effect_id: 1224
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9010:
  _id_: 9010
  attribute_id: 1
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Slash
    ja: 気絶の斬撃
    ko: 기절의 참격
    zh_hant: 昏迷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5253
  skill_field_effect_id: 1226
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20027
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9011:
  _id_: 9011
  attribute_id: 1
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5254
  skill_field_effect_id: 1227
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20030
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10428
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9012:
  _id_: 9012
  attribute_id: 1
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5255
  skill_field_effect_id: 1228
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
  - hit_rate: 100
    id: 20030
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10428
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9013:
  _id_: 9013
  attribute_id: 1
  cost: 2
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Lion's Roar Encore
    ja: 獅子の咆哮 Encore
    ko: 사자의 포효 Encore
    zh_hant: 獅子咆哮 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5256
  skill_field_effect_id: 1229
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
9015:
  _id_: 9015
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9016:
  _id_: 9016
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9017:
  _id_: 9017
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9018:
  _id_: 9018
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9019:
  _id_: 9019
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Slash
    ja: 必中の斬撃
    ko: 백발백중의 참격
    zh_hant: 必中斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
9020:
  _id_: 9020
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9021:
  _id_: 9021
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9022:
  _id_: 9022
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9023:
  _id_: 9023
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9025:
  _id_: 9025
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9026:
  _id_: 9026
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9027:
  _id_: 9027
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9028:
  _id_: 9028
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9029:
  _id_: 9029
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9030:
  _id_: 9030
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9031:
  _id_: 9031
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9032:
  _id_: 9032
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9033:
  _id_: 9033
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9035:
  _id_: 9035
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3257
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9036:
  _id_: 9036
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9037:
  _id_: 9037
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9038:
  _id_: 9038
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9039:
  _id_: 9039
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9040:
  _id_: 9040
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3262
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9041:
  _id_: 9041
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
9042:
  _id_: 9042
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9043:
  _id_: 9043
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9045:
  _id_: 9045
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9046:
  _id_: 9046
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9047:
  _id_: 9047
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9048:
  _id_: 9048
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9049:
  _id_: 9049
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9050:
  _id_: 9050
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9051:
  _id_: 9051
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9052:
  _id_: 9052
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9053:
  _id_: 9053
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9054:
  _id_: 9054
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9056:
  _id_: 9056
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9057:
  _id_: 9057
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9058:
  _id_: 9058
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9059:
  _id_: 9059
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9060:
  _id_: 9060
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9061:
  _id_: 9061
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9062:
  _id_: 9062
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9063:
  _id_: 9063
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9065:
  _id_: 9065
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9066:
  _id_: 9066
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9067:
  _id_: 9067
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9068:
  _id_: 9068
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9069:
  _id_: 9069
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9070:
  _id_: 9070
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9071:
  _id_: 9071
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9072:
  _id_: 9072
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9073:
  _id_: 9073
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9074:
  _id_: 9074
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9076:
  _id_: 9076
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9077:
  _id_: 9077
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9078:
  _id_: 9078
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9079:
  _id_: 9079
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9080:
  _id_: 9080
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9081:
  _id_: 9081
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9082:
  _id_: 9082
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9083:
  _id_: 9083
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9084:
  _id_: 9084
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9085:
  _id_: 9085
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9087:
  _id_: 9087
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9088:
  _id_: 9088
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9089:
  _id_: 9089
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9090:
  _id_: 9090
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9091:
  _id_: 9091
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9092:
  _id_: 9092
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9093:
  _id_: 9093
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9094:
  _id_: 9094
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9096:
  _id_: 9096
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3286
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9097:
  _id_: 9097
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3287
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9098:
  _id_: 9098
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3288
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9099:
  _id_: 9099
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3289
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9100:
  _id_: 9100
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3290
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9101:
  _id_: 9101
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Noxious Flower Dance
    ja: 毒花の舞
    ko: 독화의 춤
    zh_hant: 毒花之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4658
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9102:
  _id_: 9102
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Dance
    ja: 奮起の舞
    ko: 분기의 춤
    zh_hant: 奮起之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3292
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9103:
  _id_: 9103
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Glorious Dream! NEO
    ja: グロリアスドリーム！  NEO
    ko: 글로리어스 드림! NEO
    zh_hant: 燦爛的美夢！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4659
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9105:
  _id_: 9105
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9106:
  _id_: 9106
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9107:
  _id_: 9107
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9108:
  _id_: 9108
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9109:
  _id_: 9109
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9110:
  _id_: 9110
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9111:
  _id_: 9111
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Firedance
    ja: 炎舞
    ko: 염무
    zh_hant: 炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9112:
  _id_: 9112
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9113:
  _id_: 9113
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9114:
  _id_: 9114
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Hope★ NEO
    ja: シャイニングホープ★ NEO
    ko: 샤이닝 호프★ NEO
    zh_hant: Shining Hope★ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9116:
  _id_: 9116
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3304
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9117:
  _id_: 9117
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3305
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9118:
  _id_: 9118
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3306
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9119:
  _id_: 9119
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3307
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9120:
  _id_: 9120
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3308
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9121:
  _id_: 9121
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3309
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9122:
  _id_: 9122
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3310
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9123:
  _id_: 9123
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Slash
    ja: 抑止の斬撃
    ko: 억제의 참격
    zh_hant: 抑止斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4662
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9124:
  _id_: 9124
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3312
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9125:
  _id_: 9125
  attribute_id: 7
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Beautiful Pose♪ NEO
    ja: ビューティポージング♪ NEO
    ko: 뷰티 포징♪ NEO
    zh_hant: Pretty Poss♪ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4663
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9127:
  _id_: 9127
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9128:
  _id_: 9128
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9129:
  _id_: 9129
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9130:
  _id_: 9130
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9131:
  _id_: 9131
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Defense Concerto
    ja: 防衛の協奏曲
    ko: 방위의 협주곡
    zh_hant: 防衛協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9132:
  _id_: 9132
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9133:
  _id_: 9133
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9134:
  _id_: 9134
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Galactic Kaiser-Walzer NEO
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
    ko: 위풍당당 ~은하 황제 원무곡~ NEO
    zh_hant: 威光堂堂 ～銀河皇帝圓舞曲～ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9136:
  _id_: 9136
  attribute_id: 8
  cost: 1
  icon_id: 450
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Resistance
    ja: 耐性の斬撃
    ko: 저항의 참격
    zh_hant: 耐性斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5258
  skill_field_effect_id: 1232
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10314
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10417
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9137:
  _id_: 9137
  attribute_id: 8
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5259
  skill_field_effect_id: 1233
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9138:
  _id_: 9138
  attribute_id: 8
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5260
  skill_field_effect_id: 1234
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9139:
  _id_: 9139
  attribute_id: 8
  cost: 2
  icon_id: 471
  is_multiple_command_unique_skill: 0
  name:
    en: Somehow I Feel So Dizzy...
    ja: なんだか強いお酒を飲んだみたい
    ko: 뭔가 독한 음료를 마신 것 같은 느낌이야
    zh_hant: 好像喝了烈酒似的
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5261
  skill_field_effect_id: 1235
  skill_options:
  - hit_rate: 100
    id: 10436
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 388
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
  - hit_rate: 100
    id: 10433
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9141:
  _id_: 9141
  attribute_id: 6
  cost: 1
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Slash
    ja: 気絶の斬撃
    ko: 기절의 참격
    zh_hant: 昏迷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5263
  skill_field_effect_id: 1239
  skill_options:
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10341
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10361
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9142:
  _id_: 9142
  attribute_id: 6
  cost: 2
  icon_id: 441
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Inactivity
    ja: 沈滞の斬撃
    ko: 침체의 참격
    zh_hant: 沉滯斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5264
  skill_field_effect_id: 1240
  skill_options:
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10374
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9143:
  _id_: 9143
  attribute_id: 6
  cost: 2
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Contraction
    ja: 狭窄の斬撃
    ko: 협착의 참격
    zh_hant: 視野收窄斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5265
  skill_field_effect_id: 1241
  skill_options:
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9144:
  _id_: 9144
  attribute_id: 6
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World Encore
    ja: 逆転世界の開眼 Encore
    ko: 역전세계의 개안 Encore
    zh_hant: 翻轉世界的領悟 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5266
  skill_field_effect_id: 1242
  skill_options:
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 5
    - 5
    - 5
    - 5
    - 5
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
9146:
  _id_: 9146
  attribute_id: 1
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Support
    ja: 支援の打撃
    ko: 지원의 타격
    zh_hant: 支援敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5268
  skill_field_effect_id: 1245
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9147:
  _id_: 9147
  attribute_id: 1
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Smash
    ja: 致命の打撃
    ko: 치명의 타격
    zh_hant: 致命敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5269
  skill_field_effect_id: 1246
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9148:
  _id_: 9148
  attribute_id: 1
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Dispel
    ja: 解除の打撃
    ko: 해제의 타격
    zh_hant: 解除敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5270
  skill_field_effect_id: 1247
  skill_options:
  - hit_rate: 100
    id: 20030
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9149:
  _id_: 9149
  attribute_id: 1
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Fateful Awakening
    ja: 運命の目覚め
    ko: 운명의 각성
    zh_hant: 命運的覺醒
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5271
  skill_field_effect_id: 1248
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10396
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9163:
  _id_: 9163
  attribute_id: 8
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Superstrength
    ja: 怪力の一閃
    ko: 괴력의 일섬
    zh_hant: 怪力閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5274
  skill_field_effect_id: 1251
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10352
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9164:
  _id_: 9164
  attribute_id: 8
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Flash
    ja: 増強の一閃
    ko: 증강의 일섬
    zh_hant: 增強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5275
  skill_field_effect_id: 1252
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10301
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9165:
  _id_: 9165
  attribute_id: 8
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Flash
    ja: 致命の一閃
    ko: 치명의 일섬
    zh_hant: 致命閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5276
  skill_field_effect_id: 1253
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9166:
  _id_: 9166
  attribute_id: 8
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Moonlight Sacrament Encore
    ja: 秘石が導く月光の秘蹟 Encore
    ko: 보석이 인도하는 달빛의 성례 Encore
    zh_hant: 由秘石所引導的月光秘蹟 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5277
  skill_field_effect_id: 1254
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9168:
  _id_: 9168
  attribute_id: 3
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Smash
    ja: 気絶の打撃
    ko: 기절의 타격
    zh_hant: 昏迷敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5279
  skill_field_effect_id: 1258
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9169:
  _id_: 9169
  attribute_id: 3
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Smash of Love
    ja: 恋の打撃
    ko: 사랑의 타격
    zh_hant: 戀的敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5280
  skill_field_effect_id: 1259
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9170:
  _id_: 9170
  attribute_id: 3
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Smash
    ja: 停止の打撃
    ko: 정지의 타격
    zh_hant: 停止敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5281
  skill_field_effect_id: 1260
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9171:
  _id_: 9171
  attribute_id: 3
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Light of Hope Encore
    ja: 希望は光になりて Encore
    ko: 희망은 빛이 될 자 Encore
    zh_hant: 希望終將成為光 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5282
  skill_field_effect_id: 1261
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10427
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9173:
  _id_: 9173
  attribute_id: 9
  cost: 1
  icon_id: 450
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting of Resistance
    ja: 耐性の狙撃
    ko: 저항의 저격
    zh_hant: 耐性狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5284
  skill_field_effect_id: 1263
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9174:
  _id_: 9174
  attribute_id: 9
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Sharpshooting
    ja: 軽快な狙撃
    ko: 경쾌한 저격
    zh_hant: 輕快狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5285
  skill_field_effect_id: 1264
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9175:
  _id_: 9175
  attribute_id: 9
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Sharpshooting
    ja: 重圧の狙撃
    ko: 중압의 저격
    zh_hant: 重壓狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5286
  skill_field_effect_id: 1265
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10438
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9176:
  _id_: 9176
  attribute_id: 9
  cost: 2
  icon_id: 10013
  is_multiple_command_unique_skill: 0
  name:
    en: Rising White Blaster Encore
    ja: ライジング・ホワイトブラスター Encore
    ko: 라이징 화이트 블래스터 Encore
    zh_hant: 冉升純白衝擊波 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5287
  skill_field_effect_id: 1266
  skill_options:
  - hit_rate: 100
    id: 20025
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10438
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9193:
  _id_: 9193
  attribute_id: 6
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Love
    ja: 恋の一撃
    ko: 사랑의 일격
    zh_hant: 戀的一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5293
  skill_field_effect_id: 1270
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10435
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9194:
  _id_: 9194
  attribute_id: 6
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Strike
    ja: 停止の一撃
    ko: 정지의 일격
    zh_hant: 停止一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5294
  skill_field_effect_id: 1271
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9195:
  _id_: 9195
  attribute_id: 6
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Strike
    ja: 軽快な一撃
    ko: 경쾌한 일격
    zh_hant: 輕快一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5295
  skill_field_effect_id: 1272
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9196:
  _id_: 9196
  attribute_id: 6
  cost: 2
  icon_id: 473
  is_multiple_command_unique_skill: 0
  name:
    en: Dignified Kagura
    ja: 凛鳴神楽
    ko: 울려 퍼지는 카구라
    zh_hant: 凜鳴神樂
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5296
  skill_field_effect_id: 1273
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10441
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 387
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
9198:
  _id_: 9198
  attribute_id: 3
  cost: 2
  icon_id: 469
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Expertise
    ja: 達人の一撃
    ko: 달인의 일격
    zh_hant: 精通一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5298
  skill_field_effect_id: 1277
  skill_options:
  - hit_rate: 100
    id: 10422
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9199:
  _id_: 9199
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Strike
    ja: 増強の一撃
    ko: 증강의 일격
    zh_hant: 增強一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5299
  skill_field_effect_id: 1278
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9200:
  _id_: 9200
  attribute_id: 3
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Strike
    ja: 致命の一撃
    ko: 치명의 일격
    zh_hant: 致命一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5300
  skill_field_effect_id: 1279
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10413
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9201:
  _id_: 9201
  attribute_id: 3
  cost: 2
  icon_id: 404
  is_multiple_command_unique_skill: 0
  name:
    en: Empty Prayer Encore
    ja: 空虚な祈り Encore
    ko: 공허한 기도 Encore
    zh_hant: 空虛的祈禱 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5301
  skill_field_effect_id: 1280
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10413
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 361
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9208:
  _id_: 9208
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Sharpshooting
    ja: 狙撃
    ko: 저격
    zh_hant: 狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9209:
  _id_: 9209
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9210:
  _id_: 9210
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9211:
  _id_: 9211
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9212:
  _id_: 9212
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2610
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9213:
  _id_: 9213
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9214:
  _id_: 9214
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Rondo
    ja: 闇炎の輪舞曲
    ko: 암흑 불꽃의 윤무곡
    zh_hant: 暗炎圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9215:
  _id_: 9215
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9217:
  _id_: 9217
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9218:
  _id_: 9218
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2615
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9219:
  _id_: 9219
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9220:
  _id_: 9220
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2617
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9221:
  _id_: 9221
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9222:
  _id_: 9222
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 170
    - 170
    - 170
    - 170
9223:
  _id_: 9223
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2620
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9224:
  _id_: 9224
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2621
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9225:
  _id_: 9225
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2622
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9226:
  _id_: 9226
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2623
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9228:
  _id_: 9228
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9229:
  _id_: 9229
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9230:
  _id_: 9230
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9231:
  _id_: 9231
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9232:
  _id_: 9232
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9233:
  _id_: 9233
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9234:
  _id_: 9234
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9235:
  _id_: 9235
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9236:
  _id_: 9236
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9237:
  _id_: 9237
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9239:
  _id_: 9239
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9240:
  _id_: 9240
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9241:
  _id_: 9241
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2643
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9242:
  _id_: 9242
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9243:
  _id_: 9243
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9244:
  _id_: 9244
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9245:
  _id_: 9245
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9246:
  _id_: 9246
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2648
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9247:
  _id_: 9247
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9249:
  _id_: 9249
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2650
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9250:
  _id_: 9250
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2651
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9251:
  _id_: 9251
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2652
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9252:
  _id_: 9252
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2653
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9253:
  _id_: 9253
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2654
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9254:
  _id_: 9254
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Flurry
    ja: 強襲の連撃
    ko: 강습의 연격
    zh_hant: 強襲連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2655
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9255:
  _id_: 9255
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9256:
  _id_: 9256
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9257:
  _id_: 9257
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2658
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9258:
  _id_: 9258
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9260:
  _id_: 9260
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9261:
  _id_: 9261
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9262:
  _id_: 9262
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9263:
  _id_: 9263
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9264:
  _id_: 9264
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9265:
  _id_: 9265
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9266:
  _id_: 9266
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9267:
  _id_: 9267
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9268:
  _id_: 9268
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9269:
  _id_: 9269
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9270:
  _id_: 9270
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9272:
  _id_: 9272
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9273:
  _id_: 9273
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9274:
  _id_: 9274
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9275:
  _id_: 9275
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9276:
  _id_: 9276
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9277:
  _id_: 9277
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9278:
  _id_: 9278
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9279:
  _id_: 9279
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9281:
  _id_: 9281
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9282:
  _id_: 9282
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9283:
  _id_: 9283
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9284:
  _id_: 9284
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9285:
  _id_: 9285
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9286:
  _id_: 9286
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9287:
  _id_: 9287
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9288:
  _id_: 9288
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9289:
  _id_: 9289
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9290:
  _id_: 9290
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9292:
  _id_: 9292
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9293:
  _id_: 9293
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9294:
  _id_: 9294
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9295:
  _id_: 9295
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9296:
  _id_: 9296
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9297:
  _id_: 9297
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9298:
  _id_: 9298
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9299:
  _id_: 9299
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9300:
  _id_: 9300
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9301:
  _id_: 9301
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9302:
  _id_: 9302
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9304:
  _id_: 9304
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Sharpshooting
    ja: 強狙撃
    ko: 강한 저격
    zh_hant: 強狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9305:
  _id_: 9305
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9306:
  _id_: 9306
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9307:
  _id_: 9307
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9308:
  _id_: 9308
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Sharpshooting
    ja: 必中の狙撃
    ko: 백발백중의 저격
    zh_hant: 必中狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9309:
  _id_: 9309
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9310:
  _id_: 9310
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Blaze Concerto
    ja: 闇炎の協奏曲
    ko: 암흑 불꽃의 협주곡
    zh_hant: 暗炎協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9311:
  _id_: 9311
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Eat Me! NEO
    ja: Eat me！ NEO
    ko: Eat me! NEO
    zh_hant: Eat me！ NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9313:
  _id_: 9313
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9314:
  _id_: 9314
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9315:
  _id_: 9315
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9316:
  _id_: 9316
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9317:
  _id_: 9317
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9318:
  _id_: 9318
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9319:
  _id_: 9319
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9320:
  _id_: 9320
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9321:
  _id_: 9321
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9322:
  _id_: 9322
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Off with Her Head! NEO
    ja: 首はねの刑 NEO
    ko: 참수형 NEO
    zh_hant: 斬首之刑 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9324:
  _id_: 9324
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9325:
  _id_: 9325
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9326:
  _id_: 9326
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9327:
  _id_: 9327
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9328:
  _id_: 9328
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9329:
  _id_: 9329
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9330:
  _id_: 9330
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9331:
  _id_: 9331
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blind Fire Flower
    ja: 暗闇の炎花
    ko: 암흑의 염화
    zh_hant: 黑暗炎花
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9332:
  _id_: 9332
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9333:
  _id_: 9333
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9334:
  _id_: 9334
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Sacrament NEO
    ja: 秘石が導く月光の秘蹟　NEO
    ko: 보석이 인도하는 달빛의 성례 NEO
    zh_hant: 由秘石所引導的月光秘蹟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9336:
  _id_: 9336
  attribute_id: 9
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Flash
    ja: 停止の一閃
    ko: 정지의 일섬
    zh_hant: 停止閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5303
  skill_field_effect_id: 1283
  skill_options:
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10435
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10417
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9337:
  _id_: 9337
  attribute_id: 9
  cost: 2
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Flash
    ja: 封印の一閃
    ko: 봉인의 일섬
    zh_hant: 封印閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5304
  skill_field_effect_id: 1284
  skill_options:
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9338:
  _id_: 9338
  attribute_id: 9
  cost: 2
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Contraction
    ja: 狭窄の一閃
    ko: 협착의 일섬
    zh_hant: 視野收窄閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5305
  skill_field_effect_id: 1285
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10443
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9339:
  _id_: 9339
  attribute_id: 9
  cost: 2
  icon_id: 474
  is_multiple_command_unique_skill: 0
  name:
    en: Hopeful First Bite
    ja: ドキドキ！？ファーストバイト
    ko: 두근두근?! 케이크 먹여주기
    zh_hant: 怦然心動的第一口蛋糕
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5306
  skill_field_effect_id: 1286
  skill_options:
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10442
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 10443
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
9341:
  _id_: 9341
  attribute_id: 6
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5308
  skill_field_effect_id: 1290
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9342:
  _id_: 9342
  attribute_id: 6
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5309
  skill_field_effect_id: 1291
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9343:
  _id_: 9343
  attribute_id: 6
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5310
  skill_field_effect_id: 1292
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 362
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9344:
  _id_: 9344
  attribute_id: 6
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: I Will Defeat You with My Brilliance Encore
    ja: 今宵 キラめきで あんたを Encore
    ko: 오늘밤 반짝임으로 당신을 Encore
    zh_hant: 今晚以閃耀將妳—— Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5311
  skill_field_effect_id: 1293
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 362
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9346:
  _id_: 9346
  attribute_id: 5
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Slash
    ja: 気絶の斬撃
    ko: 기절의 참격
    zh_hant: 昏迷斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5313
  skill_field_effect_id: 1297
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10329
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 10000
    - 11000
    - 12000
    - 13000
    - 14000
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9347:
  _id_: 9347
  attribute_id: 5
  cost: 2
  icon_id: 385
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Love
    ja: 恋の斬撃
    ko: 사랑의 참격
    zh_hant: 戀的斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5314
  skill_field_effect_id: 1298
  skill_options:
  - hit_rate: 100
    id: 10356
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 60
    - 60
    - 60
    - 60
    - 60
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9348:
  _id_: 9348
  attribute_id: 5
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5315
  skill_field_effect_id: 1299
  skill_options:
  - hit_rate: 100
    id: 10405
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 230
    - 240
    - 250
    - 260
    - 270
9349:
  _id_: 9349
  attribute_id: 5
  cost: 2
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Dangerous Sweethearts Encore
    ja: 危険なマイスイート Encore
    ko: 위험한 마이 스위트 Encore
    zh_hant: 危險的小甜心 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5316
  skill_field_effect_id: 1300
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 83
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9363:
  _id_: 9363
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2832
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9364:
  _id_: 9364
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2833
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9365:
  _id_: 9365
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2834
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9366:
  _id_: 9366
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2835
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9367:
  _id_: 9367
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2836
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9368:
  _id_: 9368
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2837
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9369:
  _id_: 9369
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2838
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9370:
  _id_: 9370
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2839
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 75
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9372:
  _id_: 9372
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9373:
  _id_: 9373
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9374:
  _id_: 9374
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9375:
  _id_: 9375
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9376:
  _id_: 9376
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9377:
  _id_: 9377
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9378:
  _id_: 9378
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9379:
  _id_: 9379
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9381:
  _id_: 9381
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2865
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9382:
  _id_: 9382
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Sharpshooting
    ja: 双狙撃
    ko: 쌍저격
    zh_hant: 雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2866
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9383:
  _id_: 9383
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Sharpshooting
    ja: 強襲の双狙撃
    ko: 강습의 쌍저격
    zh_hant: 強襲雙狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2867
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9384:
  _id_: 9384
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2868
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9385:
  _id_: 9385
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2869
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9386:
  _id_: 9386
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2870
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9387:
  _id_: 9387
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2871
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9388:
  _id_: 9388
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2872
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9389:
  _id_: 9389
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2873
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9391:
  _id_: 9391
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9392:
  _id_: 9392
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9393:
  _id_: 9393
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9394:
  _id_: 9394
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9395:
  _id_: 9395
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9396:
  _id_: 9396
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9397:
  _id_: 9397
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9398:
  _id_: 9398
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9399:
  _id_: 9399
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9401:
  _id_: 9401
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9402:
  _id_: 9402
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9403:
  _id_: 9403
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9404:
  _id_: 9404
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9405:
  _id_: 9405
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9406:
  _id_: 9406
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9407:
  _id_: 9407
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9408:
  _id_: 9408
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9410:
  _id_: 9410
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9411:
  _id_: 9411
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9412:
  _id_: 9412
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9413:
  _id_: 9413
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9414:
  _id_: 9414
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9415:
  _id_: 9415
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9416:
  _id_: 9416
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9417:
  _id_: 9417
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9418:
  _id_: 9418
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9420:
  _id_: 9420
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Strike
    ja: 強襲の一撃
    ko: 강습의 일격
    zh_hant: 強襲一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2902
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9421:
  _id_: 9421
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Sharpshooting
    ja: 参狙撃
    ko: 삼저격
    zh_hant: 參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2903
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9422:
  _id_: 9422
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Sharpshooting
    ja: 強襲の参狙撃
    ko: 강습의 삼저격
    zh_hant: 強襲參狙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2904
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9423:
  _id_: 9423
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2905
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9424:
  _id_: 9424
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2906
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9425:
  _id_: 9425
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2907
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9426:
  _id_: 9426
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Bewitching Dance
    ja: 惑いの舞
    ko: 미혹의 춤
    zh_hant: 迷惑之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4801
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9427:
  _id_: 9427
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Moonlight Rain NEO
    ja: 月下叢雨 終幕 NEO
    ko: 월하총우 종막 NEO
    zh_hant: 月下叢雨 終幕 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4802
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9429:
  _id_: 9429
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9430:
  _id_: 9430
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9431:
  _id_: 9431
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9432:
  _id_: 9432
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9433:
  _id_: 9433
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9434:
  _id_: 9434
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9435:
  _id_: 9435
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9436:
  _id_: 9436
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9437:
  _id_: 9437
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9439:
  _id_: 9439
  attribute_id: 5
  cost: 1
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Contraction
    ja: 狭窄の斬撃
    ko: 협착의 참격
    zh_hant: 視野收窄斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5319
  skill_field_effect_id: 1302
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20024
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10435
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10443
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9440:
  _id_: 9440
  attribute_id: 5
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5320
  skill_field_effect_id: 1303
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20023
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10443
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9441:
  _id_: 9441
  attribute_id: 5
  cost: 1
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Slash
    ja: 封印の斬撃
    ko: 봉인의 참격
    zh_hant: 封印斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5321
  skill_field_effect_id: 1304
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10438
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9442:
  _id_: 9442
  attribute_id: 5
  cost: 1
  icon_id: 343
  is_multiple_command_unique_skill: 0
  name:
    en: Fan Rosette Encore
    ja: 扇の花結び Encore
    ko: 부채 꽃매듭 Encore
    zh_hant: 花結之扇 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5322
  skill_field_effect_id: 1305
  skill_options:
  - hit_rate: 100
    id: 10447
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10443
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 310
    - 320
    - 330
    - 340
    - 350
9444:
  _id_: 9444
  attribute_id: 9
  cost: 2
  icon_id: 441
  is_multiple_command_unique_skill: 0
  name:
    en: Strike of Inactivity
    ja: 沈滞の一撃
    ko: 침체의 일격
    zh_hant: 沉滯一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5324
  skill_field_effect_id: 1308
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10428
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9445:
  _id_: 9445
  attribute_id: 9
  cost: 2
  icon_id: 372
  is_multiple_command_unique_skill: 0
  name:
    en: Knockout Strike
    ja: 気絶の一撃
    ko: 기절의 일격
    zh_hant: 昏迷一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5325
  skill_field_effect_id: 1309
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10451
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10410
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9446:
  _id_: 9446
  attribute_id: 9
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    en: Stop Strike
    ja: 停止の一撃
    ko: 정지의 일격
    zh_hant: 停止一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5326
  skill_field_effect_id: 1310
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10451
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9447:
  _id_: 9447
  attribute_id: 9
  cost: 2
  icon_id: 473
  is_multiple_command_unique_skill: 1
  name:
    en: Try and Kill Me, Nana Daiba Encore
    ja: 殺してみせろよ 大場なな Encore
    ko: 어디 한번 죽여봐 다이바 나나 Encore
    zh_hant: 來殺我啊，大場奈奈！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5327
  skill_field_effect_id: 1311
  skill_options:
  - hit_rate: 100
    id: 10441
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 5
    - 5
    - 5
    - 5
    - 5
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 386
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
  - hit_rate: 100
    id: 10433
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9449:
  _id_: 9449
  attribute_id: 4
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5329
  skill_field_effect_id: 1315
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10422
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9450:
  _id_: 9450
  attribute_id: 4
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5330
  skill_field_effect_id: 1316
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9451:
  _id_: 9451
  attribute_id: 4
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5331
  skill_field_effect_id: 1317
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9452:
  _id_: 9452
  attribute_id: 4
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Nocturne Game Encore
    ja: 紅月夜遊戯 Encore
    ko: 붉은 달밤의 유희 Encore
    zh_hant: 紅月夜遊戲 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5332
  skill_field_effect_id: 1318
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10396
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10284
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9454:
  _id_: 9454
  attribute_id: 9
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Superstrength
    ja: 怪力の一閃
    ko: 괴력의 일섬
    zh_hant: 怪力閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5334
  skill_field_effect_id: 1321
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9455:
  _id_: 9455
  attribute_id: 9
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Flash
    ja: 増強の一閃
    ko: 증강의 일섬
    zh_hant: 增強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5335
  skill_field_effect_id: 1322
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9456:
  _id_: 9456
  attribute_id: 9
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Flash
    ja: 致命の一閃
    ko: 치명의 일섬
    zh_hant: 致命閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5336
  skill_field_effect_id: 1323
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9457:
  _id_: 9457
  attribute_id: 9
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Blazing Dance
    ja: 美焔の舞
    ko: 미염의 춤
    zh_hant: 美焰之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5337
  skill_field_effect_id: 1324
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9459:
  _id_: 9459
  attribute_id: 2
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5339
  skill_field_effect_id: 1328
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10438
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9460:
  _id_: 9460
  attribute_id: 2
  cost: 2
  icon_id: 441
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Inactivity
    ja: 沈滞の斬撃
    ko: 침체의 참격
    zh_hant: 沉滯斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5340
  skill_field_effect_id: 1329
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10428
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9461:
  _id_: 9461
  attribute_id: 2
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5341
  skill_field_effect_id: 1330
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9462:
  _id_: 9462
  attribute_id: 2
  cost: 2
  icon_id: 476
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction Encore
    ja: 塔の断罪 Encore
    ko: 탑의 단죄 Encore
    zh_hant: 塔之定罪 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5342
  skill_field_effect_id: 1331
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9479:
  _id_: 9479
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2291
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9480:
  _id_: 9480
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9481:
  _id_: 9481
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2293
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9482:
  _id_: 9482
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9483:
  _id_: 9483
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
9484:
  _id_: 9484
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9485:
  _id_: 9485
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9487:
  _id_: 9487
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9488:
  _id_: 9488
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9489:
  _id_: 9489
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9490:
  _id_: 9490
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9491:
  _id_: 9491
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9492:
  _id_: 9492
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9493:
  _id_: 9493
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9494:
  _id_: 9494
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9495:
  _id_: 9495
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9496:
  _id_: 9496
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9497:
  _id_: 9497
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9499:
  _id_: 9499
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2329
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9500:
  _id_: 9500
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2330
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9501:
  _id_: 9501
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2331
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9502:
  _id_: 9502
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2332
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9503:
  _id_: 9503
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2333
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9504:
  _id_: 9504
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2334
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9505:
  _id_: 9505
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2335
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9507:
  _id_: 9507
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9508:
  _id_: 9508
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9509:
  _id_: 9509
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9510:
  _id_: 9510
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9511:
  _id_: 9511
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9512:
  _id_: 9512
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9513:
  _id_: 9513
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9514:
  _id_: 9514
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9515:
  _id_: 9515
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9516:
  _id_: 9516
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9517:
  _id_: 9517
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9519:
  _id_: 9519
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9520:
  _id_: 9520
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9521:
  _id_: 9521
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9522:
  _id_: 9522
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9523:
  _id_: 9523
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9524:
  _id_: 9524
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9525:
  _id_: 9525
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9526:
  _id_: 9526
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9527:
  _id_: 9527
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9529:
  _id_: 9529
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9530:
  _id_: 9530
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9531:
  _id_: 9531
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9532:
  _id_: 9532
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9533:
  _id_: 9533
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9534:
  _id_: 9534
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9535:
  _id_: 9535
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9536:
  _id_: 9536
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9537:
  _id_: 9537
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9538:
  _id_: 9538
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9539:
  _id_: 9539
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9541:
  _id_: 9541
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9542:
  _id_: 9542
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9543:
  _id_: 9543
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9544:
  _id_: 9544
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9545:
  _id_: 9545
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9546:
  _id_: 9546
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9547:
  _id_: 9547
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9548:
  _id_: 9548
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9549:
  _id_: 9549
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9551:
  _id_: 9551
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9552:
  _id_: 9552
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9553:
  _id_: 9553
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9554:
  _id_: 9554
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9555:
  _id_: 9555
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9556:
  _id_: 9556
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9557:
  _id_: 9557
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9558:
  _id_: 9558
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9559:
  _id_: 9559
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9560:
  _id_: 9560
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9561:
  _id_: 9561
  attribute_id: 4
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9563:
  _id_: 9563
  attribute_id: 5
  cost: 1
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Slash
    ja: 衰光の斬撃
    ko: 쇠광의 참격
    zh_hant: 衰光斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5344
  skill_field_effect_id: 1334
  skill_options:
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10456
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10413
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9564:
  _id_: 9564
  attribute_id: 5
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5345
  skill_field_effect_id: 1335
  skill_options:
  - hit_rate: 100
    id: 10412
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10456
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9565:
  _id_: 9565
  attribute_id: 5
  cost: 2
  icon_id: 466
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Collapse
    ja: 虚脱の斬撃
    ko: 허탈의 참격
    zh_hant: 虛脫斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5346
  skill_field_effect_id: 1336
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10456
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9566:
  _id_: 9566
  attribute_id: 5
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Shining Peace Encore
    ja: 道に光を、戦場に花を Encore
    ko: 길에 빛을, 전장에 꽃을 Encore
    zh_hant: 光綻放於道路，花盛開於戰場 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5347
  skill_field_effect_id: 1337
  skill_options:
  - hit_rate: 100
    id: 20025
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10413
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9568:
  _id_: 9568
  attribute_id: 3
  cost: 1
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    ja: 錯乱の斬撃
  optional_description:
    ja: ''
  sequence_id: 5349
  skill_field_effect_id: 1341
  skill_options:
  - hit_rate: 100
    id: 10434
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9569:
  _id_: 9569
  attribute_id: 3
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    ja: 軽快な斬撃
  optional_description:
    ja: ''
  sequence_id: 5350
  skill_field_effect_id: 1342
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10417
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9570:
  _id_: 9570
  attribute_id: 3
  cost: 2
  icon_id: 479
  is_multiple_command_unique_skill: 0
  name:
    ja: 短縮の斬撃
  optional_description:
    ja: ''
  sequence_id: 5351
  skill_field_effect_id: 1343
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10417
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9571:
  _id_: 9571
  attribute_id: 3
  cost: 2
  icon_id: 479
  is_multiple_command_unique_skill: 0
  name:
    ja: 永遠の少年
  optional_description:
    ja: ''
  sequence_id: 5352
  skill_field_effect_id: 1344
  skill_options:
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10353
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 389
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
9573:
  _id_: 9573
  attribute_id: 8
  cost: 2
  icon_id: 222
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Flash
    ja: 衰光の一閃
    ko: 쇠광의 일섬
    zh_hant: 衰光閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5354
  skill_field_effect_id: 1348
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 347
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9574:
  _id_: 9574
  attribute_id: 8
  cost: 2
  icon_id: 89
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant Flash
    ja: 煌めく一閃
    ko: 빛나는 일섬
    zh_hant: 輝煌閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5355
  skill_field_effect_id: 1349
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9575:
  _id_: 9575
  attribute_id: 8
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Fatigue
    ja: 疲労の一閃
    ko: 피로의 일섬
    zh_hant: 疲勞閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5356
  skill_field_effect_id: 1350
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9576:
  _id_: 9576
  attribute_id: 8
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Brilliant☆Sunshine! Encore
    ja: 燦々☆サンシャイン！ Encore
    ko: 눈부시게 빛나는 ☆선샤인! Encore
    zh_hant: 燦爛☆陽光！ Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5357
  skill_field_effect_id: 1351
  skill_options:
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10392
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9578:
  _id_: 9578
  attribute_id: 1
  cost: 1
  icon_id: 469
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Expertise
    ja: 達人の一閃
    ko: 달인의 일섬
    zh_hant: 精通閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5359
  skill_field_effect_id: 1355
  skill_options:
  - hit_rate: 100
    id: 10422
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10446
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10425
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2112
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9579:
  _id_: 9579
  attribute_id: 1
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Flash
    ja: 増強の一閃
    ko: 증강의 일섬
    zh_hant: 增強閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5360
  skill_field_effect_id: 1356
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10324
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9580:
  _id_: 9580
  attribute_id: 1
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Flash
    ja: 致命の一閃
    ko: 치명의 일섬
    zh_hant: 致命閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5361
  skill_field_effect_id: 1357
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 361
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9581:
  _id_: 9581
  attribute_id: 1
  cost: 2
  icon_id: 479
  is_multiple_command_unique_skill: 1
  name:
    en: Fated Moment
    ja: 待ちわびた瞬間
    ko: 고대하던 순간
    zh_hant: 等待已久的時刻
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5362
  skill_field_effect_id: 1358
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10324
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 361
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9583:
  _id_: 9583
  attribute_id: 4
  cost: 1
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    ja: 封印の刺突
  optional_description:
    ja: ''
  sequence_id: 5364
  skill_field_effect_id: 1362
  skill_options:
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10428
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10440
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9584:
  _id_: 9584
  attribute_id: 4
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    ja: 軽快な刺突
  optional_description:
    ja: ''
  sequence_id: 5365
  skill_field_effect_id: 1363
  skill_options:
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9585:
  _id_: 9585
  attribute_id: 4
  cost: 2
  icon_id: 395
  is_multiple_command_unique_skill: 0
  name:
    ja: 加護の刺突
  optional_description:
    ja: ''
  sequence_id: 5366
  skill_field_effect_id: 1364
  skill_options:
  - hit_rate: 100
    id: 10315
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20028
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9586:
  _id_: 9586
  attribute_id: 4
  cost: 2
  icon_id: 464
  is_multiple_command_unique_skill: 0
  name:
    ja: 船上の復讐
  optional_description:
    ja: ''
  sequence_id: 5367
  skill_field_effect_id: 1365
  skill_options:
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9588:
  _id_: 9588
  attribute_id: 3
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    ja: 怪力の狙撃
  optional_description:
    ja: ''
  sequence_id: 5369
  skill_field_effect_id: 1369
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10280
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9589:
  _id_: 9589
  attribute_id: 3
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    ja: 増強の狙撃
  optional_description:
    ja: ''
  sequence_id: 5370
  skill_field_effect_id: 1370
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9590:
  _id_: 9590
  attribute_id: 3
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    ja: 致命の狙撃
  optional_description:
    ja: ''
  sequence_id: 5371
  skill_field_effect_id: 1371
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 364
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9591:
  _id_: 9591
  attribute_id: 3
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    ja: 妖精のいたずら
  optional_description:
    ja: ''
  sequence_id: 5372
  skill_field_effect_id: 1372
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 364
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9593:
  _id_: 9593
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3221
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9594:
  _id_: 9594
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強斬撃
  optional_description:
    ja: ''
  sequence_id: 3222
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9595:
  _id_: 9595
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3223
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9596:
  _id_: 9596
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 3224
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9597:
  _id_: 9597
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の斬撃
  optional_description:
    ja: ''
  sequence_id: 3225
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
9598:
  _id_: 9598
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 炎舞
  optional_description:
    ja: ''
  sequence_id: 3226
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9599:
  _id_: 9599
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 3227
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9600:
  _id_: 9600
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 浄化の舞
  optional_description:
    ja: ''
  sequence_id: 3228
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9601:
  _id_: 9601
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: シャイニングホープ★ NEO
  optional_description:
    ja: ''
  sequence_id: 3229
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9603:
  _id_: 9603
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3460
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9604:
  _id_: 9604
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3461
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9605:
  _id_: 9605
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3462
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9606:
  _id_: 9606
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3463
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9607:
  _id_: 9607
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3464
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9608:
  _id_: 9608
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3465
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9609:
  _id_: 9609
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 防衛の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3466
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9610:
  _id_: 9610
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3467
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9611:
  _id_: 9611
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
  optional_description:
    ja: ''
  sequence_id: 3468
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9613:
  _id_: 9613
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3257
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9614:
  _id_: 9614
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強斬撃
  optional_description:
    ja: ''
  sequence_id: 3258
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9615:
  _id_: 9615
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3259
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9616:
  _id_: 9616
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 3260
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9617:
  _id_: 9617
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の連撃
  optional_description:
    ja: ''
  sequence_id: 3261
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9618:
  _id_: 9618
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 炎舞
  optional_description:
    ja: ''
  sequence_id: 3262
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9619:
  _id_: 9619
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 3263
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
9620:
  _id_: 9620
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 浄化の舞
  optional_description:
    ja: ''
  sequence_id: 3264
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9621:
  _id_: 9621
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: シャイニングホープ★ NEO
  optional_description:
    ja: ''
  sequence_id: 3265
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9623:
  _id_: 9623
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3469
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9624:
  _id_: 9624
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3470
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9625:
  _id_: 9625
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3471
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9626:
  _id_: 9626
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3472
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9627:
  _id_: 9627
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3473
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9628:
  _id_: 9628
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3474
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9629:
  _id_: 9629
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 防衛の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3475
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 126
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9630:
  _id_: 9630
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 3476
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9631:
  _id_: 9631
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3477
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9632:
  _id_: 9632
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
  optional_description:
    ja: ''
  sequence_id: 3478
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
9634:
  _id_: 9634
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9635:
  _id_: 9635
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強斬撃
  optional_description:
    ja: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9636:
  _id_: 9636
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9637:
  _id_: 9637
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9638:
  _id_: 9638
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9639:
  _id_: 9639
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の連撃
  optional_description:
    ja: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9640:
  _id_: 9640
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 炎舞
  optional_description:
    ja: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9641:
  _id_: 9641
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9642:
  _id_: 9642
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 浄化の舞
  optional_description:
    ja: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9643:
  _id_: 9643
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: シャイニングホープ★ NEO
  optional_description:
    ja: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9645:
  _id_: 9645
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9646:
  _id_: 9646
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9647:
  _id_: 9647
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9648:
  _id_: 9648
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9649:
  _id_: 9649
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 防衛の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9650:
  _id_: 9650
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9651:
  _id_: 9651
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9652:
  _id_: 9652
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
  optional_description:
    ja: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9654:
  _id_: 9654
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3294
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9655:
  _id_: 9655
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強斬撃
  optional_description:
    ja: ''
  sequence_id: 3295
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9656:
  _id_: 9656
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3296
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9657:
  _id_: 9657
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3297
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9658:
  _id_: 9658
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3298
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9659:
  _id_: 9659
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の連撃
  optional_description:
    ja: ''
  sequence_id: 3299
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9660:
  _id_: 9660
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 炎舞
  optional_description:
    ja: ''
  sequence_id: 4660
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9661:
  _id_: 9661
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 3301
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9662:
  _id_: 9662
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 浄化の舞
  optional_description:
    ja: ''
  sequence_id: 3302
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9663:
  _id_: 9663
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: シャイニングホープ★ NEO
  optional_description:
    ja: ''
  sequence_id: 4661
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9665:
  _id_: 9665
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3479
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9666:
  _id_: 9666
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3480
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9667:
  _id_: 9667
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3481
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9668:
  _id_: 9668
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3482
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9669:
  _id_: 9669
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 防衛の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3483
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10100
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9670:
  _id_: 9670
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 4656
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9671:
  _id_: 9671
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3485
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9672:
  _id_: 9672
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 威光堂々　～銀河皇帝円舞曲～　NEO
  optional_description:
    ja: ''
  sequence_id: 4657
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9686:
  _id_: 9686
  attribute_id: 2
  cost: 2
  icon_id: 429
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Support
    ja: 支援の斬撃
    ko: 지원의 참격
    zh_hant: 支援斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5374
  skill_field_effect_id: 1376
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10422
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9687:
  _id_: 9687
  attribute_id: 2
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5375
  skill_field_effect_id: 1377
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10347
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9688:
  _id_: 9688
  attribute_id: 2
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5376
  skill_field_effect_id: 1378
  skill_options:
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10361
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 220
    - 230
    - 240
    - 250
    - 260
9689:
  _id_: 9689
  attribute_id: 2
  cost: 2
  icon_id: 417
  is_multiple_command_unique_skill: 0
  name:
    en: Dark Feast Encore
    ja: Dark feast Encore
    ko: Dark feast Encore
    zh_hant: Dark feast Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5377
  skill_field_effect_id: 1379
  skill_options:
  - hit_rate: 100
    id: 10345
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 624
    target_id: 6020
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9691:
  _id_: 9691
  attribute_id: 8
  cost: 2
  icon_id: 400
  is_multiple_command_unique_skill: 0
  name:
    en: Seal Flash
    ja: 封印の一閃
    ko: 봉인의 일섬
    zh_hant: 封印閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5379
  skill_field_effect_id: 1383
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10445
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9692:
  _id_: 9692
  attribute_id: 8
  cost: 2
  icon_id: 394
  is_multiple_command_unique_skill: 0
  name:
    en: Static Flash
    ja: 鈍足の一閃
    ko: 둔화의 일섬
    zh_hant: 慢行閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5380
  skill_field_effect_id: 1384
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10456
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9693:
  _id_: 9693
  attribute_id: 8
  cost: 2
  icon_id: 482
  is_multiple_command_unique_skill: 0
  name:
    en: Flash of Shortening
    ja: 短縮の一閃
    ko: 단축의 일섬
    zh_hant: 縮短閃光
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5381
  skill_field_effect_id: 1385
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9694:
  _id_: 9694
  attribute_id: 8
  cost: 2
  icon_id: 479
  is_multiple_command_unique_skill: 0
  name:
    en: This Road Is Where We Part Encore
    ja: ここが別れの一本道 Encore
    ko: 이곳이 이별의 외길 Encore
    zh_hant: 此處即為離別的一人道 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5382
  skill_field_effect_id: 1386
  skill_options:
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 388
    target_id: 2002
    times:
    - 15
    - 15
    - 15
    - 15
    - 15
    values:
    - 410
    - 420
    - 430
    - 440
    - 450
  - hit_rate: 100
    id: 10433
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9696:
  _id_: 9696
  attribute_id: 1
  cost: 1
  icon_id: 433
  is_multiple_command_unique_skill: 0
  name:
    ja: 錯乱の斬撃
  optional_description:
    ja: ''
  sequence_id: 5384
  skill_field_effect_id: 1390
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10467
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10361
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9697:
  _id_: 9697
  attribute_id: 1
  cost: 2
  icon_id: 345
  is_multiple_command_unique_skill: 0
  name:
    ja: 停止の斬撃
  optional_description:
    ja: ''
  sequence_id: 5385
  skill_field_effect_id: 1391
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10467
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10417
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9698:
  _id_: 9698
  attribute_id: 1
  cost: 2
  icon_id: 466
  is_multiple_command_unique_skill: 0
  name:
    ja: 虚脱の斬撃
  optional_description:
    ja: ''
  sequence_id: 5386
  skill_field_effect_id: 1392
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10467
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9699:
  _id_: 9699
  attribute_id: 1
  cost: 2
  icon_id: 454
  is_multiple_command_unique_skill: 0
  name:
    ja: 金色の魔法
  optional_description:
    ja: ''
  sequence_id: 5387
  skill_field_effect_id: 1393
  skill_options:
  - hit_rate: 100
    id: 10454
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10468
    target_id: 2011
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9701:
  _id_: 9701
  attribute_id: 2
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    ja: 軽快な斬撃
  optional_description:
    ja: ''
  sequence_id: 5389
  skill_field_effect_id: 1397
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 20026
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10438
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9702:
  _id_: 9702
  attribute_id: 2
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    ja: 疲労の斬撃
  optional_description:
    ja: ''
  sequence_id: 5390
  skill_field_effect_id: 1398
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9703:
  _id_: 9703
  attribute_id: 2
  cost: 2
  icon_id: 479
  is_multiple_command_unique_skill: 0
  name:
    ja: 短縮の斬撃
  optional_description:
    ja: ''
  sequence_id: 5391
  skill_field_effect_id: 1399
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2114
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9704:
  _id_: 9704
  attribute_id: 2
  cost: 2
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    ja: 気高き魂
  optional_description:
    ja: ''
  sequence_id: 5392
  skill_field_effect_id: 1400
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9706:
  _id_: 9706
  attribute_id: 8
  cost: 2
  icon_id: 398
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Superstrength
    ja: 怪力の斬撃
    ko: 괴력의 참격
    zh_hant: 怪力斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5394
  skill_field_effect_id: 1404
  skill_options:
  - hit_rate: 100
    id: 10319
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10453
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10284
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9707:
  _id_: 9707
  attribute_id: 8
  cost: 2
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5395
  skill_field_effect_id: 1405
  skill_options:
  - hit_rate: 100
    id: 89
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10284
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9708:
  _id_: 9708
  attribute_id: 8
  cost: 2
  icon_id: 365
  is_multiple_command_unique_skill: 0
  name:
    en: Fatal Slash
    ja: 致命の斬撃
    ko: 치명의 참격
    zh_hant: 致命斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5396
  skill_field_effect_id: 1406
  skill_options:
  - hit_rate: 100
    id: 10282
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10283
    target_id: 1002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10446
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 471
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 363
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 200
    - 210
    - 220
    - 230
    - 240
9709:
  _id_: 9709
  attribute_id: 8
  cost: 2
  icon_id: 360
  is_multiple_command_unique_skill: 1
  name:
    en: Glory of Rebirth Encore
    ja: 蘇る栄光 Encore
    ko: 되살아나는 영광 Encore
    zh_hant: 重拾榮光 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5397
  skill_field_effect_id: 1407
  skill_options:
  - hit_rate: 100
    id: 10357
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 10260
    target_id: 2111
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10349
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 363
    target_id: 6010
    times:
    - 20
    - 20
    - 20
    - 20
    - 20
    values:
    - 480
    - 510
    - 540
    - 570
    - 600
9711:
  _id_: 9711
  attribute_id: 9
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5399
  skill_field_effect_id: 1411
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2112
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9712:
  _id_: 9712
  attribute_id: 9
  cost: 1
  icon_id: 479
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Shortening
    ja: 短縮の斬撃
    ko: 단축의 참격
    zh_hant: 縮短斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5400
  skill_field_effect_id: 1412
  skill_options:
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2113
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9713:
  _id_: 9713
  attribute_id: 9
  cost: 2
  icon_id: 338
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Slash
    ja: 重圧の斬撃
    ko: 중압의 참격
    zh_hant: 重壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5401
  skill_field_effect_id: 1413
  skill_options:
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10467
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2114
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 210
    - 220
    - 230
    - 240
    - 250
9714:
  _id_: 9714
  attribute_id: 9
  cost: 2
  icon_id: 487
  is_multiple_command_unique_skill: 1
  name:
    en: Love & Rebirth Judgement Encore
    ja: Love＆Rebirth Judgment Encore
    ko: Love & Rebirth Judgment Encore
    zh_hant: Love＆Rebirth Judgment Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5402
  skill_field_effect_id: 1414
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 630
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10440
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 310
    target_id: 2002
    times:
    - 12
    - 12
    - 12
    - 12
    - 12
    values:
    - 360
    - 370
    - 380
    - 390
    - 400
9731:
  _id_: 9731
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 狙撃
  optional_description:
    ja: ''
  sequence_id: 2606
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9732:
  _id_: 9732
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強狙撃
  optional_description:
    ja: ''
  sequence_id: 2607
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9733:
  _id_: 9733
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2608
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9734:
  _id_: 9734
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 2609
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9735:
  _id_: 9735
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の狙撃
  optional_description:
    ja: ''
  sequence_id: 2610
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9736:
  _id_: 9736
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2611
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9737:
  _id_: 9737
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 闇炎の輪舞曲
  optional_description:
    ja: ''
  sequence_id: 2612
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9738:
  _id_: 9738
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: Eat me！ NEO
  optional_description:
    ja: ''
  sequence_id: 2613
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 55
    target_id: 2113
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9740:
  _id_: 9740
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 2614
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9741:
  _id_: 9741
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2615
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9742:
  _id_: 9742
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 2616
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9743:
  _id_: 9743
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2617
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9744:
  _id_: 9744
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2618
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9745:
  _id_: 9745
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の連撃
  optional_description:
    ja: ''
  sequence_id: 2619
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 170
    - 170
    - 170
    - 170
    - 170
9746:
  _id_: 9746
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 2620
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9747:
  _id_: 9747
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 柔和の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2621
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9748:
  _id_: 9748
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 惑いの協奏曲
  optional_description:
    ja: ''
  sequence_id: 2622
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9749:
  _id_: 9749
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 首はねの刑 NEO
  optional_description:
    ja: ''
  sequence_id: 2623
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9751:
  _id_: 9751
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3239
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9752:
  _id_: 9752
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3240
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9753:
  _id_: 9753
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3241
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9754:
  _id_: 9754
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3242
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9755:
  _id_: 9755
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3243
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9756:
  _id_: 9756
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3244
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9757:
  _id_: 9757
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の連撃
  optional_description:
    ja: ''
  sequence_id: 3245
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9758:
  _id_: 9758
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3246
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9759:
  _id_: 9759
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 無力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3247
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9760:
  _id_: 9760
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 秘石が導く月光の秘蹟　NEO
  optional_description:
    ja: ''
  sequence_id: 3248
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9762:
  _id_: 9762
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強狙撃
  optional_description:
    ja: ''
  sequence_id: 2641
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9763:
  _id_: 9763
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 2642
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9764:
  _id_: 9764
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強双撃
  optional_description:
    ja: ''
  sequence_id: 2643
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9765:
  _id_: 9765
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2644
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9766:
  _id_: 9766
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 2645
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9767:
  _id_: 9767
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の狙撃
  optional_description:
    ja: ''
  sequence_id: 2646
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9768:
  _id_: 9768
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2647
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9769:
  _id_: 9769
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 闇炎の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2648
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9770:
  _id_: 9770
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: Eat me！ NEO
  optional_description:
    ja: ''
  sequence_id: 2649
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9772:
  _id_: 9772
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 2650
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9773:
  _id_: 9773
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2651
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9774:
  _id_: 9774
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 2652
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2112
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9775:
  _id_: 9775
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2653
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9776:
  _id_: 9776
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2654
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9777:
  _id_: 9777
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の連撃
  optional_description:
    ja: ''
  sequence_id: 2655
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9778:
  _id_: 9778
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 2656
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9779:
  _id_: 9779
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 柔和の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2657
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9780:
  _id_: 9780
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 惑いの協奏曲
  optional_description:
    ja: ''
  sequence_id: 2658
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9781:
  _id_: 9781
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 首はねの刑 NEO
  optional_description:
    ja: ''
  sequence_id: 2659
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 75
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9783:
  _id_: 9783
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3275
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9784:
  _id_: 9784
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 3276
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9785:
  _id_: 9785
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3277
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9786:
  _id_: 9786
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3278
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9787:
  _id_: 9787
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3279
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9788:
  _id_: 9788
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3280
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9789:
  _id_: 9789
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3281
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9790:
  _id_: 9790
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 3282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9791:
  _id_: 9791
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9792:
  _id_: 9792
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 無力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9793:
  _id_: 9793
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 秘石が導く月光の秘蹟　NEO
  optional_description:
    ja: ''
  sequence_id: 3285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 62
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9795:
  _id_: 9795
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強狙撃
  optional_description:
    ja: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9796:
  _id_: 9796
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9797:
  _id_: 9797
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9798:
  _id_: 9798
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9799:
  _id_: 9799
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の狙撃
  optional_description:
    ja: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9800:
  _id_: 9800
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9801:
  _id_: 9801
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 闇炎の協奏曲
  optional_description:
    ja: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9802:
  _id_: 9802
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: Eat me！ NEO
  optional_description:
    ja: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9804:
  _id_: 9804
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9805:
  _id_: 9805
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9806:
  _id_: 9806
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9807:
  _id_: 9807
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9808:
  _id_: 9808
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9809:
  _id_: 9809
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 追撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9810:
  _id_: 9810
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9811:
  _id_: 9811
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 柔和の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9812:
  _id_: 9812
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 惑いの協奏曲
  optional_description:
    ja: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9813:
  _id_: 9813
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 首はねの刑 NEO
  optional_description:
    ja: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9815:
  _id_: 9815
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9816:
  _id_: 9816
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9817:
  _id_: 9817
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9818:
  _id_: 9818
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9819:
  _id_: 9819
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9820:
  _id_: 9820
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9821:
  _id_: 9821
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9822:
  _id_: 9822
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9823:
  _id_: 9823
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9824:
  _id_: 9824
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 無力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9825:
  _id_: 9825
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 秘石が導く月光の秘蹟　NEO
  optional_description:
    ja: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9827:
  _id_: 9827
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強狙撃
  optional_description:
    ja: ''
  sequence_id: 2678
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9828:
  _id_: 9828
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2679
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9829:
  _id_: 9829
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強参撃
  optional_description:
    ja: ''
  sequence_id: 2680
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9830:
  _id_: 9830
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2681
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9831:
  _id_: 9831
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の狙撃
  optional_description:
    ja: ''
  sequence_id: 2682
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9832:
  _id_: 9832
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 2683
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9833:
  _id_: 9833
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 闇炎の協奏曲
  optional_description:
    ja: ''
  sequence_id: 5080
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9834:
  _id_: 9834
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: Eat me！ NEO
  optional_description:
    ja: ''
  sequence_id: 5081
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9836:
  _id_: 9836
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 2686
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9837:
  _id_: 9837
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の斬撃
  optional_description:
    ja: ''
  sequence_id: 2687
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9838:
  _id_: 9838
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 2688
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9839:
  _id_: 9839
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 2689
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9840:
  _id_: 9840
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2690
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9841:
  _id_: 9841
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 追撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2691
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9842:
  _id_: 9842
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 堅守の舞
  optional_description:
    ja: ''
  sequence_id: 2692
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
9843:
  _id_: 9843
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 柔和の協奏曲
  optional_description:
    ja: ''
  sequence_id: 2693
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9844:
  _id_: 9844
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 惑いの協奏曲
  optional_description:
    ja: ''
  sequence_id: 5082
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9845:
  _id_: 9845
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 首はねの刑 NEO
  optional_description:
    ja: ''
  sequence_id: 5083
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10020
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9847:
  _id_: 9847
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 斬撃
  optional_description:
    ja: ''
  sequence_id: 3314
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9848:
  _id_: 9848
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 双撃
  optional_description:
    ja: ''
  sequence_id: 3315
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9849:
  _id_: 9849
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の双撃
  optional_description:
    ja: ''
  sequence_id: 3316
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9850:
  _id_: 9850
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 参撃
  optional_description:
    ja: ''
  sequence_id: 3317
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9851:
  _id_: 9851
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 強襲の参撃
  optional_description:
    ja: ''
  sequence_id: 3318
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9852:
  _id_: 9852
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 迎撃の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3319
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9853:
  _id_: 9853
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 必中の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3320
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9854:
  _id_: 9854
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 暗闇の炎花
  optional_description:
    ja: ''
  sequence_id: 5084
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9855:
  _id_: 9855
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 奮起の風
  optional_description:
    ja: ''
  sequence_id: 3322
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9856:
  _id_: 9856
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 無力の協奏曲
  optional_description:
    ja: ''
  sequence_id: 3323
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9857:
  _id_: 9857
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    ja: 秘石が導く月光の秘蹟　NEO
  optional_description:
    ja: ''
  sequence_id: 5085
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10030
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9859:
  _id_: 9859
  attribute_id: 9
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5404
  skill_field_effect_id: 1418
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 387
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9860:
  _id_: 9860
  attribute_id: 9
  cost: 2
  icon_id: 453
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Fatigue
    ja: 疲労の斬撃
    ko: 피로의 참격
    zh_hant: 疲勞斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5405
  skill_field_effect_id: 1419
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 387
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9861:
  _id_: 9861
  attribute_id: 9
  cost: 2
  icon_id: 464
  is_multiple_command_unique_skill: 0
  name:
    en: Overpower Slash
    ja: 威圧の斬撃
    ko: 위압의 참격
    zh_hant: 威壓斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5406
  skill_field_effect_id: 1420
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2124
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 387
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9862:
  _id_: 9862
  attribute_id: 9
  cost: 2
  icon_id: 471
  is_multiple_command_unique_skill: 0
  name:
    en: This Road Is Where We Part Encore
    ja: ここが別れの一本道 Encore
    ko: 이곳이 이별의 외길 Encore
    zh_hant: 此處即為離別的一人道 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5407
  skill_field_effect_id: 1421
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 629
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 387
    target_id: 2002
    times:
    - 16
    - 16
    - 16
    - 16
    - 16
    values:
    - 380
    - 400
    - 420
    - 450
    - 500
  - hit_rate: 100
    id: 10433
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9864:
  _id_: 9864
  attribute_id: 8
  cost: 1
  icon_id: 419
  is_multiple_command_unique_skill: 0
  name:
    en: Happy Slash
    ja: 軽快な斬撃
    ko: 경쾌한 참격
    zh_hant: 輕快斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5409
  skill_field_effect_id: 1425
  skill_options:
  - hit_rate: 100
    id: 10464
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10449
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 40
    - 40
    - 40
    - 40
    - 40
  - hit_rate: 100
    id: 10469
    target_id: 1002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2122
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 386
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9865:
  _id_: 9865
  attribute_id: 8
  cost: 1
  icon_id: 425
  is_multiple_command_unique_skill: 0
  name:
    en: Slash of Contraction
    ja: 狭窄の斬撃
    ko: 협착의 참격
    zh_hant: 視野收窄斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5410
  skill_field_effect_id: 1426
  skill_options:
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10443
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2123
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 386
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9866:
  _id_: 9866
  attribute_id: 8
  cost: 1
  icon_id: 310
  is_multiple_command_unique_skill: 0
  name:
    en: Strengthening Slash
    ja: 増強の斬撃
    ko: 증강의 참격
    zh_hant: 增強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5411
  skill_field_effect_id: 1427
  skill_options:
  - hit_rate: 100
    id: 572
    target_id: 1002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 1
    - 1
    - 1
    - 1
    - 1
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 2
    - 2
    - 2
    - 2
    - 2
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10284
    target_id: 2124
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 386
    target_id: 2121
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 240
    - 250
    - 260
    - 270
    - 280
9867:
  _id_: 9867
  attribute_id: 8
  cost: 1
  icon_id: 464
  is_multiple_command_unique_skill: 0
  name:
    en: Karen Aijo—to the Next Stage! Encore
    ja: 愛城華恋は次の舞台へ Encore
    ko: 아이조 카렌은 다음 무대로 Encore
    zh_hant: 愛城華戀即將邁向下一個舞台 Encore
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 5412
  skill_field_effect_id: 1428
  skill_options:
  - hit_rate: 100
    id: 10447
    target_id: 1002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10457
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 4
    - 4
    - 4
    - 4
    - 4
  - hit_rate: 100
    id: 10461
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 629
    target_id: 2701
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 386
    target_id: 2002
    times:
    - 16
    - 16
    - 16
    - 16
    - 16
    values:
    - 380
    - 400
    - 420
    - 450
    - 500
9869:
  _id_: 9869
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2840
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9870:
  _id_: 9870
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2841
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9871:
  _id_: 9871
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2842
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9872:
  _id_: 9872
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Flurry
    ja: 連撃
    ko: 연격
    zh_hant: 連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2843
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9873:
  _id_: 9873
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Rondo
    ja: 無力の輪舞曲
    ko: 무력의 윤무곡
    zh_hant: 無力圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2844
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 23
    target_id: 2123
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9874:
  _id_: 9874
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2845
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9875:
  _id_: 9875
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2846
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9876:
  _id_: 9876
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2847
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9878:
  _id_: 9878
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2624
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9879:
  _id_: 9879
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2625
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9880:
  _id_: 9880
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2626
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9881:
  _id_: 9881
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2627
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9882:
  _id_: 9882
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2628
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9883:
  _id_: 9883
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2629
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9884:
  _id_: 9884
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2630
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9885:
  _id_: 9885
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2631
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9887:
  _id_: 9887
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2874
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9888:
  _id_: 9888
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2875
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9889:
  _id_: 9889
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2876
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9890:
  _id_: 9890
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2877
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9891:
  _id_: 9891
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2878
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9892:
  _id_: 9892
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2879
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9893:
  _id_: 9893
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2880
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 23
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9894:
  _id_: 9894
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2881
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9895:
  _id_: 9895
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2882
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9896:
  _id_: 9896
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2883
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9898:
  _id_: 9898
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2660
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9899:
  _id_: 9899
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2661
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9900:
  _id_: 9900
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2662
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9901:
  _id_: 9901
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2663
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9902:
  _id_: 9902
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2664
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9903:
  _id_: 9903
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Rondo
    ja: 減光の輪舞曲
    ko: 감광의 윤무곡
    zh_hant: 減光圓舞曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2665
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 259
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9904:
  _id_: 9904
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2666
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9905:
  _id_: 9905
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Drowsy Concerto
    ja: 眠りの協奏曲
    ko: 잠의 협주곡
    zh_hant: 睡眠協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2667
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9906:
  _id_: 9906
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2668
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 58
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9908:
  _id_: 9908
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9909:
  _id_: 9909
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9910:
  _id_: 9910
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9911:
  _id_: 9911
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9912:
  _id_: 9912
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9913:
  _id_: 9913
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9914:
  _id_: 9914
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9915:
  _id_: 9915
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9916:
  _id_: 9916
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9917:
  _id_: 9917
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9919:
  _id_: 9919
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9920:
  _id_: 9920
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9921:
  _id_: 9921
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9922:
  _id_: 9922
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9923:
  _id_: 9923
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9924:
  _id_: 9924
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9925:
  _id_: 9925
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9926:
  _id_: 9926
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9927:
  _id_: 9927
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9929:
  _id_: 9929
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2910
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9930:
  _id_: 9930
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2911
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9931:
  _id_: 9931
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2912
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9932:
  _id_: 9932
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2913
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9933:
  _id_: 9933
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2914
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9934:
  _id_: 9934
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2915
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9935:
  _id_: 9935
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Helpless Concerto
    ja: 無力の協奏曲
    ko: 무력의 협주곡
    zh_hant: 無力協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2916
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 21
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10308
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9936:
  _id_: 9936
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Evasion Dance
    ja: 回避の舞
    ko: 회피의 춤
    zh_hant: 迴避之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2917
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 18
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9937:
  _id_: 9937
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Flurry
    ja: 必中の連撃
    ko: 백발백중의 연격
    zh_hant: 必中連擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4803
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9938:
  _id_: 9938
  attribute_id: 5
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Cherry Blossom Quick-Draw NEO
    ja: 桜花抜刀術　壱式 NEO
    ko: 벚꽃발도술 일식 NEO
    zh_hant: 櫻花拔刀術　壹式 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4804
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9940:
  _id_: 9940
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2696
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9941:
  _id_: 9941
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2697
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9942:
  _id_: 9942
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2698
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9943:
  _id_: 9943
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2699
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9944:
  _id_: 9944
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pursuit Concerto
    ja: 追撃の協奏曲
    ko: 추격의 협주곡
    zh_hant: 追擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2700
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9945:
  _id_: 9945
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dim Concerto
    ja: 減光の協奏曲
    ko: 감광의 협주곡
    zh_hant: 減光協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2701
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 10300
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 60
    - 65
    - 70
    - 75
    - 80
9946:
  _id_: 9946
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2702
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
9947:
  _id_: 9947
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Freezing Concerto
    ja: 凍てつく協奏曲
    ko: 얼어붙은 협주곡
    zh_hant: 凍結的協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4805
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9948:
  _id_: 9948
  attribute_id: 6
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Upside Down World NEO
    ja: 逆転世界の開眼 NEO
    ko: 역전세계의 개안 NEO
    zh_hant: 翻轉世界的領悟 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4806
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
9950:
  _id_: 9950
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2282
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9951:
  _id_: 9951
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2283
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9952:
  _id_: 9952
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2284
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9953:
  _id_: 9953
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2285
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9954:
  _id_: 9954
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2286
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 5000
    - 5000
    - 5000
    - 5000
    - 5000
9955:
  _id_: 9955
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2287
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
9956:
  _id_: 9956
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2288
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9957:
  _id_: 9957
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2289
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9958:
  _id_: 9958
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2290
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 59
    target_id: 2123
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9960:
  _id_: 9960
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2291
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9961:
  _id_: 9961
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2292
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9962:
  _id_: 9962
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2293
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9963:
  _id_: 9963
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2294
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9964:
  _id_: 9964
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2295
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 180
    - 180
    - 180
    - 180
    - 180
9965:
  _id_: 9965
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2296
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9966:
  _id_: 9966
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2297
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 224
    target_id: 2113
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9968:
  _id_: 9968
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1972
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9969:
  _id_: 9969
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1973
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9970:
  _id_: 9970
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1974
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9971:
  _id_: 9971
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1975
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9972:
  _id_: 9972
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1976
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9973:
  _id_: 9973
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1977
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9974:
  _id_: 9974
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1978
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9975:
  _id_: 9975
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1979
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 50
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 50
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9976:
  _id_: 9976
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1980
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9977:
  _id_: 9977
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1981
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9978:
  _id_: 9978
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 1982
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
9980:
  _id_: 9980
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2318
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9981:
  _id_: 9981
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2319
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9982:
  _id_: 9982
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2320
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
9983:
  _id_: 9983
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Dual Slash
    ja: 強双撃
    ko: 강한 쌍격
    zh_hant: 強雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2321
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
9984:
  _id_: 9984
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2322
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9985:
  _id_: 9985
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2323
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9986:
  _id_: 9986
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2324
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 7000
    - 7000
    - 7000
    - 7000
    - 7000
9987:
  _id_: 9987
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Strike
    ja: 必中の一撃
    ko: 백발백중의 일격
    zh_hant: 必中一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2325
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9988:
  _id_: 9988
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Wind
    ja: 浄化の風
    ko: 정화의 바람
    zh_hant: 淨化之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2326
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9989:
  _id_: 9989
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2327
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9990:
  _id_: 9990
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2328
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 50
    id: 59
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
9992:
  _id_: 9992
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2329
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9993:
  _id_: 9993
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2330
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
9994:
  _id_: 9994
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2331
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
9995:
  _id_: 9995
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2332
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
9996:
  _id_: 9996
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2333
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 35
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
9997:
  _id_: 9997
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2334
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
9998:
  _id_: 9998
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2335
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 224
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10000:
  _id_: 10000
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Slash
    ja: 斬撃
    ko: 참격
    zh_hant: 斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2010
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10001:
  _id_: 10001
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2011
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10002:
  _id_: 10002
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2012
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
10003:
  _id_: 10003
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2013
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
10004:
  _id_: 10004
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2014
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10005:
  _id_: 10005
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2015
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10006:
  _id_: 10006
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2016
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 8
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 20
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
  - hit_rate: 100
    id: 22
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
10007:
  _id_: 10007
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2017
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 55
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 3000
    - 3000
    - 3000
    - 3000
    - 3000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10008:
  _id_: 10008
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2018
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 9
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10009:
  _id_: 10009
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2019
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
10010:
  _id_: 10010
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2020
  skill_field_effect_id: 0
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 32
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 20
    - 20
    - 20
    - 20
    - 20
10012:
  _id_: 10012
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10013:
  _id_: 10013
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10014:
  _id_: 10014
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10015:
  _id_: 10015
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10016:
  _id_: 10016
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10017:
  _id_: 10017
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
10018:
  _id_: 10018
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10019:
  _id_: 10019
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10020:
  _id_: 10020
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10021:
  _id_: 10021
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10022:
  _id_: 10022
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10024:
  _id_: 10024
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10025:
  _id_: 10025
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10026:
  _id_: 10026
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10027:
  _id_: 10027
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10028:
  _id_: 10028
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
10029:
  _id_: 10029
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10030:
  _id_: 10030
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10031:
  _id_: 10031
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10032:
  _id_: 10032
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 250
    - 250
    - 250
    - 250
    - 250
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10034:
  _id_: 10034
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10035:
  _id_: 10035
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
10036:
  _id_: 10036
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
10037:
  _id_: 10037
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10038:
  _id_: 10038
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10039:
  _id_: 10039
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10040:
  _id_: 10040
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10041:
  _id_: 10041
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 57
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10042:
  _id_: 10042
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10043:
  _id_: 10043
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10044:
  _id_: 10044
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10046:
  _id_: 10046
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strike
    ja: 一撃
    ko: 일격
    zh_hant: 一擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2356
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10047:
  _id_: 10047
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Slash
    ja: 強斬撃
    ko: 강한 참격
    zh_hant: 強斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2357
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10048:
  _id_: 10048
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2358
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10049:
  _id_: 10049
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Slash
    ja: 強参撃
    ko: 강한 삼격
    zh_hant: 強參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2359
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10050:
  _id_: 10050
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2360
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10051:
  _id_: 10051
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Ironclad Dance
    ja: 堅守の舞
    ko: 굳은 수호의 춤
    zh_hant: 堅守之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2361
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 30
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
  - hit_rate: 100
    id: 31
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 10000
    - 10000
    - 10000
    - 10000
    - 10000
10052:
  _id_: 10052
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Perfect Aim Concerto
    ja: 必中の協奏曲
    ko: 백발백중의 협주곡
    zh_hant: 必中協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2362
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10053:
  _id_: 10053
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Purifying Dance
    ja: 浄化の舞
    ko: 정화의 춤
    zh_hant: 淨化之舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2363
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 128
    target_id: 1001
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 127
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10054:
  _id_: 10054
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2364
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 12
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10055:
  _id_: 10055
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Befuddling Concerto
    ja: 惑いの協奏曲
    ko: 미혹의 협주곡
    zh_hant: 迷惑協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4615
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10056:
  _id_: 10056
  attribute_id: 3
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Blue Days Pierce NEO
    ja: ブルーデイズの一刺し NEO
    ko: 블루 데이즈의 일격찌르기 NEO
    zh_hant: 藍天刺擊 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4616
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 4
    - 4
    - 4
    - 4
    - 4
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10058:
  _id_: 10058
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Smash
    ja: 打撃
    ko: 타격
    zh_hant: 敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2367
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10059:
  _id_: 10059
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Smash
    ja: 強打撃
    ko: 강한 타격
    zh_hant: 強敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2368
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2011
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10060:
  _id_: 10060
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Smash
    ja: 参打撃
    ko: 삼타격
    zh_hant: 參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2369
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10061:
  _id_: 10061
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Strong Triple Smash
    ja: 強参打撃
    ko: 강한 삼타격
    zh_hant: 強參敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2370
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2113
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10062:
  _id_: 10062
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Accuracy Smash
    ja: 必中の打撃
    ko: 백발백중의 타격
    zh_hant: 必中敲擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2371
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10292
    target_id: 1001
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
10063:
  _id_: 10063
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2372
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10064:
  _id_: 10064
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Softening Concerto
    ja: 柔和の協奏曲
    ko: 유화의 협주곡
    zh_hant: 柔和協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2373
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 11
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 13
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10065:
  _id_: 10065
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Pressure Concerto
    ja: 重圧の協奏曲
    ko: 중압의 협주곡
    zh_hant: 重壓協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4617
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 200
    - 200
    - 200
    - 200
    - 200
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10066:
  _id_: 10066
  attribute_id: 1
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Buttercup Carpet NEO
    ja: 金鳳花の絨毯 NEO
    ko: 미나리아재비의 양탄자 NEO
    zh_hant: 毛茛地毯 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4618
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10050
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
10068:
  _id_: 10068
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Slash
    ja: 強襲の斬撃
    ko: 강습의 참격
    zh_hant: 強襲斬擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2050
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 1
    target_id: 2121
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10069:
  _id_: 10069
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Dual Slash
    ja: 双撃
    ko: 쌍격
    zh_hant: 雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2051
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 80
    - 80
    - 80
    - 80
    - 80
10070:
  _id_: 10070
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Dual Slash
    ja: 強襲の双撃
    ko: 강습의 쌍격
    zh_hant: 強襲雙擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2052
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 80
    target_id: 2122
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 120
    - 120
    - 120
    - 120
    - 120
10071:
  _id_: 10071
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Triple Slash
    ja: 参撃
    ko: 삼격
    zh_hant: 參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2053
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 70
    - 70
    - 70
    - 70
    - 70
10072:
  _id_: 10072
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Violent Triple Slash
    ja: 強襲の参撃
    ko: 강습의 삼격
    zh_hant: 強襲參擊
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2054
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2123
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 100
    - 100
    - 100
    - 100
    - 100
10073:
  _id_: 10073
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Concerto
    ja: 迎撃の協奏曲
    ko: 요격의 협주곡
    zh_hant: 迎擊協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2055
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 82
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
10074:
  _id_: 10074
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Inspiring Gust
    ja: 奮起の風
    ko: 분기의 바람
    zh_hant: 奮起之風
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2056
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10338
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
  - hit_rate: 100
    id: 10306
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10282
    target_id: 1001
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10075:
  _id_: 10075
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Restraint Firedance
    ja: 抑止の炎舞
    ko: 억제의 염무
    zh_hant: 抑止的炎舞
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2057
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 10010
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10291
    target_id: 2002
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 0
    - 0
    - 0
    - 0
    - 0
10076:
  _id_: 10076
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Weakening Concerto
    ja: 脱力の協奏曲
    ko: 탈력의 협주곡
    zh_hant: 虛脫協奏曲
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 2058
  skill_field_effect_id: 811
  skill_options:
  - hit_rate: 100
    id: 10307
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 50
    - 50
    - 50
    - 50
    - 50
10077:
  _id_: 10077
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Counter Solo
    ja: 反撃の独奏
    ko: 반격의 독주
    zh_hant: 反擊獨奏
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4619
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 81
    target_id: 2002
    times:
    - 0
    - 0
    - 0
    - 0
    - 0
    values:
    - 150
    - 150
    - 150
    - 150
    - 150
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
10078:
  _id_: 10078
  attribute_id: 2
  cost: 2
  icon_id: 1
  is_multiple_command_unique_skill: 0
  name:
    en: Tower's Conviction NEO
    ja: 塔の断罪 NEO
    ko: 탑의 단죄 NEO
    zh_hant: 塔之定罪 NEO
  optional_description:
    en: ''
    ja: ''
    ko: ''
    zh_hant: ''
  sequence_id: 4620
  skill_field_effect_id: 742
  skill_options:
  - hit_rate: 100
    id: 320
    target_id: 2002
    times:
    - 3
    - 3
    - 3
    - 3
    - 3
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10160
    target_id: 2002
    times:
    - 1
    - 1
    - 1
    - 1
    - 1
    values:
    - 99999
    - 99999
    - 99999
    - 99999
    - 99999
  - hit_rate: 100
    id: 10339
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30
  - hit_rate: 100
    id: 10340
    target_id: 1001
    times:
    - 2
    - 2
    - 2
    - 2
    - 2
    values:
    - 30
    - 30
    - 30
    - 30
    - 30

*/

inline val dataGenSkill get() = """{"2243":{"attribute_id":6,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1467,"skill_field_effect_id":0,"_id_":2243,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2244":{"attribute_id":6,"cost":3,"description":{"en":"High damage to front enemy. Act Power up to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体にACTパワーアップを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的ACT力量"},"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Slash","ja":"奮起の斬撃","ko":"분기의 참격","zh_hant":"奮起斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1468,"skill_field_effect_id":0,"_id_":2244,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2245":{"attribute_id":6,"cost":3,"description":{"en":"High damage to front enemy. Low Brilliance recovery to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体のキラめきを少し回復する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 반짝임을 조금 회복","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並回復所有我方少許的光芒"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Synchro Slash","ja":"呼応の斬撃","ko":"호응의 참격","zh_hant":"呼應斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1469,"skill_field_effect_id":0,"_id_":2245,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,11,12,13,15]}]},"2246":{"attribute_id":6,"cost":2,"description":{"en":"Perfect Aim High damage to all enemies, ignoring Aggro, Provoke, Barrier, Reflect and Invincible. Applies Stage Effect [We Are on the Stage (Cloud)] to allies' stage.","ja":"敵全体に威力(大)の必中攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（雲）」を付与する この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する","ko":"적 전체에게 타깃 고정, 도발, 배리어, 반사, 무적을 무시한 위력(대) 백발백중 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(구름)]을 부여","zh_hant":"對所有敵人發動威力（大）的必中攻擊，並賦予我方的舞台舞台效果「我們已經站上舞台（雲）」 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵"},"icon_id":1006,"is_multiple_command_unique_skill":0,"name":{"en":"I will protect them! Forever... Again and again!","ja":"私が守るの、ずっと何度でも","ko":"내가 지키겠어, 언제까지고 몇 번이든","zh_hant":"不管多少次我都會守護的。"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1470,"skill_field_effect_id":10,"_id_":2246,"skill_options":[{"id":310,"hit_rate":100,"target_id":22002,"times":[2,2,2,2,2],"values":[117,123,128,134,140]}]},"2290":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵を威力(小)で攻撃 自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1505,"skill_field_effect_id":0,"_id_":2290,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"2291":{"attribute_id":1,"cost":3,"description":{"en":"High damage to front enemy. Normal and Special Defense up to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体に通常防御力アップ、特殊防御力アップを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 일반 방어력 증가, 특수 방어력 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的普通防禦力和特殊防禦力"},"icon_id":10,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Bravery","ja":"剛勇の斬撃","ko":"용감의 참격","zh_hant":"勇猛斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1506,"skill_field_effect_id":0,"_id_":2291,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]},{"id":12,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]}]},"2292":{"attribute_id":1,"cost":3,"description":{"en":"High damage to front enemy. Medium Brilliance recovery to 2 allies with the highest Act Power.","ja":"前から1番目の敵に威力(大)の攻撃を行い、ACTパワーが高い2体の味方のキラめきを(中)回復する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, ACT 파워가 높은 아군 2명의 반짝임(중) 회복","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並回復ACT力量較高的2名我方的光芒（中）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Glittering Slash","ja":"煌星の斬撃","ko":"기라성의 참격","zh_hant":"閃耀之星斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1507,"skill_field_effect_id":0,"_id_":2292,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1127,"times":[0,0,0,0,0],"values":[20,23,25,27,30]}]},"2293":{"attribute_id":1,"cost":2,"description":{"en":"Very High damage to all enemies. Brilliance Recovery and Brilliance Regen to all allies. Applies Stage Effect [We Are on the Stage (Flower)] to allies' stage.","ja":"敵全体に威力(大+)の攻撃を行い、味方全体のキラめきを回復、毎ターンキラめき回復を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（花）」を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 전체의 반짝임을 회복, 매 턴 반짝임 회복을 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(꽃)]을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，回復所有我方的光芒，並賦予每回合光芒回復效果，同時賦予我方的舞台舞台效果「我們已經站上舞台（花）」"},"icon_id":1001,"is_multiple_command_unique_skill":0,"name":{"en":"We will all do Starlight!","ja":"みんなを、スタァライト！しちゃいます！！","ko":"모두를 스타라이트! 하겠습니다!!","zh_hant":"我會令大家星光照耀的！！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1508,"skill_field_effect_id":2,"_id_":2293,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":29,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,10,10,10,10]}]},"2295":{"attribute_id":2,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1510,"skill_field_effect_id":0,"_id_":2295,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2296":{"attribute_id":2,"cost":3,"description":{"en":"High damage to front enemy. Agility up to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体にすばやさアップを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 민첩 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的敏捷"},"icon_id":14,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Slash","ja":"疾風の斬撃","ko":"질풍의 참격","zh_hant":"疾風斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1511,"skill_field_effect_id":0,"_id_":2296,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2297":{"attribute_id":2,"cost":3,"description":{"en":"High damage to front enemy. Evasion x1 to 3 front allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、前から3体の味方に回避を付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 앞에서 3명의 아군에게 회피를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並賦予前面3名我方迴避"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"Thunderclap Slash","ja":"迅雷の斬撃","ko":"우레의 참격","zh_hant":"迅雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1512,"skill_field_effect_id":0,"_id_":2297,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":34,"hit_rate":100,"target_id":1133,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2298":{"attribute_id":2,"cost":3,"description":{"en":"High damage & AP Up to all enemies. AP Down to all allies. Applies Stage Effect [We Are on the Stage (Wind)] to allies' stage.","ja":"敵全体に威力(大)の攻撃を行いAP増加を付与し、味方全体にAP減少を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（風）」を付与する","ko":"적 전체에게 위력(대) 공격, AP 증가 부여, 아군 전체에게 AP 감소를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(바람)]을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予AP增加效果，以及給予所有我方AP減少效果，同時賦予我方的舞台舞台效果「我們已經站上舞台（風）」"},"icon_id":1002,"is_multiple_command_unique_skill":0,"name":{"en":"I'll have you follow me till the very end!","ja":"最後までつきおうてもらうで！","ko":"끝까지 저와 함께하도록 해요!","zh_hant":"你就陪我到最後一刻吧！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1513,"skill_field_effect_id":4,"_id_":2298,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2300":{"attribute_id":5,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1515,"skill_field_effect_id":0,"_id_":2300,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2301":{"attribute_id":5,"cost":2,"description":{"en":"Low damage & HP recovery down to all enemies.","ja":"敵全体に威力(小)の攻撃を行い、HP回復量ダウンを付与する","ko":"적 전체에게 위력(소) 공격, HP 회복량 감소를 부여","zh_hant":"對所有敵人發動威力（小）攻擊，並降低HP回復量"},"icon_id":65,"is_multiple_command_unique_skill":0,"name":{"en":"Cursed Slash","ja":"呪歌の斬撃","ko":"저주 노래의 참격","zh_hant":"咒歌斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1516,"skill_field_effect_id":0,"_id_":2301,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[40,42,44,47,50]},{"id":65,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"2302":{"attribute_id":5,"cost":3,"description":{"en":"High damage to front enemy. Normal Defense down to all enemies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、敵全体に通常防御力ダウンを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 일반 방어력 감소를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並降低所有敵人的普通防禦力"},"icon_id":11,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Slash","ja":"弛緩の斬撃","ko":"이완의 참격","zh_hant":"遲緩斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1517,"skill_field_effect_id":0,"_id_":2302,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":11,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]}]},"2303":{"attribute_id":5,"cost":2,"description":{"en":"HP recovery down & High damage to all enemies. Applies Stage Effect [We Are on the Stage (Space)] to allies' stage.","ja":"敵全体にHP回復量ダウンを付与し、威力(大)の攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（宙）」を付与する","ko":"적 전체에게 HP 회복량 감소를 부여, 위력(대) 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(우주)]를 부여","zh_hant":"降低所有敵人的HP回復量，並發動威力（大）攻擊，同時賦予我方的舞台舞台效果「我們已經站上舞台（宙）」"},"icon_id":1005,"is_multiple_command_unique_skill":0,"name":{"en":"I will dash forth with fighting spirit!","ja":"気合入れて、突っ走ります！","ko":"정신 바짝 차리고 달리겠습니다!","zh_hant":"拿出幹勁向前衝！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1518,"skill_field_effect_id":8,"_id_":2303,"skill_options":[{"id":65,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]}]},"2419":{"attribute_id":3,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Snipe","ja":"強撃","ko":"강격","zh_hant":"強擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1622,"skill_field_effect_id":0,"_id_":2419,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2420":{"attribute_id":3,"cost":3,"description":{"en":"High damage to front enemy. Damage Received down to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体に被ダメージダウンを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 받는 대미지 감소를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並降低所有我方受到的傷害"},"icon_id":114,"is_multiple_command_unique_skill":0,"name":{"en":"Blessed Strike","ja":"加護の一撃","ko":"가호의 일격","zh_hant":"加護一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1623,"skill_field_effect_id":0,"_id_":2420,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":126,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[10,12,14,17,20]}]},"2421":{"attribute_id":3,"cost":3,"description":{"en":"High damage to front enemy. Low Brilliance recovery to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体のキラめきを少し回復する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 반짝임을 조금 회복","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並回復所有我方少許的光芒"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Synchro Strike","ja":"呼応の一撃","ko":"호응의 일격","zh_hant":"呼應一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1624,"skill_field_effect_id":0,"_id_":2421,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,11,12,13,15]}]},"2422":{"attribute_id":3,"cost":2,"description":{"en":"Act Power up & Climax Act Power up to all allies. High damage to all enemies. Applies Stage Effect [We Are on the Stage (Snow)] to allies' stage.","ja":"味方全体にACTパワーアップ、クライマックスACT威力アップを付与し、敵全体に威力(大)の攻撃を行い、舞台の味方側に舞台効果「私たちはもう舞台の上（雪）」を付与する","ko":"아군 전체에게 ACT 파워 증가, 클라이맥스 ACT 위력 증가를 부여, 적 전체에게 위력(대) 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(눈)]을 부여","zh_hant":"提升所有我方的ACT力量、CLIMAX ACT威力，並對所有敵人發動威力（大）攻擊，同時賦予我方的舞台舞台效果「我們已經站上舞台（雪）」"},"icon_id":1003,"is_multiple_command_unique_skill":0,"name":{"en":"I'll take hold of a star of my own!","ja":"掴んでみせます、自分星！","ko":"붙잡아 보이겠습니다, 자신별!","zh_hant":"我會抓住，自己的星光！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1625,"skill_field_effect_id":5,"_id_":2422,"skill_options":[{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":40,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]}]},"2424":{"attribute_id":1,"cost":2,"description":{"en":"Medium+ damage to front 3 enemies.","ja":"前から3体の敵に威力(中+)の攻撃","ko":"앞에서 3명의 적에게 위력(중+) 공격","zh_hant":"對前方的3個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1627,"skill_field_effect_id":0,"_id_":2424,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"2425":{"attribute_id":1,"cost":3,"description":{"en":"High damage to front enemy. Agility down to all enemies.","ja":"前から1体の敵に威力(大)の攻撃を行い、敵全体にすばやさダウンを付与する","ko":"앞에서 1명의 적에게 위력(대) 공격, 적 전체에게 민첩 감소를 부여","zh_hant":"對前方的1個敵人發動威力（大）攻擊，並降低所有敵人的敏捷"},"icon_id":15,"is_multiple_command_unique_skill":0,"name":{"en":"Sluggish Smash","ja":"鈍重の打撃","ko":"둔중의 타격","zh_hant":"沉重敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1628,"skill_field_effect_id":0,"_id_":2425,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":15,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2426":{"attribute_id":1,"cost":3,"description":{"en":"High damage to front 3 enemies. Dexterity up & Critical up to 2 allies with the highest Act Power.","ja":"前から3体の敵に威力(大)の攻撃を行い、ACTパワーの高い味方2体にクリティカル率アップ、クリティカル威力アップを付与する","ko":"앞에서 3명의 적에게 위력(대) 공격, ACT 파워가 높은 아군 2명에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"對前方的3個敵人發動威力（大）攻擊，並提升ACT力量高的我方2名的會心率與會心威力"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1629,"skill_field_effect_id":0,"_id_":2426,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[97,102,106,111,116]},{"id":20,"hit_rate":100,"target_id":1127,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":22,"hit_rate":100,"target_id":1127,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2427":{"attribute_id":1,"cost":2,"description":{"en":"Very High damage & Accuracy Rate Down to all enemies. Fortitude 1 hit to all allies. Applies Stage Effect [We Are on the Stage (Flower)] to allies' stage.","ja":"敵全体に威力(大+)の攻撃を行い、命中率ダウンを付与し、味方全体に不屈を1付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（花）」を付与する","ko":"적 전체에게 위력(대+) 공격, 명중률 감소를 부여, 아군 전체에게 불굴 1회를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(꽃)]을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予命中率降低。同時賦予所有我方不屈1次，並賦予我方的舞台舞台效果「我們已經站上舞台（花）」"},"icon_id":1001,"is_multiple_command_unique_skill":0,"name":{"en":"I was the one...who was always by your side.","ja":"ずっとそばに居たのは……わたしなんだよ？","ko":"늘 곁에 있었던 사람은...나잖아?","zh_hant":"一直陪在你身邊的……可是我啊？"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1630,"skill_field_effect_id":3,"_id_":2427,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]},{"id":36,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2514":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1708,"skill_field_effect_id":0,"_id_":2514,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2515":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1709,"skill_field_effect_id":0,"_id_":2515,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2516":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1710,"skill_field_effect_id":0,"_id_":2516,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2517":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1711,"skill_field_effect_id":0,"_id_":2517,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2518":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 1 front enemies.","ja":"前から1体の敵に強力な多段攻撃","ko":"앞에서 1명의 적에게 강력한 다단 공격","zh_hant":"對前方的1個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poison Slash","ja":"猛斬撃","ko":"용맹한 참격","zh_hant":"猛斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1712,"skill_field_effect_id":0,"_id_":2518,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"2519":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1713,"skill_field_effect_id":0,"_id_":2519,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"2520":{"attribute_id":7,"cost":2,"description":{"en":"Low damage & Poison to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃し、毒を付与","ko":"앞에서 3명의 적에게 위력(소) 공격, 독을 부여","zh_hant":"對前方的3個敵人發動威力（小）攻擊，並造成中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Jack-o-Lantern Ripper NEO","ja":"ジャックオランタン・リッパー  NEO","ko":"잭오랜턴 리퍼 NEO","zh_hant":"傑克南瓜燈撕裂斬  NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1714,"skill_field_effect_id":0,"_id_":2520,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"2522":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1715,"skill_field_effect_id":0,"_id_":2522,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2523":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1716,"skill_field_effect_id":0,"_id_":2523,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2524":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1717,"skill_field_effect_id":0,"_id_":2524,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2525":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1718,"skill_field_effect_id":0,"_id_":2525,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2526":{"attribute_id":5,"cost":2,"description":{"en":"Set chance to inflict Burn to all enemies.","ja":"敵全体に確率で火傷を付与","ko":"적 전체에게 일정 확률로 화상을 부여","zh_hant":"機率性賦予所有敵人燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1719,"skill_field_effect_id":0,"_id_":2526,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"2527":{"attribute_id":5,"cost":2,"description":{"en":"Normal Barrier to self.","ja":"自身に通常バリア付与","ko":"자신에게 일반 배리어를 부여","zh_hant":"賦予自己普通防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1720,"skill_field_effect_id":0,"_id_":2527,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"2528":{"attribute_id":5,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1721,"skill_field_effect_id":0,"_id_":2528,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2529":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 1 front enemy.","ja":"自身に必中を付与し、前から1体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 앞에서 1명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pumpkin Trick NEO","ja":"パンプキントリック NEO","ko":"펌프킨 트릭 NEO","zh_hant":"南瓜戲法 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1722,"skill_field_effect_id":0,"_id_":2529,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2531":{"attribute_id":7,"cost":1,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1723,"skill_field_effect_id":0,"_id_":2531,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2532":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1724,"skill_field_effect_id":0,"_id_":2532,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2533":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1725,"skill_field_effect_id":0,"_id_":2533,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2534":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1726,"skill_field_effect_id":0,"_id_":2534,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2535":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1727,"skill_field_effect_id":0,"_id_":2535,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2536":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1728,"skill_field_effect_id":0,"_id_":2536,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2537":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 rear enemies.","ja":"後から3体の敵に多段攻撃","ko":"뒤에서 3명의 적에게 다단 공격","zh_hant":"對後方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1729,"skill_field_effect_id":0,"_id_":2537,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2538":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to 3 rear enemies.","ja":"後から3体の敵にACTパワーダウン付与","ko":"뒤에서 3명의 적에게 ACT 파워 감소를 부여","zh_hant":"降低後方3個敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1730,"skill_field_effect_id":0,"_id_":2538,"skill_options":[{"id":9,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2539":{"attribute_id":7,"cost":3,"description":{"en":"Multi-hit attack to 3 rear enemies.","ja":"後から3体の敵に多段攻撃","ko":"뒤에서 3명의 적에게 다단 공격","zh_hant":"對後方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bat Shrine NEO","ja":"コウモリおみこし NEO","ko":"박쥐 가마 NEO","zh_hant":"蝙蝠神轎 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1731,"skill_field_effect_id":0,"_id_":2539,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2541":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1732,"skill_field_effect_id":0,"_id_":2541,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2542":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1733,"skill_field_effect_id":0,"_id_":2542,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2543":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1734,"skill_field_effect_id":0,"_id_":2543,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2544":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1735,"skill_field_effect_id":0,"_id_":2544,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2545":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1736,"skill_field_effect_id":0,"_id_":2545,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2546":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1737,"skill_field_effect_id":0,"_id_":2546,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2547":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1738,"skill_field_effect_id":0,"_id_":2547,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2548":{"attribute_id":5,"cost":2,"description":{"en":"Set chance to inflict Poison & Blindness to all enemies.","ja":"敵全体に確率で毒と暗闇付与","ko":"적 전체에게 일정 확률로 독, 암흑을 부여","zh_hant":"機率性賦予所有敵人中毒和盲目"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Noxious Flower","ja":"暗闇の毒花","ko":"암흑의 독화","zh_hant":"黑暗毒花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1739,"skill_field_effect_id":0,"_id_":2548,"skill_options":[{"id":54,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[6000,6000,6000,6000,6000]},{"id":62,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"2549":{"attribute_id":5,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1740,"skill_field_effect_id":0,"_id_":2549,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"2550":{"attribute_id":5,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1741,"skill_field_effect_id":0,"_id_":2550,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2551":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪　NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪　NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1742,"skill_field_effect_id":0,"_id_":2551,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2553":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1743,"skill_field_effect_id":0,"_id_":2553,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2554":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1744,"skill_field_effect_id":0,"_id_":2554,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2555":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1745,"skill_field_effect_id":0,"_id_":2555,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2556":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1746,"skill_field_effect_id":0,"_id_":2556,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2557":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に強力な多段攻撃","ko":"앞에서 3명의 적에게 강력한 다단 공격","zh_hant":"對前方的3個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poison Triple Slash","ja":"猛参撃","ko":"용맹한 삼격","zh_hant":"猛參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1747,"skill_field_effect_id":0,"_id_":2557,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[140,140,140,140,140]}]},"2558":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1748,"skill_field_effect_id":0,"_id_":2558,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2559":{"attribute_id":7,"cost":2,"description":{"en":"Medium damage & Poison to all enemies.","ja":"敵全体に威力(中)で攻撃し、毒を付与","ko":"적 전체에게 위력(중) 공격, 독을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並造成中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Jack-o-Lantern Ripper NEO","ja":"ジャックオランタン・リッパー  NEO","ko":"잭오랜턴 리퍼 NEO","zh_hant":"傑克南瓜燈撕裂斬  NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1749,"skill_field_effect_id":0,"_id_":2559,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"2561":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1750,"skill_field_effect_id":0,"_id_":2561,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2562":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1751,"skill_field_effect_id":0,"_id_":2562,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2563":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1752,"skill_field_effect_id":0,"_id_":2563,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2564":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1753,"skill_field_effect_id":0,"_id_":2564,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2565":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 앞에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1754,"skill_field_effect_id":0,"_id_":2565,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2566":{"attribute_id":5,"cost":2,"description":{"en":"Burn to all enemies.","ja":"敵全体に火傷を付与","ko":"적 전체에게 화상을 부여","zh_hant":"賦予所有敵人燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1755,"skill_field_effect_id":0,"_id_":2566,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"2567":{"attribute_id":5,"cost":2,"description":{"en":"Normal Barrier to self.","ja":"自身に通常バリア付与","ko":"자신에게 일반 배리어를 부여","zh_hant":"賦予自己普通防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1756,"skill_field_effect_id":0,"_id_":2567,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"2568":{"attribute_id":5,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1757,"skill_field_effect_id":0,"_id_":2568,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2569":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 앞에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pumpkin Trick NEO","ja":"パンプキントリック NEO","ko":"펌프킨 트릭 NEO","zh_hant":"南瓜戲法 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1758,"skill_field_effect_id":0,"_id_":2569,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2571":{"attribute_id":7,"cost":1,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1759,"skill_field_effect_id":0,"_id_":2571,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2572":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1760,"skill_field_effect_id":0,"_id_":2572,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2573":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1761,"skill_field_effect_id":0,"_id_":2573,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2574":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1762,"skill_field_effect_id":0,"_id_":2574,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2575":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1763,"skill_field_effect_id":0,"_id_":2575,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2576":{"attribute_id":7,"cost":3,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1764,"skill_field_effect_id":0,"_id_":2576,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2577":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to all enemies.","ja":"敵全体に多段攻撃","ko":"적 전체에게 다단 공격","zh_hant":"對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1765,"skill_field_effect_id":0,"_id_":2577,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2578":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1766,"skill_field_effect_id":0,"_id_":2578,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2579":{"attribute_id":7,"cost":3,"description":{"en":"Multi-hit attack to all enemies.","ja":"敵全体に多段攻撃","ko":"적 전체에게 다단 공격","zh_hant":"對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bat Shrine NEO","ja":"コウモリおみこし NEO","ko":"박쥐 가마 NEO","zh_hant":"蝙蝠神轎 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1767,"skill_field_effect_id":0,"_id_":2579,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2581":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1768,"skill_field_effect_id":0,"_id_":2581,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2582":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1769,"skill_field_effect_id":0,"_id_":2582,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2583":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1770,"skill_field_effect_id":0,"_id_":2583,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2584":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1771,"skill_field_effect_id":0,"_id_":2584,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2585":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1772,"skill_field_effect_id":0,"_id_":2585,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2586":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1773,"skill_field_effect_id":0,"_id_":2586,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2587":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1774,"skill_field_effect_id":0,"_id_":2587,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2588":{"attribute_id":5,"cost":2,"description":{"en":"Poison & Blindness to all enemies.","ja":"敵全体に毒と暗闇付与","ko":"적 전체에게 독, 암흑을 부여","zh_hant":"賦予所有敵人中毒與盲目效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Noxious Flower","ja":"暗闇の毒花","ko":"암흑의 독화","zh_hant":"黑暗毒花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1775,"skill_field_effect_id":0,"_id_":2588,"skill_options":[{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[6000,6000,6000,6000,6000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"2589":{"attribute_id":5,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1776,"skill_field_effect_id":0,"_id_":2589,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2590":{"attribute_id":5,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1777,"skill_field_effect_id":0,"_id_":2590,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2591":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪　NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪　NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1778,"skill_field_effect_id":0,"_id_":2591,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2593":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1779,"skill_field_effect_id":0,"_id_":2593,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2594":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1780,"skill_field_effect_id":0,"_id_":2594,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2595":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1781,"skill_field_effect_id":0,"_id_":2595,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2596":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1782,"skill_field_effect_id":0,"_id_":2596,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2597":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poison Triple Slash","ja":"猛参撃","ko":"용맹한 삼격","zh_hant":"猛參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1783,"skill_field_effect_id":0,"_id_":2597,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2598":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1784,"skill_field_effect_id":0,"_id_":2598,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2599":{"attribute_id":7,"cost":2,"description":{"en":"High damage & Heavy Poison to all enemies.","ja":"敵全体に威力(大)で攻撃し、高威力の毒を付与","ko":"적 전체에게 위력(대) 공격, 높은 위력의 독을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並造成高威力的中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Jack-o-Lantern Ripper NEO","ja":"ジャックオランタン・リッパー  NEO","ko":"잭오랜턴 리퍼 NEO","zh_hant":"傑克南瓜燈撕裂斬  NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1785,"skill_field_effect_id":0,"_id_":2599,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"2601":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1786,"skill_field_effect_id":0,"_id_":2601,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2602":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1787,"skill_field_effect_id":0,"_id_":2602,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2603":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1788,"skill_field_effect_id":0,"_id_":2603,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2604":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1789,"skill_field_effect_id":0,"_id_":2604,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2605":{"attribute_id":5,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1790,"skill_field_effect_id":0,"_id_":2605,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2606":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1791,"skill_field_effect_id":0,"_id_":2606,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2607":{"attribute_id":5,"cost":2,"description":{"en":"Strong Burn to all enemies.","ja":"敵全体に高威力の火傷を付与","ko":"적 전체에게 높은 위력의 화상을 부여","zh_hant":"賦予所有敵人高威力的燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1792,"skill_field_effect_id":0,"_id_":2607,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"2608":{"attribute_id":5,"cost":2,"description":{"en":"Normal Barrier to self.","ja":"自身に通常バリア付与","ko":"자신에게 일반 배리어를 부여","zh_hant":"賦予自己普通防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1793,"skill_field_effect_id":0,"_id_":2608,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[12000,12000,12000,12000,12000]}]},"2609":{"attribute_id":5,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1794,"skill_field_effect_id":0,"_id_":2609,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2610":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pumpkin Trick NEO","ja":"パンプキントリック NEO","ko":"펌프킨 트릭 NEO","zh_hant":"南瓜戲法 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1795,"skill_field_effect_id":0,"_id_":2610,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2612":{"attribute_id":7,"cost":1,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1796,"skill_field_effect_id":0,"_id_":2612,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2613":{"attribute_id":7,"cost":1,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1797,"skill_field_effect_id":0,"_id_":2613,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2614":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1798,"skill_field_effect_id":0,"_id_":2614,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2615":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1799,"skill_field_effect_id":0,"_id_":2615,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2616":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1800,"skill_field_effect_id":0,"_id_":2616,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2617":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1801,"skill_field_effect_id":0,"_id_":2617,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2618":{"attribute_id":7,"cost":3,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1802,"skill_field_effect_id":0,"_id_":2618,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2619":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Concerto","ja":"連撃の協奏曲","ko":"연격의 협주곡","zh_hant":"連擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1803,"skill_field_effect_id":0,"_id_":2619,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2620":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1804,"skill_field_effect_id":0,"_id_":2620,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2621":{"attribute_id":7,"cost":3,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bat Shrine NEO","ja":"コウモリおみこし NEO","ko":"박쥐 가마 NEO","zh_hant":"蝙蝠神轎 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1805,"skill_field_effect_id":0,"_id_":2621,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2623":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1806,"skill_field_effect_id":0,"_id_":2623,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2624":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1807,"skill_field_effect_id":0,"_id_":2624,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2625":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1808,"skill_field_effect_id":0,"_id_":2625,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2626":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1809,"skill_field_effect_id":0,"_id_":2626,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2627":{"attribute_id":5,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1810,"skill_field_effect_id":0,"_id_":2627,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2628":{"attribute_id":5,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1811,"skill_field_effect_id":0,"_id_":2628,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2629":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1812,"skill_field_effect_id":0,"_id_":2629,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2630":{"attribute_id":5,"cost":2,"description":{"en":"Poison & Blindness to all enemies.","ja":"敵全体に毒と暗闇付与","ko":"적 전체에게 독, 암흑을 부여","zh_hant":"賦予所有敵人中毒與盲目效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Noxious Flower","ja":"暗闇の毒花","ko":"암흑의 독화","zh_hant":"黑暗毒花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1813,"skill_field_effect_id":0,"_id_":2630,"skill_options":[{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[6000,6000,6000,6000,6000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"2631":{"attribute_id":5,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1814,"skill_field_effect_id":0,"_id_":2631,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2632":{"attribute_id":5,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1815,"skill_field_effect_id":0,"_id_":2632,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2633":{"attribute_id":5,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪　NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪　NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1816,"skill_field_effect_id":0,"_id_":2633,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2659":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵を威力(小)で攻撃 自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1840,"skill_field_effect_id":0,"_id_":2659,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"2660":{"attribute_id":4,"cost":2,"description":{"en":"Medium damage to all enemies. Evasion x1 to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体に回避1回を付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 회피 1회를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並賦予所有我方迴避1次"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"Secluded Feelings","ja":"隠遁の思い","ko":"은둔하는 생각","zh_hant":"離群索居的回憶"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1841,"skill_field_effect_id":0,"_id_":2660,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":34,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2661":{"attribute_id":4,"cost":2,"description":{"en":"Medium damage & Agility down to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、すばやさダウンを付与する","ko":"적 전체에게 위력(중) 공격, 민첩 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並降低敏捷"},"icon_id":15,"is_multiple_command_unique_skill":0,"name":{"en":"Gentle Steps","ja":"ゆるやかな歩み","ko":"느릿한 걸음","zh_hant":"悠緩的步調"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1842,"skill_field_effect_id":0,"_id_":2661,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":15,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2662":{"attribute_id":4,"cost":2,"description":{"en":"Very high damage & Act Power down & Normal Defense down & Blindness (Unremovable) to all enemies.","ja":"敵全体に威力(大+)で攻撃し、ACTパワーダウン、通常防御力ダウン、解除不可の暗闇を付与する","ko":"적 전체에게 위력(대+) 공격, ACT 파워 감소, 일반 방어력 감소, 해제 불가능한 암흑을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，降低ACT力量、普通防禦力，並賦予無法解除的盲目"},"icon_id":62,"is_multiple_command_unique_skill":0,"name":{"en":"Reach the Abyss","ja":"そして隠者は深淵に至る","ko":"그리고 은자는 심연에 이르른다","zh_hant":"於是隱士終將抵達深淵"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1843,"skill_field_effect_id":0,"_id_":2662,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":302,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2696":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy. Normal Barrier to self.","ja":"前から1番目の敵を威力(小)で攻撃し、自身に通常バリアを付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신에게 일반 배리어를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予自身普通防護罩"},"icon_id":30,"is_multiple_command_unique_skill":0,"name":{"en":"Walled Slash","ja":"創壁の斬撃","ko":"창벽의 참격","zh_hant":"創壁斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1867,"skill_field_effect_id":0,"_id_":2696,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"2697":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim & Dexterity up to all allies. High damage to front enemy.","ja":"味方全体に必中、クリティカル率アップを付与し、前から1番目の敵に威力(大)で攻撃を行う","ko":"아군 전체에게 백발백중, 크리티컬 확률 증가를 부여, 앞에서 첫 번째 적에게 위력(대) 공격","zh_hant":"賦予所有我方必中並提升會心率，並對前面數來第1個敵人發動威力（大）攻擊"},"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Destruction Begins","ja":"破壊の始まり","ko":"파괴의 시작","zh_hant":"破壞之始"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1868,"skill_field_effect_id":0,"_id_":2697,"skill_options":[{"id":35,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"2698":{"attribute_id":2,"cost":3,"description":{"en":"Marked & Medium damage to all enemies.","ja":"敵全体に刻印を付与し、威力(中)で攻撃を行う","ko":"적 전체에게 각인을 부여, 위력(중) 공격","zh_hant":"賦予所有敵人刻印，並發動威力（中）攻擊"},"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Imminent Calamity","ja":"迫る災害","ko":"닥쳐오는 재해","zh_hant":"災害逼近"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1869,"skill_field_effect_id":0,"_id_":2698,"skill_options":[{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"2699":{"attribute_id":2,"cost":2,"description":{"en":"Very High damage to all enemies. Evasion x2 & Fortitude x1 to all allies.","ja":"敵全体に威力(大+)で攻撃を行い、味方全体に回避2回、不屈1回を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 전체에게 회피 2회, 불굴 1회를 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予所有我方迴避2次、不屈1次"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction","ja":"塔の断罪","ko":"탑의 단죄","zh_hant":"塔之定罪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1870,"skill_field_effect_id":0,"_id_":2699,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":34,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2701":{"attribute_id":4,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1890,"skill_field_effect_id":0,"_id_":2701,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2702":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 front enemies. Act Power up, Dexterity up to self.","ja":"前から3体の敵に威力(大)の攻撃を行い、自身にACTパワーアップ、クリティカル率アップを付与する","ko":"앞에서 3명의 적에게 위력(대) 공격, 자신에게 ACT 파워 증가, 크리티컬 확률 증가를 부여","zh_hant":"對前面3個敵人發動威力（大）攻擊，並提升自己的ACT力量、會心率"},"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Mysterious Slash","ja":"神気の斬撃","ko":"신기의 참격","zh_hant":"神氣斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1891,"skill_field_effect_id":0,"_id_":2702,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[97,102,106,111,116]},{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2703":{"attribute_id":4,"cost":3,"description":{"en":"High damage to front enemy. Removes Cont. Negative Effects from all allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Slash","ja":"浄化の斬撃","ko":"정화의 참격","zh_hant":"淨化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1892,"skill_field_effect_id":0,"_id_":2703,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2704":{"attribute_id":4,"cost":2,"description":{"en":"Set damage to 3 front enemies. If enemy's HP reaches 0 or below, they will Exit. Applies Stage Effect [We Are on the Stage (Moon)] to allies' stage.","ja":"前から3体の敵に固定値ダメージを与え、舞台の味方側に舞台効果「私たちはもう舞台の上（月）」を付与する この攻撃で敵のHPが0以下になった場合、退場させる","ko":"앞에서 3명의 적에게 적의 HP가 0 이하가 되면 퇴장시키는 고정 대미지 공격, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(달)]을 부여","zh_hant":"對前方的3個敵人發動固定傷害攻擊，並賦予我方的舞台舞台效果「我們已經站上舞台（月）」 當敵人受到此攻擊後HP降到0以下時將退場"},"icon_id":1004,"is_multiple_command_unique_skill":0,"name":{"en":"Tonight, I will show you my brilliance!","ja":"今宵、煌めきを、あなたに！","ko":"오늘 밤, 반짝임을 당신에게!","zh_hant":"今晚將閃耀獻給你！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1893,"skill_field_effect_id":7,"_id_":2704,"skill_options":[{"id":322,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[5000,5500,6000,6500,7500]}]},"2775":{"attribute_id":6,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1927,"skill_field_effect_id":0,"_id_":2775,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"2776":{"attribute_id":6,"cost":2,"description":{"en":"Normal Barrier & Special Barrier & AP Down to all allies.","ja":"味方全体に通常バリア、特殊バリア、AP減少を付与する","ko":"아군 전체에게 일반 배리어, 특수 배리어, AP 감소를 부여","zh_hant":"賦予所有我方普通防護罩、特殊防護罩及AP減少效果"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Bestowal","ja":"堅守の附与","ko":"굳은 수호의 부여","zh_hant":"堅守恩賜"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1928,"skill_field_effect_id":0,"_id_":2776,"skill_options":[{"id":30,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2777":{"attribute_id":6,"cost":1,"description":{"en":"Aggro to all enemies. Evasion Rate Up & Dmg Received down to self.","ja":"敵全体にターゲット固定を付与し、自身に回避率アップと被ダメージダウンを付与する","ko":"적 전체에게 타깃 고정을 부여, 자신에게 회피 확률 증가와 받는 대미지 감소를 부여","zh_hant":"賦予所有敵人目標鎖定，並提升自己的迴避率與降低自己受到的傷害"},"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Whole Protection","ja":"全土の庇護","ko":"전토의 비호","zh_hant":"全境庇護"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1929,"skill_field_effect_id":0,"_id_":2777,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,32,35,40,50]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"2778":{"attribute_id":6,"cost":2,"description":{"en":"Flip Negative Effects x3 to all allies. Flip Positive Effects x3 & High damage to all enemies.","ja":"味方全体に3回分のマイナス効果反転、敵全体に3回分のプラス効果反転を適用し、威力(大)で攻撃を行う","ko":"아군 전체에 3회분의 마이너스 효과 반전, 적 전체에 3회분의 플러스 효과 반전을 적용하고 위력(대) 공격","zh_hant":"對所有我方施加3次負面狀態效果反轉，且對所有敵人施加3次正面狀態效果反轉，並發動威力（大）攻擊"},"icon_id":151,"is_multiple_command_unique_skill":0,"name":{"en":"Empress's Gloom","ja":"女帝陛下の憂鬱","ko":"여제 폐하의 우울","zh_hant":"女帝陛下的憂鬱"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1930,"skill_field_effect_id":0,"_id_":2778,"skill_options":[{"id":151,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":323,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]}]},"2785":{"attribute_id":6,"cost":2,"description":{"en":"Low damage & Mark to front enemy.","ja":"前から1番目の敵に威力(小)で攻撃を行い、刻印を付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 각인을 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予刻印"},"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Marked Slash","ja":"刻印の斬撃","ko":"각인의 참격","zh_hant":"刻印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1937,"skill_field_effect_id":0,"_id_":2785,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":150,"hit_rate":100,"target_id":2011,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"2786":{"attribute_id":6,"cost":2,"description":{"en":"Medium damage to front enemy. Removes Cont. Negative Effects from 3 front allies.","ja":"前から1番目の敵に威力(中)で攻撃を行い、前から3体の味方の継続マイナス効果を解除する","ko":"앞에서 첫 번째 적에게 위력(중) 공격, 앞에서 3명의 아군의 지속 마이너스 효과를 해제","zh_hant":"對前面數來第1個敵方發動威力（中）攻擊，並解除前面3名我方的持續性負面效果"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Flash","ja":"浄化の一閃","ko":"정화의 일섬","zh_hant":"淨化閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1938,"skill_field_effect_id":0,"_id_":2786,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":128,"hit_rate":100,"target_id":1133,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2787":{"attribute_id":6,"cost":2,"description":{"en":"Medium damage to front enemy. Low Brilliance recovery to all allies.","ja":"前から1番目の敵に威力(中)で攻撃を行い、味方全体のキラめきを少し回復する","ko":"앞에서 첫 번째 적에게 위력(중) 공격, 아군 전체의 반짝임을 조금 회복","zh_hant":"對前面數來第1個敵人發動威力（中）攻擊，並回復所有我方少許的光芒"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Synchro of Brilliance","ja":"キラめきの呼応","ko":"반짝임의 호응","zh_hant":"光芒呼應"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1939,"skill_field_effect_id":0,"_id_":2787,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,11,12,13,15]}]},"2788":{"attribute_id":6,"cost":1,"description":{"en":"Removes Cont. Positive Effects & Extremely High damage to front enemy. Reflect Normal Damage & Reflect Special Damage to all allies. Applies Stage Effect [We Are on the Stage (Cloud)] to allies' stage.","ja":"前から1番目の敵の継続プラス効果を解除し、威力(特大)で攻撃を行い、味方全体に通常ダメージ反射、特殊ダメージ反射を付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（雲）」を付与する","ko":"앞에서 첫 번째 적의 지속 플러스 효과를 해제하고 위력(특대) 공격, 아군 전체에게 일반 대미지 반사, 특수 대미지 반사를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(구름)]을 부여","zh_hant":"解除前面數來第1個敵人的持續性正面效果，並發動威力（特大）攻擊。同時賦予所有我方反射普通傷害、反射特殊傷害，並賦予我方的舞台舞台效果「我們已經站上舞台（雲）」"},"icon_id":1006,"is_multiple_command_unique_skill":0,"name":{"en":"C'est moi! la star!","ja":"C'est moi！la star！","ko":"C'est moi! la star!","zh_hant":"C'est moi！la star！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1940,"skill_field_effect_id":9,"_id_":2788,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[350,370,390,420,450]},{"id":32,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]},{"id":33,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]}]},"2795":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1947,"skill_field_effect_id":0,"_id_":2795,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2796":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1948,"skill_field_effect_id":0,"_id_":2796,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2797":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Double Smash","ja":"双打撃","ko":"쌍타격","zh_hant":"雙敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1949,"skill_field_effect_id":0,"_id_":2797,"skill_options":[{"id":1,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2798":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Double Smash","ja":"強双打撃","ko":"강한 쌍타격","zh_hant":"強雙敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1950,"skill_field_effect_id":0,"_id_":2798,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2799":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1951,"skill_field_effect_id":0,"_id_":2799,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2800":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参連打撃","ko":"삼연타격","zh_hant":"參連敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1952,"skill_field_effect_id":0,"_id_":2800,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2801":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to 3 front enemies.","ja":"前から3体の敵にACTパワーダウン付与","ko":"앞에서 3명의 적에게 ACT 파워 감소를 부여","zh_hant":"降低前方3個敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1953,"skill_field_effect_id":0,"_id_":2801,"skill_options":[{"id":9,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2802":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1954,"skill_field_effect_id":0,"_id_":2802,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2803":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Present for You NEO","ja":"プレゼント・フォー・ユー NEO","ko":"너를 위한 선물 NEO","zh_hant":"好禮相送 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1955,"skill_field_effect_id":0,"_id_":2803,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2805":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1956,"skill_field_effect_id":0,"_id_":2805,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2806":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1957,"skill_field_effect_id":0,"_id_":2806,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2807":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1958,"skill_field_effect_id":0,"_id_":2807,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2808":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1959,"skill_field_effect_id":0,"_id_":2808,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2809":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1960,"skill_field_effect_id":0,"_id_":2809,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"2810":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 1 rear enemy.","ja":"自身に必中を付与し、後から1体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1961,"skill_field_effect_id":0,"_id_":2810,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"2811":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1962,"skill_field_effect_id":0,"_id_":2811,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2812":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1963,"skill_field_effect_id":0,"_id_":2812,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"2813":{"attribute_id":4,"cost":2,"description":{"en":"High damage & Confusion to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、混乱を付与","ko":"뒤에서부터 3명의 적에게 위력(대) 공격, 혼란을 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dreaming Bell NEO","ja":"夢見るベル NEO","ko":"꿈꾸는 벨 NEO","zh_hant":"夢境鈴聲 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1964,"skill_field_effect_id":0,"_id_":2813,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2815":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1965,"skill_field_effect_id":0,"_id_":2815,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2816":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1966,"skill_field_effect_id":0,"_id_":2816,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2817":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1967,"skill_field_effect_id":0,"_id_":2817,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2818":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1968,"skill_field_effect_id":0,"_id_":2818,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2819":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to 1 front enemy.","ja":"自身に必中を付与し、前から1体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 1명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對前方的1個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1969,"skill_field_effect_id":0,"_id_":2819,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"2820":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1970,"skill_field_effect_id":0,"_id_":2820,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2821":{"attribute_id":7,"cost":2,"description":{"en":"AP Up to 3 front enemies.","ja":"前から3体の敵にAP増加を付与","ko":"앞에서 3명의 적에게 AP 증가를 부여","zh_hant":"賦予前方的3個敵人AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blast off, Dai-Banana! NEO","ja":"大バナナ号、発進！ NEO","ko":"대 바나나 호, 발진! NEO","zh_hant":"大BANANA號，前進！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1971,"skill_field_effect_id":0,"_id_":2821,"skill_options":[{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2823":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":2823,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2824":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":2824,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2825":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":2825,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2826":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":2826,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2827":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":2827,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2828":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":2828,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2829":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":2829,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"2830":{"attribute_id":4,"cost":2,"description":{"en":"Set chance to inflict Burn & Stun to all enemies.","ja":"敵全体に確率で火傷とスタンを付与","ko":"적 전체에게 일정 확률로 화상과 스턴을 부여","zh_hant":"機率性賦予所有敵人燒傷與暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":2830,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2831":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":2831,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2832":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies. Reflect Normal Damage to self.","ja":"後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":2832,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"2833":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies. Reflect Normal Damage to self.","ja":"後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":2833,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"2835":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1983,"skill_field_effect_id":0,"_id_":2835,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2836":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1984,"skill_field_effect_id":0,"_id_":2836,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2837":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Double Smash","ja":"双打撃","ko":"쌍타격","zh_hant":"雙敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1985,"skill_field_effect_id":0,"_id_":2837,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2838":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Double Smash","ja":"強双打撃","ko":"강한 쌍타격","zh_hant":"強雙敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1986,"skill_field_effect_id":0,"_id_":2838,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2839":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1987,"skill_field_effect_id":0,"_id_":2839,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2840":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参連打撃","ko":"삼연타격","zh_hant":"參連敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1988,"skill_field_effect_id":0,"_id_":2840,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2841":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1989,"skill_field_effect_id":0,"_id_":2841,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2842":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1990,"skill_field_effect_id":0,"_id_":2842,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2843":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Present for You NEO","ja":"プレゼント・フォー・ユー NEO","ko":"너를 위한 선물 NEO","zh_hant":"好禮相送 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1991,"skill_field_effect_id":0,"_id_":2843,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2845":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1992,"skill_field_effect_id":0,"_id_":2845,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2846":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1993,"skill_field_effect_id":0,"_id_":2846,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2847":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1994,"skill_field_effect_id":0,"_id_":2847,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2848":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1995,"skill_field_effect_id":0,"_id_":2848,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2849":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1996,"skill_field_effect_id":0,"_id_":2849,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2850":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1997,"skill_field_effect_id":0,"_id_":2850,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2851":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1998,"skill_field_effect_id":0,"_id_":2851,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"2852":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1999,"skill_field_effect_id":0,"_id_":2852,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2853":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2000,"skill_field_effect_id":0,"_id_":2853,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2854":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2001,"skill_field_effect_id":0,"_id_":2854,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2855":{"attribute_id":4,"cost":2,"description":{"en":"High damage & chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で混乱を付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dreaming Bell NEO","ja":"夢見るベル NEO","ko":"꿈꾸는 벨 NEO","zh_hant":"夢境鈴聲 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2002,"skill_field_effect_id":0,"_id_":2855,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2857":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2003,"skill_field_effect_id":0,"_id_":2857,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2858":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2004,"skill_field_effect_id":0,"_id_":2858,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2859":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2005,"skill_field_effect_id":0,"_id_":2859,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2860":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2006,"skill_field_effect_id":0,"_id_":2860,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2861":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 앞에서 3명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2007,"skill_field_effect_id":0,"_id_":2861,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2862":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2008,"skill_field_effect_id":0,"_id_":2862,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2863":{"attribute_id":7,"cost":2,"description":{"en":"High damage & AP Up to all enemies.","ja":"敵全体に威力(大)で攻撃し、AP増加を付与","ko":"적 전체에게 위력(대) 공격, AP 증가를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blast off, Dai-Banana! NEO","ja":"大バナナ号、発進！ NEO","ko":"대 바나나 호, 발진! NEO","zh_hant":"大BANANA號，前進！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2009,"skill_field_effect_id":0,"_id_":2863,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2865":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":2865,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2866":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":2866,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2867":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":2867,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2868":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":2868,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2869":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":2869,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2870":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":2870,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2871":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":2871,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"2872":{"attribute_id":4,"cost":2,"description":{"en":"Burn & Stun to all enemies.","ja":"敵全体に火傷とスタン付与","ko":"적 전체에게 화상과 스턴을 부여","zh_hant":"賦予所有敵人燒傷與暈眩效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":2872,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2873":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":2873,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2874":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies. Reflect Normal Damage to self.","ja":"敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":2874,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"2875":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies. Reflect Normal Damage to self.","ja":"敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":2875,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"2877":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2021,"skill_field_effect_id":0,"_id_":2877,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2878":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2022,"skill_field_effect_id":0,"_id_":2878,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2879":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Double Smash","ja":"強双打撃","ko":"강한 쌍타격","zh_hant":"強雙敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2023,"skill_field_effect_id":0,"_id_":2879,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2880":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2024,"skill_field_effect_id":0,"_id_":2880,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2881":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2025,"skill_field_effect_id":0,"_id_":2881,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2882":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2026,"skill_field_effect_id":0,"_id_":2882,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2883":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2027,"skill_field_effect_id":0,"_id_":2883,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2884":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 필중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2028,"skill_field_effect_id":0,"_id_":2884,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2885":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 필중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Present for You NEO","ja":"プレゼント・フォー・ユー NEO","ko":"너를 위한 선물 NEO","zh_hant":"好禮相送 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2029,"skill_field_effect_id":0,"_id_":2885,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2887":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2030,"skill_field_effect_id":0,"_id_":2887,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2888":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2031,"skill_field_effect_id":0,"_id_":2888,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2889":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2032,"skill_field_effect_id":0,"_id_":2889,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2890":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2033,"skill_field_effect_id":0,"_id_":2890,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2891":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2034,"skill_field_effect_id":0,"_id_":2891,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2892":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2035,"skill_field_effect_id":0,"_id_":2892,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"2893":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2036,"skill_field_effect_id":0,"_id_":2893,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2894":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2037,"skill_field_effect_id":0,"_id_":2894,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"2895":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2038,"skill_field_effect_id":0,"_id_":2895,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2896":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2039,"skill_field_effect_id":0,"_id_":2896,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2897":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dreaming Bell NEO","ja":"夢見るベル NEO","ko":"꿈꾸는 벨 NEO","zh_hant":"夢境鈴聲 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2040,"skill_field_effect_id":0,"_id_":2897,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2899":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2041,"skill_field_effect_id":0,"_id_":2899,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2900":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2042,"skill_field_effect_id":0,"_id_":2900,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2901":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2043,"skill_field_effect_id":0,"_id_":2901,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2902":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2044,"skill_field_effect_id":0,"_id_":2902,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2903":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 필중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2045,"skill_field_effect_id":0,"_id_":2903,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"2904":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2046,"skill_field_effect_id":0,"_id_":2904,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2905":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2047,"skill_field_effect_id":0,"_id_":2905,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2906":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & AP Up to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、AP増加を付与","ko":"적 전체에게 강력한 다단 공격, AP 증가를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2048,"skill_field_effect_id":0,"_id_":2906,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2907":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & AP Up to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、AP増加を付与","ko":"적 전체에게 강력한 다단 공격, AP 증가를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blast off, Dai-Banana! NEO","ja":"大バナナ号、発進！ NEO","ko":"대 바나나 호, 발진! NEO","zh_hant":"大BANANA號，前進！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2049,"skill_field_effect_id":0,"_id_":2907,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2909":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":2909,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2910":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":2910,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"2911":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":2911,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"2912":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":2912,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"2913":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":2913,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"2914":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":2914,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"2915":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":2915,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"2916":{"attribute_id":4,"cost":2,"description":{"en":"Strong Burn & Stun to all enemies.","ja":"敵全体に高威力の火傷とスタン付与","ko":"적 전체에게 높은 위력의 화상과 스턴을 부여","zh_hant":"賦予所有敵人高威力的燒傷與暈眩效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":2916,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2917":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":2917,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"2918":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.","ja":"敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":2918,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"2919":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.","ja":"敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":2919,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"2928":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy. Agility up to all allies.","ja":"前から1番目の敵に威力(小)で攻撃を行い、味方全体にすばやさアップを付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 아군 전체에게 민첩 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並提升所有我方的敏捷"},"icon_id":14,"is_multiple_command_unique_skill":0,"name":{"en":"Quick Slash","ja":"俊速の斬撃","ko":"신속의 참격","zh_hant":"神速斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2061,"skill_field_effect_id":0,"_id_":2928,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"2929":{"attribute_id":5,"cost":1,"description":{"en":"Cont. Negative Effects Resistance to front 3 allies.","ja":"前から3体の味方に継続マイナス効果耐性を付与する","ko":"앞에서 3명의 아군에게 지속 마이너스 효과 저항을 부여","zh_hant":"賦予前面3名我方持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Sacred Song","ja":"聖域の歌","ko":"성역의 노래","zh_hant":"聖域之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2062,"skill_field_effect_id":0,"_id_":2929,"skill_options":[{"id":26,"hit_rate":100,"target_id":1133,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"2930":{"attribute_id":5,"cost":3,"description":{"en":"Medium damage & chance at Stun to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、一定確率でスタンを付与する","ko":"적 전체에게 위력(중) 공격, 일정 확률로 스턴을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並在一定機率下賦予暈眩"},"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Concerto","ja":"抑止の協奏曲","ko":"억제의 협주곡","zh_hant":"抑止協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2063,"skill_field_effect_id":0,"_id_":2930,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2931":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim & Act Power up to self. Removes Cont. Negative Effects from all allies. Very High damage to all enemies (counts as Dream & extra damage to normal-type enemies). Applies [Concentration (Space)].","ja":"自身に必中とACTパワーアップを付与、味方全体の継続マイナス効果を解除し、敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「本日も集中あるのみ（宙）」を付与する　この攻撃は夢属性の攻撃として扱い、通常タイプの敵に対して特攻","ko":"자신에게 백발백중과 ACT 파워 증가를 부여, 아군 전체의 지속 마이너스 효과를 해제, 적 전체에게 위력(대+) 공격, 적 쪽 무대에 무대 효과 [오늘도 집중할 뿐(우주)]을 부여, 이 공격은 꿈 속성으로 적용되며 일반 타입 적에게 특수 공격","zh_hant":"賦予自己必中並提升自己的ACT力量，解除所有我方的持續性負面效果，對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「今天也要全神貫注（宙）」 此攻擊為夢屬性，會對普通類型的敵方造成特攻效果"},"icon_id":1014,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Fire","ja":"ひしめく鼓動は青の炎","ko":"술렁이는 고동은 푸른 불꽃","zh_hant":"群起鼓動的湛藍之火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2064,"skill_field_effect_id":19,"_id_":2931,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":306,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[125,135,145,155,170]}]},"2968":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy. Evasion x1 to 3 front allies.","ja":"前から1番目の敵に威力(小)で攻撃を行い、前から3体の味方に回避を1回付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 앞에서 3명의 아군에게 회피 1회를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予前面3名我方迴避1次"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Slash","ja":"回避の斬撃","ko":"회피의 참격","zh_hant":"迴避斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2092,"skill_field_effect_id":0,"_id_":2968,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":34,"hit_rate":100,"target_id":1133,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2969":{"attribute_id":2,"cost":2,"description":{"en":"Low damage & AP Up to 3 front enemies.","ja":"前から3体の敵に威力(小)の攻撃を行い、AP増加を付与する","ko":"앞에서 3명의 적에게 위력(소) 공격, AP 증가를 부여","zh_hant":"對前面的3個敵人發動威力（小）攻擊，並賦予AP增加效果"},"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Rondo","ja":"重圧の輪舞曲","ko":"중압의 윤무곡","zh_hant":"重壓圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2093,"skill_field_effect_id":0,"_id_":2969,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"2970":{"attribute_id":2,"cost":2,"description":{"en":"Low Brilliance recovery & Absorb to all allies.","ja":"味方全体のキラめきを少し回復し、吸収を付与する","ko":"아군 전체의 반짝임을 조금 회복, 흡수를 부여","zh_hant":"回復所有我方少許的光芒，並賦予吸收效果"},"icon_id":44,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Dance","ja":"吸収の舞","ko":"흡수의 춤","zh_hant":"吸收之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2094,"skill_field_effect_id":0,"_id_":2970,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,11,12,13,15]},{"id":44,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,23,26,29,33]}]},"2971":{"attribute_id":7,"cost":2,"description":{"en":"Very High damage (counts as Dream & extra damage to enemies inflicted with Burn) & high chance at Stop to 3 front enemies. Applies [Concentration (Wind)].","ja":"前から3体の敵に威力(大+)で攻撃を行い、高確率でストップを付与し、舞台の敵側に舞台効果「本日も集中あるのみ（風）」を付与する　この攻撃は夢属性の攻撃として扱い、火傷状態の敵に対して特攻","ko":"앞에서 3명의 적에게 위력(대+) 공격, 높은 확률로 스톱을 부여, 적 쪽 무대에 무대 효과 [오늘도 집중할 뿐(바람)]을 부여, 이 공격은 꿈 속성 공격으로 적용되며 화상 상태의 적에게 특수 공격","zh_hant":"對前面的3個敵人發動威力（大+）攻擊，並以高機率造成停止，同時賦予敵方的舞台舞台效果「今天也要全神貫注（風）」 此攻擊為夢屬性，會對燒傷狀態的敵方造成特攻效果"},"icon_id":1015,"is_multiple_command_unique_skill":0,"name":{"en":"Dawn Storm","ja":"吹き荒れる風は暁の印","ko":"거친 바람은 새벽의 증거","zh_hant":"呼嘯狂風為黎明之徵"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2095,"skill_field_effect_id":20,"_id_":2971,"skill_options":[{"id":277,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[170,175,180,185,200]},{"id":60,"hit_rate":75,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2973":{"attribute_id":3,"cost":1,"description":{"en":"Aggro removal & Aggro immunity to all allies.","ja":"味方全体のターゲット固定を解除し、ターゲット固定無効を付与する","ko":"아군 전체의 타깃 고정을 해제, 타깃 고정 무효를 부여","zh_hant":"解除所有我方的目標鎖定，並賦予目標鎖定無效"},"icon_id":153,"is_multiple_command_unique_skill":0,"name":{"en":"Target Immunity","ja":"標的無効","ko":"표적 무효","zh_hant":"目標無效"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2098,"skill_field_effect_id":0,"_id_":2973,"skill_options":[{"id":154,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":153,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"2974":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy. Counter Heal to 3 rear allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、後ろから3体の味方にカウンターヒールを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 카운터 힐을 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並賦予後面3名我方還擊治療"},"icon_id":45,"is_multiple_command_unique_skill":0,"name":{"en":"Song of Healing","ja":"癒しの歌","ko":"치유의 노래","zh_hant":"治癒之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2099,"skill_field_effect_id":0,"_id_":2974,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":241,"hit_rate":100,"target_id":1143,"times":[1,1,1,1,1],"values":[5,6,7,8,10]}]},"2975":{"attribute_id":3,"cost":3,"description":{"en":"Low damage to front enemy. Fortitude 1 hit to all allies.","ja":"前から1番目の敵に威力(小)で攻撃を行い、味方全体に不屈を1回付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 아군 전체에게 불굴 1회를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予所有我方不屈1次"},"icon_id":36,"is_multiple_command_unique_skill":0,"name":{"en":"Fortitude Concerto","ja":"不屈の協奏曲","ko":"불굴의 협주곡","zh_hant":"不屈協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2100,"skill_field_effect_id":0,"_id_":2975,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":36,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"2976":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity up & Critical up to self. High damage to all enemies (counts as Dream & extra damage to enemies inflicted with Poison). Applies [Concentration (Snow)].","ja":"自身にクリティカル率アップとクリティカル威力アップを付与し、敵全体に威力(大)で攻撃を行い、舞台の敵側に舞台効果「本日も集中あるのみ（雪）」を付与する　この攻撃は夢属性の攻撃として扱い、毒状態の敵に対して特攻","ko":"자신에게 크리티컬 확률 증가와 크리티컬 위력 증가를 부여, 적 전체에게 위력(대) 공격, 적 쪽 무대에 무대 효과 [오늘도 집중할 뿐(눈)]을 부여, 이 공격은 꿈 속성으로 적용되며 독 상태의 적에게 특수 공격","zh_hant":"提升自己的會心率及會心威力，對所有敵人發動威力（大）攻擊，並賦予敵方的舞台舞台效果「今天也要全神貫注（雪）」 此攻擊為夢屬性，會對中毒的敵方造成特攻效果"},"icon_id":1016,"is_multiple_command_unique_skill":0,"name":{"en":"Let It Rain","ja":"ハジマリの雨を降らせましょう","ko":"시작의 비를 내리게 해요","zh_hant":"降下起始之雨吧"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2101,"skill_field_effect_id":21,"_id_":2976,"skill_options":[{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":276,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,105,110,115,120]}]},"3005":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Brilliance","ja":"キラめきの一撃","ko":"반짝임의 일격","zh_hant":"光芒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2119,"skill_field_effect_id":0,"_id_":3005,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3006":{"attribute_id":1,"cost":2,"description":{"en":"High damage to front enemy. Removes Cont. Positive Effects to all enemies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果を解除する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과를 해제","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Purity of Wisdom","ja":"英知の浄化","ko":"영지의 정화","zh_hant":"睿智的淨化"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2120,"skill_field_effect_id":0,"_id_":3006,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3007":{"attribute_id":1,"cost":2,"description":{"en":"Medium damage to all enemies. Agility up to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体にすばやさアップを付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 민첩 증가를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並提升所有我方的敏捷"},"icon_id":14,"is_multiple_command_unique_skill":0,"name":{"en":"Rapid Pace","ja":"迅速な歩み","ko":"신속한 걸음","zh_hant":"迅速的步調"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2121,"skill_field_effect_id":0,"_id_":3007,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3008":{"attribute_id":1,"cost":2,"description":{"en":"Very high damage & Strong Poison (Unremovable) to all enemies. Act Power up & Normal Defense up to all allies.","ja":"敵全体に威力(大+)で攻撃し、解除不可の猛毒を付与し、味方全体にACTパワーアップと通常防御力アップを付与する","ko":"적 전체에게 위력(대+) 공격, 해제 불가능한 맹독을 부여, 아군 전체에게 ACT 파워 증가와 일반 방어력 증가를 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，賦予無法解除的猛毒，並提升所有我方的ACT力量、普通防禦力"},"icon_id":54,"is_multiple_command_unique_skill":0,"name":{"en":"High Judgement","ja":"女教皇はかく裁けり","ko":"여교황은 이렇게 판결했노라","zh_hant":"女教皇如此裁斷"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2122,"skill_field_effect_id":0,"_id_":3008,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":303,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[6,8,10,12,15]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":10,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]}]},"3011":{"attribute_id":1,"cost":2,"description":{"en":"Medium+ damage to rear enemy.","ja":"後ろから1番目の敵に威力(中+)の攻撃","ko":"뒤에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對後面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ardent Slash","ja":"烈斬撃","ko":"열참격","zh_hant":"烈焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2125,"skill_field_effect_id":0,"_id_":3011,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3012":{"attribute_id":1,"cost":2,"description":{"en":"Act Power up & Dexterity up to self. Medium damage to rear enemy.","ja":"自身にACTパワーアップ、クリティカル率アップを付与し、後ろから1番目の敵に威力(中)の攻撃を行う","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가를 부여, 뒤에서 첫 번째 적에게 위력(중) 공격","zh_hant":"提升自己的ACT力量、會心率，並對後面數來第1個敵人發動威力（中）攻擊"},"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Shogun's Stance","ja":"武将の構え","ko":"무장의 자세","zh_hant":"武將的架式"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2126,"skill_field_effect_id":0,"_id_":3012,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"3013":{"attribute_id":1,"cost":2,"description":{"en":"Reflect Normal Damage & Reflect Special Damage to self. High damage to rear enemy.","ja":"自身に通常ダメージ反射と特殊ダメージ反射を付与し、後ろから1番目の敵に威力(大)の攻撃を行う","ko":"자신에게 일반 대미지 반사와 특수 대미지 반사를 부여, 뒤에서 첫 번째 적에게 위력(대) 공격","zh_hant":"賦予自己反射普通傷害與反射特殊傷害，並對後面數來第1個敵人發動威力（大）攻擊"},"icon_id":32,"is_multiple_command_unique_skill":0,"name":{"en":"Nobunaga's Attack","ja":"信長の応戦","ko":"노부나가의 응전","zh_hant":"信長的應戰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2127,"skill_field_effect_id":0,"_id_":3013,"skill_options":[{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"3014":{"attribute_id":1,"cost":2,"description":{"en":"Very High damage to all enemies. Resilience & Fortitude x1 to all allies.","ja":"敵全体に威力(大+)で攻撃を行い、味方全体に不倒と不屈1回を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 전체에게 불멸과 불굴 1회를 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予所有我方不倒與不屈1次"},"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Tenma Hell","ja":"天魔の獄炎","ko":"천마의 옥염","zh_hant":"天魔的煉獄之火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2128,"skill_field_effect_id":0,"_id_":3014,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":299,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3016":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2130,"skill_field_effect_id":0,"_id_":3016,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3017":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim to self. High damage to front enemy.","ja":"自身に必中を付与し、前から1番目の敵に威力(大)で攻撃を行う","ko":"자신에게 백발백중을 부여, 앞에서 첫 번째 적에게 위력(대) 공격","zh_hant":"賦予自己必中，並對前面數來第1個敵人發動威力（大）攻擊"},"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Bull's Eye","ja":"ブルズアイ","ko":"불스아이","zh_hant":"正中紅心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2131,"skill_field_effect_id":0,"_id_":3017,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"3018":{"attribute_id":2,"cost":3,"description":{"en":"High damage to front enemy. Cont. Negative Effects Resistance & Special Barrier to all allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、味方全体に継続マイナス効果耐性と特殊バリアを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 지속 마이너스 효과 저항과 특수 배리어를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並賦予所有我方持續性負面效果耐性與特殊防護罩"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Miser's Safe","ja":"守銭奴の金庫","ko":"수전노의 금고","zh_hant":"守財奴的金庫"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2132,"skill_field_effect_id":0,"_id_":3018,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"3019":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies & chance to inflict Stun & Stop.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃を行い、一定確率でスタンとストップを付与する","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격, 일정 확률로 스턴과 스톱을 부여","zh_hant":"賦予自己必中，對所有敵人發動威力（大）攻擊，並以一定機率造成暈眩和停止"},"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"Western Lasso","ja":"ウェスタン・ロープ・アクション","ko":"웨스턴 로프 액션","zh_hant":"西部・套索・絕技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2133,"skill_field_effect_id":0,"_id_":3019,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":60,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3021":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2135,"skill_field_effect_id":0,"_id_":3021,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3022":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2136,"skill_field_effect_id":0,"_id_":3022,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3023":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to to front enemy.","ja":"前から1体の敵に強力な多段攻撃","ko":"앞에서 1명의 적에게 강력한 다단 공격","zh_hant":"對前方的1個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2137,"skill_field_effect_id":0,"_id_":3023,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3024":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2138,"skill_field_effect_id":0,"_id_":3024,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3025":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2139,"skill_field_effect_id":0,"_id_":3025,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3026":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2140,"skill_field_effect_id":0,"_id_":3026,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3027":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2141,"skill_field_effect_id":0,"_id_":3027,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3028":{"attribute_id":7,"cost":2,"description":{"en":"Chance (50%) at Confusion to all enemies.","ja":"敵全体に確率（50％）で混乱を付与する","ko":"적 전체에게 50% 확률로 혼란을 부여","zh_hant":"有50％的機率對所有敵人賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Parasol Trick NEO","ja":"新春晴傘かくし芸 NEO","ko":"새해 양산 개인기 NEO","zh_hant":"新春陽傘特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2142,"skill_field_effect_id":0,"_id_":3028,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3030":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2143,"skill_field_effect_id":0,"_id_":3030,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3031":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2144,"skill_field_effect_id":0,"_id_":3031,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3032":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2145,"skill_field_effect_id":0,"_id_":3032,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3033":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2146,"skill_field_effect_id":0,"_id_":3033,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3034":{"attribute_id":3,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 1 rear enemy.","ja":"自身に必中を付与し、後から1体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2147,"skill_field_effect_id":0,"_id_":3034,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"3035":{"attribute_id":3,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2148,"skill_field_effect_id":0,"_id_":3035,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3036":{"attribute_id":3,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2149,"skill_field_effect_id":0,"_id_":3036,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3037":{"attribute_id":3,"cost":2,"description":{"en":"Chance (50%) at Burn to all enemies.","ja":"敵全体に確率（50％）で火傷を付与","ko":"적 전체에게 50% 확률로 화상을 부여","zh_hant":"有50％的機率賦予所有敵人燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2150,"skill_field_effect_id":0,"_id_":3037,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"3038":{"attribute_id":3,"cost":2,"description":{"en":"Chance (50%) at Burn to all enemies.","ja":"敵全体に確率（50％）で火傷を付与","ko":"적 전체에게 50% 확률로 화상을 부여","zh_hant":"有50％的機率賦予所有敵人燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Hanetsuki Blackout NEO","ja":"羽根突き墨汁打 NEO","ko":"하고이타 먹물타 NEO","zh_hant":"板羽墨汁殺球 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2151,"skill_field_effect_id":0,"_id_":3038,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"3040":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2152,"skill_field_effect_id":0,"_id_":3040,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3041":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2153,"skill_field_effect_id":0,"_id_":3041,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3042":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2154,"skill_field_effect_id":0,"_id_":3042,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3043":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2155,"skill_field_effect_id":0,"_id_":3043,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3044":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2156,"skill_field_effect_id":0,"_id_":3044,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3045":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to 3 front enemies.","ja":"前から3体の敵にACTパワーダウン付与","ko":"앞에서 3명의 적에게 ACT 파워 감소를 부여","zh_hant":"降低前方3個敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2157,"skill_field_effect_id":0,"_id_":3045,"skill_options":[{"id":9,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3046":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to 3 front enemies.","ja":"前から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"앞에서 3명의 적에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低前方3個敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2158,"skill_field_effect_id":0,"_id_":3046,"skill_options":[{"id":21,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3047":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2159,"skill_field_effect_id":0,"_id_":3047,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3048":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Hammer Drop NEO","ja":"賀正おとし槌 NEO","ko":"근하신년 망치 NEO","zh_hant":"謹賀新年槌擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2160,"skill_field_effect_id":0,"_id_":3048,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3050":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2161,"skill_field_effect_id":0,"_id_":3050,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3051":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2162,"skill_field_effect_id":0,"_id_":3051,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3052":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2163,"skill_field_effect_id":0,"_id_":3052,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3053":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2164,"skill_field_effect_id":0,"_id_":3053,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3054":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2165,"skill_field_effect_id":0,"_id_":3054,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3055":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies. Evasion Rate up to self.","ja":"後から3体の敵に威力(大)で攻撃し、自身に回避率アップを付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 자신에게 회피 확률 증가를 부여","zh_hant":"對後面的3個敵人發動威力（大）攻擊，並提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2166,"skill_field_effect_id":0,"_id_":3055,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3056":{"attribute_id":3,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2167,"skill_field_effect_id":0,"_id_":3056,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3057":{"attribute_id":3,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2168,"skill_field_effect_id":0,"_id_":3057,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3058":{"attribute_id":3,"cost":2,"description":{"en":"Chance (50%) at Freeze to all enemies.","ja":"敵全体に確率（50％）で凍結を付与","ko":"적 전체에게 50% 확률로 동결을 부여","zh_hant":"有50％的機率賦予所有敵人凍結"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2169,"skill_field_effect_id":0,"_id_":3058,"skill_options":[{"id":61,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3060":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2170,"skill_field_effect_id":0,"_id_":3060,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3061":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2171,"skill_field_effect_id":0,"_id_":3061,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3062":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2172,"skill_field_effect_id":0,"_id_":3062,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3063":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2173,"skill_field_effect_id":0,"_id_":3063,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3064":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2174,"skill_field_effect_id":0,"_id_":3064,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3065":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に強力な多段攻撃","ko":"앞에서 3명의 적에게 강력한 다단 공격","zh_hant":"對前方的3個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2175,"skill_field_effect_id":0,"_id_":3065,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3066":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2176,"skill_field_effect_id":0,"_id_":3066,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3067":{"attribute_id":7,"cost":2,"description":{"en":"High damage & chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で混乱を付与する","ko":"적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2177,"skill_field_effect_id":0,"_id_":3067,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3068":{"attribute_id":7,"cost":2,"description":{"en":"High damage & chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で混乱を付与する","ko":"적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Parasol Trick NEO","ja":"新春晴傘かくし芸 NEO","ko":"새해 양산 개인기 NEO","zh_hant":"新春陽傘特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2178,"skill_field_effect_id":0,"_id_":3068,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3070":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2179,"skill_field_effect_id":0,"_id_":3070,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3071":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2180,"skill_field_effect_id":0,"_id_":3071,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3072":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2181,"skill_field_effect_id":0,"_id_":3072,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3073":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2182,"skill_field_effect_id":0,"_id_":3073,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3074":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2183,"skill_field_effect_id":0,"_id_":3074,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3075":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2184,"skill_field_effect_id":0,"_id_":3075,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3076":{"attribute_id":3,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2185,"skill_field_effect_id":0,"_id_":3076,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3077":{"attribute_id":3,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2186,"skill_field_effect_id":0,"_id_":3077,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3078":{"attribute_id":3,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2187,"skill_field_effect_id":0,"_id_":3078,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"3079":{"attribute_id":3,"cost":2,"description":{"en":"High damage & Burn to all enemies.","ja":"敵全体に威力(大)で攻撃し、火傷を付与","ko":"적 전체에게 위력(대) 공격, 화상을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並造成燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2188,"skill_field_effect_id":0,"_id_":3079,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"3080":{"attribute_id":3,"cost":2,"description":{"en":"High damage & Burn to all enemies.","ja":"敵全体に威力(大)で攻撃し、火傷を付与","ko":"적 전체에게 위력(대) 공격, 화상을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並造成燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Hanetsuki Blackout NEO","ja":"羽根突き墨汁打 NEO","ko":"하고이타 먹물타 NEO","zh_hant":"板羽墨汁殺球 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2189,"skill_field_effect_id":0,"_id_":3080,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"3082":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2190,"skill_field_effect_id":0,"_id_":3082,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3083":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2191,"skill_field_effect_id":0,"_id_":3083,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3084":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2192,"skill_field_effect_id":0,"_id_":3084,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3085":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2193,"skill_field_effect_id":0,"_id_":3085,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3086":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2194,"skill_field_effect_id":0,"_id_":3086,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3087":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2195,"skill_field_effect_id":0,"_id_":3087,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3088":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to all enemies.","ja":"敵全体に多段攻撃","ko":"적 전체에게 다단 공격","zh_hant":"對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Dance","ja":"連撃の舞","ko":"연격의 춤","zh_hant":"連擊之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2196,"skill_field_effect_id":0,"_id_":3088,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3089":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2197,"skill_field_effect_id":0,"_id_":3089,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3090":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2198,"skill_field_effect_id":0,"_id_":3090,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3091":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2199,"skill_field_effect_id":0,"_id_":3091,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3092":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Hammer Drop NEO","ja":"賀正おとし槌 NEO","ko":"근하신년 망치 NEO","zh_hant":"謹賀新年槌擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2200,"skill_field_effect_id":0,"_id_":3092,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3094":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2201,"skill_field_effect_id":0,"_id_":3094,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3095":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2202,"skill_field_effect_id":0,"_id_":3095,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3096":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2203,"skill_field_effect_id":0,"_id_":3096,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3097":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2204,"skill_field_effect_id":0,"_id_":3097,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3098":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2205,"skill_field_effect_id":0,"_id_":3098,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3099":{"attribute_id":3,"cost":2,"description":{"en":"High damage to all enemies. Evasion Rate up to self.","ja":"敵全体に威力(大)で攻撃じ、自身に回避率アップを付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 회피 확률 증가를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2206,"skill_field_effect_id":0,"_id_":3099,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[40,40,40,40,40]}]},"3100":{"attribute_id":3,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2207,"skill_field_effect_id":0,"_id_":3100,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3101":{"attribute_id":3,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2208,"skill_field_effect_id":0,"_id_":3101,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3102":{"attribute_id":3,"cost":2,"description":{"en":"High damage & High change (75%) at Freeze to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率（75％）で凍結を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률(75%)로 동결을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率（75％）造成凍結"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"氷結の協奏曲","ko":"빙결의 협주곡","zh_hant":"冰凍協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2209,"skill_field_effect_id":0,"_id_":3102,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":61,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3103":{"attribute_id":3,"cost":2,"description":{"en":"High damage & High change (75%) at Freeze to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率（75％）で凍結を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률(75%)로 동결을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率（75％）造成凍結"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2210,"skill_field_effect_id":0,"_id_":3103,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":61,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3105":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2211,"skill_field_effect_id":0,"_id_":3105,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3106":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2212,"skill_field_effect_id":0,"_id_":3106,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3107":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2213,"skill_field_effect_id":0,"_id_":3107,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3108":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2214,"skill_field_effect_id":0,"_id_":3108,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3109":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2215,"skill_field_effect_id":0,"_id_":3109,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3110":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2216,"skill_field_effect_id":0,"_id_":3110,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3111":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2217,"skill_field_effect_id":0,"_id_":3111,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3112":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2218,"skill_field_effect_id":0,"_id_":3112,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3113":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Parasol Trick NEO","ja":"新春晴傘かくし芸 NEO","ko":"새해 양산 개인기 NEO","zh_hant":"新春陽傘特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2219,"skill_field_effect_id":0,"_id_":3113,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3115":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2220,"skill_field_effect_id":0,"_id_":3115,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3116":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2221,"skill_field_effect_id":0,"_id_":3116,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3117":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2222,"skill_field_effect_id":0,"_id_":3117,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3118":{"attribute_id":3,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2223,"skill_field_effect_id":0,"_id_":3118,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3119":{"attribute_id":3,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2224,"skill_field_effect_id":0,"_id_":3119,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3120":{"attribute_id":3,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2225,"skill_field_effect_id":0,"_id_":3120,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3121":{"attribute_id":3,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2226,"skill_field_effect_id":0,"_id_":3121,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3122":{"attribute_id":3,"cost":2,"description":{"en":"Strong Multi-hit attack & Strong Burn to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、高威力の火傷を付与","ko":"적 전체에게 강력한 다단 공격, 높은 위력의 화상을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予高威力的燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2227,"skill_field_effect_id":0,"_id_":3122,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"3123":{"attribute_id":3,"cost":2,"description":{"en":"Strong Multi-hit attack & Strong Burn to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、高威力の火傷を付与","ko":"적 전체에게 강력한 다단 공격, 높은 위력의 화상을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予高威力的燒傷"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Hanetsuki Blackout NEO","ja":"羽根突き墨汁打 NEO","ko":"하고이타 먹물타 NEO","zh_hant":"板羽墨汁殺球 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2228,"skill_field_effect_id":0,"_id_":3123,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"3125":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2229,"skill_field_effect_id":0,"_id_":3125,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3126":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2230,"skill_field_effect_id":0,"_id_":3126,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3127":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2231,"skill_field_effect_id":0,"_id_":3127,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3128":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2232,"skill_field_effect_id":0,"_id_":3128,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3129":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2233,"skill_field_effect_id":0,"_id_":3129,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3130":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Dance","ja":"連撃の舞","ko":"연격의 춤","zh_hant":"連擊之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2234,"skill_field_effect_id":0,"_id_":3130,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3131":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2235,"skill_field_effect_id":0,"_id_":3131,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3132":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2236,"skill_field_effect_id":0,"_id_":3132,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3133":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2237,"skill_field_effect_id":0,"_id_":3133,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3134":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"New Year's Hammer Drop NEO","ja":"賀正おとし槌 NEO","ko":"근하신년 망치 NEO","zh_hant":"謹賀新年槌擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2238,"skill_field_effect_id":0,"_id_":3134,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3136":{"attribute_id":3,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2239,"skill_field_effect_id":0,"_id_":3136,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3137":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2240,"skill_field_effect_id":0,"_id_":3137,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3138":{"attribute_id":3,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2241,"skill_field_effect_id":0,"_id_":3138,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3139":{"attribute_id":3,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2242,"skill_field_effect_id":0,"_id_":3139,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3140":{"attribute_id":3,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Evasion Rate up to self.","ja":"敵全体に強力な多段攻撃を行い、自身に回避率アップを付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 회피 확률 증가를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2243,"skill_field_effect_id":0,"_id_":3140,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"3141":{"attribute_id":3,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2244,"skill_field_effect_id":0,"_id_":3141,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3142":{"attribute_id":3,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2245,"skill_field_effect_id":0,"_id_":3142,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3143":{"attribute_id":3,"cost":2,"description":{"en":"Strong Multi-hit attack & Freeze to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、凍結を付与する","ko":"적 전체에게 강력한 다단 공격, 동결을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予凍結"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"氷結の協奏曲","ko":"빙결의 협주곡","zh_hant":"冰凍協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2246,"skill_field_effect_id":0,"_id_":3143,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3144":{"attribute_id":3,"cost":2,"description":{"en":"Strong Multi-hit attack & Freeze to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、凍結を付与する","ko":"적 전체에게 강력한 다단 공격, 동결을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予凍結"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2247,"skill_field_effect_id":0,"_id_":3144,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3146":{"attribute_id":2,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2248,"skill_field_effect_id":0,"_id_":3146,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3147":{"attribute_id":2,"cost":2,"description":{"en":"High damage to front enemy. Removes Cont. Negative Effects and applies Cont. Negative Effects Resistance to all allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除し、継続マイナス効果耐性を付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제, 아군 전체에게 지속 마이너스 효과 저항을 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果，且賦予持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purity of Strength","ja":"力の浄化","ko":"힘의 정화","zh_hant":"力量的淨化"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2249,"skill_field_effect_id":0,"_id_":3147,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"3148":{"attribute_id":2,"cost":1,"description":{"en":"Aggro to all enemies. Counter Heal & Dmg Received down to self.","ja":"敵全体にターゲット固定を付与し、自身にカウンターヒールと被ダメージダウンを付与する","ko":"적 전체에게 타깃 고정을 부여, 자신에게 카운터 힐과 받는 대미지 감소를 부여","zh_hant":"賦予所有敵人目標鎖定，並賦予自身還擊治療且降低受到的傷害"},"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Resilient Protection","ja":"剛毅の庇護","ko":"강직의 비호","zh_hant":"剛毅庇護"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2250,"skill_field_effect_id":0,"_id_":3148,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":241,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[5,6,7,8,10]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"3149":{"attribute_id":2,"cost":2,"description":{"en":"Very high damage to front enemy. HP Regen & Evasion Rate up to all allies.","ja":"前から1番目の敵に威力(大+)で攻撃を行い、味方全体に毎ターンHP回復と回避率アップを付与する","ko":"앞에서 첫 번째 적에게 위력(대+) 공격, 아군 전체에게 매 턴 HP 회복과 회피 확률 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大+）攻擊，並賦予所有我方每回合HP回復且提升迴避率"},"icon_id":28,"is_multiple_command_unique_skill":0,"name":{"en":"Lion's Roar","ja":"獅子の咆哮","ko":"사자의 포효","zh_hant":"獅子咆哮"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2251,"skill_field_effect_id":0,"_id_":3149,"skill_options":[{"id":83,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[328,345,361,378,394]},{"id":28,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10000,12000,14000,16000,20000]},{"id":18,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,32,35,40,50]}]},"3151":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to front enemy. Special Barrier to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身に特殊バリアを付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신에게 특수 배리어를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予自己特殊防護罩"},"icon_id":31,"is_multiple_command_unique_skill":0,"name":{"en":"Walled Slash","ja":"造壁の斬撃","ko":"조벽의 참격","zh_hant":"造壁斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2253,"skill_field_effect_id":0,"_id_":3151,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"3152":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage & Accuracy Rate Down & Dexterity down to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、命中率ダウンとクリティカル率ダウンを付与する","ko":"적 전체에게 위력(중) 공격, 명중률 감소, 크리티컬 확률 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並降低命中率、會心率"},"icon_id":17,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzled Pupils","ja":"眩む瞳","ko":"어두워지는 눈동자","zh_hant":"眩目之瞳"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2254,"skill_field_effect_id":0,"_id_":3152,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]},{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]}]},"3153":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage & AP up & Reduced Brilliance Recovery to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、AP増加とキラめき獲得ダウンを付与する","ko":"적 전체에게 위력(중) 공격, AP 증가, 반짝임 획득 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並賦予AP增加、獲得光芒減少"},"icon_id":192,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Blink","ja":"減光の瞬き","ko":"감광의 반짝임","zh_hant":"減光之瞬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2255,"skill_field_effect_id":0,"_id_":3153,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"3154":{"attribute_id":3,"cost":2,"description":{"en":"High damage & High chance at Freeze to all enemies. Exit Evasion to self.","ja":"敵全体に威力(大)で攻撃を行い、高確率で凍結を付与し、自身に退場回避を付与する","ko":"적 전체에게 위력(대) 공격, 높은 확률로 동결을 부여, 자신에게 퇴장 회피를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並有高機率造成凍結，同時能賦予自己退場迴避"},"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World","ja":"逆転世界の開眼","ko":"역전세계의 개안","zh_hant":"翻轉世界的領悟"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2256,"skill_field_effect_id":0,"_id_":3154,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":61,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":155,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3156":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy. Agility down to all enemies.","ja":"前から1番目の敵に威力(小)で攻撃を行い、敵全体にすばやさダウンを付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 적 전체에게 민첩 감소를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並降低所有敵人的敏捷"},"icon_id":15,"is_multiple_command_unique_skill":0,"name":{"en":"Static Slash","ja":"鈍足の斬撃","ko":"둔화의 참격","zh_hant":"慢行的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2258,"skill_field_effect_id":0,"_id_":3156,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":15,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3157":{"attribute_id":6,"cost":2,"description":{"en":"Medium damage & Act Power down & Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、ACTパワーダウン、通常防御力ダウン、特殊防御力ダウンを付与する","ko":"적 전체에게 위력(중) 공격, ACT 파워 감소, 일반 방어력 감소, 특수 방어력 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並降低ACT力量、普通防禦力、特殊防禦力"},"icon_id":9,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Magic","ja":"脱力の魔術","ko":"탈력의 마술","zh_hant":"虛脫魔術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2259,"skill_field_effect_id":0,"_id_":3157,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3158":{"attribute_id":6,"cost":3,"description":{"en":"Low Brilliance recovery & Special Barrier to all allies.","ja":"味方全体のキラめきを少し回復し、特殊バリアを付与する","ko":"아군 전체의 반짝임을 조금 회복, 특수 배리어를 부여","zh_hant":"回復所有我方少許的光芒，並賦予特殊防護罩效果"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Protection of Brilliance","ja":"キラめきの加護","ko":"반짝임의 가호","zh_hant":"光芒加護"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2260,"skill_field_effect_id":0,"_id_":3158,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,11,12,13,15]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"3159":{"attribute_id":6,"cost":2,"description":{"en":"High damage & Confusion & Blindness & Heavy Burn & Marked to all enemies.","ja":"敵全体に威力(大)の攻撃を行い、混乱、暗闇、大火傷、刻印を付与する","ko":"적 전체에게 위력(대) 공격, 혼란, 암흑, 대화상, 각인을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並造成混亂、盲目、嚴重燒傷、刻印"},"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Arcanum Magicae","ja":"アルカナム・マジーケ","ko":"아르카눔 마지케","zh_hant":"阿爾克那・魔術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2261,"skill_field_effect_id":0,"_id_":3159,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":246,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5,6,7,8,10]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3161":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to front enemy. Evasion x1 to 3 rear allies.","ja":"前から1番目の敵に威力(小)で攻撃を行い、後から3体の味方に回避を1回付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 뒤에서 3명의 아군에게 회피 1회를 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予後面3名我方迴避1次"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2263,"skill_field_effect_id":0,"_id_":3161,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":34,"hit_rate":100,"target_id":1143,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3162":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage to front enemy. Removes Cont. Positive Effects to all enemies.","ja":"前から1番目の敵に威力(中)で攻撃を行い、敵全体の継続プラス効果を解除する","ko":"앞에서 첫 번째 적에게 위력(중) 공격, 적 전체의 지속 플러스 효과를 해제","zh_hant":"對前面數來第1個敵人發動威力（中）攻擊，並解除所有敵人的持續性正面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Severing Blade","ja":"断切の刃","ko":"단절의 칼날","zh_hant":"切斷之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2264,"skill_field_effect_id":0,"_id_":3162,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3163":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage to front enemy. Cont. Negative Effects Resistance to all allies.","ja":"前から1番目の敵に威力(中)で攻撃を行い、味方全体に継続マイナス効果耐性を付与する","ko":"앞에서 1명의 적에게 위력(중) 공격, 아군 전체에게 지속 마이너스 효과 저항을 부여","zh_hant":"對前面數來第1個敵人發動威力（中）攻擊，並賦予所有我方持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Sacred Blade","ja":"聖域の刃","ko":"성역의 칼날","zh_hant":"聖域之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2265,"skill_field_effect_id":0,"_id_":3163,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"3164":{"attribute_id":3,"cost":2,"description":{"en":"Act Power up & Dexterity up to self. Removes Cont. Positive Effects & Very high damage to all enemies.","ja":"自身にACTパワーアップとクリティカル率アップを付与し、敵全体の継続プラス効果を解除し、威力(大+)で攻撃を行う","ko":"자신에게 ACT 파워 증가와 크리티컬 확률 증가를 부여, 적 전체의 지속 플러스 효과를 해제하고 위력(대+) 공격","zh_hant":"提升自己的ACT力量和會心率，解除所有敵人的持續性正面效果，並發動威力（大+）攻擊"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Flying Dragon","ja":"龍飛剣","ko":"용비검","zh_hant":"龍飛劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2266,"skill_field_effect_id":0,"_id_":3164,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3171":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2273,"skill_field_effect_id":0,"_id_":3171,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3172":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2274,"skill_field_effect_id":0,"_id_":3172,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3173":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2275,"skill_field_effect_id":0,"_id_":3173,"skill_options":[{"id":1,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3174":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2276,"skill_field_effect_id":0,"_id_":3174,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3175":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2277,"skill_field_effect_id":0,"_id_":3175,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3176":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2278,"skill_field_effect_id":0,"_id_":3176,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3177":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to 3 front enemies.","ja":"前から3体の敵にACTパワーダウン付与","ko":"앞에서 3명의 적에게 ACT 파워 감소를 부여","zh_hant":"降低前方3個敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2279,"skill_field_effect_id":0,"_id_":3177,"skill_options":[{"id":9,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3178":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2280,"skill_field_effect_id":0,"_id_":3178,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3179":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2281,"skill_field_effect_id":0,"_id_":3179,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3181":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":3181,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3182":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":3182,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3183":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":3183,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3184":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":3184,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3185":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":3185,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3186":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 1 rear enemy.","ja":"自身に必中を付与し、後から1体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":3186,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"3187":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":3187,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3188":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":3188,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3189":{"attribute_id":4,"cost":2,"description":{"en":"High damage & Confusion to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、混乱を付与","ko":"뒤에서부터 3명의 적에게 위력(대) 공격, 혼란을 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":3189,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3191":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2291,"skill_field_effect_id":0,"_id_":3191,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3192":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2292,"skill_field_effect_id":0,"_id_":3192,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3193":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2293,"skill_field_effect_id":0,"_id_":3193,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3194":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2294,"skill_field_effect_id":0,"_id_":3194,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3195":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to 1 front enemy.","ja":"自身に必中を付与し、前から1体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 1명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對前方的1個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2295,"skill_field_effect_id":0,"_id_":3195,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"3196":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2296,"skill_field_effect_id":0,"_id_":3196,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3197":{"attribute_id":7,"cost":2,"description":{"en":"AP Up to 3 front enemies.","ja":"前から3体の敵にAP増加を付与","ko":"앞에서 3명의 적에게 AP 증가를 부여","zh_hant":"賦予前方的3個敵人AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2297,"skill_field_effect_id":0,"_id_":3197,"skill_options":[{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3199":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2298,"skill_field_effect_id":0,"_id_":3199,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3200":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2299,"skill_field_effect_id":0,"_id_":3200,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3201":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2300,"skill_field_effect_id":0,"_id_":3201,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3202":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2301,"skill_field_effect_id":0,"_id_":3202,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3203":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2302,"skill_field_effect_id":0,"_id_":3203,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3204":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2303,"skill_field_effect_id":0,"_id_":3204,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3205":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2304,"skill_field_effect_id":0,"_id_":3205,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3206":{"attribute_id":4,"cost":2,"description":{"en":"Set chance to inflict Burn & Stun to all enemies.","ja":"敵全体に確率で火傷とスタンを付与","ko":"적 전체에게 일정 확률로 화상과 스턴을 부여","zh_hant":"機率性賦予所有敵人燒傷與暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2305,"skill_field_effect_id":0,"_id_":3206,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3207":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2306,"skill_field_effect_id":0,"_id_":3207,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3208":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies. Reflect Normal Damage to self.","ja":"後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2307,"skill_field_effect_id":0,"_id_":3208,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"3209":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies. Reflect Normal Damage to self.","ja":"後から3体の敵に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對後面的3個敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2308,"skill_field_effect_id":0,"_id_":3209,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"3211":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2309,"skill_field_effect_id":0,"_id_":3211,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3212":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2310,"skill_field_effect_id":0,"_id_":3212,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3213":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2311,"skill_field_effect_id":0,"_id_":3213,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3214":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2312,"skill_field_effect_id":0,"_id_":3214,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3215":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2313,"skill_field_effect_id":0,"_id_":3215,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3216":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2314,"skill_field_effect_id":0,"_id_":3216,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3217":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2315,"skill_field_effect_id":0,"_id_":3217,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3218":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2316,"skill_field_effect_id":0,"_id_":3218,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3219":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2317,"skill_field_effect_id":0,"_id_":3219,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3221":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":3221,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3222":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":3222,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3223":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":3223,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3224":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":3224,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3225":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":3225,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3226":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":3226,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3227":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":3227,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"3228":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":3228,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3229":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":3229,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3230":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":3230,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3231":{"attribute_id":4,"cost":2,"description":{"en":"High damage & chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で混乱を付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":3231,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3233":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2329,"skill_field_effect_id":0,"_id_":3233,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3234":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2330,"skill_field_effect_id":0,"_id_":3234,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3235":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2331,"skill_field_effect_id":0,"_id_":3235,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3236":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2332,"skill_field_effect_id":0,"_id_":3236,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3237":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to 3 front enemies.","ja":"自身に必中を付与し、前から3体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여하고, 앞에서 3명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對前方的3個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2333,"skill_field_effect_id":0,"_id_":3237,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3238":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2334,"skill_field_effect_id":0,"_id_":3238,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3239":{"attribute_id":7,"cost":2,"description":{"en":"High damage & AP Up to all enemies.","ja":"敵全体に威力(大)で攻撃し、AP増加を付与","ko":"적 전체에게 위력(대) 공격, AP 증가를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2335,"skill_field_effect_id":0,"_id_":3239,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3241":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2336,"skill_field_effect_id":0,"_id_":3241,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3242":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2337,"skill_field_effect_id":0,"_id_":3242,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3243":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2338,"skill_field_effect_id":0,"_id_":3243,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3244":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2339,"skill_field_effect_id":0,"_id_":3244,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3245":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2340,"skill_field_effect_id":0,"_id_":3245,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3246":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2341,"skill_field_effect_id":0,"_id_":3246,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3247":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2342,"skill_field_effect_id":0,"_id_":3247,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3248":{"attribute_id":4,"cost":2,"description":{"en":"Burn & Stun to all enemies.","ja":"敵全体に火傷とスタン付与","ko":"적 전체에게 화상과 스턴을 부여","zh_hant":"賦予所有敵人燒傷與暈眩效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2343,"skill_field_effect_id":0,"_id_":3248,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3249":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2344,"skill_field_effect_id":0,"_id_":3249,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3250":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies. Reflect Normal Damage to self.","ja":"敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2345,"skill_field_effect_id":0,"_id_":3250,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"3251":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies. Reflect Normal Damage to self.","ja":"敵全体に威力(大)で攻撃し、自身に通常ダメージ反射を付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2346,"skill_field_effect_id":0,"_id_":3251,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"3253":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":0,"_id_":3253,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3254":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":0,"_id_":3254,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3255":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":0,"_id_":3255,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3256":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":0,"_id_":3256,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3257":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":0,"_id_":3257,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3258":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":0,"_id_":3258,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3259":{"attribute_id":7,"cost":3,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":0,"_id_":3259,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3260":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2354,"skill_field_effect_id":0,"_id_":3260,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3261":{"attribute_id":7,"cost":3,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2355,"skill_field_effect_id":0,"_id_":3261,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3263":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":3263,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3264":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":3264,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3265":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":3265,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3266":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":3266,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3267":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":3267,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3268":{"attribute_id":4,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":3268,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3269":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":3269,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3270":{"attribute_id":4,"cost":2,"description":{"en":"Remove Negative Effects to self. Remove Positive Effects to all enemies.","ja":"自身のマイナス効果を解除し、敵全体のプラス効果を解除する","ko":"자신의 마이너스 효과를 해제, 적 전체의 플러스 효과를 해제","zh_hant":"解除自己的負面效果，同時解除所有敵人的正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":3270,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3271":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":3271,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3272":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2365,"skill_field_effect_id":0,"_id_":3272,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3273":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2366,"skill_field_effect_id":0,"_id_":3273,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3275":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":0,"_id_":3275,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3276":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":0,"_id_":3276,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3277":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":0,"_id_":3277,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3278":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":0,"_id_":3278,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3279":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":0,"_id_":3279,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3280":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":0,"_id_":3280,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3281":{"attribute_id":7,"cost":2,"description":{"en":"Normal Defense down & Special Defense down to all enemies.","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"적 전체에게 일반/특수 방어력 감소를 부여","zh_hant":"降低所有敵人的普通防禦力與特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":0,"_id_":3281,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3282":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & AP Up to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、AP増加を付与","ko":"적 전체에게 강력한 다단 공격, AP 증가를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2374,"skill_field_effect_id":0,"_id_":3282,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3283":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & AP Up to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、AP増加を付与","ko":"적 전체에게 강력한 다단 공격, AP 증가를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予AP增加"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2375,"skill_field_effect_id":0,"_id_":3283,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3285":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2376,"skill_field_effect_id":0,"_id_":3285,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3286":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2377,"skill_field_effect_id":0,"_id_":3286,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3287":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2378,"skill_field_effect_id":0,"_id_":3287,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3288":{"attribute_id":4,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2379,"skill_field_effect_id":0,"_id_":3288,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3289":{"attribute_id":4,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2380,"skill_field_effect_id":0,"_id_":3289,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3290":{"attribute_id":4,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2381,"skill_field_effect_id":0,"_id_":3290,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3291":{"attribute_id":4,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2382,"skill_field_effect_id":0,"_id_":3291,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3292":{"attribute_id":4,"cost":2,"description":{"en":"Strong Burn & Stun to all enemies.","ja":"敵全体に高威力の火傷とスタン付与","ko":"적 전체에게 높은 위력의 화상과 스턴을 부여","zh_hant":"賦予所有敵人高威力的燒傷與暈眩效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2383,"skill_field_effect_id":0,"_id_":3292,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3293":{"attribute_id":4,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2384,"skill_field_effect_id":0,"_id_":3293,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3294":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.","ja":"敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2385,"skill_field_effect_id":0,"_id_":3294,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3295":{"attribute_id":4,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Reflect Normal Damage to self.","ja":"敵全体に強力な多段攻撃を行い、自身に通常ダメージ反射を付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 일반 대미지 반사를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予自己反射普通傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2386,"skill_field_effect_id":0,"_id_":3295,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3314":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2397,"skill_field_effect_id":0,"_id_":3314,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3315":{"attribute_id":5,"cost":1,"description":{"en":"Removes Cont. Positive Effects to 3 front enemies.","ja":"前から3体の敵の継続プラス効果を解除する","ko":"앞에서 3명의 적의 지속 플러스 효과를 해제","zh_hant":"解除前面3名敵方的持續性正面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Victory Strategy","ja":"勝機の戦法","ko":"승기의 전법","zh_hant":"致勝的戰術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2398,"skill_field_effect_id":0,"_id_":3315,"skill_options":[{"id":127,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3316":{"attribute_id":5,"cost":2,"description":{"en":"High damage to enemy with the highest Act Power. AP Down to 3 front allies.","ja":"ACTパワーが高い敵1体に威力(大)の攻撃を行い、前から3体の味方にAP減少を付与する","ko":"ACT 파워가 높은 적 1명에게 위력(대) 공격, 앞에서 3명의 아군에게 AP 감소를 부여","zh_hant":"對1名ACT力量高的敵人發動威力（大）攻擊，並賦予前面3名我方AP減少"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Blade of Justice","ja":"正義の太刀","ko":"정의의 검","zh_hant":"正義的太刀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2399,"skill_field_effect_id":0,"_id_":3316,"skill_options":[{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1133,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3317":{"attribute_id":5,"cost":2,"description":{"en":"Very high damage & Stop to enemy with the highest Act Power, dealing extra damage to special-type enemies.","ja":"ACTパワーが高い敵1体に威力(大+)の攻撃を行い、ストップを付与する　この攻撃は特殊タイプの敵に特攻","ko":"ACT 파워가 높은 적 1명에게 위력(대+) 공격, 스톱을 부여, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對1名ACT力量高的敵人發動威力（大+）攻擊，並賦予停止　此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Purge Blade","ja":"粛清の刃","ko":"숙청의 칼날","zh_hant":"肅清之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2400,"skill_field_effect_id":0,"_id_":3317,"skill_options":[{"id":308,"hit_rate":100,"target_id":2051,"times":[3,3,3,3,3],"values":[307,323,338,353,369]},{"id":60,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3334":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2412,"skill_field_effect_id":0,"_id_":3334,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3335":{"attribute_id":5,"cost":2,"description":{"en":"High damage to front enemy. Removes Cont. Positive Effects to all enemies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果を解除する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과를 해제","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Purity of Heaven","ja":"天命の浄化","ko":"천명의 정화","zh_hant":"天命的淨化"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2413,"skill_field_effect_id":0,"_id_":3335,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3336":{"attribute_id":5,"cost":3,"description":{"en":"Medium damage to all enemies. Dexterity up & Effective element damage up to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体にクリティカル率アップ、有利属性ダメージアップを付与する","ko":"적 전체에게 위력(중) 공격, 아군 전원에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並提升所有我方的會心率、對有利屬性的傷害"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Destiny Guidance","ja":"運命の導き","ko":"운명의 인도","zh_hant":"命運之引導"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2414,"skill_field_effect_id":0,"_id_":3336,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3337":{"attribute_id":5,"cost":2,"description":{"en":"Special Defense down & Perfect Aim Very High damage to 3 front enemies, ignoring Aggro, Provoke, Barrier, Reflect and Invincible.","ja":"前から3体の敵に特殊防御力ダウンを付与し、威力(大+)の必中攻撃を行う この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する","ko":"앞에서 3명의 적에게 특수 방어력 감소를 부여, 위력(대+)의 백발백중 공격, 이 공격은 타깃 고정, 도발, 배리어, 반사, 무적을 무시","zh_hant":"降低前方3名敵人的特殊防禦力，並發動威力（大+）的必中攻擊 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵"},"icon_id":198,"is_multiple_command_unique_skill":0,"name":{"en":"Destiny's End","ja":"エンド・オブ・ディスティニー","ko":"엔드 오브 데스티니","zh_hant":"End Of Destiny"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2415,"skill_field_effect_id":0,"_id_":3337,"skill_options":[{"id":13,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":310,"hit_rate":100,"target_id":2177,"times":[4,4,4,4,4],"values":[186,200,214,228,243]}]},"3339":{"attribute_id":2,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Medium damage to rear enemy.","ja":"後ろから1番目の敵の継続プラス効果を解除し、威力(中)の攻撃を行う","ko":"뒤에서 첫 번째 적의 지속 플러스 효과를 해제, 위력(중) 공격","zh_hant":"解除後面數來第1個敵人的持續性正面效果，並發動威力（中）攻擊"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Severing Flash","ja":"断切の一閃","ko":"단절의 일섬","zh_hant":"切斷之閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2417,"skill_field_effect_id":0,"_id_":3339,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"3340":{"attribute_id":2,"cost":2,"description":{"en":"High damage to rear enemy. Normal Barrier & Special Barrier to all allies.","ja":"後ろから1番目の敵に威力(大)で攻撃し、味方全体に通常バリアと特殊バリアを付与する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 일반 배리어와 특수 배리어를 부여","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，並賦予所有我方普通防護罩、特殊防護罩"},"icon_id":30,"is_multiple_command_unique_skill":0,"name":{"en":"Sturdy Stance","ja":"強堅の構え","ko":"굳건한 자세","zh_hant":"堅韌的架式"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2418,"skill_field_effect_id":0,"_id_":3340,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":30,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"3341":{"attribute_id":2,"cost":3,"description":{"en":"High damage to rear enemy. High chance at Sleep to 3 rear enemies.","ja":"後ろから1番目の敵に威力(大)で攻撃し、後ろから3体の敵に高確率で睡眠を付与する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 적에게 높은 확률로 수면을 부여","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，並高機率賦予後方3名敵人睡眠效果"},"icon_id":58,"is_multiple_command_unique_skill":0,"name":{"en":"Hypnotic Dance","ja":"催眠の舞","ko":"최면의 춤","zh_hant":"催眠之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2419,"skill_field_effect_id":0,"_id_":3341,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":58,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3342":{"attribute_id":2,"cost":2,"description":{"en":"Very High damage to 3 rear enemies. Evasion Rate up & Exit Evasion to 3 rear allies.","ja":"後ろから3体の敵に威力(大+)で攻撃を行い、後ろから3体の味方に回避率アップと退場回避を付与する","ko":"뒤에서 3명의 적에게 위력(대+) 공격, 뒤에서 3명의 아군에게 회피 확률 증가와 퇴장 회피를 부여","zh_hant":"對後方的3個敵人發動威力（大+）攻擊，並提升後方3名我方的迴避率，同時賦予退場迴避"},"icon_id":155,"is_multiple_command_unique_skill":0,"name":{"en":"Ruler's War","ja":"天下人の戦","ko":"천하를 얻은 자의 싸움","zh_hant":"天下霸主之戰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2420,"skill_field_effect_id":0,"_id_":3342,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[186,200,214,228,243]},{"id":18,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[30,32,35,40,50]},{"id":155,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3344":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2422,"skill_field_effect_id":0,"_id_":3344,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3345":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2423,"skill_field_effect_id":0,"_id_":3345,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3346":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2424,"skill_field_effect_id":0,"_id_":3346,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3347":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2425,"skill_field_effect_id":0,"_id_":3347,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3348":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2426,"skill_field_effect_id":0,"_id_":3348,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3349":{"attribute_id":7,"cost":2,"description":{"en":"Powerful Multi-hit attack to 1 rear enemy.","ja":"後から1体の敵に強力な多段攻撃","ko":"뒤에서 1명의 적에게 강력한 다단 공격","zh_hant":"對後方的1個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flurry","ja":"強連撃","ko":"강한 연격","zh_hant":"強連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2427,"skill_field_effect_id":0,"_id_":3349,"skill_options":[{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"3350":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2428,"skill_field_effect_id":0,"_id_":3350,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3351":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2429,"skill_field_effect_id":0,"_id_":3351,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3352":{"attribute_id":7,"cost":2,"description":{"en":"Set chance to inflict Stun to all enemies.","ja":"敵全体に確率でスタンを付与する","ko":"적 전체에게 일정 확률로 스턴을 부여","zh_hant":"機率性賦予所有敵人暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Stay Away! NEO","ja":"こっちにこないで！ NEO","ko":"가까이 오지 마! NEO","zh_hant":"不要過來！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2430,"skill_field_effect_id":0,"_id_":3352,"skill_options":[{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3354":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2431,"skill_field_effect_id":0,"_id_":3354,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3355":{"attribute_id":6,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2432,"skill_field_effect_id":0,"_id_":3355,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3356":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2433,"skill_field_effect_id":0,"_id_":3356,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3357":{"attribute_id":6,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2434,"skill_field_effect_id":0,"_id_":3357,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3358":{"attribute_id":6,"cost":2,"description":{"en":"Dexterity down & Critical down to 3 front enemies.","ja":"前から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"앞에서 3명의 적에게 크리티컬 확률 감소를 부여, 크리티컬 위력 감소를 부여","zh_hant":"降低前方3個敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2435,"skill_field_effect_id":0,"_id_":3358,"skill_options":[{"id":21,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3359":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2436,"skill_field_effect_id":0,"_id_":3359,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3360":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 front enemies.","ja":"自身にACTパワーアップと必中を付与し、前から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 앞에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2437,"skill_field_effect_id":0,"_id_":3360,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3362":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2438,"skill_field_effect_id":0,"_id_":3362,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3363":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2439,"skill_field_effect_id":0,"_id_":3363,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3364":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2440,"skill_field_effect_id":0,"_id_":3364,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3365":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2441,"skill_field_effect_id":0,"_id_":3365,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3366":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Powerful Multi-hit attack to 1 rear enemy.","ja":"自身に必中を付与し、後から1体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여하고, 뒤에서 1명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對後方的1個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2442,"skill_field_effect_id":0,"_id_":3366,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,170,170,170,170]}]},"3367":{"attribute_id":7,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2443,"skill_field_effect_id":0,"_id_":3367,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3368":{"attribute_id":7,"cost":2,"description":{"en":"Accuracy Rate Down to 3 rear enemies.","ja":"後ろから3体に命中率ダウンを付与","ko":"뒤에서 3명에게 명중률 감소를 부여","zh_hant":"降低後方3名的命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzling Rondo","ja":"眩惑の輪舞曲","ko":"현혹의 윤무곡","zh_hant":"眩目圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2444,"skill_field_effect_id":0,"_id_":3368,"skill_options":[{"id":17,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3369":{"attribute_id":7,"cost":2,"description":{"en":"High damage & Accuracy Rate down to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃を行い、命中率ダウンを付与","ko":"뒤에서 3명의 적에게 위력(대) 공격, 명중률 감소를 부여","zh_hant":"對後方3個敵方發動威力（大）攻擊，並降低命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fuoco! NEO","ja":"Fuoco! NEO","ko":"Fuoco! NEO","zh_hant":"Fuoco！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2445,"skill_field_effect_id":0,"_id_":3369,"skill_options":[{"id":83,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":17,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3371":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2446,"skill_field_effect_id":0,"_id_":3371,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3372":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2447,"skill_field_effect_id":0,"_id_":3372,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3373":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2448,"skill_field_effect_id":0,"_id_":3373,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3374":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2449,"skill_field_effect_id":0,"_id_":3374,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3375":{"attribute_id":6,"cost":2,"description":{"en":"High damage to front 3 enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2450,"skill_field_effect_id":0,"_id_":3375,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3376":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies. Dmg Received down to self.","ja":"前から3体の敵に威力(大)で攻撃し、自身に被ダメージダウンを付与する","ko":"앞에서 3명의 적에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여","zh_hant":"對前面3名敵人發動威力（大）攻擊，並降低自身受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Protection","ja":"加護の斬撃","ko":"가호의 참격","zh_hant":"加護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2451,"skill_field_effect_id":0,"_id_":3376,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3377":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2452,"skill_field_effect_id":0,"_id_":3377,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3378":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2453,"skill_field_effect_id":0,"_id_":3378,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3379":{"attribute_id":6,"cost":2,"description":{"en":"Set chance to inflict Poison & Confusion to all enemies.","ja":"敵全体に確率で毒と混乱を付与","ko":"적 전체에게 일정 확률로 독, 혼란을 부여","zh_hant":"機率性賦予所有敵人中毒和混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2454,"skill_field_effect_id":0,"_id_":3379,"skill_options":[{"id":54,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3381":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2455,"skill_field_effect_id":0,"_id_":3381,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3382":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2456,"skill_field_effect_id":0,"_id_":3382,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3383":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2457,"skill_field_effect_id":0,"_id_":3383,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3384":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2458,"skill_field_effect_id":0,"_id_":3384,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3385":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2459,"skill_field_effect_id":0,"_id_":3385,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3386":{"attribute_id":7,"cost":2,"description":{"en":"Powerful Multi-hit attack to 3 rear enemies.","ja":"後から3体の敵に強力な多段攻撃","ko":"뒤에서 3명의 적에게 강력한 다단 공격","zh_hant":"對後方的3個敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Tri-Slash","ja":"強参連撃","ko":"강한 삼연격","zh_hant":"強参連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2460,"skill_field_effect_id":0,"_id_":3386,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3387":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2461,"skill_field_effect_id":0,"_id_":3387,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3388":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2462,"skill_field_effect_id":0,"_id_":3388,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3389":{"attribute_id":7,"cost":2,"description":{"en":"High damage & High chance at Stun to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率でスタンを付与する","ko":"적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Constraint Concerto","ja":"抑制の協奏曲","ko":"억제의 협주곡","zh_hant":"抑制協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2463,"skill_field_effect_id":0,"_id_":3389,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":57,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3390":{"attribute_id":7,"cost":2,"description":{"en":"High damage & High chance at Stun to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率でスタンを付与する","ko":"적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Stay Away! NEO","ja":"こっちにこないで！ NEO","ko":"가까이 오지 마! NEO","zh_hant":"不要過來！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2464,"skill_field_effect_id":0,"_id_":3390,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3392":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2465,"skill_field_effect_id":0,"_id_":3392,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3393":{"attribute_id":6,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2466,"skill_field_effect_id":0,"_id_":3393,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3394":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2467,"skill_field_effect_id":0,"_id_":3394,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3395":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2468,"skill_field_effect_id":0,"_id_":3395,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3396":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2469,"skill_field_effect_id":0,"_id_":3396,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3397":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2470,"skill_field_effect_id":0,"_id_":3397,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3398":{"attribute_id":6,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2471,"skill_field_effect_id":0,"_id_":3398,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3399":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2472,"skill_field_effect_id":0,"_id_":3399,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3400":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2473,"skill_field_effect_id":0,"_id_":3400,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3402":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2474,"skill_field_effect_id":0,"_id_":3402,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3403":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2475,"skill_field_effect_id":0,"_id_":3403,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3404":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2476,"skill_field_effect_id":0,"_id_":3404,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3405":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2477,"skill_field_effect_id":0,"_id_":3405,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3406":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Powerful Multi-hit attack to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に強力な多段攻撃","ko":"자신에게 백발백중을 부여하고, 뒤에서 3명의 적에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Tri-Slash","ja":"必中の参連撃","ko":"백발백중의 삼연격","zh_hant":"必中參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2478,"skill_field_effect_id":0,"_id_":3406,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3407":{"attribute_id":7,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2479,"skill_field_effect_id":0,"_id_":3407,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3408":{"attribute_id":7,"cost":2,"description":{"en":"Accuracy Rate down to all enemies.","ja":"敵全体に命中率ダウンを付与","ko":"적 전체에게 명중률 감소를 부여","zh_hant":"降低所有敵人的命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzling Concerto","ja":"眩惑の協奏曲","ko":"현혹의 협주곡","zh_hant":"眩目協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2480,"skill_field_effect_id":0,"_id_":3408,"skill_options":[{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3409":{"attribute_id":7,"cost":2,"description":{"en":"High damage & Accuracy Rate down to all enemies.","ja":"敵全体に威力(大)で攻撃し、命中率ダウンを付与","ko":"적 전체에게 위력(대) 공격, 명중률 감소를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並降低命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fuoco! NEO","ja":"Fuoco! NEO","ko":"Fuoco! NEO","zh_hant":"Fuoco！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2481,"skill_field_effect_id":0,"_id_":3409,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3411":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2482,"skill_field_effect_id":0,"_id_":3411,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3412":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2483,"skill_field_effect_id":0,"_id_":3412,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3413":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2484,"skill_field_effect_id":0,"_id_":3413,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3414":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2485,"skill_field_effect_id":0,"_id_":3414,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3415":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2486,"skill_field_effect_id":0,"_id_":3415,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3416":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies. Dmg Received down to self.","ja":"敵全体に威力(大)で攻撃じ、自身に被ダメージダウンを付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並降低自身受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Protection","ja":"加護の斬撃","ko":"가호의 참격","zh_hant":"加護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2487,"skill_field_effect_id":0,"_id_":3416,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3417":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2488,"skill_field_effect_id":0,"_id_":3417,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3418":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2489,"skill_field_effect_id":0,"_id_":3418,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3419":{"attribute_id":6,"cost":2,"description":{"en":"High damage & High chance at Poison & Confusion to all enemies","ja":"敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Slash","ja":"毒惑の斬撃","ko":"독혹의 참격","zh_hant":"毒惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2490,"skill_field_effect_id":0,"_id_":3419,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":54,"hit_rate":75,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3420":{"attribute_id":6,"cost":2,"description":{"en":"High damage & High chance at Poison & Confusion to all enemies","ja":"敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2491,"skill_field_effect_id":0,"_id_":3420,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":75,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3422":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2492,"skill_field_effect_id":0,"_id_":3422,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3423":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2493,"skill_field_effect_id":0,"_id_":3423,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3424":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2494,"skill_field_effect_id":0,"_id_":3424,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3425":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2495,"skill_field_effect_id":0,"_id_":3425,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3426":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2496,"skill_field_effect_id":0,"_id_":3426,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3427":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2497,"skill_field_effect_id":0,"_id_":3427,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3428":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2498,"skill_field_effect_id":0,"_id_":3428,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3429":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2499,"skill_field_effect_id":0,"_id_":3429,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3430":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Stun to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、スタンを付与する","ko":"적 전체에게 강력한 다단 공격, 스턴을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Constraint Concerto","ja":"抑制の協奏曲","ko":"억제의 협주곡","zh_hant":"抑制協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2500,"skill_field_effect_id":0,"_id_":3430,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3431":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Stun to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、スタンを付与する","ko":"적 전체에게 강력한 다단 공격, 스턴을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予暈眩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Stay Away! NEO","ja":"こっちにこないで！ NEO","ko":"가까이 오지 마! NEO","zh_hant":"不要過來！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2501,"skill_field_effect_id":0,"_id_":3431,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3433":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2502,"skill_field_effect_id":0,"_id_":3433,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3434":{"attribute_id":6,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2503,"skill_field_effect_id":0,"_id_":3434,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3435":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2504,"skill_field_effect_id":0,"_id_":3435,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3436":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2505,"skill_field_effect_id":0,"_id_":3436,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3437":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2506,"skill_field_effect_id":0,"_id_":3437,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3438":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2507,"skill_field_effect_id":0,"_id_":3438,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3439":{"attribute_id":6,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2508,"skill_field_effect_id":0,"_id_":3439,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3440":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":3440,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3441":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2510,"skill_field_effect_id":0,"_id_":3441,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3443":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 1 rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2511,"skill_field_effect_id":0,"_id_":3443,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3444":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 1 rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2512,"skill_field_effect_id":0,"_id_":3444,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3445":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2513,"skill_field_effect_id":0,"_id_":3445,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3446":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2514,"skill_field_effect_id":0,"_id_":3446,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3447":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2515,"skill_field_effect_id":0,"_id_":3447,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3448":{"attribute_id":7,"cost":2,"description":{"en":"Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Tri-Slash","ja":"必中の参連撃","ko":"백발백중의 삼연격","zh_hant":"必中參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2516,"skill_field_effect_id":0,"_id_":3448,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3449":{"attribute_id":7,"cost":2,"description":{"en":"Normal Barrier & Special Barrier to self.","ja":"自身に通常バリア、特殊バリアを付与","ko":"자신에게 일반 배리어, 특수 배리어를 부여","zh_hant":"賦予自己普通防護罩、特殊防護罩"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2517,"skill_field_effect_id":0,"_id_":3449,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3450":{"attribute_id":7,"cost":2,"description":{"en":"Accuracy Rate down to all enemies.","ja":"敵全体に命中率ダウンを付与","ko":"적 전체에게 명중률 감소를 부여","zh_hant":"降低所有敵人的命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzling Concerto","ja":"眩惑の協奏曲","ko":"현혹의 협주곡","zh_hant":"眩目協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2518,"skill_field_effect_id":0,"_id_":3450,"skill_options":[{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"3451":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Accuracy Rate down to all enemies. ","ja":"敵全体に強力な多段攻撃を行い、命中率ダウンを付与","ko":"적 전체에게 강력한 다단 공격, 명중률 감소를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並降低命中率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fuoco! NEO","ja":"Fuoco! NEO","ko":"Fuoco! NEO","zh_hant":"Fuoco！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2519,"skill_field_effect_id":0,"_id_":3451,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"3453":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2520,"skill_field_effect_id":0,"_id_":3453,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3454":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2521,"skill_field_effect_id":0,"_id_":3454,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3455":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2522,"skill_field_effect_id":0,"_id_":3455,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3456":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2523,"skill_field_effect_id":0,"_id_":3456,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3457":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Strong Dmg Received down to self.","ja":"敵全体に強力な多段攻撃を行い、自身に強力な被ダメージダウンを付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 강력한 받는 대미지 감소를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並大幅降低自己受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Protection","ja":"加護の斬撃","ko":"가호의 참격","zh_hant":"加護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2524,"skill_field_effect_id":0,"_id_":3457,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3458":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2525,"skill_field_effect_id":0,"_id_":3458,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3459":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2526,"skill_field_effect_id":0,"_id_":3459,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3460":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack & Poison & Confusion to all enemies","ja":"敵全体に強力な多段攻撃を行い、毒と混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 독, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Slash","ja":"毒惑の斬撃","ko":"독혹의 참격","zh_hant":"毒惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2527,"skill_field_effect_id":0,"_id_":3460,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3461":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack & Poison & Confusion to all enemies","ja":"敵全体に強力な多段攻撃を行い、毒と混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 독, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2528,"skill_field_effect_id":0,"_id_":3461,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3471":{"attribute_id":4,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2536,"skill_field_effect_id":0,"_id_":3471,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3472":{"attribute_id":4,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Medium damage to front enemy.","ja":"前から1番目の敵の継続プラス効果を解除し、威力(中)の攻撃を行う","ko":"앞에서 첫 번째 적에게 지속 플러스 효과를 해제, 위력(중) 공격 ","zh_hant":"解除前面數來第1個敵人的持續性正面效果，並發動威力（中）攻擊"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Severing Slash","ja":"断切の斬撃","ko":"단절의 참격","zh_hant":"切斷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2537,"skill_field_effect_id":0,"_id_":3472,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3473":{"attribute_id":4,"cost":3,"description":{"en":"High damage to front enemy & chance at Blindness to all enemies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、敵全体に一定確率で暗闇を付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 일정 확률로 암흑을 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並有一定機率賦予所有敵人盲目效果"},"icon_id":62,"is_multiple_command_unique_skill":0,"name":{"en":"Darkness Slash","ja":"黒暗の斬撃","ko":"암흑의 참격","zh_hant":"黑闇斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2538,"skill_field_effect_id":0,"_id_":3473,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":62,"hit_rate":40,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3474":{"attribute_id":4,"cost":2,"description":{"en":"Perfect Aim to self. High damage & Blindness & Act Power down to all enemies. Applies Stage Effect [We Are on the Stage (Moon)] to allies' stage.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃を行い、暗闇とACTパワーダウンを付与し、舞台の味方側に舞台効果「私たちはもう舞台の上（月）」を付与する","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격, 암흑과 ACT 파워 감소를 부여, 아군 쪽 무대에 무대 효과 [우리는 이미 무대 위(달)]을 부여","zh_hant":"賦予自身必中效果，對所有敵人發動威力（大）攻擊，賦予盲目並降低ACT力量，同時賦予我方的舞台舞台效果「我們已經站上舞台（月）」"},"icon_id":1004,"is_multiple_command_unique_skill":0,"name":{"en":"All of this... is for the sake of \"Starlight\"!","ja":"全ては、スタァライトのために！","ko":"모든 것은 스타라이트를 위해!","zh_hant":"一切都是為了Starlight！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2539,"skill_field_effect_id":6,"_id_":3474,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3476":{"attribute_id":6,"cost":2,"description":{"en":"Low damage & Mark to front enemy.","ja":"前から1番目の敵に威力(小)で攻撃を行い、刻印を付与する","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 각인을 부여","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並賦予刻印"},"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Marked Slash","ja":"刻印の斬撃","ko":"각인의 참격","zh_hant":"刻印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2541,"skill_field_effect_id":0,"_id_":3476,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":150,"hit_rate":100,"target_id":2011,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"3477":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies. Removes Cont. Negative Effects from all allies.","ja":"敵全体に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除する","ko":"적 전체에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제","zh_hant":"對所有敵人發動威力（大）攻擊，並解除所有我方的持續性負面效果"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞踊","ko":"정화의 무용","zh_hant":"淨化舞蹈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2542,"skill_field_effect_id":0,"_id_":3477,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3478":{"attribute_id":6,"cost":3,"description":{"en":"Agility up to all allies. Agility down to all enemies.","ja":"味方全体にすばやさアップを付与し、敵全体にすばやさダウンを付与する","ko":"아군 전체에게 민첩 증가를 부여, 적 전체에게 민첩 감소를 부여","zh_hant":"提升所有我方的敏捷，並降低所有敵人的敏捷"},"icon_id":14,"is_multiple_command_unique_skill":0,"name":{"en":"Turnaround Move","ja":"逆転の一手","ko":"역전의 한 수","zh_hant":"逆轉的一步"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2543,"skill_field_effect_id":0,"_id_":3478,"skill_options":[{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":15,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3479":{"attribute_id":6,"cost":2,"description":{"en":"Dexterity down & Critical down & Special Defense down & Very High damage to all enemies, dealing more damage when own HP is lower.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン、特殊防御力ダウンを付与し、威力(大+)で攻撃を行う　この攻撃は自身のHPが低い程威力が増加する","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소, 특수 방어력 감소를 부여, 자신의 HP가 낮을수록 위력이 증가하는 위력(대+) 공격","zh_hant":"降低所有敵人的會心率、會心威力、特殊防禦力，並發動威力（大+）攻擊　此攻擊會在自己HP越低時威力越強"},"icon_id":5,"is_multiple_command_unique_skill":0,"name":{"en":"Peach Oath","ja":"桃園の誓い","ko":"도원의 맹세","zh_hant":"桃園三結義"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2544,"skill_field_effect_id":0,"_id_":3479,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":147,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[125,135,145,155,170]}]},"3496":{"attribute_id":1,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2558,"skill_field_effect_id":0,"_id_":3496,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3497":{"attribute_id":1,"cost":2,"description":{"en":"Dexterity up & Critical up to self. Medium damage to front enemy.","ja":"自身にクリティカル率アップ、クリティカル威力アップを付与し、前から1番目の敵に威力(中)の攻撃を行う","ko":"자신에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여하고, 앞에서 첫 번째 적에게 위력(중) 공격","zh_hant":"提升自己的會心率、會心威力，並對前面數來第1個敵人發動威力（中）攻擊"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Warrior's Pride","ja":"武士の矜持","ko":"무사의 긍지","zh_hant":"武士的矜持"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2559,"skill_field_effect_id":0,"_id_":3497,"skill_options":[{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"3498":{"attribute_id":1,"cost":2,"description":{"en":"Act Power up & Effective element damage up to self. High damage to front enemy.","ja":"自身にACTパワーアップ、有利属性ダメージアップを付与し、前から1番目の敵に威力(大)の攻撃を行う","ko":"자신에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여, 앞에서 첫 번째 적에게 위력(대) 공격","zh_hant":"提升自己的ACT力量、對有利屬性的傷害，並對前面數來第1個敵人發動威力（大）攻擊"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Tough Blade","ja":"強靭な刃","ko":"강인한 칼날","zh_hant":"堅韌之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2560,"skill_field_effect_id":0,"_id_":3498,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":39,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"3499":{"attribute_id":1,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Very High damage to front enemy, dealing extra damage to normal-type enemies.","ja":"前から1番目の敵の継続プラス効果を解除し、威力(大+)の攻撃を行う　この攻撃は通常タイプの敵に特攻","ko":"앞에서 첫 번째 적의 지속 플러스 효과를 해제, 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격","zh_hant":"解除前面數來第1個敵人的持續性正面效果，並發動威力（大+）攻擊　此攻擊會對普通類型的敵人造成特攻效果"},"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Kotetsu's Roar","ja":"虎徹ノ轟咆","ko":"코테츠의 포효","zh_hant":"虎徹的轟咆"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2561,"skill_field_effect_id":0,"_id_":3499,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":306,"hit_rate":100,"target_id":2011,"times":[3,3,3,3,3],"values":[307,323,338,353,369]}]},"3532":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2592,"skill_field_effect_id":0,"_id_":3532,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3533":{"attribute_id":2,"cost":2,"description":{"en":"Medium damage to all enemies. Removes Cont. Negative Effects from all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体の継続マイナス効果を解除する","ko":"적 전체에게 위력(중) 공격, 아군 전체의 지속 마이너스 효과를 해제","zh_hant":"對所有敵人發動威力（中）攻擊，並解除所有我方的持續性負面效果"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Weir Unleashing","ja":"しがらみの解放","ko":"속박의 해방","zh_hant":"解放束縛"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2593,"skill_field_effect_id":0,"_id_":3533,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3534":{"attribute_id":2,"cost":2,"description":{"en":"Medium damage & Act Power down & Dexterity down to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、ACTパワーダウンとクリティカル率ダウンを付与する","ko":"적 전체에게 위력(중) 공격, ACT 파워 감소, 크리티컬 확률 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並降低ACT力量、會心率"},"icon_id":21,"is_multiple_command_unique_skill":0,"name":{"en":"Belligerent Smile","ja":"好戦的な笑み","ko":"호전적인 웃음","zh_hant":"好戰的笑容"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2594,"skill_field_effect_id":0,"_id_":3534,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3535":{"attribute_id":2,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Climax Act Power down & Very High damage to all enemies.","ja":"敵全体の継続プラス効果を解除し、クライマックスACT威力ダウンを付与し、威力(大+)で攻撃を行う","ko":"적 전체의 지속 플러스 효과를 해제하고 클라이맥스 ACT 위력 감소를 부여, 위력(대+) 공격","zh_hant":"解除所有敵人的持續性正面效果，降低CLIMAX ACT威力，並發動威力（大+）攻擊"},"icon_id":220,"is_multiple_command_unique_skill":0,"name":{"en":"Chariot Rampage","ja":"チャリオット・ランペイジ","ko":"채리엇 램페이지","zh_hant":"衝鋒馬車"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2595,"skill_field_effect_id":0,"_id_":3535,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":339,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[40,42,44,47,50]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3537":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2597,"skill_field_effect_id":0,"_id_":3537,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3538":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2598,"skill_field_effect_id":0,"_id_":3538,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3539":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2599,"skill_field_effect_id":0,"_id_":3539,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3540":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2600,"skill_field_effect_id":0,"_id_":3540,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3541":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Thrust","ja":"連刺突","ko":"연속 찌르기","zh_hant":"連突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2601,"skill_field_effect_id":0,"_id_":3541,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3542":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵にACTパワーダウン付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2602,"skill_field_effect_id":0,"_id_":3542,"skill_options":[{"id":9,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3543":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2603,"skill_field_effect_id":0,"_id_":3543,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3544":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、後から3体の敵に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2604,"skill_field_effect_id":0,"_id_":3544,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3545":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、後から3体の敵に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2605,"skill_field_effect_id":0,"_id_":3545,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3547":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting","ja":"狙撃","ko":"저격","zh_hant":"狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2606,"skill_field_effect_id":0,"_id_":3547,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3548":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2607,"skill_field_effect_id":0,"_id_":3548,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3549":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2608,"skill_field_effect_id":0,"_id_":3549,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3550":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2609,"skill_field_effect_id":0,"_id_":3550,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3551":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2610,"skill_field_effect_id":0,"_id_":3551,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3552":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2611,"skill_field_effect_id":0,"_id_":3552,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3553":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃し、火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Rondo","ja":"闇炎の輪舞曲","ko":"암흑 불꽃의 윤무곡","zh_hant":"暗炎圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2612,"skill_field_effect_id":0,"_id_":3553,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3554":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃し、火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2613,"skill_field_effect_id":0,"_id_":3554,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3556":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2614,"skill_field_effect_id":0,"_id_":3556,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3557":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2615,"skill_field_effect_id":0,"_id_":3557,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3558":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2616,"skill_field_effect_id":0,"_id_":3558,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3559":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2617,"skill_field_effect_id":0,"_id_":3559,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3560":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2618,"skill_field_effect_id":0,"_id_":3560,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3561":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2619,"skill_field_effect_id":0,"_id_":3561,"skill_options":[{"id":82,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,170,170,170,170]}]},"3562":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に通常バリア、特殊バリアを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2620,"skill_field_effect_id":0,"_id_":3562,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3563":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2621,"skill_field_effect_id":0,"_id_":3563,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3564":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に確率で混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2622,"skill_field_effect_id":0,"_id_":3564,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3565":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に確率で混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2623,"skill_field_effect_id":0,"_id_":3565,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3567":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":3567,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3568":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":3568,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3569":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":3569,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3570":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":3570,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3571":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":3571,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3572":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":3572,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"3573":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":3573,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3574":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に確率で睡眠を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":3574,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3576":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2632,"skill_field_effect_id":0,"_id_":3576,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3577":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2633,"skill_field_effect_id":0,"_id_":3577,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3578":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2634,"skill_field_effect_id":0,"_id_":3578,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3579":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2635,"skill_field_effect_id":0,"_id_":3579,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3580":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Thrust","ja":"連刺突","ko":"연속 찌르기","zh_hant":"連突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2636,"skill_field_effect_id":0,"_id_":3580,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3581":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体にACTパワーダウン付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2637,"skill_field_effect_id":0,"_id_":3581,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3582":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2638,"skill_field_effect_id":0,"_id_":3582,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3583":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2639,"skill_field_effect_id":0,"_id_":3583,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3584":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、敵全体に多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2640,"skill_field_effect_id":0,"_id_":3584,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3586":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2641,"skill_field_effect_id":0,"_id_":3586,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3587":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から2体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2642,"skill_field_effect_id":0,"_id_":3587,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3588":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2643,"skill_field_effect_id":0,"_id_":3588,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3589":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2644,"skill_field_effect_id":0,"_id_":3589,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3590":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2645,"skill_field_effect_id":0,"_id_":3590,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3591":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2646,"skill_field_effect_id":0,"_id_":3591,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3592":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2647,"skill_field_effect_id":0,"_id_":3592,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3593":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2648,"skill_field_effect_id":0,"_id_":3593,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3594":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2649,"skill_field_effect_id":0,"_id_":3594,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3596":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2650,"skill_field_effect_id":0,"_id_":3596,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3597":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2651,"skill_field_effect_id":0,"_id_":3597,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3598":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2652,"skill_field_effect_id":0,"_id_":3598,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3599":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2653,"skill_field_effect_id":0,"_id_":3599,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3600":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2654,"skill_field_effect_id":0,"_id_":3600,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3601":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2655,"skill_field_effect_id":0,"_id_":3601,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3602":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に通常バリア、特殊バリアを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2656,"skill_field_effect_id":0,"_id_":3602,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3603":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2657,"skill_field_effect_id":0,"_id_":3603,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3604":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、高確率で混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2658,"skill_field_effect_id":0,"_id_":3604,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3605":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、高確率で混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2659,"skill_field_effect_id":0,"_id_":3605,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3607":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":3607,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3608":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":3608,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3609":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":3609,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3610":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":3610,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3611":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":3611,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3612":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":3612,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"3613":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":3613,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3614":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、確率で睡眠を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":3614,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3615":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、確率で睡眠を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":3615,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3617":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":0,"_id_":3617,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3618":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":0,"_id_":3618,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3619":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":0,"_id_":3619,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3620":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":0,"_id_":3620,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3621":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":0,"_id_":3621,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3622":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体にACTパワーダウン付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":0,"_id_":3622,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3623":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":0,"_id_":3623,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3624":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2676,"skill_field_effect_id":0,"_id_":3624,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3625":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、敵全体に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2677,"skill_field_effect_id":0,"_id_":3625,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3627":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":0,"_id_":3627,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3628":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":0,"_id_":3628,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3629":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":0,"_id_":3629,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3630":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":0,"_id_":3630,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3631":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":0,"_id_":3631,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3632":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":0,"_id_":3632,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3633":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、高威力の火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2684,"skill_field_effect_id":0,"_id_":3633,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3634":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、高威力の火傷と暗闇を付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2685,"skill_field_effect_id":0,"_id_":3634,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3636":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":0,"_id_":3636,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3637":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":0,"_id_":3637,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3638":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(小)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":0,"_id_":3638,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3639":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"前から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":0,"_id_":3639,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3640":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":0,"_id_":3640,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3641":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":0,"_id_":3641,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3642":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"自身に通常バリア、特殊バリアを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":0,"_id_":3642,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3643":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に通常防御力ダウン、特殊防御力ダウンを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":0,"_id_":3643,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3644":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2694,"skill_field_effect_id":0,"_id_":3644,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3645":{"attribute_id":7,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、混乱を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2695,"skill_field_effect_id":0,"_id_":3645,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3647":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から1体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":3647,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3648":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から2体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":3648,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3649":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"後から3体の敵に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":3649,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3650":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":3650,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3651":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":3651,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3652":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":3652,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"3653":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":3653,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3654":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":3654,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3655":{"attribute_id":1,"cost":2,"description":{"en":"","ja":"敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する","ko":"","zh_hant":""},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":3655,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3657":{"attribute_id":4,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2705,"skill_field_effect_id":0,"_id_":3657,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3658":{"attribute_id":4,"cost":3,"description":{"en":"Very High damage & Heavy Poison & Strong Burn to all enemies.","ja":"敵全体に威力(大+)で攻撃を行い、高威力の毒と高威力の火傷を付与する","ko":"적 전체에게 위력(대+) 공격, 높은 위력의 독과 높은 위력의 화상을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並造成高威力的中毒與高威力的燒傷"},"icon_id":54,"is_multiple_command_unique_skill":0,"name":{"en":"Denunciation of Justice","ja":"正義の糾弾","ko":"정의의 규탄","zh_hant":"正義的譴責"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2706,"skill_field_effect_id":0,"_id_":3658,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[97,101,106,112,116]},{"id":54,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[3000,3500,4000,4500,5000]},{"id":55,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1000,1500,2000,2500,3000]}]},"3659":{"attribute_id":4,"cost":3,"description":{"en":"Medium damage & chance at Stop to 3 rear enemies.","ja":"後ろから3体の敵に威力(中)で攻撃を行い、一定確率でストップを付与する","ko":"뒤에서 3명의 적에게 위력(중) 공격, 일정 확률로 스톱을 부여","zh_hant":"對後面的3個敵人發動威力（中）攻擊，並以一定機率造成停止"},"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure of Justice","ja":"正義の重圧","ko":"정의의 중압","zh_hant":"正義的重壓"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2707,"skill_field_effect_id":0,"_id_":3659,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":60,"hit_rate":50,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3660":{"attribute_id":4,"cost":1,"description":{"en":"Strong Set damage to enemy with the highest Act Power.","ja":"ACTパワーが1番高い敵1体に高い固定値ダメージを与える","ko":"ACT 파워가 가장 높은 적 1명에게 높은 고정 대미지 공격","zh_hant":"對1名ACT力量最高的敵人發動強大的固定傷害攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bullet of Justice","ja":"バレット・オブ・ジャスティス","ko":"불릿 오브 저스티스","zh_hant":"Bullet of justice"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2708,"skill_field_effect_id":0,"_id_":3660,"skill_options":[{"id":320,"hit_rate":100,"target_id":2146,"times":[3,3,3,3,3],"values":[60003,70002,80001,90000,99999]}]},"3662":{"attribute_id":3,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2710,"skill_field_effect_id":0,"_id_":3662,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3663":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy. Dexterity up & Critical up to all allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、味方全体にクリティカル率アップ、クリティカル威力アップを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的會心率、會心威力"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Trustworthy Light","ja":"信頼の光","ko":"신뢰의 빛","zh_hant":"信賴之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2711,"skill_field_effect_id":0,"_id_":3663,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]}]},"3664":{"attribute_id":3,"cost":1,"description":{"en":"Aggro to all enemies. Evasion Rate Up & Dmg Received down to self.","ja":"敵全体にターゲット固定を付与し、自身に回避率アップと被ダメージダウンを付与する","ko":"적 전체에게 타깃 고정을 부여, 자신에게 회피 확률 증가와 받는 대미지 감소를 부여","zh_hant":"賦予所有敵人目標鎖定，並提升自己的迴避率與降低自己受到的傷害"},"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"King's Guidance","ja":"王の導き","ko":"왕의 인도","zh_hant":"王之指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2712,"skill_field_effect_id":0,"_id_":3664,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,32,35,40,50]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"3665":{"attribute_id":3,"cost":2,"description":{"en":"Very High damage to enemy with the highest Act Power, dealing extra damage to enemies inflicted with Freeze. Removes Exit from 1 rear ally. ","ja":"ACTパワーの1番高い敵に威力(大+)の攻撃を行い、退場した中で後ろから1体の味方の退場状態を解除する　この攻撃は凍結状態の敵に特攻","ko":"ACT 파워가 가장 높은 적 1명에게 위력(대+) 공격, 퇴장한 아군 중 뒤에서 1명의 퇴장 상태를 해제, 이 공격은 동결 상태의 적에게 특수 공격","zh_hant":"對1名ACT力量最高的敵人發動威力（大+）攻擊，從已退場的舞台少女中解除後面1名我方的退場狀態　此攻擊會對凍結狀態的敵方造成特攻效果"},"icon_id":197,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Peace","ja":"道に光を、戦場に花を","ko":"길에 빛을, 전장에 꽃을","zh_hant":"光綻放於道路，花盛開於戰場"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2713,"skill_field_effect_id":0,"_id_":3665,"skill_options":[{"id":283,"hit_rate":100,"target_id":2051,"times":[4,4,4,4,4],"values":[307,323,338,353,369]},{"id":309,"hit_rate":100,"target_id":11012,"times":[0,0,0,0,0],"values":[40,42,44,47,50]}]},"3667":{"attribute_id":2,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2715,"skill_field_effect_id":0,"_id_":3667,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3668":{"attribute_id":2,"cost":2,"description":{"en":"Medium damage to rear enemy. Act Power up & Effective element damage up to all allies.","ja":"後ろから1番目の敵に威力(中)の攻撃を行い、味方全体にACTパワーアップ、有利属性ダメージアップを付与する","ko":"뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여","zh_hant":"對後面數來第1個敵人發動威力（中）攻擊，並提升所有我方的ACT力量、對有利屬性的傷害"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Victory Battle","ja":"勝利の戦","ko":"승리의 전쟁","zh_hant":"勝利之戰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2716,"skill_field_effect_id":0,"_id_":3668,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3669":{"attribute_id":2,"cost":3,"description":{"en":"High damage to rear enemy. Dexterity up & Effective element damage up to all allies.","ja":"後ろから1番目の敵に威力(大)の攻撃を行い、味方全体にクリティカル率アップ、有利属性ダメージアップを付与する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，並提升所有我方的會心率、對有利屬性的傷害"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Furious War","ja":"激情の乱","ko":"격정의 난","zh_hant":"激情之亂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2717,"skill_field_effect_id":0,"_id_":3669,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3670":{"attribute_id":2,"cost":2,"description":{"en":"Flip Positive Effects x5 & Very High damage to rear enemy, dealing extra damage to normal-type enemies.","ja":"後ろから1番目の敵に5回分のプラス効果反転を適用し、威力(大+)で攻撃を行う　この攻撃は通常タイプの敵に特攻","ko":"뒤에서 첫 번째 적에게 5회분의 플러스 효과 반전을 적용, 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격","zh_hant":"對後面數來第1個敵人施加5次正面狀態效果反轉，並發動威力（大+）攻擊 此攻擊會對普通類型的敵人造成特攻效果"},"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Invincible Spear","ja":"天下無敵の槍","ko":"천하무적의 창","zh_hant":"天下無敵之槍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2718,"skill_field_effect_id":0,"_id_":3670,"skill_options":[{"id":323,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":306,"hit_rate":100,"target_id":2121,"times":[3,3,3,3,3],"values":[307,323,338,353,369]}]},"3677":{"attribute_id":1,"cost":2,"description":{"en":"Medium+ damage to 3 front enemies.","ja":"前から3体の敵に威力(中+)の攻撃","ko":"앞에서 3명의 적에게 위력(중+) 공격","zh_hant":"對前方的3個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2720,"skill_field_effect_id":0,"_id_":3677,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"3678":{"attribute_id":1,"cost":2,"description":{"en":"Removes Cont. Positive Effects to all enemies. Removes Cont. Negative Effects from all allies.","ja":"敵全体の継続プラス効果を解除し、味方全体の継続マイナス効果を解除する","ko":"적 전체의 지속 플러스 효과를 해제하고, 아군 전체의 지속 마이너스 효과를 해제","zh_hant":"解除所有敵人的持續性正面效果，並解除所有我方的持續性負面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Dream & Reality","ja":"夢と現実","ko":"꿈과 현실","zh_hant":"夢與現實"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2721,"skill_field_effect_id":0,"_id_":3678,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3679":{"attribute_id":1,"cost":3,"description":{"en":"Very High damage & chance at Sleep to all enemies.","ja":"敵全体に威力(大+)の攻撃を行い、一定確率で睡眠を付与する","ko":"적 전체에게 위력(대+) 공격, 일정 확률로 수면을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並在一定機率下造成睡眠"},"icon_id":58,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Dreams","ja":"安らかな眠り","ko":"편안한 잠","zh_hant":"安詳的睡眠"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2722,"skill_field_effect_id":0,"_id_":3679,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[97,101,106,112,116]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3680":{"attribute_id":1,"cost":2,"description":{"en":"Very High damage to all enemies. Applies Stage Effect [Light of Courage] to allies' stage.","ja":"敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「勇気の灯」を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [용기의 등불]을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「勇氣之燈」"},"icon_id":1000,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Dream","ja":"パーフェクトドリーム","ko":"퍼펙트 드림","zh_hant":"完美的夢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2723,"skill_field_effect_id":1,"_id_":3680,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3682":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2725,"skill_field_effect_id":0,"_id_":3682,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3683":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy, dealing extra damage to normal-type enemies.","ja":"前から1番目の敵に威力(大)で攻撃 この攻撃は通常タイプの敵に特攻","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 일반 타입인 적에게 특수 공격","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對普通類型的敵人造成特攻效果"},"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Imagination Flash","ja":"想像の一閃","ko":"상상의 일섬","zh_hant":"想像閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2726,"skill_field_effect_id":0,"_id_":3683,"skill_options":[{"id":306,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"3684":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy. AP Down to 3 rear allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、後ろから3体の味方にAP減少を付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 AP 감소를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並賦予後面3名我方AP減少"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Dream Song","ja":"夢の歌","ko":"꿈의 노래","zh_hant":"夢之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2727,"skill_field_effect_id":0,"_id_":3684,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3685":{"attribute_id":7,"cost":2,"description":{"en":"Very High damage to enemy with the highest Act Power, dealing extra damage to normal-type enemies.","ja":"ACTパワーが高い敵1体に威力(大+)の攻撃 この攻撃は通常タイプの敵に特攻","ko":"ACT 파워가 높은 적 1명에게 위력(대+) 공격, 이 공격은 일반 타입인 적에게 특수 공격","zh_hant":"對1名ACT力量高的敵人發動威力（大+）攻擊，此攻擊會對普通類型的敵方造成特攻效果"},"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Pillow Storm!","ja":"高速マクラ！　乱れ投げ！","ko":"고속 베개! 마구 던지기!","zh_hant":"高速亂投枕！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2728,"skill_field_effect_id":0,"_id_":3685,"skill_options":[{"id":306,"hit_rate":100,"target_id":2051,"times":[5,5,5,5,5],"values":[307,323,338,353,369]}]},"3703":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2743,"skill_field_effect_id":0,"_id_":3703,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3704":{"attribute_id":7,"cost":2,"description":{"en":"Medium damage to all enemies. Perfect Aim & Damage Received down to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体に必中と被ダメージダウンを付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 백발백중, 받는 대미지 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，賦予所有我方必中，並降低所有我方受到的傷害"},"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Earnest Love","ja":"一途な思い","ko":"일편단심","zh_hant":"專情"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2744,"skill_field_effect_id":0,"_id_":3704,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":35,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":126,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"3705":{"attribute_id":7,"cost":2,"description":{"en":"Medium damage to all enemies. Unremovable Cont. Negative Effects Resistance to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体に解除不可の継続マイナス効果耐性を付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 해제 불가능한 지속 마이너스 효과 저항을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並賦予所有我方無法解除的持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Fleeting Love","ja":"淡い恋心","ko":"아련한 연심","zh_hant":"心懷戀慕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2745,"skill_field_effect_id":0,"_id_":3705,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":346,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]}]},"3706":{"attribute_id":7,"cost":1,"description":{"en":"High damage & Lovesickness to all enemies.","ja":"敵全体に威力(大)で攻撃を行い、恋わずらいを付与する","ko":"적 전체에게 위력(대) 공격, 상사병을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並造成苦戀"},"icon_id":221,"is_multiple_command_unique_skill":0,"name":{"en":"Labyrinthine Love","ja":"恋は迷宮","ko":"사랑은 미궁","zh_hant":"戀愛迷宮"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2746,"skill_field_effect_id":0,"_id_":3706,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[117,123,128,134,140]},{"id":340,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3708":{"attribute_id":5,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2748,"skill_field_effect_id":0,"_id_":3708,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3709":{"attribute_id":5,"cost":2,"description":{"en":"Act Power up & Critical up to self. Medium damage to enemy with the highest Act Power.","ja":"自身にACTパワーアップ、クリティカル威力アップを付与し、ACTパワーの1番高い敵に威力(中)の攻撃を行う","ko":"자신에게 ACT 파워 증가, 크리티컬 위력 증가를 부여, ACT 파워가 가장 높은 적에게 위력(중) 공격","zh_hant":"提升自己的ACT力量、會心威力，並對1名ACT力量最高的敵人發動威力（中）攻擊"},"icon_id":22,"is_multiple_command_unique_skill":0,"name":{"en":"Spearheading Blade","ja":"先陣を切る刃","ko":"선두를 달리는 칼날","zh_hant":"先鋒之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2749,"skill_field_effect_id":0,"_id_":3709,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"3710":{"attribute_id":5,"cost":2,"description":{"en":"Dexterity up & Effective element damage up to self. High damage to enemy with the highest Act Power","ja":"自身にクリティカル率アップ、有利属性ダメージアップを付与し、ACTパワーの1番高い敵に威力(大)の攻撃を行う","ko":"자신에게 크리티컬 확률 증가, 유리한 속성 대미지 증가를 부여,  ACT 파워가 가장 높은 적에게 위력(대) 공격","zh_hant":"提升自己的會心率、有利屬性傷害，並對1名ACT力量最高的敵人發動威力（大）攻擊"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Dashing Blade","ja":"颯爽たる刃","ko":"씩씩한 칼날","zh_hant":"颯爽之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2750,"skill_field_effect_id":0,"_id_":3710,"skill_options":[{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":39,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"3711":{"attribute_id":5,"cost":2,"description":{"en":"Marked & Normal Defense down & Very High damage to enemy with the highest Act Power, dealing extra damage to special-type enemies.","ja":"ACTパワーの1番高い敵に刻印と通常防御力ダウンを付与し、威力(大+)の攻撃を行う　この攻撃は特殊タイプの敵に特攻","ko":"ACT 파워가 가장 높은 적에게 각인과 일반 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"賦予1名ACT力量最高的敵人刻印、降低普通防禦力，並發動威力（大+）攻擊　此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Greatest Spear","ja":"日ノ本一の槍","ko":"최고의 창","zh_hant":"日本第一之槍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2751,"skill_field_effect_id":0,"_id_":3711,"skill_options":[{"id":150,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2051,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":308,"hit_rate":100,"target_id":2051,"times":[3,3,3,3,3],"values":[307,323,338,353,369]}]},"3713":{"attribute_id":5,"cost":2,"description":{"en":"Low damage to rear enemy. Low Brilliance recovery to self.","ja":"後ろから1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"뒤에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對後面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Slash","ja":"キラめきの剣撃","ko":"반짝임의 검격","zh_hant":"光芒劍擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2753,"skill_field_effect_id":0,"_id_":3713,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3714":{"attribute_id":5,"cost":2,"description":{"en":"Medium damage to all enemies. Act Power up & AP Down to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体にACTパワーアップとAP減少を付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가와 AP 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並提升所有我方的ACT力量，同時賦予AP減少"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Justice","ja":"正義の剣","ko":"정의의 검","zh_hant":"正義之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2754,"skill_field_effect_id":0,"_id_":3714,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3715":{"attribute_id":5,"cost":2,"description":{"en":"High damage to rear enemy. Removes Cont. Negative Effects & HP recovery to all allies.","ja":"後ろから1番目の敵に威力(大)で攻撃を行い、味方全体の継続マイナス効果を解除し、HPを回復する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 아군 전체의 지속 마이너스 효과를 해제, HP를 회복","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，解除所有我方的持續性負面效果，並回復HP"},"icon_id":6,"is_multiple_command_unique_skill":0,"name":{"en":"Right Judgement","ja":"正しき裁き","ko":"올바른 심판","zh_hant":"正當判決"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2755,"skill_field_effect_id":0,"_id_":3715,"skill_options":[{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,27,30]}]},"3716":{"attribute_id":5,"cost":2,"description":{"en":"Act Power up & Dexterity up & Critical up to self. Extremely High damage to all enemies.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与し、敵全体に威力(特大)で攻撃を行う","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여, 적 전체에게 위력(특대) 공격","zh_hant":"提升自己的ACT力量＆會心率＆會心威力，並對所有敵人發動威力（特大）攻擊"},"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Absolute Justice","ja":"絶対正義　強制断罪","ko":"절대정의 강제단죄","zh_hant":"絕對正義　強制定罪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2756,"skill_field_effect_id":0,"_id_":3716,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"3718":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2758,"skill_field_effect_id":0,"_id_":3718,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3719":{"attribute_id":1,"cost":2,"description":{"en":"Medium damage & Act Power down & Accuracy Rate down to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、ACTパワーダウンと命中率ダウンを付与する","ko":"적 전체에게 위력(중) 공격, ACT 파워 감소, 명중률 감소를 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並降低ACT力量、命中率"},"icon_id":17,"is_multiple_command_unique_skill":0,"name":{"en":"Sun Glamor","ja":"陽の幻惑","ko":"태양의 환혹","zh_hant":"陽之誘惑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2759,"skill_field_effect_id":0,"_id_":3719,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,32,34,37,40]}]},"3720":{"attribute_id":1,"cost":2,"description":{"en":"Medium damage & Strong Burn to all enemies.","ja":"敵全体に威力(中)で攻撃を行い、高威力の火傷を付与する","ko":"적 전체에게 위력(중) 공격, 높은 위력의 화상을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並造成高威力的燒傷"},"icon_id":55,"is_multiple_command_unique_skill":0,"name":{"en":"Raging Sun","ja":"猛炎の太陽","ko":"맹염의 태양","zh_hant":"猛炎之太陽"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2760,"skill_field_effect_id":0,"_id_":3720,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":55,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1000,1500,2000,2500,3000]}]},"3721":{"attribute_id":1,"cost":2,"description":{"en":"Unremovable Heavy Burn & Special Defense down & Very High damage to all enemies. Deals extra damage to enemies inflicted with Burn.","ja":"敵全体に解除不可の大火傷と特殊防御力ダウンを付与し、威力(大+)で攻撃を行う この攻撃は火傷状態の敵に対して特攻","ko":"적 전체에게 해제 불가능한 대화상과 특수 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 화상 상태의 적에게 특수 공격","zh_hant":"賦予所有敵人無法解除的嚴重燒傷並降低特殊防禦力，發動威力（大+）攻擊 此攻擊會對燒傷的敵人造成特攻效果"},"icon_id":55,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant☆Sunshine!","ja":"燦々☆サンシャイン！","ko":"눈부시게 빛나는 ☆선샤인!","zh_hant":"燦爛☆陽光！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2761,"skill_field_effect_id":0,"_id_":3721,"skill_options":[{"id":304,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5,6,7,8,10]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":277,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[125,135,145,155,170]}]},"3723":{"attribute_id":4,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2763,"skill_field_effect_id":0,"_id_":3723,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3724":{"attribute_id":4,"cost":2,"description":{"en":"High damage to front enemy. Counter Heal to all allies.","ja":"前から1番目の敵に威力(大)で攻撃を行い、味方全体にカウンターヒールを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 카운터 힐을 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並賦予所有我方還擊治療"},"icon_id":45,"is_multiple_command_unique_skill":0,"name":{"en":"Healing Prayer","ja":"治癒の祈り","ko":"치유의 기도","zh_hant":"治癒的祈禱"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2764,"skill_field_effect_id":0,"_id_":3724,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":241,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[5,6,7,8,10]}]},"3725":{"attribute_id":4,"cost":1,"description":{"en":"Aggro to all enemies. Normal Barrier & Special Barrier to self.","ja":"敵全体にターゲット固定を付与し、自身に通常バリアと特殊バリアを付与する","ko":"적 전체에게 타깃 고정을 부여, 자신에게 일반 배리어와 특수 배리어를 부여","zh_hant":"賦予所有敵人目標鎖定，並賦予自身普通防護罩、特殊防護罩"},"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Solid Shield","ja":"堅強の盾","ko":"견고한 방패","zh_hant":"堅強之盾"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2765,"skill_field_effect_id":0,"_id_":3725,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"3726":{"attribute_id":4,"cost":2,"description":{"en":"Very High damage to enemy with the highest Act Power. Absorb & Damage Received down to all allies.","ja":"ACTパワーの一番高い敵に威力(大+)で攻撃を行い、味方全体に吸収と被ダメージダウンを付与する","ko":"ACT 파워가 가장 높은 적에게 위력(대+) 공격, 아군 전체에게 흡수와 받는 대미지 감소를 부여","zh_hant":"對ACT力量最高的敵人發動威力（大+）攻擊，賦予所有我方吸收，並降低受到的傷害"},"icon_id":44,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament","ja":"秘石が導く月光の秘蹟","ko":"보석이 인도하는 달빛의 성례","zh_hant":"由秘石所引導的月光秘蹟"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2766,"skill_field_effect_id":0,"_id_":3726,"skill_options":[{"id":82,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[328,345,361,378,394]},{"id":44,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,23,26,29,33]},{"id":126,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"3728":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2768,"skill_field_effect_id":0,"_id_":3728,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3729":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2769,"skill_field_effect_id":0,"_id_":3729,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3730":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2770,"skill_field_effect_id":0,"_id_":3730,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3731":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2771,"skill_field_effect_id":0,"_id_":3731,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3732":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2772,"skill_field_effect_id":0,"_id_":3732,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3733":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies. Dmg Received down to self.","ja":"前から3体の敵に威力(大)で攻撃し、自身に被ダメージダウンを付与する","ko":"앞에서 3명의 적에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여","zh_hant":"對前方的3個敵人發動威力（大）攻擊，並降低自身受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Protection","ja":"加護の刺突","ko":"가호의 찌르기","zh_hant":"加護突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2773,"skill_field_effect_id":0,"_id_":3733,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3734":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2774,"skill_field_effect_id":0,"_id_":3734,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3735":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2775,"skill_field_effect_id":0,"_id_":3735,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3736":{"attribute_id":6,"cost":2,"description":{"en":"Set chance to inflict Poison & Confusion to all enemies.","ja":"敵全体に確率で毒と混乱を付与","ko":"적 전체에게 일정 확률로 독, 혼란을 부여","zh_hant":"機率性賦予所有敵人中毒和混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2776,"skill_field_effect_id":0,"_id_":3736,"skill_options":[{"id":54,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3738":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2777,"skill_field_effect_id":0,"_id_":3738,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3739":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2778,"skill_field_effect_id":0,"_id_":3739,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3740":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2779,"skill_field_effect_id":0,"_id_":3740,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3741":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2780,"skill_field_effect_id":0,"_id_":3741,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3742":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2781,"skill_field_effect_id":0,"_id_":3742,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3743":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies. Dmg Received down to self.","ja":"敵全体に威力(大)で攻撃じ、自身に被ダメージダウンを付与する","ko":"적 전체에게 위력(대) 공격, 자신에게 받는 대미지 감소를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並降低自身受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Protection","ja":"加護の刺突","ko":"가호의 찌르기","zh_hant":"加護突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2782,"skill_field_effect_id":0,"_id_":3743,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3744":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2783,"skill_field_effect_id":0,"_id_":3744,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3745":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2784,"skill_field_effect_id":0,"_id_":3745,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3746":{"attribute_id":6,"cost":2,"description":{"en":"High damage & High chance at Poison & Confusion to all enemies","ja":"敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Thrust","ja":"毒惑の刺突","ko":"독혹의 찌르기","zh_hant":"毒惑突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2785,"skill_field_effect_id":0,"_id_":3746,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":54,"hit_rate":75,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3747":{"attribute_id":6,"cost":2,"description":{"en":"High damage & High chance at Poison & Confusion to all enemies","ja":"敵全体に威力(大)で攻撃し、高確率で毒と混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 독, 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2786,"skill_field_effect_id":0,"_id_":3747,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":75,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3749":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Thrust","ja":"強襲の刺突","ko":"강습의 찌르기","zh_hant":"強襲突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2787,"skill_field_effect_id":0,"_id_":3749,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3750":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2788,"skill_field_effect_id":0,"_id_":3750,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3751":{"attribute_id":6,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2789,"skill_field_effect_id":0,"_id_":3751,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3752":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2790,"skill_field_effect_id":0,"_id_":3752,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3753":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies. Strong Dmg Received down to self.","ja":"敵全体に強力な多段攻撃を行い、自身に強力な被ダメージダウンを付与する","ko":"적 전체에게 강력한 다단 공격, 자신에게 강력한 받는 대미지 감소를 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並大幅降低自己受到的傷害"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Protection","ja":"加護の刺突","ko":"가호의 찌르기","zh_hant":"加護突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2791,"skill_field_effect_id":0,"_id_":3753,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":126,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3754":{"attribute_id":6,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2792,"skill_field_effect_id":0,"_id_":3754,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3755":{"attribute_id":6,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2793,"skill_field_effect_id":0,"_id_":3755,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3756":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack & Poison & Confusion to all enemies","ja":"敵全体に強力な多段攻撃を行い、毒と混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 독, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Thrust","ja":"毒惑の刺突","ko":"독혹의 찌르기","zh_hant":"毒惑突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2794,"skill_field_effect_id":0,"_id_":3756,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3757":{"attribute_id":6,"cost":2,"description":{"en":"Strong Multi-hit attack & Poison & Confusion to all enemies","ja":"敵全体に強力な多段攻撃を行い、毒と混乱を付与する","ko":"적 전체에게 강력한 다단 공격, 독, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予中毒、混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2795,"skill_field_effect_id":0,"_id_":3757,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3759":{"attribute_id":1,"cost":2,"description":{"en":"Removes Cont. Negative Effects and applies Cont. Negative Effects Resistance to 3 front allies. Medium damage to 3 front enemies.","ja":"前から3体の味方の継続マイナス効果を解除し、継続マイナス効果耐性を付与し、前から3体の敵に威力(中)の攻撃を行う","ko":"앞에서 3명의 아군의 지속 마이너스 효과를 해제, 지속 마이너스 효과 저항을 부여, 앞에서 3명의 적에게 위력(중) 공격","zh_hant":"解除前面3名我方的持續性負面效果，賦予持續性負面效果耐性，並對前面的3個敵人發動威力（中）攻擊"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Holy Slash","ja":"神域の斬撃","ko":"신역의 참격","zh_hant":"神域斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2796,"skill_field_effect_id":0,"_id_":3759,"skill_options":[{"id":128,"hit_rate":100,"target_id":1133,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1133,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"3760":{"attribute_id":1,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Medium damage to 3 front enemies.","ja":"前から3体の敵の継続プラス効果を解除し、威力(中)の攻撃を行う","ko":"앞에서 3명의 적의 지속 플러스 효과를 해제, 위력(중) 공격","zh_hant":"解除前面3個敵人的持續性正面效果，並發動威力（中）攻擊"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Severing Slash","ja":"断切の斬撃","ko":"단절의 참격","zh_hant":"切斷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2797,"skill_field_effect_id":0,"_id_":3760,"skill_options":[{"id":127,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"3761":{"attribute_id":1,"cost":2,"description":{"en":"Dexterity up & Critical up to self. Medium damage to 3 front enemies.","ja":"自身にクリティカル率アップ、クリティカル威力アップを付与し、前から3体の敵に威力(中)の攻撃を行う","ko":"자신에게 크리티컬 확률 증가, 크리티컬 위력 증가를 부여하고, 앞에서 3명의 적에게 위력(중) 공격","zh_hant":"提升自己的會心率、會心威力，並對前面3個敵人發動威力（中）攻擊"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Flash Slash","ja":"閃光の斬撃","ko":"섬광의 참격","zh_hant":"閃光斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2798,"skill_field_effect_id":0,"_id_":3761,"skill_options":[{"id":20,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"3762":{"attribute_id":1,"cost":2,"description":{"en":"Normal Defense down & Perfect Aim Very High damage to 3 front enemies, ignoring Aggro, Provoke, Barrier, Reflect and Invincible.","ja":"前から3体の敵に通常防御力ダウンを付与し、威力(大+)の必中攻撃を行う この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する","ko":"앞에서 3명의 적에게 일반 방어력 감소를 부여, 위력(대+)의 백발백중 공격, 이 공격은 타깃 고정, 도발, 배리어, 반사, 무적을 무시","zh_hant":"降低前方3個敵人的普通防禦力，並發動威力（大+）的必中攻擊 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵"},"icon_id":198,"is_multiple_command_unique_skill":0,"name":{"en":"I spread my wings, to Frontier!","ja":"その羽広げてすすめフロンティア！","ko":"날개를 펼치고 나아가라 프론티어!","zh_hant":"展開雙翅飛向燦爛邊疆！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2799,"skill_field_effect_id":0,"_id_":3762,"skill_options":[{"id":11,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":310,"hit_rate":100,"target_id":2177,"times":[3,3,3,3,3],"values":[186,200,214,228,243]}]},"3770":{"attribute_id":2,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2802,"skill_field_effect_id":0,"_id_":3770,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3771":{"attribute_id":2,"cost":2,"description":{"en":"High damage to front enemy, dealing extra damage to special-type enemies.","ja":"前から1番目の敵に威力(大)で攻撃 この攻撃は特殊タイプの敵に特攻","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Creation Slash","ja":"創造の斬撃","ko":"창조의 참격","zh_hant":"創造斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2803,"skill_field_effect_id":0,"_id_":3771,"skill_options":[{"id":308,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"3772":{"attribute_id":2,"cost":2,"description":{"en":"High damage to front enemy. Effective element damage up to 3 rear allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、後ろから3体の味方に有利属性ダメージアップを付与する","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 뒤에서 3명의 아군에게 유리한 속성 대미지 증가를 부여","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升後面3名我方的有利屬性傷害"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"General's Oath","ja":"騎士団長の誓い","ko":"기사단장의 맹세","zh_hant":"騎士團長的誓言"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2804,"skill_field_effect_id":0,"_id_":3772,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":39,"hit_rate":100,"target_id":1143,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3773":{"attribute_id":2,"cost":2,"description":{"en":"Very High damage to enemy with the highest Act Power, dealing extra damage to special-type enemies.","ja":"ACTパワーが高い敵1体に威力(大+)の攻撃 この攻撃は特殊タイプの敵に特攻","ko":"ACT 파워가 높은 적 1명에게 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對1名ACT力量高的敵人發動威力（大+）攻擊 此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Black Lion's Scratch Encore","ja":"黒獅子の爪痕 Encore","ko":"흑사자의 조흔 Encore","zh_hant":"黑獅子爪痕 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2805,"skill_field_effect_id":0,"_id_":3773,"skill_options":[{"id":308,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[307,323,338,353,369]}]},"3775":{"attribute_id":3,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Medium damage to 3 front enemies.","ja":"前から3体の敵の継続プラス効果を解除し、威力(中)の攻撃を行う","ko":"앞에서 3명의 적의 지속 플러스 효과를 해제, 위력(중) 공격","zh_hant":"解除前面3個敵人的持續性正面效果，並發動威力（中）攻擊"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Purity of Courage","ja":"勇気の浄化","ko":"용기의 정화","zh_hant":"勇氣的淨化"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2807,"skill_field_effect_id":0,"_id_":3775,"skill_options":[{"id":127,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"3776":{"attribute_id":3,"cost":2,"description":{"en":"High damage & High chance at Confusion & Blindness to all enemies.","ja":"敵全体に威力(大)で攻撃を行い、高確率で混乱と暗闇を付与する","ko":"적 전체에게 위력(대) 공격, 높은 확률로 혼란과 암흑을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率賦予混亂與盲目"},"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Repression","ja":"抑圧の剣","ko":"억압의 검","zh_hant":"壓抑之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2808,"skill_field_effect_id":0,"_id_":3776,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":62,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3777":{"attribute_id":3,"cost":3,"description":{"en":"High damage to all enemies. Special Barrier & Evasion x1 to all allies.","ja":"敵全体に威力(大)で攻撃を行い、味方全体に特殊バリアと回避を1回付与する","ko":"적 전체에게 위력(대) 공격, 아군 전체에게 특수 배리어와 회피 1회를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予所有我方特殊防護罩與迴避1次"},"icon_id":34,"is_multiple_command_unique_skill":0,"name":{"en":"General's Guidance","ja":"騎士団長の導き","ko":"기사단장의 인도","zh_hant":"騎士團長的引導"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2809,"skill_field_effect_id":0,"_id_":3777,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[5000,6000,7000,8000,10000]},{"id":34,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3778":{"attribute_id":3,"cost":2,"description":{"en":"Very High damage to all enemies. Applies Stage Effect [Sunset Tune] to enemies' stage.","ja":"敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「落日の音色」を付与する","ko":"적 전체에게 위력(대+) 공격, 적 쪽 무대에 무대 효과 [낙조의 음색]을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「落日音色」"},"icon_id":1007,"is_multiple_command_unique_skill":0,"name":{"en":"Celestial Truth Encore","ja":"天道の理 Encore","ko":"천도의 이치 Encore","zh_hant":"天道之理 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2810,"skill_field_effect_id":11,"_id_":3778,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3791":{"attribute_id":3,"cost":2,"description":{"en":"Medium+ damage to 3 front enemies.","ja":"前から3体の敵に威力(中+)の攻撃","ko":"앞에서 3명의 적에게 위력(중+) 공격","zh_hant":"對前方的3個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Sharpshooting","ja":"激化の狙撃","ko":"격화의 저격","zh_hant":"激化狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2813,"skill_field_effect_id":0,"_id_":3791,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"3792":{"attribute_id":3,"cost":2,"description":{"en":"High damage & Brilliance Recovery down & Special Defense down to all enemies.","ja":"敵全体に威力(大)で攻撃を行い、キラめき獲得ダウンと特殊防御力ダウンを付与する","ko":"적 전체에게 위력(대) 공격, 반짝임 획득 감소와 특수 방어력 감소를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予獲得光芒減少效果，且降低特殊防禦力"},"icon_id":192,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Shooting","ja":"減光の射撃","ko":"감광의 사격","zh_hant":"減光射擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2814,"skill_field_effect_id":0,"_id_":3792,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3793":{"attribute_id":3,"cost":3,"description":{"en":"AP Up to all enemies. AP Down to all allies.","ja":"敵全体にAP増加を付与し、味方全体にAP減少を付与する","ko":"적 전체에게 AP 증가를 부여, 아군 전체에게 AP 감소를 부여","zh_hant":"賦予所有敵人AP增加效果，並賦予所有我方AP減少效果"},"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Reverse Situation","ja":"形勢逆転","ko":"형세 역전","zh_hant":"形勢逆轉"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2815,"skill_field_effect_id":0,"_id_":3793,"skill_options":[{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3794":{"attribute_id":3,"cost":2,"description":{"en":"Very High damage to all enemies. Applies Stage Effect [Shadow Stupor] to enemies' stage.","ja":"敵全体に威力(大+)で攻撃を行い、舞台の敵側に舞台効果「昏迷の影」を付与する","ko":"적 전체에게 위력(대+) 공격, 무대의 적에게 무대 효과 [혼미의 그림자]를 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「昏迷之影」"},"icon_id":1008,"is_multiple_command_unique_skill":0,"name":{"en":"Golden Duel","ja":"ゴールデン・デュエル","ko":"골든 듀얼","zh_hant":"黃金的決鬥"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2816,"skill_field_effect_id":12,"_id_":3794,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3796":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to rear enemy. Low Brilliance recovery to self.","ja":"後ろから1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"뒤에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對後面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Slash","ja":"キラめきの剣撃","ko":"반짝임의 검격","zh_hant":"光芒劍擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2818,"skill_field_effect_id":0,"_id_":3796,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3797":{"attribute_id":1,"cost":2,"description":{"en":"Medium damage to rear enemy. Act Power up & Effective element damage up to all allies.","ja":"後ろから1番目の敵に威力(中)で攻撃を行い、味方全体にACTパワーアップ、有利属性ダメージアップを付与する","ko":"뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 ACT 파워 증가, 유리한 속성 대미지 증가를 부여","zh_hant":"對後面數來第1個敵人發動威力（中）攻擊，並提升所有我方的ACT力量、對有利屬性的傷害"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Soul Contract","ja":"魂の契約","ko":"영혼의 계약","zh_hant":"靈魂之契約"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2819,"skill_field_effect_id":0,"_id_":3797,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3798":{"attribute_id":1,"cost":3,"description":{"en":"High damage to rear enemy. Removes Cont. & Count. Positive Effects to all enemies.","ja":"後ろから1番目の敵に威力(大)で攻撃を行い、敵全体の継続プラス効果と回数プラス効果を解除する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 적 전체의 지속 플러스 효과와 횟수 플러스 효과를 해제","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，並解除所有敵人的持續性正面效果與次數性正面效果"},"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Devil's Whisper","ja":"悪魔の囁き","ko":"악마의 속삭임","zh_hant":"惡魔的低語"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2820,"skill_field_effect_id":0,"_id_":3798,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":338,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3799":{"attribute_id":1,"cost":2,"description":{"en":"Removes Cont. Negative Effects from all allies. Removes Cont. Positive Effects & Extremely High damage to all enemies.","ja":"味方全体の継続マイナス効果を解除し、敵全体の継続プラス効果を解除し、威力(特大)で攻撃を行う","ko":"아군 전체의 지속 마이너스 효과를 해제하고, 적 전체의 지속 플러스 효과를 해제, 위력(특대) 공격","zh_hant":"解除所有我方的持續性負面效果與所有敵方的持續性正面效果，並發動威力（特大）的攻擊"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Flames of Hell","ja":"来たれ、地獄の業火よ","ko":"오너라, 지옥의 업화여","zh_hant":"來吧，地獄之火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2821,"skill_field_effect_id":0,"_id_":3799,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"3801":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flash","ja":"一閃","ko":"일섬","zh_hant":"閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2823,"skill_field_effect_id":0,"_id_":3801,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3802":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2824,"skill_field_effect_id":0,"_id_":3802,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3803":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Twin Flash","ja":"双一閃","ko":"쌍일섬","zh_hant":"雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2825,"skill_field_effect_id":0,"_id_":3803,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3804":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2826,"skill_field_effect_id":0,"_id_":3804,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3805":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flash Flurry","ja":"連一閃","ko":"연일섬","zh_hant":"連閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2827,"skill_field_effect_id":0,"_id_":3805,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3806":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to 3 front enemies.","ja":"前から3体の敵にACTパワーダウン付与","ko":"앞에서 3명의 적에게 ACT 파워 감소를 부여","zh_hant":"降低前方3個敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2828,"skill_field_effect_id":0,"_id_":3806,"skill_options":[{"id":9,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3807":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2829,"skill_field_effect_id":0,"_id_":3807,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3808":{"attribute_id":7,"cost":2,"description":{"en":"Poison to all enemies.","ja":"敵全体に毒を付与する","ko":"적 전체에게 독을 부여","zh_hant":"賦予所有敵人中毒效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2830,"skill_field_effect_id":0,"_id_":3808,"skill_options":[{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3809":{"attribute_id":7,"cost":2,"description":{"en":"Poison to all enemies.","ja":"敵全体に毒を付与する","ko":"적 전체에게 독을 부여","zh_hant":"賦予所有敵人中毒效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2831,"skill_field_effect_id":0,"_id_":3809,"skill_options":[{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3811":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2832,"skill_field_effect_id":0,"_id_":3811,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3812":{"attribute_id":2,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2833,"skill_field_effect_id":0,"_id_":3812,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3813":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2834,"skill_field_effect_id":0,"_id_":3813,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3814":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2835,"skill_field_effect_id":0,"_id_":3814,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3815":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim to self. High damage to rear enemy.","ja":"自身に必中を付与し、後から1体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2836,"skill_field_effect_id":0,"_id_":3815,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3816":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2837,"skill_field_effect_id":0,"_id_":3816,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3817":{"attribute_id":2,"cost":2,"description":{"en":"High damage & High chance at Confusion to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、高確率で混乱を付与","ko":"뒤에서부터 3명의 적에게 위력(대) 공격, 높은 확률로 혼란을 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並以高機率造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2838,"skill_field_effect_id":0,"_id_":3817,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3818":{"attribute_id":2,"cost":2,"description":{"en":"High damage & High chance at Confusion to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、高確率で混乱を付与","ko":"뒤에서부터 3명의 적에게 위력(대) 공격, 높은 확률로 혼란을 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並以高機率造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2839,"skill_field_effect_id":0,"_id_":3818,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3820":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2840,"skill_field_effect_id":0,"_id_":3820,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3821":{"attribute_id":7,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2841,"skill_field_effect_id":0,"_id_":3821,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3822":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2842,"skill_field_effect_id":0,"_id_":3822,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3823":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 rear enemies.","ja":"後から3体の敵に多段攻撃","ko":"뒤에서 3명의 적에게 다단 공격","zh_hant":"對後方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry","ja":"連撃","ko":"연격","zh_hant":"連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2843,"skill_field_effect_id":0,"_id_":3823,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3824":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to 3 rear enemies.","ja":"後から3体の敵にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"뒤에서 3명의 적에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低後方3個敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2844,"skill_field_effect_id":0,"_id_":3824,"skill_options":[{"id":21,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3825":{"attribute_id":7,"cost":2,"description":{"en":"Evasion Rate up to self.","ja":"自身に回避率アップを付与する","ko":"자신에게 회피 확률 증가를 부여","zh_hant":"提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2845,"skill_field_effect_id":0,"_id_":3825,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3826":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 rear enemies.","ja":"自身にACTパワーアップと必中を付与し、後から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 뒤에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對後方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2846,"skill_field_effect_id":0,"_id_":3826,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3827":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to 3 rear enemies.","ja":"自身にACTパワーアップと必中を付与し、後から3体の敵に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 뒤에서 3명의 적에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對後方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2847,"skill_field_effect_id":0,"_id_":3827,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3829":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2848,"skill_field_effect_id":0,"_id_":3829,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3830":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2849,"skill_field_effect_id":0,"_id_":3830,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3831":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2850,"skill_field_effect_id":0,"_id_":3831,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3832":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2851,"skill_field_effect_id":0,"_id_":3832,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3833":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2852,"skill_field_effect_id":0,"_id_":3833,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3834":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2853,"skill_field_effect_id":0,"_id_":3834,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"3835":{"attribute_id":2,"cost":2,"description":{"en":"High damage & Flip Positive Effects to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃し、プラス効果反転を適用する","ko":"앞에서 3명의 적에게 위력(대) 공격, 플러스 효과 반전을 적용","zh_hant":"對前方的3個敵人發動威力（大）攻擊，並施加正面狀態效果反轉"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flip Rondo","ja":"反転の輪舞曲","ko":"반전의 윤무곡","zh_hant":"反轉圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2854,"skill_field_effect_id":0,"_id_":3835,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":323,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[3,3,3,3,3]}]},"3836":{"attribute_id":2,"cost":2,"description":{"en":"Chance at Stop to all enemies.","ja":"敵全体に確率でストップを付与","ko":"적 전체에게 일정 확률로 스톱을 부여","zh_hant":"機率性賦予所有敵人停止"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2855,"skill_field_effect_id":0,"_id_":3836,"skill_options":[{"id":60,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3838":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2856,"skill_field_effect_id":0,"_id_":3838,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3839":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Twin Flash","ja":"双一閃","ko":"쌍일섬","zh_hant":"雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2857,"skill_field_effect_id":0,"_id_":3839,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3840":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2858,"skill_field_effect_id":0,"_id_":3840,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3841":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2859,"skill_field_effect_id":0,"_id_":3841,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3842":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack to 3 front enemies.","ja":"前から3体の敵に多段攻撃","ko":"앞에서 3명의 적에게 다단 공격","zh_hant":"對前方的3個敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flash Flurry","ja":"連一閃","ko":"연일섬","zh_hant":"連閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2860,"skill_field_effect_id":0,"_id_":3842,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3843":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2861,"skill_field_effect_id":0,"_id_":3843,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3844":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2862,"skill_field_effect_id":0,"_id_":3844,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3845":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack & Poison to all enemies","ja":"敵全体に多段攻撃を行い、毒を付与する","ko":"적 전체에게 다단 공격, 독을 부여","zh_hant":"對所有敵人發動多段攻擊，並造成中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2863,"skill_field_effect_id":0,"_id_":3845,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3846":{"attribute_id":7,"cost":2,"description":{"en":"Multi-hit attack & Poison to all enemies","ja":"敵全体に多段攻撃を行い、毒を付与する","ko":"적 전체에게 다단 공격, 독을 부여","zh_hant":"對所有敵人發動多段攻擊，並造成中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2864,"skill_field_effect_id":0,"_id_":3846,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"3848":{"attribute_id":2,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2865,"skill_field_effect_id":0,"_id_":3848,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3849":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Sharpshooting","ja":"双狙撃","ko":"쌍저격","zh_hant":"雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2866,"skill_field_effect_id":0,"_id_":3849,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3850":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Sharpshooting","ja":"強襲の双狙撃","ko":"강습의 쌍저격","zh_hant":"強襲雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2867,"skill_field_effect_id":0,"_id_":3850,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3851":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2868,"skill_field_effect_id":0,"_id_":3851,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3852":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2869,"skill_field_effect_id":0,"_id_":3852,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3853":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim to self. High damage to 3 rear enemies.","ja":"自身に必中を付与し、後から3体の敵に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2870,"skill_field_effect_id":0,"_id_":3853,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3854":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2871,"skill_field_effect_id":0,"_id_":3854,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3855":{"attribute_id":2,"cost":2,"description":{"en":"High damage & High chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率で混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2872,"skill_field_effect_id":0,"_id_":3855,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3856":{"attribute_id":2,"cost":2,"description":{"en":"High damage & High chance at Confusion to all enemies.","ja":"敵全体に威力(大)で攻撃し、高確率で混乱を付与","ko":"적 전체에게 위력(대) 공격, 높은 확률로 혼란을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率造成混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2873,"skill_field_effect_id":0,"_id_":3856,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3858":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2874,"skill_field_effect_id":0,"_id_":3858,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3859":{"attribute_id":7,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2875,"skill_field_effect_id":0,"_id_":3859,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3860":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2876,"skill_field_effect_id":0,"_id_":3860,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3861":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2877,"skill_field_effect_id":0,"_id_":3861,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3862":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2878,"skill_field_effect_id":0,"_id_":3862,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3863":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2879,"skill_field_effect_id":0,"_id_":3863,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3864":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2880,"skill_field_effect_id":0,"_id_":3864,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3865":{"attribute_id":7,"cost":2,"description":{"en":"Evasion Rate up to self.","ja":"自身に回避率アップを付与する","ko":"자신에게 회피 확률 증가를 부여","zh_hant":"提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2881,"skill_field_effect_id":0,"_id_":3865,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"3866":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2882,"skill_field_effect_id":0,"_id_":3866,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3867":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2883,"skill_field_effect_id":0,"_id_":3867,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3869":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy.","ja":"前から1体の敵に威力(小)で攻撃","ko":"앞에서 1명의 적에게 위력(소) 공격","zh_hant":"對前方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2884,"skill_field_effect_id":0,"_id_":3869,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3870":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 2 front enemies.","ja":"前から2体の敵に威力(小)で攻撃","ko":"앞에서 2명의 적에게 위력(소) 공격","zh_hant":"對前方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2885,"skill_field_effect_id":0,"_id_":3870,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"3871":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2886,"skill_field_effect_id":0,"_id_":3871,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3872":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2887,"skill_field_effect_id":0,"_id_":3872,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3873":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2888,"skill_field_effect_id":0,"_id_":3873,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3874":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2889,"skill_field_effect_id":0,"_id_":3874,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"3875":{"attribute_id":2,"cost":2,"description":{"en":"High damage & Flip Positive Effects x3 to all enemies.","ja":"敵全体に威力(大)で攻撃じ、3回分のプラス効果反転を適用する","ko":"적 전체에게 위력(대) 공격, 3회분의 플러스 효과 반전을 적용","zh_hant":"對所有敵人發動威力（大）攻擊，並施加3次正面狀態效果反轉"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flip Fiery Concerto","ja":"反転の協奏曲","ko":"반전의 협주곡","zh_hant":"反轉協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2890,"skill_field_effect_id":0,"_id_":3875,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":323,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]}]},"3876":{"attribute_id":2,"cost":2,"description":{"en":"High damage & chance at Stop to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率でストップを付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 스톱을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成停止"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Concerto","ja":"抑止の協奏曲","ko":"억제의 협주곡","zh_hant":"抑止協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2891,"skill_field_effect_id":0,"_id_":3876,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":60,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3877":{"attribute_id":2,"cost":2,"description":{"en":"High damage & chance at Stop to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率でストップを付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 스톱을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成停止"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2892,"skill_field_effect_id":0,"_id_":3877,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":60,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3879":{"attribute_id":7,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":0,"_id_":3879,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3880":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":0,"_id_":3880,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3881":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 front enemies.","ja":"前から3体の敵に威力(小)で攻撃","ko":"앞에서 3명의 적에게 위력(소) 공격","zh_hant":"對前方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":0,"_id_":3881,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3882":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":0,"_id_":3882,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3883":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":0,"_id_":3883,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3884":{"attribute_id":7,"cost":2,"description":{"en":"Act Power down to all enemies.","ja":"敵全体にACTパワーダウン付与","ko":"적 전체에게 ACT 파워 감소를 부여","zh_hant":"降低所有敵人的ACT力量"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":0,"_id_":3884,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3885":{"attribute_id":7,"cost":2,"description":{"en":"Remove Cont. Negative Effects to self. Remove Cont. Positive Effects to all enemies.","ja":"自身の継続マイナス効果を解除し、敵全体の継続プラス効果を解除する","ko":"자신의 지속 마이너스 효과를 해제, 적 전체의 지속 플러스 효과를 해제","zh_hant":"解除自己的持續性負面效果，同時解除所有敵人的持續性正面效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":0,"_id_":3885,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3886":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Heavy Poison to all enemies","ja":"敵全体に強力な多段攻撃を行い、高威力の毒を付与する","ko":"적 전체에게 강력한 다단 공격, 높은 위력의 독을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並造成高威力的中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2900,"skill_field_effect_id":0,"_id_":3886,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3887":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack & Heavy Poison to all enemies","ja":"敵全体に強力な多段攻撃を行い、高威力の毒を付与する","ko":"적 전체에게 강력한 다단 공격, 높은 위력의 독을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並造成高威力的中毒"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2901,"skill_field_effect_id":0,"_id_":3887,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"3889":{"attribute_id":2,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":0,"_id_":3889,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3890":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":0,"_id_":3890,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3891":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":0,"_id_":3891,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3892":{"attribute_id":2,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":0,"_id_":3892,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3893":{"attribute_id":2,"cost":2,"description":{"en":"Perfect Aim to self. High damage to all enemies.","ja":"自身に必中を付与し、敵全体に威力(大)で攻撃","ko":"자신에게 백발백중을 부여, 적 전체에게 위력(대) 공격","zh_hant":"賦予自身必中效果，並對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":0,"_id_":3893,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3894":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Normal Defense up & Special Defense up to self.","ja":"自身にACTパワーアップ、通常防御力アップ、特殊防御力アップを付与","ko":"자신에게 ACT 파워 증가, 일반/특수 방어력 증가를 부여","zh_hant":"提升自身的ACT力量、普通防禦力、特殊防禦力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":0,"_id_":3894,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3895":{"attribute_id":2,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies.","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2908,"skill_field_effect_id":0,"_id_":3895,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3896":{"attribute_id":2,"cost":2,"description":{"en":"Strong Multi-hit attack & Confusion to all enemies.","ja":"敵全体に強力な多段攻撃を行い、混乱を付与","ko":"적 전체에게 강력한 다단 공격, 혼란을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並賦予混亂"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2909,"skill_field_effect_id":0,"_id_":3896,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3898":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":0,"_id_":3898,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3899":{"attribute_id":7,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":0,"_id_":3899,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3900":{"attribute_id":7,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":0,"_id_":3900,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"3901":{"attribute_id":7,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":0,"_id_":3901,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3902":{"attribute_id":7,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":0,"_id_":3902,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3903":{"attribute_id":7,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":0,"_id_":3903,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3904":{"attribute_id":7,"cost":2,"description":{"en":"Dexterity down & Critical down to all enemies.","ja":"敵全体にクリティカル率ダウン、クリティカル威力ダウン付与","ko":"적 전체에게 크리티컬 확률 감소, 크리티컬 위력 감소를 부여","zh_hant":"降低所有敵人的會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":0,"_id_":3904,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3905":{"attribute_id":7,"cost":2,"description":{"en":"Evasion Rate up to self.","ja":"自身に回避率アップを付与する","ko":"자신에게 회피 확률 증가를 부여","zh_hant":"提升自己的迴避率"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":0,"_id_":3905,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"3906":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2918,"skill_field_effect_id":0,"_id_":3906,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3907":{"attribute_id":7,"cost":2,"description":{"en":"Act Power up & Perfect Aim to self. Strong Multi-hit attack to all enemies.","ja":"自身にACTパワーアップと必中を付与し、敵全体に強力な多段攻撃","ko":"자신에게 ACT 파워 증가와 백발백중을 부여, 적 전체에게 강력한 다단 공격","zh_hant":"提升自己的ACT力量並賦予自身必中，同時對所有敵人發動強大的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2919,"skill_field_effect_id":0,"_id_":3907,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"3909":{"attribute_id":2,"cost":2,"description":{"en":"High damage to front enemy.","ja":"前から1体の敵に威力(大)で攻撃","ko":"앞에서 1명의 적에게 위력(대) 공격","zh_hant":"對前方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Thrust","ja":"強襲の刺突","ko":"강습의 찌르기","zh_hant":"強襲突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2920,"skill_field_effect_id":0,"_id_":3909,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"3910":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 2 front enemies.","ja":"前から2体の敵に威力(大)で攻撃","ko":"앞에서 2명의 적에게 위력(대) 공격","zh_hant":"對前方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2921,"skill_field_effect_id":0,"_id_":3910,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3911":{"attribute_id":2,"cost":2,"description":{"en":"High damage to 3 front enemies.","ja":"前から3体の敵に威力(大)で攻撃","ko":"앞에서 3명의 적에게 위력(대) 공격","zh_hant":"對前方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2922,"skill_field_effect_id":0,"_id_":3911,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3912":{"attribute_id":2,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2923,"skill_field_effect_id":0,"_id_":3912,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"3913":{"attribute_id":2,"cost":2,"description":{"en":"Act Power up & Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2924,"skill_field_effect_id":0,"_id_":3913,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"3914":{"attribute_id":2,"cost":2,"description":{"en":"Strong Multi-hit attack & Flip Positive Effects x5 to all enemies.","ja":"敵全体に強力な多段攻撃を行い、5回分のプラス効果反転を付与する","ko":"적 전체에게 강력한 다단 공격, 5회분의 플러스 효과 반전을 적용","zh_hant":"對所有敵人發動強力的多段攻擊，並施加5次正面狀態效果反轉"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flip Fiery Concerto","ja":"反転の協奏曲","ko":"반전의 협주곡","zh_hant":"反轉協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2925,"skill_field_effect_id":0,"_id_":3914,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":323,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]}]},"3915":{"attribute_id":2,"cost":2,"description":{"en":"Strong Multi-hit attack & High chance at Sleep to all enemies.","ja":"敵全体に強力な多段攻撃を行い、高確率でストップを付与する","ko":"적 전체에게 강력한 다단 공격, 높은 확률로 스톱을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並以高機率賦予停止"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Concerto","ja":"抑止の協奏曲","ko":"억제의 협주곡","zh_hant":"抑止協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2926,"skill_field_effect_id":0,"_id_":3915,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":60,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3916":{"attribute_id":2,"cost":2,"description":{"en":"Strong Multi-hit attack & High chance at Sleep to all enemies.","ja":"敵全体に強力な多段攻撃を行い、高確率でストップを付与する","ko":"적 전체에게 강력한 다단 공격, 높은 확률로 스톱을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並以高機率賦予停止"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2927,"skill_field_effect_id":0,"_id_":3916,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":60,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3918":{"attribute_id":4,"cost":2,"description":{"en":"Medium+ damage to 3 rear enemies.","ja":"後ろから3体の敵に威力(中+)の攻撃","ko":"뒤에서 3명의 적에게 위력(중+) 공격","zh_hant":"對後面的3個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Profuse Strike","ja":"繚乱の一撃","ko":"요란의 일격","zh_hant":"繚亂一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2928,"skill_field_effect_id":0,"_id_":3918,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"3919":{"attribute_id":4,"cost":2,"description":{"en":"High damage & Special Defense down & Strong Poison to all enemies.","ja":"敵全体に威力(大)で攻撃を行い、特殊防御力ダウンと猛毒を付与する","ko":"적 전체에게 위력(대) 공격, 특수 방어력 감소와 맹독을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並降低特殊防禦力，且賦予猛毒"},"icon_id":54,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Invitation","ja":"妖毒の誘い","ko":"요독의 초대","zh_hant":"妖毒的誘惑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2929,"skill_field_effect_id":0,"_id_":3919,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":245,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[6,8,10,12,15]}]},"3920":{"attribute_id":4,"cost":3,"description":{"en":"Act Power up & Dexterity up to self. High damage to all enemies, dealing extra damage to enemies inflicted with Poison.","ja":"自身にACTパワーアップとクリティカル率アップを付与し、敵全体に威力(大)で攻撃を行う　この攻撃は毒状態の敵に対して特攻","ko":"자신에게 ACT 파워 증가와 크리티컬 확률 증가를 부여, 적 전체에게 위력(대) 공격. 이 공격은 독 상태의 적에게 특수 공격","zh_hant":"提升自己的ACT力量及會心率，並對所有敵人發動威力（大）攻擊 此攻擊會對中毒的敵方造成特攻效果"},"icon_id":158,"is_multiple_command_unique_skill":0,"name":{"en":"Life Blade","ja":"命の刃","ko":"생명의 칼날","zh_hant":"命之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2930,"skill_field_effect_id":0,"_id_":3920,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":276,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[74,78,82,87,91]}]},"3921":{"attribute_id":4,"cost":2,"description":{"en":"Very High damage to 3 rear enemies. Applies Stage Effect [Lightning Shade] to allies' stage.","ja":"後ろから3体の敵に威力(大+)の攻撃を行い 、舞台の味方側に舞台効果「電光影裏」を付与する","ko":"뒤에서 3명의 적에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [번갯불의 그림자]를 부여","zh_hant":"對後面的3個敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「雷光影裏」"},"icon_id":1009,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"三段突き","ko":"삼단 찌르기","zh_hant":"三段突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2931,"skill_field_effect_id":13,"_id_":3921,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[186,200,214,228,243]}]},"3943":{"attribute_id":1,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2948,"skill_field_effect_id":0,"_id_":3943,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3944":{"attribute_id":1,"cost":2,"description":{"en":"Effective element damage up & Dexterity up to self. High damage to enemy with the highest Act Power.","ja":"自身に有利属性ダメージアップとクリティカル率アップを付与し、ACTパワーの1番高い敵に威力(大)の攻撃を行う","ko":"자신에게 유리한 속성 대미지 증가, 크리티컬 확률 증가를 부여, ACT 파워가 가장 높은 적에게 위력(대) 공격","zh_hant":"提升自己對有利屬性的傷害與會心率，並對1名ACT力量最高的敵人發動威力（大）攻擊"},"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Determination","ja":"決意の一閃","ko":"결의의 일섬","zh_hant":"決意的閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2949,"skill_field_effect_id":0,"_id_":3944,"skill_options":[{"id":39,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"3945":{"attribute_id":1,"cost":2,"description":{"en":"High damage to enemy with the highest Act Power. Act Power up & AP Down to all allies.","ja":"ACTパワーの1番高い敵に威力(大)の攻撃を行い、味方全体にACTパワーアップとAP減少を付与する","ko":"ACT 파워가 가장 높은 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가와 AP 감소를 부여","zh_hant":"對1名ACT力量最高的敵人發動威力（大）攻擊，並提升所有我方的ACT力量，同時賦予AP減少"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Unwavering Passion","ja":"ゆるぎなき熱情","ko":"확고한 열정","zh_hant":"堅定的熱情"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2950,"skill_field_effect_id":0,"_id_":3945,"skill_options":[{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3946":{"attribute_id":1,"cost":2,"description":{"en":"Act Power down & Normal Defense down & Very High damage to rear enemy, dealing extra damage to special-type enemies.","ja":"後ろから1番目の敵にACTパワーダウンと通常防御力ダウンを付与し、威力(大+)の攻撃を行う　この攻撃は特殊タイプの敵に特攻","ko":"뒤에서 첫 번째 적에게 ACT 파워 감소, 일반 방어력 감소를 부여, 위력(대+) 공격, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"降低後面數來第1個敵人的ACT力量與普通防禦力，並發動威力（大+）攻擊　此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"O king, my burning passion will create your noble path!","ja":"情熱の炎で王道を作る！","ko":"정열의 불꽃으로 왕도를 만든다!","zh_hant":"燃燒吧激情烈焰，王道蕩蕩！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2951,"skill_field_effect_id":0,"_id_":3946,"skill_options":[{"id":9,"hit_rate":100,"target_id":2121,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":11,"hit_rate":100,"target_id":2121,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":308,"hit_rate":100,"target_id":2121,"times":[4,4,4,4,4],"values":[307,323,338,353,369]}]},"3948":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage to 3 front enemies. AP down to 3 front allies.","ja":"前から3体の敵に威力(中)の攻撃を行い、前から3体の味方にAP減少を付与する","ko":"앞에서 3명의 적에게 위력(중) 공격, 앞에서 3명의 아군에게 AP 감소를 부여","zh_hant":"對前面的3個敵人發動威力（中）攻擊，並賦予前面3名我方AP減少"},"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Prayer Song","ja":"祈りの歌","ko":"기도의 노래","zh_hant":"祈願之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2953,"skill_field_effect_id":0,"_id_":3948,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":157,"hit_rate":100,"target_id":1133,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3949":{"attribute_id":3,"cost":2,"description":{"en":"High damage to all enemies. Act Power up & Dexterity up to all allies.","ja":"敵全体に威力(大)の攻撃を行い、味方全体にACTパワーアップとクリティカル率アップを付与する","ko":"적 전체에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가, 크리티컬 확률 증가를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並提升所有我方的ACT力量與會心率"},"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Goddess Smile","ja":"女神の微笑み","ko":"여신의 미소","zh_hant":"女神的微笑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2954,"skill_field_effect_id":0,"_id_":3949,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3950":{"attribute_id":3,"cost":3,"description":{"en":"Removes Cont. Positive Effects & AP up & Medium damage to all enemies.","ja":"敵全体の継続プラス効果を解除し、AP増加を付与し、威力(中)の攻撃を行う","ko":"적 전체의 지속 플러스 효과를 해제, AP 증가를 부여, 위력(중) 공격","zh_hant":"解除所有敵人的持續性正面效果，賦予AP增加，並發動威力（中）攻擊"},"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Piercing Arrow","ja":"貫きの矢","ko":"관통 화살","zh_hant":"貫穿之箭矢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2955,"skill_field_effect_id":0,"_id_":3950,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"3951":{"attribute_id":3,"cost":2,"description":{"en":"Removes Cont. Positive Effects & Very High damage & Freeze to all enemies.","ja":"敵全体の継続プラス効果を解除し、威力(大+)の攻撃を行い、凍結を付与する","ko":"적 전체의 지속 플러스 효과를 해제, 위력(대+) 공격, 동결을 부여","zh_hant":"解除所有敵人的持續性正面效果，發動威力（大+）攻擊，並造成凍結"},"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"This world is a stage. Even the king is a player!","ja":"この世は舞台 王すらも役者――ですよ？","ko":"이 세상은 무대, 왕조차 배우――라고요?","zh_hant":"整個世界是座舞台，當代王者也只是演員而已――唷？"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2956,"skill_field_effect_id":0,"_id_":3951,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3953":{"attribute_id":6,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Swing of Brilliance","ja":"キラめきのスイング","ko":"반짝임의 스윙","zh_hant":"光芒搖曳"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2958,"skill_field_effect_id":0,"_id_":3953,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3954":{"attribute_id":6,"cost":2,"description":{"en":"Medium damage to all enemies. Removes Cont. Negative Effects from all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体の継続マイナス効果を解除する","ko":"적 전체에게 위력(중) 공격, 아군 전체의 지속 마이너스 효과를 해제","zh_hant":"對所有敵人發動威力（中）攻擊，並解除所有我方的持續性負面效果"},"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Trick Play","ja":"トリックプレー","ko":"트릭 플레이","zh_hant":"假動作"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2959,"skill_field_effect_id":0,"_id_":3954,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"3955":{"attribute_id":6,"cost":2,"description":{"en":"High damage to all enemies, dealing extra damage to normal-type enemies. Evasion Rate up to all allies.","ja":"敵全体に威力(大)で攻撃を行い、味方全体に回避率アップを付与する　この攻撃は通常タイプの敵に特攻","ko":"적 전체에게 위력(대) 공격, 아군 전체에게 회피 확률 증가를 부여, 이 공격은 일반 타입인 적에게 특수 공격","zh_hant":"對所有敵人發動威力（大）攻擊，並提升所有我方的迴避率　此攻擊會對普通類型的敵方造成特攻效果"},"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Team Cornerstone","ja":"扇の要","ko":"중심축","zh_hant":"場上的司令塔"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2960,"skill_field_effect_id":0,"_id_":3955,"skill_options":[{"id":306,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[74,78,82,87,91]},{"id":18,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,32,35,40,50]}]},"3956":{"attribute_id":6,"cost":2,"description":{"en":"Very High damage to all enemies. Applies Stage Effect [Ironclad Guard] to allies' stage.","ja":"敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「鉄壁の守備」を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [철벽 수비]를 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「鐵壁守備」"},"icon_id":1010,"is_multiple_command_unique_skill":0,"name":{"en":"Superb Play","ja":"気迫のファインプレー","ko":"기백의 파인 플레이","zh_hant":"氣勢磅礡的精彩守備"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2961,"skill_field_effect_id":14,"_id_":3956,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3958":{"attribute_id":3,"cost":2,"description":{"en":"Medium+ damage to front enemy.","ja":"前から1番目の敵に威力(中+)の攻撃","ko":"앞에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對前面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Full Swing","ja":"フルスイング","ko":"풀 스윙","zh_hant":"全力揮擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2963,"skill_field_effect_id":0,"_id_":3958,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3959":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy, dealing extra damage to special-type enemies.","ja":"前から1番目の敵に威力(大)で攻撃 この攻撃は特殊タイプの敵に特攻","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊 此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Here We Go!","ja":"しまっていこう！","ko":"긴장 풀지 말자!","zh_hant":"集中精神上吧！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2964,"skill_field_effect_id":0,"_id_":3959,"skill_options":[{"id":308,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"3960":{"attribute_id":3,"cost":2,"description":{"en":"High damage to front enemy, dealing extra damage to special-type enemies. Act Power up to all allies.","ja":"前から1番目の敵に威力(大)の攻撃を行い、味方全体にACTパワーアップを付与する この攻撃は特殊タイプの敵に特攻","ko":"앞에서 첫 번째 적에게 위력(대) 공격, 아군 전체에게 ACT 파워 증가를 부여, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對前面數來第1個敵人發動威力（大）攻擊，並提升所有我方的ACT力量 此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Focus On Outs!","ja":"バッター集中！","ko":"타자 집중!","zh_hant":"專心對付打者！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2965,"skill_field_effect_id":0,"_id_":3960,"skill_options":[{"id":308,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3961":{"attribute_id":3,"cost":2,"description":{"en":"Very High damage to all enemies. Applies Stage Effect [Boldness] to allies' stage.","ja":"敵全体に威力(大+)で攻撃を行い、舞台の味方側に舞台効果「ガッツ」を付与する","ko":"적 전체에게 위력(대+) 공격, 아군 쪽 무대에 무대 효과 [근성]을 부여","zh_hant":"對所有敵人發動威力（大+）攻擊，並賦予我方的舞台舞台效果「毅力」"},"icon_id":1011,"is_multiple_command_unique_skill":0,"name":{"en":"Home Run Spirit","ja":"闘志のホームラン","ko":"투지의 홈런","zh_hant":"充滿鬥志的全壘打"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2966,"skill_field_effect_id":15,"_id_":3961,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"3968":{"attribute_id":5,"cost":2,"description":{"en":"Medium+ damage to 3 front enemies.","ja":"前から3体の敵に威力(中+)の攻撃","ko":"앞에서 3명의 적에게 위력(중+) 공격","zh_hant":"對前方的3個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2968,"skill_field_effect_id":0,"_id_":3968,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"3969":{"attribute_id":5,"cost":2,"description":{"en":"High damage & High chance at Stun to all enemies.","ja":"敵全体に威力(大)で攻撃を行い、高確率でスタンを付与する","ko":"적 전체에게 위력(대) 공격, 높은 확률로 스턴을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並以高機率賦予暈眩"},"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Thunderclap Blade","ja":"迅雷の刃","ko":"우레의 칼날","zh_hant":"迅雷之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2969,"skill_field_effect_id":0,"_id_":3969,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":57,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"3970":{"attribute_id":5,"cost":2,"description":{"en":"Medium damage to all enemies. Unremovable Cont. Negative Effects Resistance to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体に解除不可の継続マイナス効果耐性を付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 해제 불가능한 지속 마이너스 효과 저항을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並賦予所有我方無法解除的持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Thundercloud Yell","ja":"雷雲の呼声","ko":"뇌운을 부르는 소리","zh_hant":"雷雲之呼聲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2970,"skill_field_effect_id":0,"_id_":3970,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":346,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]}]},"3971":{"attribute_id":5,"cost":2,"description":{"en":"Very High damage to 3 front enemies. Applies Stage Effect [Thunder] to enemies' stage.","ja":"前から3体の敵に威力(大+)の攻撃を行い 、舞台の敵側に舞台効果「雷鳴」を付与する","ko":"앞에서 3명의 적에게 위력(대+) 공격, 적 쪽 무대에 무대 효과 [천둥]을 부여","zh_hant":"對前面的3個敵人發動威力（大+）攻擊，並賦予敵方的舞台舞台效果「雷鳴」"},"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Justice Blitz","ja":"正義の雷光","ko":"정의의 번개","zh_hant":"正義的雷光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2971,"skill_field_effect_id":16,"_id_":3971,"skill_options":[{"id":83,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[186,200,214,228,243]}]},"3988":{"attribute_id":2,"cost":2,"description":{"en":"Low damage to front enemy. Low Brilliance recovery to self.","ja":"前から1番目の敵に威力(小)で攻撃を行い、自身のキラめき(小)回復","ko":"앞에서 첫 번째 적에게 위력(소) 공격, 자신의 반짝임(소) 회복","zh_hant":"對前面數來第1個敵人發動威力（小）攻擊，並回復自己的光芒（小）"},"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Swing of Brilliance","ja":"キラめきのスイング","ko":"반짝임의 스윙","zh_hant":"光芒搖曳"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2985,"skill_field_effect_id":0,"_id_":3988,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"3989":{"attribute_id":2,"cost":2,"description":{"en":"Medium damage to all enemies. Cont. Negative Effects Resistance to all allies.","ja":"敵全体に威力(中)で攻撃を行い、味方全体に継続マイナス効果耐性を付与する","ko":"적 전체에게 위력(중) 공격, 아군 전체에게 지속 마이너스 효과 저항을 부여","zh_hant":"對所有敵人發動威力（中）攻擊，並賦予所有我方持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Sliding Catch","ja":"スライディングキャッチ","ko":"슬라이딩 캐치","zh_hant":"滑接"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2986,"skill_field_effect_id":0,"_id_":3989,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"3990":{"attribute_id":2,"cost":2,"description":{"en":"High damage to all enemies, dealing extra damage to special-type enemies. Evasion x1 to all allies.","ja":"敵全体に威力(大)で攻撃を行い、味方全体に回避を1回付与する　この攻撃は特殊タイプの敵に特攻","ko":"적 전체에게 위력(대) 공격, 아군 전체에게 회피 1회를 부여, 이 공격은 특수 타입인 적에게 특수 공격","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予所有我方迴避1次　此攻擊會對特殊類型的敵方造成特攻效果"},"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Backup","ja":"バックアップ","ko":"백업","zh_hant":"補位"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2987,"skill_field_effect_id":0,"_id_":3990,"skill_options":[{"id":308,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[74,78,82,87,91]},{"id":34,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"3991":{"attribute_id":2,"cost":2,"description":{"en":"Extremely High damage to all enemies. Applies Stage Effect [Winning Determination] to allies' stage.","ja":"敵全体に威力(特大)で攻撃を行い、舞台の味方側に舞台効果「勝負根性」を付与する","ko":"적 전체에게 위력(특대) 공격, 아군 쪽 무대에게 무대 효과 [승부 근성]을 부여","zh_hant":"對所有敵人發動威力（特大）攻擊，並賦予我方的舞台舞台效果「勝負鬥志」"},"icon_id":1013,"is_multiple_command_unique_skill":0,"name":{"en":"Hot-Blooded Home Run","ja":"熱血バックホーム","ko":"열혈 백홈","zh_hant":"熱血回傳"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2988,"skill_field_effect_id":17,"_id_":3991,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"3993":{"attribute_id":3,"cost":2,"description":{"en":"Medium+ damage to rear enemy.","ja":"後ろから1番目の敵に威力(中+)の攻撃","ko":"뒤에서 첫 번째 적에게 위력(중+) 공격","zh_hant":"對後面數來第1個敵人發動威力（中+）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ardent Slash","ja":"烈斬撃","ko":"열참격","zh_hant":"烈焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2990,"skill_field_effect_id":0,"_id_":3993,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"3994":{"attribute_id":3,"cost":2,"description":{"en":"Medium damage to rear enemy. Dexterity up & Cont. Negative Effects Resistance to all allies.","ja":"後ろから1番目の敵に威力(中)で攻撃を行い、味方全体にクリティカル率アップと継続マイナス効果耐性を付与する","ko":"뒤에서 첫 번째 적에게 위력(중) 공격, 아군 전체에게 크리티컬 확률 증가와 지속 마이너스 효과 저항을 부여","zh_hant":"對後面數來第1個敵人發動威力（中）攻擊，並提昇所有我方的會心率，且賦予持續性負面效果耐性"},"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Soul Rebirth","ja":"魂の再生","ko":"영혼의 재생","zh_hant":"靈魂再生"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2991,"skill_field_effect_id":0,"_id_":3994,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"3995":{"attribute_id":3,"cost":2,"description":{"en":"High damage to rear enemy. Marked & Normal Defense down to all enemies.","ja":"後ろから1番目の敵に威力(大)で攻撃を行い、敵全体に刻印と通常防御力ダウンを付与する","ko":"뒤에서 첫 번째 적에게 위력(대) 공격, 적 전체에게 각인과 일반 방어력 감소를 부여","zh_hant":"對後面數來第1個敵人發動威力（大）攻擊，並降低所有敵人的普通防禦力，且賦予刻印"},"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Death's Whisper","ja":"死神の囁き","ko":"사신의 속삭임","zh_hant":"死神的低語"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2992,"skill_field_effect_id":0,"_id_":3995,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"3996":{"attribute_id":3,"cost":2,"description":{"en":"Perfect Aim Extremely High damage to all enemies, ignoring Aggro, Provoke, Barrier, Reflect and Invincible. Revive 1 time to 2 rear allies.","ja":"敵全体に威力(特大)の必中攻撃を行い、後ろから2体の味方に起死回生を1回付与する　この攻撃はターゲット固定、挑発、バリア、反射、無敵を無視する","ko":"적 전체에게 위력(특대) 백발백중 공격, 뒤에서 2명의 아군에게 기사회생을 1회 부여, 이 공격은 타깃 고정, 도발, 배리어, 반사, 무적을 무시","zh_hant":"對所有敵人發動威力（特大）的必中攻擊，並賦予後面的2名我方起死回生1次 此攻擊會無視目標鎖定、挑釁、防護罩、反射、無敵"},"icon_id":228,"is_multiple_command_unique_skill":0,"name":{"en":"Memento Mori","ja":"死、忘るなかれ","ko":"죽음을 잊지 말라","zh_hant":"莫忘死亡"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2993,"skill_field_effect_id":0,"_id_":3996,"skill_options":[{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":360,"hit_rate":100,"target_id":1142,"times":[1,1,1,1,1],"values":[50,50,50,50,50]}]},"3998":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2995,"skill_field_effect_id":0,"_id_":3998,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"3999":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2996,"skill_field_effect_id":0,"_id_":3999,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4000":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2997,"skill_field_effect_id":0,"_id_":4000,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4001":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2998,"skill_field_effect_id":0,"_id_":4001,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4002":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2999,"skill_field_effect_id":0,"_id_":4002,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4003":{"attribute_id":1,"cost":2,"description":{"en":"High damage & Reduced Brilliance Recovery to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 반짝임 획득 감소를 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並賦予獲得光芒減少效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3000,"skill_field_effect_id":0,"_id_":4003,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"4004":{"attribute_id":1,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3001,"skill_field_effect_id":0,"_id_":4004,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4005":{"attribute_id":1,"cost":2,"description":{"en":"Set chance to inflict Sleep to all enemies.","ja":"敵全体に確率で睡眠を付与","ko":"적 전체에게 일정 확률로 수면을 부여","zh_hant":"機率性賦予所有敵人睡眠"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3002,"skill_field_effect_id":0,"_id_":4005,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4007":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to rear enemy.","ja":"後から1体の敵に威力(小)で攻撃","ko":"뒤에서 1명의 적에게 위력(소) 공격","zh_hant":"對後方的1個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3003,"skill_field_effect_id":0,"_id_":4007,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4008":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to 2 rear enemies.","ja":"後から2体の敵に威力(小)で攻撃","ko":"뒤에서 2명의 적에게 위력(소) 공격","zh_hant":"對後方的2個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3004,"skill_field_effect_id":0,"_id_":4008,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4009":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3005,"skill_field_effect_id":0,"_id_":4009,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4010":{"attribute_id":1,"cost":2,"description":{"en":"Low damage to 3 rear enemies.","ja":"後から3体の敵に威力(小)で攻撃","ko":"뒤에서 3명의 적에게 위력(소) 공격","zh_hant":"對後方的3個敵人發動威力（小）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3006,"skill_field_effect_id":0,"_id_":4010,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4011":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3007,"skill_field_effect_id":0,"_id_":4011,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4012":{"attribute_id":1,"cost":2,"description":{"en":"High damage & Reduced Brilliance Recovery to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"뒤에서 3명의 적에게 위력(대) 공격, 반짝임 획득 감소를 부여","zh_hant":"對後方的3個敵人發動威力（大）攻擊，並賦予獲得光芒減少效果"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3008,"skill_field_effect_id":0,"_id_":4012,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"4013":{"attribute_id":1,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3009,"skill_field_effect_id":0,"_id_":4013,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4014":{"attribute_id":1,"cost":2,"description":{"en":"High damage & chance at Sleep to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で睡眠を付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 수면을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成睡眠"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3010,"skill_field_effect_id":0,"_id_":4014,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4015":{"attribute_id":1,"cost":2,"description":{"en":"High damage & chance at Sleep to all enemies.","ja":"敵全体に威力(大)で攻撃し、確率で睡眠を付与","ko":"적 전체에게 위력(대) 공격, 일정 확률로 수면을 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並在一定機率下造成睡眠"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3011,"skill_field_effect_id":0,"_id_":4015,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4017":{"attribute_id":1,"cost":2,"description":{"en":"High damage to rear enemy.","ja":"後から1体の敵に威力(大)で攻撃","ko":"뒤에서 1명의 적에게 위력(대) 공격","zh_hant":"對後方的1個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Thrust","ja":"強襲の刺突","ko":"강습의 찌르기","zh_hant":"強襲突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3012,"skill_field_effect_id":0,"_id_":4017,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4018":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 2 rear enemies.","ja":"後から2体の敵に威力(大)で攻撃","ko":"뒤에서 2명의 적에게 위력(대) 공격","zh_hant":"對後方的2個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3013,"skill_field_effect_id":0,"_id_":4018,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4019":{"attribute_id":1,"cost":2,"description":{"en":"High damage to 3 rear enemies.","ja":"後から3体の敵に威力(大)で攻撃","ko":"뒤에서 3명의 적에게 위력(대) 공격","zh_hant":"對後方的3個敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3014,"skill_field_effect_id":0,"_id_":4019,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4020":{"attribute_id":1,"cost":2,"description":{"en":"High damage to all enemies.","ja":"敵全体に威力(大)で攻撃","ko":"적 전체에게 위력(대) 공격","zh_hant":"對所有敵人發動威力（大）攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3015,"skill_field_effect_id":0,"_id_":4020,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4021":{"attribute_id":1,"cost":2,"description":{"en":"Strong Multi-hit attack to all enemies.","ja":"敵全体に強力な多段攻撃","ko":"적 전체에게 강력한 다단 공격","zh_hant":"對所有敵人發動強力的多段攻擊"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3016,"skill_field_effect_id":0,"_id_":4021,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4022":{"attribute_id":1,"cost":2,"description":{"en":"High damage & Brilliance Recovery down to all enemies.","ja":"敵全体に威力(大)で攻撃し、キラめき獲得ダウンを付与する","ko":"적 전체에게 위력(대) 공격, 반짝임 획득 감소를 부여","zh_hant":"對所有敵人發動威力（大）攻擊，並賦予獲得光芒減少"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3017,"skill_field_effect_id":0,"_id_":4022,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"4023":{"attribute_id":1,"cost":2,"description":{"en":"Act Power up, Dexterity up & Critical up to self.","ja":"自身にACTパワーアップ、クリティカル率アップ、クリティカル威力アップを付与","ko":"자신에게 ACT 파워 증가, 크리티컬 확률 증가, 크리티컬 위력 증가를 부여","zh_hant":"提升自己的ACT力量、會心率、會心威力"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3018,"skill_field_effect_id":0,"_id_":4023,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4024":{"attribute_id":1,"cost":2,"description":{"en":"Strong Multi-hit attack & high chance at Sleep to all enemies.","ja":"敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する","ko":"적 전체에게 강력한 다단 공격, 높은 확률로 수면을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並以高機率賦予睡眠"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3019,"skill_field_effect_id":0,"_id_":4024,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4025":{"attribute_id":1,"cost":2,"description":{"en":"Strong Multi-hit attack & high chance at Sleep to all enemies.","ja":"敵全体に強力な多段攻撃を行い、高確率で睡眠を付与する","ko":"적 전체에게 강력한 다단 공격, 높은 확률로 수면을 부여","zh_hant":"對所有敵人發動強力的多段攻擊，並以高機率賦予睡眠"},"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3020,"skill_field_effect_id":0,"_id_":4025,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4027":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3021,"skill_field_effect_id":0,"_id_":4027,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4028":{"attribute_id":2,"cost":2,"icon_id":58,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Song","ja":"眠りの歌","ko":"잠의 노래","zh_hant":"睡眠之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3022,"skill_field_effect_id":0,"_id_":4028,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4029":{"attribute_id":2,"cost":3,"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Mad Dance","ja":"狂惑の舞","ko":"광란의 춤","zh_hant":"狂惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3023,"skill_field_effect_id":0,"_id_":4029,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4030":{"attribute_id":2,"cost":2,"icon_id":232,"is_multiple_command_unique_skill":0,"name":{"en":"To a new life, to a new stage!","ja":"謳いあげます命の夢を！！","ko":"노래하지요 생의 꿈을!!","zh_hant":"謳歌而上！人生夢想！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3024,"skill_field_effect_id":18,"_id_":4030,"skill_options":[{"id":364,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[125,135,145,155,170]}]},"4032":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3026,"skill_field_effect_id":0,"_id_":4032,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4033":{"attribute_id":5,"cost":2,"icon_id":229,"is_multiple_command_unique_skill":0,"name":{"en":"Fresh Wind","ja":"時代の新風","ko":"시대의 새바람","zh_hant":"時代的新風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3027,"skill_field_effect_id":0,"_id_":4033,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[74,78,82,87,91]}]},"4034":{"attribute_id":5,"cost":2,"icon_id":229,"is_multiple_command_unique_skill":0,"name":{"en":"Final Battle","ja":"決戦の幕開け","ko":"결전의 개막","zh_hant":"決戰即將開始"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3028,"skill_field_effect_id":0,"_id_":4034,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[47,50,53,56,58]}]},"4035":{"attribute_id":5,"cost":2,"icon_id":1017,"is_multiple_command_unique_skill":0,"name":{"en":"Hitotsu no Tachi","ja":"奥義　一之太刀","ko":"오의 일지태도","zh_hant":"奧義 一之太刀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3029,"skill_field_effect_id":22,"_id_":4035,"skill_options":[{"id":361,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[180,190,200,210,220]}]},"4037":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ardent Slash","ja":"烈斬撃","ko":"열참격","zh_hant":"烈焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3031,"skill_field_effect_id":0,"_id_":4037,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4038":{"attribute_id":3,"cost":2,"icon_id":196,"is_multiple_command_unique_skill":0,"name":{"en":"Resolute Blade","ja":"覚悟の刃","ko":"각오의 칼날","zh_hant":"覺悟之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3032,"skill_field_effect_id":0,"_id_":4038,"skill_options":[{"id":308,"hit_rate":100,"target_id":2021,"times":[2,2,2,2,2],"values":[156,163,171,178,187]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4039":{"attribute_id":3,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Determination","ja":"決意の一撃","ko":"결의의 일격","zh_hant":"決意一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3033,"skill_field_effect_id":0,"_id_":4039,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4040":{"attribute_id":3,"cost":2,"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"My life is on this stage!","ja":"命の在処この舞台に見つけたり！","ko":"생을 둘 곳 이 무대에서 찾으리!","zh_hant":"命之所處即為舞台！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3034,"skill_field_effect_id":0,"_id_":4040,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":371,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4042":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3036,"skill_field_effect_id":0,"_id_":4042,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4043":{"attribute_id":4,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Rhythm of Dawn","ja":"夜明けの奏","ko":"새벽의 음률","zh_hant":"黎明的音色"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3037,"skill_field_effect_id":0,"_id_":4043,"skill_options":[{"id":127,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4044":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Beginning of Story","ja":"はじまりの物語","ko":"이야기의 시작","zh_hant":"起始的故事"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3038,"skill_field_effect_id":0,"_id_":4044,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4045":{"attribute_id":4,"cost":2,"icon_id":234,"is_multiple_command_unique_skill":0,"name":{"en":"1001 Illusions","ja":"千夜一夜の幻想","ko":"천일야화의 환상","zh_hant":"一千零一夜的幻想"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3039,"skill_field_effect_id":0,"_id_":4045,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":377,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[2222,3333,4444,5555,6666]}]},"4052":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Reverse Flash","ja":"裏一閃","ko":"이일섬","zh_hant":"裏閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3041,"skill_field_effect_id":0,"_id_":4052,"skill_options":[{"id":80,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4053":{"attribute_id":6,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Lightning Speed","ja":"電光石火","ko":"전광석화","zh_hant":"雷光石火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3042,"skill_field_effect_id":0,"_id_":4053,"skill_options":[{"id":80,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":34,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4054":{"attribute_id":6,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Skyward Leap","ja":"大空への跳躍","ko":"드넓은 하늘로의 도약","zh_hant":"邁向高空的跳躍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3043,"skill_field_effect_id":0,"_id_":4054,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4055":{"attribute_id":6,"cost":2,"icon_id":235,"is_multiple_command_unique_skill":0,"name":{"en":"Aiming for that sky, to Frontier!","ja":"あの空目指してすすめフロンティア！","ko":"저 하늘을 향해 나아가라 프론티어!","zh_hant":"朝向那片天空　前進無垠邊疆！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3044,"skill_field_effect_id":0,"_id_":4055,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":382,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]}]},"4057":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Profuse Slash","ja":"繚乱の斬撃","ko":"요란의 참격","zh_hant":"繚亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3046,"skill_field_effect_id":0,"_id_":4057,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4058":{"attribute_id":2,"cost":2,"icon_id":6,"is_multiple_command_unique_skill":0,"name":{"en":"Swift as Wind","ja":"風の如く","ko":"바람처럼","zh_hant":"宛如風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3047,"skill_field_effect_id":0,"_id_":4058,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,27,30]}]},"4059":{"attribute_id":2,"cost":2,"icon_id":33,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce as Fire","ja":"火の如く","ko":"불처럼","zh_hant":"宛如火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3048,"skill_field_effect_id":0,"_id_":4059,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4060":{"attribute_id":2,"cost":2,"icon_id":1008,"is_multiple_command_unique_skill":0,"name":{"en":"Furinkazan","ja":"風林火山","ko":"풍림화산","zh_hant":"風林火山"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3049,"skill_field_effect_id":23,"_id_":4060,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]}]},"4065":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3051,"skill_field_effect_id":0,"_id_":4065,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4066":{"attribute_id":4,"cost":2,"icon_id":62,"is_multiple_command_unique_skill":0,"name":{"en":"Twilight Dance","ja":"宵闇の舞","ko":"초저녁의 춤","zh_hant":"宵暗之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3052,"skill_field_effect_id":0,"_id_":4066,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[97,102,106,111,116]},{"id":302,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4067":{"attribute_id":4,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Dragon Thunder","ja":"龍の雷","ko":"용의 불호령","zh_hant":"龍之雷"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3053,"skill_field_effect_id":0,"_id_":4067,"skill_options":[{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4068":{"attribute_id":4,"cost":2,"icon_id":1018,"is_multiple_command_unique_skill":0,"name":{"en":"War God's Flash","ja":"軍神の一閃","ko":"군신의 일섬","zh_hant":"軍神閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3054,"skill_field_effect_id":24,"_id_":4068,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4070":{"attribute_id":2,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3056,"skill_field_effect_id":0,"_id_":4070,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4071":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Heart","ja":"自由な心","ko":"자유로운 마음","zh_hant":"自由之心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3057,"skill_field_effect_id":0,"_id_":4071,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"4072":{"attribute_id":2,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Limitless Radiance","ja":"永遠の輝き","ko":"영원한 반짝임","zh_hant":"永恆光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3058,"skill_field_effect_id":0,"_id_":4072,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4073":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Possibility∞Infinity","ja":"Possibility∞Infinity","ko":"Possibility∞Infinity","zh_hant":"無限∞可能"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3059,"skill_field_effect_id":0,"_id_":4073,"skill_options":[{"id":310,"hit_rate":100,"target_id":22002,"times":[4,4,4,4,4],"values":[200,210,220,230,240]},{"id":384,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4075":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3061,"skill_field_effect_id":0,"_id_":4075,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4076":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3062,"skill_field_effect_id":0,"_id_":4076,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4077":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3063,"skill_field_effect_id":0,"_id_":4077,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4078":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3064,"skill_field_effect_id":0,"_id_":4078,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4079":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3065,"skill_field_effect_id":0,"_id_":4079,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4080":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3066,"skill_field_effect_id":0,"_id_":4080,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4081":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3067,"skill_field_effect_id":0,"_id_":4081,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4082":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Midnight NEO","ja":"ブラッディ・ミッドナイト NEO","ko":"블러디 미드나이트 NEO","zh_hant":"血腥午夜 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3068,"skill_field_effect_id":0,"_id_":4082,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4084":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3069,"skill_field_effect_id":0,"_id_":4084,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4085":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3070,"skill_field_effect_id":0,"_id_":4085,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4086":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3071,"skill_field_effect_id":0,"_id_":4086,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4087":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3072,"skill_field_effect_id":0,"_id_":4087,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4088":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3073,"skill_field_effect_id":0,"_id_":4088,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4089":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3074,"skill_field_effect_id":0,"_id_":4089,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4090":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3075,"skill_field_effect_id":0,"_id_":4090,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4091":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3076,"skill_field_effect_id":0,"_id_":4091,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4092":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3077,"skill_field_effect_id":0,"_id_":4092,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4094":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3078,"skill_field_effect_id":0,"_id_":4094,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4095":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3079,"skill_field_effect_id":0,"_id_":4095,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4096":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3080,"skill_field_effect_id":0,"_id_":4096,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4097":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3081,"skill_field_effect_id":0,"_id_":4097,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4098":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3082,"skill_field_effect_id":0,"_id_":4098,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4099":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Rondo","ja":"脱力の輪舞曲","ko":"탈력의 윤무곡","zh_hant":"虛脫圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3083,"skill_field_effect_id":0,"_id_":4099,"skill_options":[{"id":9,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4100":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3084,"skill_field_effect_id":0,"_id_":4100,"skill_options":[{"id":21,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4101":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3085,"skill_field_effect_id":0,"_id_":4101,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4102":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cross of Retribution NEO","ja":"聖罰の十字架 NEO","ko":"성벌의 십자가 NEO","zh_hant":"聖罰十字架 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3086,"skill_field_effect_id":0,"_id_":4102,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4104":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3087,"skill_field_effect_id":0,"_id_":4104,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4105":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3088,"skill_field_effect_id":0,"_id_":4105,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4106":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3089,"skill_field_effect_id":0,"_id_":4106,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4107":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3090,"skill_field_effect_id":0,"_id_":4107,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4108":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3091,"skill_field_effect_id":0,"_id_":4108,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4109":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3092,"skill_field_effect_id":0,"_id_":4109,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4110":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3093,"skill_field_effect_id":0,"_id_":4110,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4111":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3094,"skill_field_effect_id":0,"_id_":4111,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4112":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3095,"skill_field_effect_id":0,"_id_":4112,"skill_options":[{"id":61,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4114":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3096,"skill_field_effect_id":0,"_id_":4114,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4115":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3097,"skill_field_effect_id":0,"_id_":4115,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4116":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3098,"skill_field_effect_id":0,"_id_":4116,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4117":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3099,"skill_field_effect_id":0,"_id_":4117,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4118":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3100,"skill_field_effect_id":0,"_id_":4118,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4119":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3101,"skill_field_effect_id":0,"_id_":4119,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4120":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3102,"skill_field_effect_id":0,"_id_":4120,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4121":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3103,"skill_field_effect_id":0,"_id_":4121,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4122":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Midnight NEO","ja":"ブラッディ・ミッドナイト NEO","ko":"블러디 미드나이트 NEO","zh_hant":"血腥午夜 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3104,"skill_field_effect_id":0,"_id_":4122,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4124":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3105,"skill_field_effect_id":0,"_id_":4124,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4125":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3106,"skill_field_effect_id":0,"_id_":4125,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4126":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3107,"skill_field_effect_id":0,"_id_":4126,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4127":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3108,"skill_field_effect_id":0,"_id_":4127,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4128":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3109,"skill_field_effect_id":0,"_id_":4128,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4129":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3110,"skill_field_effect_id":0,"_id_":4129,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4130":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3111,"skill_field_effect_id":0,"_id_":4130,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4131":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3112,"skill_field_effect_id":0,"_id_":4131,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4132":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3113,"skill_field_effect_id":0,"_id_":4132,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4133":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3114,"skill_field_effect_id":0,"_id_":4133,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4134":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3115,"skill_field_effect_id":0,"_id_":4134,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4136":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3116,"skill_field_effect_id":0,"_id_":4136,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4137":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3117,"skill_field_effect_id":0,"_id_":4137,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4138":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3118,"skill_field_effect_id":0,"_id_":4138,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4139":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3119,"skill_field_effect_id":0,"_id_":4139,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4140":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3120,"skill_field_effect_id":0,"_id_":4140,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4141":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3121,"skill_field_effect_id":0,"_id_":4141,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4142":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Dance","ja":"連撃の舞","ko":"연격의 춤","zh_hant":"連擊之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3122,"skill_field_effect_id":0,"_id_":4142,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4143":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3123,"skill_field_effect_id":0,"_id_":4143,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4144":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3124,"skill_field_effect_id":0,"_id_":4144,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4145":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3125,"skill_field_effect_id":0,"_id_":4145,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4146":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cross of Retribution NEO","ja":"聖罰の十字架 NEO","ko":"성벌의 십자가 NEO","zh_hant":"聖罰十字架 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3126,"skill_field_effect_id":0,"_id_":4146,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4148":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust","ja":"刺突","ko":"찌르기","zh_hant":"突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3127,"skill_field_effect_id":0,"_id_":4148,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4149":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Thrust","ja":"双刺突","ko":"두번 찌르기","zh_hant":"雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3128,"skill_field_effect_id":0,"_id_":4149,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4150":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3129,"skill_field_effect_id":0,"_id_":4150,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4151":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3130,"skill_field_effect_id":0,"_id_":4151,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4152":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3131,"skill_field_effect_id":0,"_id_":4152,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4153":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3132,"skill_field_effect_id":0,"_id_":4153,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[40,40,40,40,40]}]},"4154":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3133,"skill_field_effect_id":0,"_id_":4154,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4155":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3134,"skill_field_effect_id":0,"_id_":4155,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4156":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"氷結の協奏曲","ko":"빙결의 협주곡","zh_hant":"冰凍協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3135,"skill_field_effect_id":0,"_id_":4156,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":61,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4157":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3136,"skill_field_effect_id":0,"_id_":4157,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":61,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4159":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3137,"skill_field_effect_id":0,"_id_":4159,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4160":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3138,"skill_field_effect_id":0,"_id_":4160,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4161":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3139,"skill_field_effect_id":0,"_id_":4161,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4162":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3140,"skill_field_effect_id":0,"_id_":4162,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4163":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3141,"skill_field_effect_id":0,"_id_":4163,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4164":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3142,"skill_field_effect_id":0,"_id_":4164,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4165":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3143,"skill_field_effect_id":0,"_id_":4165,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4166":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3144,"skill_field_effect_id":0,"_id_":4166,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4167":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Midnight NEO","ja":"ブラッディ・ミッドナイト NEO","ko":"블러디 미드나이트 NEO","zh_hant":"血腥午夜 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3145,"skill_field_effect_id":0,"_id_":4167,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4169":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":4169,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4170":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":4170,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4171":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":4171,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4172":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":4172,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4173":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":4173,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4174":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":4174,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4175":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":4175,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4176":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":4176,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4177":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":4177,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4179":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3155,"skill_field_effect_id":0,"_id_":4179,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4180":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3156,"skill_field_effect_id":0,"_id_":4180,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4181":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3157,"skill_field_effect_id":0,"_id_":4181,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4182":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3158,"skill_field_effect_id":0,"_id_":4182,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4183":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3159,"skill_field_effect_id":0,"_id_":4183,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4184":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Dance","ja":"連撃の舞","ko":"연격의 춤","zh_hant":"連擊之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3160,"skill_field_effect_id":0,"_id_":4184,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4185":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3161,"skill_field_effect_id":0,"_id_":4185,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4186":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3162,"skill_field_effect_id":0,"_id_":4186,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4187":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3163,"skill_field_effect_id":0,"_id_":4187,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4188":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cross of Retribution NEO","ja":"聖罰の十字架 NEO","ko":"성벌의 십자가 NEO","zh_hant":"聖罰十字架 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3164,"skill_field_effect_id":0,"_id_":4188,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4190":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Thrust","ja":"強襲の刺突","ko":"강습의 찌르기","zh_hant":"強襲突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3165,"skill_field_effect_id":0,"_id_":4190,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4191":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Thrust","ja":"強襲の双刺突","ko":"강습의 두번 찌르기","zh_hant":"強襲雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3166,"skill_field_effect_id":0,"_id_":4191,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4192":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Thrust","ja":"強襲の参刺突","ko":"강습의 세번 찌르기","zh_hant":"強襲參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3167,"skill_field_effect_id":0,"_id_":4192,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4193":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3168,"skill_field_effect_id":0,"_id_":4193,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4194":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Strike","ja":"回避の一撃","ko":"회피의 일격","zh_hant":"迴避一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3169,"skill_field_effect_id":0,"_id_":4194,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"4195":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3170,"skill_field_effect_id":0,"_id_":4195,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4196":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3171,"skill_field_effect_id":0,"_id_":4196,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4197":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"氷結の協奏曲","ko":"빙결의 협주곡","zh_hant":"冰凍協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3172,"skill_field_effect_id":0,"_id_":4197,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4198":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟 NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3173,"skill_field_effect_id":0,"_id_":4198,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4206":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3174,"skill_field_effect_id":0,"_id_":4206,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4207":{"attribute_id":2,"cost":2,"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Poetic Murmur","ja":"歌人の呟き","ko":"가인의 독백","zh_hant":"歌人的細語"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3175,"skill_field_effect_id":0,"_id_":4207,"skill_options":[{"id":306,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[156,163,171,178,187]},{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4208":{"attribute_id":2,"cost":2,"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Sorrowful Song","ja":"悲哀の歌","ko":"비애의 노래","zh_hant":"悲哀之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3176,"skill_field_effect_id":0,"_id_":4208,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4209":{"attribute_id":2,"cost":2,"icon_id":1007,"is_multiple_command_unique_skill":0,"name":{"en":"Esthetics of Subtlety","ja":"あはれの美学","ko":"정취의 미학","zh_hant":"物哀美學"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3177,"skill_field_effect_id":25,"_id_":4209,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":306,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[307,323,338,353,369]}]},"4216":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ardent Slash","ja":"烈斬撃","ko":"열참격","zh_hant":"烈焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3179,"skill_field_effect_id":0,"_id_":4216,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4217":{"attribute_id":5,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Heart of Affection","ja":"慈悲の心","ko":"자비의 마음","zh_hant":"慈悲之心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3180,"skill_field_effect_id":0,"_id_":4217,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":30,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"4218":{"attribute_id":5,"cost":1,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Relief of Light","ja":"光の救済","ko":"빛의 구원","zh_hant":"光之救贖"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3181,"skill_field_effect_id":0,"_id_":4218,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":241,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[5,6,7,8,10]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4219":{"attribute_id":5,"cost":1,"icon_id":32,"is_multiple_command_unique_skill":0,"name":{"en":"Show Me the Right Path, Mirror","ja":"鏡よ照らせ 正しき道を","ko":"거울아 바른 길을 비춰다오","zh_hant":"鏡子啊！照映出正確的道路吧！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3182,"skill_field_effect_id":0,"_id_":4219,"skill_options":[{"id":150,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[328,345,361,378,394]},{"id":32,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]},{"id":33,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]}]},"4221":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Aggravating Slash","ja":"激化の斬撃","ko":"격화의 참격","zh_hant":"激化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3184,"skill_field_effect_id":0,"_id_":4221,"skill_options":[{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4222":{"attribute_id":3,"cost":2,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Dusk Horizon","ja":"夕闇の地平線","ko":"초저녁의 지평선","zh_hant":"薄暮的地平線"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3185,"skill_field_effect_id":0,"_id_":4222,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":232,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4223":{"attribute_id":3,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Twilight Sky","ja":"夕暮れの空","ko":"해질녘 하늘","zh_hant":"黃昏天色"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3186,"skill_field_effect_id":0,"_id_":4223,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4224":{"attribute_id":3,"cost":2,"icon_id":1019,"is_multiple_command_unique_skill":0,"name":{"en":"Twilight Bodyguard","ja":"黄昏の用心棒","ko":"황혼의 호위꾼","zh_hant":"垂暮的保鑣"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3187,"skill_field_effect_id":26,"_id_":4224,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4233":{"attribute_id":6,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Purity of Courage","ja":"勇気の浄化","ko":"용기의 정화","zh_hant":"勇氣的淨化"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3191,"skill_field_effect_id":0,"_id_":4233,"skill_options":[{"id":127,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4234":{"attribute_id":6,"cost":2,"icon_id":58,"is_multiple_command_unique_skill":0,"name":{"en":"Poetic Ecstasy","ja":"歌人の夢心地","ko":"가인의 황홀경","zh_hant":"歌人的夢境"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3192,"skill_field_effect_id":0,"_id_":4234,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4235":{"attribute_id":6,"cost":2,"icon_id":28,"is_multiple_command_unique_skill":0,"name":{"en":"Delightful Song","ja":"歓喜の歌","ko":"환희의 노래","zh_hant":"歡喜之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3193,"skill_field_effect_id":0,"_id_":4235,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[97,101,106,112,116]},{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":28,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[5000,5500,6000,6500,7000]}]},"4236":{"attribute_id":6,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Esthetics of Beauty","ja":"をかしの美学","ko":"흥취의 미학","zh_hant":"明快美學"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3194,"skill_field_effect_id":0,"_id_":4236,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":385,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"4253":{"attribute_id":3,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3208,"skill_field_effect_id":0,"_id_":4253,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4254":{"attribute_id":3,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Dance","ja":"疾風の舞","ko":"질풍의 춤","zh_hant":"疾風之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3209,"skill_field_effect_id":0,"_id_":4254,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4255":{"attribute_id":3,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Motivated Strike","ja":"気合の一撃","ko":"기합의 일격","zh_hant":"氣勢一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3210,"skill_field_effect_id":0,"_id_":4255,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[97,101,106,112,116]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4256":{"attribute_id":3,"cost":2,"icon_id":1020,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce War Cry","ja":"猛将の雄叫び","ko":"용맹한 장수의 외침","zh_hant":"猛將的怒吼"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3211,"skill_field_effect_id":27,"_id_":4256,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":155,"hit_rate":100,"target_id":1135,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4258":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3213,"skill_field_effect_id":0,"_id_":4258,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4259":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3214,"skill_field_effect_id":0,"_id_":4259,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4260":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3215,"skill_field_effect_id":0,"_id_":4260,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4261":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3216,"skill_field_effect_id":0,"_id_":4261,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4262":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poison Slash","ja":"猛斬撃","ko":"용맹한 참격","zh_hant":"猛斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3217,"skill_field_effect_id":0,"_id_":4262,"skill_options":[{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4263":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3218,"skill_field_effect_id":0,"_id_":4263,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]},{"id":54,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4264":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3219,"skill_field_effect_id":0,"_id_":4264,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4265":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3220,"skill_field_effect_id":0,"_id_":4265,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4267":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3221,"skill_field_effect_id":0,"_id_":4267,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4268":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3222,"skill_field_effect_id":0,"_id_":4268,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4269":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3223,"skill_field_effect_id":0,"_id_":4269,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4270":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3224,"skill_field_effect_id":0,"_id_":4270,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4271":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3225,"skill_field_effect_id":0,"_id_":4271,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4272":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3226,"skill_field_effect_id":0,"_id_":4272,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4273":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3227,"skill_field_effect_id":0,"_id_":4273,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4274":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3228,"skill_field_effect_id":0,"_id_":4274,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4275":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3229,"skill_field_effect_id":0,"_id_":4275,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4277":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3230,"skill_field_effect_id":0,"_id_":4277,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4278":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3231,"skill_field_effect_id":0,"_id_":4278,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4279":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3232,"skill_field_effect_id":0,"_id_":4279,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4280":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3233,"skill_field_effect_id":0,"_id_":4280,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4281":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3234,"skill_field_effect_id":0,"_id_":4281,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4282":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3235,"skill_field_effect_id":0,"_id_":4282,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4283":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3236,"skill_field_effect_id":0,"_id_":4283,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4284":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3237,"skill_field_effect_id":0,"_id_":4284,"skill_options":[{"id":9,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4285":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3238,"skill_field_effect_id":0,"_id_":4285,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4287":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":4287,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4288":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":4288,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4289":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":4289,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4290":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":4290,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4291":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":4291,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4292":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":4292,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4293":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":4293,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4294":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":4294,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4295":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":4295,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4296":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":4296,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4298":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3249,"skill_field_effect_id":0,"_id_":4298,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4299":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3250,"skill_field_effect_id":0,"_id_":4299,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4300":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3251,"skill_field_effect_id":0,"_id_":4300,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4301":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3252,"skill_field_effect_id":0,"_id_":4301,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4302":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Poison Triple Slash","ja":"猛参撃","ko":"용맹한 삼격","zh_hant":"猛參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3253,"skill_field_effect_id":0,"_id_":4302,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[140,140,140,140,140]}]},"4303":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3254,"skill_field_effect_id":0,"_id_":4303,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4304":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3255,"skill_field_effect_id":0,"_id_":4304,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4305":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3256,"skill_field_effect_id":0,"_id_":4305,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4307":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3257,"skill_field_effect_id":0,"_id_":4307,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4308":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3258,"skill_field_effect_id":0,"_id_":4308,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4309":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3259,"skill_field_effect_id":0,"_id_":4309,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4310":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3260,"skill_field_effect_id":0,"_id_":4310,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4311":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3261,"skill_field_effect_id":0,"_id_":4311,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4312":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3262,"skill_field_effect_id":0,"_id_":4312,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4313":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3263,"skill_field_effect_id":0,"_id_":4313,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4314":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3264,"skill_field_effect_id":0,"_id_":4314,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4315":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3265,"skill_field_effect_id":0,"_id_":4315,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4317":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3266,"skill_field_effect_id":0,"_id_":4317,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4318":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3267,"skill_field_effect_id":0,"_id_":4318,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4319":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3268,"skill_field_effect_id":0,"_id_":4319,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4320":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3269,"skill_field_effect_id":0,"_id_":4320,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4321":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3270,"skill_field_effect_id":0,"_id_":4321,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4322":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3271,"skill_field_effect_id":0,"_id_":4322,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4323":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3272,"skill_field_effect_id":0,"_id_":4323,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4324":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3273,"skill_field_effect_id":0,"_id_":4324,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4325":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3274,"skill_field_effect_id":0,"_id_":4325,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4327":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":4327,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4328":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":4328,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4329":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":4329,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4330":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":4330,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4331":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":4331,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4332":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":4332,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4333":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":4333,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4334":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":4334,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4335":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":4335,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4336":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":4336,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4337":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":4337,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4339":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":0,"_id_":4339,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4340":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":0,"_id_":4340,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4341":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":0,"_id_":4341,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4342":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":0,"_id_":4342,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4343":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":0,"_id_":4343,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4344":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3291,"skill_field_effect_id":0,"_id_":4344,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4345":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":0,"_id_":4345,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4346":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3293,"skill_field_effect_id":0,"_id_":4346,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4348":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":0,"_id_":4348,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4349":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":0,"_id_":4349,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4350":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":0,"_id_":4350,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4351":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":0,"_id_":4351,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4352":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":0,"_id_":4352,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4353":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":0,"_id_":4353,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4354":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3300,"skill_field_effect_id":0,"_id_":4354,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4355":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":0,"_id_":4355,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4356":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":0,"_id_":4356,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4357":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3303,"skill_field_effect_id":0,"_id_":4357,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4359":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":0,"_id_":4359,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4360":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":0,"_id_":4360,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4361":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":0,"_id_":4361,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4362":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":0,"_id_":4362,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4363":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":0,"_id_":4363,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4364":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":0,"_id_":4364,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4365":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":0,"_id_":4365,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4366":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3311,"skill_field_effect_id":0,"_id_":4366,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4367":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":0,"_id_":4367,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4368":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3313,"skill_field_effect_id":0,"_id_":4368,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4370":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":4370,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4371":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":4371,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4372":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":4372,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4373":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":4373,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4374":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":4374,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4375":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":4375,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4376":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":4376,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4377":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":4377,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4378":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":4378,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4379":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":4379,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4380":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":4380,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4382":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Slash","ja":"キラめきの剣撃","ko":"반짝임의 검격","zh_hant":"光芒劍擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3325,"skill_field_effect_id":0,"_id_":4382,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4383":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Land and Sky","ja":"空と大地","ko":"하늘과 대지","zh_hant":"天空與大地"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3326,"skill_field_effect_id":0,"_id_":4383,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"4384":{"attribute_id":4,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Light and Darkness","ja":"光と闇","ko":"빛과 어둠","zh_hant":"光與暗"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3327,"skill_field_effect_id":0,"_id_":4384,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4385":{"attribute_id":4,"cost":2,"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Genesis","ja":"独煌のゲネシス","ko":"눈부신 제네시스","zh_hant":"獨尊創世紀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3328,"skill_field_effect_id":0,"_id_":4385,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":60,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4387":{"attribute_id":6,"cost":1,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Adjustment","ja":"調整","ko":"조정","zh_hant":"調整"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3330,"skill_field_effect_id":0,"_id_":4387,"skill_options":[{"id":157,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4388":{"attribute_id":6,"cost":2,"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Clumsy Handling","ja":"稚拙な運用","ko":"치졸한 운용","zh_hant":"拙劣的運用"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3331,"skill_field_effect_id":0,"_id_":4388,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4389":{"attribute_id":6,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Skillful Management","ja":"巧みな管理","ko":"정교한 관리","zh_hant":"巧妙的管理"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3332,"skill_field_effect_id":0,"_id_":4389,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4390":{"attribute_id":6,"cost":2,"icon_id":234,"is_multiple_command_unique_skill":0,"name":{"en":"Article 14: Forceful Removal","ja":"幸福都市検察法第14条『強攻排除』","ko":"행복 도시 검찰법 제14조 [강공배제]","zh_hant":"幸福都市檢查法第14條『強攻排除』"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3333,"skill_field_effect_id":0,"_id_":4390,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[197,205,210,215,230]},{"id":377,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[2222,3333,4444,5555,6666]}]},"4392":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Dance","ja":"疾風の舞","ko":"질풍의 춤","zh_hant":"疾風之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3335,"skill_field_effect_id":0,"_id_":4392,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4393":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Forced Breakthrough","ja":"強行突破","ko":"강행돌파","zh_hant":"強行突破"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3336,"skill_field_effect_id":0,"_id_":4393,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4394":{"attribute_id":4,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Limitless Radiance","ja":"永遠の輝き","ko":"영원한 반짝임","zh_hant":"永恆光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3337,"skill_field_effect_id":0,"_id_":4394,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4395":{"attribute_id":4,"cost":2,"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"Oni's Fist","ja":"鬼の鉄拳","ko":"악마의 철권","zh_hant":"鬼之鐵拳"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3338,"skill_field_effect_id":0,"_id_":4395,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":371,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4397":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Prayer","ja":"祈りの剣","ko":"기도의 검","zh_hant":"祈願之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3340,"skill_field_effect_id":0,"_id_":4397,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":157,"hit_rate":100,"target_id":1133,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4398":{"attribute_id":2,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Divinity","ja":"女神の剣","ko":"여신의 검","zh_hant":"女神之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3341,"skill_field_effect_id":0,"_id_":4398,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4399":{"attribute_id":2,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Piercing Sword","ja":"貫きの剣","ko":"관통의 검","zh_hant":"貫穿之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3342,"skill_field_effect_id":0,"_id_":4399,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4400":{"attribute_id":2,"cost":2,"icon_id":198,"is_multiple_command_unique_skill":0,"name":{"en":"Haja Kensei - Ouka Houshin","ja":"破邪剣征・桜花放神","ko":"파사검정 앵화방신","zh_hant":"破邪劍征・櫻花放神"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3343,"skill_field_effect_id":0,"_id_":4400,"skill_options":[{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[240,250,260,270,280]}]},"4402":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3345,"skill_field_effect_id":0,"_id_":4402,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4403":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Dance","ja":"疾風の舞","ko":"질풍의 춤","zh_hant":"疾風之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3346,"skill_field_effect_id":0,"_id_":4403,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4404":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Motivated Strike","ja":"気合の一撃","ko":"기합의 일격","zh_hant":"氣勢一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3347,"skill_field_effect_id":0,"_id_":4404,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[97,101,106,112,116]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4405":{"attribute_id":4,"cost":2,"icon_id":1021,"is_multiple_command_unique_skill":0,"name":{"en":"Sacre de Lumiere","ja":"サクレ・デ・リュミエール","ko":"사크레 드 뤼미에르","zh_hant":"神聖之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3348,"skill_field_effect_id":28,"_id_":4405,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":360,"hit_rate":100,"target_id":1142,"times":[1,1,1,1,1],"values":[50,50,50,50,50]}]},"4407":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3350,"skill_field_effect_id":0,"_id_":4407,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4408":{"attribute_id":1,"cost":2,"icon_id":195,"is_multiple_command_unique_skill":0,"name":{"en":"Creation Slash","ja":"創造の斬撃","ko":"창조의 참격","zh_hant":"創造斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3351,"skill_field_effect_id":0,"_id_":4408,"skill_options":[{"id":306,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"4409":{"attribute_id":1,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Victory Oath","ja":"勝利の誓い","ko":"승리의 맹세","zh_hant":"勝利誓約"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3352,"skill_field_effect_id":0,"_id_":4409,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":39,"hit_rate":100,"target_id":1143,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4410":{"attribute_id":1,"cost":2,"icon_id":62,"is_multiple_command_unique_skill":0,"name":{"en":"Rambling Wheel","ja":"ランブリング・ホイール","ko":"럼블링 휠","zh_hant":"水車斬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3353,"skill_field_effect_id":0,"_id_":4410,"skill_options":[{"id":376,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4412":{"attribute_id":2,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Blade","ja":"浄化の刃","ko":"정화의 칼날","zh_hant":"淨化之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3355,"skill_field_effect_id":0,"_id_":4412,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4413":{"attribute_id":2,"cost":2,"icon_id":192,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Blink","ja":"減光の瞬き","ko":"감광의 반짝임","zh_hant":"減光之瞬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3356,"skill_field_effect_id":0,"_id_":4413,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"4414":{"attribute_id":2,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Skyward Leap","ja":"大空への跳躍","ko":"드넓은 하늘로의 도약","zh_hant":"邁向高空的跳躍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3357,"skill_field_effect_id":0,"_id_":4414,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4415":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Nostalgic Cherry Blossoms","ja":"想い出の桜花","ko":"추억의 벚꽃","zh_hant":"回憶的櫻花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3358,"skill_field_effect_id":0,"_id_":4415,"skill_options":[{"id":310,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[200,210,220,230,240]},{"id":384,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4417":{"attribute_id":6,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Limitless Radiance","ja":"永遠の輝き","ko":"영원한 반짝임","zh_hant":"永恆光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3363,"skill_field_effect_id":0,"_id_":4417,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4418":{"attribute_id":6,"cost":2,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Cloud Piercing","ja":"雲射る刃","ko":"구름을 찌르는 칼날","zh_hant":"穿雲之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3364,"skill_field_effect_id":0,"_id_":4418,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":35,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"4419":{"attribute_id":6,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Blade","ja":"疾風の刃","ko":"질풍의 칼날","zh_hant":"疾風之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3365,"skill_field_effect_id":0,"_id_":4419,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4420":{"attribute_id":6,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Flames of Justice","ja":"正義の業火","ko":"정의의 업화","zh_hant":"正義的業火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3366,"skill_field_effect_id":29,"_id_":4420,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":299,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4447":{"attribute_id":1,"cost":2,"icon_id":6,"is_multiple_command_unique_skill":0,"name":{"en":"One Arrow","ja":"一の矢","ko":"첫 번째 화살","zh_hant":"第一箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3380,"skill_field_effect_id":0,"_id_":4447,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,27,30]}]},"4448":{"attribute_id":1,"cost":2,"icon_id":33,"is_multiple_command_unique_skill":0,"name":{"en":"Two Arrows","ja":"二の矢","ko":"두 번째 화살","zh_hant":"第二箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3381,"skill_field_effect_id":0,"_id_":4448,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4449":{"attribute_id":1,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Three Arrows","ja":"三の矢","ko":"세 번째 화살","zh_hant":"第三箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3382,"skill_field_effect_id":0,"_id_":4449,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":30,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"4450":{"attribute_id":1,"cost":2,"icon_id":1023,"is_multiple_command_unique_skill":0,"name":{"en":"Three Arrows' Bond","ja":"三矢の絆","ko":"세 화살의 인연","zh_hant":"三箭的羈絆"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3383,"skill_field_effect_id":30,"_id_":4450,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4452":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3385,"skill_field_effect_id":0,"_id_":4452,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4453":{"attribute_id":6,"cost":2,"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Decision Time","ja":"決断の時","ko":"결단의 시간","zh_hant":"決斷之時"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3386,"skill_field_effect_id":0,"_id_":4453,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4454":{"attribute_id":6,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Judgement Time","ja":"審判の時","ko":"심판의 시간","zh_hant":"審判之時"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3387,"skill_field_effect_id":0,"_id_":4454,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4455":{"attribute_id":6,"cost":2,"icon_id":229,"is_multiple_command_unique_skill":0,"name":{"en":"Love & Rebirth Judgement","ja":"Love＆Rebirth Judgment","ko":"Love & Rebirth Judgment","zh_hant":"Love＆Rebirth Judgment"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3388,"skill_field_effect_id":0,"_id_":4455,"skill_options":[{"id":386,"hit_rate":100,"target_id":22002,"times":[4,4,4,4,4],"values":[200,210,220,230,240]},{"id":7,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[40,42,44,47,50]}]},"4457":{"attribute_id":6,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Dance","ja":"疾風の舞","ko":"질풍의 춤","zh_hant":"疾風之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3390,"skill_field_effect_id":0,"_id_":4457,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4458":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Forced Breakthrough","ja":"強行突破","ko":"강행돌파","zh_hant":"強行突破"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3391,"skill_field_effect_id":0,"_id_":4458,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4459":{"attribute_id":6,"cost":2,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Limitless Radiance","ja":"永遠の輝き","ko":"영원한 반짝임","zh_hant":"永恆光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3392,"skill_field_effect_id":0,"_id_":4459,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4460":{"attribute_id":6,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Gatling Typhoon","ja":"乱れ撃ちタイフーン","ko":"난사 타이푼","zh_hant":"亂射颱風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3393,"skill_field_effect_id":0,"_id_":4460,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4462":{"attribute_id":5,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3395,"skill_field_effect_id":0,"_id_":4462,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4463":{"attribute_id":5,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Song","ja":"浄化の歌","ko":"정화의 노래","zh_hant":"淨化之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3396,"skill_field_effect_id":0,"_id_":4463,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4464":{"attribute_id":5,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Voice","ja":"浄化の声","ko":"정화의 목소리","zh_hant":"淨化之聲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3397,"skill_field_effect_id":0,"_id_":4464,"skill_options":[{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4465":{"attribute_id":5,"cost":2,"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Listen to the Sound of My Soul!","ja":"聞かせて魅せます命の響！","ko":"들려드리지요 생의 울림을!","zh_hant":"響徹雲霄，生命迴響！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3398,"skill_field_effect_id":0,"_id_":4465,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[164,172,181,189,197]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4467":{"attribute_id":1,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3400,"skill_field_effect_id":0,"_id_":4467,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4468":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Heart","ja":"自由な心","ko":"자유로운 마음","zh_hant":"自由之心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3401,"skill_field_effect_id":0,"_id_":4468,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"4469":{"attribute_id":1,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Piercing Sword","ja":"貫きの剣","ko":"관통의 검","zh_hant":"貫穿之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3402,"skill_field_effect_id":0,"_id_":4469,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4470":{"attribute_id":1,"cost":2,"icon_id":1024,"is_multiple_command_unique_skill":0,"name":{"en":"Rose Escape","ja":"薔薇の逃避行","ko":"장미의 도피행","zh_hant":"玫瑰的逃世"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3403,"skill_field_effect_id":31,"_id_":4470,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4472":{"attribute_id":5,"cost":2,"icon_id":239,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Power","ja":"恋の力","ko":"애정의 힘","zh_hant":"戀的力量"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3405,"skill_field_effect_id":0,"_id_":4472,"skill_options":[{"id":345,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"4473":{"attribute_id":5,"cost":2,"icon_id":221,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Anguish","ja":"恋の苦しみ","ko":"애정의 고통","zh_hant":"戀的苦澀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3406,"skill_field_effect_id":0,"_id_":4473,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":341,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4474":{"attribute_id":5,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Warmth","ja":"恋の暖かみ","ko":"애정의 온기","zh_hant":"戀的溫暖"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3407,"skill_field_effect_id":0,"_id_":4474,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"4475":{"attribute_id":5,"cost":2,"icon_id":239,"is_multiple_command_unique_skill":0,"name":{"en":"One Drop of Love","ja":"一滴の愛","ko":"한 방울의 사랑","zh_hant":"一滴的愛"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3408,"skill_field_effect_id":0,"_id_":4475,"skill_options":[{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]},{"id":156,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":345,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[180,190,200,210,220]}]},"4477":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3069,"skill_field_effect_id":0,"_id_":4477,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4478":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3070,"skill_field_effect_id":0,"_id_":4478,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4479":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3071,"skill_field_effect_id":0,"_id_":4479,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4480":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3072,"skill_field_effect_id":0,"_id_":4480,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4481":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3073,"skill_field_effect_id":0,"_id_":4481,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4482":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3074,"skill_field_effect_id":0,"_id_":4482,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4483":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3075,"skill_field_effect_id":0,"_id_":4483,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4484":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3076,"skill_field_effect_id":0,"_id_":4484,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4485":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3077,"skill_field_effect_id":0,"_id_":4485,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4487":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3105,"skill_field_effect_id":0,"_id_":4487,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4488":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3106,"skill_field_effect_id":0,"_id_":4488,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4489":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3107,"skill_field_effect_id":0,"_id_":4489,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4490":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3108,"skill_field_effect_id":0,"_id_":4490,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4491":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3109,"skill_field_effect_id":0,"_id_":4491,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4492":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3110,"skill_field_effect_id":0,"_id_":4492,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4493":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3111,"skill_field_effect_id":0,"_id_":4493,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4494":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3112,"skill_field_effect_id":0,"_id_":4494,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4495":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3113,"skill_field_effect_id":0,"_id_":4495,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4496":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3114,"skill_field_effect_id":0,"_id_":4496,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4497":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3115,"skill_field_effect_id":0,"_id_":4497,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4499":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":4499,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4500":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":4500,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4501":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":4501,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4502":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":4502,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4503":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":4503,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4504":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":4504,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4505":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":4505,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4506":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":4506,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4507":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":4507,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4524":{"attribute_id":1,"cost":2,"icon_id":189,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Strength","ja":"愛の力","ko":"사랑의 힘","zh_hant":"愛的力量"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3415,"skill_field_effect_id":0,"_id_":4524,"skill_options":[{"id":284,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[156,163,171,178,187]}]},"4525":{"attribute_id":1,"cost":2,"icon_id":62,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Suffering","ja":"愛の苦しみ","ko":"사랑의 고통","zh_hant":"愛的苦澀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3416,"skill_field_effect_id":0,"_id_":4525,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":302,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4526":{"attribute_id":1,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Affection","ja":"愛の暖かみ","ko":"사랑의 온기","zh_hant":"愛的溫暖"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3417,"skill_field_effect_id":0,"_id_":4526,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"4527":{"attribute_id":1,"cost":2,"icon_id":151,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom of Tragedy","ja":"悲劇の花吹雪","ko":"비극의 꽃보라","zh_hant":"悲劇的花吹雪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3418,"skill_field_effect_id":0,"_id_":4527,"skill_options":[{"id":151,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":284,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[180,190,200,210,220]}]},"4529":{"attribute_id":3,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3420,"skill_field_effect_id":0,"_id_":4529,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4530":{"attribute_id":3,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Path of Hope","ja":"希望への道","ko":"희망으로의 길","zh_hant":"通往希望的道路"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3421,"skill_field_effect_id":0,"_id_":4530,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4531":{"attribute_id":3,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Skyward Leap","ja":"大空への跳躍","ko":"드넓은 하늘로의 도약","zh_hant":"邁向高空的跳躍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3422,"skill_field_effect_id":0,"_id_":4531,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4532":{"attribute_id":3,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Light of Hope","ja":"希望は光になりて","ko":"희망은 빛이 될 자","zh_hant":"希望終將成為光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3423,"skill_field_effect_id":0,"_id_":4532,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":392,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4534":{"attribute_id":5,"cost":2,"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Proof","ja":"愛の証明","ko":"사랑의 증명","zh_hant":"愛的證明"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3425,"skill_field_effect_id":0,"_id_":4534,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4535":{"attribute_id":5,"cost":2,"icon_id":1025,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Lament","ja":"愛の嘆き","ko":"사랑의 비탄","zh_hant":"愛的慨嘆"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3426,"skill_field_effect_id":32,"_id_":4535,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4536":{"attribute_id":5,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Love's Affection","ja":"愛の暖かみ","ko":"사랑의 온기","zh_hant":"愛的溫暖"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3427,"skill_field_effect_id":0,"_id_":4536,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"4537":{"attribute_id":5,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Tragedy","ja":"美しき悲劇","ko":"아름다운 비극","zh_hant":"淒美的悲劇"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3428,"skill_field_effect_id":0,"_id_":4537,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":384,"hit_rate":100,"target_id":4068,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4539":{"attribute_id":5,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Lovely Arrow","ja":"麗しの矢","ko":"아름다운 화살","zh_hant":"美麗之箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3430,"skill_field_effect_id":0,"_id_":4539,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4540":{"attribute_id":5,"cost":2,"icon_id":6,"is_multiple_command_unique_skill":0,"name":{"en":"Love Arrow","ja":"愛の矢","ko":"사랑의 화살","zh_hant":"愛之箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3431,"skill_field_effect_id":0,"_id_":4540,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,27,30]}]},"4541":{"attribute_id":5,"cost":2,"icon_id":33,"is_multiple_command_unique_skill":0,"name":{"en":"Arrow of Freedom","ja":"自由の矢","ko":"자유의 화살","zh_hant":"自由之箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3432,"skill_field_effect_id":0,"_id_":4541,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4542":{"attribute_id":5,"cost":2,"icon_id":1021,"is_multiple_command_unique_skill":0,"name":{"en":"Aggressive Coyote","ja":"牙剝くコヨーテ","ko":"사나운 코요테","zh_hant":"露出獠牙的郊狼"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3433,"skill_field_effect_id":33,"_id_":4542,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":384,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4549":{"attribute_id":3,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Mow","ja":"浄化の薙払","ko":"정화의 베어넘기기","zh_hant":"淨化之橫掃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3435,"skill_field_effect_id":0,"_id_":4549,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4550":{"attribute_id":3,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Strategic Prank","ja":"策略家のいたずら","ko":"책략가의 장난","zh_hant":"謀略家的惡作劇"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3436,"skill_field_effect_id":0,"_id_":4550,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[129,136,141,148,155]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4551":{"attribute_id":3,"cost":2,"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Limitless Radiance","ja":"永遠の輝き","ko":"영원한 반짝임","zh_hant":"永恆光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3437,"skill_field_effect_id":0,"_id_":4551,"skill_options":[{"id":80,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4552":{"attribute_id":3,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Together with the King!","ja":"わが宿命は、王と共に！","ko":"나의 숙명은 왕과 함께!","zh_hant":"吾之宿命，與王同在！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3438,"skill_field_effect_id":0,"_id_":4552,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4554":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3440,"skill_field_effect_id":0,"_id_":4554,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4555":{"attribute_id":4,"cost":2,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Dynamic Attack","ja":"ダイナミックアタック","ko":"다이내믹 어택","zh_hant":"舞動攻擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3441,"skill_field_effect_id":0,"_id_":4555,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":232,"hit_rate":100,"target_id":2121,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4556":{"attribute_id":4,"cost":3,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Pinpoint Clutch","ja":"ピンポイントクラッチ","ko":"핀포인트 클러치","zh_hant":"重點式固定技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3442,"skill_field_effect_id":0,"_id_":4556,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":394,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4557":{"attribute_id":4,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Nightmare Show","ja":"Nightmare Show","ko":"Nightmare Show","zh_hant":"夢魘表演"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3443,"skill_field_effect_id":0,"_id_":4557,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[240,250,260,270,280]},{"id":394,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[60,60,60,60,60]},{"id":232,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4559":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ardent Thrust","ja":"烈刺突","ko":"강렬한 찌르기","zh_hant":"烈焰突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3445,"skill_field_effect_id":0,"_id_":4559,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"4560":{"attribute_id":1,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Emperor's Authority","ja":"皇帝の威厳","ko":"황제의 위엄","zh_hant":"皇帝的威嚴"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3446,"skill_field_effect_id":0,"_id_":4560,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":31,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[3000,3500,4000,4500,5000]}]},"4561":{"attribute_id":1,"cost":1,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Emperor's Prestige","ja":"皇帝の威信","ko":"황제의 위신","zh_hant":"皇帝的威信"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3447,"skill_field_effect_id":0,"_id_":4561,"skill_options":[{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,32,35,40,50]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4562":{"attribute_id":1,"cost":2,"icon_id":33,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer","ja":"威光堂々　～銀河皇帝円舞曲～","ko":"위풍당당 ~은하 황제 원무곡~","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3448,"skill_field_effect_id":0,"_id_":4562,"skill_options":[{"id":150,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[328,345,361,378,394]},{"id":32,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]},{"id":33,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]}]},"4564":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Profuse Strike","ja":"繚乱の一撃","ko":"요란의 일격","zh_hant":"繚亂一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3450,"skill_field_effect_id":0,"_id_":4564,"skill_options":[{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[91,95,99,104,109]}]},"4565":{"attribute_id":4,"cost":2,"icon_id":54,"is_multiple_command_unique_skill":0,"name":{"en":"Poisonous Invitation","ja":"妖毒の誘い","ko":"요독의 초대","zh_hant":"妖毒的誘惑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3451,"skill_field_effect_id":0,"_id_":4565,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":245,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[6,8,10,12,15]}]},"4566":{"attribute_id":4,"cost":3,"icon_id":158,"is_multiple_command_unique_skill":0,"name":{"en":"Life Blade","ja":"命の刃","ko":"생명의 칼날","zh_hant":"命之刃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3452,"skill_field_effect_id":0,"_id_":4566,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":276,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[74,78,82,87,91]}]},"4567":{"attribute_id":4,"cost":2,"icon_id":197,"is_multiple_command_unique_skill":0,"name":{"en":"Invincible Sword","ja":"無敵の剣","ko":"무적의 검","zh_hant":"無敵之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3453,"skill_field_effect_id":34,"_id_":4567,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[240,250,260,270,280]},{"id":309,"hit_rate":100,"target_id":11011,"times":[0,0,0,0,0],"values":[50,55,60,65,70]}]},"4569":{"attribute_id":3,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3455,"skill_field_effect_id":0,"_id_":4569,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4570":{"attribute_id":3,"cost":2,"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Madness Attack","ja":"マッドネスアタック","ko":"매드니스 어택","zh_hant":"瘋狂攻擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3456,"skill_field_effect_id":0,"_id_":4570,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":298,"hit_rate":100,"target_id":2121,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4571":{"attribute_id":3,"cost":3,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Pinpoint Clutch","ja":"ピンポイントクラッチ","ko":"핀포인트 클러치","zh_hant":"重點式固定技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3457,"skill_field_effect_id":0,"_id_":4571,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":394,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4572":{"attribute_id":3,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"PONZU Toxic Mist","ja":"PONZU毒霧","ko":"PONZU 독안개","zh_hant":"柚子醋毒霧"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3458,"skill_field_effect_id":0,"_id_":4572,"skill_options":[{"id":127,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":54,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[55555,66666,77777,88888,99999]},{"id":310,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"4574":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":4574,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4575":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":4575,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4576":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":4576,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4577":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":4577,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4578":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":4578,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4579":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":4579,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4580":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":4580,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4581":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":4581,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4582":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":4582,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4584":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":4584,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4585":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":4585,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4586":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":4586,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4587":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":4587,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4588":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":4588,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4589":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":4589,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4590":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":4590,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4591":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":4591,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4592":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":4592,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4593":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":4593,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4595":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":4595,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4596":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":4596,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4597":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":4597,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4598":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":4598,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4599":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":4599,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4600":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":4600,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4601":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":4601,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4602":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":4602,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4604":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":4604,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4605":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":4605,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4606":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":4606,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4607":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":4607,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4608":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":4608,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4609":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":4609,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4610":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":4610,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4611":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":4611,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4613":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2832,"skill_field_effect_id":0,"_id_":4613,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4614":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2833,"skill_field_effect_id":0,"_id_":4614,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4615":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2834,"skill_field_effect_id":0,"_id_":4615,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4616":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2835,"skill_field_effect_id":0,"_id_":4616,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4617":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2836,"skill_field_effect_id":0,"_id_":4617,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4618":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2837,"skill_field_effect_id":0,"_id_":4618,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4619":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2838,"skill_field_effect_id":0,"_id_":4619,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4620":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2839,"skill_field_effect_id":0,"_id_":4620,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4622":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2865,"skill_field_effect_id":0,"_id_":4622,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4623":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Sharpshooting","ja":"双狙撃","ko":"쌍저격","zh_hant":"雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2866,"skill_field_effect_id":0,"_id_":4623,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4624":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Sharpshooting","ja":"強襲の双狙撃","ko":"강습의 쌍저격","zh_hant":"強襲雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2867,"skill_field_effect_id":0,"_id_":4624,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4625":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2868,"skill_field_effect_id":0,"_id_":4625,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4626":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2869,"skill_field_effect_id":0,"_id_":4626,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4627":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2870,"skill_field_effect_id":0,"_id_":4627,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4628":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2871,"skill_field_effect_id":0,"_id_":4628,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4629":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2872,"skill_field_effect_id":0,"_id_":4629,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4630":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2873,"skill_field_effect_id":0,"_id_":4630,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4632":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":0,"_id_":4632,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4633":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":0,"_id_":4633,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4634":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":0,"_id_":4634,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4635":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":0,"_id_":4635,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4636":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":0,"_id_":4636,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4637":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":0,"_id_":4637,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4638":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2908,"skill_field_effect_id":0,"_id_":4638,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4639":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2909,"skill_field_effect_id":0,"_id_":4639,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4641":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":0,"_id_":4641,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4642":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":0,"_id_":4642,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4643":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":0,"_id_":4643,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4644":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":0,"_id_":4644,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4645":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":0,"_id_":4645,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4646":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":0,"_id_":4646,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4647":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":0,"_id_":4647,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4648":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2900,"skill_field_effect_id":0,"_id_":4648,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4649":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2901,"skill_field_effect_id":0,"_id_":4649,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4660":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":0,"_id_":4660,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4661":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":0,"_id_":4661,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4662":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":0,"_id_":4662,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4663":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":0,"_id_":4663,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4664":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":0,"_id_":4664,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4665":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":0,"_id_":4665,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4666":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":0,"_id_":4666,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4667":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":0,"_id_":4667,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"4668":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2918,"skill_field_effect_id":0,"_id_":4668,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4669":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2919,"skill_field_effect_id":0,"_id_":4669,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"4687":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Brilliance","ja":"月光のキラめき","ko":"달빛의 반짝임","zh_hant":"月光的光芒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3501,"skill_field_effect_id":0,"_id_":4687,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4688":{"attribute_id":4,"cost":3,"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Insanity","ja":"月光の狂気","ko":"달빛의 광기","zh_hant":"月光的瘋狂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3502,"skill_field_effect_id":0,"_id_":4688,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[220,240,260,280,300]},{"id":59,"hit_rate":100,"target_id":2146,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4689":{"attribute_id":4,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Ring","ja":"月光環","ko":"월광환","zh_hant":"月光環"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3503,"skill_field_effect_id":0,"_id_":4689,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4690":{"attribute_id":4,"cost":2,"icon_id":235,"is_multiple_command_unique_skill":0,"name":{"en":"Rising Moon☆Rampage!","ja":"Rising Moon☆Rampage！","ko":"Rising Moon☆Rampage!","zh_hant":"Rising Moon☆Rampage！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3504,"skill_field_effect_id":0,"_id_":4690,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":382,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]}]},"4692":{"attribute_id":4,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Mow","ja":"浄化の薙払","ko":"정화의 베어넘기기","zh_hant":"淨化之橫掃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3506,"skill_field_effect_id":0,"_id_":4692,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4693":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3507,"skill_field_effect_id":0,"_id_":4693,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4694":{"attribute_id":4,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Unconventional Sword","ja":"型破りの剣","ko":"파격의 검","zh_hant":"打破常規之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3508,"skill_field_effect_id":35,"_id_":4694,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4695":{"attribute_id":4,"cost":2,"icon_id":60,"is_multiple_command_unique_skill":0,"name":{"en":"Baragaki","ja":"茨掻き","ko":"마구 할퀴기","zh_hant":"爪痕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3509,"skill_field_effect_id":0,"_id_":4695,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":60,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4697":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Strike","ja":"浄化の一撃","ko":"정화의 일격","zh_hant":"浄化一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3511,"skill_field_effect_id":0,"_id_":4697,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4698":{"attribute_id":4,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Strike","ja":"弛緩の一撃","ko":"이완의 일격","zh_hant":"遲緩一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3512,"skill_field_effect_id":0,"_id_":4698,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":13,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4699":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Strike","ja":"自由な一撃","ko":"자유로운 일격","zh_hant":"自由一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3513,"skill_field_effect_id":0,"_id_":4699,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4700":{"attribute_id":4,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Flower of Recollection","ja":"追憶の銀花","ko":"추억의 은꽃","zh_hant":"追憶的銀花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3514,"skill_field_effect_id":0,"_id_":4700,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"4702":{"attribute_id":6,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Mow","ja":"浄化の薙払","ko":"정화의 베어넘기기","zh_hant":"淨化之橫掃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3516,"skill_field_effect_id":0,"_id_":4702,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4703":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3517,"skill_field_effect_id":0,"_id_":4703,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4704":{"attribute_id":6,"cost":2,"icon_id":1025,"is_multiple_command_unique_skill":0,"name":{"en":"Day Lamp Shadow","ja":"昼行燈の影","ko":"한낮의 등불 그림자","zh_hant":"晝行燈之影"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3518,"skill_field_effect_id":36,"_id_":4704,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4705":{"attribute_id":6,"cost":2,"icon_id":6,"is_multiple_command_unique_skill":0,"name":{"en":"Snow Melting","ja":"雪解","ko":"눈석임","zh_hant":"融雪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3519,"skill_field_effect_id":0,"_id_":4705,"skill_options":[{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]},{"id":34,"hit_rate":100,"target_id":1135,"times":[5,5,5,5,5],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4707":{"attribute_id":7,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Victory Present","ja":"勝利の贈り物","ko":"승리의 선물","zh_hant":"勝利的餽贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3521,"skill_field_effect_id":0,"_id_":4707,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4708":{"attribute_id":7,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Present","ja":"自由な贈り物","ko":"자유로운 선물","zh_hant":"自由的餽贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3522,"skill_field_effect_id":0,"_id_":4708,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"4709":{"attribute_id":7,"cost":2,"icon_id":33,"is_multiple_command_unique_skill":0,"name":{"en":"Counterattack Present","ja":"反撃の贈り物","ko":"반격의 선물","zh_hant":"反擊的饋贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3523,"skill_field_effect_id":0,"_id_":4709,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]}]},"4710":{"attribute_id":7,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Black Santa's Present","ja":"ブラックサンタのプレゼント","ko":"블랙 산타의 선물","zh_hant":"黑色聖誕老人的禮物"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3524,"skill_field_effect_id":0,"_id_":4710,"skill_options":[{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]},{"id":156,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[240,250,260,270,280]}]},"4712":{"attribute_id":6,"cost":2,"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Present","ja":"凍てつく贈り物","ko":"얼어붙은 선물","zh_hant":"凍結的餽贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3526,"skill_field_effect_id":0,"_id_":4712,"skill_options":[{"id":127,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":61,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4713":{"attribute_id":6,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Selfish Present","ja":"わがままな贈り物","ko":"제멋대로인 선물","zh_hant":"任性的餽贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3527,"skill_field_effect_id":0,"_id_":4713,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"4714":{"attribute_id":6,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Disorderly Present","ja":"取り乱す贈り物","ko":"흐트러진 선물","zh_hant":"雜亂無章的餽贈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3528,"skill_field_effect_id":0,"_id_":4714,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":384,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"4715":{"attribute_id":6,"cost":2,"icon_id":241,"is_multiple_command_unique_skill":0,"name":{"en":"White Santa's Present","ja":"ホワイトサンタのプレゼント","ko":"화이트 산타의 선물","zh_hant":"白色聖誕老人的禮物"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3529,"skill_field_effect_id":0,"_id_":4715,"skill_options":[{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":310,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[200,210,220,230,240]},{"id":398,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[55555,66666,77777,88888,99999]}]},"4717":{"attribute_id":6,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Gale Dance","ja":"疾風の舞","ko":"질풍의 춤","zh_hant":"疾風之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3531,"skill_field_effect_id":0,"_id_":4717,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[84,88,92,97,101]}]},"4718":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Gust of Brilliance","ja":"キラめきの風","ko":"반짝임의 바람","zh_hant":"光芒之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3532,"skill_field_effect_id":0,"_id_":4718,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[15,16,17,18,20]}]},"4719":{"attribute_id":6,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Lightning Mow","ja":"雷撃の薙払","ko":"뇌격의 베어넘기기","zh_hant":"雷擊橫掃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3533,"skill_field_effect_id":38,"_id_":4719,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"4720":{"attribute_id":6,"cost":2,"icon_id":1010,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"青龍炎舞","ko":"청룡염무","zh_hant":"青龍炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3534,"skill_field_effect_id":39,"_id_":4720,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[55555,66666,77777,88888,99999]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4722":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":4722,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4723":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":4723,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4724":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":4724,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4725":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":4725,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4726":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":4726,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4727":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":4727,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4728":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":4728,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4729":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":4729,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4730":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":4730,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4732":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":4732,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4733":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":4733,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4734":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":4734,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4735":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":4735,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4736":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":4736,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4737":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":4737,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4738":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":4738,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4739":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":4739,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4740":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":4740,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4742":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":4742,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4743":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":4743,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4744":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":4744,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4745":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":4745,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4746":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":4746,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4747":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":4747,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4748":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":4748,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4749":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":4749,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4750":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":4750,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4751":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":4751,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4752":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":4752,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4754":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":4754,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4755":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":4755,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4756":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":4756,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4757":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":4757,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4758":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":4758,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4759":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":4759,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4760":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":4760,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4761":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":4761,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4762":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":4762,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4763":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":4763,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4765":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":4765,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4766":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":4766,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4767":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":4767,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4768":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":4768,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4769":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":4769,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4770":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":4770,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4771":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":4771,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4772":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":4772,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4773":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":4773,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4774":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2365,"skill_field_effect_id":0,"_id_":4774,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4775":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2366,"skill_field_effect_id":0,"_id_":4775,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4777":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":4777,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4778":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":4778,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4779":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":4779,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4780":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":4780,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4781":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":4781,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4782":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":4782,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4783":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":4783,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4784":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":4784,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4786":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":0,"_id_":4786,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4787":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":0,"_id_":4787,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4788":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":0,"_id_":4788,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4789":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":0,"_id_":4789,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4790":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":0,"_id_":4790,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4791":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":0,"_id_":4791,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4792":{"attribute_id":7,"cost":3,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":0,"_id_":4792,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4793":{"attribute_id":7,"cost":3,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2354,"skill_field_effect_id":0,"_id_":4793,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4794":{"attribute_id":7,"cost":3,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2355,"skill_field_effect_id":0,"_id_":4794,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4796":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":4796,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4797":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":4797,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4798":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":4798,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4799":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":4799,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4800":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":4800,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4801":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":4801,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4802":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":4802,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4803":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":4803,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4804":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":4804,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4805":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2365,"skill_field_effect_id":0,"_id_":4805,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4806":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2366,"skill_field_effect_id":0,"_id_":4806,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4808":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":0,"_id_":4808,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4809":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":0,"_id_":4809,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4810":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":0,"_id_":4810,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4811":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":0,"_id_":4811,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4812":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":0,"_id_":4812,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4813":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":0,"_id_":4813,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4814":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":0,"_id_":4814,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4815":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2374,"skill_field_effect_id":0,"_id_":4815,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4816":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2375,"skill_field_effect_id":0,"_id_":4816,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4818":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":4818,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4819":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":4819,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4820":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":4820,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4821":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":4821,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4822":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":4822,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4823":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":4823,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4824":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":4824,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4825":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":4825,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4843":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Bright Flower","ja":"光花","ko":"광화","zh_hant":"光芒之花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3544,"skill_field_effect_id":0,"_id_":4843,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4844":{"attribute_id":1,"cost":2,"icon_id":59,"is_multiple_command_unique_skill":0,"name":{"en":"Scattered Flower","ja":"散花","ko":"산화","zh_hant":"凋零之花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3545,"skill_field_effect_id":0,"_id_":4844,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":59,"hit_rate":100,"target_id":2146,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4845":{"attribute_id":1,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Budding Flower","ja":"芽吹花","ko":"싹트는 꽃","zh_hant":"萌芽之花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3546,"skill_field_effect_id":0,"_id_":4845,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"4846":{"attribute_id":1,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Daybreak Petals","ja":"東雲の飛花","ko":"새벽의 비화","zh_hant":"東雲飛花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3547,"skill_field_effect_id":37,"_id_":4846,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4848":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Life Sword","ja":"生大刀","ko":"생명의 대도","zh_hant":"生大刀"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3549,"skill_field_effect_id":0,"_id_":4848,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4849":{"attribute_id":5,"cost":2,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Life Bow","ja":"生弓矢","ko":"생명의 궁시","zh_hant":"生弓矢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3550,"skill_field_effect_id":0,"_id_":4849,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":57,"hit_rate":100,"target_id":2146,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4850":{"attribute_id":5,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Life Koto","ja":"沼琴","ko":"하늘의 거문고","zh_hant":"沼琴"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3551,"skill_field_effect_id":0,"_id_":4850,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4851":{"attribute_id":5,"cost":2,"icon_id":1027,"is_multiple_command_unique_skill":0,"name":{"en":"Dawn of Compassion","ja":"慈愛の曙","ko":"자애의 새벽","zh_hant":"慈愛曙光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3552,"skill_field_effect_id":40,"_id_":4851,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4853":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Brilliance","ja":"キラめきのいちげき","ko":"반짝임의 일격","zh_hant":"光芒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3554,"skill_field_effect_id":0,"_id_":4853,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4854":{"attribute_id":6,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Weakness","ja":"きゅうしょのいちげき","ko":"급소의 일격","zh_hant":"要害一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3555,"skill_field_effect_id":0,"_id_":4854,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":394,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4855":{"attribute_id":6,"cost":3,"icon_id":220,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Strike","ja":"じゃくたいかのいちげき","ko":"약체화의 일격","zh_hant":"弱化一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3556,"skill_field_effect_id":0,"_id_":4855,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":339,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[40,42,44,47,50]}]},"4856":{"attribute_id":6,"cost":2,"icon_id":45,"is_multiple_command_unique_skill":0,"name":{"en":"Legendary Hero","ja":"伝説の勇者","ko":"전설의 용사","zh_hant":"傳說的勇者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3557,"skill_field_effect_id":0,"_id_":4856,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":29,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":241,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[5,6,7,8,10]}]},"4863":{"attribute_id":3,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3563,"skill_field_effect_id":0,"_id_":4863,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4864":{"attribute_id":3,"cost":2,"icon_id":8,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Victory","ja":"勝利への一閃","ko":"승리를 향한 일섬","zh_hant":"前往勝利的閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3564,"skill_field_effect_id":0,"_id_":4864,"skill_options":[{"id":1,"hit_rate":100,"target_id":2041,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10,12,14,17,20]}]},"4865":{"attribute_id":3,"cost":3,"icon_id":18,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Evasion","ja":"回避の一閃","ko":"회피의 일섬","zh_hant":"迴避閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3565,"skill_field_effect_id":0,"_id_":4865,"skill_options":[{"id":1,"hit_rate":100,"target_id":2041,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":18,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,32,35,40,50]}]},"4866":{"attribute_id":3,"cost":2,"icon_id":151,"is_multiple_command_unique_skill":0,"name":{"en":"Yellow Tornado","ja":"イエローファイントルネード","ko":"옐로우 파인 토네이도","zh_hant":"燦黃龍捲風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3566,"skill_field_effect_id":0,"_id_":4866,"skill_options":[{"id":151,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4868":{"attribute_id":1,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Smash","ja":"浄化の打撃","ko":"정화의 타격","zh_hant":"淨化敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3568,"skill_field_effect_id":0,"_id_":4868,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4869":{"attribute_id":1,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Smash","ja":"弛緩の打撃","ko":"이완의 타격","zh_hant":"遲緩敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3569,"skill_field_effect_id":0,"_id_":4869,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":13,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"4870":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Smash","ja":"自由な打撃","ko":"자유로운 타격","zh_hant":"自由敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3570,"skill_field_effect_id":0,"_id_":4870,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"4871":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"With love and courage, to Frontier!","ja":"愛と勇気ですすめフロンティア！","ko":"사랑과 용기로 나아가라 프론티어!","zh_hant":"貫徹愛與勇氣　邁向嶄新邊疆！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3571,"skill_field_effect_id":0,"_id_":4871,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]},{"id":394,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4873":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3221,"skill_field_effect_id":0,"_id_":4873,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4874":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3222,"skill_field_effect_id":0,"_id_":4874,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4875":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3223,"skill_field_effect_id":0,"_id_":4875,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4876":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3224,"skill_field_effect_id":0,"_id_":4876,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4877":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3225,"skill_field_effect_id":0,"_id_":4877,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"4878":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3226,"skill_field_effect_id":0,"_id_":4878,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4879":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3227,"skill_field_effect_id":0,"_id_":4879,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4880":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3228,"skill_field_effect_id":0,"_id_":4880,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4881":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3229,"skill_field_effect_id":0,"_id_":4881,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"4883":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":4883,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4884":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":4884,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4885":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":4885,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4886":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":4886,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4887":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":4887,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4888":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":4888,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4889":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":4889,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4890":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":4890,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4891":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":4891,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4892":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":4892,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"4893":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":4893,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"4895":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3257,"skill_field_effect_id":0,"_id_":4895,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4896":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3258,"skill_field_effect_id":0,"_id_":4896,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4897":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3259,"skill_field_effect_id":0,"_id_":4897,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4898":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3260,"skill_field_effect_id":0,"_id_":4898,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4899":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3261,"skill_field_effect_id":0,"_id_":4899,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4900":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3262,"skill_field_effect_id":0,"_id_":4900,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4901":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3263,"skill_field_effect_id":0,"_id_":4901,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4902":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3264,"skill_field_effect_id":0,"_id_":4902,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4903":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3265,"skill_field_effect_id":0,"_id_":4903,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"4905":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":4905,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4906":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":4906,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4907":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":4907,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4908":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":4908,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4909":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":4909,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4910":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":4910,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4911":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":4911,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"4912":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":4912,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4913":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":4913,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4914":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":4914,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"4915":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":4915,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"4917":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":0,"_id_":4917,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4918":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":0,"_id_":4918,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4919":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":0,"_id_":4919,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4920":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":0,"_id_":4920,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4921":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":0,"_id_":4921,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4922":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":0,"_id_":4922,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4923":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3300,"skill_field_effect_id":0,"_id_":4923,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4924":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":0,"_id_":4924,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4925":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":0,"_id_":4925,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4926":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3303,"skill_field_effect_id":0,"_id_":4926,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"4928":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":4928,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4929":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":4929,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4930":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":4930,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4931":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":4931,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4932":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":4932,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4933":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":4933,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4934":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":4934,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4935":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":4935,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4936":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":4936,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4937":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":4937,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4938":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":4938,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4940":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":0,"_id_":4940,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4941":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":0,"_id_":4941,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4942":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":0,"_id_":4942,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4943":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":0,"_id_":4943,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4944":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":0,"_id_":4944,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4945":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3291,"skill_field_effect_id":0,"_id_":4945,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4946":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":0,"_id_":4946,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4947":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3293,"skill_field_effect_id":0,"_id_":4947,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4949":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":0,"_id_":4949,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4950":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":0,"_id_":4950,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4951":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":0,"_id_":4951,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4952":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":0,"_id_":4952,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4953":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":0,"_id_":4953,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4954":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":0,"_id_":4954,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4955":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3300,"skill_field_effect_id":0,"_id_":4955,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4956":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":0,"_id_":4956,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"4957":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":0,"_id_":4957,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"4958":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3303,"skill_field_effect_id":0,"_id_":4958,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"4960":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":0,"_id_":4960,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4961":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":0,"_id_":4961,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"4962":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":0,"_id_":4962,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4963":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":0,"_id_":4963,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4964":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":0,"_id_":4964,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4965":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":0,"_id_":4965,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4966":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":0,"_id_":4966,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4967":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3311,"skill_field_effect_id":0,"_id_":4967,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4968":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":0,"_id_":4968,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4969":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3313,"skill_field_effect_id":0,"_id_":4969,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4971":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":4971,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4972":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":4972,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"4973":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":4973,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"4974":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":4974,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"4975":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":4975,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"4976":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":4976,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"4977":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":4977,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"4978":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":4978,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4979":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":4979,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"4980":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":4980,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4981":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":4981,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"4988":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3573,"skill_field_effect_id":0,"_id_":4988,"skill_options":[{"id":1,"hit_rate":100,"target_id":2161,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4989":{"attribute_id":2,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Mei Houwang's Strike","ja":"美猴王の一撃","ko":"미후왕의 일격","zh_hant":"美猴王的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3574,"skill_field_effect_id":0,"_id_":4989,"skill_options":[{"id":1,"hit_rate":100,"target_id":2161,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":394,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4990":{"attribute_id":2,"cost":3,"icon_id":150,"is_multiple_command_unique_skill":0,"name":{"en":"Qitian Dasheng's Strike","ja":"斉天大聖の一撃","ko":"제천대성의 일격","zh_hant":"齊天大聖的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3575,"skill_field_effect_id":0,"_id_":4990,"skill_options":[{"id":1,"hit_rate":100,"target_id":2161,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":150,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"4991":{"attribute_id":2,"cost":2,"icon_id":32,"is_multiple_command_unique_skill":0,"name":{"en":"Ruyi Jingu Bang","ja":"如意金箍棒","ko":"여의금고봉","zh_hant":"如意金箍棒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3576,"skill_field_effect_id":0,"_id_":4991,"skill_options":[{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"4993":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3578,"skill_field_effect_id":0,"_id_":4993,"skill_options":[{"id":1,"hit_rate":100,"target_id":2141,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"4994":{"attribute_id":6,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Divine Fire","ja":"怪火","ko":"괴화","zh_hant":"怪火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3579,"skill_field_effect_id":0,"_id_":4994,"skill_options":[{"id":1,"hit_rate":100,"target_id":2141,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":394,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"4995":{"attribute_id":6,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Fire of Light","ja":"灯火","ko":"등불","zh_hant":"燈火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3580,"skill_field_effect_id":0,"_id_":4995,"skill_options":[{"id":1,"hit_rate":100,"target_id":2141,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"4996":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flames of Birth","ja":"炎の降誕祭","ko":"불의 성탄제","zh_hant":"炎之降生祭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3581,"skill_field_effect_id":0,"_id_":4996,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[55555,66666,77777,88888,99999]},{"id":302,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5008":{"attribute_id":5,"cost":1,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Power Flash","ja":"渾身の一閃","ko":"혼신의 일섬","zh_hant":"全力閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3591,"skill_field_effect_id":0,"_id_":5008,"skill_options":[{"id":1,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"5009":{"attribute_id":5,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Hopeful Flash","ja":"希望の一閃","ko":"희망의 일섬","zh_hant":"希望閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3592,"skill_field_effect_id":0,"_id_":5009,"skill_options":[{"id":1,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5010":{"attribute_id":5,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Leap","ja":"キラめきの跳躍","ko":"반짝임의 도약","zh_hant":"光芒跳躍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3593,"skill_field_effect_id":0,"_id_":5010,"skill_options":[{"id":1,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[20,30,40,50,60]}]},"5011":{"attribute_id":5,"cost":2,"icon_id":229,"is_multiple_command_unique_skill":0,"name":{"en":"To You...a Beautiful End","ja":"今君に 美しい最期を","ko":"지금 너에게 아름다운 최후를","zh_hant":"現在就讓妳迎接最美的結局"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3594,"skill_field_effect_id":0,"_id_":5011,"skill_options":[{"id":386,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[180,190,200,210,220]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]}]},"5013":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3596,"skill_field_effect_id":0,"_id_":5013,"skill_options":[{"id":1,"hit_rate":100,"target_id":2171,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5014":{"attribute_id":4,"cost":2,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Sorrowful Tune","ja":"悲哀の音色","ko":"비애의 음색","zh_hant":"悲哀的音色"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3597,"skill_field_effect_id":0,"_id_":5014,"skill_options":[{"id":1,"hit_rate":100,"target_id":2171,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":57,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5015":{"attribute_id":4,"cost":3,"icon_id":20,"is_multiple_command_unique_skill":0,"name":{"en":"Tune of Encouragement","ja":"激励の音色","ko":"격려의 음색","zh_hant":"激勵的音色"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3598,"skill_field_effect_id":0,"_id_":5015,"skill_options":[{"id":1,"hit_rate":100,"target_id":2171,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5016":{"attribute_id":4,"cost":2,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Orpheus's Melody","ja":"オルフェウスの調べ","ko":"오르페우스의 멜로디","zh_hant":"奧菲斯的旋律"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3599,"skill_field_effect_id":0,"_id_":5016,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[240,250,260,270,280]},{"id":232,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5018":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3601,"skill_field_effect_id":0,"_id_":5018,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5019":{"attribute_id":1,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Impact Drop","ja":"インパクトドロップ","ko":"임팩트 드롭","zh_hant":"強力墜擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3602,"skill_field_effect_id":0,"_id_":5019,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":431,"hit_rate":50,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5020":{"attribute_id":1,"cost":3,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Bombardier Saijo Buster","ja":"西條式ボンバルディエバスター","ko":"사이조식 봄바디어 버스터","zh_hant":"西條式炮擊炸彈摔"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3603,"skill_field_effect_id":0,"_id_":5020,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5021":{"attribute_id":1,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Update Purge","ja":"粛清のアップデート","ko":"숙청의 업데이트","zh_hant":"肅清的更新"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3604,"skill_field_effect_id":0,"_id_":5021,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":431,"hit_rate":75,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5025":{"attribute_id":3,"cost":1,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Collect Clutch","ja":"コレクトクラッチ","ko":"컬렉트 클러치","zh_hant":"珍藏式固定技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3606,"skill_field_effect_id":0,"_id_":5025,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5026":{"attribute_id":3,"cost":2,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Light Hold","ja":"ライトホールド","ko":"라이트 홀드","zh_hant":"正義鎖定技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3607,"skill_field_effect_id":0,"_id_":5026,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,32,35,40,50]}]},"5027":{"attribute_id":3,"cost":3,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Heavy Sleeper","ja":"ヘビースリーパー","ko":"헤비 슬리퍼","zh_hant":"沉重鎖喉技"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3608,"skill_field_effect_id":0,"_id_":5027,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5028":{"attribute_id":3,"cost":2,"icon_id":32,"is_multiple_command_unique_skill":0,"name":{"en":"BLOODY TEA TIME","ja":"BLOODY TEA TIME","ko":"BLOODY TEA TIME","zh_hant":"BLOODY TEA TIME"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3609,"skill_field_effect_id":0,"_id_":5028,"skill_options":[{"id":150,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[350,370,390,420,450]},{"id":32,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]},{"id":33,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[10,12,14,17,20]}]},"5030":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3611,"skill_field_effect_id":0,"_id_":5030,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5031":{"attribute_id":4,"cost":2,"icon_id":227,"is_multiple_command_unique_skill":0,"name":{"en":"Incantation","ja":"呪術","ko":"주술","zh_hant":"咒術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3612,"skill_field_effect_id":0,"_id_":5031,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":354,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[7500,7500,7500,7500,7500]},{"id":298,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5032":{"attribute_id":4,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Divination","ja":"占術","ko":"점술","zh_hant":"占卜術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3613,"skill_field_effect_id":0,"_id_":5032,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,15,20,25,30]}]},"5033":{"attribute_id":4,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Shikigami","ja":"清めの式神","ko":"정화의 식신","zh_hant":"淨化的式神"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3614,"skill_field_effect_id":0,"_id_":5033,"skill_options":[{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]},{"id":156,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":35,"hit_rate":100,"target_id":1135,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":359,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[180,190,200,210,220]}]},"5035":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Brilliance","ja":"キラめきの一撃","ko":"반짝임의 일격","zh_hant":"光芒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3616,"skill_field_effect_id":0,"_id_":5035,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5036":{"attribute_id":1,"cost":2,"icon_id":1024,"is_multiple_command_unique_skill":0,"name":{"en":"Mischief","ja":"悪ふざけ","ko":"못된 장난","zh_hant":"整人"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3617,"skill_field_effect_id":41,"_id_":5036,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5037":{"attribute_id":1,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Prank","ja":"イタズラ","ko":"장난","zh_hant":"惡作劇"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3618,"skill_field_effect_id":0,"_id_":5037,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5038":{"attribute_id":1,"cost":2,"icon_id":178,"is_multiple_command_unique_skill":0,"name":{"en":"Trickster","ja":"Trickster","ko":"Trickster","zh_hant":"搗蛋鬼"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3619,"skill_field_effect_id":0,"_id_":5038,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":349,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":435,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5040":{"attribute_id":5,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Strike","ja":"浄化の一撃","ko":"정화의 일격","zh_hant":"浄化一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3621,"skill_field_effect_id":0,"_id_":5040,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5041":{"attribute_id":5,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Strike","ja":"弛緩の一撃","ko":"이완의 일격","zh_hant":"遲緩一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3622,"skill_field_effect_id":0,"_id_":5041,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":13,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5042":{"attribute_id":5,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Strike","ja":"自由な一撃","ko":"자유로운 일격","zh_hant":"自由一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3623,"skill_field_effect_id":0,"_id_":5042,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5043":{"attribute_id":5,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"I will put my life on the line!","ja":"命かけたる正念場いざご覧あれ！","ko":"생을 건 중대한 장면 자 보아라!","zh_hant":"賭上性命的危機一刻，敬請觀賞！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3624,"skill_field_effect_id":42,"_id_":5043,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5045":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":5045,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5046":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":5046,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5047":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":5047,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5048":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":5048,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5049":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":5049,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5050":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":5050,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5051":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":5051,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5052":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":5052,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5054":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":5054,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5055":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":5055,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5056":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":5056,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5057":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":5057,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5058":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":5058,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5059":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":5059,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5060":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":5060,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5061":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":5061,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5062":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":5062,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5064":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":5064,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5065":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":5065,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5066":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":5066,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5067":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":5067,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5068":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":5068,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5069":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":5069,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5070":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":5070,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5071":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":5071,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5072":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":5072,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5074":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2492,"skill_field_effect_id":0,"_id_":5074,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5075":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2493,"skill_field_effect_id":0,"_id_":5075,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5076":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2494,"skill_field_effect_id":0,"_id_":5076,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5077":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2495,"skill_field_effect_id":0,"_id_":5077,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5078":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2496,"skill_field_effect_id":0,"_id_":5078,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5079":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2497,"skill_field_effect_id":0,"_id_":5079,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5080":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2498,"skill_field_effect_id":0,"_id_":5080,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5081":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2499,"skill_field_effect_id":0,"_id_":5081,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5082":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Constraint Concerto","ja":"抑制の協奏曲","ko":"억제의 협주곡","zh_hant":"抑制協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2500,"skill_field_effect_id":0,"_id_":5082,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5083":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Stay Away! NEO","ja":"こっちにこないで！ NEO","ko":"가까이 오지 마! NEO","zh_hant":"不要過來！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2501,"skill_field_effect_id":0,"_id_":5083,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5085":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2502,"skill_field_effect_id":0,"_id_":5085,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5086":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2503,"skill_field_effect_id":0,"_id_":5086,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5087":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2504,"skill_field_effect_id":0,"_id_":5087,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5088":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2505,"skill_field_effect_id":0,"_id_":5088,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5089":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2506,"skill_field_effect_id":0,"_id_":5089,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5090":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2507,"skill_field_effect_id":0,"_id_":5090,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5091":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2508,"skill_field_effect_id":0,"_id_":5091,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5092":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":5092,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5093":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":5093,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5094":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2510,"skill_field_effect_id":0,"_id_":5094,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5096":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2511,"skill_field_effect_id":0,"_id_":5096,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5097":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2512,"skill_field_effect_id":0,"_id_":5097,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5098":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2513,"skill_field_effect_id":0,"_id_":5098,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5099":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2514,"skill_field_effect_id":0,"_id_":5099,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5100":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2515,"skill_field_effect_id":0,"_id_":5100,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5101":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Tri-Slash","ja":"必中の参連撃","ko":"백발백중의 삼연격","zh_hant":"必中參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2516,"skill_field_effect_id":0,"_id_":5101,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5102":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2517,"skill_field_effect_id":0,"_id_":5102,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5103":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzling Concerto","ja":"眩惑の協奏曲","ko":"현혹의 협주곡","zh_hant":"眩目協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2518,"skill_field_effect_id":0,"_id_":5103,"skill_options":[{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"5104":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Tri-Slash","ja":"必中の参連撃","ko":"백발백중의 삼연격","zh_hant":"必中參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2516,"skill_field_effect_id":0,"_id_":5104,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5105":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fuoco! NEO","ja":"Fuoco! NEO","ko":"Fuoco! NEO","zh_hant":"Fuoco！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2519,"skill_field_effect_id":0,"_id_":5105,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[99999,99999,99999,99999,99999]},{"id":17,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"5107":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":5107,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5108":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":5108,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5109":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":5109,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5110":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":5110,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5111":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":5111,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5112":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":5112,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5113":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":5113,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5114":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":5114,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5115":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":5115,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5140":{"attribute_id":3,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Brilliance","ja":"キラめきの一撃","ko":"반짝임의 일격","zh_hant":"光芒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3634,"skill_field_effect_id":0,"_id_":5140,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5141":{"attribute_id":3,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Protection Strike","ja":"圧力の一撃","ko":"압력의 일격","zh_hant":"壓力一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3635,"skill_field_effect_id":43,"_id_":5141,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5142":{"attribute_id":3,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Light Arrow","ja":"光の矢","ko":"빛의 화살","zh_hant":"光之箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3636,"skill_field_effect_id":0,"_id_":5142,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5143":{"attribute_id":3,"cost":2,"icon_id":1028,"is_multiple_command_unique_skill":1,"name":{"en":"Try and kill me, Nana Daiba","ja":"殺してみせろよ 大場なな","ko":"어디 한번 죽여봐 다이바 나나","zh_hant":"來殺我啊，大場奈奈！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3637,"skill_field_effect_id":44,"_id_":5143,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5145":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3639,"skill_field_effect_id":0,"_id_":5145,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5146":{"attribute_id":5,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Flash","ja":"浄化の一閃","ko":"정화의 일섬","zh_hant":"淨化閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3640,"skill_field_effect_id":0,"_id_":5146,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5147":{"attribute_id":5,"cost":3,"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Merchant's Wallet","ja":"商人の財布","ko":"상인의 지갑","zh_hant":"商人的錢包"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3641,"skill_field_effect_id":0,"_id_":5147,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":61,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5148":{"attribute_id":5,"cost":2,"icon_id":30,"is_multiple_command_unique_skill":0,"name":{"en":"Trade Secrets","ja":"商いの極意","ko":"장사의 비법","zh_hant":"商人的秘訣"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3642,"skill_field_effect_id":0,"_id_":5148,"skill_options":[{"id":436,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[300000,350000,400000,450000,500000]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"5155":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3644,"skill_field_effect_id":0,"_id_":5155,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5156":{"attribute_id":4,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Seeker of Truth","ja":"真理を解く者","ko":"진리를 말하는 자","zh_hant":"揭開真理者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3645,"skill_field_effect_id":0,"_id_":5156,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5157":{"attribute_id":4,"cost":3,"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Beacon of the Abyss","ja":"深淵を照らす者","ko":"심연을 비추는 자","zh_hant":"照耀深淵者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3646,"skill_field_effect_id":0,"_id_":5157,"skill_options":[{"id":5,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":61,"hit_rate":100,"target_id":2121,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5158":{"attribute_id":4,"cost":2,"icon_id":247,"is_multiple_command_unique_skill":0,"name":{"en":"Runic Principles","ja":"ルーンの理","ko":"룬의 이치","zh_hant":"盧恩字母的法則"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3647,"skill_field_effect_id":0,"_id_":5158,"skill_options":[{"id":128,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":439,"hit_rate":100,"target_id":1142,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":440,"hit_rate":100,"target_id":1142,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":441,"hit_rate":100,"target_id":1142,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5160":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3649,"skill_field_effect_id":0,"_id_":5160,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5161":{"attribute_id":2,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Delicious Apple","ja":"おいしい林檎","ko":"맛있는 사과","zh_hant":"美味的蘋果"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3650,"skill_field_effect_id":0,"_id_":5161,"skill_options":[{"id":361,"hit_rate":100,"target_id":2141,"times":[1,1,1,1,1],"values":[156,163,171,178,187]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5162":{"attribute_id":2,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Wonderful Dream","ja":"素敵な夢","ko":"멋진 꿈","zh_hant":"美妙的夢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3651,"skill_field_effect_id":0,"_id_":5162,"skill_options":[{"id":361,"hit_rate":100,"target_id":2141,"times":[1,1,1,1,1],"values":[156,163,171,178,187]},{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[20,30,40,50,60]}]},"5163":{"attribute_id":2,"cost":2,"icon_id":248,"is_multiple_command_unique_skill":0,"name":{"en":"Shackles of Poison","ja":"毒林檎の枷","ko":"독사과의 족쇄","zh_hant":"毒蘋果的枷鎖"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3652,"skill_field_effect_id":0,"_id_":5163,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":54,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[55555,66666,77777,88888,99999]},{"id":302,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":443,"hit_rate":100,"target_id":4073,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5165":{"attribute_id":3,"cost":1,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Questioning","ja":"職務質問","ko":"불심검문","zh_hant":"進行盤問"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3654,"skill_field_effect_id":0,"_id_":5165,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"5166":{"attribute_id":3,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"All-Points Bulletin","ja":"緊急配備","ko":"긴급 배치","zh_hant":"緊急調派"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3655,"skill_field_effect_id":0,"_id_":5166,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5167":{"attribute_id":3,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"On-Site Express","ja":"現場急行","ko":"현장 급행","zh_hant":"馳赴現場"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3656,"skill_field_effect_id":0,"_id_":5167,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5168":{"attribute_id":3,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Officer Akikaze's Emergency Arrest","ja":"秋風巡査の緊急逮捕劇","ko":"아키카제 순경의 긴급 체포극","zh_hant":"秋風警員的緊急追捕劇"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3657,"skill_field_effect_id":0,"_id_":5168,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"5170":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3659,"skill_field_effect_id":0,"_id_":5170,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[88,92,96,101,105]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5171":{"attribute_id":5,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Loyal Subject","ja":"忠実なるしもべ","ko":"충실한 심복","zh_hant":"忠誠的僕人"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3660,"skill_field_effect_id":0,"_id_":5171,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5172":{"attribute_id":5,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Devour","ja":"喰らい尽くす","ko":"먹어치우기","zh_hant":"啃食殆盡"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3661,"skill_field_effect_id":0,"_id_":5172,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5173":{"attribute_id":5,"cost":2,"icon_id":1023,"is_multiple_command_unique_skill":0,"name":{"en":"Infernal Gnawing","ja":"冥獣の噛砕","ko":"저승 맹수의 깨물어부수기","zh_hant":"冥獸的撕咬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3662,"skill_field_effect_id":45,"_id_":5173,"skill_options":[{"id":360,"hit_rate":100,"target_id":1143,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1143,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[300,325,350,375,400]}]},"5175":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Reaching Out","ja":"寄り添う心","ko":"다가서는 마음","zh_hant":"關愛之心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3664,"skill_field_effect_id":0,"_id_":5175,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5176":{"attribute_id":2,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sense of Justice","ja":"強い正義感","ko":"강한 정의감","zh_hant":"強烈的正義感"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3665,"skill_field_effect_id":0,"_id_":5176,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2146,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5177":{"attribute_id":2,"cost":3,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Healthy Body","ja":"健康な体","ko":"건강한 몸","zh_hant":"健康的身體"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3666,"skill_field_effect_id":0,"_id_":5177,"skill_options":[{"id":1,"hit_rate":100,"target_id":2146,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5178":{"attribute_id":2,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Officer Aijo's Traffic Safety","ja":"愛城巡査の交通安全指導","ko":"아이조 순경의 교통안전 교육","zh_hant":"愛城警員的交通安全指導"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3667,"skill_field_effect_id":0,"_id_":5178,"skill_options":[{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,22,24,27,30]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":84,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5180":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3069,"skill_field_effect_id":0,"_id_":5180,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5181":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3070,"skill_field_effect_id":0,"_id_":5181,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5182":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3071,"skill_field_effect_id":0,"_id_":5182,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5183":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3072,"skill_field_effect_id":0,"_id_":5183,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5184":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3073,"skill_field_effect_id":0,"_id_":5184,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"5185":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3074,"skill_field_effect_id":0,"_id_":5185,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5186":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3075,"skill_field_effect_id":0,"_id_":5186,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"5187":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3076,"skill_field_effect_id":0,"_id_":5187,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5188":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3077,"skill_field_effect_id":0,"_id_":5188,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5190":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3105,"skill_field_effect_id":0,"_id_":5190,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5191":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3106,"skill_field_effect_id":0,"_id_":5191,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5192":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3107,"skill_field_effect_id":0,"_id_":5192,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5193":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3108,"skill_field_effect_id":0,"_id_":5193,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5194":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3109,"skill_field_effect_id":0,"_id_":5194,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5195":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3110,"skill_field_effect_id":0,"_id_":5195,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5196":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3111,"skill_field_effect_id":0,"_id_":5196,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5197":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3112,"skill_field_effect_id":0,"_id_":5197,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5198":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3113,"skill_field_effect_id":0,"_id_":5198,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5199":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3114,"skill_field_effect_id":0,"_id_":5199,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5200":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3115,"skill_field_effect_id":0,"_id_":5200,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5202":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":5202,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5203":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":5203,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5204":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":5204,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5205":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":5205,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5206":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":5206,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5207":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":5207,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5208":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":5208,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5209":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":5209,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5210":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":5210,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5212":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":5212,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5213":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":5213,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5214":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":5214,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5215":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":5215,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5216":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":5216,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5217":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":5217,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5218":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":5218,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5219":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":5219,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5220":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":5220,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5221":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":5221,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5223":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":5223,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5224":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":5224,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"5225":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":5225,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5226":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":5226,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5227":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":5227,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5228":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":5228,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5229":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":5229,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5230":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":5230,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5231":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":5231,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5232":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":5232,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5233":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":5233,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5235":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":5235,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5236":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":5236,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5237":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":5237,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5238":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":5238,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5239":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":5239,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5240":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":5240,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5241":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":5241,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5242":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":5242,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5243":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":5243,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5244":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":5244,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5245":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":5245,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5247":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3137,"skill_field_effect_id":0,"_id_":5247,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5248":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3138,"skill_field_effect_id":0,"_id_":5248,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5249":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3139,"skill_field_effect_id":0,"_id_":5249,"skill_options":[{"id":80,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5250":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3140,"skill_field_effect_id":0,"_id_":5250,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5251":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3141,"skill_field_effect_id":0,"_id_":5251,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5252":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3142,"skill_field_effect_id":0,"_id_":5252,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5253":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3143,"skill_field_effect_id":0,"_id_":5253,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5254":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3144,"skill_field_effect_id":0,"_id_":5254,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5255":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Midnight NEO","ja":"ブラッディ・ミッドナイト NEO","ko":"블러디 미드나이트 NEO","zh_hant":"血腥午夜 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3145,"skill_field_effect_id":0,"_id_":5255,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5257":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":5257,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5258":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":5258,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5259":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":5259,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5260":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":5260,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5261":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":5261,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5262":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":5262,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5263":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":5263,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5264":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":5264,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5265":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":5265,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5267":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3155,"skill_field_effect_id":0,"_id_":5267,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5268":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3156,"skill_field_effect_id":0,"_id_":5268,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5269":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3157,"skill_field_effect_id":0,"_id_":5269,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5270":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3158,"skill_field_effect_id":0,"_id_":5270,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5271":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3159,"skill_field_effect_id":0,"_id_":5271,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5272":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry Dance","ja":"連撃の舞","ko":"연격의 춤","zh_hant":"連擊之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3160,"skill_field_effect_id":0,"_id_":5272,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5273":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3161,"skill_field_effect_id":0,"_id_":5273,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5274":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3162,"skill_field_effect_id":0,"_id_":5274,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5275":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3163,"skill_field_effect_id":0,"_id_":5275,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5276":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cross of Retribution NEO","ja":"聖罰の十字架 NEO","ko":"성벌의 십자가 NEO","zh_hant":"聖罰十字架 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3164,"skill_field_effect_id":0,"_id_":5276,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5278":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":5278,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5279":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":5279,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5280":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":5280,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5281":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":5281,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5282":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":5282,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5283":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":5283,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5284":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":5284,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5285":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":5285,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5286":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":5286,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5287":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":5287,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5288":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":5288,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5290":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3669,"skill_field_effect_id":0,"_id_":5290,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5291":{"attribute_id":4,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunderous Slash","ja":"轟雷の斬撃","ko":"굉뢰의 참격","zh_hant":"轟雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3670,"skill_field_effect_id":46,"_id_":5291,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5292":{"attribute_id":4,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Genius Conduct","ja":"天才の振る舞い","ko":"천재의 행동","zh_hant":"天才的舉止"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3671,"skill_field_effect_id":0,"_id_":5292,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5293":{"attribute_id":4,"cost":2,"icon_id":1029,"is_multiple_command_unique_skill":1,"name":{"en":"Watch Me from Hell. I'm the Star","ja":"奈落で見上げろ 私がスタァだ","ko":"나락에서 올려다봐라 내가 스타다","zh_hant":"在地獄抬頭望吧，我才是STAR！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3672,"skill_field_effect_id":47,"_id_":5293,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5295":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3674,"skill_field_effect_id":0,"_id_":5295,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5296":{"attribute_id":2,"cost":2,"icon_id":1019,"is_multiple_command_unique_skill":0,"name":{"en":"Hope Smash","ja":"希望の打撃","ko":"희망의 타격","zh_hant":"希望敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3675,"skill_field_effect_id":48,"_id_":5296,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5297":{"attribute_id":2,"cost":3,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Faint Smash","ja":"昏倒の打撃","ko":"혼절의 타격","zh_hant":"昏倒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3676,"skill_field_effect_id":0,"_id_":5297,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":57,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5298":{"attribute_id":7,"cost":2,"icon_id":248,"is_multiple_command_unique_skill":0,"name":{"en":"Quintet Prominence Breaker","ja":"クインテット・プロミネンスブレイカー","ko":"퀸텟 프로미넌스 브레이커","zh_hant":"五重奏・熾焰日珥粉碎擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3677,"skill_field_effect_id":0,"_id_":5298,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":308,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[180,190,200,210,220]},{"id":442,"hit_rate":100,"target_id":2031,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5300":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Thrust","ja":"浄化の刺突","ko":"정화의 찌르기","zh_hant":"淨化突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3679,"skill_field_effect_id":0,"_id_":5300,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5301":{"attribute_id":4,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Thrust","ja":"弛緩の刺突","ko":"이완의 찌르기","zh_hant":"遲緩突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3680,"skill_field_effect_id":0,"_id_":5301,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":13,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5302":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Severe Thrust","ja":"厳格なる刺突","ko":"엄격한 찌르기","zh_hant":"嚴厲突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3681,"skill_field_effect_id":0,"_id_":5302,"skill_options":[{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5303":{"attribute_id":4,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"The King Shines His Light on the Hollow Stage!","ja":"神無き舞台に王者の光を！","ko":"신이 없는 무대에 왕의 빛을!","zh_hant":"在無主舞台上，降下王者之光！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3682,"skill_field_effect_id":49,"_id_":5303,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5305":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3684,"skill_field_effect_id":0,"_id_":5305,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5306":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Cake Rooftop","ja":"ケーキの屋根","ko":"케이크 지붕","zh_hant":"蛋糕屋頂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3685,"skill_field_effect_id":50,"_id_":5306,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5307":{"attribute_id":2,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Bread Window","ja":"パンの窓","ko":"빵 창문","zh_hant":"麵包窗戶"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3686,"skill_field_effect_id":0,"_id_":5307,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5308":{"attribute_id":2,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Helping Gretel","ja":"グレーテルのお手伝い","ko":"그레텔의 도움","zh_hant":"小幫手葛麗特"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3687,"skill_field_effect_id":0,"_id_":5308,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5310":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting","ja":"狙撃","ko":"저격","zh_hant":"狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2606,"skill_field_effect_id":0,"_id_":5310,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5311":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2607,"skill_field_effect_id":0,"_id_":5311,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5312":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2608,"skill_field_effect_id":0,"_id_":5312,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5313":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2609,"skill_field_effect_id":0,"_id_":5313,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5314":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2610,"skill_field_effect_id":0,"_id_":5314,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5315":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2611,"skill_field_effect_id":0,"_id_":5315,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5316":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Rondo","ja":"闇炎の輪舞曲","ko":"암흑 불꽃의 윤무곡","zh_hant":"暗炎圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2612,"skill_field_effect_id":0,"_id_":5316,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5317":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2613,"skill_field_effect_id":0,"_id_":5317,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5319":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2641,"skill_field_effect_id":0,"_id_":5319,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5320":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2642,"skill_field_effect_id":0,"_id_":5320,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5321":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2643,"skill_field_effect_id":0,"_id_":5321,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5322":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2644,"skill_field_effect_id":0,"_id_":5322,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5323":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2645,"skill_field_effect_id":0,"_id_":5323,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5324":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2646,"skill_field_effect_id":0,"_id_":5324,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5325":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2647,"skill_field_effect_id":0,"_id_":5325,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5326":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2648,"skill_field_effect_id":0,"_id_":5326,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5327":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2649,"skill_field_effect_id":0,"_id_":5327,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5329":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":0,"_id_":5329,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5330":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":0,"_id_":5330,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5331":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":0,"_id_":5331,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5332":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":0,"_id_":5332,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5333":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":0,"_id_":5333,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5334":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":0,"_id_":5334,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5335":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2684,"skill_field_effect_id":0,"_id_":5335,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5336":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2685,"skill_field_effect_id":0,"_id_":5336,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5338":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":0,"_id_":5338,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5339":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":0,"_id_":5339,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5340":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":0,"_id_":5340,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5341":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":0,"_id_":5341,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5342":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":0,"_id_":5342,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5343":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":0,"_id_":5343,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5344":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":0,"_id_":5344,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5345":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2676,"skill_field_effect_id":0,"_id_":5345,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5346":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2677,"skill_field_effect_id":0,"_id_":5346,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5348":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":0,"_id_":5348,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5349":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":0,"_id_":5349,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5350":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":0,"_id_":5350,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5351":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":0,"_id_":5351,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5352":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":0,"_id_":5352,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5353":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":0,"_id_":5353,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5354":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2684,"skill_field_effect_id":0,"_id_":5354,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5355":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2685,"skill_field_effect_id":0,"_id_":5355,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5357":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":0,"_id_":5357,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5358":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":0,"_id_":5358,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5359":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":0,"_id_":5359,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5360":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":0,"_id_":5360,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5361":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":0,"_id_":5361,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5362":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":0,"_id_":5362,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5363":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":0,"_id_":5363,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5364":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":0,"_id_":5364,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5365":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2694,"skill_field_effect_id":0,"_id_":5365,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5366":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2695,"skill_field_effect_id":0,"_id_":5366,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5373":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Skilled Qigong","ja":"練気功","ko":"연기공","zh_hant":"練氣功"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3689,"skill_field_effect_id":0,"_id_":5373,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5374":{"attribute_id":6,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Point","ja":"点穴","ko":"점혈","zh_hant":"點穴"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3690,"skill_field_effect_id":0,"_id_":5374,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":394,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"5375":{"attribute_id":6,"cost":3,"icon_id":235,"is_multiple_command_unique_skill":0,"name":{"en":"Fa Jin","ja":"発勁","ko":"발경","zh_hant":"發勁"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3691,"skill_field_effect_id":0,"_id_":5375,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":382,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]}]},"5376":{"attribute_id":7,"cost":2,"icon_id":248,"is_multiple_command_unique_skill":0,"name":{"en":"Blazedance Finisher","ja":"焔舞殺法","ko":"화무살법","zh_hant":"焰舞殺法"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3692,"skill_field_effect_id":0,"_id_":5376,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":306,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":442,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5378":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3694,"skill_field_effect_id":0,"_id_":5378,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5379":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Cake Rooftop","ja":"ケーキの屋根","ko":"케이크 지붕","zh_hant":"蛋糕屋頂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3695,"skill_field_effect_id":51,"_id_":5379,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5380":{"attribute_id":6,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Chocolate Chair","ja":"チョコレートの椅子","ko":"초콜릿 의자","zh_hant":"巧克力椅子"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3696,"skill_field_effect_id":0,"_id_":5380,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]}]},"5381":{"attribute_id":6,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Temptation","ja":"お菓子な誘惑","ko":"과자의 유혹","zh_hant":"零食的誘惑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3697,"skill_field_effect_id":0,"_id_":5381,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":449,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5383":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3699,"skill_field_effect_id":0,"_id_":5383,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5384":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Cotton Candy Blanket","ja":"コットンキャンディーの毛布","ko":"코튼캔디로 만든 담요","zh_hant":"棉花糖毛毯"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3700,"skill_field_effect_id":52,"_id_":5384,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5385":{"attribute_id":1,"cost":3,"icon_id":61,"is_multiple_command_unique_skill":0,"name":{"en":"Ice Cream Desk","ja":"アイスクリームの机","ko":"아이스크림으로 만든 책상","zh_hant":"冰淇淋書桌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3701,"skill_field_effect_id":0,"_id_":5385,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":61,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5386":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Hansel's Wit","ja":"ヘンゼルの知恵","ko":"헨젤의 지혜","zh_hant":"漢賽爾的智慧"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3702,"skill_field_effect_id":53,"_id_":5386,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"5388":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3704,"skill_field_effect_id":0,"_id_":5388,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5389":{"attribute_id":2,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Megingjord","ja":"メギンギョルズ","ko":"메긴기요르드","zh_hant":"梅金吉奧德"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3705,"skill_field_effect_id":54,"_id_":5389,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5390":{"attribute_id":2,"cost":3,"icon_id":114,"is_multiple_command_unique_skill":0,"name":{"en":"Jarngreipr","ja":"ヤールングレイプル","ko":"야른그레이프르","zh_hant":"雅恩格利佩爾"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3706,"skill_field_effect_id":0,"_id_":5390,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":126,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,26,30]}]},"5391":{"attribute_id":2,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Mjolnir","ja":"雷鳴のミョルニル","ko":"천둥의 묠니르","zh_hant":"雷鳴的妙爾尼爾"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3707,"skill_field_effect_id":0,"_id_":5391,"skill_options":[{"id":156,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":22002,"times":[5,5,5,5,5],"values":[200,210,220,230,240]}]},"5393":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3709,"skill_field_effect_id":0,"_id_":5393,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5394":{"attribute_id":2,"cost":2,"icon_id":252,"is_multiple_command_unique_skill":0,"name":{"en":"Soul Lacking","ja":"魂の欠落","ko":"영혼의 결핍","zh_hant":"缺乏靈魂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3710,"skill_field_effect_id":0,"_id_":5394,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":453,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5395":{"attribute_id":2,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Talent","ja":"輝く才能","ko":"반짝이는 재능","zh_hant":"輝煌才能"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3711,"skill_field_effect_id":0,"_id_":5395,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5396":{"attribute_id":2,"cost":2,"icon_id":1031,"is_multiple_command_unique_skill":0,"name":{"en":"I will defeat you with my brilliance","ja":"今宵 キラめきで あんたを","ko":"오늘밤 반짝임으로 당신을","zh_hant":"今晚以閃耀將妳——"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3712,"skill_field_effect_id":55,"_id_":5396,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"5398":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3714,"skill_field_effect_id":0,"_id_":5398,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5399":{"attribute_id":5,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Enchanting Pride","ja":"エンチャントプライド","ko":"인챈트 프라이드","zh_hant":"傲慢附魔"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3715,"skill_field_effect_id":0,"_id_":5399,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5400":{"attribute_id":5,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Gravity Field","ja":"グラビティフィールド","ko":"그래비티 필드","zh_hant":"重力領域"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3716,"skill_field_effect_id":0,"_id_":5400,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5401":{"attribute_id":5,"cost":2,"icon_id":31,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Darkness","ja":"Flash of darkness","ko":"Flash of darkness","zh_hant":"Flash of darkness"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3717,"skill_field_effect_id":0,"_id_":5401,"skill_options":[{"id":437,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[300000,350000,400000,450000,500000]},{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"5408":{"attribute_id":2,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Flash","ja":"浄化の一閃","ko":"정화의 일섬","zh_hant":"淨化閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3719,"skill_field_effect_id":0,"_id_":5408,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":80,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5409":{"attribute_id":2,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Relaxing Flash","ja":"弛緩の一閃","ko":"이완의 일섬","zh_hant":"遲緩閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3720,"skill_field_effect_id":0,"_id_":5409,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":11,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":13,"hit_rate":100,"target_id":2021,"times":[3,3,3,3,3],"values":[10,12,14,17,20]},{"id":81,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5410":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Accelerating Flash","ja":"加速する一閃","ko":"가속하는 일섬","zh_hant":"加速閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3721,"skill_field_effect_id":0,"_id_":5410,"skill_options":[{"id":81,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5411":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Hearts aflutter, to Frontier!","ja":"胸ときめかせてすすめフロンティア！","ko":"가슴 설레며 나아가라 프론티어!","zh_hant":"胸懷怦然心動，攜手前進邊疆！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3722,"skill_field_effect_id":56,"_id_":5411,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5428":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Attack","ja":"キラめきのアタック","ko":"반짝임의 어택","zh_hant":"光芒之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3732,"skill_field_effect_id":0,"_id_":5428,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5429":{"attribute_id":4,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Courageous Attack","ja":"勇気のアタック","ko":"용기의 어택","zh_hant":"勇氣之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3733,"skill_field_effect_id":0,"_id_":5429,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":444,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5430":{"attribute_id":4,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Attack","ja":"鼓舞するアタック","ko":"고무의 어택","zh_hant":"鼓舞之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3734,"skill_field_effect_id":0,"_id_":5430,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,22,24,26,30]}]},"5431":{"attribute_id":4,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Boisterous Attack","ja":"乱舞アタック","ko":"난무 어택","zh_hant":"亂舞之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3735,"skill_field_effect_id":0,"_id_":5431,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[350,370,390,420,450]}]},"5433":{"attribute_id":1,"cost":1,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Intense Attack","ja":"強烈なアタック","ko":"강렬한 어택","zh_hant":"強烈之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3737,"skill_field_effect_id":0,"_id_":5433,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[147,154,161,168,176]}]},"5434":{"attribute_id":1,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Hopeful Attack","ja":"希望のアタック","ko":"희망의 어택","zh_hant":"希望之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3738,"skill_field_effect_id":0,"_id_":5434,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5435":{"attribute_id":1,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Oppressive Attack","ja":"重圧のアタック","ko":"중압의 어택","zh_hant":"重壓之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3739,"skill_field_effect_id":0,"_id_":5435,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5436":{"attribute_id":1,"cost":2,"icon_id":252,"is_multiple_command_unique_skill":0,"name":{"en":"Passionate Attack","ja":"情熱アタック","ko":"열정의 어택","zh_hant":"熱情之擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3740,"skill_field_effect_id":0,"_id_":5436,"skill_options":[{"id":453,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":224,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":62,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[300,325,350,375,400]},{"id":349,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5438":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2832,"skill_field_effect_id":0,"_id_":5438,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5439":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2833,"skill_field_effect_id":0,"_id_":5439,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5440":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2834,"skill_field_effect_id":0,"_id_":5440,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5441":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2835,"skill_field_effect_id":0,"_id_":5441,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5442":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2836,"skill_field_effect_id":0,"_id_":5442,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5443":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2837,"skill_field_effect_id":0,"_id_":5443,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5444":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2838,"skill_field_effect_id":0,"_id_":5444,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5445":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2839,"skill_field_effect_id":0,"_id_":5445,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5447":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2865,"skill_field_effect_id":0,"_id_":5447,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5448":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Sharpshooting","ja":"双狙撃","ko":"쌍저격","zh_hant":"雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2866,"skill_field_effect_id":0,"_id_":5448,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5449":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Sharpshooting","ja":"強襲の双狙撃","ko":"강습의 쌍저격","zh_hant":"強襲雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2867,"skill_field_effect_id":0,"_id_":5449,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5450":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2868,"skill_field_effect_id":0,"_id_":5450,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5451":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2869,"skill_field_effect_id":0,"_id_":5451,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5452":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2870,"skill_field_effect_id":0,"_id_":5452,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5453":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2871,"skill_field_effect_id":0,"_id_":5453,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5454":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2872,"skill_field_effect_id":0,"_id_":5454,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5455":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2873,"skill_field_effect_id":0,"_id_":5455,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5457":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":0,"_id_":5457,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5458":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":0,"_id_":5458,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5459":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":0,"_id_":5459,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5460":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":0,"_id_":5460,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5461":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":0,"_id_":5461,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5462":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":0,"_id_":5462,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5463":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2908,"skill_field_effect_id":0,"_id_":5463,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5464":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2909,"skill_field_effect_id":0,"_id_":5464,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5466":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":0,"_id_":5466,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5467":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":0,"_id_":5467,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5468":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":0,"_id_":5468,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5469":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":0,"_id_":5469,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5470":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":0,"_id_":5470,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5471":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":0,"_id_":5471,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5472":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2908,"skill_field_effect_id":0,"_id_":5472,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5473":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2909,"skill_field_effect_id":0,"_id_":5473,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5475":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":5475,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5476":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":5476,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5477":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":5477,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5478":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":5478,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5479":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":5479,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5480":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":5480,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5481":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":5481,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5482":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":5482,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5483":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":5483,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5484":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":5484,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"5485":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":5485,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"5487":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":5487,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5488":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":5488,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5489":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":5489,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5490":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":5490,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5491":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":5491,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5492":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":5492,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5493":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":5493,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5494":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":5494,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5495":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":5495,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5496":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":5496,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"5497":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":5497,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"5499":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":5499,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5500":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":5500,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5501":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":5501,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5502":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":5502,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5503":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":5503,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5504":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":5504,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5505":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":5505,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5506":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":5506,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5507":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":5507,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5508":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":5508,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"5509":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":5509,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"5511":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":5511,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5512":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":5512,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5513":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":5513,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5514":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":5514,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5515":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":5515,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5516":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":5516,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5517":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":5517,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5518":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":5518,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5519":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":5519,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5520":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":5520,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"5521":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":5521,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"5523":{"attribute_id":7,"cost":1,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Power Sharpshooting","ja":"渾身の狙撃","ko":"혼신의 저격","zh_hant":"全力狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3742,"skill_field_effect_id":0,"_id_":5523,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"5524":{"attribute_id":7,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Sharpshooting","ja":"浄化の狙撃","ko":"정화의 저격","zh_hant":"淨化狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3743,"skill_field_effect_id":0,"_id_":5524,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5525":{"attribute_id":7,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Carefree Sharpshooting","ja":"自由な狙撃","ko":"자유로운 저격","zh_hant":"自由狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3744,"skill_field_effect_id":0,"_id_":5525,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5526":{"attribute_id":7,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Rising White Blaster","ja":"ライジングホワイトブラスター","ko":"라이징 화이트 블래스터","zh_hant":"冉升純白衝擊波"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3745,"skill_field_effect_id":0,"_id_":5526,"skill_options":[{"id":156,"hit_rate":100,"target_id":1135,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":61,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5528":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3747,"skill_field_effect_id":0,"_id_":5528,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5529":{"attribute_id":6,"cost":2,"icon_id":36,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Fortitude","ja":"不屈の一閃","ko":"불굴의 일섬","zh_hant":"不屈閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3748,"skill_field_effect_id":0,"_id_":5529,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":36,"hit_rate":100,"target_id":1141,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5530":{"attribute_id":6,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Blooming Blood","ja":"花咲く血潮","ko":"꽃피는 핏줄기","zh_hant":"如花盛開的熱情"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3749,"skill_field_effect_id":0,"_id_":5530,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5531":{"attribute_id":6,"cost":2,"icon_id":1032,"is_multiple_command_unique_skill":1,"name":{"en":"This Road Is Where We Part","ja":"ここが別れの一本道","ko":"이곳이 이별의 외길","zh_hant":"此處即為離別的一人道"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3750,"skill_field_effect_id":57,"_id_":5531,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":36,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5533":{"attribute_id":2,"cost":1,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Power Strike","ja":"渾身の一撃","ko":"혼신의 일격","zh_hant":"全力一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3752,"skill_field_effect_id":0,"_id_":5533,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[129,136,141,148,155]}]},"5534":{"attribute_id":2,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Strike","ja":"浄化の一撃","ko":"정화의 일격","zh_hant":"浄化一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3753,"skill_field_effect_id":0,"_id_":5534,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5535":{"attribute_id":2,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Promise with the Stars","ja":"万象との約束","ko":"만물과의 약속","zh_hant":"與萬象的約定"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3754,"skill_field_effect_id":0,"_id_":5535,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5536":{"attribute_id":2,"cost":2,"icon_id":247,"is_multiple_command_unique_skill":0,"name":{"en":"Light of Compassion","ja":"慈愛の光","ko":"자애의 빛","zh_hant":"慈愛光輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3755,"skill_field_effect_id":0,"_id_":5536,"skill_options":[{"id":439,"hit_rate":100,"target_id":1001,"times":[5,5,5,5,5],"values":[0,0,0,0,0]},{"id":440,"hit_rate":100,"target_id":1001,"times":[5,5,5,5,5],"values":[0,0,0,0,0]},{"id":441,"hit_rate":100,"target_id":1001,"times":[5,5,5,5,5],"values":[30,30,30,30,30]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[220,240,260,280,300]}]},"5538":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Brilliance","ja":"キラめきの一撃","ko":"반짝임의 일격","zh_hant":"光芒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3757,"skill_field_effect_id":0,"_id_":5538,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5539":{"attribute_id":1,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Strength of Awaiting","ja":"待つ者の強さ","ko":"기다리는 자의 강함","zh_hant":"等待者的堅強"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3758,"skill_field_effect_id":0,"_id_":5539,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":4002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":444,"hit_rate":100,"target_id":4002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5540":{"attribute_id":1,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Power to Believe","ja":"信じる力","ko":"믿는 힘","zh_hant":"信仰之力"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3759,"skill_field_effect_id":0,"_id_":5540,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":4002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":4002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":4002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5541":{"attribute_id":1,"cost":2,"icon_id":265,"is_multiple_command_unique_skill":0,"name":{"en":"Empty Prayer","ja":"空虚な祈り","ko":"공허한 기도","zh_hant":"空虛的祈禱"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3760,"skill_field_effect_id":0,"_id_":5541,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5547":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3767,"skill_field_effect_id":0,"_id_":5547,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5548":{"attribute_id":5,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Honest","ja":"実直","ko":"정직함","zh_hant":"誠實"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3768,"skill_field_effect_id":0,"_id_":5548,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":4012,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":444,"hit_rate":100,"target_id":4012,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5549":{"attribute_id":5,"cost":3,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Earnest","ja":"真面目","ko":"성실함","zh_hant":"正經"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3769,"skill_field_effect_id":0,"_id_":5549,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5550":{"attribute_id":5,"cost":2,"icon_id":228,"is_multiple_command_unique_skill":0,"name":{"en":"Mad Love","ja":"狂気の愛","ko":"광기의 사랑","zh_hant":"瘋狂的愛"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3770,"skill_field_effect_id":0,"_id_":5550,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":20,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5552":{"attribute_id":3,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3762,"skill_field_effect_id":0,"_id_":5552,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5553":{"attribute_id":3,"cost":3,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Fiery Dance","ja":"情熱のステップ","ko":"정열의 스텝","zh_hant":"熱情步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3763,"skill_field_effect_id":0,"_id_":5553,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[54,56,59,62,64]}]},"5554":{"attribute_id":3,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Captivating Dance","ja":"魅惑のステップ","ko":"매혹의 스텝","zh_hant":"魅惑步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3764,"skill_field_effect_id":0,"_id_":5554,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5555":{"attribute_id":3,"cost":2,"icon_id":221,"is_multiple_command_unique_skill":0,"name":{"en":"Habanera","ja":"恋は鳥のように","ko":"사랑은 새처럼","zh_hant":"愛情是一隻自由的鳥兒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3765,"skill_field_effect_id":0,"_id_":5555,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[55555,66666,77777,88888,99999]},{"id":341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5557":{"attribute_id":6,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Slash","ja":"浄化の斬撃","ko":"정화의 참격","zh_hant":"淨化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3772,"skill_field_effect_id":0,"_id_":5557,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5558":{"attribute_id":6,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Tension","ja":"緊張の斬撃","ko":"긴장의 참격","zh_hant":"緊張斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3773,"skill_field_effect_id":58,"_id_":5558,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5559":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Encouragement","ja":"激励の斬撃","ko":"격려의 참격","zh_hant":"激勵斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3774,"skill_field_effect_id":0,"_id_":5559,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5560":{"attribute_id":6,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"I Will Blossom until There's No Life in Me!","ja":"凛と咲きます命果つまで！","ko":"늠름히 피겠습니다 이 생이 다할 때까지!","zh_hant":"直至命盡，凜冽綻放！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3775,"skill_field_effect_id":59,"_id_":5560,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5562":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3777,"skill_field_effect_id":0,"_id_":5562,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5563":{"attribute_id":1,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Strike","ja":"浄化の一撃","ko":"정화의 일격","zh_hant":"浄化一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3778,"skill_field_effect_id":0,"_id_":5563,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5564":{"attribute_id":1,"cost":3,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Profusion of Flowers","ja":"千紅万紫","ko":"천홍만자","zh_hant":"千紅萬紫"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3779,"skill_field_effect_id":0,"_id_":5564,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":431,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5565":{"attribute_id":1,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Nocturne Game","ja":"紅月夜遊戯","ko":"붉은 달밤의 유희","zh_hant":"紅月夜遊戲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3780,"skill_field_effect_id":0,"_id_":5565,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":431,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5567":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":5567,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5568":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":5568,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5569":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":5569,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5570":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":5570,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5571":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":5571,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5572":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":5572,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5573":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":5573,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5574":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":5574,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5575":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":5575,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5576":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2365,"skill_field_effect_id":0,"_id_":5576,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5577":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2366,"skill_field_effect_id":0,"_id_":5577,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5579":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":5579,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5580":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":5580,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5581":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":5581,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5582":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":5582,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5583":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":5583,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5584":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":5584,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5585":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":5585,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5586":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":5586,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5588":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":5588,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5589":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":5589,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5590":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":5590,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5591":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":5591,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5592":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":5592,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5593":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":5593,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5594":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":5594,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5595":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":5595,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5596":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":5596,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5598":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":5598,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5599":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":5599,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5600":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":5600,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5601":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":5601,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5602":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":5602,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5603":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":5603,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5604":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":5604,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5605":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":5605,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5606":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":5606,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5608":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":5608,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5609":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":5609,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5610":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":5610,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5611":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":5611,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5612":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":5612,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5613":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":5613,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5614":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":5614,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5615":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":5615,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5616":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":5616,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5618":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3782,"skill_field_effect_id":0,"_id_":5618,"skill_options":[{"id":1,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5619":{"attribute_id":6,"cost":3,"icon_id":192,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Slash","ja":"減光の斬撃","ko":"감광의 참격","zh_hant":"減光斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3783,"skill_field_effect_id":0,"_id_":5619,"skill_options":[{"id":1,"hit_rate":100,"target_id":2081,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5620":{"attribute_id":6,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Fruits of Labor","ja":"努力の結晶","ko":"노력의 결정","zh_hant":"努力結晶"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3784,"skill_field_effect_id":0,"_id_":5620,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5621":{"attribute_id":6,"cost":2,"icon_id":1033,"is_multiple_command_unique_skill":0,"name":{"en":"This Road Is Where We Part","ja":"ここが別れの一本道","ko":"이곳이 이별의 외길","zh_hant":"此處即為離別的一人道"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3785,"skill_field_effect_id":60,"_id_":5621,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":346,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5623":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3787,"skill_field_effect_id":0,"_id_":5623,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5624":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Passionate Slash","ja":"熱情の斬撃","ko":"열정의 참격","zh_hant":"熱情斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3788,"skill_field_effect_id":0,"_id_":5624,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":4001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":4001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"5625":{"attribute_id":1,"cost":3,"icon_id":1020,"is_multiple_command_unique_skill":0,"name":{"en":"Unseen Play","ja":"まだ見ぬ戯曲","ko":"아직 보지 못한 희곡","zh_hant":"前所未見的戲碼"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3789,"skill_field_effect_id":61,"_id_":5625,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5626":{"attribute_id":1,"cost":2,"icon_id":1034,"is_multiple_command_unique_skill":1,"name":{"en":"Karen Aijo—to the next stage!","ja":"愛城華恋は次の舞台へ","ko":"아이조 카렌은 다음 무대로","zh_hant":"愛城華戀即將邁向下一個舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3790,"skill_field_effect_id":62,"_id_":5626,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5633":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3797,"skill_field_effect_id":0,"_id_":5633,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5634":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Slash","ja":"鼓舞の斬撃","ko":"고무의 참격","zh_hant":"鼓舞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3798,"skill_field_effect_id":0,"_id_":5634,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":4011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":4011,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"5635":{"attribute_id":4,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Stalemate Slash","ja":"膠着の斬撃","ko":"교착의 참격","zh_hant":"膠著斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3799,"skill_field_effect_id":0,"_id_":5635,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5636":{"attribute_id":4,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Anastrophe","ja":"Anastrophe","ko":"Anastrophe","zh_hant":"Anastrophe"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3800,"skill_field_effect_id":0,"_id_":5636,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5643":{"attribute_id":2,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Brilliance","ja":"キラめきの打撃","ko":"반짝임의 타격","zh_hant":"光芒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3807,"skill_field_effect_id":0,"_id_":5643,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5644":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Cumulative Smash","ja":"累加の打撃","ko":"누적의 타격","zh_hant":"累加敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3808,"skill_field_effect_id":0,"_id_":5644,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5645":{"attribute_id":2,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Exuberant Smash","ja":"充溢の打撃","ko":"흘러넘침의 타격","zh_hant":"洋溢敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3809,"skill_field_effect_id":0,"_id_":5645,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[60,60,60,60,60]}]},"5646":{"attribute_id":2,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Schnee & Glockchen","ja":"Schnee & Glockchen","ko":"Schnee & Glockchen","zh_hant":"Schnee & Glockchen"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3810,"skill_field_effect_id":0,"_id_":5646,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":346,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5648":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3812,"skill_field_effect_id":0,"_id_":5648,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5649":{"attribute_id":6,"cost":2,"icon_id":252,"is_multiple_command_unique_skill":0,"name":{"en":"Abyss Nightmare","ja":"アビス・ナイトメア","ko":"어비스 나이트메어","zh_hant":"深淵夢魘"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3813,"skill_field_effect_id":0,"_id_":5649,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":453,"hit_rate":100,"target_id":2401,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"5650":{"attribute_id":6,"cost":3,"icon_id":57,"is_multiple_command_unique_skill":0,"name":{"en":"Soul Possession","ja":"ソウル・テイク","ko":"소울 테이크","zh_hant":"掠奪靈魂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3814,"skill_field_effect_id":0,"_id_":5650,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2401,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":232,"hit_rate":100,"target_id":2401,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5651":{"attribute_id":6,"cost":2,"icon_id":229,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Feast","ja":"Dark feast","ko":"Dark feast","zh_hant":"Dark feast"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3815,"skill_field_effect_id":0,"_id_":5651,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":386,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":384,"hit_rate":100,"target_id":2401,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5653":{"attribute_id":1,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Sharpshooting","ja":"浄化の狙撃","ko":"정화의 저격","zh_hant":"淨化狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3819,"skill_field_effect_id":0,"_id_":5653,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5654":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting Blitz","ja":"雷光の狙撃","ko":"뇌광의 저격","zh_hant":"雷光狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3820,"skill_field_effect_id":63,"_id_":5654,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5655":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Encouragement","ja":"激励の狙撃","ko":"격려의 저격","zh_hant":"激勵狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3821,"skill_field_effect_id":0,"_id_":5655,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5656":{"attribute_id":1,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Against the wind, to Frontier!","ja":"いどめ向かい風すすめフロンティア！","ko":"달려들어라 맞바람에 나아가라 프론티어!","zh_hant":"不畏迎面強風，挺身前進邊疆！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3822,"skill_field_effect_id":64,"_id_":5656,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5663":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3830,"skill_field_effect_id":0,"_id_":5663,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5664":{"attribute_id":4,"cost":2,"icon_id":269,"is_multiple_command_unique_skill":0,"name":{"en":"Deceptive Flash","ja":"欺瞞の一閃","ko":"기만의 일섬","zh_hant":"欺瞞閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3831,"skill_field_effect_id":0,"_id_":5664,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":460,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5665":{"attribute_id":4,"cost":3,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Ostentatious Flash","ja":"虚飾の一閃","ko":"허식의 일섬","zh_hant":"虛飾閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3832,"skill_field_effect_id":0,"_id_":5665,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5666":{"attribute_id":4,"cost":2,"icon_id":269,"is_multiple_command_unique_skill":0,"name":{"en":"Wild Chaser","ja":"Wild chaser","ko":"Wild chaser","zh_hant":"Wild chaser"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3833,"skill_field_effect_id":0,"_id_":5666,"skill_options":[{"id":462,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":460,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":385,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5668":{"attribute_id":4,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3835,"skill_field_effect_id":0,"_id_":5668,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5669":{"attribute_id":4,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Hope","ja":"希望の剣","ko":"희망의 검","zh_hant":"希望之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3836,"skill_field_effect_id":0,"_id_":5669,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5670":{"attribute_id":4,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Recovery","ja":"再起の剣","ko":"재기의 검","zh_hant":"再起之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3837,"skill_field_effect_id":0,"_id_":5670,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5671":{"attribute_id":4,"cost":2,"icon_id":228,"is_multiple_command_unique_skill":0,"name":{"en":"Glory of Rebirth","ja":"蘇る栄光","ko":"되살아나는 영광","zh_hant":"重拾榮光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3838,"skill_field_effect_id":0,"_id_":5671,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":310,"hit_rate":100,"target_id":22002,"times":[5,5,5,5,5],"values":[200,210,220,230,240]}]},"5678":{"attribute_id":1,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3840,"skill_field_effect_id":0,"_id_":5678,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5679":{"attribute_id":1,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Utsusemi Dance","ja":"空蝉の舞踏","ko":"허물의 무도","zh_hant":"空蟬的舞步"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3841,"skill_field_effect_id":0,"_id_":5679,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":463,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5680":{"attribute_id":1,"cost":3,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Bubble Dance","ja":"泡沫の舞踏","ko":"포말의 무도","zh_hant":"泡沫的舞步"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3842,"skill_field_effect_id":0,"_id_":5680,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5681":{"attribute_id":1,"cost":2,"icon_id":1023,"is_multiple_command_unique_skill":0,"name":{"en":"Regenerating Dance","ja":"回生の舞踊","ko":"회생의 무용","zh_hant":"重生的舞步"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3843,"skill_field_effect_id":65,"_id_":5681,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5698":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Enchanting Pose","ja":"魅惑のポーズ","ko":"매혹적인 포즈","zh_hant":"魅惑的姿勢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3857,"skill_field_effect_id":0,"_id_":5698,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5699":{"attribute_id":5,"cost":3,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Enchanting Walk","ja":"魅惑のウォーキング","ko":"매혹적인 워킹","zh_hant":"魅惑的步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3858,"skill_field_effect_id":0,"_id_":5699,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5700":{"attribute_id":5,"cost":4,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Enchanting Smile","ja":"魅惑のスマイル","ko":"매혹적인 스마일","zh_hant":"魅惑的笑容"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3859,"skill_field_effect_id":0,"_id_":5700,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5701":{"attribute_id":5,"cost":2,"icon_id":272,"is_multiple_command_unique_skill":1,"name":{"en":"Yachiyo Tsuruhime's Runway","ja":"鶴姫やちよのランウェイ","ko":"츠루히메 야치요의 런웨이","zh_hant":"鶴姬八千代的伸展台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3860,"skill_field_effect_id":66,"_id_":5701,"skill_options":[{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5703":{"attribute_id":1,"cost":1,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Adorable Pose","ja":"可憐なポーズ","ko":"가련한 포즈","zh_hant":"動人的姿勢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3862,"skill_field_effect_id":0,"_id_":5703,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5704":{"attribute_id":1,"cost":2,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Adorable Walk","ja":"可憐なウォーキング","ko":"가련한 워킹","zh_hant":"動人的步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3863,"skill_field_effect_id":0,"_id_":5704,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5705":{"attribute_id":1,"cost":3,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Adorable Smile","ja":"可憐なスマイル","ko":"가련한 스마일","zh_hant":"動人的笑容"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3864,"skill_field_effect_id":0,"_id_":5705,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":241,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[10,12,14,16,20]}]},"5706":{"attribute_id":1,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Yuyuko Tanaka's Runway","ja":"田中ゆゆ子のランウェイ","ko":"타나카 유유코의 런웨이","zh_hant":"田中悠悠子的伸展台"},"optional_description":{"en":"Guest Use: Aggro Not Applied","ja":"ゲスト使用時、ターゲット固定は適用外","ko":"게스트 사용 시, 타깃 고정은 적용되지 않음","zh_hant":"使用來賓時，目標鎖定無效"},"sequence_id":3865,"skill_field_effect_id":0,"_id_":5706,"skill_options":[{"id":448,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5709":{"attribute_id":5,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Slash","ja":"浄化の斬撃","ko":"정화의 참격","zh_hant":"淨化斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3867,"skill_field_effect_id":0,"_id_":5709,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5710":{"attribute_id":5,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Bitter Slash","ja":"甘苦の斬撃","ko":"고락의 참격","zh_hant":"甘苦斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3868,"skill_field_effect_id":67,"_id_":5710,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5711":{"attribute_id":5,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Encouragement","ja":"激励の斬撃","ko":"격려의 참격","zh_hant":"激勵斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3869,"skill_field_effect_id":0,"_id_":5711,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]}]},"5712":{"attribute_id":5,"cost":2,"icon_id":1020,"is_multiple_command_unique_skill":0,"name":{"en":"We Shall Conquer the King's Summit Together!","ja":"共に征きます 王の頂！","ko":"함께 가겠습니다, 왕의 정점으로!","zh_hant":"與君一同出征，前往王之巔峰！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3870,"skill_field_effect_id":68,"_id_":5712,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5714":{"attribute_id":3,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Humble Slash","ja":"卑下の斬撃","ko":"비하의 참격","zh_hant":"卑下斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3872,"skill_field_effect_id":0,"_id_":5714,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5715":{"attribute_id":3,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Slash","ja":"苦悶の斬撃","ko":"고민의 참격","zh_hant":"苦悶斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3873,"skill_field_effect_id":0,"_id_":5715,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":431,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5716":{"attribute_id":3,"cost":3,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Mortifying Slash","ja":"憂悶の斬撃","ko":"번민의 참격","zh_hant":"憂悶斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3874,"skill_field_effect_id":0,"_id_":5716,"skill_options":[{"id":127,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":431,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5717":{"attribute_id":3,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Black Tempest Break","ja":"ブラックテンペストブレイク","ko":"블랙 템페스트 브레이크","zh_hant":"漆黑・暴風雨斷擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3875,"skill_field_effect_id":0,"_id_":5717,"skill_options":[{"id":127,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":431,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"5719":{"attribute_id":5,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Brilliance","ja":"キラめきの刺突","ko":"반짝임의 찌르기","zh_hant":"光芒突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3877,"skill_field_effect_id":0,"_id_":5719,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5720":{"attribute_id":5,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Nervous Thrust","ja":"緊張の刺突","ko":"긴장의 찌르기","zh_hant":"緊張突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3878,"skill_field_effect_id":69,"_id_":5720,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5721":{"attribute_id":5,"cost":3,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Thrust","ja":"衰光の刺突","ko":"쇠광의 찌르기","zh_hant":"衰光突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3879,"skill_field_effect_id":0,"_id_":5721,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"5722":{"attribute_id":5,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Delight - King's Majesty","ja":"Delight ～王の威光～","ko":"Delight ~왕의 위광~","zh_hant":"Delight ～王之威風～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3880,"skill_field_effect_id":0,"_id_":5722,"skill_options":[{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":54,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[55555,66666,77777,88888,99999]}]},"5724":{"attribute_id":6,"cost":2,"icon_id":241,"is_multiple_command_unique_skill":0,"name":{"en":"Vanilla","ja":"バニラ","ko":"바닐라","zh_hant":"香草"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3882,"skill_field_effect_id":0,"_id_":5724,"skill_options":[{"id":127,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":398,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[55555,66666,77777,88888,99999]}]},"5725":{"attribute_id":6,"cost":2,"icon_id":241,"is_multiple_command_unique_skill":0,"name":{"en":"Strawberry","ja":"ストロベリー","ko":"스트로베리","zh_hant":"草莓"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3883,"skill_field_effect_id":0,"_id_":5725,"skill_options":[{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":398,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[55555,66666,77777,88888,99999]}]},"5726":{"attribute_id":6,"cost":3,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Chocolate","ja":"チョコレート","ko":"초콜릿","zh_hant":"巧克力"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3884,"skill_field_effect_id":0,"_id_":5726,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5727":{"attribute_id":6,"cost":2,"icon_id":241,"is_multiple_command_unique_skill":0,"name":{"en":"SWEET BOMB","ja":"SWEET BOMB","ko":"SWEET BOMB","zh_hant":"SWEET BOMB"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3885,"skill_field_effect_id":0,"_id_":5727,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":398,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[55555,66666,77777,88888,99999]}]},"5756":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3069,"skill_field_effect_id":0,"_id_":5756,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5757":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3070,"skill_field_effect_id":0,"_id_":5757,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5758":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3071,"skill_field_effect_id":0,"_id_":5758,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5759":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3072,"skill_field_effect_id":0,"_id_":5759,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5760":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3073,"skill_field_effect_id":0,"_id_":5760,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"5761":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3074,"skill_field_effect_id":0,"_id_":5761,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5762":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3075,"skill_field_effect_id":0,"_id_":5762,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"5763":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3076,"skill_field_effect_id":0,"_id_":5763,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5764":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3077,"skill_field_effect_id":0,"_id_":5764,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5766":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3105,"skill_field_effect_id":0,"_id_":5766,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5767":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3106,"skill_field_effect_id":0,"_id_":5767,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5768":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3107,"skill_field_effect_id":0,"_id_":5768,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5769":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3108,"skill_field_effect_id":0,"_id_":5769,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5770":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3109,"skill_field_effect_id":0,"_id_":5770,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5771":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3110,"skill_field_effect_id":0,"_id_":5771,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5772":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3111,"skill_field_effect_id":0,"_id_":5772,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5773":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3112,"skill_field_effect_id":0,"_id_":5773,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5774":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3113,"skill_field_effect_id":0,"_id_":5774,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5775":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3114,"skill_field_effect_id":0,"_id_":5775,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5776":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3115,"skill_field_effect_id":0,"_id_":5776,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"5778":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":5778,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5779":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":5779,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5780":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":5780,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5781":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":5781,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5782":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":5782,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5783":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":5783,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5784":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":5784,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5785":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":5785,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5786":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":5786,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"5788":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":5788,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5789":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":5789,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5790":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":5790,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5791":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":5791,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5792":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":5792,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5793":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":5793,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5794":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":5794,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"5795":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":5795,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5796":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":5796,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"5798":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":5798,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5799":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":5799,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5800":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":5800,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5801":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":5801,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5802":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":5802,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5803":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":5803,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5804":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":5804,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5805":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":5805,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5806":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":5806,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5807":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":5807,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5809":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":5809,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5810":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":5810,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"5811":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":5811,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5812":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":5812,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5813":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":5813,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5814":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":5814,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5815":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":5815,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5816":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":5816,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5817":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":5817,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5818":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":5818,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5819":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":5819,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5821":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":5821,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5822":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":5822,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5823":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":5823,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5824":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":5824,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5825":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":5825,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5826":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":5826,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5827":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":5827,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5828":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":5828,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5829":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":5829,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5830":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":5830,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5831":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":5831,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5833":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":5833,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5834":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":5834,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5835":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":5835,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5836":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":5836,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5837":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":5837,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5838":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":5838,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5839":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":5839,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5840":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":5840,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5841":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":5841,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5842":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":5842,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5843":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":5843,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"5845":{"attribute_id":6,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"More than Anything in the World","ja":"世界中のなによりも","ko":"세상에서 제일","zh_hant":"愛妳勝過世間萬物"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3903,"skill_field_effect_id":0,"_id_":5845,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5846":{"attribute_id":6,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"By My Side Forever","ja":"永遠に私のそばに","ko":"영원히 제 곁에","zh_hant":"永遠留在我的身邊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3904,"skill_field_effect_id":72,"_id_":5846,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5847":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":0,"name":{"en":"For Her","ja":"彼女のために","ko":"그녀를 위해","zh_hant":"一切都是為了她"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3905,"skill_field_effect_id":73,"_id_":5847,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5848":{"attribute_id":6,"cost":2,"icon_id":248,"is_multiple_command_unique_skill":0,"name":{"en":"Kiss of Detoxification","ja":"解毒の接吻","ko":"해독의 입맞춤","zh_hant":"解毒之吻"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3906,"skill_field_effect_id":0,"_id_":5848,"skill_options":[{"id":446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[450,460,470,480,500]},{"id":443,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5850":{"attribute_id":3,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Hermetic Smash","ja":"厳封の打撃","ko":"엄봉의 타격","zh_hant":"密封敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3910,"skill_field_effect_id":0,"_id_":5850,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5851":{"attribute_id":3,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunderous Smash","ja":"轟雷の打撃","ko":"굉뢰의 타격","zh_hant":"轟雷敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3911,"skill_field_effect_id":74,"_id_":5851,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5852":{"attribute_id":3,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Ready to Stand on Stage","ja":"舞台に立つ覚悟","ko":"무대에 설 각오","zh_hant":"站上舞台的覺悟"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3912,"skill_field_effect_id":0,"_id_":5852,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1132,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5853":{"attribute_id":3,"cost":2,"icon_id":1042,"is_multiple_command_unique_skill":1,"name":{"en":"My Dreams Will Come True on Stage","ja":"夢咲く舞台に 輝け 私","ko":"꿈이 꽃피는 무대에서 난 빛나리","zh_hant":"我要在綻放夢想的舞台上熠熠生輝"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3913,"skill_field_effect_id":75,"_id_":5853,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5855":{"attribute_id":3,"cost":2,"icon_id":1038,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Applauses","ja":"喝采の斬撃","ko":"갈채의 참격","zh_hant":"喝采斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3915,"skill_field_effect_id":77,"_id_":5855,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"5856":{"attribute_id":3,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Tension","ja":"緊張の斬撃","ko":"긴장의 참격","zh_hant":"緊張斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3916,"skill_field_effect_id":78,"_id_":5856,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5857":{"attribute_id":3,"cost":2,"icon_id":273,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Disaster","ja":"厄災の斬撃","ko":"재앙의 참격","zh_hant":"災厄斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3917,"skill_field_effect_id":0,"_id_":5857,"skill_options":[{"id":470,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5858":{"attribute_id":3,"cost":2,"icon_id":1020,"is_multiple_command_unique_skill":0,"name":{"en":"Delight - Yell of Passion","ja":"Delight ～激情の叫び～","ko":"Delight ~격정의 외침~","zh_hant":"Delight ～激情的吶喊～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3918,"skill_field_effect_id":76,"_id_":5858,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5860":{"attribute_id":2,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Weak Point Slash","ja":"搦手の斬撃","ko":"허점의 참격","zh_hant":"搦手斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3920,"skill_field_effect_id":0,"_id_":5860,"skill_options":[{"id":1,"hit_rate":100,"target_id":2031,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2031,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2031,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"5861":{"attribute_id":2,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Ostentatious Slash","ja":"虚飾の斬撃","ko":"허식의 참격","zh_hant":"虛榮斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3921,"skill_field_effect_id":0,"_id_":5861,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"5862":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"狼藉の斬撃","ko":"행패의 참격","zh_hant":"狼藉斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3922,"skill_field_effect_id":0,"_id_":5862,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"5863":{"attribute_id":2,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Delight - Sword of Mediation","ja":"Delight ～仲裁の剣～","ko":"Delight ~중재의 검~","zh_hant":"Delight ～仲裁之劍～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3923,"skill_field_effect_id":0,"_id_":5863,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":384,"hit_rate":50,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5865":{"attribute_id":5,"cost":2,"icon_id":238,"is_multiple_command_unique_skill":0,"name":{"en":"Bear Slayer","ja":"熊をも倒す一撃","ko":"곰마저 쓰러뜨리는 일격","zh_hant":"能打倒熊的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3925,"skill_field_effect_id":0,"_id_":5865,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5866":{"attribute_id":5,"cost":3,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Earth Spider Slayer","ja":"蜘蛛をも倒す一撃","ko":"거미마저 쓰러뜨리는 일격","zh_hant":"能打倒蜘蛛的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3926,"skill_field_effect_id":0,"_id_":5866,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5867":{"attribute_id":5,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Axe-Bearer","ja":"鉞担いで","ko":"큰 도끼를 짊어지고","zh_hant":"肩上扛著斧頭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3927,"skill_field_effect_id":0,"_id_":5867,"skill_options":[{"id":89,"hit_rate":100,"target_id":1133,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5868":{"attribute_id":5,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Contest of Strength","ja":"剛腕力比べ","ko":"힘겨루기","zh_hant":"以強勁臂彎比力氣"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3928,"skill_field_effect_id":0,"_id_":5868,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,60,60,60,60]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"5892":{"attribute_id":6,"cost":1,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Brilliance","ja":"キラめきの一閃","ko":"반짝임의 일섬","zh_hant":"光芒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3946,"skill_field_effect_id":0,"_id_":5892,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"5893":{"attribute_id":6,"cost":2,"icon_id":250,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Flash","ja":"純化の一閃","ko":"순화의 일섬","zh_hant":"純化閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3947,"skill_field_effect_id":0,"_id_":5893,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":444,"hit_rate":100,"target_id":1133,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":445,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"5894":{"attribute_id":6,"cost":3,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorbing Flash","ja":"吸光の一閃","ko":"흡광의 일섬","zh_hant":"吸光閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3948,"skill_field_effect_id":0,"_id_":5894,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]}]},"5895":{"attribute_id":6,"cost":2,"icon_id":32,"is_multiple_command_unique_skill":0,"name":{"en":"Circle of Connect","ja":"Circle of Connect","ko":"Circle of Connect","zh_hant":"Circle of Connect"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3949,"skill_field_effect_id":0,"_id_":5895,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":32,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":33,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":346,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5897":{"attribute_id":5,"cost":2,"icon_id":273,"is_multiple_command_unique_skill":0,"name":{"en":"Light of Hope","ja":"希望の光","ko":"희망의 빛","zh_hant":"希望之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3952,"skill_field_effect_id":0,"_id_":5897,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":470,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[100,100,100,100,100]}]},"5898":{"attribute_id":5,"cost":2,"icon_id":1040,"is_multiple_command_unique_skill":0,"name":{"en":"Fight Together","ja":"共に戦う力","ko":"함께 싸울 힘","zh_hant":"並肩作戰之力"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3953,"skill_field_effect_id":80,"_id_":5898,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5899":{"attribute_id":5,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Dominate Evil","ja":"魔を怯ませる力","ko":"마를 압도할 힘","zh_hant":"震懾魔物之力"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3954,"skill_field_effect_id":81,"_id_":5899,"skill_options":[{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5900":{"attribute_id":5,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Light of Rescue","ja":"救いの光","ko":"구원의 빛","zh_hant":"救贖之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3955,"skill_field_effect_id":0,"_id_":5900,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[450,460,470,480,500]}]},"5902":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2431,"skill_field_effect_id":0,"_id_":5902,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5903":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2432,"skill_field_effect_id":0,"_id_":5903,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5904":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2433,"skill_field_effect_id":0,"_id_":5904,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5905":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tri-Slash","ja":"参連撃","ko":"삼연격","zh_hant":"參連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2434,"skill_field_effect_id":0,"_id_":5905,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5906":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2435,"skill_field_effect_id":0,"_id_":5906,"skill_options":[{"id":21,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5907":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2436,"skill_field_effect_id":0,"_id_":5907,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5908":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2437,"skill_field_effect_id":0,"_id_":5908,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"5910":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2465,"skill_field_effect_id":0,"_id_":5910,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5911":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2466,"skill_field_effect_id":0,"_id_":5911,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5912":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2467,"skill_field_effect_id":0,"_id_":5912,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5913":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2468,"skill_field_effect_id":0,"_id_":5913,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5914":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2469,"skill_field_effect_id":0,"_id_":5914,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5915":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2470,"skill_field_effect_id":0,"_id_":5915,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5916":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2471,"skill_field_effect_id":0,"_id_":5916,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5917":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2472,"skill_field_effect_id":0,"_id_":5917,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5918":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2473,"skill_field_effect_id":0,"_id_":5918,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5920":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2502,"skill_field_effect_id":0,"_id_":5920,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5921":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2503,"skill_field_effect_id":0,"_id_":5921,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5922":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2504,"skill_field_effect_id":0,"_id_":5922,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5923":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2505,"skill_field_effect_id":0,"_id_":5923,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5924":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2506,"skill_field_effect_id":0,"_id_":5924,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5925":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2507,"skill_field_effect_id":0,"_id_":5925,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5926":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2508,"skill_field_effect_id":0,"_id_":5926,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5927":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":5927,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5928":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2510,"skill_field_effect_id":0,"_id_":5928,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"5930":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2502,"skill_field_effect_id":0,"_id_":5930,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5931":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2503,"skill_field_effect_id":0,"_id_":5931,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5932":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2504,"skill_field_effect_id":0,"_id_":5932,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5933":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2505,"skill_field_effect_id":0,"_id_":5933,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5934":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2506,"skill_field_effect_id":0,"_id_":5934,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5935":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2507,"skill_field_effect_id":0,"_id_":5935,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5936":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2508,"skill_field_effect_id":0,"_id_":5936,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"5937":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":5937,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"5938":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2509,"skill_field_effect_id":0,"_id_":5938,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5939":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette NEO","ja":"メイドのたしなみ NEO","ko":"메이드의 소양 NEO","zh_hant":"女僕的特技 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2510,"skill_field_effect_id":0,"_id_":5939,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"5941":{"attribute_id":3,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Hermetic Slash","ja":"厳封の斬撃","ko":"엄봉의 참격","zh_hant":"密封斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3957,"skill_field_effect_id":0,"_id_":5941,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5942":{"attribute_id":3,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Exuberant Slash","ja":"充溢の斬撃","ko":"흘러넘침의 참격","zh_hant":"洋溢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3958,"skill_field_effect_id":0,"_id_":5942,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":463,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5943":{"attribute_id":3,"cost":3,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Elaborate Slash","ja":"絢爛の斬撃","ko":"현란의 참격","zh_hant":"絢爛斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3959,"skill_field_effect_id":82,"_id_":5943,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5944":{"attribute_id":3,"cost":2,"icon_id":275,"is_multiple_command_unique_skill":0,"name":{"en":"Swear by Heaven and Earth","ja":"俯仰天地","ko":"부앙천지","zh_hant":"俯仰天地"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3960,"skill_field_effect_id":0,"_id_":5944,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":29,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":472,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5956":{"attribute_id":2,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Wise Guidance","ja":"賢慮の導き","ko":"현려의 인도","zh_hant":"賢明指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3973,"skill_field_effect_id":0,"_id_":5956,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5957":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Talented Guidance","ja":"才気の導き","ko":"재기의 인도","zh_hant":"才華指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3974,"skill_field_effect_id":0,"_id_":5957,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5958":{"attribute_id":2,"cost":3,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Future Guidance","ja":"未来への導き","ko":"미래로의 인도","zh_hant":"未來指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3975,"skill_field_effect_id":0,"_id_":5958,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"5959":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":1,"name":{"en":"Tome of Wisdom","ja":"叡智の書","ko":"예지의 서","zh_hant":"睿智之書"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3976,"skill_field_effect_id":0,"_id_":5959,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"5961":{"attribute_id":4,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Graceful Pose","ja":"優雅なポーズ","ko":"우아한 포즈","zh_hant":"優雅的姿勢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3978,"skill_field_effect_id":0,"_id_":5961,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5962":{"attribute_id":4,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Graceful Walk","ja":"優雅なウォーキング","ko":"우아한 워킹","zh_hant":"優雅的步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3979,"skill_field_effect_id":84,"_id_":5962,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"5963":{"attribute_id":4,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Graceful Smile","ja":"優雅なスマイル","ko":"우아한 스마일","zh_hant":"優雅的笑容"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3980,"skill_field_effect_id":0,"_id_":5963,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1132,"times":[0,0,0,0,0],"values":[60,65,70,75,80]}]},"5964":{"attribute_id":4,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":1,"name":{"en":"Kaoruko Hanayagi's Runway","ja":"花柳香子のランウェイ","ko":"하나야기 카오루코의 런웨이","zh_hant":"花柳香子的伸展台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3981,"skill_field_effect_id":85,"_id_":5964,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"5971":{"attribute_id":4,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Wisdom Flash","ja":"英気の一閃","ko":"영기의 일섬","zh_hant":"英氣閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3983,"skill_field_effect_id":86,"_id_":5971,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5972":{"attribute_id":4,"cost":2,"icon_id":1019,"is_multiple_command_unique_skill":0,"name":{"en":"Lively Flash","ja":"溌剌な一閃","ko":"발랄한 일섬","zh_hant":"活潑閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3984,"skill_field_effect_id":87,"_id_":5972,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5973":{"attribute_id":4,"cost":3,"icon_id":1039,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance Flash","ja":"旺然たる一閃","ko":"왕성한 일섬","zh_hant":"朝氣閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3985,"skill_field_effect_id":88,"_id_":5973,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"5974":{"attribute_id":4,"cost":2,"icon_id":1023,"is_multiple_command_unique_skill":0,"name":{"en":"Sky Blue Combo Shooting","ja":"スカイブルーコンビシューティング","ko":"스카이블루 콤비 슈팅","zh_hant":"天藍劇團組合射擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3986,"skill_field_effect_id":89,"_id_":5974,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"5976":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":5976,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5977":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":5977,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5978":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":5978,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5979":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":5979,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5980":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":5980,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5981":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":5981,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5982":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":5982,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"5983":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":5983,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5985":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":5985,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5986":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":5986,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"5987":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":5987,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5988":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":5988,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"5989":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":5989,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5990":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":5990,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"5991":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":5991,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"5992":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":5992,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5993":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":5993,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"5995":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":5995,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5996":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":5996,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5997":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":5997,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"5998":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":5998,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"5999":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":5999,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6000":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":6000,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6001":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":6001,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6002":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":6002,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6003":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":6003,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6005":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":6005,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6006":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":6006,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6007":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":6007,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6008":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":6008,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6009":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":6009,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6010":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":6010,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6011":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":6011,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6012":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":6012,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6013":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":6013,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6015":{"attribute_id":6,"cost":3,"icon_id":192,"is_multiple_command_unique_skill":0,"name":{"en":"Exquisite Pose","ja":"華麗なポーズ","ko":"화려한 포즈","zh_hant":"華麗的姿勢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3988,"skill_field_effect_id":0,"_id_":6015,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6016":{"attribute_id":6,"cost":3,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Exquisite Walk","ja":"華麗なウォーキング","ko":"화려한 워킹","zh_hant":"華麗的步伐"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3989,"skill_field_effect_id":0,"_id_":6016,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":384,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":474,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[1,1,1,1,1]}]},"6017":{"attribute_id":6,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Exquisite Smile","ja":"華麗なスマイル","ko":"화려한 스마일","zh_hant":"華麗的笑容"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3990,"skill_field_effect_id":0,"_id_":6017,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":157,"hit_rate":100,"target_id":1145,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6018":{"attribute_id":6,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Futaba Isurugi's Runway","ja":"石動双葉のランウェイ","ko":"이스루기 후타바의 런웨이","zh_hant":"石動雙葉的伸展台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3991,"skill_field_effect_id":0,"_id_":6018,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":442,"hit_rate":100,"target_id":2404,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6020":{"attribute_id":2,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Valkyrie Prayer","ja":"戦乙女の祈り","ko":"발키리의 기도","zh_hant":"女武神的祈禱"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3993,"skill_field_effect_id":91,"_id_":6020,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6021":{"attribute_id":2,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Valkyrie Constraint","ja":"戦乙女の制約","ko":"발키리의 제약","zh_hant":"女武神的約束"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3994,"skill_field_effect_id":92,"_id_":6021,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,10,10,10,10]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6022":{"attribute_id":2,"cost":3,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Valkyrie Pupils","ja":"戦乙女の瞳","ko":"발키리의 눈동자","zh_hant":"女武神的眼眸"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3995,"skill_field_effect_id":93,"_id_":6022,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[131,137,143,150,157]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"6023":{"attribute_id":2,"cost":2,"icon_id":1045,"is_multiple_command_unique_skill":0,"name":{"en":"Fire Awakening","ja":"蒼炎の目覚め","ko":"푸른 불꽃의 각성","zh_hant":"蒼焰的覺醒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3996,"skill_field_effect_id":90,"_id_":6023,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6030":{"attribute_id":9,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Desire","ja":"宿望の剣","ko":"숙원의 검","zh_hant":"宿願之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4002,"skill_field_effect_id":96,"_id_":6030,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6031":{"attribute_id":9,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Courage","ja":"勇気の剣","ko":"용기의 검","zh_hant":"勇氣之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4003,"skill_field_effect_id":97,"_id_":6031,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6032":{"attribute_id":9,"cost":3,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Evil Slayer","ja":"悪を討つ剣","ko":"악을 처단하는 검","zh_hant":"討惡之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4004,"skill_field_effect_id":98,"_id_":6032,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[131,137,143,150,157]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6033":{"attribute_id":9,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":1,"name":{"en":"Balmung","ja":"愛のバルムンク","ko":"사랑의 발뭉","zh_hant":"愛之巴爾蒙克"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4005,"skill_field_effect_id":99,"_id_":6033,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":479,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":476,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":86,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"6035":{"attribute_id":4,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"Priority","ja":"譲り合い","ko":"양보","zh_hant":"互相禮讓"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4007,"skill_field_effect_id":0,"_id_":6035,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6036":{"attribute_id":4,"cost":2,"icon_id":240,"is_multiple_command_unique_skill":0,"name":{"en":"Safety","ja":"安全第一","ko":"안전제일","zh_hant":"安全第一"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4008,"skill_field_effect_id":0,"_id_":6036,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":394,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[60,60,60,60,60]}]},"6037":{"attribute_id":4,"cost":2,"icon_id":1039,"is_multiple_command_unique_skill":0,"name":{"en":"Signal","ja":"進行合図","ko":"진행신호","zh_hant":"通行手勢"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4009,"skill_field_effect_id":94,"_id_":6037,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6038":{"attribute_id":4,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Officer Otonashi's Traffic Control","ja":"音無巡査の交通整理","ko":"오토나시 순경의 교통정리","zh_hant":"音無警員的交通指揮"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4010,"skill_field_effect_id":95,"_id_":6038,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[650,660,670,680,700]}]},"6045":{"attribute_id":2,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Hope","ja":"希望の斬撃","ko":"희망의 참격","zh_hant":"希望斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4012,"skill_field_effect_id":100,"_id_":6045,"skill_options":[{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6046":{"attribute_id":2,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Enchanting Slash","ja":"魅惑の斬撃","ko":"매혹의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4013,"skill_field_effect_id":101,"_id_":6046,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":392,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6047":{"attribute_id":2,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Desired Stage","ja":"望まれた舞台","ko":"바라던 무대","zh_hant":"期望的舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4014,"skill_field_effect_id":0,"_id_":6047,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":473,"hit_rate":100,"target_id":1143,"times":[1,1,1,1,1],"values":[2,2,2,2,2]}]},"6048":{"attribute_id":2,"cost":2,"icon_id":1047,"is_multiple_command_unique_skill":1,"name":{"en":"Hikari Kagura—I'm the Star!","ja":"神楽ひかり 私がスタァだ！","ko":"카구라 히카리 내가 스타다!","zh_hant":"神樂光 我正是Star！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4015,"skill_field_effect_id":102,"_id_":6048,"skill_options":[{"id":360,"hit_rate":100,"target_id":4136,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6050":{"attribute_id":4,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Awakening Song","ja":"目覚めの歌","ko":"각성의 노래","zh_hant":"喚醒之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4017,"skill_field_effect_id":0,"_id_":6050,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":231,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6051":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"All-Knowing Song","ja":"全知の歌","ko":"전지의 노래","zh_hant":"全知之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4018,"skill_field_effect_id":0,"_id_":6051,"skill_options":[{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6052":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Earth Song","ja":"大地の歌","ko":"대지의 노래","zh_hant":"大地之歌"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4019,"skill_field_effect_id":0,"_id_":6052,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":14,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6053":{"attribute_id":4,"cost":1,"icon_id":284,"is_multiple_command_unique_skill":0,"name":{"en":"Leading Song","ja":"歌声の道標","ko":"노랫소리의 길잡이","zh_hant":"歌聲的指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4020,"skill_field_effect_id":0,"_id_":6053,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":485,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":486,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6055":{"attribute_id":2,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Constraint Strike","ja":"制約の一撃","ko":"제약의 일격","zh_hant":"制約一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4022,"skill_field_effect_id":103,"_id_":6055,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":224,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6056":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Encouragement","ja":"激励の一撃","ko":"격려의 일격","zh_hant":"激勵一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4023,"skill_field_effect_id":104,"_id_":6056,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6057":{"attribute_id":2,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Victory","ja":"勝利の一撃","ko":"승리의 일격","zh_hant":"勝利一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4024,"skill_field_effect_id":105,"_id_":6057,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6058":{"attribute_id":2,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Moon Slayer","ja":"月夜の退魔","ko":"달밤의 퇴마","zh_hant":"月夜之退魔"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4025,"skill_field_effect_id":106,"_id_":6058,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6072":{"attribute_id":3,"cost":2,"icon_id":249,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Virility","ja":"精悍な剣","ko":"정한한 검","zh_hant":"精悍之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4038,"skill_field_effect_id":0,"_id_":6072,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":251,"hit_rate":100,"target_id":2051,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6073":{"attribute_id":3,"cost":2,"icon_id":273,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Loyalty","ja":"忠義の剣","ko":"충의의 검","zh_hant":"忠義之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4039,"skill_field_effect_id":0,"_id_":6073,"skill_options":[{"id":462,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":470,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6074":{"attribute_id":3,"cost":3,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Compassion","ja":"慈愛の剣","ko":"자애의 검","zh_hant":"慈愛之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4040,"skill_field_effect_id":0,"_id_":6074,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]}]},"6075":{"attribute_id":3,"cost":2,"icon_id":1048,"is_multiple_command_unique_skill":0,"name":{"en":"Rose of Sincerity","ja":"誠心のばら","ko":"성심의 장미","zh_hant":"忠誠玫瑰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4041,"skill_field_effect_id":107,"_id_":6075,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6077":{"attribute_id":6,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Passion","ja":"情熱の剣","ko":"정열의 검","zh_hant":"熱情之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4043,"skill_field_effect_id":108,"_id_":6077,"skill_options":[{"id":473,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6078":{"attribute_id":6,"cost":3,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Nobility","ja":"高潔な剣","ko":"고결한 검","zh_hant":"高潔之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4044,"skill_field_effect_id":109,"_id_":6078,"skill_options":[{"id":34,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6079":{"attribute_id":6,"cost":4,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Beauty","ja":"美しき剣","ko":"아름다운 검","zh_hant":"美艷之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4045,"skill_field_effect_id":0,"_id_":6079,"skill_options":[{"id":89,"hit_rate":100,"target_id":1145,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6080":{"attribute_id":6,"cost":2,"icon_id":236,"is_multiple_command_unique_skill":0,"name":{"en":"Rose of Beauty","ja":"麗しきばら","ko":"아름다운 장미","zh_hant":"艷麗玫瑰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4046,"skill_field_effect_id":110,"_id_":6080,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6082":{"attribute_id":7,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Brilliance","ja":"キラめきの斬撃","ko":"반짝임의 참격","zh_hant":"光芒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4048,"skill_field_effect_id":0,"_id_":6082,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[93,98,102,107,112]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"6083":{"attribute_id":7,"cost":2,"icon_id":269,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Grace","ja":"麗しの剣","ko":"아름다운 검","zh_hant":"美麗之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4049,"skill_field_effect_id":0,"_id_":6083,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":394,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[60,60,60,60,60]},{"id":460,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6084":{"attribute_id":7,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of Fury","ja":"激情の剣","ko":"격정의 검","zh_hant":"激情之劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4050,"skill_field_effect_id":0,"_id_":6084,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6085":{"attribute_id":7,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Rose of Beauty Respect Ver.","ja":"麗しきばら Respect Ver.","ko":"아름다운 장미 Respect Ver.","zh_hant":"艷麗玫瑰 Respect Ver."},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4051,"skill_field_effect_id":116,"_id_":6085,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6087":{"attribute_id":8,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Suppression Slash","ja":"制圧の斬撃","ko":"제압의 참격","zh_hant":"鎮壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4053,"skill_field_effect_id":114,"_id_":6087,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6088":{"attribute_id":8,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Graceful Slash","ja":"優雅な斬撃","ko":"우아한 참격","zh_hant":"優雅斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4054,"skill_field_effect_id":115,"_id_":6088,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[131,137,143,150,157]}]},"6089":{"attribute_id":8,"cost":3,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorbing Slash","ja":"吸光の斬撃","ko":"흡광의 참격","zh_hant":"吸光斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4055,"skill_field_effect_id":0,"_id_":6089,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[131,137,143,150,157]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6090":{"attribute_id":8,"cost":2,"icon_id":1050,"is_multiple_command_unique_skill":1,"name":{"en":"Rose of Nobility","ja":"気高きばら","ko":"고귀한 장미","zh_hant":"高貴玫瑰"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4056,"skill_field_effect_id":113,"_id_":6090,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":473,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[2,2,2,2,2]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[225,236,247,258,270]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6092":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":6092,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6093":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":6093,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6094":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":6094,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6095":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":6095,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6096":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":6096,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6097":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":6097,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6098":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":6098,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6099":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":6099,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6100":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":6100,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6101":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":6101,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6103":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":6103,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6104":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":6104,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"6105":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":6105,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6106":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":6106,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6107":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":6107,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6108":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":6108,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6109":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":6109,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6110":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":6110,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6111":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":6111,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6112":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":6112,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6113":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":6113,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6115":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":6115,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6116":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":6116,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6117":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":6117,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6118":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":6118,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6119":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":6119,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6120":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":6120,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6121":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":6121,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6122":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":6122,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6123":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":6123,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6124":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":6124,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6125":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":6125,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6127":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":6127,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6128":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":6128,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6129":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":6129,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6130":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":6130,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6131":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":6131,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6132":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":6132,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6133":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":6133,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6134":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":6134,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6135":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":6135,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6136":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":6136,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6137":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":6137,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6149":{"attribute_id":3,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Cold-Blooded King","ja":"冷血な王","ko":"냉혹한 왕","zh_hant":"冷血的王"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4062,"skill_field_effect_id":117,"_id_":6149,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6150":{"attribute_id":3,"cost":2,"icon_id":1052,"is_multiple_command_unique_skill":0,"name":{"en":"Merciless King","ja":"無慈悲な王","ko":"무자비한 왕","zh_hant":"無情的王"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4063,"skill_field_effect_id":118,"_id_":6150,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6151":{"attribute_id":3,"cost":3,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Stern King","ja":"峻厳な王","ko":"준엄한 왕","zh_hant":"嚴苛的王"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4064,"skill_field_effect_id":122,"_id_":6151,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6152":{"attribute_id":3,"cost":2,"icon_id":287,"is_multiple_command_unique_skill":0,"name":{"en":"Hades's Conviction","ja":"冥王の断罪","ko":"명왕의 단죄","zh_hant":"冥王之定罪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4065,"skill_field_effect_id":0,"_id_":6152,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":489,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]},{"id":442,"hit_rate":100,"target_id":2021,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6166":{"attribute_id":1,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Mint","ja":"ミント","ko":"민트","zh_hant":"薄荷"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4078,"skill_field_effect_id":123,"_id_":6166,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"6167":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Chocolate Sauce","ja":"チョコレートソース","ko":"초콜릿 소스","zh_hant":"巧克力醬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4079,"skill_field_effect_id":124,"_id_":6167,"skill_options":[{"id":445,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6168":{"attribute_id":1,"cost":3,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Whipped Cream","ja":"ホイップクリーム","ko":"휘핑크림","zh_hant":"鮮奶油"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4080,"skill_field_effect_id":125,"_id_":6168,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6169":{"attribute_id":1,"cost":2,"icon_id":288,"is_multiple_command_unique_skill":0,"name":{"en":"Pudding Press♪","ja":"ぷるるん♪プリンプレス","ko":"탱글탱글♪ 푸딩 대소동","zh_hant":"軟嫩Q彈♪布丁壓頂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4081,"skill_field_effect_id":126,"_id_":6169,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6171":{"attribute_id":5,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"King's Castle Walls","ja":"王の城壁","ko":"왕의 성벽","zh_hant":"王的城牆"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4083,"skill_field_effect_id":128,"_id_":6171,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6172":{"attribute_id":5,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"King's Imposing Figure","ja":"王の雄姿","ko":"왕의 용맹함","zh_hant":"王的英姿"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4084,"skill_field_effect_id":129,"_id_":6172,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[10,10,10,10,10]},{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6173":{"attribute_id":5,"cost":3,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Eternal Life","ja":"永遠の命","ko":"영원한 생명","zh_hant":"永恆生命"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4085,"skill_field_effect_id":130,"_id_":6173,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"6174":{"attribute_id":5,"cost":2,"icon_id":289,"is_multiple_command_unique_skill":0,"name":{"en":"King of Uruk","ja":"ウルクの王","ko":"우르크의 왕","zh_hant":"烏魯克之王"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4086,"skill_field_effect_id":131,"_id_":6174,"skill_options":[{"id":299,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":495,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6176":{"attribute_id":1,"cost":2,"icon_id":1024,"is_multiple_command_unique_skill":0,"name":{"en":"Laws of the Underworld","ja":"冥府の掟","ko":"저승의 규칙","zh_hant":"冥府的律法"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4093,"skill_field_effect_id":133,"_id_":6176,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6177":{"attribute_id":1,"cost":2,"icon_id":237,"is_multiple_command_unique_skill":0,"name":{"en":"Peace of the Underworld","ja":"冥府の安寧","ko":"저승의 안녕","zh_hant":"冥府的安寧"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4094,"skill_field_effect_id":0,"_id_":6177,"skill_options":[{"id":127,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":496,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6178":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Quiet of the Underworld","ja":"冥府の静寂","ko":"저승의 고요","zh_hant":"冥府的寂靜"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4095,"skill_field_effect_id":134,"_id_":6178,"skill_options":[{"id":440,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6179":{"attribute_id":1,"cost":2,"icon_id":287,"is_multiple_command_unique_skill":1,"name":{"en":"Adverse Fate","ja":"数奇な運命","ko":"기구한 운명","zh_hant":"曲折的命運"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4096,"skill_field_effect_id":135,"_id_":6179,"skill_options":[{"id":462,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6181":{"attribute_id":6,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Arrow of Revelation","ja":"示しの矢","ko":"계시의 활","zh_hant":"啟示之箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4088,"skill_field_effect_id":137,"_id_":6181,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6182":{"attribute_id":6,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"The One Who Stops","ja":"止める者","ko":"멈추는 자","zh_hant":"遏止之人"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4089,"skill_field_effect_id":138,"_id_":6182,"skill_options":[{"id":392,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6183":{"attribute_id":6,"cost":3,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Sagittarius' Brilliance","ja":"いて座のキラめき","ko":"궁수자리의 반짝임","zh_hant":"人馬座的光芒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4090,"skill_field_effect_id":0,"_id_":6183,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[20,30,40,50,60]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[20,20,20,20,20]}]},"6184":{"attribute_id":6,"cost":2,"icon_id":1058,"is_multiple_command_unique_skill":1,"name":{"en":"Arrow of the Sage","ja":"賢者の弓","ko":"현자의 활","zh_hant":"賢者之弓"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4091,"skill_field_effect_id":139,"_id_":6184,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6186":{"attribute_id":6,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Heresy","ja":"邪道","ko":"사도","zh_hant":"邪道"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4098,"skill_field_effect_id":141,"_id_":6186,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6187":{"attribute_id":6,"cost":2,"icon_id":178,"is_multiple_command_unique_skill":0,"name":{"en":"Curse","ja":"呪詛","ko":"저주","zh_hant":"詛咒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4099,"skill_field_effect_id":0,"_id_":6187,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":251,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6188":{"attribute_id":6,"cost":2,"icon_id":1060,"is_multiple_command_unique_skill":0,"name":{"en":"Evil Offering","ja":"悪へ供奉","ko":"악을 따르는 자","zh_hant":"邪惡的供養"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4100,"skill_field_effect_id":142,"_id_":6188,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":252,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6189":{"attribute_id":6,"cost":2,"icon_id":1051,"is_multiple_command_unique_skill":0,"name":{"en":"Doman the Accursed","ja":"厭魅のドーマン","ko":"염매의 도만","zh_hant":"厭魅九字紋"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4101,"skill_field_effect_id":143,"_id_":6189,"skill_options":[{"id":156,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":501,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6191":{"attribute_id":1,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Abundant Crops","ja":"豊穣の務め","ko":"풍요의 책무","zh_hant":"豐饒的職責"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4103,"skill_field_effect_id":145,"_id_":6191,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6192":{"attribute_id":1,"cost":2,"icon_id":26,"is_multiple_command_unique_skill":0,"name":{"en":"First Strike","ja":"開戦の打撃","ko":"개전의 타격","zh_hant":"開戰敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4104,"skill_field_effect_id":0,"_id_":6192,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":462,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"6193":{"attribute_id":1,"cost":2,"icon_id":293,"is_multiple_command_unique_skill":0,"name":{"en":"Impetus of Beauty","ja":"美の衝動","ko":"아름다움의 충동","zh_hant":"美的衝動"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4105,"skill_field_effect_id":146,"_id_":6193,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":499,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6194":{"attribute_id":1,"cost":2,"icon_id":293,"is_multiple_command_unique_skill":0,"name":{"en":"Love Beast","ja":"愛の魔物","ko":"사랑의 마물","zh_hant":"愛的魔物"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4106,"skill_field_effect_id":0,"_id_":6194,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":60,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":499,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6196":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4108,"skill_field_effect_id":149,"_id_":6196,"skill_options":[{"id":89,"hit_rate":100,"target_id":1142,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6197":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Slash","ja":"碧き斬撃","ko":"푸른 참격","zh_hant":"碧綠斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4109,"skill_field_effect_id":150,"_id_":6197,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":508,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":350,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6198":{"attribute_id":6,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4110,"skill_field_effect_id":151,"_id_":6198,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6199":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":1,"name":{"en":"Delight - My Thoughts","ja":"Delight ～我が想い～","ko":"Delight ~나의 마음~","zh_hant":"Delight ～我的心意～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4111,"skill_field_effect_id":152,"_id_":6199,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6201":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":6201,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6202":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":6202,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6203":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":6203,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6204":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":6204,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6205":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":6205,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6206":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":6206,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6207":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":6207,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6208":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":6208,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6209":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":6209,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"6211":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":6211,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6212":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":6212,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6213":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":6213,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6214":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":6214,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6215":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":6215,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6216":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":6216,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6217":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":6217,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6218":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":6218,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"6219":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":6219,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6220":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":6220,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"6222":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":6222,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6223":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":6223,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6224":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":6224,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6225":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":6225,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6226":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":6226,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6227":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":6227,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"6228":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":6228,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6229":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":6229,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"6231":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":6231,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6232":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":6232,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6233":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":6233,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6234":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":6234,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6235":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":6235,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6236":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3484,"skill_field_effect_id":0,"_id_":6236,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"6237":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":6237,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6238":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3486,"skill_field_effect_id":0,"_id_":6238,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"6240":{"attribute_id":9,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Good Deeds","ja":"善行を積む","ko":"선행 쌓기","zh_hant":"日行一善"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4113,"skill_field_effect_id":153,"_id_":6240,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6241":{"attribute_id":9,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Admonition and Charity","ja":"訓戒と施し","ko":"훈계와 시혜","zh_hant":"訓誡與施捨"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4114,"skill_field_effect_id":154,"_id_":6241,"skill_options":[{"id":509,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6242":{"attribute_id":9,"cost":2,"icon_id":295,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Reversal","ja":"逆転の一閃","ko":"역전의 일섬","zh_hant":"逆轉閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4115,"skill_field_effect_id":155,"_id_":6242,"skill_options":[{"id":509,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[131,137,143,150,157]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6243":{"attribute_id":9,"cost":2,"icon_id":295,"is_multiple_command_unique_skill":1,"name":{"en":"Xmas Prayer","ja":"聖夜の祈り","ko":"성야의 기도","zh_hant":"聖夜的祈禱"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4116,"skill_field_effect_id":156,"_id_":6243,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":509,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[225,236,247,258,270]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6245":{"attribute_id":2,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Cold Glance","ja":"冷酷な眼差し","ko":"냉혹한 눈빛","zh_hant":"冷酷的眼神"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4118,"skill_field_effect_id":157,"_id_":6245,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6246":{"attribute_id":2,"cost":2,"icon_id":1037,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Sorcery","ja":"黒魔術","ko":"흑마술","zh_hant":"黑魔法"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4119,"skill_field_effect_id":158,"_id_":6246,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6247":{"attribute_id":2,"cost":2,"icon_id":1061,"is_multiple_command_unique_skill":0,"name":{"en":"Jealousy and Envy","ja":"嫉妬と羨望","ko":"질투와 선망","zh_hant":"嫉妒與羨慕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4120,"skill_field_effect_id":159,"_id_":6247,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6248":{"attribute_id":2,"cost":2,"icon_id":1023,"is_multiple_command_unique_skill":0,"name":{"en":"Giftigen Apfel","ja":"giftigen Apfel","ko":"Giftiger Apfel","zh_hant":"Giftiger Apfel"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4121,"skill_field_effect_id":160,"_id_":6248,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":54,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":371,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[650,660,670,680,700]}]},"6254":{"attribute_id":8,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Flash","ja":"煌めく一閃","ko":"빛나는 일섬","zh_hant":"輝煌閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4123,"skill_field_effect_id":162,"_id_":6254,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6255":{"attribute_id":8,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Flash","ja":"吸収の一閃","ko":"흡수의 일섬","zh_hant":"吸收閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4124,"skill_field_effect_id":163,"_id_":6255,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":445,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6256":{"attribute_id":8,"cost":2,"icon_id":297,"is_multiple_command_unique_skill":0,"name":{"en":"Overwhelm Flash","ja":"圧倒の一閃","ko":"압도의 일섬","zh_hant":"壓倒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4125,"skill_field_effect_id":164,"_id_":6256,"skill_options":[{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[131,137,143,150,157]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6257":{"attribute_id":8,"cost":2,"icon_id":298,"is_multiple_command_unique_skill":0,"name":{"en":"Starting Jump!","ja":"始まりのジャンプ！","ko":"시작의 점프!","zh_hant":"起始之跳躍！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4126,"skill_field_effect_id":165,"_id_":6257,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":512,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[225,236,247,258,270]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"6259":{"attribute_id":3,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4128,"skill_field_effect_id":166,"_id_":6259,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6260":{"attribute_id":3,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Hope","ja":"希望の斬撃","ko":"희망의 참격","zh_hant":"希望斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4129,"skill_field_effect_id":167,"_id_":6260,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":224,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6261":{"attribute_id":3,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Slash","ja":"雷鳴の斬撃","ko":"천둥의 참격","zh_hant":"雷鳴斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4130,"skill_field_effect_id":168,"_id_":6261,"skill_options":[{"id":1,"hit_rate":100,"target_id":2021,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6262":{"attribute_id":3,"cost":2,"icon_id":1038,"is_multiple_command_unique_skill":1,"name":{"en":"Fruits Co-Performance","ja":"フルーツたちの共演","ko":"과일들의 합동 공연","zh_hant":"各式水果的共演"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4131,"skill_field_effect_id":169,"_id_":6262,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6264":{"attribute_id":3,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Hope","ja":"希望の斬撃","ko":"희망의 참격","zh_hant":"希望斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4133,"skill_field_effect_id":170,"_id_":6264,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6265":{"attribute_id":3,"cost":2,"icon_id":1057,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Vitality","ja":"活力の斬撃","ko":"활력의 참격","zh_hant":"活力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4134,"skill_field_effect_id":171,"_id_":6265,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6266":{"attribute_id":3,"cost":3,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Slash","ja":"煌めく斬撃","ko":"빛나는 참격","zh_hant":"輝煌斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4135,"skill_field_effect_id":172,"_id_":6266,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1132,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6267":{"attribute_id":3,"cost":2,"icon_id":1064,"is_multiple_command_unique_skill":1,"name":{"en":"Pan's Flute","ja":"牧神パーンの笛","ko":"목신 판의 피리","zh_hant":"牧神潘的潘笛"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4136,"skill_field_effect_id":173,"_id_":6267,"skill_options":[{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":548,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[197,210,220,230,240]}]},"6291":{"attribute_id":4,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Tango","ja":"魅了のタンゴ","ko":"매료의 탱고","zh_hant":"魅惑的探戈"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4153,"skill_field_effect_id":180,"_id_":6291,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6292":{"attribute_id":4,"cost":2,"icon_id":293,"is_multiple_command_unique_skill":0,"name":{"en":"La Caña of Sealing","ja":"封印のカーニャ","ko":"봉인의 카냐","zh_hant":"封印的坎亞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4154,"skill_field_effect_id":0,"_id_":6292,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":462,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":500,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":385,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]}]},"6293":{"attribute_id":4,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Solea of Freedom","ja":"自由のソレア","ko":"자유의 솔레아","zh_hant":"自由的孤調"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4155,"skill_field_effect_id":181,"_id_":6293,"skill_options":[{"id":488,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":499,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6294":{"attribute_id":4,"cost":2,"icon_id":284,"is_multiple_command_unique_skill":0,"name":{"en":"Red Passion Flamenco","ja":"紅き情熱のフラメンコ","ko":"붉은 열정의 플라멩코","zh_hant":"熱情如火的佛朗明哥"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4156,"skill_field_effect_id":182,"_id_":6294,"skill_options":[{"id":485,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":486,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":499,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6296":{"attribute_id":5,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4158,"skill_field_effect_id":183,"_id_":6296,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6297":{"attribute_id":5,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4159,"skill_field_effect_id":184,"_id_":6297,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6298":{"attribute_id":5,"cost":3,"icon_id":1069,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4160,"skill_field_effect_id":185,"_id_":6298,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6299":{"attribute_id":5,"cost":2,"icon_id":1069,"is_multiple_command_unique_skill":0,"name":{"en":"Macaron Dream Encore","ja":"マカロン・ドリーム Encore","ko":"마카롱 드림 Encore","zh_hant":"馬卡龍幻夢 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4161,"skill_field_effect_id":186,"_id_":6299,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6301":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Charm","ja":"魅了の一閃","ko":"매료의 일섬","zh_hant":"魅惑閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4163,"skill_field_effect_id":189,"_id_":6301,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6302":{"attribute_id":1,"cost":2,"icon_id":1036,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Arrest","ja":"捕縛の一閃","ko":"포박의 일섬","zh_hant":"綁縛閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4164,"skill_field_effect_id":190,"_id_":6302,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6303":{"attribute_id":1,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Swirling Flash","ja":"渦巻く一閃","ko":"소용돌이치는 일섬","zh_hant":"螺旋閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4165,"skill_field_effect_id":191,"_id_":6303,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6304":{"attribute_id":1,"cost":2,"icon_id":287,"is_multiple_command_unique_skill":0,"name":{"en":"Raise the Sails!","ja":"出航！宝船","ko":"출항! 보물선","zh_hant":"出航！寶船"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4166,"skill_field_effect_id":0,"_id_":6304,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":495,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":551,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6306":{"attribute_id":2,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Charm","ja":"魅了の一閃","ko":"매료의 일섬","zh_hant":"魅惑閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4168,"skill_field_effect_id":193,"_id_":6306,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6307":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Flash","ja":"甘美な一閃","ko":"감미로운 일섬","zh_hant":"甘美閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4169,"skill_field_effect_id":194,"_id_":6307,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6308":{"attribute_id":2,"cost":3,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Ovation","ja":"万雷の一閃","ko":"만뢰의 일섬","zh_hant":"萬雷閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4170,"skill_field_effect_id":195,"_id_":6308,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6309":{"attribute_id":2,"cost":2,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Pumpkin Trick Encore","ja":"パンプキントリック Encore","ko":"펌프킨 트릭 Encore","zh_hant":"南瓜戲法 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4171,"skill_field_effect_id":196,"_id_":6309,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6323":{"attribute_id":4,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Nightmare Slash","ja":"悪夢の斬撃","ko":"악몽의 참격","zh_hant":"惡夢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4184,"skill_field_effect_id":200,"_id_":6323,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":470,"hit_rate":100,"target_id":2051,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6324":{"attribute_id":4,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4185,"skill_field_effect_id":201,"_id_":6324,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6325":{"attribute_id":4,"cost":2,"icon_id":1057,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Vitality","ja":"活力の斬撃","ko":"활력의 참격","zh_hant":"活力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4186,"skill_field_effect_id":202,"_id_":6325,"skill_options":[{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]}]},"6326":{"attribute_id":4,"cost":2,"icon_id":1039,"is_multiple_command_unique_skill":1,"name":{"en":"Love Dripping Magic","ja":"滴る恋の魔法","ko":"싱그러운 사랑의 마법","zh_hant":"滴答的戀愛魔法"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4187,"skill_field_effect_id":203,"_id_":6326,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":548,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6328":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":6328,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6329":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":6329,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6330":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":6330,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6331":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":6331,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6332":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":6332,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6333":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":6333,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6334":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":6334,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6335":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":6335,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6336":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":6336,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6337":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":6337,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6338":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":6338,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6340":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":6340,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6341":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":6341,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6342":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":6342,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6343":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":6343,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6344":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":6344,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6345":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":6345,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6346":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":6346,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6347":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":6347,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6348":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":6348,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6349":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":6349,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6350":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":6350,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6352":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":6352,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6353":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":6353,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6354":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":6354,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6355":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":6355,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6356":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":6356,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6357":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":6357,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6358":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":6358,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6359":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":6359,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6360":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":6360,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6361":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":6361,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6362":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":6362,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6364":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":6364,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6365":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":6365,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6366":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":6366,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6367":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":6367,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6368":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":6368,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6369":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":6369,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6370":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":6370,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6371":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":6371,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6372":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":6372,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6373":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":6373,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6374":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":6374,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6376":{"attribute_id":2,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Smash","ja":"魅了の打撃","ko":"매료의 타격","zh_hant":"魅惑敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4189,"skill_field_effect_id":205,"_id_":6376,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6377":{"attribute_id":2,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Smash","ja":"重圧の打撃","ko":"중압의 타격","zh_hant":"重壓敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4190,"skill_field_effect_id":206,"_id_":6377,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6378":{"attribute_id":2,"cost":2,"icon_id":1057,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Vitality","ja":"活力の打撃","ko":"활력의 타격","zh_hant":"活力敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4191,"skill_field_effect_id":207,"_id_":6378,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6379":{"attribute_id":2,"cost":2,"icon_id":301,"is_multiple_command_unique_skill":1,"name":{"en":"End of the Dream","ja":"夢の終わりに","ko":"꿈의 끝으로","zh_hant":"夢想的終焉"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4192,"skill_field_effect_id":208,"_id_":6379,"skill_options":[{"id":557,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[1,1,1,1,1]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6381":{"attribute_id":5,"cost":1,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Smash","ja":"封印の打撃","ko":"봉인의 타격","zh_hant":"封印敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4194,"skill_field_effect_id":0,"_id_":6381,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6382":{"attribute_id":5,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4195,"skill_field_effect_id":211,"_id_":6382,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6383":{"attribute_id":5,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4196,"skill_field_effect_id":212,"_id_":6383,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6384":{"attribute_id":5,"cost":2,"icon_id":1071,"is_multiple_command_unique_skill":1,"name":{"en":"Torrent of Beauty","ja":"美しき奔流","ko":"아름다운 분류","zh_hant":"美麗激流"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4197,"skill_field_effect_id":213,"_id_":6384,"skill_options":[{"id":7,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":462,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":385,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[3000,3500,4000,4500,5000]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6386":{"attribute_id":9,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4199,"skill_field_effect_id":0,"_id_":6386,"skill_options":[{"id":447,"hit_rate":100,"target_id":1132,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6387":{"attribute_id":9,"cost":2,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Resolute Slash","ja":"覚悟の斬撃","ko":"각오의 참격","zh_hant":"覺悟斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4200,"skill_field_effect_id":216,"_id_":6387,"skill_options":[{"id":447,"hit_rate":100,"target_id":1132,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6388":{"attribute_id":9,"cost":2,"icon_id":1054,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4201,"skill_field_effect_id":217,"_id_":6388,"skill_options":[{"id":447,"hit_rate":100,"target_id":1132,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6389":{"attribute_id":9,"cost":1,"icon_id":1074,"is_multiple_command_unique_skill":0,"name":{"en":"Flowers of Evil","ja":"Flowers of Evil","ko":"Flowers of Evil","zh_hant":"Flowers of Evil"},"optional_description":{"en":"Guest Use: Aggro Not Applied","ja":"ゲスト使用時、ターゲット固定は適用外","ko":"게스트 사용 시, 타깃 고정은 적용되지 않음","zh_hant":"使用來賓時，目標鎖定無效"},"sequence_id":4202,"skill_field_effect_id":218,"_id_":6389,"skill_options":[{"id":448,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":8,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[225,234,243,252,270]},{"id":432,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6392":{"attribute_id":1,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4204,"skill_field_effect_id":221,"_id_":6392,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6393":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4205,"skill_field_effect_id":222,"_id_":6393,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6394":{"attribute_id":1,"cost":3,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4206,"skill_field_effect_id":223,"_id_":6394,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6395":{"attribute_id":1,"cost":2,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Inferno Shadow Art Encore","ja":"火影の術 Encore","ko":"화영의 술법 Encore","zh_hant":"火影之術 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4207,"skill_field_effect_id":224,"_id_":6395,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6397":{"attribute_id":6,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Slash","ja":"雷鳴の斬撃","ko":"천둥의 참격","zh_hant":"雷鳴斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4209,"skill_field_effect_id":226,"_id_":6397,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":565,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6398":{"attribute_id":6,"cost":2,"icon_id":1060,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4210,"skill_field_effect_id":227,"_id_":6398,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6399":{"attribute_id":6,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4211,"skill_field_effect_id":228,"_id_":6399,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":445,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6400":{"attribute_id":6,"cost":2,"icon_id":1075,"is_multiple_command_unique_skill":1,"name":{"en":"Toys - Psychokinesis","ja":"トイズ～サイコキネシス～","ko":"토이즈 ~사이코키네시스~","zh_hant":"TOYS～念動力～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4212,"skill_field_effect_id":229,"_id_":6400,"skill_options":[{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":31,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[500000,500000,500000,500000,500000]}]},"6402":{"attribute_id":1,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4219,"skill_field_effect_id":237,"_id_":6402,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":35,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":8,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6403":{"attribute_id":1,"cost":2,"icon_id":1046,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4220,"skill_field_effect_id":238,"_id_":6403,"skill_options":[{"id":8,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6404":{"attribute_id":1,"cost":2,"icon_id":1009,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4221,"skill_field_effect_id":239,"_id_":6404,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":22,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6405":{"attribute_id":1,"cost":2,"icon_id":194,"is_multiple_command_unique_skill":0,"name":{"en":"Toys - Tri-Ascend","ja":"トイズ～トライアセンド～","ko":"토이즈 ~트라이어센드~","zh_hant":"TOYS～三重上升～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4222,"skill_field_effect_id":240,"_id_":6405,"skill_options":[{"id":448,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":8,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":431,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"6407":{"attribute_id":5,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4214,"skill_field_effect_id":231,"_id_":6407,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6408":{"attribute_id":5,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Sharpshooting","ja":"魅了の狙撃","ko":"매료의 저격","zh_hant":"魅惑狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4215,"skill_field_effect_id":232,"_id_":6408,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":347,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6409":{"attribute_id":5,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Sharpshooting","ja":"雷鳴の狙撃","ko":"천둥의 저격","zh_hant":"雷鳴狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4216,"skill_field_effect_id":233,"_id_":6409,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6410":{"attribute_id":5,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":1,"name":{"en":"Toys - Hyper Sensitive","ja":"トイズ～ハイパーセンシティブ～","ko":"토이즈 ~하이퍼 센서티브~","zh_hant":"TOYS～五感強化～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4217,"skill_field_effect_id":234,"_id_":6410,"skill_options":[{"id":360,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6412":{"attribute_id":4,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4224,"skill_field_effect_id":244,"_id_":6412,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6413":{"attribute_id":4,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4225,"skill_field_effect_id":245,"_id_":6413,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6414":{"attribute_id":4,"cost":2,"icon_id":1039,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4226,"skill_field_effect_id":246,"_id_":6414,"skill_options":[{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":570,"hit_rate":100,"target_id":1701,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]}]},"6415":{"attribute_id":4,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Tornado of Beginning","ja":"はじまりの竜巻","ko":"시작의 회오리","zh_hant":"起始的龍捲風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4227,"skill_field_effect_id":247,"_id_":6415,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":551,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6417":{"attribute_id":6,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4229,"skill_field_effect_id":250,"_id_":6417,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6418":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4230,"skill_field_effect_id":251,"_id_":6418,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6419":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4231,"skill_field_effect_id":252,"_id_":6419,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6420":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Cross of Retribution Encore","ja":"聖罰の十字架 Encore","ko":"성벌의 십자가 Encore","zh_hant":"聖罰十字架 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4232,"skill_field_effect_id":253,"_id_":6420,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6422":{"attribute_id":7,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4234,"skill_field_effect_id":255,"_id_":6422,"skill_options":[{"id":444,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6423":{"attribute_id":7,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4235,"skill_field_effect_id":0,"_id_":6423,"skill_options":[{"id":36,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":231,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6424":{"attribute_id":7,"cost":2,"icon_id":1057,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Vitality","ja":"活力の斬撃","ko":"활력의 참격","zh_hant":"活力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4236,"skill_field_effect_id":256,"_id_":6424,"skill_options":[{"id":360,"hit_rate":100,"target_id":1132,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":259,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6425":{"attribute_id":7,"cost":2,"icon_id":1077,"is_multiple_command_unique_skill":1,"name":{"en":"Toys - Direct Hack","ja":"トイズ～ダイレクトハック～","ko":"토이즈 ~다이렉트 핵~","zh_hant":"TOYS～電子入侵～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4237,"skill_field_effect_id":257,"_id_":6425,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":571,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6439":{"attribute_id":8,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4250,"skill_field_effect_id":259,"_id_":6439,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6440":{"attribute_id":8,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4251,"skill_field_effect_id":260,"_id_":6440,"skill_options":[{"id":548,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":445,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6441":{"attribute_id":8,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Slash","ja":"吸収の斬撃","ko":"흡수의 참격","zh_hant":"吸收斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4252,"skill_field_effect_id":261,"_id_":6441,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6442":{"attribute_id":8,"cost":2,"icon_id":1056,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Beliefs","ja":"信念の照らすもの","ko":"신념을 비추는 것","zh_hant":"照亮信念者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4253,"skill_field_effect_id":262,"_id_":6442,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":480,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":477,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":86,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"6459":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Flash","ja":"輝く一閃","ko":"반짝이는 일섬","zh_hant":"輝耀閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4263,"skill_field_effect_id":265,"_id_":6459,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6460":{"attribute_id":1,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Charm","ja":"魅了の一閃","ko":"매료의 일섬","zh_hant":"魅惑閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4264,"skill_field_effect_id":266,"_id_":6460,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":251,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6461":{"attribute_id":1,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Flash","ja":"封印の一閃","ko":"봉인의 일섬","zh_hant":"封印閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4265,"skill_field_effect_id":267,"_id_":6461,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":252,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6462":{"attribute_id":1,"cost":2,"icon_id":1079,"is_multiple_command_unique_skill":0,"name":{"en":"Snow Footprints","ja":"雪の足跡","ko":"눈의 발자취","zh_hant":"雪的腳印"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4266,"skill_field_effect_id":268,"_id_":6462,"skill_options":[{"id":156,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6464":{"attribute_id":3,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Charm","ja":"魅了の一閃","ko":"매료의 일섬","zh_hant":"魅惑閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4268,"skill_field_effect_id":271,"_id_":6464,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6465":{"attribute_id":3,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Flash","ja":"甘美な一閃","ko":"감미로운 일섬","zh_hant":"甘美閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4269,"skill_field_effect_id":272,"_id_":6465,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6466":{"attribute_id":3,"cost":2,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Ovation","ja":"万雷の一閃","ko":"만뢰의 일섬","zh_hant":"萬雷閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4270,"skill_field_effect_id":273,"_id_":6466,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6467":{"attribute_id":3,"cost":2,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Fuoco! Encore","ja":"Fuoco! Encore","ko":"Fuoco! Encore","zh_hant":"Fuoco! Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4271,"skill_field_effect_id":274,"_id_":6467,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6469":{"attribute_id":1,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4273,"skill_field_effect_id":276,"_id_":6469,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6470":{"attribute_id":1,"cost":2,"icon_id":1071,"is_multiple_command_unique_skill":0,"name":{"en":"Elegant Slash","ja":"風雅な斬撃","ko":"고상한 참격","zh_hant":"文雅斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4274,"skill_field_effect_id":277,"_id_":6470,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6471":{"attribute_id":1,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Slash","ja":"灰色の斬撃","ko":"잿빛의 참격","zh_hant":"灰色斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4275,"skill_field_effect_id":278,"_id_":6471,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6472":{"attribute_id":1,"cost":2,"icon_id":1078,"is_multiple_command_unique_skill":1,"name":{"en":"Pisces' Bubbles","ja":"双魚の水沫","ko":"쌍어의 물보라","zh_hant":"雙魚的水花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4276,"skill_field_effect_id":279,"_id_":6472,"skill_options":[{"id":29,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":123,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6478":{"attribute_id":1,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Dynamic Strike","ja":"豪快な一撃","ko":"호쾌한 일격","zh_hant":"豪爽一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4278,"skill_field_effect_id":282,"_id_":6478,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6479":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Hope","ja":"希望の一撃","ko":"희망의 일격","zh_hant":"希望一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4279,"skill_field_effect_id":283,"_id_":6479,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":462,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6480":{"attribute_id":1,"cost":2,"icon_id":313,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Strike","ja":"猛攻の一撃","ko":"맹공의 일격","zh_hant":"猛攻一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4280,"skill_field_effect_id":284,"_id_":6480,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":580,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,22,24,27,30]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6481":{"attribute_id":1,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Passion","ja":"情熱の照らすもの","ko":"정열을 비추는 것","zh_hant":"照亮熱情者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4281,"skill_field_effect_id":285,"_id_":6481,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":391,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6483":{"attribute_id":6,"cost":2,"icon_id":293,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4283,"skill_field_effect_id":288,"_id_":6483,"skill_options":[{"id":500,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6484":{"attribute_id":6,"cost":2,"icon_id":314,"is_multiple_command_unique_skill":0,"name":{"en":"Cursed Slash","ja":"呪いの斬撃","ko":"저주의 참격","zh_hant":"詛咒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4284,"skill_field_effect_id":289,"_id_":6484,"skill_options":[{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":251,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6485":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4285,"skill_field_effect_id":290,"_id_":6485,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":252,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6486":{"attribute_id":6,"cost":2,"icon_id":284,"is_multiple_command_unique_skill":0,"name":{"en":"Myriad of Flowers","ja":"百花斉放、華うらら","ko":"백화제방, 화려한 꽃","zh_hant":"百花爭妍、萬紫千紅"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4286,"skill_field_effect_id":291,"_id_":6486,"skill_options":[{"id":485,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":486,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6488":{"attribute_id":4,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4288,"skill_field_effect_id":293,"_id_":6488,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6489":{"attribute_id":4,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4289,"skill_field_effect_id":294,"_id_":6489,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6490":{"attribute_id":4,"cost":2,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4290,"skill_field_effect_id":295,"_id_":6490,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6491":{"attribute_id":4,"cost":2,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Peach Oath Encore","ja":"桃園の誓い Encore","ko":"도원의 맹세 Encore","zh_hant":"桃園三結義 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4291,"skill_field_effect_id":296,"_id_":6491,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6493":{"attribute_id":4,"cost":1,"icon_id":305,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Slash","ja":"反攻の斬撃","ko":"반격의 참격","zh_hant":"反攻斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4293,"skill_field_effect_id":300,"_id_":6493,"skill_options":[{"id":565,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6494":{"attribute_id":4,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4294,"skill_field_effect_id":301,"_id_":6494,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6495":{"attribute_id":4,"cost":2,"icon_id":306,"is_multiple_command_unique_skill":0,"name":{"en":"Dynamic Slash","ja":"豪快な斬撃","ko":"호쾌한 참격","zh_hant":"豪爽斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4295,"skill_field_effect_id":302,"_id_":6495,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":445,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6496":{"attribute_id":4,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliance of Guidance","ja":"導きのキラめき","ko":"인도의 반짝임","zh_hant":"引導的光芒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4296,"skill_field_effect_id":303,"_id_":6496,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":462,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6498":{"attribute_id":2,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Flash","ja":"灰色の一閃","ko":"잿빛의 일섬","zh_hant":"灰色閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4298,"skill_field_effect_id":306,"_id_":6498,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6499":{"attribute_id":2,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Swirling Flash","ja":"渦巻く一閃","ko":"소용돌이치는 일섬","zh_hant":"螺旋閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4299,"skill_field_effect_id":307,"_id_":6499,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6500":{"attribute_id":2,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Support","ja":"支援の一閃","ko":"지원의 일섬","zh_hant":"支援閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4300,"skill_field_effect_id":308,"_id_":6500,"skill_options":[{"id":570,"hit_rate":100,"target_id":1701,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6501":{"attribute_id":2,"cost":2,"icon_id":1081,"is_multiple_command_unique_skill":0,"name":{"en":"Absurd Joke","ja":"不条理な戯れ","ko":"부조리한 장난","zh_hant":"荒誕的打鬧"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4301,"skill_field_effect_id":309,"_id_":6501,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6503":{"attribute_id":6,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Flash","ja":"軽快な一閃","ko":"경쾌한 일섬","zh_hant":"輕快閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4303,"skill_field_effect_id":312,"_id_":6503,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6504":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Flash","ja":"甘美な一閃","ko":"감미로운 일섬","zh_hant":"甘美閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4304,"skill_field_effect_id":313,"_id_":6504,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6505":{"attribute_id":6,"cost":3,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Ovation","ja":"万雷の一閃","ko":"만뢰의 일섬","zh_hant":"萬雷閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4305,"skill_field_effect_id":314,"_id_":6505,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6506":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Hop Hip★ Attack Encore","ja":"ホップヒップ★アタック Encore","ko":"합힙★어택 Encore","zh_hant":"躍進★攻擊 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4306,"skill_field_effect_id":315,"_id_":6506,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6520":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":6520,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6521":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":6521,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6522":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":6522,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6523":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":6523,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6524":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":6524,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6525":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":6525,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6526":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":6526,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6527":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":6527,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6528":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":6528,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6529":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":6529,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6530":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":6530,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6532":{"attribute_id":9,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Slash","ja":"雷鳴の斬撃","ko":"천둥의 참격","zh_hant":"雷鳴斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4308,"skill_field_effect_id":317,"_id_":6532,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6533":{"attribute_id":9,"cost":2,"icon_id":1044,"is_multiple_command_unique_skill":0,"name":{"en":"Charming Slash","ja":"魅了の斬撃","ko":"매료의 참격","zh_hant":"魅惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4309,"skill_field_effect_id":318,"_id_":6533,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6534":{"attribute_id":9,"cost":2,"icon_id":1054,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4310,"skill_field_effect_id":319,"_id_":6534,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2051,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6535":{"attribute_id":9,"cost":2,"icon_id":298,"is_multiple_command_unique_skill":0,"name":{"en":"Noble Baumkuchen","ja":"高貴なるバウムクーヘン","ko":"고귀한 바움쿠헨","zh_hant":"高貴的年輪蛋糕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4311,"skill_field_effect_id":320,"_id_":6535,"skill_options":[{"id":512,"hit_rate":100,"target_id":4157,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":123,"hit_rate":100,"target_id":4157,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":393,"hit_rate":100,"target_id":6010,"times":[10,10,10,10,10],"values":[450,460,470,480,500]}]},"6537":{"attribute_id":4,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4324,"skill_field_effect_id":323,"_id_":6537,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6538":{"attribute_id":4,"cost":2,"icon_id":1071,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4325,"skill_field_effect_id":324,"_id_":6538,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6539":{"attribute_id":4,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Slash","ja":"苦悶の斬撃","ko":"고민의 참격","zh_hant":"苦悶斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4326,"skill_field_effect_id":325,"_id_":6539,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6540":{"attribute_id":4,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":1,"name":{"en":"Dreaming Sheep","ja":"Dreaming sheep","ko":"Dreaming sheep","zh_hant":"Dreaming sheep"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4327,"skill_field_effect_id":326,"_id_":6540,"skill_options":[{"id":29,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":580,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6542":{"attribute_id":3,"cost":1,"icon_id":3001,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Smash","ja":"反撃の打撃","ko":"반격의 타격","zh_hant":"反擊敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4329,"skill_field_effect_id":329,"_id_":6542,"skill_options":[{"id":565,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6543":{"attribute_id":3,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Smash","ja":"重圧の打撃","ko":"중압의 타격","zh_hant":"重壓敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4330,"skill_field_effect_id":330,"_id_":6543,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6544":{"attribute_id":3,"cost":2,"icon_id":178,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Smash","ja":"封印の打撃","ko":"봉인의 타격","zh_hant":"封印敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4331,"skill_field_effect_id":331,"_id_":6544,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":251,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":252,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6545":{"attribute_id":3,"cost":2,"icon_id":321,"is_multiple_command_unique_skill":0,"name":{"en":"Blessed Wind","ja":"祝福の南風","ko":"축복의 남풍","zh_hant":"祝福之南風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4332,"skill_field_effect_id":332,"_id_":6545,"skill_options":[{"id":156,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6547":{"attribute_id":2,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4334,"skill_field_effect_id":335,"_id_":6547,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6548":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Smash","ja":"甘美な打撃","ko":"감미로운 타격","zh_hant":"甘美敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4335,"skill_field_effect_id":336,"_id_":6548,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6549":{"attribute_id":2,"cost":2,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Ovation","ja":"万雷の打撃","ko":"만뢰의 타격","zh_hant":"萬雷敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4336,"skill_field_effect_id":337,"_id_":6549,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6550":{"attribute_id":2,"cost":2,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Raise the Flag! Encore","ja":"旗揚げ号令！ Encore","ko":"깃발 들기 호령! Encore","zh_hant":"舉旗號令！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4337,"skill_field_effect_id":338,"_id_":6550,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6552":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Thrust","ja":"軽快な刺突","ko":"경쾌한 찌르기","zh_hant":"輕快突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4339,"skill_field_effect_id":340,"_id_":6552,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6553":{"attribute_id":4,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4340,"skill_field_effect_id":341,"_id_":6553,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6554":{"attribute_id":4,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Thrust","ja":"雷鳴の刺突","ko":"천둥의 찌르기","zh_hant":"雷鳴突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4341,"skill_field_effect_id":342,"_id_":6554,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6555":{"attribute_id":4,"cost":2,"icon_id":316,"is_multiple_command_unique_skill":1,"name":{"en":"Snow Melting Encore","ja":"雪解 Encore","ko":"눈석임 Encore","zh_hant":"融雪 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4342,"skill_field_effect_id":343,"_id_":6555,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":392,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":363,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6557":{"attribute_id":8,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4344,"skill_field_effect_id":346,"_id_":6557,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6558":{"attribute_id":8,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4345,"skill_field_effect_id":347,"_id_":6558,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6559":{"attribute_id":8,"cost":3,"icon_id":1083,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Applauses","ja":"喝采の斬撃","ko":"갈채의 참격","zh_hant":"喝采斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4346,"skill_field_effect_id":348,"_id_":6559,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6560":{"attribute_id":8,"cost":2,"icon_id":1083,"is_multiple_command_unique_skill":0,"name":{"en":"Justice Blitz Encore","ja":"正義の雷光 Encore","ko":"정의의 번개 Encore","zh_hant":"正義的雷光 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4347,"skill_field_effect_id":349,"_id_":6560,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6562":{"attribute_id":3,"cost":1,"icon_id":3001,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Strike","ja":"反攻の一撃","ko":"반격의 일격","zh_hant":"反攻一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4349,"skill_field_effect_id":351,"_id_":6562,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6563":{"attribute_id":3,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Strike","ja":"重圧の一撃","ko":"중압의 일격","zh_hant":"重壓一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4350,"skill_field_effect_id":352,"_id_":6563,"skill_options":[{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6564":{"attribute_id":3,"cost":2,"icon_id":1056,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Strike","ja":"苦悶の一撃","ko":"고민의 일격","zh_hant":"苦悶一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4351,"skill_field_effect_id":353,"_id_":6564,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6565":{"attribute_id":3,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Aggressive Coyote Encore","ja":"牙剝くコヨーテ Encore","ko":"사나운 코요테 Encore","zh_hant":"露出獠牙的郊狼 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4352,"skill_field_effect_id":354,"_id_":6565,"skill_options":[{"id":123,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6567":{"attribute_id":6,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Slash","ja":"灰色の斬撃","ko":"잿빛의 참격","zh_hant":"灰色斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4354,"skill_field_effect_id":357,"_id_":6567,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6568":{"attribute_id":6,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Profuse Slash","ja":"繚乱の斬撃","ko":"요란의 참격","zh_hant":"繚亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4355,"skill_field_effect_id":358,"_id_":6568,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6569":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Applauses","ja":"喝采の斬撃","ko":"갈채의 참격","zh_hant":"喝采斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4356,"skill_field_effect_id":359,"_id_":6569,"skill_options":[{"id":570,"hit_rate":100,"target_id":1701,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6570":{"attribute_id":6,"cost":2,"icon_id":1072,"is_multiple_command_unique_skill":0,"name":{"en":"Spark That Illuminates the Truth","ja":"真実を照らし出す、一筋の閃き","ko":"진실을 비추는 한 줄기의 섬광","zh_hant":"點亮真相的一閃"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4357,"skill_field_effect_id":360,"_id_":6570,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6572":{"attribute_id":3,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4359,"skill_field_effect_id":363,"_id_":6572,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6573":{"attribute_id":3,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4360,"skill_field_effect_id":364,"_id_":6573,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6574":{"attribute_id":3,"cost":3,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4361,"skill_field_effect_id":365,"_id_":6574,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6575":{"attribute_id":3,"cost":2,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Fan Rosette Encore","ja":"扇の花結び Encore","ko":"부채 꽃매듭 Encore","zh_hant":"花結之扇 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4362,"skill_field_effect_id":366,"_id_":6575,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6629":{"attribute_id":9,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Flash","ja":"雷鳴の一閃","ko":"천둥의 일섬","zh_hant":"雷鳴閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4375,"skill_field_effect_id":376,"_id_":6629,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6630":{"attribute_id":9,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Flash","ja":"輝く一閃","ko":"반짝이는 일섬","zh_hant":"輝耀閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4376,"skill_field_effect_id":377,"_id_":6630,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6631":{"attribute_id":9,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Flash","ja":"苦悶の一閃","ko":"고민의 일섬","zh_hant":"苦悶閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4377,"skill_field_effect_id":378,"_id_":6631,"skill_options":[{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6632":{"attribute_id":9,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":1,"name":{"en":"Sea God's Majesty","ja":"海神の威","ko":"해신의 위엄","zh_hant":"海神之威"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4378,"skill_field_effect_id":379,"_id_":6632,"skill_options":[{"id":595,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[250,260,270,280,300]}]},"6634":{"attribute_id":8,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Slash","ja":"雷鳴の斬撃","ko":"천둥의 참격","zh_hant":"雷鳴斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4380,"skill_field_effect_id":382,"_id_":6634,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6635":{"attribute_id":8,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4381,"skill_field_effect_id":383,"_id_":6635,"skill_options":[{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6636":{"attribute_id":8,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Slash","ja":"苦悶の斬撃","ko":"고민의 참격","zh_hant":"苦悶斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4382,"skill_field_effect_id":384,"_id_":6636,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":1,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6637":{"attribute_id":8,"cost":2,"icon_id":324,"is_multiple_command_unique_skill":1,"name":{"en":"Cup of Paradise","ja":"極楽の盞","ko":"극락의 술잔","zh_hant":"極樂杯盞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4383,"skill_field_effect_id":385,"_id_":6637,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":596,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[250,260,270,280,300]}]},"6654":{"attribute_id":2,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Slash","ja":"雷鳴の斬撃","ko":"천둥의 참격","zh_hant":"雷鳴斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4389,"skill_field_effect_id":388,"_id_":6654,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":565,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6655":{"attribute_id":2,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4390,"skill_field_effect_id":389,"_id_":6655,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6656":{"attribute_id":2,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Slash","ja":"苦悶の斬撃","ko":"고민의 참격","zh_hant":"苦悶斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4391,"skill_field_effect_id":390,"_id_":6656,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6657":{"attribute_id":2,"cost":2,"icon_id":1085,"is_multiple_command_unique_skill":1,"name":{"en":"Charging Ahead in a Starry Night","ja":"星夜の猛進","ko":"성야의 맹진","zh_hant":"星夜突進"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4392,"skill_field_effect_id":391,"_id_":6657,"skill_options":[{"id":29,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":88,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6659":{"attribute_id":8,"cost":1,"icon_id":152,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Slash","ja":"守護の斬撃","ko":"수호의 참격","zh_hant":"守護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4394,"skill_field_effect_id":394,"_id_":6659,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6660":{"attribute_id":8,"cost":1,"icon_id":1083,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Applauses","ja":"喝采の斬撃","ko":"갈채의 참격","zh_hant":"喝采斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4395,"skill_field_effect_id":395,"_id_":6660,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":152,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6661":{"attribute_id":8,"cost":1,"icon_id":1074,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Control","ja":"支配の斬撃","ko":"지배의 참격","zh_hant":"支配斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4396,"skill_field_effect_id":396,"_id_":6661,"skill_options":[{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":152,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6662":{"attribute_id":8,"cost":1,"icon_id":1079,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope Encore","ja":"希望の乱舞 Encore","ko":"희망의 난무 Encore","zh_hant":"希望亂舞 Encore"},"optional_description":{"en":"Guest Use: Aggro Not Applied","ja":"ゲスト使用時、ターゲット固定は適用外","ko":"게스트 사용 시, 타깃 고정은 적용되지 않음","zh_hant":"使用來賓時，目標鎖定無效"},"sequence_id":4397,"skill_field_effect_id":397,"_id_":6662,"skill_options":[{"id":448,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":448,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":432,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6674":{"attribute_id":2,"cost":1,"icon_id":3004,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Smash","ja":"反射の打撃","ko":"반사의 타격","zh_hant":"反射敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4399,"skill_field_effect_id":400,"_id_":6674,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6675":{"attribute_id":2,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Smash","ja":"重圧の打撃","ko":"중압의 타격","zh_hant":"重壓敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4400,"skill_field_effect_id":401,"_id_":6675,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6676":{"attribute_id":2,"cost":2,"icon_id":314,"is_multiple_command_unique_skill":0,"name":{"en":"Demolition Strike","ja":"解体の打撃","ko":"해체의 타격","zh_hant":"解體敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4401,"skill_field_effect_id":402,"_id_":6676,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6677":{"attribute_id":2,"cost":2,"icon_id":45,"is_multiple_command_unique_skill":0,"name":{"en":"Love Heart Impact","ja":"ラブハート・インパクト","ko":"러브 하트 임팩트","zh_hant":"愛心衝擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4402,"skill_field_effect_id":403,"_id_":6677,"skill_options":[{"id":241,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6679":{"attribute_id":5,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4404,"skill_field_effect_id":407,"_id_":6679,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6680":{"attribute_id":5,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Smash","ja":"甘美な打撃","ko":"감미로운 타격","zh_hant":"甘美敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4405,"skill_field_effect_id":408,"_id_":6680,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6681":{"attribute_id":5,"cost":3,"icon_id":1069,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Ovation","ja":"万雷の打撃","ko":"만뢰의 타격","zh_hant":"萬雷敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4406,"skill_field_effect_id":409,"_id_":6681,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6682":{"attribute_id":5,"cost":2,"icon_id":1069,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Crime at Night Encore","ja":"闇夜の完全犯罪 Encore","ko":"암야의 완전범죄 Encore","zh_hant":"暗夜的完美犯罪 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4407,"skill_field_effect_id":410,"_id_":6682,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6684":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Thrust","ja":"甘美な刺突","ko":"감미로운 찌르기","zh_hant":"甘美突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4409,"skill_field_effect_id":412,"_id_":6684,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":367,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6685":{"attribute_id":2,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4410,"skill_field_effect_id":413,"_id_":6685,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":367,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6686":{"attribute_id":2,"cost":2,"icon_id":1037,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Applauses","ja":"喝采の刺突","ko":"갈채의 찌르기","zh_hant":"喝采突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4411,"skill_field_effect_id":414,"_id_":6686,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":471,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":367,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6687":{"attribute_id":2,"cost":2,"icon_id":1087,"is_multiple_command_unique_skill":1,"name":{"en":"Oni's Fist Encore","ja":"鬼の鉄拳 Encore","ko":"악마의 철권 Encore","zh_hant":"鬼之鐵拳 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4412,"skill_field_effect_id":415,"_id_":6687,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":367,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6689":{"attribute_id":1,"cost":1,"icon_id":3003,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4414,"skill_field_effect_id":418,"_id_":6689,"skill_options":[{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6690":{"attribute_id":1,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4415,"skill_field_effect_id":419,"_id_":6690,"skill_options":[{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6691":{"attribute_id":1,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4416,"skill_field_effect_id":420,"_id_":6691,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":463,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6692":{"attribute_id":1,"cost":2,"icon_id":1089,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Pride","ja":"誇りの照らすもの","ko":"긍지가 비추는 것","zh_hant":"照亮榮耀者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4417,"skill_field_effect_id":421,"_id_":6692,"skill_options":[{"id":123,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6694":{"attribute_id":5,"cost":1,"icon_id":3005,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4419,"skill_field_effect_id":424,"_id_":6694,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6695":{"attribute_id":5,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4420,"skill_field_effect_id":425,"_id_":6695,"skill_options":[{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6696":{"attribute_id":5,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4421,"skill_field_effect_id":426,"_id_":6696,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6697":{"attribute_id":5,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Hope","ja":"希望の照らすもの","ko":"희망이 비추는 것","zh_hant":"照亮希望者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4422,"skill_field_effect_id":427,"_id_":6697,"skill_options":[{"id":595,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6700":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":6700,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6701":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":6701,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6702":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":6702,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6703":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":6703,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6704":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":6704,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6705":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":6705,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6706":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":6706,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6707":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":6707,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6709":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":6709,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6710":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":6710,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6711":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":6711,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6712":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":6712,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6713":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":6713,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6714":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":6714,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6715":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":6715,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6716":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":6716,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6717":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":6717,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6719":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":6719,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6720":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":6720,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6721":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":6721,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6722":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":6722,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6723":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":6723,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6724":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":6724,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6725":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":6725,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6726":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":6726,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6727":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":6727,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6729":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":0,"_id_":6729,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6730":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":0,"_id_":6730,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6731":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":0,"_id_":6731,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6732":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":0,"_id_":6732,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6733":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":0,"_id_":6733,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6734":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":0,"_id_":6734,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":259,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"6735":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":0,"_id_":6735,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6736":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2703,"skill_field_effect_id":0,"_id_":6736,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6737":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2704,"skill_field_effect_id":0,"_id_":6737,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":58,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6739":{"attribute_id":3,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Support","ja":"支援の打撃","ko":"지원의 타격","zh_hant":"支援敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4424,"skill_field_effect_id":430,"_id_":6739,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6740":{"attribute_id":3,"cost":2,"icon_id":39,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4425,"skill_field_effect_id":431,"_id_":6740,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6741":{"attribute_id":3,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Smash","ja":"増強の打撃","ko":"증강의 타격","zh_hant":"增強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4426,"skill_field_effect_id":432,"_id_":6741,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6742":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Mission","ja":"パーフェクト・ミッション","ko":"퍼펙트 미션","zh_hant":"完美任務"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4427,"skill_field_effect_id":433,"_id_":6742,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6756":{"attribute_id":1,"cost":1,"icon_id":3004,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4429,"skill_field_effect_id":436,"_id_":6756,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6757":{"attribute_id":1,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4430,"skill_field_effect_id":437,"_id_":6757,"skill_options":[{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6758":{"attribute_id":1,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4431,"skill_field_effect_id":438,"_id_":6758,"skill_options":[{"id":440,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":234,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6759":{"attribute_id":1,"cost":2,"icon_id":1049,"is_multiple_command_unique_skill":1,"name":{"en":"Purge Blade Encore","ja":"粛清の刃 Encore","ko":"숙청의 칼날 Encore","zh_hant":"肅清之刃 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4432,"skill_field_effect_id":439,"_id_":6759,"skill_options":[{"id":444,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":234,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6761":{"attribute_id":3,"cost":1,"icon_id":3005,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Sharpshooting","ja":"反射の狙撃","ko":"반사의 저격","zh_hant":"反射狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4434,"skill_field_effect_id":442,"_id_":6761,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6762":{"attribute_id":3,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Sharpshooting","ja":"重圧の狙撃","ko":"중압의 저격","zh_hant":"重壓狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4435,"skill_field_effect_id":443,"_id_":6762,"skill_options":[{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6763":{"attribute_id":3,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Support Shooting","ja":"援護射撃","ko":"엄호사격","zh_hant":"掩護射擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4436,"skill_field_effect_id":444,"_id_":6763,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6764":{"attribute_id":3,"cost":2,"icon_id":1088,"is_multiple_command_unique_skill":0,"name":{"en":"Longing for the Outside World","ja":"広がる世界への憧憬","ko":"펼쳐지는 세계에 대한 동경","zh_hant":"對廣闊世界的憧憬"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4437,"skill_field_effect_id":445,"_id_":6764,"skill_options":[{"id":596,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6766":{"attribute_id":4,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Sharpshooting","ja":"軽快な狙撃","ko":"경쾌한 저격","zh_hant":"輕快狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4439,"skill_field_effect_id":448,"_id_":6766,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6767":{"attribute_id":4,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Sharpshooting","ja":"甘美な狙撃","ko":"감미로운 저격","zh_hant":"甘美狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4440,"skill_field_effect_id":449,"_id_":6767,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6768":{"attribute_id":4,"cost":3,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Ovation","ja":"万雷の狙撃","ko":"만뢰의 저격","zh_hant":"萬雷狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4441,"skill_field_effect_id":450,"_id_":6768,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6769":{"attribute_id":4,"cost":2,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! Encore","ja":"Eat me！ Encore","ko":"Eat me! Encore","zh_hant":"Eat me！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4442,"skill_field_effect_id":451,"_id_":6769,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6771":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":6771,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6772":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":6772,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6773":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":6773,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6774":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":6774,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6775":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":6775,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6776":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":6776,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6777":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":6777,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6778":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":6778,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6779":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":6779,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6780":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":6780,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6782":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":6782,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6783":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":6783,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"6784":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":6784,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6785":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":6785,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6786":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":6786,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6787":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":6787,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6788":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":6788,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6789":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":6789,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6790":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":6790,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6791":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":6791,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6792":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":6792,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6794":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":6794,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6795":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":6795,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6796":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":6796,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6797":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":6797,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6798":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":6798,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6799":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":6799,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6800":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":6800,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6801":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":6801,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6802":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":6802,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6803":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":6803,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6804":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":6804,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6806":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":0,"_id_":6806,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6807":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":0,"_id_":6807,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6808":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":0,"_id_":6808,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6809":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":0,"_id_":6809,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6810":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":0,"_id_":6810,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6811":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":0,"_id_":6811,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6812":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":0,"_id_":6812,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6813":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3321,"skill_field_effect_id":0,"_id_":6813,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6814":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":0,"_id_":6814,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6815":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":0,"_id_":6815,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6816":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3324,"skill_field_effect_id":0,"_id_":6816,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"6828":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Strike","ja":"輝く一撃","ko":"반짝이는 일격","zh_hant":"輝耀一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4448,"skill_field_effect_id":453,"_id_":6828,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6829":{"attribute_id":6,"cost":2,"icon_id":318,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4449,"skill_field_effect_id":454,"_id_":6829,"skill_options":[{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6830":{"attribute_id":6,"cost":2,"icon_id":242,"is_multiple_command_unique_skill":0,"name":{"en":"Anguish Strike","ja":"苦悶の一撃","ko":"고민의 일격","zh_hant":"苦悶一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4450,"skill_field_effect_id":455,"_id_":6830,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6831":{"attribute_id":6,"cost":2,"icon_id":248,"is_multiple_command_unique_skill":1,"name":{"en":"Twin Stars","ja":"ふたつの明星","ko":"두 개의 샛별","zh_hant":"兩顆明星"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4451,"skill_field_effect_id":456,"_id_":6831,"skill_options":[{"id":29,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":442,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6833":{"attribute_id":5,"cost":1,"icon_id":325,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Strike","ja":"堅守の一撃","ko":"굳은 수호의 일격","zh_hant":"堅守一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4453,"skill_field_effect_id":459,"_id_":6833,"skill_options":[{"id":598,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6834":{"attribute_id":5,"cost":2,"icon_id":314,"is_multiple_command_unique_skill":0,"name":{"en":"Obstructing Strike","ja":"阻害の一撃","ko":"방해의 일격","zh_hant":"妨礙一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4454,"skill_field_effect_id":460,"_id_":6834,"skill_options":[{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6835":{"attribute_id":5,"cost":2,"icon_id":58,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsiness Strike","ja":"睡魔の一撃","ko":"수마의 일격","zh_hant":"睡魔一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4455,"skill_field_effect_id":461,"_id_":6835,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":58,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6836":{"attribute_id":5,"cost":2,"icon_id":297,"is_multiple_command_unique_skill":0,"name":{"en":"The Freed Shadow","ja":"解放されし影","ko":"해방된 그림자","zh_hant":"被解放的影子"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4456,"skill_field_effect_id":462,"_id_":6836,"skill_options":[{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":22002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6838":{"attribute_id":1,"cost":2,"icon_id":1022,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4458,"skill_field_effect_id":465,"_id_":6838,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6839":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Strike","ja":"甘美な一撃","ko":"감미로운 일격","zh_hant":"甘美一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4459,"skill_field_effect_id":466,"_id_":6839,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6840":{"attribute_id":1,"cost":3,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Ovation","ja":"万雷の一撃","ko":"만뢰의 일격","zh_hant":"萬雷一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4460,"skill_field_effect_id":467,"_id_":6840,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6841":{"attribute_id":1,"cost":2,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Help Me, Wolf! Encore","ja":"助けて！オオカミさん Encore","ko":"늑대야, 살려 줘! Encore","zh_hant":"救救我！大野狼先生 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4461,"skill_field_effect_id":468,"_id_":6841,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6843":{"attribute_id":9,"cost":1,"icon_id":3005,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4463,"skill_field_effect_id":474,"_id_":6843,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6844":{"attribute_id":9,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Slash","ja":"灰色の斬撃","ko":"잿빛의 참격","zh_hant":"灰色斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4464,"skill_field_effect_id":475,"_id_":6844,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":463,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6845":{"attribute_id":9,"cost":2,"icon_id":271,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4465,"skill_field_effect_id":476,"_id_":6845,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":464,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":608,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6846":{"attribute_id":9,"cost":2,"icon_id":332,"is_multiple_command_unique_skill":1,"name":{"en":"Strongest Music - Key.","ja":"最強の音楽～Key.～","ko":"최강의 음악 ~Key.~","zh_hant":"最強音樂～Key.～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4466,"skill_field_effect_id":477,"_id_":6846,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":502,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":608,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6848":{"attribute_id":1,"cost":1,"icon_id":3005,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4468,"skill_field_effect_id":478,"_id_":6848,"skill_options":[{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6849":{"attribute_id":1,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Slash","ja":"灰色の斬撃","ko":"잿빛의 참격","zh_hant":"灰色斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4469,"skill_field_effect_id":479,"_id_":6849,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6850":{"attribute_id":1,"cost":2,"icon_id":173,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4470,"skill_field_effect_id":480,"_id_":6850,"skill_options":[{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":607,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6851":{"attribute_id":1,"cost":2,"icon_id":331,"is_multiple_command_unique_skill":1,"name":{"en":"Strongest Music - DJ","ja":"最強の音楽～DJ～","ko":"최강의 음악 ~DJ~","zh_hant":"最強音樂～DJ～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4471,"skill_field_effect_id":481,"_id_":6851,"skill_options":[{"id":595,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":607,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6853":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Flash","ja":"甘美な一閃","ko":"감미로운 일섬","zh_hant":"甘美閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4473,"skill_field_effect_id":482,"_id_":6853,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6854":{"attribute_id":6,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Flash","ja":"灰色の一閃","ko":"잿빛의 일섬","zh_hant":"灰色閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4474,"skill_field_effect_id":483,"_id_":6854,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6855":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Applauses","ja":"喝采の一閃","ko":"갈채의 일섬","zh_hant":"喝采閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4475,"skill_field_effect_id":484,"_id_":6855,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6856":{"attribute_id":6,"cost":2,"icon_id":316,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Courage","ja":"勇気の照らすもの","ko":"용기가 비추는 것","zh_hant":"照亮勇氣者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4476,"skill_field_effect_id":485,"_id_":6856,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":364,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6858":{"attribute_id":5,"cost":1,"icon_id":3004,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4478,"skill_field_effect_id":486,"_id_":6858,"skill_options":[{"id":591,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6859":{"attribute_id":5,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Slash","ja":"灰色の斬撃","ko":"잿빛의 참격","zh_hant":"灰色斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4479,"skill_field_effect_id":487,"_id_":6859,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6860":{"attribute_id":5,"cost":2,"icon_id":321,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Reduction","ja":"減少の斬撃","ko":"감소의 참격","zh_hant":"降低斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4480,"skill_field_effect_id":488,"_id_":6860,"skill_options":[{"id":454,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":590,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":350,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6861":{"attribute_id":5,"cost":1,"icon_id":318,"is_multiple_command_unique_skill":1,"name":{"en":"Wonderland Time Limit","ja":"不思議の国のタイムリミット","ko":"이상한 나라의 타임리밋","zh_hant":"仙境的時限"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4481,"skill_field_effect_id":489,"_id_":6861,"skill_options":[{"id":606,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6863":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4483,"skill_field_effect_id":490,"_id_":6863,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6864":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4484,"skill_field_effect_id":491,"_id_":6864,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6865":{"attribute_id":6,"cost":3,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4485,"skill_field_effect_id":492,"_id_":6865,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6866":{"attribute_id":6,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Sacrifice Chain Encore","ja":"生贄の鎖 Encore","ko":"제물의 사슬 Encore","zh_hant":"祭品之鎖 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4486,"skill_field_effect_id":493,"_id_":6866,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6868":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":6868,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6869":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":6869,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6870":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":6870,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6871":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":6871,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6872":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":6872,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6873":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":6873,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6874":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":6874,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6875":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"抑止の炎舞"},"optional_description":{"ja":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":6875,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6876":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"脱力の協奏曲"},"optional_description":{"ja":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":6876,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6877":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"反撃の独奏"},"optional_description":{"ja":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":6877,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6878":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"塔の断罪 NEO"},"optional_description":{"ja":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":6878,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6880":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":6880,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6881":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":6881,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6882":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":6882,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6883":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":6883,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6884":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":6884,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6885":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":6885,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6886":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":6886,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"6887":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"抑止の炎舞"},"optional_description":{"ja":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":6887,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6888":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"脱力の協奏曲"},"optional_description":{"ja":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":6888,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6889":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"反撃の独奏"},"optional_description":{"ja":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":6889,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6890":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"塔の断罪 NEO"},"optional_description":{"ja":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":6890,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"6892":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":6892,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6893":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":6893,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6894":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":6894,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6895":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":6895,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6896":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":6896,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6897":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":6897,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6898":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":6898,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6899":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"抑止の炎舞"},"optional_description":{"ja":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":6899,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6900":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"脱力の協奏曲"},"optional_description":{"ja":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":6900,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6901":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"反撃の独奏"},"optional_description":{"ja":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":6901,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6902":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"塔の断罪 NEO"},"optional_description":{"ja":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":6902,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6904":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":6904,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6905":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":6905,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"6906":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":6906,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6907":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":6907,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6908":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":6908,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6909":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":6909,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6910":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":6910,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"6911":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"抑止の炎舞"},"optional_description":{"ja":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":6911,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6912":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"脱力の協奏曲"},"optional_description":{"ja":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":6912,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"6913":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"反撃の独奏"},"optional_description":{"ja":""},"sequence_id":2059,"skill_field_effect_id":0,"_id_":6913,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6914":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"塔の断罪 NEO"},"optional_description":{"ja":""},"sequence_id":2060,"skill_field_effect_id":0,"_id_":6914,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"6916":{"attribute_id":5,"cost":2,"icon_id":1076,"is_multiple_command_unique_skill":0,"name":{"en":"Gray Flash","ja":"灰色の一閃","ko":"잿빛의 일섬","zh_hant":"灰色閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4488,"skill_field_effect_id":498,"_id_":6916,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6917":{"attribute_id":5,"cost":2,"icon_id":1026,"is_multiple_command_unique_skill":0,"name":{"en":"Profuse Flash","ja":"繚乱の一閃","ko":"요란의 일섬","zh_hant":"繚亂閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4489,"skill_field_effect_id":499,"_id_":6917,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":465,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6918":{"attribute_id":5,"cost":2,"icon_id":1040,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Applauses","ja":"喝采の一閃","ko":"갈채의 일섬","zh_hant":"喝采閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4490,"skill_field_effect_id":500,"_id_":6918,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":26,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6919":{"attribute_id":5,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Lupin's Brilliant Work","ja":"大怪盗の華麗なる仕事","ko":"대괴도의 화려한 활약","zh_hant":"大怪盜的華麗工作"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4491,"skill_field_effect_id":501,"_id_":6919,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6931":{"attribute_id":3,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Support","ja":"援護の刺突","ko":"엄호의 찌르기","zh_hant":"掩護突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4493,"skill_field_effect_id":503,"_id_":6931,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6932":{"attribute_id":3,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Thrust","ja":"雷鳴の刺突","ko":"천둥의 찌르기","zh_hant":"雷鳴突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4494,"skill_field_effect_id":504,"_id_":6932,"skill_options":[{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6933":{"attribute_id":3,"cost":2,"icon_id":1074,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Control","ja":"支配の刺突","ko":"지배의 찌르기","zh_hant":"支配突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4495,"skill_field_effect_id":505,"_id_":6933,"skill_options":[{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6934":{"attribute_id":3,"cost":2,"icon_id":336,"is_multiple_command_unique_skill":1,"name":{"en":"Belief Scissors","ja":"Belief Scissors","ko":"Belief Scissors","zh_hant":"Belief Scissors"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4496,"skill_field_effect_id":506,"_id_":6934,"skill_options":[{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6936":{"attribute_id":4,"cost":1,"icon_id":3006,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Flash","ja":"反射の一閃","ko":"반사의 일섬","zh_hant":"反射閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4498,"skill_field_effect_id":509,"_id_":6936,"skill_options":[{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6937":{"attribute_id":4,"cost":2,"icon_id":1012,"is_multiple_command_unique_skill":0,"name":{"en":"Thunder Flash","ja":"雷鳴の一閃","ko":"천둥의 일섬","zh_hant":"雷鳴閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4499,"skill_field_effect_id":510,"_id_":6937,"skill_options":[{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6938":{"attribute_id":4,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Flash","ja":"火炎の一閃","ko":"화염의 일섬","zh_hant":"火焰閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4500,"skill_field_effect_id":511,"_id_":6938,"skill_options":[{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6939":{"attribute_id":4,"cost":2,"icon_id":1085,"is_multiple_command_unique_skill":0,"name":{"en":"Final Light","ja":"最後の灯火","ko":"마지막 등불","zh_hant":"最後的火光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4501,"skill_field_effect_id":512,"_id_":6939,"skill_options":[{"id":595,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"6941":{"attribute_id":3,"cost":2,"icon_id":336,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Blindness","ja":"暗闇の打撃","ko":"암흑의 타격","zh_hant":"盲目敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4503,"skill_field_effect_id":515,"_id_":6941,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6942":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Smash","ja":"増強の打撃","ko":"증강의 타격","zh_hant":"增強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4504,"skill_field_effect_id":516,"_id_":6942,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6943":{"attribute_id":3,"cost":2,"icon_id":1089,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Vitality","ja":"活力の打撃","ko":"활력의 타격","zh_hant":"活力敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4505,"skill_field_effect_id":517,"_id_":6943,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"6944":{"attribute_id":3,"cost":2,"icon_id":336,"is_multiple_command_unique_skill":1,"name":{"en":"Illumination of Compassion","ja":"慈愛の照らすもの","ko":"자애가 비추는 것","zh_hant":"照亮慈愛者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4506,"skill_field_effect_id":518,"_id_":6944,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"6946":{"attribute_id":2,"cost":1,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4508,"skill_field_effect_id":520,"_id_":6946,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":4068,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"6947":{"attribute_id":2,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Plundering","ja":"略奪の斬撃","ko":"약탈의 참격","zh_hant":"掠奪斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4509,"skill_field_effect_id":521,"_id_":6947,"skill_options":[{"id":595,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6948":{"attribute_id":2,"cost":2,"icon_id":324,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Usurpation","ja":"収奪の斬撃","ko":"수탈의 참격","zh_hant":"強奪斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4510,"skill_field_effect_id":522,"_id_":6948,"skill_options":[{"id":596,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6949":{"attribute_id":2,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Martial Dance","ja":"功夫大乱舞","ko":"쿵푸 대난무","zh_hant":"功夫大亂舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4511,"skill_field_effect_id":523,"_id_":6949,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10020,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"6951":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4513,"skill_field_effect_id":526,"_id_":6951,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6952":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4514,"skill_field_effect_id":527,"_id_":6952,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6953":{"attribute_id":2,"cost":3,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4515,"skill_field_effect_id":528,"_id_":6953,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"6954":{"attribute_id":2,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Phantom Tears Encore","ja":"ファントムの涙 Encore","ko":"팬텀의 눈물 Encore","zh_hant":"魅影之淚 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4516,"skill_field_effect_id":529,"_id_":6954,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6971":{"attribute_id":4,"cost":1,"icon_id":3006,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Smash","ja":"反射の打撃","ko":"반사의 타격","zh_hant":"反射敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4523,"skill_field_effect_id":531,"_id_":6971,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6972":{"attribute_id":4,"cost":2,"icon_id":308,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Support","ja":"援護の打撃","ko":"엄호의 타격","zh_hant":"掩護敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4524,"skill_field_effect_id":532,"_id_":6972,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6973":{"attribute_id":4,"cost":2,"icon_id":1064,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Calamity","ja":"凶変の打撃","ko":"흉변의 타격","zh_hant":"變故敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4525,"skill_field_effect_id":533,"_id_":6973,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6974":{"attribute_id":4,"cost":2,"icon_id":324,"is_multiple_command_unique_skill":0,"name":{"en":"Guardian of Dazzling Sunshine","ja":"眩陽の守護者","ko":"눈부신 태양의 수호자","zh_hant":"炫陽守護者"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4526,"skill_field_effect_id":534,"_id_":6974,"skill_options":[{"id":596,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":383,"hit_rate":100,"target_id":2124,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]}]},"6976":{"attribute_id":9,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4528,"skill_field_effect_id":537,"_id_":6976,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6977":{"attribute_id":9,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4529,"skill_field_effect_id":538,"_id_":6977,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6978":{"attribute_id":9,"cost":2,"icon_id":1082,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4530,"skill_field_effect_id":539,"_id_":6978,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6979":{"attribute_id":9,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Black Lion's Roar Encore","ja":"黒獅子の咆哮 Encore","ko":"흑사자의 포효 Encore","zh_hant":"黑獅子咆哮 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4531,"skill_field_effect_id":540,"_id_":6979,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"6981":{"attribute_id":2,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4533,"skill_field_effect_id":542,"_id_":6981,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6982":{"attribute_id":2,"cost":2,"icon_id":324,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Usurpation","ja":"収奪の斬撃","ko":"수탈의 참격","zh_hant":"強奪斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4534,"skill_field_effect_id":543,"_id_":6982,"skill_options":[{"id":596,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6983":{"attribute_id":2,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Plundering","ja":"略奪の斬撃","ko":"약탈의 참격","zh_hant":"掠奪斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4535,"skill_field_effect_id":544,"_id_":6983,"skill_options":[{"id":595,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6984":{"attribute_id":2,"cost":2,"icon_id":284,"is_multiple_command_unique_skill":0,"name":{"en":"Sword of the Sun","ja":"陽煌覇剣","ko":"눈부신 태양의 패검","zh_hant":"陽煌霸劍"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4536,"skill_field_effect_id":545,"_id_":6984,"skill_options":[{"id":485,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":486,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":586,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":580,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"6986":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3146,"skill_field_effect_id":0,"_id_":6986,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"6987":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3147,"skill_field_effect_id":0,"_id_":6987,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"6988":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3148,"skill_field_effect_id":0,"_id_":6988,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"6989":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3149,"skill_field_effect_id":0,"_id_":6989,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6990":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3150,"skill_field_effect_id":0,"_id_":6990,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"6991":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3151,"skill_field_effect_id":0,"_id_":6991,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"6992":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3152,"skill_field_effect_id":0,"_id_":6992,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"6993":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Blazedance","ja":"猛焔舞","ko":"맹화무","zh_hant":"猛焰舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3153,"skill_field_effect_id":0,"_id_":6993,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"6994":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bloody Full Moon NEO","ja":"ブラッディ・フルムーン NEO","ko":"블러디 풀 문 NEO","zh_hant":"血腥滿月 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3154,"skill_field_effect_id":0,"_id_":6994,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"6996":{"attribute_id":9,"cost":2,"icon_id":339,"is_multiple_command_unique_skill":0,"name":{"en":"Provoke Slash","ja":"挑発の斬撃","ko":"도발의 참격","zh_hant":"挑釁斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4538,"skill_field_effect_id":548,"_id_":6996,"skill_options":[{"id":10060,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6997":{"attribute_id":9,"cost":2,"icon_id":342,"is_multiple_command_unique_skill":0,"name":{"en":"Luminous Slash","ja":"光明の斬撃","ko":"광명의 참격","zh_hant":"光明斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4539,"skill_field_effect_id":549,"_id_":6997,"skill_options":[{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10060,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6998":{"attribute_id":9,"cost":2,"icon_id":340,"is_multiple_command_unique_skill":0,"name":{"en":"Fireproof Slash","ja":"耐火の斬撃","ko":"내화의 참격","zh_hant":"耐火斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4540,"skill_field_effect_id":550,"_id_":6998,"skill_options":[{"id":20001,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10070,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10060,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"6999":{"attribute_id":9,"cost":1,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce Encore","ja":"ブルーデイズの一刺し Encore","ko":"블루 데이즈의 일격찌르기 Encore","zh_hant":"藍天刺擊 Encore"},"optional_description":{"en":"Guest Use: Greater Provoke Not Applied","ja":"ゲスト使用時、上位挑発は適用外","ko":"게스트 사용 시, 상위 도발은 게스트적용되지 않음","zh_hant":"使用來賓時，高級挑釁無效"},"sequence_id":4541,"skill_field_effect_id":551,"_id_":6999,"skill_options":[{"id":448,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":448,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10060,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7001":{"attribute_id":1,"cost":1,"icon_id":341,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Order","ja":"秩序の斬撃","ko":"질서의 참격","zh_hant":"秩序斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4543,"skill_field_effect_id":554,"_id_":7001,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":20002,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10090,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7002":{"attribute_id":1,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Slash","ja":"火炎の斬撃","ko":"화염의 참격","zh_hant":"火焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4544,"skill_field_effect_id":555,"_id_":7002,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7003":{"attribute_id":1,"cost":2,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4545,"skill_field_effect_id":556,"_id_":7003,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":508,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7004":{"attribute_id":1,"cost":2,"icon_id":336,"is_multiple_command_unique_skill":0,"name":{"en":"Execution of the Ruthless Queen","ja":"冷酷なる女王の処刑","ko":"냉혹한 여왕의 처형","zh_hant":"冷血皇后的處刑"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4546,"skill_field_effect_id":557,"_id_":7004,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7006":{"attribute_id":3,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4548,"skill_field_effect_id":560,"_id_":7006,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7007":{"attribute_id":3,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4549,"skill_field_effect_id":561,"_id_":7007,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7008":{"attribute_id":3,"cost":3,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4550,"skill_field_effect_id":562,"_id_":7008,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7009":{"attribute_id":3,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Maid's Etiquette Encore","ja":"メイドのたしなみ Encore","ko":"메이드의 소양 Encore","zh_hant":"女僕的特技 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4551,"skill_field_effect_id":563,"_id_":7009,"skill_options":[{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7023":{"attribute_id":6,"cost":1,"icon_id":3006,"is_multiple_command_unique_skill":0,"name":{"en":"Reflect Slash","ja":"反射の斬撃","ko":"반사의 참격","zh_hant":"反射斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4553,"skill_field_effect_id":565,"_id_":7023,"skill_options":[{"id":568,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7024":{"attribute_id":6,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Slash","ja":"火炎の斬撃","ko":"화염의 참격","zh_hant":"火焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4554,"skill_field_effect_id":566,"_id_":7024,"skill_options":[{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7025":{"attribute_id":6,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Plundering","ja":"略奪の斬撃","ko":"약탈의 참격","zh_hant":"掠奪斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4555,"skill_field_effect_id":567,"_id_":7025,"skill_options":[{"id":595,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":384,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7026":{"attribute_id":6,"cost":2,"icon_id":10006,"is_multiple_command_unique_skill":0,"name":{"en":"Black Lion's Cleave","ja":"黒獅子の爪裂き","ko":"흑사자의 발톱 찢기","zh_hant":"黑獅子利爪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4556,"skill_field_effect_id":568,"_id_":7026,"skill_options":[{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":577,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7028":{"attribute_id":5,"cost":1,"icon_id":342,"is_multiple_command_unique_skill":0,"name":{"en":"Luminous Slash","ja":"光明の斬撃","ko":"광명의 참격","zh_hant":"光明斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4558,"skill_field_effect_id":571,"_id_":7028,"skill_options":[{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7029":{"attribute_id":5,"cost":2,"icon_id":346,"is_multiple_command_unique_skill":0,"name":{"en":"Defensive Slash","ja":"防護の斬撃","ko":"방호의 참격","zh_hant":"防護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4559,"skill_field_effect_id":572,"_id_":7029,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":618,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7030":{"attribute_id":5,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4560,"skill_field_effect_id":573,"_id_":7030,"skill_options":[{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7031":{"attribute_id":5,"cost":2,"icon_id":298,"is_multiple_command_unique_skill":0,"name":{"en":"Scarlet Moon","ja":"緋月散華","ko":"비월산화","zh_hant":"緋月散花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4561,"skill_field_effect_id":574,"_id_":7031,"skill_options":[{"id":512,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10110,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]},{"id":10040,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7033":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4563,"skill_field_effect_id":577,"_id_":7033,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7034":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4564,"skill_field_effect_id":578,"_id_":7034,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7035":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4565,"skill_field_effect_id":579,"_id_":7035,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7036":{"attribute_id":6,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Yoru-no-osukuni Encore","ja":"夜之食国 Encore","ko":"밤을 먹는 나라 Encore","zh_hant":"夜之食國 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4566,"skill_field_effect_id":580,"_id_":7036,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7048":{"attribute_id":5,"cost":1,"icon_id":341,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Order","ja":"秩序の斬撃","ko":"질서의 참격","zh_hant":"秩序斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4568,"skill_field_effect_id":582,"_id_":7048,"skill_options":[{"id":20002,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10090,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7049":{"attribute_id":5,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Slash","ja":"輝く斬撃","ko":"반짝이는 참격","zh_hant":"光輝斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4569,"skill_field_effect_id":583,"_id_":7049,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7050":{"attribute_id":5,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4570,"skill_field_effect_id":584,"_id_":7050,"skill_options":[{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7051":{"attribute_id":5,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":1,"name":{"en":"True Strength","ja":"True Strength","ko":"True Strength","zh_hant":"True Strength"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4571,"skill_field_effect_id":585,"_id_":7051,"skill_options":[{"id":10120,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7053":{"attribute_id":8,"cost":1,"icon_id":346,"is_multiple_command_unique_skill":0,"name":{"en":"Defensive Slash","ja":"防護の斬撃","ko":"방호의 참격","zh_hant":"防護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4573,"skill_field_effect_id":588,"_id_":7053,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":618,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7054":{"attribute_id":8,"cost":2,"icon_id":335,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Slash","ja":"惑いの斬撃","ko":"미혹의 참격","zh_hant":"迷惑斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4574,"skill_field_effect_id":589,"_id_":7054,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7055":{"attribute_id":8,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4575,"skill_field_effect_id":590,"_id_":7055,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7056":{"attribute_id":8,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Strongest Music - Ba. & Vo.","ja":"最強の音楽～Ba.&Vo.～","ko":"최강의 음악 ~Ba.&Vo.~","zh_hant":"最強音樂～Ba.&Vo.～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4576,"skill_field_effect_id":591,"_id_":7056,"skill_options":[{"id":383,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7058":{"attribute_id":9,"cost":1,"icon_id":348,"is_multiple_command_unique_skill":0,"name":{"en":"Iceproof Strike","ja":"耐氷の一撃","ko":"내빙의 일격","zh_hant":"耐冰一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4578,"skill_field_effect_id":594,"_id_":7058,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10140,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7059":{"attribute_id":9,"cost":2,"icon_id":323,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Plundering","ja":"略奪の一撃","ko":"약탈의 일격","zh_hant":"掠奪一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4579,"skill_field_effect_id":595,"_id_":7059,"skill_options":[{"id":595,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7060":{"attribute_id":9,"cost":2,"icon_id":324,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Usurpation","ja":"収奪の一撃","ko":"수탈의 일격","zh_hant":"強奪一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4580,"skill_field_effect_id":596,"_id_":7060,"skill_options":[{"id":596,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7061":{"attribute_id":9,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Strongest Music - Gt.","ja":"最強の音楽～Gt.～","ko":"최강의 음악 ~Gt.~","zh_hant":"最強音樂～Gt.～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4581,"skill_field_effect_id":597,"_id_":7061,"skill_options":[{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":595,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":596,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[6,6,6,6,6]},{"id":10120,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7064":{"attribute_id":5,"cost":2,"icon_id":336,"is_multiple_command_unique_skill":0,"name":{"en":"Blindness Slash","ja":"暗闇の斬撃","ko":"암흑의 참격","zh_hant":"盲目斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4583,"skill_field_effect_id":600,"_id_":7064,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7065":{"attribute_id":5,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4584,"skill_field_effect_id":601,"_id_":7065,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7066":{"attribute_id":5,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Slash","ja":"吸収の斬撃","ko":"흡수의 참격","zh_hant":"吸收斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4585,"skill_field_effect_id":602,"_id_":7066,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7067":{"attribute_id":5,"cost":2,"icon_id":1020,"is_multiple_command_unique_skill":1,"name":{"en":"Peculiar Cauldron","ja":"奇妙な大釜","ko":"기묘한 가마솥","zh_hant":"奇妙的大鍋"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4586,"skill_field_effect_id":603,"_id_":7067,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":361,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7069":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4588,"skill_field_effect_id":605,"_id_":7069,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7070":{"attribute_id":4,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4589,"skill_field_effect_id":606,"_id_":7070,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7071":{"attribute_id":4,"cost":2,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4590,"skill_field_effect_id":607,"_id_":7071,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7072":{"attribute_id":4,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Jet-Black Arabesque Encore","ja":"漆黒のアラベスク Encore","ko":"칠흑의 아라베스크 Encore","zh_hant":"漆黑之阿拉貝斯舞 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4591,"skill_field_effect_id":608,"_id_":7072,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7074":{"attribute_id":8,"cost":1,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Flash","ja":"必中の一閃","ko":"백발백중의 일섬","zh_hant":"必中閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4593,"skill_field_effect_id":610,"_id_":7074,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":508,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7075":{"attribute_id":8,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Freeze Flash","ja":"凍結の一閃","ko":"동결의 일섬","zh_hant":"凍結閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4594,"skill_field_effect_id":611,"_id_":7075,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7076":{"attribute_id":8,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Flash","ja":"停止の一閃","ko":"정지의 일섬","zh_hant":"停止閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4595,"skill_field_effect_id":612,"_id_":7076,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7077":{"attribute_id":8,"cost":2,"icon_id":348,"is_multiple_command_unique_skill":0,"name":{"en":"Strongest Music - Dr.","ja":"最強の音楽～Dr.～","ko":"최강의 음악 ~Dr.~","zh_hant":"最強音樂～Dr.～"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4596,"skill_field_effect_id":613,"_id_":7077,"skill_options":[{"id":10140,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":383,"hit_rate":100,"target_id":4069,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7079":{"attribute_id":9,"cost":1,"icon_id":341,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Order","ja":"秩序の斬撃","ko":"질서의 참격","zh_hant":"秩序斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4598,"skill_field_effect_id":616,"_id_":7079,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20002,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10090,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7080":{"attribute_id":9,"cost":2,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4599,"skill_field_effect_id":617,"_id_":7080,"skill_options":[{"id":508,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7081":{"attribute_id":9,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Invincibility","ja":"無敵の斬撃","ko":"무적의 참격","zh_hant":"無敵斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4600,"skill_field_effect_id":618,"_id_":7081,"skill_options":[{"id":558,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7082":{"attribute_id":9,"cost":2,"icon_id":156,"is_multiple_command_unique_skill":0,"name":{"en":"Fate and the Stars","ja":"運命と星","ko":"운명과 별","zh_hant":"命運與星星"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4601,"skill_field_effect_id":619,"_id_":7082,"skill_options":[{"id":558,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[15000,15000,15000,15000,15000]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7084":{"attribute_id":4,"cost":1,"icon_id":340,"is_multiple_command_unique_skill":0,"name":{"en":"Fireproof Slash","ja":"耐火の斬撃","ko":"내화의 참격","zh_hant":"耐火斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4603,"skill_field_effect_id":621,"_id_":7084,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20001,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10070,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7085":{"attribute_id":4,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Slash","ja":"火炎の斬撃","ko":"화염의 참격","zh_hant":"火焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4604,"skill_field_effect_id":622,"_id_":7085,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[40,40,40,40,40]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[40,40,40,40,40]},{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7086":{"attribute_id":4,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Slash","ja":"停止の斬撃","ko":"정지의 참격","zh_hant":"停止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4605,"skill_field_effect_id":623,"_id_":7086,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":508,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10120,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7087":{"attribute_id":4,"cost":2,"icon_id":351,"is_multiple_command_unique_skill":0,"name":{"en":"Sacred Light","ja":"聖なる光","ko":"성스러운 빛","zh_hant":"神聖之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4606,"skill_field_effect_id":624,"_id_":7087,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":488,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[15000,15000,15000,15000,15000]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7089":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4608,"skill_field_effect_id":627,"_id_":7089,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7090":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4609,"skill_field_effect_id":628,"_id_":7090,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7091":{"attribute_id":1,"cost":2,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4610,"skill_field_effect_id":629,"_id_":7091,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7092":{"attribute_id":1,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce War Cry Encore","ja":"猛将の雄叫び Encore","ko":"용맹한 장수의 외침 Encore","zh_hant":"猛將的怒吼 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4611,"skill_field_effect_id":630,"_id_":7092,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7094":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":0,"_id_":7094,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7095":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":0,"_id_":7095,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7096":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":0,"_id_":7096,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7097":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":0,"_id_":7097,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7098":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":0,"_id_":7098,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7099":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":0,"_id_":7099,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7100":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":0,"_id_":7100,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7101":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4613,"skill_field_effect_id":0,"_id_":7101,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7102":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4614,"skill_field_effect_id":0,"_id_":7102,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7104":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":0,"_id_":7104,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7105":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":0,"_id_":7105,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7106":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":0,"_id_":7106,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7107":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":0,"_id_":7107,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7108":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":0,"_id_":7108,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7109":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":0,"_id_":7109,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7110":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":0,"_id_":7110,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7111":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4613,"skill_field_effect_id":0,"_id_":7111,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7112":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4614,"skill_field_effect_id":0,"_id_":7112,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7114":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":7114,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7115":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":7115,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7116":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":7116,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7117":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":7117,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7118":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":7118,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7119":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":7119,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7120":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":7120,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7121":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":7121,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7122":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":7122,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7123":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":0,"_id_":7123,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"7124":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":0,"_id_":7124,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"7126":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":0,"_id_":7126,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7127":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":0,"_id_":7127,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7128":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":0,"_id_":7128,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7129":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":0,"_id_":7129,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7130":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":0,"_id_":7130,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7131":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":0,"_id_":7131,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7132":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":0,"_id_":7132,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7133":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":0,"_id_":7133,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7134":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":0,"_id_":7134,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7135":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":0,"_id_":7135,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7136":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":0,"_id_":7136,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7138":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":0,"_id_":7138,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7139":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":0,"_id_":7139,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7140":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":0,"_id_":7140,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7141":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":0,"_id_":7141,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7142":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":0,"_id_":7142,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7143":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":0,"_id_":7143,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7144":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":0,"_id_":7144,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7145":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":0,"_id_":7145,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7146":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":0,"_id_":7146,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7148":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":0,"_id_":7148,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7149":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":0,"_id_":7149,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7150":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":0,"_id_":7150,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7151":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":0,"_id_":7151,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7152":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":0,"_id_":7152,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7153":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":0,"_id_":7153,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7154":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":0,"_id_":7154,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7155":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":0,"_id_":7155,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7156":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":0,"_id_":7156,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7158":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":7158,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7159":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":7159,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7160":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":7160,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7161":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":7161,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7162":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":7162,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7163":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":7163,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7164":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":7164,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7165":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":7165,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7166":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":7166,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7167":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":0,"_id_":7167,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":33,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7168":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":0,"_id_":7168,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":33,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7170":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":0,"_id_":7170,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7171":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":0,"_id_":7171,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7172":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":0,"_id_":7172,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7173":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":0,"_id_":7173,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7174":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":0,"_id_":7174,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7175":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":0,"_id_":7175,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7176":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":0,"_id_":7176,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7177":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":0,"_id_":7177,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7178":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":0,"_id_":7178,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7179":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":0,"_id_":7179,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":33,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7180":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":0,"_id_":7180,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":33,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7182":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":7182,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7183":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":7183,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7184":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":7184,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7185":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":7185,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7186":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":7186,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"7187":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":7187,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"7188":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":7188,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7189":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":7189,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7190":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":7190,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7192":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":7192,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7193":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":7193,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7194":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":7194,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7195":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":7195,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7196":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":7196,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7197":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":7197,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7198":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":7198,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"7199":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":7199,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7200":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":7200,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7201":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":7201,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7202":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":7202,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7204":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":7204,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7205":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":7205,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7206":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":7206,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7207":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":7207,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7208":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":7208,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7209":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":7209,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7210":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":7210,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7211":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":7211,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7212":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":7212,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7213":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":7213,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7214":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":7214,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7216":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":7216,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7217":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":7217,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7218":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":7218,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7219":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":7219,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7220":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":7220,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7221":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":7221,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7222":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":7222,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7223":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":7223,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7224":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":7224,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7225":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":7225,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7226":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":7226,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7255":{"attribute_id":1,"cost":1,"icon_id":342,"is_multiple_command_unique_skill":0,"name":{"en":"Luminous Flash","ja":"光明の一閃","ko":"광명의 일섬","zh_hant":"光明閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4626,"skill_field_effect_id":633,"_id_":7255,"skill_options":[{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":508,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7256":{"attribute_id":1,"cost":2,"icon_id":351,"is_multiple_command_unique_skill":0,"name":{"en":"Electric Flash","ja":"感電の一閃","ko":"감전의 일섬","zh_hant":"感電閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4627,"skill_field_effect_id":634,"_id_":7256,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":10120,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7257":{"attribute_id":1,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Flash","ja":"停止の一閃","ko":"정지의 일섬","zh_hant":"停止閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4628,"skill_field_effect_id":635,"_id_":7257,"skill_options":[{"id":453,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10120,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7258":{"attribute_id":1,"cost":2,"icon_id":298,"is_multiple_command_unique_skill":0,"name":{"en":"Blessings of Spring Light","ja":"春光の恩恵","ko":"봄빛의 은혜","zh_hant":"春光的恩惠"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4629,"skill_field_effect_id":636,"_id_":7258,"skill_options":[{"id":512,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7260":{"attribute_id":3,"cost":1,"icon_id":340,"is_multiple_command_unique_skill":0,"name":{"en":"Fireproof Slash","ja":"耐火の斬撃","ko":"내화의 참격","zh_hant":"耐火斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4631,"skill_field_effect_id":639,"_id_":7260,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20001,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10070,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7261":{"attribute_id":3,"cost":2,"icon_id":351,"is_multiple_command_unique_skill":0,"name":{"en":"Electric Slash","ja":"感電の斬撃","ko":"감전의 참격","zh_hant":"感電斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4632,"skill_field_effect_id":640,"_id_":7261,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":581,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7262":{"attribute_id":3,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Slash","ja":"停止の斬撃","ko":"정지의 참격","zh_hant":"停止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4633,"skill_field_effect_id":641,"_id_":7262,"skill_options":[{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":4069,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7263":{"attribute_id":3,"cost":2,"icon_id":347,"is_multiple_command_unique_skill":0,"name":{"en":"Lovesick Monologue","ja":"恋わずらいのモノローグ","ko":"상사병의 모놀로그","zh_hant":"苦戀的獨白"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4634,"skill_field_effect_id":642,"_id_":7263,"skill_options":[{"id":10130,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":4069,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[200,210,220,230,240]}]},"7265":{"attribute_id":8,"cost":1,"icon_id":349,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Time Keeping","ja":"時守の斬撃","ko":"시간 수호자의 참격","zh_hant":"時守斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4636,"skill_field_effect_id":645,"_id_":7265,"skill_options":[{"id":20004,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10150,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10060,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7266":{"attribute_id":8,"cost":1,"icon_id":359,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4637,"skill_field_effect_id":646,"_id_":7266,"skill_options":[{"id":10250,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10230,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7267":{"attribute_id":8,"cost":1,"icon_id":357,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Slash","ja":"守護の斬撃","ko":"수호의 참격","zh_hant":"守護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4638,"skill_field_effect_id":647,"_id_":7267,"skill_options":[{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10230,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7268":{"attribute_id":8,"cost":2,"icon_id":357,"is_multiple_command_unique_skill":0,"name":{"en":"Stars and Fate","ja":"星と運命","ko":"별과 운명","zh_hant":"星星與命運"},"optional_description":{"en":"Guest Use: Greater Aggro Not Applied","ja":"ゲスト使用時、上位ターゲット固定は適用外","ko":"게스트 사용 시, 상위 타깃 고정은 적용되지 않음","zh_hant":"使用來賓時，高級目標鎖定無效"},"sequence_id":4639,"skill_field_effect_id":648,"_id_":7268,"skill_options":[{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10250,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7270":{"attribute_id":1,"cost":2,"icon_id":335,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Blindness","ja":"暗闇の刺突","ko":"암흑의 찌르기","zh_hant":"盲目突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4641,"skill_field_effect_id":651,"_id_":7270,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7271":{"attribute_id":1,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Strengthening","ja":"増強の刺突","ko":"증강의 찌르기","zh_hant":"增強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4642,"skill_field_effect_id":652,"_id_":7271,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7272":{"attribute_id":1,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Absorption","ja":"吸収の刺突","ko":"흡수의 찌르기","zh_hant":"吸收突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4643,"skill_field_effect_id":653,"_id_":7272,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[165,173,181,189,198]}]},"7273":{"attribute_id":1,"cost":2,"icon_id":1020,"is_multiple_command_unique_skill":1,"name":{"en":"Happy Surprise Egg","ja":"ハッピーサプライズエッグ","ko":"해피 서프라이즈 에그","zh_hant":"歡樂驚喜彩蛋"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4644,"skill_field_effect_id":654,"_id_":7273,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":583,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":364,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7275":{"attribute_id":5,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Thrust","ja":"軽快な刺突","ko":"경쾌한 찌르기","zh_hant":"輕快突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4646,"skill_field_effect_id":656,"_id_":7275,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7276":{"attribute_id":5,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Thrust","ja":"甘美な刺突","ko":"감미로운 찌르기","zh_hant":"甘美突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4647,"skill_field_effect_id":657,"_id_":7276,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7277":{"attribute_id":5,"cost":2,"icon_id":1069,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Ovation","ja":"万雷の刺突","ko":"만뢰의 찌르기","zh_hant":"萬雷突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4648,"skill_field_effect_id":658,"_id_":7277,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7278":{"attribute_id":5,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Flying Dragon Kick Encore","ja":"竜翔脚 Encore","ko":"용상각 Encore","zh_hant":"龍翔腳 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4649,"skill_field_effect_id":659,"_id_":7278,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7280":{"attribute_id":2,"cost":1,"icon_id":348,"is_multiple_command_unique_skill":0,"name":{"en":"Resistance Strike","ja":"耐性の一撃","ko":"저항의 일격","zh_hant":"耐性一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4651,"skill_field_effect_id":661,"_id_":7280,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20005,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10140,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7281":{"attribute_id":2,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Strike","ja":"重圧の一撃","ko":"중압의 일격","zh_hant":"重壓一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4652,"skill_field_effect_id":662,"_id_":7281,"skill_options":[{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7282":{"attribute_id":2,"cost":2,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4653,"skill_field_effect_id":663,"_id_":7282,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7283":{"attribute_id":2,"cost":2,"icon_id":361,"is_multiple_command_unique_skill":0,"name":{"en":"Fantastic Show","ja":"Fantastic show","ko":"Fantastic show","zh_hant":"Fantastic show"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4654,"skill_field_effect_id":664,"_id_":7283,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10270,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[40,40,40,40,40]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10120,"hit_rate":100,"target_id":2124,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7296":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":7296,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7297":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":7297,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7298":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":7298,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7299":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":7299,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7300":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":7300,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7301":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":7301,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7302":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":7302,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7303":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":7303,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7304":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":7304,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"7306":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":7306,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7307":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":7307,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7308":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":7308,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7309":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":7309,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7310":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":7310,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7311":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":7311,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7312":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":7312,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7313":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":7313,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"7314":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":7314,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7315":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":7315,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"7317":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":7317,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7318":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":7318,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7319":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":7319,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7320":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":7320,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7321":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":7321,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7322":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":0,"_id_":7322,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7323":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":7323,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7324":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":0,"_id_":7324,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7326":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":0,"_id_":7326,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7327":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":0,"_id_":7327,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7328":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":0,"_id_":7328,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7329":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":0,"_id_":7329,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7330":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":0,"_id_":7330,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7331":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":0,"_id_":7331,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7332":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":0,"_id_":7332,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7333":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":0,"_id_":7333,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":59,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7335":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":0,"_id_":7335,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7336":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":0,"_id_":7336,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7337":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":0,"_id_":7337,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7338":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":0,"_id_":7338,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7339":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":0,"_id_":7339,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7340":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":0,"_id_":7340,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7341":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":0,"_id_":7341,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7342":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":0,"_id_":7342,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7344":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":0,"_id_":7344,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7345":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":0,"_id_":7345,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7346":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":0,"_id_":7346,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7347":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":0,"_id_":7347,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7348":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":0,"_id_":7348,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7349":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":0,"_id_":7349,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7350":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":0,"_id_":7350,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7351":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":0,"_id_":7351,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7352":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":0,"_id_":7352,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7353":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":0,"_id_":7353,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7355":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":0,"_id_":7355,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7356":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":0,"_id_":7356,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7357":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":0,"_id_":7357,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7358":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":0,"_id_":7358,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7359":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":0,"_id_":7359,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7360":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":0,"_id_":7360,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7361":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":0,"_id_":7361,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7362":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":0,"_id_":7362,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7363":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":0,"_id_":7363,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7364":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":0,"_id_":7364,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7366":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":0,"_id_":7366,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7367":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":0,"_id_":7367,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7368":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":0,"_id_":7368,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7369":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":0,"_id_":7369,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7370":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":0,"_id_":7370,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7371":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":0,"_id_":7371,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7372":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":0,"_id_":7372,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7373":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":0,"_id_":7373,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":54,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7375":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":0,"_id_":7375,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7376":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":0,"_id_":7376,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7377":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":0,"_id_":7377,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7378":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":0,"_id_":7378,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7379":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":0,"_id_":7379,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7380":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":0,"_id_":7380,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7381":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":0,"_id_":7381,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7382":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":0,"_id_":7382,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7383":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":0,"_id_":7383,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7384":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":0,"_id_":7384,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7386":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":0,"_id_":7386,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7387":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":0,"_id_":7387,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7388":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":0,"_id_":7388,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7389":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":0,"_id_":7389,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7390":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":0,"_id_":7390,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7391":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":0,"_id_":7391,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7392":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":0,"_id_":7392,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7393":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":0,"_id_":7393,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7394":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":0,"_id_":7394,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7395":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":0,"_id_":7395,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7397":{"attribute_id":6,"cost":1,"icon_id":342,"is_multiple_command_unique_skill":0,"name":{"en":"Luminous Flash","ja":"光明の一閃","ko":"광명의 일섬","zh_hant":"光明閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4664,"skill_field_effect_id":668,"_id_":7397,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7398":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Flash","ja":"輝く一閃","ko":"반짝이는 일섬","zh_hant":"輝耀閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4665,"skill_field_effect_id":669,"_id_":7398,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10130,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7399":{"attribute_id":6,"cost":2,"icon_id":197,"is_multiple_command_unique_skill":0,"name":{"en":"Restorative Flash","ja":"再起の一閃","ko":"재기의 일섬","zh_hant":"再起閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4666,"skill_field_effect_id":670,"_id_":7399,"skill_options":[{"id":309,"hit_rate":100,"target_id":11011,"times":[0,0,0,0,0],"values":[50,55,60,65,70]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7400":{"attribute_id":6,"cost":2,"icon_id":363,"is_multiple_command_unique_skill":1,"name":{"en":"It’s Showtime!","ja":"It's showtime！","ko":"It's showtime!","zh_hant":"It's showtime！"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4667,"skill_field_effect_id":671,"_id_":7400,"skill_options":[{"id":309,"hit_rate":100,"target_id":11012,"times":[0,0,0,0,0],"values":[50,55,60,65,70]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[15000,15000,15000,15000,15000]},{"id":10281,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7402":{"attribute_id":5,"cost":1,"icon_id":340,"is_multiple_command_unique_skill":0,"name":{"en":"Fireproof Slash","ja":"耐火の斬撃","ko":"내화의 참격","zh_hant":"耐火斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4669,"skill_field_effect_id":674,"_id_":7402,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20001,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10070,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7403":{"attribute_id":5,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4670,"skill_field_effect_id":675,"_id_":7403,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]}]},"7404":{"attribute_id":5,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4671,"skill_field_effect_id":676,"_id_":7404,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":508,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10040,"hit_rate":100,"target_id":4069,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7405":{"attribute_id":5,"cost":2,"icon_id":366,"is_multiple_command_unique_skill":0,"name":{"en":"Senji Ryakketsu - Summon Shikigami","ja":"占事略决・式神召喚","ko":"점사약결 식신 소환","zh_hant":"占事略決・式神召喚"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4672,"skill_field_effect_id":677,"_id_":7405,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7407":{"attribute_id":2,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4674,"skill_field_effect_id":680,"_id_":7407,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7408":{"attribute_id":2,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4675,"skill_field_effect_id":681,"_id_":7408,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7409":{"attribute_id":2,"cost":2,"icon_id":1066,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4676,"skill_field_effect_id":682,"_id_":7409,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7410":{"attribute_id":2,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"1001 Illusions Encore","ja":"千夜一夜の幻想 Encore","ko":"천일야화의 환상 Encore","zh_hant":"一千零一夜的幻想 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4677,"skill_field_effect_id":683,"_id_":7410,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7412":{"attribute_id":3,"cost":1,"icon_id":367,"is_multiple_command_unique_skill":0,"name":{"en":"Antistatic Strike","ja":"耐電の一撃","ko":"내전의 일격","zh_hant":"耐電一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4679,"skill_field_effect_id":685,"_id_":7412,"skill_options":[{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10285,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7413":{"attribute_id":3,"cost":2,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4680,"skill_field_effect_id":686,"_id_":7413,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7414":{"attribute_id":3,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Strike","ja":"重圧の一撃","ko":"중압의 일격","zh_hant":"重壓一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4681,"skill_field_effect_id":687,"_id_":7414,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]}]},"7415":{"attribute_id":3,"cost":2,"icon_id":1096,"is_multiple_command_unique_skill":1,"name":{"en":"Gift for My Master","ja":"ささやかなるご主人様への贈り物","ko":"주인님을 위한 소소한 선물","zh_hant":"送給主人的小小心意"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4682,"skill_field_effect_id":688,"_id_":7415,"skill_options":[{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7417":{"attribute_id":3,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4684,"skill_field_effect_id":691,"_id_":7417,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7418":{"attribute_id":3,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Strike","ja":"甘美な一撃","ko":"감미로운 일격","zh_hant":"甘美一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4685,"skill_field_effect_id":692,"_id_":7418,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7419":{"attribute_id":3,"cost":2,"icon_id":1067,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Ovation","ja":"万雷の一撃","ko":"만뢰의 일격","zh_hant":"萬雷一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4686,"skill_field_effect_id":693,"_id_":7419,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7420":{"attribute_id":3,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Christine's Song Encore","ja":"クリスティーヌの歌声 Encore","ko":"크리스틴의 노랫소리 Encore","zh_hant":"克莉絲汀的歌聲 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4687,"skill_field_effect_id":694,"_id_":7420,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7444":{"attribute_id":4,"cost":1,"icon_id":341,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Order","ja":"秩序の一撃","ko":"질서의 일격","zh_hant":"秩序一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4690,"skill_field_effect_id":697,"_id_":7444,"skill_options":[{"id":20002,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10090,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7445":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Strike","ja":"煌めく一撃","ko":"빛나는 일격","zh_hant":"輝煌一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4691,"skill_field_effect_id":698,"_id_":7445,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7446":{"attribute_id":4,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Freeze Strike","ja":"氷結の一撃","ko":"빙결의 일격","zh_hant":"冰凍一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4692,"skill_field_effect_id":699,"_id_":7446,"skill_options":[{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[165,173,181,189,198]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7447":{"attribute_id":4,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":1,"name":{"en":"Libra's Conviction","ja":"天秤の断罪","ko":"천칭의 단죄","zh_hant":"天秤之定罪"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4693,"skill_field_effect_id":700,"_id_":7447,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7449":{"attribute_id":2,"cost":1,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Flash","ja":"軽快な一閃","ko":"경쾌한 일섬","zh_hant":"輕快閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4695,"skill_field_effect_id":703,"_id_":7449,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20005,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10140,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7450":{"attribute_id":2,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Flash","ja":"致命の一閃","ko":"치명의 일섬","zh_hant":"致命閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4696,"skill_field_effect_id":704,"_id_":7450,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7451":{"attribute_id":2,"cost":2,"icon_id":35,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Flash","ja":"必中の一閃","ko":"백발백중의 일섬","zh_hant":"必中閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4697,"skill_field_effect_id":705,"_id_":7451,"skill_options":[{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":508,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7452":{"attribute_id":2,"cost":2,"icon_id":369,"is_multiple_command_unique_skill":0,"name":{"en":"Chasing the White Rabbit","ja":"白うさぎを追いかけて","ko":"흰토끼를 쫓아서","zh_hant":"追逐白兔"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4698,"skill_field_effect_id":706,"_id_":7452,"skill_options":[{"id":620,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":619,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[450,460,470,480,500]}]},"7454":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Flash","ja":"軽快な一閃","ko":"경쾌한 일섬","zh_hant":"輕快閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4700,"skill_field_effect_id":709,"_id_":7454,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7455":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Flash","ja":"甘美な一閃","ko":"감미로운 일섬","zh_hant":"甘美閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4701,"skill_field_effect_id":710,"_id_":7455,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7456":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Ovation","ja":"万雷の一閃","ko":"만뢰의 일섬","zh_hant":"萬雷閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4702,"skill_field_effect_id":711,"_id_":7456,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7457":{"attribute_id":6,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Pandora's Box Encore","ja":"パンドラの箱 Encore","ko":"판도라의 상자 Encore","zh_hant":"潘朵拉的盒子 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4703,"skill_field_effect_id":712,"_id_":7457,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7471":{"attribute_id":3,"cost":1,"icon_id":371,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4706,"skill_field_effect_id":714,"_id_":7471,"skill_options":[{"id":20005,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20004,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10290,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7472":{"attribute_id":3,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Slash","ja":"煌めく斬撃","ko":"빛나는 참격","zh_hant":"輝煌斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4707,"skill_field_effect_id":715,"_id_":7472,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7473":{"attribute_id":3,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4708,"skill_field_effect_id":716,"_id_":7473,"skill_options":[{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7474":{"attribute_id":3,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":1,"name":{"en":"Petals of Fate","ja":"運命の花弁","ko":"운명의 꽃잎","zh_hant":"命運花瓣"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4709,"skill_field_effect_id":717,"_id_":7474,"skill_options":[{"id":10290,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7476":{"attribute_id":1,"cost":1,"icon_id":367,"is_multiple_command_unique_skill":0,"name":{"en":"Antistatic Slash","ja":"耐電の斬撃","ko":"내전의 참격","zh_hant":"耐電斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4711,"skill_field_effect_id":720,"_id_":7476,"skill_options":[{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10285,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7477":{"attribute_id":1,"cost":2,"icon_id":363,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Slumber","ja":"睡眠の斬撃","ko":"수면의 참격","zh_hant":"睡眠斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4712,"skill_field_effect_id":721,"_id_":7477,"skill_options":[{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7478":{"attribute_id":1,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Confusion","ja":"混乱の斬撃","ko":"혼란의 참격","zh_hant":"混亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4713,"skill_field_effect_id":722,"_id_":7478,"skill_options":[{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7479":{"attribute_id":1,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":1,"name":{"en":"Chosen King Encore","ja":"選ばれし王 Encore","ko":"선택받은 왕 Encore","zh_hant":"天選之王 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4714,"skill_field_effect_id":723,"_id_":7479,"skill_options":[{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[15000,15000,15000,15000,15000]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]},{"id":10281,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7481":{"attribute_id":4,"cost":1,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4716,"skill_field_effect_id":726,"_id_":7481,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]}]},"7482":{"attribute_id":4,"cost":2,"icon_id":347,"is_multiple_command_unique_skill":0,"name":{"en":"Fortitude Slash","ja":"不屈の斬撃","ko":"불굴의 참격","zh_hant":"不屈斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4717,"skill_field_effect_id":727,"_id_":7482,"skill_options":[{"id":10130,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]}]},"7483":{"attribute_id":4,"cost":2,"icon_id":344,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Slash","ja":"回避の斬撃","ko":"회피의 참격","zh_hant":"迴避斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4718,"skill_field_effect_id":728,"_id_":7483,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]}]},"7484":{"attribute_id":4,"cost":2,"icon_id":1034,"is_multiple_command_unique_skill":0,"name":{"en":"We Will All Do Starlight! Encore","ja":"みんなを、スタァライト！しちゃいます！！ Encore","ko":"모두를 스타라이트! 하겠습니다!! Encore","zh_hant":"我會令大家星光照耀的！！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4719,"skill_field_effect_id":729,"_id_":7484,"skill_options":[{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7486":{"attribute_id":6,"cost":1,"icon_id":375,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Liberation","ja":"解放の斬撃","ko":"해방의 참격","zh_hant":"解放斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4721,"skill_field_effect_id":731,"_id_":7486,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20010,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10294,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7487":{"attribute_id":6,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Slash","ja":"吸収の斬撃","ko":"흡수의 참격","zh_hant":"吸收斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4722,"skill_field_effect_id":732,"_id_":7487,"skill_options":[{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7488":{"attribute_id":6,"cost":2,"icon_id":10005,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Boost","ja":"特効の斬撃","ko":"특효의 참격","zh_hant":"特效斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4723,"skill_field_effect_id":733,"_id_":7488,"skill_options":[{"id":20010,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":571,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7489":{"attribute_id":6,"cost":2,"icon_id":376,"is_multiple_command_unique_skill":1,"name":{"en":"Scattering of Fate","ja":"運命の散花","ko":"운명의 산화","zh_hant":"命運花落"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4724,"skill_field_effect_id":734,"_id_":7489,"skill_options":[{"id":10295,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":571,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"7491":{"attribute_id":4,"cost":2,"icon_id":359,"is_multiple_command_unique_skill":0,"name":{"en":"Antistatic Slash","ja":"耐電の斬撃","ko":"내전의 참격","zh_hant":"耐電斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4726,"skill_field_effect_id":737,"_id_":7491,"skill_options":[{"id":10250,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7492":{"attribute_id":4,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4727,"skill_field_effect_id":738,"_id_":7492,"skill_options":[{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7493":{"attribute_id":4,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4728,"skill_field_effect_id":739,"_id_":7493,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7494":{"attribute_id":4,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Two Dragon's Prophecy Encore","ja":"二頭の竜の予言 Encore","ko":"쌍두룡의 예언 Encore","zh_hant":"兩頭龍的預言 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4729,"skill_field_effect_id":740,"_id_":7494,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"7496":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":811,"_id_":7496,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7497":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":742,"_id_":7497,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7498":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":811,"_id_":7498,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7499":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":742,"_id_":7499,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7500":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":742,"_id_":7500,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7501":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":811,"_id_":7501,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7502":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":742,"_id_":7502,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7503":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4731,"skill_field_effect_id":742,"_id_":7503,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7504":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4732,"skill_field_effect_id":742,"_id_":7504,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7506":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":7506,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7507":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":7507,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7508":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":7508,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7509":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":7509,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7510":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":7510,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7511":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":7511,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7512":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4733,"skill_field_effect_id":742,"_id_":7512,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7513":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4734,"skill_field_effect_id":742,"_id_":7513,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7515":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":7515,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7516":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":7516,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7517":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":7517,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7518":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":7518,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7519":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":7519,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7520":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":7520,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7521":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":7521,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7522":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":7522,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7523":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4735,"skill_field_effect_id":742,"_id_":7523,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7524":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4736,"skill_field_effect_id":742,"_id_":7524,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7526":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":7526,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7527":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":7527,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7528":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":7528,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7529":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":7529,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7530":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":7530,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7531":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":7531,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7532":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":7532,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7533":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4737,"skill_field_effect_id":742,"_id_":7533,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7534":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":7534,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7535":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":7535,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7536":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4738,"skill_field_effect_id":742,"_id_":7536,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7538":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":811,"_id_":7538,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7539":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":742,"_id_":7539,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7540":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":811,"_id_":7540,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7541":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":742,"_id_":7541,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7542":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":742,"_id_":7542,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7543":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":811,"_id_":7543,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7544":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":742,"_id_":7544,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7545":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4731,"skill_field_effect_id":742,"_id_":7545,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7546":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4732,"skill_field_effect_id":742,"_id_":7546,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7548":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":7548,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7549":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":7549,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7550":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":7550,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7551":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":7551,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7552":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":7552,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7553":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":7553,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7554":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4733,"skill_field_effect_id":742,"_id_":7554,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7555":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4734,"skill_field_effect_id":742,"_id_":7555,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7557":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":7557,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7558":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":7558,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7559":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":7559,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7560":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":7560,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7561":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":7561,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7562":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":7562,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7563":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":7563,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7564":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":7564,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7565":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4735,"skill_field_effect_id":742,"_id_":7565,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7566":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with her head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4736,"skill_field_effect_id":742,"_id_":7566,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7568":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":7568,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7569":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":7569,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7570":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":7570,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7571":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":7571,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7572":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":7572,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7573":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":7573,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7574":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":7574,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7575":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4737,"skill_field_effect_id":742,"_id_":7575,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7576":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":7576,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7577":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":7577,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7578":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4738,"skill_field_effect_id":742,"_id_":7578,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10210,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7580":{"attribute_id":2,"cost":1,"icon_id":374,"is_multiple_command_unique_skill":0,"name":{"en":"Awakening Slash","ja":"目覚めの斬撃","ko":"각성의 참격","zh_hant":"喚醒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4739,"skill_field_effect_id":743,"_id_":7580,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20011,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10293,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7581":{"attribute_id":2,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4740,"skill_field_effect_id":744,"_id_":7581,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7582":{"attribute_id":2,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Freeze Slash","ja":"氷結の斬撃","ko":"빙결의 참격","zh_hant":"冰凍斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4741,"skill_field_effect_id":745,"_id_":7582,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20009,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7583":{"attribute_id":2,"cost":2,"icon_id":377,"is_multiple_command_unique_skill":1,"name":{"en":"Bud of Fate","ja":"運命の蕾","ko":"운명의 꽃봉오리","zh_hant":"命運花蕾"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4742,"skill_field_effect_id":746,"_id_":7583,"skill_options":[{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7585":{"attribute_id":5,"cost":1,"icon_id":379,"is_multiple_command_unique_skill":0,"name":{"en":"Swift Flash","ja":"速攻の一閃","ko":"속공의 일섬","zh_hant":"速攻閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4744,"skill_field_effect_id":749,"_id_":7585,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10285,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7586":{"attribute_id":5,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Flash","ja":"火炎の一閃","ko":"화염의 일섬","zh_hant":"火焰閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4745,"skill_field_effect_id":750,"_id_":7586,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10040,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7587":{"attribute_id":5,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Flash","ja":"必中の一閃","ko":"백발백중의 일섬","zh_hant":"必中閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4746,"skill_field_effect_id":751,"_id_":7587,"skill_options":[{"id":10130,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10299,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7588":{"attribute_id":5,"cost":1,"icon_id":379,"is_multiple_command_unique_skill":1,"name":{"en":"Majestic Clarent Encore","ja":"光砕くクラレント Encore","ko":"빛을 부수는 클라렌트 Encore","zh_hant":"碎光之Clarent Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4747,"skill_field_effect_id":752,"_id_":7588,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[30,30,30,30,30]},{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7590":{"attribute_id":3,"cost":1,"icon_id":367,"is_multiple_command_unique_skill":0,"name":{"en":"Antistatic Slash","ja":"耐電の斬撃","ko":"내전의 참격","zh_hant":"耐電斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4749,"skill_field_effect_id":755,"_id_":7590,"skill_options":[{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10285,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":471,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"7591":{"attribute_id":3,"cost":2,"icon_id":380,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Degradation","ja":"堕落の斬撃","ko":"타락의 참격","zh_hant":"墮落斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4750,"skill_field_effect_id":756,"_id_":7591,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[40,40,40,40,40]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[40,40,40,40,40]}]},"7592":{"attribute_id":3,"cost":2,"icon_id":197,"is_multiple_command_unique_skill":0,"name":{"en":"Restorative Slash","ja":"再起の斬撃","ko":"재기의 참격","zh_hant":"再起斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4751,"skill_field_effect_id":757,"_id_":7592,"skill_options":[{"id":309,"hit_rate":100,"target_id":11013,"times":[0,0,0,0,0],"values":[50,55,60,65,70]},{"id":10301,"hit_rate":100,"target_id":1001,"times":[99,99,99,99,99],"values":[0,0,0,0,0]},{"id":10295,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10286,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7593":{"attribute_id":3,"cost":2,"icon_id":380,"is_multiple_command_unique_skill":0,"name":{"en":"Sunlight Impale","ja":"サンライト・インペイル","ko":"선라이트 임페일","zh_hant":"陽光刺穿"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4752,"skill_field_effect_id":758,"_id_":7593,"skill_options":[{"id":10240,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"7610":{"attribute_id":2,"cost":1,"icon_id":371,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Resistance","ja":"耐性の狙撃","ko":"저항의 저격","zh_hant":"耐性狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4754,"skill_field_effect_id":761,"_id_":7610,"skill_options":[{"id":10290,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20012,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7611":{"attribute_id":2,"cost":2,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Hope","ja":"希望の狙撃","ko":"희망의 저격","zh_hant":"希望狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4755,"skill_field_effect_id":762,"_id_":7611,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20012,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7612":{"attribute_id":2,"cost":2,"icon_id":368,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Restoration","ja":"挽回の狙撃","ko":"만회의 저격","zh_hant":"挽救狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4756,"skill_field_effect_id":763,"_id_":7612,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10286,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":20012,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7613":{"attribute_id":2,"cost":2,"icon_id":382,"is_multiple_command_unique_skill":1,"name":{"en":"Scorpion's Devotion","ja":"大蠍の真心","ko":"전갈의 진심","zh_hant":"大蠍子的真心"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4757,"skill_field_effect_id":764,"_id_":7613,"skill_options":[{"id":10302,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":85,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]},{"id":20012,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7615":{"attribute_id":8,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4759,"skill_field_effect_id":767,"_id_":7615,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10120,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7616":{"attribute_id":8,"cost":2,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Hope","ja":"希望の斬撃","ko":"희망의 참격","zh_hant":"希望斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4760,"skill_field_effect_id":768,"_id_":7616,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7617":{"attribute_id":8,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4761,"skill_field_effect_id":769,"_id_":7617,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10040,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7618":{"attribute_id":8,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Cat's Revenge Encore","ja":"猫のお返し Encore","ko":"고양이의 보은 Encore","zh_hant":"貓的還擊 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4762,"skill_field_effect_id":770,"_id_":7618,"skill_options":[{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":85,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7620":{"attribute_id":1,"cost":1,"icon_id":378,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Resistance","ja":"耐性の打撃","ko":"저항의 타격","zh_hant":"耐性敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4764,"skill_field_effect_id":772,"_id_":7620,"skill_options":[{"id":20013,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10297,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7621":{"attribute_id":1,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Love","ja":"恋の打撃","ko":"사랑의 타격","zh_hant":"戀的敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4765,"skill_field_effect_id":773,"_id_":7621,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7622":{"attribute_id":1,"cost":2,"icon_id":351,"is_multiple_command_unique_skill":0,"name":{"en":"Electric Smash","ja":"感電の打撃","ko":"감전의 타격","zh_hant":"感電敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4766,"skill_field_effect_id":774,"_id_":7622,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7623":{"attribute_id":1,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":1,"name":{"en":"Brilliant Mahiru","ja":"キラめくまひるの舞台","ko":"반짝이는 마히루의 무대","zh_hant":"真晝的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4767,"skill_field_effect_id":775,"_id_":7623,"skill_options":[{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7625":{"attribute_id":2,"cost":2,"icon_id":359,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4769,"skill_field_effect_id":778,"_id_":7625,"skill_options":[{"id":10250,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":567,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7626":{"attribute_id":2,"cost":2,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Hope","ja":"希望の斬撃","ko":"희망의 참격","zh_hant":"希望斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4770,"skill_field_effect_id":779,"_id_":7626,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7627":{"attribute_id":2,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4771,"skill_field_effect_id":780,"_id_":7627,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7628":{"attribute_id":2,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Brilliant Suzu","ja":"キラめく涼の舞台","ko":"반짝이는 스즈의 무대","zh_hant":"涼的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4772,"skill_field_effect_id":781,"_id_":7628,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"7640":{"attribute_id":9,"cost":2,"icon_id":351,"is_multiple_command_unique_skill":0,"name":{"en":"Electric Strike","ja":"感電の一撃","ko":"감전의 일격","zh_hant":"感電一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4774,"skill_field_effect_id":784,"_id_":7640,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7641":{"attribute_id":9,"cost":2,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Hope","ja":"希望の一撃","ko":"희망의 일격","zh_hant":"希望一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4775,"skill_field_effect_id":785,"_id_":7641,"skill_options":[{"id":451,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":567,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7642":{"attribute_id":9,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Strike","ja":"致命の一撃","ko":"치명의 일격","zh_hant":"致命一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4776,"skill_field_effect_id":786,"_id_":7642,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7643":{"attribute_id":9,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Blossom Dance Encore","ja":"烈開花の舞踏 Encore","ko":"세찬 개화의 무도 Encore","zh_hant":"盛綻的舞步 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4777,"skill_field_effect_id":787,"_id_":7643,"skill_options":[{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[390,410,430,460,490]}]},"7645":{"attribute_id":4,"cost":1,"icon_id":375,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Liberation","ja":"解放の一撃","ko":"해방의 일격","zh_hant":"解放一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4779,"skill_field_effect_id":789,"_id_":7645,"skill_options":[{"id":89,"hit_rate":100,"target_id":1143,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":20010,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10294,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7646":{"attribute_id":4,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Love","ja":"恋の一撃","ko":"사랑의 일격","zh_hant":"戀的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4780,"skill_field_effect_id":790,"_id_":7646,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]}]},"7647":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Strike","ja":"煌めく一撃","ko":"빛나는 일격","zh_hant":"輝煌一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4781,"skill_field_effect_id":791,"_id_":7647,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":1001,"times":[99,99,99,99,99],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7648":{"attribute_id":4,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Weaving Gratitude","ja":"恩返しの機織り","ko":"보은의 길쌈","zh_hant":"織布以報恩"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4782,"skill_field_effect_id":792,"_id_":7648,"skill_options":[{"id":10311,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[200,200,200,200,200]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":20012,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7650":{"attribute_id":4,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4784,"skill_field_effect_id":795,"_id_":7650,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7651":{"attribute_id":4,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Strike","ja":"甘美な一撃","ko":"감미로운 일격","zh_hant":"甘美一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4785,"skill_field_effect_id":796,"_id_":7651,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7652":{"attribute_id":4,"cost":2,"icon_id":1068,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Ovation","ja":"万雷の一撃","ko":"만뢰의 일격","zh_hant":"萬雷一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4786,"skill_field_effect_id":797,"_id_":7652,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7653":{"attribute_id":4,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Phantom Thief Encore","ja":"神出鬼没の大怪盗 Encore","ko":"신출귀몰의 대괴도 Encore","zh_hant":"神出鬼沒的大怪盜 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4787,"skill_field_effect_id":798,"_id_":7653,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7655":{"attribute_id":9,"cost":1,"icon_id":389,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4789,"skill_field_effect_id":800,"_id_":7655,"skill_options":[{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20011,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10309,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7656":{"attribute_id":9,"cost":1,"icon_id":357,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Slash","ja":"守護の斬撃","ko":"수호의 참격","zh_hant":"守護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4790,"skill_field_effect_id":801,"_id_":7656,"skill_options":[{"id":10309,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10230,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7657":{"attribute_id":9,"cost":1,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4791,"skill_field_effect_id":802,"_id_":7657,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10230,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7658":{"attribute_id":9,"cost":1,"icon_id":390,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Maya","ja":"キラめく真矢の舞台","ko":"반짝이는 마야의 무대","zh_hant":"真矢的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4792,"skill_field_effect_id":803,"_id_":7658,"skill_options":[{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10310,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7660":{"attribute_id":7,"cost":1,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4794,"skill_field_effect_id":806,"_id_":7660,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20003,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10080,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]}]},"7661":{"attribute_id":7,"cost":2,"icon_id":347,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Fortitude","ja":"不屈の打撃","ko":"불굴의 타격","zh_hant":"不屈敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4795,"skill_field_effect_id":807,"_id_":7661,"skill_options":[{"id":10130,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]},{"id":10281,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7662":{"attribute_id":7,"cost":2,"icon_id":344,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Smash","ja":"回避の打撃","ko":"회피의 타격","zh_hant":"迴避敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4796,"skill_field_effect_id":808,"_id_":7662,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,190,200,210,220]},{"id":10281,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7663":{"attribute_id":7,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Shiro","ja":"キラめく詩呂の舞台","ko":"반짝이는 시로의 무대","zh_hant":"詩呂的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4797,"skill_field_effect_id":809,"_id_":7663,"skill_options":[{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"7665":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":811,"_id_":7665,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7666":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":742,"_id_":7666,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7667":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":811,"_id_":7667,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7668":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":742,"_id_":7668,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7669":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":742,"_id_":7669,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7670":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":811,"_id_":7670,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7671":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":742,"_id_":7671,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7672":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fire Flower Dance","ja":"炎花の舞","ko":"염화의 춤","zh_hant":"炎花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4799,"skill_field_effect_id":742,"_id_":7672,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7673":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4800,"skill_field_effect_id":742,"_id_":7673,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7675":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":7675,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7676":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":7676,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7677":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":7677,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7678":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":7678,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7679":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":7679,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7680":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":7680,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7681":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":7681,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7682":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":7682,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7684":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":7684,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7685":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":7685,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7686":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":7686,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7687":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":7687,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7688":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":7688,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7689":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":7689,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7690":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":7690,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7691":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":7691,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"7692":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":7692,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7693":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":7693,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7695":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":7695,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7696":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":7696,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7697":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":7697,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7698":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":7698,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7699":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":7699,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7700":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":7700,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"7701":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":7701,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7702":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":7702,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7703":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":7703,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7705":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":811,"_id_":7705,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7706":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":742,"_id_":7706,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7707":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":811,"_id_":7707,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7708":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":742,"_id_":7708,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7709":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":742,"_id_":7709,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7710":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":811,"_id_":7710,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7711":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":742,"_id_":7711,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7712":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fire Flower Dance","ja":"炎花の舞","ko":"염화의 춤","zh_hant":"炎花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4799,"skill_field_effect_id":742,"_id_":7712,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"7713":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4800,"skill_field_effect_id":742,"_id_":7713,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"7715":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":7715,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7716":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":7716,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7717":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":7717,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7718":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":7718,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7719":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":7719,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7720":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":7720,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7721":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":7721,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7722":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":7722,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7724":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":7724,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7725":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":7725,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7726":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":7726,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7727":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":7727,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7728":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":7728,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7729":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":7729,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7730":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":7730,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7731":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":7731,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"7732":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":7732,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7733":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":7733,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7735":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":7735,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7736":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":7736,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7737":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":7737,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7738":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":7738,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7739":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":7739,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7740":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":7740,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"7741":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":7741,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7742":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":7742,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7743":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":7743,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7745":{"attribute_id":6,"cost":1,"icon_id":367,"is_multiple_command_unique_skill":0,"name":{"en":"Antistatic Flash","ja":"耐電の一閃","ko":"내전의 일섬","zh_hant":"耐電閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4807,"skill_field_effect_id":813,"_id_":7745,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20006,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10285,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7746":{"attribute_id":6,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Love","ja":"恋の一閃","ko":"사랑의 일섬","zh_hant":"戀的閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4808,"skill_field_effect_id":814,"_id_":7746,"skill_options":[{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7747":{"attribute_id":6,"cost":2,"icon_id":392,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Reduction","ja":"減少の一閃","ko":"감소의 일섬","zh_hant":"減少閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4809,"skill_field_effect_id":815,"_id_":7747,"skill_options":[{"id":10312,"hit_rate":100,"target_id":4193,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10110,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7748":{"attribute_id":6,"cost":2,"icon_id":393,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Ichie","ja":"キラめくいちえの舞台","ko":"반짝이는 이치에의 무대","zh_hant":"一愛的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4810,"skill_field_effect_id":816,"_id_":7748,"skill_options":[{"id":621,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[99,99,99,99,99]},{"id":10312,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":85,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7750":{"attribute_id":1,"cost":1,"icon_id":378,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4812,"skill_field_effect_id":819,"_id_":7750,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20013,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10297,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7751":{"attribute_id":1,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4813,"skill_field_effect_id":820,"_id_":7751,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7752":{"attribute_id":1,"cost":2,"icon_id":395,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Protection","ja":"加護の斬撃","ko":"가호의 참격","zh_hant":"加護斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4814,"skill_field_effect_id":821,"_id_":7752,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10315,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7753":{"attribute_id":1,"cost":2,"icon_id":395,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Claudine","ja":"キラめくクロディーヌの舞台","ko":"반짝이는 클로딘의 무대","zh_hant":"克洛迪娜的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4815,"skill_field_effect_id":822,"_id_":7753,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10315,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7755":{"attribute_id":3,"cost":1,"icon_id":397,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4817,"skill_field_effect_id":825,"_id_":7755,"skill_options":[{"id":20014,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10318,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7756":{"attribute_id":3,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4818,"skill_field_effect_id":826,"_id_":7756,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7757":{"attribute_id":3,"cost":2,"icon_id":1093,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Slumber","ja":"睡眠の斬撃","ko":"수면의 참격","zh_hant":"睡眠斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4819,"skill_field_effect_id":827,"_id_":7757,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10170,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[15000,15000,15000,15000,15000]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7758":{"attribute_id":3,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Unclouded Love","ja":"曇りなき愛の情動","ko":"투명한 사랑의 감정","zh_hant":"純粹的愛意"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4820,"skill_field_effect_id":828,"_id_":7758,"skill_options":[{"id":20014,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20012,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7760":{"attribute_id":1,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4822,"skill_field_effect_id":831,"_id_":7760,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7761":{"attribute_id":1,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4823,"skill_field_effect_id":832,"_id_":7761,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7762":{"attribute_id":1,"cost":2,"icon_id":1065,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4824,"skill_field_effect_id":833,"_id_":7762,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7763":{"attribute_id":1,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Scarlet Moon Blade Encore","ja":"緋色斬月 Encore","ko":"비색참월 Encore","zh_hant":"緋色斬月 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4825,"skill_field_effect_id":834,"_id_":7763,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7765":{"attribute_id":6,"cost":1,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4827,"skill_field_effect_id":836,"_id_":7765,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10309,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"7766":{"attribute_id":6,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4828,"skill_field_effect_id":837,"_id_":7766,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":20007,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"7767":{"attribute_id":6,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4829,"skill_field_effect_id":838,"_id_":7767,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10292,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20012,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"7768":{"attribute_id":6,"cost":2,"icon_id":399,"is_multiple_command_unique_skill":0,"name":{"en":"Unmovable Star","ja":"不動の星","ko":"부동의 별","zh_hant":"不動之星"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4830,"skill_field_effect_id":839,"_id_":7768,"skill_options":[{"id":622,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":619,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"7770":{"attribute_id":5,"cost":1,"icon_id":402,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Resistance","ja":"耐性の打撃","ko":"저항의 타격","zh_hant":"耐性敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4832,"skill_field_effect_id":842,"_id_":7770,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20015,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10322,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7771":{"attribute_id":5,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Fainting","ja":"失神の打撃","ko":"실신의 타격","zh_hant":"昏厥敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4833,"skill_field_effect_id":843,"_id_":7771,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7772":{"attribute_id":5,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Freezing","ja":"凍結の打撃","ko":"동결의 타격","zh_hant":"凍結敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4834,"skill_field_effect_id":844,"_id_":7772,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7773":{"attribute_id":5,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Lalafin","ja":"キラめくララフィンの舞台","ko":"반짝이는 라라핀의 무대","zh_hant":"菈樂菲的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4835,"skill_field_effect_id":845,"_id_":7773,"skill_options":[{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"7802":{"attribute_id":6,"cost":1,"icon_id":378,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4842,"skill_field_effect_id":848,"_id_":7802,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20013,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10297,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7803":{"attribute_id":6,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Surprise Slash","ja":"奇襲の斬撃","ko":"기습의 참격","zh_hant":"奇襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4843,"skill_field_effect_id":849,"_id_":7803,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7804":{"attribute_id":6,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4844,"skill_field_effect_id":850,"_id_":7804,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7805":{"attribute_id":6,"cost":2,"icon_id":407,"is_multiple_command_unique_skill":0,"name":{"en":"Supreme Medicine","ja":"至高の医術","ko":"최고의 의술","zh_hant":"頂級醫術"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4845,"skill_field_effect_id":851,"_id_":7805,"skill_options":[{"id":10328,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":85,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7807":{"attribute_id":2,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4847,"skill_field_effect_id":854,"_id_":7807,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"7808":{"attribute_id":2,"cost":2,"icon_id":1094,"is_multiple_command_unique_skill":0,"name":{"en":"Hindering Slash","ja":"妨害の斬撃","ko":"방해의 참격","zh_hant":"妨礙斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4848,"skill_field_effect_id":855,"_id_":7808,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20016,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7809":{"attribute_id":2,"cost":2,"icon_id":1093,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4849,"skill_field_effect_id":856,"_id_":7809,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20016,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7810":{"attribute_id":2,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Overflowing Blessing","ja":"溢れる女神の祝福","ko":"넘치는 여신의 축복","zh_hant":"滿溢的女神祝福"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4850,"skill_field_effect_id":857,"_id_":7810,"skill_options":[{"id":20016,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":20012,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7812":{"attribute_id":6,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4852,"skill_field_effect_id":860,"_id_":7812,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7813":{"attribute_id":6,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Slash","ja":"甘美な斬撃","ko":"감미로운 참격","zh_hant":"甘美斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4853,"skill_field_effect_id":861,"_id_":7813,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7814":{"attribute_id":6,"cost":2,"icon_id":1070,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Ovation","ja":"万雷の斬撃","ko":"만뢰의 참격","zh_hant":"萬雷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4854,"skill_field_effect_id":862,"_id_":7814,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7815":{"attribute_id":6,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Parting Tamatebako Encore","ja":"別離の玉手箱 Encore","ko":"이별의 보물상자 Encore","zh_hant":"離別的玉手箱 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4855,"skill_field_effect_id":863,"_id_":7815,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7817":{"attribute_id":3,"cost":2,"icon_id":371,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4857,"skill_field_effect_id":865,"_id_":7817,"skill_options":[{"id":10290,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7818":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4858,"skill_field_effect_id":866,"_id_":7818,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7819":{"attribute_id":3,"cost":2,"icon_id":364,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4859,"skill_field_effect_id":867,"_id_":7819,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[40,40,40,40,40]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[40,40,40,40,40]},{"id":10120,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[40,40,40,40,40]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7820":{"attribute_id":3,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Brilliant Michiru","ja":"キラめくミチルの舞台","ko":"반짝이는 미치루의 무대","zh_hant":"未知留的閃耀舞台"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4860,"skill_field_effect_id":868,"_id_":7820,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10324,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"7847":{"attribute_id":3,"cost":1,"icon_id":402,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4882,"skill_field_effect_id":877,"_id_":7847,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":20015,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10322,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10312,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7848":{"attribute_id":3,"cost":2,"icon_id":363,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Slumber","ja":"睡眠の斬撃","ko":"수면의 참격","zh_hant":"睡眠斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4883,"skill_field_effect_id":878,"_id_":7848,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10312,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7849":{"attribute_id":3,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4884,"skill_field_effect_id":879,"_id_":7849,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10312,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7850":{"attribute_id":3,"cost":2,"icon_id":409,"is_multiple_command_unique_skill":0,"name":{"en":"Sun's Pride","ja":"天道の誇り","ko":"태양의 긍지","zh_hant":"太陽的驕傲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4885,"skill_field_effect_id":880,"_id_":7850,"skill_options":[{"id":10330,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10312,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"7852":{"attribute_id":6,"cost":2,"icon_id":359,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4887,"skill_field_effect_id":883,"_id_":7852,"skill_options":[{"id":10250,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7853":{"attribute_id":6,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4888,"skill_field_effect_id":884,"_id_":7853,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7854":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Applauses","ja":"喝采の斬撃","ko":"갈채의 참격","zh_hant":"喝采斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4889,"skill_field_effect_id":885,"_id_":7854,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"7855":{"attribute_id":6,"cost":2,"icon_id":1041,"is_multiple_command_unique_skill":1,"name":{"en":"Feelings for Isolde Encore","ja":"イゾルデへの想い Encore","ko":"이졸데를 향한 마음 Encore","zh_hant":"對伊索德的思念 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4890,"skill_field_effect_id":886,"_id_":7855,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"7867":{"attribute_id":2,"cost":2,"icon_id":363,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Sleep","ja":"睡眠の刺突","ko":"수면의 찌르기","zh_hant":"睡眠突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4892,"skill_field_effect_id":889,"_id_":7867,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"7868":{"attribute_id":2,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Fainting","ja":"失神の刺突","ko":"실신의 찌르기","zh_hant":"昏厥突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4893,"skill_field_effect_id":890,"_id_":7868,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7869":{"attribute_id":2,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Love","ja":"恋の刺突","ko":"사랑의 찌르기","zh_hant":"戀的突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4894,"skill_field_effect_id":891,"_id_":7869,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7870":{"attribute_id":2,"cost":2,"icon_id":412,"is_multiple_command_unique_skill":0,"name":{"en":"Lightning of Blessing","ja":"Lightning of Blessing","ko":"Lightning of Blessing","zh_hant":"Lightning of Blessing"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4895,"skill_field_effect_id":892,"_id_":7870,"skill_options":[{"id":10339,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[80,80,80,80,80]},{"id":10340,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[80,80,80,80,80]},{"id":10130,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"7872":{"attribute_id":8,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Thrust","ja":"軽快な刺突","ko":"경쾌한 찌르기","zh_hant":"輕快突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4897,"skill_field_effect_id":895,"_id_":7872,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7873":{"attribute_id":8,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Thrust","ja":"甘美な刺突","ko":"감미로운 찌르기","zh_hant":"甘美突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4898,"skill_field_effect_id":896,"_id_":7873,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7874":{"attribute_id":8,"cost":2,"icon_id":1097,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Ovation","ja":"万雷の刺突","ko":"만뢰의 찌르기","zh_hant":"萬雷突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4899,"skill_field_effect_id":897,"_id_":7874,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"7875":{"attribute_id":8,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Secret Mission Encore","ja":"シークレット・ミッション Encore","ko":"시크릿 미션 Encore","zh_hant":"Secret Mission Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4900,"skill_field_effect_id":898,"_id_":7875,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"7877":{"attribute_id":4,"cost":1,"icon_id":378,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4902,"skill_field_effect_id":900,"_id_":7877,"skill_options":[{"id":20013,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10297,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10329,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7878":{"attribute_id":4,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4903,"skill_field_effect_id":901,"_id_":7878,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7879":{"attribute_id":4,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4904,"skill_field_effect_id":902,"_id_":7879,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"7880":{"attribute_id":4,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Crossbones Slash Encore","ja":"クロスボーンスラッシュ Encore","ko":"크로스 본 슬래시 Encore","zh_hant":"海盜斜斬 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4905,"skill_field_effect_id":903,"_id_":7880,"skill_options":[{"id":10341,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[99999,99999,99999,99999,99999]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"7882":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":7882,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7883":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":7883,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7884":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":7884,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7885":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":7885,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7886":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":7886,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"7887":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":7887,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"7888":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":7888,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7889":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":7889,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7890":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":7890,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7892":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":7892,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7893":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":7893,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7894":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":7894,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7895":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":7895,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7896":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":7896,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7897":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":7897,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7898":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":7898,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7899":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":7899,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7900":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":7900,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7901":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":7901,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7902":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":7902,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7904":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":7904,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7905":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":7905,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7906":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":7906,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7907":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":7907,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7908":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":7908,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7909":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":7909,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7910":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":7910,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"7911":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":7911,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7912":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":7912,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7913":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":7913,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7914":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":7914,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7916":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":7916,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7917":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":7917,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7918":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":7918,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7919":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":7919,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7920":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":7920,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7921":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":7921,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7922":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":7922,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"7923":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":7923,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7924":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":7924,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7925":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":7925,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7926":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":7926,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"7928":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":811,"_id_":7928,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7929":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":7929,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7930":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":742,"_id_":7930,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7931":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":7931,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7932":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":7932,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7933":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":7933,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7934":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":7934,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7935":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":7935,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7936":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":7936,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7937":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":7937,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"7938":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":7938,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"7940":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":7940,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7941":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":7941,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7942":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":7942,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7943":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":7943,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7944":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":7944,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7945":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":7945,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7946":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":7946,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7947":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":7947,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7948":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":7948,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7949":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":7949,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7950":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":7950,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7952":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":742,"_id_":7952,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7953":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":7953,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7954":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":811,"_id_":7954,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7955":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":7955,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7956":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":7956,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7957":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":7957,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"7958":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":7958,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7959":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":7959,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"7960":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":7960,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7961":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":7961,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7962":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":7962,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7964":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":7964,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7965":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":7965,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"7966":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":7966,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7967":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":7967,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7968":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":7968,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7969":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":7969,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7970":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":7970,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"7971":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":7971,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"7972":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":7972,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7973":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":7973,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7974":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":7974,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"7976":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":742,"_id_":7976,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7977":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":742,"_id_":7977,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7978":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":742,"_id_":7978,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7979":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":811,"_id_":7979,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7980":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":742,"_id_":7980,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7981":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":742,"_id_":7981,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7982":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":811,"_id_":7982,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7983":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4613,"skill_field_effect_id":742,"_id_":7983,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7984":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4614,"skill_field_effect_id":742,"_id_":7984,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7986":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":7986,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7987":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":7987,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7988":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":7988,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"7989":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":7989,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7990":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":7990,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"7991":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":7991,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7992":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":7992,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"7993":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":7993,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7994":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":7994,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"7996":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2347,"skill_field_effect_id":742,"_id_":7996,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"7997":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2348,"skill_field_effect_id":742,"_id_":7997,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"7998":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2349,"skill_field_effect_id":742,"_id_":7998,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"7999":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2350,"skill_field_effect_id":811,"_id_":7999,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8000":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2351,"skill_field_effect_id":742,"_id_":8000,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8001":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2352,"skill_field_effect_id":742,"_id_":8001,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8002":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2353,"skill_field_effect_id":811,"_id_":8002,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8003":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4613,"skill_field_effect_id":742,"_id_":8003,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8004":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dance of Hope NEO","ja":"希望の乱舞 NEO","ko":"희망의 난무 NEO","zh_hant":"希望亂舞 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4614,"skill_field_effect_id":742,"_id_":8004,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8006":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":8006,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8007":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":8007,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8008":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":8008,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8009":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":8009,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8010":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":8010,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8011":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":8011,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8012":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":8012,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8013":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":8013,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8014":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":8014,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8016":{"attribute_id":1,"cost":1,"icon_id":402,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Resistance","ja":"耐性の狙撃","ko":"저항의 저격","zh_hant":"耐性狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4907,"skill_field_effect_id":906,"_id_":8016,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20015,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10322,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8017":{"attribute_id":1,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Poison","ja":"毒の狙撃","ko":"독의 저격","zh_hant":"中毒狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4908,"skill_field_effect_id":907,"_id_":8017,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20017,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8018":{"attribute_id":1,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Love","ja":"恋の狙撃","ko":"사랑의 저격","zh_hant":"戀的狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4909,"skill_field_effect_id":908,"_id_":8018,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20017,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8019":{"attribute_id":1,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Chest of Glory Encore","ja":"チェストオブグローリー Encore","ko":"체스트 오브 글로리 Encore","zh_hant":"榮耀之箱 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4910,"skill_field_effect_id":909,"_id_":8019,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8021":{"attribute_id":8,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Slash","ja":"煌めく斬撃","ko":"빛나는 참격","zh_hant":"輝煌斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4912,"skill_field_effect_id":912,"_id_":8021,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[70,70,70,70,70]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8022":{"attribute_id":8,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Surprise Slash","ja":"奇襲の斬撃","ko":"기습의 참격","zh_hant":"奇襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4913,"skill_field_effect_id":913,"_id_":8022,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8023":{"attribute_id":8,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4914,"skill_field_effect_id":914,"_id_":8023,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10302,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8024":{"attribute_id":8,"cost":2,"icon_id":1100,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Log","ja":"甘い切り株","ko":"달콤한 통나무","zh_hant":"甜蜜的樹幹蛋糕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4915,"skill_field_effect_id":915,"_id_":8024,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10330,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"8026":{"attribute_id":5,"cost":1,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4917,"skill_field_effect_id":918,"_id_":8026,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10338,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8027":{"attribute_id":5,"cost":2,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Hope","ja":"希望の打撃","ko":"희망의 타격","zh_hant":"希望敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4918,"skill_field_effect_id":919,"_id_":8027,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10338,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8028":{"attribute_id":5,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Superstrength","ja":"怪力の打撃","ko":"괴력의 타격","zh_hant":"怪力敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4919,"skill_field_effect_id":920,"_id_":8028,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10338,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8029":{"attribute_id":5,"cost":2,"icon_id":344,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet Encore","ja":"金鳳花の絨毯 Encore","ko":"미나리아재비의 양탄자 Encore","zh_hant":"毛茛地毯 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4920,"skill_field_effect_id":921,"_id_":8029,"skill_options":[{"id":10110,"hit_rate":100,"target_id":1002,"times":[5,5,5,5,5],"values":[0,0,0,0,0]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8031":{"attribute_id":4,"cost":1,"icon_id":383,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Hope","ja":"希望の打撃","ko":"희망의 타격","zh_hant":"希望敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4922,"skill_field_effect_id":923,"_id_":8031,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10303,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10290,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8032":{"attribute_id":4,"cost":2,"icon_id":364,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4923,"skill_field_effect_id":924,"_id_":8032,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8033":{"attribute_id":4,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Smash","ja":"封印の打撃","ko":"봉인의 타격","zh_hant":"封印敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4924,"skill_field_effect_id":925,"_id_":8033,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]},{"id":20009,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8034":{"attribute_id":4,"cost":2,"icon_id":409,"is_multiple_command_unique_skill":0,"name":{"en":"Flickering Bubbles","ja":"泡沫のゆらめき","ko":"거품의 반짝임","zh_hant":"搖曳泡沫"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4925,"skill_field_effect_id":926,"_id_":8034,"skill_options":[{"id":622,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10330,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8036":{"attribute_id":9,"cost":2,"icon_id":157,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Smash","ja":"軽快な打撃","ko":"경쾌한 타격","zh_hant":"輕快敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4927,"skill_field_effect_id":929,"_id_":8036,"skill_options":[{"id":157,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"8037":{"attribute_id":9,"cost":2,"icon_id":1030,"is_multiple_command_unique_skill":0,"name":{"en":"Sweet Smash","ja":"甘美な打撃","ko":"감미로운 타격","zh_hant":"甘美敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4928,"skill_field_effect_id":930,"_id_":8037,"skill_options":[{"id":128,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"8038":{"attribute_id":9,"cost":2,"icon_id":1099,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Ovation","ja":"万雷の打撃","ko":"만뢰의 타격","zh_hant":"萬雷敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4929,"skill_field_effect_id":931,"_id_":8038,"skill_options":[{"id":22,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":39,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[170,180,190,200,210]}]},"8039":{"attribute_id":9,"cost":2,"icon_id":1035,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance Encore","ja":"青龍炎舞 Encore","ko":"청룡염무 Encore","zh_hant":"青龍炎舞 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4930,"skill_field_effect_id":932,"_id_":8039,"skill_options":[{"id":494,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":360,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":392,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[350,370,390,420,450]}]},"8053":{"attribute_id":5,"cost":2,"icon_id":420,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Resistance","ja":"耐性の打撃","ko":"저항의 타격","zh_hant":"耐性敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4933,"skill_field_effect_id":934,"_id_":8053,"skill_options":[{"id":20015,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10348,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8054":{"attribute_id":5,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Fainting","ja":"失神の打撃","ko":"실신의 타격","zh_hant":"昏厥敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4934,"skill_field_effect_id":935,"_id_":8054,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8055":{"attribute_id":5,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4935,"skill_field_effect_id":936,"_id_":8055,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8056":{"attribute_id":5,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":1,"name":{"en":"Thunderclap","ja":"闇戯雷鳴","ko":"암희뇌명","zh_hant":"暗戲雷鳴"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4936,"skill_field_effect_id":937,"_id_":8056,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8058":{"attribute_id":2,"cost":1,"icon_id":378,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4938,"skill_field_effect_id":940,"_id_":8058,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20013,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10297,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8059":{"attribute_id":2,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4939,"skill_field_effect_id":941,"_id_":8059,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":20009,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8060":{"attribute_id":2,"cost":2,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4940,"skill_field_effect_id":942,"_id_":8060,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":20009,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8061":{"attribute_id":2,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Pure Knight Encore","ja":"穢れなき騎士 Encore","ko":"고결한 기사 Encore","zh_hant":"無垢的騎士 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4941,"skill_field_effect_id":943,"_id_":8061,"skill_options":[{"id":10299,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[30,30,30,30,30]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8063":{"attribute_id":1,"cost":2,"icon_id":423,"is_multiple_command_unique_skill":0,"name":{"en":"Resistance Strike","ja":"耐性の一撃","ko":"저항의 일격","zh_hant":"耐性一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4943,"skill_field_effect_id":946,"_id_":8063,"skill_options":[{"id":20018,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10351,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8064":{"attribute_id":1,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4944,"skill_field_effect_id":947,"_id_":8064,"skill_options":[{"id":10303,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8065":{"attribute_id":1,"cost":2,"icon_id":274,"is_multiple_command_unique_skill":0,"name":{"en":"Absorb Strike","ja":"吸収の一撃","ko":"흡수의 일격","zh_hant":"吸收一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4945,"skill_field_effect_id":948,"_id_":8065,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8066":{"attribute_id":1,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Avalon's Invitation Encore","ja":"アヴァロンへの誘い Encore","ko":"아발론으로의 초대 Encore","zh_hant":"阿瓦隆的邀請 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4946,"skill_field_effect_id":949,"_id_":8066,"skill_options":[{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10324,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8068":{"attribute_id":9,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4948,"skill_field_effect_id":952,"_id_":8068,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8069":{"attribute_id":9,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Impudence","ja":"慢心の斬撃","ko":"방심의 참격","zh_hant":"傲慢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4949,"skill_field_effect_id":953,"_id_":8069,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8070":{"attribute_id":9,"cost":2,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4950,"skill_field_effect_id":954,"_id_":8070,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8071":{"attribute_id":9,"cost":2,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Legendary Hero Encore","ja":"伝説の勇者 Encore","ko":"전설의 용사 Encore","zh_hant":"傳說的勇者 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4951,"skill_field_effect_id":955,"_id_":8071,"skill_options":[{"id":10353,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8113":{"attribute_id":3,"cost":1,"icon_id":423,"is_multiple_command_unique_skill":0,"name":{"en":"Resistance Flash","ja":"耐性の一閃","ko":"저항의 일섬","zh_hant":"耐性閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4973,"skill_field_effect_id":958,"_id_":8113,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20018,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10351,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8114":{"attribute_id":3,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Poison","ja":"毒の一閃","ko":"독의 일섬","zh_hant":"中毒閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4974,"skill_field_effect_id":959,"_id_":8114,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20019,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]}]},"8115":{"attribute_id":3,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Love","ja":"恋の一閃","ko":"사랑의 일섬","zh_hant":"戀的閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4975,"skill_field_effect_id":960,"_id_":8115,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20019,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8116":{"attribute_id":3,"cost":2,"icon_id":426,"is_multiple_command_unique_skill":0,"name":{"en":"The World Is Rosy","ja":"The world is rosy","ko":"The world is rosy","zh_hant":"The world is rosy"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4976,"skill_field_effect_id":961,"_id_":8116,"skill_options":[{"id":623,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":20019,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8118":{"attribute_id":2,"cost":1,"icon_id":420,"is_multiple_command_unique_skill":0,"name":{"en":"Resistance Flash","ja":"耐性の一閃","ko":"저항의 일섬","zh_hant":"耐性閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4978,"skill_field_effect_id":964,"_id_":8118,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":570,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10348,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8119":{"attribute_id":2,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Impudence","ja":"慢心の一閃","ko":"방심의 일섬","zh_hant":"傲慢閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4979,"skill_field_effect_id":965,"_id_":8119,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8120":{"attribute_id":2,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Flash","ja":"軽快な一閃","ko":"경쾌한 일섬","zh_hant":"輕快閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4980,"skill_field_effect_id":966,"_id_":8120,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]},{"id":20017,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8121":{"attribute_id":2,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Yellow Tornado Encore","ja":"イエローファイントルネード Encore","ko":"옐로우 파인 토네이도 Encore","zh_hant":"燦黃龍捲風 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4981,"skill_field_effect_id":967,"_id_":8121,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10330,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":383,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":587,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8123":{"attribute_id":5,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Strike","ja":"封印の一撃","ko":"봉인의 일격","zh_hant":"封印一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4983,"skill_field_effect_id":970,"_id_":8123,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8124":{"attribute_id":5,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4984,"skill_field_effect_id":971,"_id_":8124,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8125":{"attribute_id":5,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4985,"skill_field_effect_id":972,"_id_":8125,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8126":{"attribute_id":5,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":1,"name":{"en":"Conflagration of the Black Lion","ja":"黒獅子の劫火","ko":"흑사자의 겁화","zh_hant":"黑獅子劫火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4986,"skill_field_effect_id":973,"_id_":8126,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8140":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3221,"skill_field_effect_id":0,"_id_":8140,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8141":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3222,"skill_field_effect_id":0,"_id_":8141,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8142":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3223,"skill_field_effect_id":0,"_id_":8142,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8143":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3224,"skill_field_effect_id":0,"_id_":8143,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8144":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3225,"skill_field_effect_id":0,"_id_":8144,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"8145":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3226,"skill_field_effect_id":0,"_id_":8145,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"8146":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3227,"skill_field_effect_id":0,"_id_":8146,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"8147":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3228,"skill_field_effect_id":0,"_id_":8147,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8148":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3229,"skill_field_effect_id":0,"_id_":8148,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"8150":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":8150,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8151":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":8151,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8152":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":8152,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8153":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":8153,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8154":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":8154,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8155":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":8155,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8156":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":8156,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8157":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":8157,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8158":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":8158,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"8160":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3257,"skill_field_effect_id":0,"_id_":8160,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8161":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3258,"skill_field_effect_id":0,"_id_":8161,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8162":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3259,"skill_field_effect_id":0,"_id_":8162,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8163":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3260,"skill_field_effect_id":0,"_id_":8163,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8164":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3261,"skill_field_effect_id":0,"_id_":8164,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8165":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3262,"skill_field_effect_id":0,"_id_":8165,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"8166":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3263,"skill_field_effect_id":0,"_id_":8166,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"8167":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3264,"skill_field_effect_id":0,"_id_":8167,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8168":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3265,"skill_field_effect_id":0,"_id_":8168,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"8170":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":8170,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8171":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":8171,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8172":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":8172,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8173":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":8173,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8174":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":8174,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8175":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":8175,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8176":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":8176,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8177":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":8177,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"8178":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":8178,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8179":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":8179,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"8181":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":811,"_id_":8181,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8182":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":742,"_id_":8182,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8183":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":742,"_id_":8183,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8184":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":811,"_id_":8184,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8185":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":742,"_id_":8185,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8186":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":742,"_id_":8186,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8187":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":811,"_id_":8187,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8188":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":742,"_id_":8188,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8190":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":8190,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8191":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":8191,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8192":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":8192,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8193":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":8193,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8194":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":8194,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8195":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":8195,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8196":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":8196,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8197":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":8197,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8198":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":8198,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8199":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":8199,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8201":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":811,"_id_":8201,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8202":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":742,"_id_":8202,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8203":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":742,"_id_":8203,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8204":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":742,"_id_":8204,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8205":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":811,"_id_":8205,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8206":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":742,"_id_":8206,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8207":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":742,"_id_":8207,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8208":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":742,"_id_":8208,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8209":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":811,"_id_":8209,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8210":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":742,"_id_":8210,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8212":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":8212,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8213":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":8213,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8214":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":8214,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8215":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":8215,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8216":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":8216,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"8217":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":8217,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8218":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":8218,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8219":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":8219,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8221":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":811,"_id_":8221,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8222":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":742,"_id_":8222,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8223":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":742,"_id_":8223,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8224":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":811,"_id_":8224,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8225":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":742,"_id_":8225,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8226":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":742,"_id_":8226,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8227":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":811,"_id_":8227,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8228":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":742,"_id_":8228,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8230":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":8230,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8231":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":8231,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8232":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":8232,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8233":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":8233,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8234":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":8234,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8235":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":8235,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8236":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":8236,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8237":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":8237,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8238":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":8238,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8239":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":8239,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8241":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":811,"_id_":8241,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8242":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":742,"_id_":8242,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8243":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":742,"_id_":8243,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8244":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":742,"_id_":8244,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8245":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":811,"_id_":8245,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8246":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":742,"_id_":8246,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8247":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":742,"_id_":8247,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8248":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":742,"_id_":8248,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8249":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":811,"_id_":8249,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8250":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":742,"_id_":8250,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8252":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":8252,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8253":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":8253,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8254":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":8254,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8255":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":8255,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8256":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":8256,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"8257":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":8257,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8258":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":8258,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8259":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":8259,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8261":{"attribute_id":9,"cost":1,"icon_id":434,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4989,"skill_field_effect_id":976,"_id_":8261,"skill_options":[{"id":10362,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"8262":{"attribute_id":9,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Slash","ja":"煌めく斬撃","ko":"빛나는 참격","zh_hant":"輝煌斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4990,"skill_field_effect_id":977,"_id_":8262,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8263":{"attribute_id":9,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4991,"skill_field_effect_id":978,"_id_":8263,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8264":{"attribute_id":9,"cost":2,"icon_id":407,"is_multiple_command_unique_skill":1,"name":{"en":"Arrow of Heaven","ja":"天上の光矢","ko":"천상의 빛 화살","zh_hant":"天上光箭"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4992,"skill_field_effect_id":979,"_id_":8264,"skill_options":[{"id":10328,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8266":{"attribute_id":4,"cost":1,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Poison","ja":"毒の斬撃","ko":"독의 참격","zh_hant":"中毒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4994,"skill_field_effect_id":982,"_id_":8266,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20018,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":276,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8267":{"attribute_id":4,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4995,"skill_field_effect_id":983,"_id_":8267,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20019,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":276,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8268":{"attribute_id":4,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4996,"skill_field_effect_id":984,"_id_":8268,"skill_options":[{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":276,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8269":{"attribute_id":4,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Piercing Evil Encore","ja":"破邪の貫き Encore","ko":"퇴마의 꿰뚫기 Encore","zh_hant":"貫穿邪惡 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4997,"skill_field_effect_id":985,"_id_":8269,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20008,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[99999,99999,99999,99999,99999]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[99999,99999,99999,99999,99999]},{"id":276,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"8271":{"attribute_id":1,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Poison","ja":"毒の斬撃","ko":"독의 참격","zh_hant":"中毒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4999,"skill_field_effect_id":988,"_id_":8271,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8272":{"attribute_id":1,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5000,"skill_field_effect_id":989,"_id_":8272,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8273":{"attribute_id":1,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5001,"skill_field_effect_id":990,"_id_":8273,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8274":{"attribute_id":1,"cost":2,"icon_id":435,"is_multiple_command_unique_skill":0,"name":{"en":"Love Is Rosy","ja":"The love is rosy","ko":"The love is rosy","zh_hant":"The love is rosy"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5002,"skill_field_effect_id":991,"_id_":8274,"skill_options":[{"id":10363,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[260,270,280,290,300]}]},"8291":{"attribute_id":3,"cost":2,"icon_id":439,"is_multiple_command_unique_skill":0,"name":{"en":"Hindering Slash","ja":"妨害の斬撃","ko":"방해의 참격","zh_hant":"妨礙斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5008,"skill_field_effect_id":994,"_id_":8291,"skill_options":[{"id":20016,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10367,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8292":{"attribute_id":3,"cost":2,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5009,"skill_field_effect_id":995,"_id_":8292,"skill_options":[{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8293":{"attribute_id":3,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5010,"skill_field_effect_id":996,"_id_":8293,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8294":{"attribute_id":3,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":1,"name":{"en":"Healing Guidance","ja":"癒しの導き","ko":"치유의 인도","zh_hant":"治癒指引"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5011,"skill_field_effect_id":997,"_id_":8294,"skill_options":[{"id":20016,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8296":{"attribute_id":4,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5013,"skill_field_effect_id":1000,"_id_":8296,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8297":{"attribute_id":4,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5014,"skill_field_effect_id":1001,"_id_":8297,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8298":{"attribute_id":4,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5015,"skill_field_effect_id":1002,"_id_":8298,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8299":{"attribute_id":4,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Orpheus's Melody Encore","ja":"オルフェウスの調べ Encore","ko":"오르페우스의 멜로디 Encore","zh_hant":"奧菲斯的旋律 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5016,"skill_field_effect_id":1003,"_id_":8299,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8326":{"attribute_id":6,"cost":2,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Slash","ja":"火炎の斬撃","ko":"화염의 참격","zh_hant":"火焰斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5038,"skill_field_effect_id":1006,"_id_":8326,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8327":{"attribute_id":6,"cost":2,"icon_id":337,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Frost","ja":"凍結の斬撃","ko":"동결의 참격","zh_hant":"凍結斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5039,"skill_field_effect_id":1007,"_id_":8327,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10040,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8328":{"attribute_id":6,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5040,"skill_field_effect_id":1008,"_id_":8328,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[50,50,50,50,50]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8329":{"attribute_id":6,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":1,"name":{"en":"Toys - Psychokinesis Encore","ja":"トイズ～サイコキネシス～ Encore","ko":"토이즈 ~사이코키네시스~ Encore","zh_hant":"TOYS～念動力～ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5041,"skill_field_effect_id":1009,"_id_":8329,"skill_options":[{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8331":{"attribute_id":8,"cost":1,"icon_id":436,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5043,"skill_field_effect_id":1012,"_id_":8331,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10364,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10362,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8332":{"attribute_id":8,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fainting","ja":"失神の斬撃","ko":"실신의 참격","zh_hant":"昏厥斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5044,"skill_field_effect_id":1013,"_id_":8332,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8333":{"attribute_id":8,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5045,"skill_field_effect_id":1014,"_id_":8333,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8334":{"attribute_id":8,"cost":2,"icon_id":426,"is_multiple_command_unique_skill":1,"name":{"en":"Toys \"Psychokinesis\"","ja":"トイズ『サイコキネシス』","ko":"토이즈 [사이코키네시스]","zh_hant":"TOYS『念動力』"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5046,"skill_field_effect_id":1015,"_id_":8334,"skill_options":[{"id":511,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":623,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[3,3,3,3,3]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10353,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":88,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[310,320,330,340,350]}]},"8336":{"attribute_id":8,"cost":1,"icon_id":440,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Clarity","ja":"耐錯の斬撃","ko":"내착의 참격","zh_hant":"耐錯斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5048,"skill_field_effect_id":1018,"_id_":8336,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20020,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10371,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8337":{"attribute_id":8,"cost":1,"icon_id":423,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Humility","ja":"耐慢の斬撃","ko":"내만의 참격","zh_hant":"耐慢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5049,"skill_field_effect_id":1019,"_id_":8337,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20018,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10351,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8338":{"attribute_id":8,"cost":1,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5050,"skill_field_effect_id":1020,"_id_":8338,"skill_options":[{"id":10302,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8339":{"attribute_id":8,"cost":1,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Toys \"Tri-Ascend\"","ja":"トイズ『トライアセンド』","ko":"토이즈 [트라이어센드]","zh_hant":"TOYS『三重上升』"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5051,"skill_field_effect_id":1021,"_id_":8339,"skill_options":[{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":20020,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10230,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8341":{"attribute_id":3,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Superstrength","ja":"怪力の狙撃","ko":"괴력의 저격","zh_hant":"怪力狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5053,"skill_field_effect_id":1024,"_id_":8341,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8342":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Sharpshooting","ja":"増強の狙撃","ko":"증강의 저격","zh_hant":"增強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5054,"skill_field_effect_id":1025,"_id_":8342,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8343":{"attribute_id":3,"cost":2,"icon_id":373,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5055,"skill_field_effect_id":1026,"_id_":8343,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8344":{"attribute_id":3,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Toys \"Hyper Sensitive\"","ja":"トイズ『ハイパーセンシティブ』","ko":"토이즈 [하이퍼 센서티브]","zh_hant":"TOYS『五感強化』"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5056,"skill_field_effect_id":1027,"_id_":8344,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8346":{"attribute_id":6,"cost":1,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5061,"skill_field_effect_id":1030,"_id_":8346,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8347":{"attribute_id":6,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5062,"skill_field_effect_id":1031,"_id_":8347,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8348":{"attribute_id":6,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5063,"skill_field_effect_id":1032,"_id_":8348,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8349":{"attribute_id":6,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Shikigami Encore","ja":"清めの式神 Encore","ko":"정화의 식신 Encore","zh_hant":"淨化的式神 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5064,"skill_field_effect_id":1033,"_id_":8349,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8351":{"attribute_id":2,"cost":1,"icon_id":377,"is_multiple_command_unique_skill":0,"name":{"en":"Marked Slash","ja":"刻印の斬撃","ko":"각인의 참격","zh_hant":"刻印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5066,"skill_field_effect_id":1036,"_id_":8351,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10298,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8352":{"attribute_id":2,"cost":2,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5067,"skill_field_effect_id":1037,"_id_":8352,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8353":{"attribute_id":2,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5068,"skill_field_effect_id":1038,"_id_":8353,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10302,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8354":{"attribute_id":2,"cost":2,"icon_id":442,"is_multiple_command_unique_skill":0,"name":{"en":"Toys \"Direct Hack\"","ja":"トイズ『ダイレクトハック』","ko":"토이즈 [다이렉트 핵]","zh_hant":"TOYS『電子入侵』"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5069,"skill_field_effect_id":1039,"_id_":8354,"skill_options":[{"id":10375,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":310,"hit_rate":100,"target_id":2002,"times":[10,10,10,10,10],"values":[310,320,330,340,350]}]},"8356":{"attribute_id":1,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Daze","ja":"錯乱の一閃","ko":"착란의 일섬","zh_hant":"錯亂閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5072,"skill_field_effect_id":1042,"_id_":8356,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8357":{"attribute_id":1,"cost":2,"icon_id":444,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Impudence","ja":"慢心の一閃","ko":"방심의 일섬","zh_hant":"傲慢閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5073,"skill_field_effect_id":1043,"_id_":8357,"skill_options":[{"id":10378,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8358":{"attribute_id":1,"cost":2,"icon_id":435,"is_multiple_command_unique_skill":0,"name":{"en":"Fierce Flash","ja":"猛攻の一閃","ko":"맹공의 일섬","zh_hant":"猛攻閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5074,"skill_field_effect_id":1044,"_id_":8358,"skill_options":[{"id":10363,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8359":{"attribute_id":1,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Sun's Guidance","ja":"お日様の導き","ko":"햇님의 인도","zh_hant":"太陽的引導"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5075,"skill_field_effect_id":1045,"_id_":8359,"skill_options":[{"id":20021,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10379,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":310,"hit_rate":100,"target_id":2002,"times":[10,10,10,10,10],"values":[310,320,330,340,350]}]},"8373":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting","ja":"狙撃","ko":"저격","zh_hant":"狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2606,"skill_field_effect_id":0,"_id_":8373,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8374":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2607,"skill_field_effect_id":0,"_id_":8374,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8375":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2608,"skill_field_effect_id":0,"_id_":8375,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8376":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2609,"skill_field_effect_id":0,"_id_":8376,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8377":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2610,"skill_field_effect_id":0,"_id_":8377,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8378":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2611,"skill_field_effect_id":0,"_id_":8378,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8379":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Rondo","ja":"闇炎の輪舞曲","ko":"암흑 불꽃의 윤무곡","zh_hant":"暗炎圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2612,"skill_field_effect_id":0,"_id_":8379,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8380":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2613,"skill_field_effect_id":0,"_id_":8380,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8382":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":8382,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8383":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":8383,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8384":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":8384,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8385":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":8385,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8386":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":8386,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8387":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":8387,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8388":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":8388,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8389":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":8389,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8390":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":8390,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8391":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":8391,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"8393":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2641,"skill_field_effect_id":0,"_id_":8393,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8394":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2642,"skill_field_effect_id":0,"_id_":8394,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8395":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2643,"skill_field_effect_id":0,"_id_":8395,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8396":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2644,"skill_field_effect_id":0,"_id_":8396,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8397":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2645,"skill_field_effect_id":0,"_id_":8397,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8398":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2646,"skill_field_effect_id":0,"_id_":8398,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8399":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2647,"skill_field_effect_id":0,"_id_":8399,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8400":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2648,"skill_field_effect_id":0,"_id_":8400,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8401":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2649,"skill_field_effect_id":0,"_id_":8401,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8403":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":8403,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8404":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":8404,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"8405":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":8405,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8406":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":8406,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8407":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":8407,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8408":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":8408,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8409":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":8409,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8410":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":8410,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"8411":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":8411,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8412":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":8412,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8413":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":8413,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"8415":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":811,"_id_":8415,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8416":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":742,"_id_":8416,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8417":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":811,"_id_":8417,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8418":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":742,"_id_":8418,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8419":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":742,"_id_":8419,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8420":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":811,"_id_":8420,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8421":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":742,"_id_":8421,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8422":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5078,"skill_field_effect_id":742,"_id_":8422,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8423":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5079,"skill_field_effect_id":742,"_id_":8423,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8425":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":8425,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8426":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":8426,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8427":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":8427,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8428":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":8428,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8429":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":8429,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8430":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":8430,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8431":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":8431,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8432":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":8432,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8434":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":8434,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8435":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":8435,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8436":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":8436,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8437":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":8437,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8438":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":8438,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8439":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":8439,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8440":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":8440,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8441":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":8441,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8442":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":8442,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8443":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":8443,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8445":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":8445,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8446":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":8446,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8447":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":8447,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8448":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":8448,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8449":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":8449,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8450":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":8450,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8451":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":8451,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8452":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":8452,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8453":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":8453,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8454":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":8454,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8455":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":8455,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8457":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Thrust","ja":"強刺突","ko":"강한 찌르기","zh_hant":"強突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2669,"skill_field_effect_id":811,"_id_":8457,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8458":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Thrust","ja":"強双刺突","ko":"강한 두번 찌르기","zh_hant":"強雙突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2670,"skill_field_effect_id":742,"_id_":8458,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8459":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Thrust","ja":"参刺突","ko":"세번 찌르기","zh_hant":"參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2671,"skill_field_effect_id":811,"_id_":8459,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8460":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Thrust","ja":"強参刺突","ko":"강한 세번 찌르기","zh_hant":"強參突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2672,"skill_field_effect_id":742,"_id_":8460,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8461":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2673,"skill_field_effect_id":742,"_id_":8461,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8462":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2674,"skill_field_effect_id":811,"_id_":8462,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8463":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2675,"skill_field_effect_id":742,"_id_":8463,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8464":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Thrust","ja":"必中の刺突","ko":"백발백중의 찌르기","zh_hant":"必中突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5078,"skill_field_effect_id":742,"_id_":8464,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8465":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"I'm Late! NEO","ja":"遅刻しちゃう！ NEO","ko":"지각하겠어! NEO","zh_hant":"要遲到了！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5079,"skill_field_effect_id":742,"_id_":8465,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8467":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":8467,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8468":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":8468,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8469":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":8469,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8470":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":8470,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8471":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":8471,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8472":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":8472,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8473":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":8473,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8474":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":8474,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8476":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":8476,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8477":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":8477,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8478":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":8478,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8479":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":8479,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8480":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":8480,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8481":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":8481,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8482":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":8482,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8483":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":8483,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8484":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":8484,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8485":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":8485,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8487":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":8487,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8488":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":8488,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8489":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":8489,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8490":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":8490,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8491":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":8491,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8492":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":8492,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8493":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":8493,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8494":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":8494,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8495":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":8495,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8496":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":8496,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8497":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":8497,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8499":{"attribute_id":5,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Poison","ja":"毒の打撃","ko":"독의 타격","zh_hant":"中毒敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5086,"skill_field_effect_id":1054,"_id_":8499,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8500":{"attribute_id":5,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Love","ja":"恋の打撃","ko":"사랑의 타격","zh_hant":"戀的敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5087,"skill_field_effect_id":1055,"_id_":8500,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8501":{"attribute_id":5,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Daze","ja":"錯乱の打撃","ko":"착란의 타격","zh_hant":"錯亂敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5088,"skill_field_effect_id":1056,"_id_":8501,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8502":{"attribute_id":5,"cost":2,"icon_id":448,"is_multiple_command_unique_skill":0,"name":{"en":"Aroundight Flash Encore","ja":"アロンダイトの一閃 Encore","ko":"아론다이트의 일섬 Encore","zh_hant":"阿隆戴特的一閃 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5089,"skill_field_effect_id":1057,"_id_":8502,"skill_options":[{"id":10381,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[310,320,330,340,350]}]},"8504":{"attribute_id":1,"cost":1,"icon_id":449,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5091,"skill_field_effect_id":1060,"_id_":8504,"skill_options":[{"id":20022,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10382,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[100,100,100,100,100]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8505":{"attribute_id":1,"cost":2,"icon_id":1091,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of the Goddess","ja":"女神の斬撃","ko":"여신의 참격","zh_hant":"女神斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5092,"skill_field_effect_id":1061,"_id_":8505,"skill_options":[{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8506":{"attribute_id":1,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5093,"skill_field_effect_id":1062,"_id_":8506,"skill_options":[{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8507":{"attribute_id":1,"cost":2,"icon_id":451,"is_multiple_command_unique_skill":1,"name":{"en":"Lily of Revelation","ja":"Lily of revelation","ko":"Lily of revelation","zh_hant":"Lily of revelation"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5094,"skill_field_effect_id":1063,"_id_":8507,"skill_options":[{"id":10385,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8519":{"attribute_id":2,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Superstrength","ja":"怪力の一閃","ko":"괴력의 일섬","zh_hant":"怪力閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5096,"skill_field_effect_id":1066,"_id_":8519,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8520":{"attribute_id":2,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Flash","ja":"増強の一閃","ko":"증강의 일섬","zh_hant":"增強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5097,"skill_field_effect_id":1067,"_id_":8520,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8521":{"attribute_id":2,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Flash","ja":"封印の一閃","ko":"봉인의 일섬","zh_hant":"封印閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5098,"skill_field_effect_id":1068,"_id_":8521,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8522":{"attribute_id":2,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Trade Secrets Encore","ja":"商いの極意 Encore","ko":"장사의 비법 Encore","zh_hant":"商人的秘訣 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5099,"skill_field_effect_id":1069,"_id_":8522,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8524":{"attribute_id":1,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Superstrength","ja":"怪力の一撃","ko":"괴력의 일격","zh_hant":"怪力一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5101,"skill_field_effect_id":1072,"_id_":8524,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8525":{"attribute_id":1,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5102,"skill_field_effect_id":1073,"_id_":8525,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8526":{"attribute_id":1,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Strike","ja":"致命の一撃","ko":"치명의 일격","zh_hant":"致命一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5103,"skill_field_effect_id":1074,"_id_":8526,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8527":{"attribute_id":1,"cost":2,"icon_id":1103,"is_multiple_command_unique_skill":1,"name":{"en":"Fruchtbarkeit Encore","ja":"フルフトバーカイト Encore","ko":"프루흐트바카이트 Encore","zh_hant":"豐饒 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5104,"skill_field_effect_id":1075,"_id_":8527,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8559":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2832,"skill_field_effect_id":0,"_id_":8559,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8560":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2833,"skill_field_effect_id":0,"_id_":8560,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8561":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2834,"skill_field_effect_id":0,"_id_":8561,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8562":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2835,"skill_field_effect_id":0,"_id_":8562,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8563":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2836,"skill_field_effect_id":0,"_id_":8563,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8564":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2837,"skill_field_effect_id":0,"_id_":8564,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8565":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2838,"skill_field_effect_id":0,"_id_":8565,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8566":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2839,"skill_field_effect_id":0,"_id_":8566,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8568":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":8568,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8569":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":8569,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8570":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":8570,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8571":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":8571,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8572":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":8572,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8573":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":8573,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"8574":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":8574,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8575":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":8575,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8577":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2865,"skill_field_effect_id":0,"_id_":8577,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8578":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Sharpshooting","ja":"双狙撃","ko":"쌍저격","zh_hant":"雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2866,"skill_field_effect_id":0,"_id_":8578,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8579":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Sharpshooting","ja":"強襲の双狙撃","ko":"강습의 쌍저격","zh_hant":"強襲雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2867,"skill_field_effect_id":0,"_id_":8579,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8580":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2868,"skill_field_effect_id":0,"_id_":8580,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8581":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2869,"skill_field_effect_id":0,"_id_":8581,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8582":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2870,"skill_field_effect_id":0,"_id_":8582,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8583":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2871,"skill_field_effect_id":0,"_id_":8583,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8584":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2872,"skill_field_effect_id":0,"_id_":8584,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8585":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2873,"skill_field_effect_id":0,"_id_":8585,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8587":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":8587,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8588":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":8588,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8589":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":8589,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8590":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":8590,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8591":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":8591,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8592":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":8592,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"8593":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":8593,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8594":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":8594,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8595":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":8595,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8597":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":811,"_id_":8597,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8598":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":742,"_id_":8598,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8599":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":811,"_id_":8599,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8600":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":742,"_id_":8600,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8601":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":742,"_id_":8601,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8602":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":811,"_id_":8602,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8603":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":742,"_id_":8603,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8604":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fire Flower Dance","ja":"炎花の舞","ko":"염화의 춤","zh_hant":"炎花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4799,"skill_field_effect_id":742,"_id_":8604,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8605":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4800,"skill_field_effect_id":742,"_id_":8605,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8607":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":8607,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8608":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":8608,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8609":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":8609,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8610":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":8610,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8611":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":8611,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8612":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":8612,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8613":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":8613,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8614":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":8614,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8616":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":8616,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8617":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":8617,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8618":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":8618,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8619":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":8619,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8620":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":8620,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8621":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":8621,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8622":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":8622,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8623":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":8623,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"8624":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":8624,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8625":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":8625,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8627":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":8627,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8628":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":8628,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8629":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":8629,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8630":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":8630,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8631":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":8631,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8632":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":8632,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"8633":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":8633,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8634":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":8634,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8635":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":8635,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8637":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Flash","ja":"強一閃","ko":"강일섬","zh_hant":"強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2893,"skill_field_effect_id":811,"_id_":8637,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8638":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Twin Flash","ja":"強襲の双一閃","ko":"강습의 쌍일섬","zh_hant":"強襲雙閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2894,"skill_field_effect_id":742,"_id_":8638,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8639":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Flash","ja":"参一閃","ko":"삼일섬","zh_hant":"參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2895,"skill_field_effect_id":811,"_id_":8639,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8640":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Flash","ja":"強襲の参一閃","ko":"강습의 삼일섬","zh_hant":"強襲參閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2896,"skill_field_effect_id":742,"_id_":8640,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8641":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2897,"skill_field_effect_id":742,"_id_":8641,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8642":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2898,"skill_field_effect_id":811,"_id_":8642,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8643":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2899,"skill_field_effect_id":742,"_id_":8643,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8644":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Fire Flower Dance","ja":"炎花の舞","ko":"염화의 춤","zh_hant":"炎花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4799,"skill_field_effect_id":742,"_id_":8644,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"8645":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flower Festival Type 3 NEO","ja":"百花繚乱　其の参 NEO","ko":"백화요란 3 NEO","zh_hant":"百花繚亂　其三 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4800,"skill_field_effect_id":742,"_id_":8645,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]}]},"8647":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":8647,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8648":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":8648,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8649":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":8649,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8650":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":8650,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8651":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":8651,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8652":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":8652,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8653":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":8653,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8654":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":8654,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8656":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":8656,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8657":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":8657,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8658":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":8658,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8659":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":8659,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8660":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":8660,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8661":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":8661,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8662":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":8662,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8663":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":8663,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"8664":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":8664,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8665":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":8665,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8667":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":8667,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8668":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":8668,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8669":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":8669,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8670":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":8670,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8671":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":8671,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8672":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":8672,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"8673":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":8673,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8674":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":8674,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8675":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":8675,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8677":{"attribute_id":3,"cost":1,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Impudence","ja":"慢心の斬撃","ko":"방심의 참격","zh_hant":"傲慢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5114,"skill_field_effect_id":1078,"_id_":8677,"skill_options":[{"id":10311,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8678":{"attribute_id":3,"cost":2,"icon_id":381,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5115,"skill_field_effect_id":1079,"_id_":8678,"skill_options":[{"id":10311,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8679":{"attribute_id":3,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5116,"skill_field_effect_id":1080,"_id_":8679,"skill_options":[{"id":10311,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10379,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8680":{"attribute_id":3,"cost":2,"icon_id":452,"is_multiple_command_unique_skill":1,"name":{"en":"Shackles of Poison Encore","ja":"毒林檎の枷 Encore","ko":"독사과의 족쇄 Encore","zh_hant":"毒蘋果的枷鎖 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5117,"skill_field_effect_id":1081,"_id_":8680,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10376,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10388,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[310,320,330,340,350]}]},"8682":{"attribute_id":4,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Poison","ja":"毒の斬撃","ko":"독의 참격","zh_hant":"中毒斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5119,"skill_field_effect_id":1084,"_id_":8682,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8683":{"attribute_id":4,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5120,"skill_field_effect_id":1085,"_id_":8683,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8684":{"attribute_id":4,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5121,"skill_field_effect_id":1086,"_id_":8684,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8685":{"attribute_id":4,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":1,"name":{"en":"Urgewalt Encore","ja":"ウーア・ゲヴァルト Encore","ko":"우어게발트 Encore","zh_hant":"根源之力 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5122,"skill_field_effect_id":1087,"_id_":8685,"skill_options":[{"id":10302,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[360,370,380,390,400]}]},"8687":{"attribute_id":7,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Poison","ja":"毒の刺突","ko":"독의 찌르기","zh_hant":"中毒突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5124,"skill_field_effect_id":1090,"_id_":8687,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10110,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8688":{"attribute_id":7,"cost":2,"icon_id":363,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Sleep","ja":"睡眠の刺突","ko":"수면의 찌르기","zh_hant":"睡眠突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5125,"skill_field_effect_id":1091,"_id_":8688,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10110,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10281,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8689":{"attribute_id":7,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Superstrength","ja":"怪力の刺突","ko":"괴력의 찌르기","zh_hant":"怪力突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5126,"skill_field_effect_id":1092,"_id_":8689,"skill_options":[{"id":10286,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10305,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8690":{"attribute_id":7,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Auflodern Encore","ja":"アオフ・ローダーン Encore","ko":"아우프로데른 Encore","zh_hant":"熱焰燃燒 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5127,"skill_field_effect_id":1093,"_id_":8690,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10286,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[30,30,30,30,30]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8692":{"attribute_id":9,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Impudence","ja":"慢心の斬撃","ko":"방심의 참격","zh_hant":"傲慢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5129,"skill_field_effect_id":1097,"_id_":8692,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]}]},"8693":{"attribute_id":9,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5130,"skill_field_effect_id":1098,"_id_":8693,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8694":{"attribute_id":9,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5131,"skill_field_effect_id":1099,"_id_":8694,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"8695":{"attribute_id":9,"cost":2,"icon_id":454,"is_multiple_command_unique_skill":0,"name":{"en":"Zufrieren Encore","ja":"ツー・フリーレン Encore","ko":"추프리렌 Encore","zh_hant":"凍結冰雪 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5132,"skill_field_effect_id":1100,"_id_":8695,"skill_options":[{"id":10328,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10393,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10379,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8697":{"attribute_id":5,"cost":1,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Support","ja":"支援の一閃","ko":"지원의 일섬","zh_hant":"支援閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5134,"skill_field_effect_id":1103,"_id_":8697,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8698":{"attribute_id":5,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Flash","ja":"致命の一閃","ko":"치명의 일섬","zh_hant":"致命閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5135,"skill_field_effect_id":1104,"_id_":8698,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8699":{"attribute_id":5,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Flash","ja":"封印の一閃","ko":"봉인의 일섬","zh_hant":"封印閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5136,"skill_field_effect_id":1105,"_id_":8699,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8700":{"attribute_id":5,"cost":2,"icon_id":455,"is_multiple_command_unique_skill":0,"name":{"en":"Infernal Gnawing Encore","ja":"冥獣の噛砕 Encore","ko":"저승 맹수의 깨물어부수기 Encore","zh_hant":"冥獸的撕咬 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5137,"skill_field_effect_id":1106,"_id_":8700,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10396,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8719":{"attribute_id":6,"cost":1,"icon_id":456,"is_multiple_command_unique_skill":0,"name":{"en":"Resistance Flash","ja":"耐性の一閃","ko":"저항의 일섬","zh_hant":"耐性閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5140,"skill_field_effect_id":1109,"_id_":8719,"skill_options":[{"id":10397,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8720":{"attribute_id":6,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Flash","ja":"重圧の一閃","ko":"중압의 일섬","zh_hant":"重壓閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5141,"skill_field_effect_id":1110,"_id_":8720,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8721":{"attribute_id":6,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Impudence","ja":"慢心の一閃","ko":"방심의 일섬","zh_hant":"傲慢閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5142,"skill_field_effect_id":1111,"_id_":8721,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8722":{"attribute_id":6,"cost":2,"icon_id":457,"is_multiple_command_unique_skill":0,"name":{"en":"Justice of the Black Lion","ja":"黒獅子の正義","ko":"흑사자의 정의","zh_hant":"黑獅子正義"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5143,"skill_field_effect_id":1112,"_id_":8722,"skill_options":[{"id":309,"hit_rate":100,"target_id":11013,"times":[0,0,0,0,0],"values":[50,55,60,65,70]},{"id":10398,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8724":{"attribute_id":8,"cost":2,"icon_id":444,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Impudence","ja":"慢心の刺突","ko":"방심의 찌르기","zh_hant":"傲慢突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5145,"skill_field_effect_id":1115,"_id_":8724,"skill_options":[{"id":10384,"hit_rate":100,"target_id":1132,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10378,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8725":{"attribute_id":8,"cost":2,"icon_id":435,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Daze","ja":"錯乱の刺突","ko":"착란의 찌르기","zh_hant":"錯亂突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5146,"skill_field_effect_id":1116,"_id_":8725,"skill_options":[{"id":10384,"hit_rate":100,"target_id":1143,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10363,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8726":{"attribute_id":8,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Thrust","ja":"煌めく刺突","ko":"빛나는 찌르기","zh_hant":"輝煌突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5147,"skill_field_effect_id":1117,"_id_":8726,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8727":{"attribute_id":8,"cost":1,"icon_id":450,"is_multiple_command_unique_skill":1,"name":{"en":"Meteor Strahl Encore","ja":"メテオール・シュトラール Encore","ko":"메테오르 슈트랄 Encore","zh_hant":"流星之光 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5148,"skill_field_effect_id":1118,"_id_":8727,"skill_options":[{"id":20025,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10384,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8739":{"attribute_id":4,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Versatile Slash","ja":"万能の斬撃","ko":"만능의 참격","zh_hant":"萬能斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5150,"skill_field_effect_id":1121,"_id_":8739,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8740":{"attribute_id":4,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5151,"skill_field_effect_id":1122,"_id_":8740,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8741":{"attribute_id":4,"cost":2,"icon_id":362,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5152,"skill_field_effect_id":1123,"_id_":8741,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8742":{"attribute_id":4,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Thunderbolt of Judgment","ja":"裁きの雷火","ko":"심판의 번갯불","zh_hant":"制裁的雷火"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5153,"skill_field_effect_id":1124,"_id_":8742,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8744":{"attribute_id":6,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Superstrength","ja":"怪力の打撃","ko":"괴력의 타격","zh_hant":"怪力敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5155,"skill_field_effect_id":1127,"_id_":8744,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10329,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8745":{"attribute_id":6,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Smash","ja":"増強の打撃","ko":"증강의 타격","zh_hant":"增強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5156,"skill_field_effect_id":1128,"_id_":8745,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8746":{"attribute_id":6,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Smash","ja":"封印の打撃","ko":"봉인의 타격","zh_hant":"封印敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5157,"skill_field_effect_id":1129,"_id_":8746,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":366,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]}]},"8747":{"attribute_id":6,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Quintet Prominence Breaker Encore","ja":"クインテット・プロミネンスブレイカー Encore","ko":"퀸텟 프로미넌스 브레이커 Encore","zh_hant":"五重奏・熾焰日珥粉碎擊 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5158,"skill_field_effect_id":1130,"_id_":8747,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":366,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8749":{"attribute_id":3,"cost":2,"icon_id":408,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Impudence","ja":"慢心の斬撃","ko":"방심의 참격","zh_hant":"傲慢斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5160,"skill_field_effect_id":1133,"_id_":8749,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8750":{"attribute_id":3,"cost":2,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Daze","ja":"錯乱の斬撃","ko":"착란의 참격","zh_hant":"錯亂斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5161,"skill_field_effect_id":1134,"_id_":8750,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8751":{"attribute_id":3,"cost":2,"icon_id":1109,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Shortening","ja":"短縮の斬撃","ko":"단축의 참격","zh_hant":"縮短斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5162,"skill_field_effect_id":1135,"_id_":8751,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8752":{"attribute_id":3,"cost":2,"icon_id":1109,"is_multiple_command_unique_skill":1,"name":{"en":"Reborn with Light in My Heart","ja":"生まれ変わった光を胸に","ko":"다시 태어난 빛을 가슴에 품고","zh_hant":"胸懷重生之光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5163,"skill_field_effect_id":1136,"_id_":8752,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[360,370,380,390,400]}]},"8754":{"attribute_id":8,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Superstrength","ja":"怪力の打撃","ko":"괴력의 타격","zh_hant":"怪力敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5165,"skill_field_effect_id":1139,"_id_":8754,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8755":{"attribute_id":8,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Support","ja":"支援の打撃","ko":"지원의 타격","zh_hant":"支援敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5166,"skill_field_effect_id":1140,"_id_":8755,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10280,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8756":{"attribute_id":8,"cost":2,"icon_id":368,"is_multiple_command_unique_skill":0,"name":{"en":"Restorative Smash","ja":"再起の打撃","ko":"재기의 타격","zh_hant":"再起敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5167,"skill_field_effect_id":1141,"_id_":8756,"skill_options":[{"id":10286,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8757":{"attribute_id":8,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"My Dreams Will Come True on Stage Encore","ja":"夢咲く舞台に 輝け 私 Encore","ko":"꿈이 꽃피는 무대에서 난 빛나리 Encore","zh_hant":"我要在綻放夢想的舞台上熠熠生輝 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5168,"skill_field_effect_id":1142,"_id_":8757,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8799":{"attribute_id":2,"cost":1,"icon_id":441,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Inactivity","ja":"沈滞の斬撃","ko":"침체의 참격","zh_hant":"沉滯斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5178,"skill_field_effect_id":1144,"_id_":8799,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10407,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8800":{"attribute_id":2,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5179,"skill_field_effect_id":1145,"_id_":8800,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10407,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8801":{"attribute_id":2,"cost":2,"icon_id":464,"is_multiple_command_unique_skill":0,"name":{"en":"Overpower Slash","ja":"威圧の斬撃","ko":"위압의 참격","zh_hant":"威壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5180,"skill_field_effect_id":1146,"_id_":8801,"skill_options":[{"id":10363,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10407,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2124,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8802":{"attribute_id":2,"cost":2,"icon_id":464,"is_multiple_command_unique_skill":1,"name":{"en":"Watch Me from Hell. I'm the Star Encore","ja":"奈落で見上げろ 私がスタァだ Encore","ko":"나락에서 올려다봐라 내가 스타다 Encore","zh_hant":"在地獄抬頭望吧，我才是STAR Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5181,"skill_field_effect_id":1147,"_id_":8802,"skill_options":[{"id":10363,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8804":{"attribute_id":4,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Superstrength","ja":"怪力の一撃","ko":"괴력의 일격","zh_hant":"怪力一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5183,"skill_field_effect_id":1150,"_id_":8804,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8805":{"attribute_id":4,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5184,"skill_field_effect_id":1151,"_id_":8805,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8806":{"attribute_id":4,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Strike","ja":"致命の一撃","ko":"치명의 일격","zh_hant":"致命一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5185,"skill_field_effect_id":1152,"_id_":8806,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8807":{"attribute_id":4,"cost":2,"icon_id":1106,"is_multiple_command_unique_skill":1,"name":{"en":"Arcanum Magicae Encore","ja":"アルカナム・マジーケ Encore","ko":"아르카눔 마지케 Encore","zh_hant":"阿爾克那・魔術 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5186,"skill_field_effect_id":1153,"_id_":8807,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8809":{"attribute_id":3,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5188,"skill_field_effect_id":1156,"_id_":8809,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8810":{"attribute_id":3,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5189,"skill_field_effect_id":1157,"_id_":8810,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8811":{"attribute_id":3,"cost":2,"icon_id":418,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5190,"skill_field_effect_id":1158,"_id_":8811,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10346,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8812":{"attribute_id":3,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Blazedance Finisher Encore","ja":"焔舞殺法 Encore","ko":"화무살법 Encore","zh_hant":"焰舞殺法 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5191,"skill_field_effect_id":1159,"_id_":8812,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10396,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8814":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":8814,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8815":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":8815,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8816":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":8816,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8817":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":8817,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8818":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":8818,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"8819":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":8819,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"8820":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":8820,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8821":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":8821,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8822":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":8822,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8824":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":8824,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8825":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":8825,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8826":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":8826,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8827":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":8827,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8828":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":8828,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8829":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":8829,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8830":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":8830,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8831":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":8831,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8832":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":8832,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8833":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":8833,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8834":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":8834,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8836":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":8836,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8837":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":8837,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8838":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":8838,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8839":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":8839,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8840":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":8840,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8841":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":8841,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8842":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":8842,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"8843":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":8843,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8844":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":8844,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8845":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":8845,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8846":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":8846,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8848":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":8848,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8849":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":8849,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8850":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":8850,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8851":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":8851,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8852":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":8852,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8853":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":8853,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8854":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":8854,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"8855":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":8855,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8856":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":8856,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8857":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":8857,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8858":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":8858,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8860":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":811,"_id_":8860,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8861":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":8861,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8862":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":742,"_id_":8862,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8863":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":8863,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8864":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":8864,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8865":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":8865,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8866":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":8866,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8867":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":8867,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8868":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":8868,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8869":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":8869,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8870":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":8870,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"8872":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":8872,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8873":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":8873,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8874":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":8874,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8875":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":8875,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8876":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":8876,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8877":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":8877,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8878":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":8878,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8879":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":8879,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8880":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":8880,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8881":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":8881,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8882":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":8882,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8884":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":742,"_id_":8884,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8885":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":8885,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8886":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":811,"_id_":8886,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8887":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":8887,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8888":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":8888,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8889":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":8889,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"8890":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":8890,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8891":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":8891,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"8892":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":8892,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8893":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":8893,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8894":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":8894,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"8896":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":8896,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8897":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":8897,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"8898":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":8898,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"8899":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":8899,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"8900":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":8900,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"8901":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":8901,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"8902":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":8902,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"8903":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":8903,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"8904":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":8904,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"8905":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":8905,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8906":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":8906,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"8920":{"attribute_id":6,"cost":2,"icon_id":443,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5194,"skill_field_effect_id":1162,"_id_":8920,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10376,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8921":{"attribute_id":6,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5195,"skill_field_effect_id":1163,"_id_":8921,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8922":{"attribute_id":6,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5196,"skill_field_effect_id":1164,"_id_":8922,"skill_options":[{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"8923":{"attribute_id":6,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"King Solomon's Ring","ja":"ソロモンの指輪","ko":"솔로몬의 반지","zh_hant":"所羅門的戒指"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5197,"skill_field_effect_id":1165,"_id_":8923,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10375,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[360,370,380,390,400]}]},"8925":{"attribute_id":4,"cost":1,"icon_id":334,"is_multiple_command_unique_skill":0,"name":{"en":"Flame Strike","ja":"炎の一撃","ko":"불꽃의 일격","zh_hant":"火焰一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5199,"skill_field_effect_id":1168,"_id_":8925,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8926":{"attribute_id":4,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5200,"skill_field_effect_id":1169,"_id_":8926,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8927":{"attribute_id":4,"cost":2,"icon_id":414,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Poison","ja":"毒の一撃","ko":"독의 일격","zh_hant":"中毒一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5201,"skill_field_effect_id":1170,"_id_":8927,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8928":{"attribute_id":4,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"High Judgement Encore","ja":"女教皇はかく裁けり Encore","ko":"여교황은 이렇게 판결했노라 Encore","zh_hant":"女教皇如此裁斷 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5202,"skill_field_effect_id":1171,"_id_":8928,"skill_options":[{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[280,290,300,310,320]}]},"8930":{"attribute_id":9,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5209,"skill_field_effect_id":1173,"_id_":8930,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]}]},"8931":{"attribute_id":9,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5210,"skill_field_effect_id":1174,"_id_":8931,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]}]},"8932":{"attribute_id":9,"cost":2,"icon_id":368,"is_multiple_command_unique_skill":0,"name":{"en":"Restorative Slash","ja":"再起の斬撃","ko":"재기의 참격","zh_hant":"再起斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5211,"skill_field_effect_id":1175,"_id_":8932,"skill_options":[{"id":10286,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]}]},"8933":{"attribute_id":9,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Dazzling Galatine Encore","ja":"まばゆきガラティーン Encore","ko":"눈부신 가라틴 Encore","zh_hant":"光耀勝利之劍 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5212,"skill_field_effect_id":1176,"_id_":8933,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10357,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[100,100,100,100,100]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[260,270,280,290,300]}]},"8935":{"attribute_id":1,"cost":1,"icon_id":450,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Resistance","ja":"耐性の打撃","ko":"저항의 타격","zh_hant":"耐性敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5204,"skill_field_effect_id":1178,"_id_":8935,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10384,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[100,100,100,100,100]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8936":{"attribute_id":1,"cost":2,"icon_id":1110,"is_multiple_command_unique_skill":0,"name":{"en":"Golden Smash","ja":"黄金の打撃","ko":"황금의 타격","zh_hant":"黃金敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5205,"skill_field_effect_id":1179,"_id_":8936,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8937":{"attribute_id":1,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Smash","ja":"重圧の打撃","ko":"중압의 타격","zh_hant":"重壓敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5206,"skill_field_effect_id":1180,"_id_":8937,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10379,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"8938":{"attribute_id":1,"cost":2,"icon_id":466,"is_multiple_command_unique_skill":0,"name":{"en":"Gilded Riddle","ja":"金色の謎かけ","ko":"황금빛 수수께끼","zh_hant":"金色的謎題"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5207,"skill_field_effect_id":1181,"_id_":8938,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"8940":{"attribute_id":9,"cost":1,"icon_id":443,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Resistance","ja":"耐性の刺突","ko":"저항의 찌르기","zh_hant":"耐性突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5214,"skill_field_effect_id":1184,"_id_":8940,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10376,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8941":{"attribute_id":9,"cost":2,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Thrust of Contraction","ja":"狭窄の刺突","ko":"협착의 찌르기","zh_hant":"視野收窄突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5215,"skill_field_effect_id":1185,"_id_":8941,"skill_options":[{"id":10353,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20029,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8942":{"attribute_id":9,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Thrust","ja":"軽快な刺突","ko":"경쾌한 찌르기","zh_hant":"輕快突刺"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5216,"skill_field_effect_id":1186,"_id_":8942,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20029,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"8943":{"attribute_id":9,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":1,"name":{"en":"Empress's Gloom Encore","ja":"女帝陛下の憂鬱 Encore","ko":"여제 폐하의 우울 Encore","zh_hant":"女帝陛下的憂鬱 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5217,"skill_field_effect_id":1187,"_id_":8943,"skill_options":[{"id":309,"hit_rate":100,"target_id":11013,"times":[0,0,0,0,0],"values":[50,55,60,65,70]},{"id":10398,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"8945":{"attribute_id":2,"cost":1,"icon_id":443,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5219,"skill_field_effect_id":1190,"_id_":8945,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10376,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]}]},"8946":{"attribute_id":2,"cost":1,"icon_id":450,"is_multiple_command_unique_skill":0,"name":{"en":"Golden Slash","ja":"黄金の斬撃","ko":"황금의 참격","zh_hant":"黃金斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5220,"skill_field_effect_id":1191,"_id_":8946,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10384,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]}]},"8947":{"attribute_id":2,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Dispel","ja":"解除の斬撃","ko":"해제의 참격","zh_hant":"解除斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5221,"skill_field_effect_id":1192,"_id_":8947,"skill_options":[{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]}]},"8948":{"attribute_id":2,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Glamorous Invitation","ja":"艶やかなる女王のいざない","ko":"요염한 여왕의 유혹","zh_hant":"美艷女王的邀約"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5222,"skill_field_effect_id":1193,"_id_":8948,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":364,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"8950":{"attribute_id":5,"cost":1,"icon_id":469,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Expertise","ja":"達人の打撃","ko":"달인의 타격","zh_hant":"精通敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5224,"skill_field_effect_id":1198,"_id_":8950,"skill_options":[{"id":10422,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8951":{"attribute_id":5,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Smash","ja":"増強の打撃","ko":"증강의 타격","zh_hant":"增強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5225,"skill_field_effect_id":1199,"_id_":8951,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8952":{"attribute_id":5,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5226,"skill_field_effect_id":1200,"_id_":8952,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10413,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"8953":{"attribute_id":5,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":1,"name":{"en":"Flash of Darkness Encore","ja":"Flash of darkness Encore","ko":"Flash of darkness Encore","zh_hant":"Flash of darkness Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5227,"skill_field_effect_id":1201,"_id_":8953,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10413,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":361,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8955":{"attribute_id":2,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5229,"skill_field_effect_id":1204,"_id_":8955,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8956":{"attribute_id":2,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5230,"skill_field_effect_id":1205,"_id_":8956,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8957":{"attribute_id":2,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5231,"skill_field_effect_id":1206,"_id_":8957,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"8958":{"attribute_id":2,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Article 14: Forceful Removal Encore","ja":"幸福都市検察法第14条『強攻排除』 Encore","ko":"행복 도시 검찰법 제14조 [강공배제] Encore","zh_hant":"幸福都市檢查法第14條『強攻排除』 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5232,"skill_field_effect_id":1207,"_id_":8958,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"8960":{"attribute_id":1,"cost":2,"icon_id":391,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Flash","ja":"キラめく一閃","ko":"반짝이는 일섬","zh_hant":"輝煌閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5234,"skill_field_effect_id":1210,"_id_":8960,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10311,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"8961":{"attribute_id":1,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Flash","ja":"気絶の一閃","ko":"기절의 일섬","zh_hant":"昏迷閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5235,"skill_field_effect_id":1211,"_id_":8961,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10407,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"8962":{"attribute_id":1,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Dispel","ja":"解除の一閃","ko":"해제의 일섬","zh_hant":"解除閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5236,"skill_field_effect_id":1212,"_id_":8962,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"8963":{"attribute_id":1,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Show Me the Right Path, Mirror Encore","ja":"鏡よ照らせ 正しき道を Encore","ko":"거울아 바른 길을 비춰다오 Encore","zh_hant":"鏡子啊！照映出正確的道路吧！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5237,"skill_field_effect_id":1213,"_id_":8963,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[360,370,380,390,400]}]},"9000":{"attribute_id":5,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Slash","ja":"気絶の斬撃","ko":"기절의 참격","zh_hant":"昏迷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5243,"skill_field_effect_id":1215,"_id_":9000,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9001":{"attribute_id":5,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5244,"skill_field_effect_id":1216,"_id_":9001,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9002":{"attribute_id":5,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Dispel","ja":"解除の斬撃","ko":"해제의 참격","zh_hant":"解除斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5245,"skill_field_effect_id":1217,"_id_":9002,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9003":{"attribute_id":5,"cost":2,"icon_id":464,"is_multiple_command_unique_skill":0,"name":{"en":"Labyrinthine Love Encore","ja":"恋は迷宮 Encore","ko":"사랑은 미궁 Encore","zh_hant":"戀愛迷宮 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5246,"skill_field_effect_id":1218,"_id_":9003,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10426,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"9005":{"attribute_id":2,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Strike","ja":"キラめく一撃","ko":"반짝이는 일격","zh_hant":"輝煌一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5248,"skill_field_effect_id":1221,"_id_":9005,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9006":{"attribute_id":2,"cost":2,"icon_id":1090,"is_multiple_command_unique_skill":0,"name":{"en":"Tearful Strike","ja":"涙の一撃","ko":"눈물의 일격","zh_hant":"眼淚一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5249,"skill_field_effect_id":1222,"_id_":9006,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9007":{"attribute_id":2,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Dispel","ja":"解除の一撃","ko":"해제의 일격","zh_hant":"解除一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5250,"skill_field_effect_id":1223,"_id_":9007,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9008":{"attribute_id":2,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Possibility∞Infinity Encore","ja":"Possibility∞Infinity Encore","ko":"Possibility∞Infinity Encore","zh_hant":"無限∞可能 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5251,"skill_field_effect_id":1224,"_id_":9008,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[360,370,380,390,400]}]},"9010":{"attribute_id":1,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Slash","ja":"気絶の斬撃","ko":"기절의 참격","zh_hant":"昏迷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5253,"skill_field_effect_id":1226,"_id_":9010,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20027,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9011":{"attribute_id":1,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5254,"skill_field_effect_id":1227,"_id_":9011,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20030,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10428,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9012":{"attribute_id":1,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5255,"skill_field_effect_id":1228,"_id_":9012,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]},{"id":20030,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10428,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9013":{"attribute_id":1,"cost":2,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Lion's Roar Encore","ja":"獅子の咆哮 Encore","ko":"사자의 포효 Encore","zh_hant":"獅子咆哮 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5256,"skill_field_effect_id":1229,"_id_":9013,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10353,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"9015":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3221,"skill_field_effect_id":0,"_id_":9015,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9016":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3222,"skill_field_effect_id":0,"_id_":9016,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9017":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3223,"skill_field_effect_id":0,"_id_":9017,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9018":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3224,"skill_field_effect_id":0,"_id_":9018,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9019":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Slash","ja":"必中の斬撃","ko":"백발백중의 참격","zh_hant":"必中斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3225,"skill_field_effect_id":0,"_id_":9019,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"9020":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3226,"skill_field_effect_id":0,"_id_":9020,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9021":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3227,"skill_field_effect_id":0,"_id_":9021,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9022":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3228,"skill_field_effect_id":0,"_id_":9022,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9023":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3229,"skill_field_effect_id":0,"_id_":9023,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9025":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":9025,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9026":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":9026,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9027":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":9027,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9028":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":9028,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9029":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":9029,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9030":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":9030,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9031":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":9031,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9032":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":9032,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9033":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":9033,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9035":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3257,"skill_field_effect_id":0,"_id_":9035,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9036":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3258,"skill_field_effect_id":0,"_id_":9036,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9037":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3259,"skill_field_effect_id":0,"_id_":9037,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9038":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3260,"skill_field_effect_id":0,"_id_":9038,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9039":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3261,"skill_field_effect_id":0,"_id_":9039,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9040":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3262,"skill_field_effect_id":0,"_id_":9040,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9041":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3263,"skill_field_effect_id":0,"_id_":9041,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"9042":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3264,"skill_field_effect_id":0,"_id_":9042,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9043":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3265,"skill_field_effect_id":0,"_id_":9043,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9045":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":9045,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9046":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":9046,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9047":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":9047,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9048":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":9048,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9049":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":9049,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9050":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":9050,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9051":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":9051,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9052":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":9052,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9053":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":9053,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9054":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":9054,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9056":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":811,"_id_":9056,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9057":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":742,"_id_":9057,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9058":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":742,"_id_":9058,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9059":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":811,"_id_":9059,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9060":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":742,"_id_":9060,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9061":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":742,"_id_":9061,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9062":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":811,"_id_":9062,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9063":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":742,"_id_":9063,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9065":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":9065,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9066":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":9066,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9067":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":9067,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9068":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":9068,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9069":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":9069,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9070":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":9070,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9071":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":9071,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9072":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":9072,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9073":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":9073,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9074":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":9074,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9076":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":811,"_id_":9076,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9077":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":742,"_id_":9077,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9078":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":742,"_id_":9078,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9079":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":742,"_id_":9079,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9080":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":811,"_id_":9080,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9081":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":742,"_id_":9081,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9082":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":742,"_id_":9082,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9083":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":742,"_id_":9083,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9084":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":811,"_id_":9084,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9085":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":742,"_id_":9085,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9087":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":9087,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9088":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":9088,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9089":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":9089,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9090":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":9090,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9091":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":9091,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"9092":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":9092,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9093":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":9093,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9094":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":9094,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9096":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3286,"skill_field_effect_id":811,"_id_":9096,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9097":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3287,"skill_field_effect_id":742,"_id_":9097,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9098":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3288,"skill_field_effect_id":742,"_id_":9098,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9099":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3289,"skill_field_effect_id":811,"_id_":9099,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9100":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3290,"skill_field_effect_id":742,"_id_":9100,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9101":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Noxious Flower Dance","ja":"毒花の舞","ko":"독화의 춤","zh_hant":"毒花之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4658,"skill_field_effect_id":742,"_id_":9101,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9102":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Dance","ja":"奮起の舞","ko":"분기의 춤","zh_hant":"奮起之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3292,"skill_field_effect_id":811,"_id_":9102,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9103":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Glorious Dream! NEO","ja":"グロリアスドリーム！  NEO","ko":"글로리어스 드림! NEO","zh_hant":"燦爛的美夢！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4659,"skill_field_effect_id":742,"_id_":9103,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9105":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":9105,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9106":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":9106,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9107":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":9107,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9108":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":9108,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9109":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":9109,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9110":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":9110,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9111":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Firedance","ja":"炎舞","ko":"염무","zh_hant":"炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":9111,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9112":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":9112,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9113":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":9113,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9114":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Hope★ NEO","ja":"シャイニングホープ★ NEO","ko":"샤이닝 호프★ NEO","zh_hant":"Shining Hope★ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":9114,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9116":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3304,"skill_field_effect_id":811,"_id_":9116,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9117":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3305,"skill_field_effect_id":742,"_id_":9117,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9118":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3306,"skill_field_effect_id":742,"_id_":9118,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9119":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3307,"skill_field_effect_id":742,"_id_":9119,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9120":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3308,"skill_field_effect_id":811,"_id_":9120,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9121":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3309,"skill_field_effect_id":742,"_id_":9121,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9122":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3310,"skill_field_effect_id":742,"_id_":9122,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9123":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Slash","ja":"抑止の斬撃","ko":"억제의 참격","zh_hant":"抑止斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4662,"skill_field_effect_id":742,"_id_":9123,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9124":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3312,"skill_field_effect_id":811,"_id_":9124,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9125":{"attribute_id":7,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Beautiful Pose♪ NEO","ja":"ビューティポージング♪ NEO","ko":"뷰티 포징♪ NEO","zh_hant":"Pretty Poss♪ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4663,"skill_field_effect_id":742,"_id_":9125,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9127":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":9127,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9128":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":9128,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9129":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":9129,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9130":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":9130,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9131":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Defense Concerto","ja":"防衛の協奏曲","ko":"방위의 협주곡","zh_hant":"防衛協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":9131,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"9132":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":9132,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9133":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":9133,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9134":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Galactic Kaiser-Walzer NEO","ja":"威光堂々　～銀河皇帝円舞曲～　NEO","ko":"위풍당당 ~은하 황제 원무곡~ NEO","zh_hant":"威光堂堂 ～銀河皇帝圓舞曲～ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":9134,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9136":{"attribute_id":8,"cost":1,"icon_id":450,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Resistance","ja":"耐性の斬撃","ko":"저항의 참격","zh_hant":"耐性斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5258,"skill_field_effect_id":1232,"_id_":9136,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10314,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10417,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9137":{"attribute_id":8,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5259,"skill_field_effect_id":1233,"_id_":9137,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9138":{"attribute_id":8,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5260,"skill_field_effect_id":1234,"_id_":9138,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9139":{"attribute_id":8,"cost":2,"icon_id":471,"is_multiple_command_unique_skill":0,"name":{"en":"Somehow I Feel So Dizzy...","ja":"なんだか強いお酒を飲んだみたい","ko":"뭔가 독한 음료를 마신 것 같은 느낌이야","zh_hant":"好像喝了烈酒似的"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5261,"skill_field_effect_id":1235,"_id_":9139,"skill_options":[{"id":10436,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":388,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]},{"id":10433,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"9141":{"attribute_id":6,"cost":1,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Slash","ja":"気絶の斬撃","ko":"기절의 참격","zh_hant":"昏迷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5263,"skill_field_effect_id":1239,"_id_":9141,"skill_options":[{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10341,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10361,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9142":{"attribute_id":6,"cost":2,"icon_id":441,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Inactivity","ja":"沈滞の斬撃","ko":"침체의 참격","zh_hant":"沉滯斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5264,"skill_field_effect_id":1240,"_id_":9142,"skill_options":[{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10374,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9143":{"attribute_id":6,"cost":2,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Contraction","ja":"狭窄の斬撃","ko":"협착의 참격","zh_hant":"視野收窄斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5265,"skill_field_effect_id":1241,"_id_":9143,"skill_options":[{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10353,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9144":{"attribute_id":6,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World Encore","ja":"逆転世界の開眼 Encore","ko":"역전세계의 개안 Encore","zh_hant":"翻轉世界的領悟 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5266,"skill_field_effect_id":1242,"_id_":9144,"skill_options":[{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[5,5,5,5,5],"values":[310,320,330,340,350]}]},"9146":{"attribute_id":1,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Support","ja":"支援の打撃","ko":"지원의 타격","zh_hant":"支援敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5268,"skill_field_effect_id":1245,"_id_":9146,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9147":{"attribute_id":1,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Smash","ja":"致命の打撃","ko":"치명의 타격","zh_hant":"致命敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5269,"skill_field_effect_id":1246,"_id_":9147,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9148":{"attribute_id":1,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Dispel","ja":"解除の打撃","ko":"해제의 타격","zh_hant":"解除敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5270,"skill_field_effect_id":1247,"_id_":9148,"skill_options":[{"id":20030,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9149":{"attribute_id":1,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Fateful Awakening","ja":"運命の目覚め","ko":"운명의 각성","zh_hant":"命運的覺醒"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5271,"skill_field_effect_id":1248,"_id_":9149,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10396,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9163":{"attribute_id":8,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Superstrength","ja":"怪力の一閃","ko":"괴력의 일섬","zh_hant":"怪力閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5274,"skill_field_effect_id":1251,"_id_":9163,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10352,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9164":{"attribute_id":8,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Flash","ja":"増強の一閃","ko":"증강의 일섬","zh_hant":"增強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5275,"skill_field_effect_id":1252,"_id_":9164,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10301,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9165":{"attribute_id":8,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Flash","ja":"致命の一閃","ko":"치명의 일섬","zh_hant":"致命閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5276,"skill_field_effect_id":1253,"_id_":9165,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9166":{"attribute_id":8,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Moonlight Sacrament Encore","ja":"秘石が導く月光の秘蹟 Encore","ko":"보석이 인도하는 달빛의 성례 Encore","zh_hant":"由秘石所引導的月光秘蹟 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5277,"skill_field_effect_id":1254,"_id_":9166,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9168":{"attribute_id":3,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Smash","ja":"気絶の打撃","ko":"기절의 타격","zh_hant":"昏迷敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5279,"skill_field_effect_id":1258,"_id_":9168,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9169":{"attribute_id":3,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Smash of Love","ja":"恋の打撃","ko":"사랑의 타격","zh_hant":"戀的敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5280,"skill_field_effect_id":1259,"_id_":9169,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9170":{"attribute_id":3,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Smash","ja":"停止の打撃","ko":"정지의 타격","zh_hant":"停止敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5281,"skill_field_effect_id":1260,"_id_":9170,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9171":{"attribute_id":3,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Light of Hope Encore","ja":"希望は光になりて Encore","ko":"희망은 빛이 될 자 Encore","zh_hant":"希望終將成為光 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5282,"skill_field_effect_id":1261,"_id_":9171,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10427,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[360,370,380,390,400]}]},"9173":{"attribute_id":9,"cost":1,"icon_id":450,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting of Resistance","ja":"耐性の狙撃","ko":"저항의 저격","zh_hant":"耐性狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5284,"skill_field_effect_id":1263,"_id_":9173,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9174":{"attribute_id":9,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Sharpshooting","ja":"軽快な狙撃","ko":"경쾌한 저격","zh_hant":"輕快狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5285,"skill_field_effect_id":1264,"_id_":9174,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9175":{"attribute_id":9,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Sharpshooting","ja":"重圧の狙撃","ko":"중압의 저격","zh_hant":"重壓狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5286,"skill_field_effect_id":1265,"_id_":9175,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10438,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[200,210,220,230,240]}]},"9176":{"attribute_id":9,"cost":2,"icon_id":10013,"is_multiple_command_unique_skill":0,"name":{"en":"Rising White Blaster Encore","ja":"ライジング・ホワイトブラスター Encore","ko":"라이징 화이트 블래스터 Encore","zh_hant":"冉升純白衝擊波 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5287,"skill_field_effect_id":1266,"_id_":9176,"skill_options":[{"id":20025,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10438,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9193":{"attribute_id":6,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Love","ja":"恋の一撃","ko":"사랑의 일격","zh_hant":"戀的一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5293,"skill_field_effect_id":1270,"_id_":9193,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10435,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9194":{"attribute_id":6,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Strike","ja":"停止の一撃","ko":"정지의 일격","zh_hant":"停止一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5294,"skill_field_effect_id":1271,"_id_":9194,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9195":{"attribute_id":6,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Strike","ja":"軽快な一撃","ko":"경쾌한 일격","zh_hant":"輕快一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5295,"skill_field_effect_id":1272,"_id_":9195,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9196":{"attribute_id":6,"cost":2,"icon_id":473,"is_multiple_command_unique_skill":0,"name":{"en":"Dignified Kagura","ja":"凛鳴神楽","ko":"울려 퍼지는 카구라","zh_hant":"凜鳴神樂"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5296,"skill_field_effect_id":1273,"_id_":9196,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10441,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":387,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]}]},"9198":{"attribute_id":3,"cost":2,"icon_id":469,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Expertise","ja":"達人の一撃","ko":"달인의 일격","zh_hant":"精通一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5298,"skill_field_effect_id":1277,"_id_":9198,"skill_options":[{"id":10422,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9199":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Strike","ja":"増強の一撃","ko":"증강의 일격","zh_hant":"增強一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5299,"skill_field_effect_id":1278,"_id_":9199,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9200":{"attribute_id":3,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Strike","ja":"致命の一撃","ko":"치명의 일격","zh_hant":"致命一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5300,"skill_field_effect_id":1279,"_id_":9200,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10413,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9201":{"attribute_id":3,"cost":2,"icon_id":404,"is_multiple_command_unique_skill":0,"name":{"en":"Empty Prayer Encore","ja":"空虚な祈り Encore","ko":"공허한 기도 Encore","zh_hant":"空虛的祈禱 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5301,"skill_field_effect_id":1280,"_id_":9201,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10413,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":361,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9208":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Sharpshooting","ja":"狙撃","ko":"저격","zh_hant":"狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2606,"skill_field_effect_id":0,"_id_":9208,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9209":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2607,"skill_field_effect_id":0,"_id_":9209,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9210":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2608,"skill_field_effect_id":0,"_id_":9210,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9211":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2609,"skill_field_effect_id":0,"_id_":9211,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9212":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2610,"skill_field_effect_id":0,"_id_":9212,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9213":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2611,"skill_field_effect_id":0,"_id_":9213,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9214":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Rondo","ja":"闇炎の輪舞曲","ko":"암흑 불꽃의 윤무곡","zh_hant":"暗炎圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2612,"skill_field_effect_id":0,"_id_":9214,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9215":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2613,"skill_field_effect_id":0,"_id_":9215,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9217":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2614,"skill_field_effect_id":0,"_id_":9217,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9218":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2615,"skill_field_effect_id":0,"_id_":9218,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9219":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2616,"skill_field_effect_id":0,"_id_":9219,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9220":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2617,"skill_field_effect_id":0,"_id_":9220,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9221":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2618,"skill_field_effect_id":0,"_id_":9221,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9222":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2619,"skill_field_effect_id":0,"_id_":9222,"skill_options":[{"id":82,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,170,170,170,170]}]},"9223":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2620,"skill_field_effect_id":0,"_id_":9223,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9224":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2621,"skill_field_effect_id":0,"_id_":9224,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9225":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2622,"skill_field_effect_id":0,"_id_":9225,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9226":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2623,"skill_field_effect_id":0,"_id_":9226,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9228":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":9228,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9229":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":9229,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9230":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":9230,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9231":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":9231,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9232":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":9232,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9233":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":9233,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9234":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":9234,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9235":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":9235,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9236":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":9236,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9237":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":9237,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9239":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2641,"skill_field_effect_id":0,"_id_":9239,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9240":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2642,"skill_field_effect_id":0,"_id_":9240,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9241":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2643,"skill_field_effect_id":0,"_id_":9241,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9242":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2644,"skill_field_effect_id":0,"_id_":9242,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9243":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2645,"skill_field_effect_id":0,"_id_":9243,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9244":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2646,"skill_field_effect_id":0,"_id_":9244,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9245":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2647,"skill_field_effect_id":0,"_id_":9245,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9246":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2648,"skill_field_effect_id":0,"_id_":9246,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9247":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2649,"skill_field_effect_id":0,"_id_":9247,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9249":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2650,"skill_field_effect_id":0,"_id_":9249,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9250":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2651,"skill_field_effect_id":0,"_id_":9250,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9251":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2652,"skill_field_effect_id":0,"_id_":9251,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9252":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2653,"skill_field_effect_id":0,"_id_":9252,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9253":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2654,"skill_field_effect_id":0,"_id_":9253,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9254":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Flurry","ja":"強襲の連撃","ko":"강습의 연격","zh_hant":"強襲連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2655,"skill_field_effect_id":0,"_id_":9254,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9255":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2656,"skill_field_effect_id":0,"_id_":9255,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9256":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2657,"skill_field_effect_id":0,"_id_":9256,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9257":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2658,"skill_field_effect_id":0,"_id_":9257,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9258":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2659,"skill_field_effect_id":0,"_id_":9258,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9260":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":9260,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9261":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":9261,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9262":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":9262,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9263":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":9263,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9264":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":9264,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9265":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":9265,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9266":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":9266,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9267":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":9267,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9268":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":9268,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9269":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":9269,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9270":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":9270,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9272":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":9272,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9273":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":9273,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9274":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":9274,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9275":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":9275,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9276":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":9276,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9277":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":9277,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9278":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":9278,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9279":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":9279,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9281":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":9281,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9282":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":9282,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9283":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":9283,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9284":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":9284,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9285":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":9285,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9286":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":9286,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9287":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":9287,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9288":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":9288,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9289":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":9289,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9290":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":9290,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9292":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":9292,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9293":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":9293,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9294":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":9294,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9295":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":9295,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9296":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":9296,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9297":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":9297,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9298":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":9298,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9299":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":9299,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9300":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":9300,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9301":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":9301,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9302":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":9302,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9304":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Sharpshooting","ja":"強狙撃","ko":"강한 저격","zh_hant":"強狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":9304,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9305":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":9305,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9306":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":9306,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9307":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":9307,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9308":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Sharpshooting","ja":"必中の狙撃","ko":"백발백중의 저격","zh_hant":"必中狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":9308,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9309":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":9309,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9310":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Blaze Concerto","ja":"闇炎の協奏曲","ko":"암흑 불꽃의 협주곡","zh_hant":"暗炎協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":9310,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9311":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Eat Me! NEO","ja":"Eat me！ NEO","ko":"Eat me! NEO","zh_hant":"Eat me！ NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":9311,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9313":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":9313,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9314":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":9314,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9315":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":9315,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9316":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":9316,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9317":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":9317,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9318":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":9318,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9319":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":9319,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9320":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":9320,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9321":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":9321,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9322":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Off with Her Head! NEO","ja":"首はねの刑 NEO","ko":"참수형 NEO","zh_hant":"斬首之刑 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":9322,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9324":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":9324,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9325":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":9325,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9326":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":9326,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9327":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":9327,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9328":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":9328,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9329":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":9329,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9330":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":9330,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9331":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blind Fire Flower","ja":"暗闇の炎花","ko":"암흑의 염화","zh_hant":"黑暗炎花"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":9331,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9332":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":9332,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9333":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":9333,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9334":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Sacrament NEO","ja":"秘石が導く月光の秘蹟　NEO","ko":"보석이 인도하는 달빛의 성례 NEO","zh_hant":"由秘石所引導的月光秘蹟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":9334,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9336":{"attribute_id":9,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Flash","ja":"停止の一閃","ko":"정지의 일섬","zh_hant":"停止閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5303,"skill_field_effect_id":1283,"_id_":9336,"skill_options":[{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10435,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10417,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9337":{"attribute_id":9,"cost":2,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Flash","ja":"封印の一閃","ko":"봉인의 일섬","zh_hant":"封印閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5304,"skill_field_effect_id":1284,"_id_":9337,"skill_options":[{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9338":{"attribute_id":9,"cost":2,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Contraction","ja":"狭窄の一閃","ko":"협착의 일섬","zh_hant":"視野收窄閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5305,"skill_field_effect_id":1285,"_id_":9338,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10443,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9339":{"attribute_id":9,"cost":2,"icon_id":474,"is_multiple_command_unique_skill":0,"name":{"en":"Hopeful First Bite","ja":"ドキドキ！？ファーストバイト","ko":"두근두근?! 케이크 먹여주기","zh_hant":"怦然心動的第一口蛋糕"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5306,"skill_field_effect_id":1286,"_id_":9339,"skill_options":[{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10442,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":10443,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]}]},"9341":{"attribute_id":6,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5308,"skill_field_effect_id":1290,"_id_":9341,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9342":{"attribute_id":6,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5309,"skill_field_effect_id":1291,"_id_":9342,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9343":{"attribute_id":6,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5310,"skill_field_effect_id":1292,"_id_":9343,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":362,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9344":{"attribute_id":6,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"I Will Defeat You with My Brilliance Encore","ja":"今宵 キラめきで あんたを Encore","ko":"오늘밤 반짝임으로 당신을 Encore","zh_hant":"今晚以閃耀將妳—— Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5311,"skill_field_effect_id":1293,"_id_":9344,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":362,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9346":{"attribute_id":5,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Slash","ja":"気絶の斬撃","ko":"기절의 참격","zh_hant":"昏迷斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5313,"skill_field_effect_id":1297,"_id_":9346,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10329,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[10000,11000,12000,13000,14000]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9347":{"attribute_id":5,"cost":2,"icon_id":385,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Love","ja":"恋の斬撃","ko":"사랑의 참격","zh_hant":"戀的斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5314,"skill_field_effect_id":1298,"_id_":9347,"skill_options":[{"id":10356,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[60,60,60,60,60]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9348":{"attribute_id":5,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5315,"skill_field_effect_id":1299,"_id_":9348,"skill_options":[{"id":10405,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[230,240,250,260,270]}]},"9349":{"attribute_id":5,"cost":2,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Dangerous Sweethearts Encore","ja":"危険なマイスイート Encore","ko":"위험한 마이 스위트 Encore","zh_hant":"危險的小甜心 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5316,"skill_field_effect_id":1300,"_id_":9349,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":83,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[360,370,380,390,400]}]},"9363":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2832,"skill_field_effect_id":0,"_id_":9363,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9364":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2833,"skill_field_effect_id":0,"_id_":9364,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9365":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2834,"skill_field_effect_id":0,"_id_":9365,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9366":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2835,"skill_field_effect_id":0,"_id_":9366,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9367":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2836,"skill_field_effect_id":0,"_id_":9367,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9368":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2837,"skill_field_effect_id":0,"_id_":9368,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9369":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2838,"skill_field_effect_id":0,"_id_":9369,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9370":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2839,"skill_field_effect_id":0,"_id_":9370,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":75,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9372":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":9372,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9373":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":9373,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9374":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":9374,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9375":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":9375,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9376":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":9376,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9377":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":9377,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9378":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":9378,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9379":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":9379,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9381":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2865,"skill_field_effect_id":0,"_id_":9381,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9382":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Sharpshooting","ja":"双狙撃","ko":"쌍저격","zh_hant":"雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2866,"skill_field_effect_id":0,"_id_":9382,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9383":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Sharpshooting","ja":"強襲の双狙撃","ko":"강습의 쌍저격","zh_hant":"強襲雙狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2867,"skill_field_effect_id":0,"_id_":9383,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9384":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2868,"skill_field_effect_id":0,"_id_":9384,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9385":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2869,"skill_field_effect_id":0,"_id_":9385,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9386":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2870,"skill_field_effect_id":0,"_id_":9386,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9387":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2871,"skill_field_effect_id":0,"_id_":9387,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9388":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2872,"skill_field_effect_id":0,"_id_":9388,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9389":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2873,"skill_field_effect_id":0,"_id_":9389,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9391":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":9391,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9392":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":9392,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9393":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":9393,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9394":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":9394,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9395":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":9395,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9396":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":9396,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9397":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":9397,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9398":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":9398,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9399":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":9399,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9401":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":9401,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9402":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":9402,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9403":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":9403,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9404":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":9404,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9405":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":9405,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9406":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":9406,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9407":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":9407,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9408":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":9408,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9410":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":9410,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9411":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":9411,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9412":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":9412,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9413":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":9413,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9414":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":9414,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9415":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":9415,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9416":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":9416,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9417":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":9417,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9418":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":9418,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9420":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Strike","ja":"強襲の一撃","ko":"강습의 일격","zh_hant":"強襲一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2902,"skill_field_effect_id":811,"_id_":9420,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9421":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Sharpshooting","ja":"参狙撃","ko":"삼저격","zh_hant":"參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2903,"skill_field_effect_id":811,"_id_":9421,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9422":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Sharpshooting","ja":"強襲の参狙撃","ko":"강습의 삼저격","zh_hant":"強襲參狙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2904,"skill_field_effect_id":742,"_id_":9422,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9423":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2905,"skill_field_effect_id":742,"_id_":9423,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9424":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2906,"skill_field_effect_id":742,"_id_":9424,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9425":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2907,"skill_field_effect_id":811,"_id_":9425,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9426":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Bewitching Dance","ja":"惑いの舞","ko":"미혹의 춤","zh_hant":"迷惑之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4801,"skill_field_effect_id":742,"_id_":9426,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9427":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Moonlight Rain NEO","ja":"月下叢雨 終幕 NEO","ko":"월하총우 종막 NEO","zh_hant":"月下叢雨 終幕 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4802,"skill_field_effect_id":742,"_id_":9427,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9429":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":9429,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9430":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":9430,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9431":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":9431,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9432":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":9432,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9433":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":9433,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9434":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":9434,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9435":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":9435,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9436":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":9436,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9437":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":9437,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9439":{"attribute_id":5,"cost":1,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Contraction","ja":"狭窄の斬撃","ko":"협착의 참격","zh_hant":"視野收窄斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5319,"skill_field_effect_id":1302,"_id_":9439,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20024,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10435,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10443,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9440":{"attribute_id":5,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5320,"skill_field_effect_id":1303,"_id_":9440,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20023,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10443,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9441":{"attribute_id":5,"cost":1,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Slash","ja":"封印の斬撃","ko":"봉인의 참격","zh_hant":"封印斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5321,"skill_field_effect_id":1304,"_id_":9441,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10438,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9442":{"attribute_id":5,"cost":1,"icon_id":343,"is_multiple_command_unique_skill":0,"name":{"en":"Fan Rosette Encore","ja":"扇の花結び Encore","ko":"부채 꽃매듭 Encore","zh_hant":"花結之扇 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5322,"skill_field_effect_id":1305,"_id_":9442,"skill_options":[{"id":10447,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10443,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[310,320,330,340,350]}]},"9444":{"attribute_id":9,"cost":2,"icon_id":441,"is_multiple_command_unique_skill":0,"name":{"en":"Strike of Inactivity","ja":"沈滞の一撃","ko":"침체의 일격","zh_hant":"沉滯一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5324,"skill_field_effect_id":1308,"_id_":9444,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10428,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9445":{"attribute_id":9,"cost":2,"icon_id":372,"is_multiple_command_unique_skill":0,"name":{"en":"Knockout Strike","ja":"気絶の一撃","ko":"기절의 일격","zh_hant":"昏迷一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5325,"skill_field_effect_id":1309,"_id_":9445,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10451,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10410,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9446":{"attribute_id":9,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"en":"Stop Strike","ja":"停止の一撃","ko":"정지의 일격","zh_hant":"停止一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5326,"skill_field_effect_id":1310,"_id_":9446,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10451,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9447":{"attribute_id":9,"cost":2,"icon_id":473,"is_multiple_command_unique_skill":1,"name":{"en":"Try and Kill Me, Nana Daiba Encore","ja":"殺してみせろよ 大場なな Encore","ko":"어디 한번 죽여봐 다이바 나나 Encore","zh_hant":"來殺我啊，大場奈奈！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5327,"skill_field_effect_id":1311,"_id_":9447,"skill_options":[{"id":10441,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[5,5,5,5,5]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":386,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]},{"id":10433,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"9449":{"attribute_id":4,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5329,"skill_field_effect_id":1315,"_id_":9449,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10422,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9450":{"attribute_id":4,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5330,"skill_field_effect_id":1316,"_id_":9450,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9451":{"attribute_id":4,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5331,"skill_field_effect_id":1317,"_id_":9451,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9452":{"attribute_id":4,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Nocturne Game Encore","ja":"紅月夜遊戯 Encore","ko":"붉은 달밤의 유희 Encore","zh_hant":"紅月夜遊戲 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5332,"skill_field_effect_id":1318,"_id_":9452,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10396,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10284,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9454":{"attribute_id":9,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Superstrength","ja":"怪力の一閃","ko":"괴력의 일섬","zh_hant":"怪力閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5334,"skill_field_effect_id":1321,"_id_":9454,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9455":{"attribute_id":9,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Flash","ja":"増強の一閃","ko":"증강의 일섬","zh_hant":"增強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5335,"skill_field_effect_id":1322,"_id_":9455,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9456":{"attribute_id":9,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Flash","ja":"致命の一閃","ko":"치명의 일섬","zh_hant":"致命閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5336,"skill_field_effect_id":1323,"_id_":9456,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9457":{"attribute_id":9,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Blazing Dance","ja":"美焔の舞","ko":"미염의 춤","zh_hant":"美焰之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5337,"skill_field_effect_id":1324,"_id_":9457,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9459":{"attribute_id":2,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5339,"skill_field_effect_id":1328,"_id_":9459,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10438,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9460":{"attribute_id":2,"cost":2,"icon_id":441,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Inactivity","ja":"沈滞の斬撃","ko":"침체의 참격","zh_hant":"沉滯斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5340,"skill_field_effect_id":1329,"_id_":9460,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10428,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9461":{"attribute_id":2,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5341,"skill_field_effect_id":1330,"_id_":9461,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]}]},"9462":{"attribute_id":2,"cost":2,"icon_id":476,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction Encore","ja":"塔の断罪 Encore","ko":"탑의 단죄 Encore","zh_hant":"塔之定罪 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5342,"skill_field_effect_id":1331,"_id_":9462,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9479":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2291,"skill_field_effect_id":0,"_id_":9479,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9480":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2292,"skill_field_effect_id":0,"_id_":9480,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9481":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2293,"skill_field_effect_id":0,"_id_":9481,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9482":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2294,"skill_field_effect_id":0,"_id_":9482,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9483":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2295,"skill_field_effect_id":0,"_id_":9483,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"9484":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2296,"skill_field_effect_id":0,"_id_":9484,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9485":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2297,"skill_field_effect_id":0,"_id_":9485,"skill_options":[{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9487":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":9487,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9488":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":9488,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9489":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":9489,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9490":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":9490,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9491":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":9491,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9492":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":9492,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9493":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":9493,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9494":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":9494,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9495":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":9495,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9496":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":9496,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9497":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":9497,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9499":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2329,"skill_field_effect_id":0,"_id_":9499,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9500":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2330,"skill_field_effect_id":0,"_id_":9500,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9501":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2331,"skill_field_effect_id":0,"_id_":9501,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9502":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2332,"skill_field_effect_id":0,"_id_":9502,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9503":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2333,"skill_field_effect_id":0,"_id_":9503,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9504":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2334,"skill_field_effect_id":0,"_id_":9504,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9505":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2335,"skill_field_effect_id":0,"_id_":9505,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9507":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":9507,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9508":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":9508,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9509":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":9509,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9510":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":9510,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9511":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":9511,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9512":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":9512,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9513":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":9513,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9514":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":9514,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9515":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":9515,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9516":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":9516,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9517":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":9517,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9519":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":9519,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9520":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":9520,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9521":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":9521,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9522":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":9522,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9523":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":9523,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9524":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":9524,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9525":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":9525,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9526":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":9526,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9527":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":9527,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9529":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":9529,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9530":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":9530,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9531":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":9531,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9532":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":9532,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9533":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":9533,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9534":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":9534,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9535":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":9535,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9536":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":9536,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9537":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":9537,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9538":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":9538,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9539":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":9539,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9541":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":9541,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9542":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":9542,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9543":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":9543,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9544":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":9544,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9545":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":9545,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9546":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":9546,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9547":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":9547,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9548":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":9548,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9549":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":9549,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9551":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":9551,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9552":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":9552,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9553":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":9553,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9554":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":9554,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9555":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":9555,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9556":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":9556,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9557":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":9557,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9558":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":9558,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9559":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":9559,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9560":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":9560,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9561":{"attribute_id":4,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":9561,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9563":{"attribute_id":5,"cost":1,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Slash","ja":"衰光の斬撃","ko":"쇠광의 참격","zh_hant":"衰光斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5344,"skill_field_effect_id":1334,"_id_":9563,"skill_options":[{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10456,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10413,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9564":{"attribute_id":5,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5345,"skill_field_effect_id":1335,"_id_":9564,"skill_options":[{"id":10412,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10456,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9565":{"attribute_id":5,"cost":2,"icon_id":466,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Collapse","ja":"虚脱の斬撃","ko":"허탈의 참격","zh_hant":"虛脫斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5346,"skill_field_effect_id":1336,"_id_":9565,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10456,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9566":{"attribute_id":5,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Shining Peace Encore","ja":"道に光を、戦場に花を Encore","ko":"길에 빛을, 전장에 꽃을 Encore","zh_hant":"光綻放於道路，花盛開於戰場 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5347,"skill_field_effect_id":1337,"_id_":9566,"skill_options":[{"id":20025,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10413,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9568":{"attribute_id":3,"cost":1,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"ja":"錯乱の斬撃"},"optional_description":{"ja":""},"sequence_id":5349,"skill_field_effect_id":1341,"_id_":9568,"skill_options":[{"id":10434,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9569":{"attribute_id":3,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"ja":"軽快な斬撃"},"optional_description":{"ja":""},"sequence_id":5350,"skill_field_effect_id":1342,"_id_":9569,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10417,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9570":{"attribute_id":3,"cost":2,"icon_id":479,"is_multiple_command_unique_skill":0,"name":{"ja":"短縮の斬撃"},"optional_description":{"ja":""},"sequence_id":5351,"skill_field_effect_id":1343,"_id_":9570,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10417,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9571":{"attribute_id":3,"cost":2,"icon_id":479,"is_multiple_command_unique_skill":0,"name":{"ja":"永遠の少年"},"optional_description":{"ja":""},"sequence_id":5352,"skill_field_effect_id":1344,"_id_":9571,"skill_options":[{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10353,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":389,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]}]},"9573":{"attribute_id":8,"cost":2,"icon_id":222,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Flash","ja":"衰光の一閃","ko":"쇠광의 일섬","zh_hant":"衰光閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5354,"skill_field_effect_id":1348,"_id_":9573,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":347,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9574":{"attribute_id":8,"cost":2,"icon_id":89,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant Flash","ja":"煌めく一閃","ko":"빛나는 일섬","zh_hant":"輝煌閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5355,"skill_field_effect_id":1349,"_id_":9574,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9575":{"attribute_id":8,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Fatigue","ja":"疲労の一閃","ko":"피로의 일섬","zh_hant":"疲勞閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5356,"skill_field_effect_id":1350,"_id_":9575,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9576":{"attribute_id":8,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Brilliant☆Sunshine! Encore","ja":"燦々☆サンシャイン！ Encore","ko":"눈부시게 빛나는 ☆선샤인! Encore","zh_hant":"燦爛☆陽光！ Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5357,"skill_field_effect_id":1351,"_id_":9576,"skill_options":[{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10392,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9578":{"attribute_id":1,"cost":1,"icon_id":469,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Expertise","ja":"達人の一閃","ko":"달인의 일섬","zh_hant":"精通閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5359,"skill_field_effect_id":1355,"_id_":9578,"skill_options":[{"id":10422,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10446,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10425,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2112,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9579":{"attribute_id":1,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Flash","ja":"増強の一閃","ko":"증강의 일섬","zh_hant":"增強閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5360,"skill_field_effect_id":1356,"_id_":9579,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10324,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9580":{"attribute_id":1,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Flash","ja":"致命の一閃","ko":"치명의 일섬","zh_hant":"致命閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5361,"skill_field_effect_id":1357,"_id_":9580,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":361,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[210,220,230,240,250]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9581":{"attribute_id":1,"cost":2,"icon_id":479,"is_multiple_command_unique_skill":1,"name":{"en":"Fated Moment","ja":"待ちわびた瞬間","ko":"고대하던 순간","zh_hant":"等待已久的時刻"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5362,"skill_field_effect_id":1358,"_id_":9581,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10324,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":361,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9583":{"attribute_id":4,"cost":1,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"ja":"封印の刺突"},"optional_description":{"ja":""},"sequence_id":5364,"skill_field_effect_id":1362,"_id_":9583,"skill_options":[{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10428,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10440,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9584":{"attribute_id":4,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"ja":"軽快な刺突"},"optional_description":{"ja":""},"sequence_id":5365,"skill_field_effect_id":1363,"_id_":9584,"skill_options":[{"id":10453,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9585":{"attribute_id":4,"cost":2,"icon_id":395,"is_multiple_command_unique_skill":0,"name":{"ja":"加護の刺突"},"optional_description":{"ja":""},"sequence_id":5366,"skill_field_effect_id":1364,"_id_":9585,"skill_options":[{"id":10315,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[20,20,20,20,20]},{"id":20028,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9586":{"attribute_id":4,"cost":2,"icon_id":464,"is_multiple_command_unique_skill":0,"name":{"ja":"船上の復讐"},"optional_description":{"ja":""},"sequence_id":5367,"skill_field_effect_id":1365,"_id_":9586,"skill_options":[{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9588":{"attribute_id":3,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"ja":"怪力の狙撃"},"optional_description":{"ja":""},"sequence_id":5369,"skill_field_effect_id":1369,"_id_":9588,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10280,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9589":{"attribute_id":3,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"ja":"増強の狙撃"},"optional_description":{"ja":""},"sequence_id":5370,"skill_field_effect_id":1370,"_id_":9589,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9590":{"attribute_id":3,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"ja":"致命の狙撃"},"optional_description":{"ja":""},"sequence_id":5371,"skill_field_effect_id":1371,"_id_":9590,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":364,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9591":{"attribute_id":3,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"ja":"妖精のいたずら"},"optional_description":{"ja":""},"sequence_id":5372,"skill_field_effect_id":1372,"_id_":9591,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":364,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9593":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3221,"skill_field_effect_id":0,"_id_":9593,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9594":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強斬撃"},"optional_description":{"ja":""},"sequence_id":3222,"skill_field_effect_id":0,"_id_":9594,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9595":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3223,"skill_field_effect_id":0,"_id_":9595,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9596":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":3224,"skill_field_effect_id":0,"_id_":9596,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9597":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の斬撃"},"optional_description":{"ja":""},"sequence_id":3225,"skill_field_effect_id":0,"_id_":9597,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"9598":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"炎舞"},"optional_description":{"ja":""},"sequence_id":3226,"skill_field_effect_id":0,"_id_":9598,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9599":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":3227,"skill_field_effect_id":0,"_id_":9599,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9600":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"浄化の舞"},"optional_description":{"ja":""},"sequence_id":3228,"skill_field_effect_id":0,"_id_":9600,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9601":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"シャイニングホープ★ NEO"},"optional_description":{"ja":""},"sequence_id":3229,"skill_field_effect_id":0,"_id_":9601,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9603":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3460,"skill_field_effect_id":0,"_id_":9603,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9604":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3461,"skill_field_effect_id":0,"_id_":9604,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9605":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3462,"skill_field_effect_id":0,"_id_":9605,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9606":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3463,"skill_field_effect_id":0,"_id_":9606,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9607":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3464,"skill_field_effect_id":0,"_id_":9607,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9608":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3465,"skill_field_effect_id":0,"_id_":9608,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9609":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"防衛の協奏曲"},"optional_description":{"ja":""},"sequence_id":3466,"skill_field_effect_id":0,"_id_":9609,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9610":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3467,"skill_field_effect_id":0,"_id_":9610,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9611":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"威光堂々　～銀河皇帝円舞曲～　NEO"},"optional_description":{"ja":""},"sequence_id":3468,"skill_field_effect_id":0,"_id_":9611,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9613":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3257,"skill_field_effect_id":0,"_id_":9613,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9614":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強斬撃"},"optional_description":{"ja":""},"sequence_id":3258,"skill_field_effect_id":0,"_id_":9614,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9615":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3259,"skill_field_effect_id":0,"_id_":9615,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9616":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":3260,"skill_field_effect_id":0,"_id_":9616,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9617":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の連撃"},"optional_description":{"ja":""},"sequence_id":3261,"skill_field_effect_id":0,"_id_":9617,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9618":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"炎舞"},"optional_description":{"ja":""},"sequence_id":3262,"skill_field_effect_id":0,"_id_":9618,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9619":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":3263,"skill_field_effect_id":0,"_id_":9619,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"9620":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"浄化の舞"},"optional_description":{"ja":""},"sequence_id":3264,"skill_field_effect_id":0,"_id_":9620,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9621":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"シャイニングホープ★ NEO"},"optional_description":{"ja":""},"sequence_id":3265,"skill_field_effect_id":0,"_id_":9621,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9623":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3469,"skill_field_effect_id":0,"_id_":9623,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9624":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3470,"skill_field_effect_id":0,"_id_":9624,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9625":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3471,"skill_field_effect_id":0,"_id_":9625,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9626":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3472,"skill_field_effect_id":0,"_id_":9626,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9627":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3473,"skill_field_effect_id":0,"_id_":9627,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9628":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3474,"skill_field_effect_id":0,"_id_":9628,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9629":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"防衛の協奏曲"},"optional_description":{"ja":""},"sequence_id":3475,"skill_field_effect_id":0,"_id_":9629,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":126,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9630":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":3476,"skill_field_effect_id":0,"_id_":9630,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9631":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3477,"skill_field_effect_id":0,"_id_":9631,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9632":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"威光堂々　～銀河皇帝円舞曲～　NEO"},"optional_description":{"ja":""},"sequence_id":3478,"skill_field_effect_id":0,"_id_":9632,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]}]},"9634":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":9634,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9635":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強斬撃"},"optional_description":{"ja":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":9635,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9636":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":9636,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9637":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":9637,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9638":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":9638,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9639":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の連撃"},"optional_description":{"ja":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":9639,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9640":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"炎舞"},"optional_description":{"ja":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":9640,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9641":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":9641,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9642":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"浄化の舞"},"optional_description":{"ja":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":9642,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9643":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"シャイニングホープ★ NEO"},"optional_description":{"ja":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":9643,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9645":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":9645,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9646":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":9646,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9647":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":9647,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9648":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":9648,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9649":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"防衛の協奏曲"},"optional_description":{"ja":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":9649,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"9650":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":9650,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9651":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":9651,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9652":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"威光堂々　～銀河皇帝円舞曲～　NEO"},"optional_description":{"ja":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":9652,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9654":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3294,"skill_field_effect_id":811,"_id_":9654,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9655":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強斬撃"},"optional_description":{"ja":""},"sequence_id":3295,"skill_field_effect_id":742,"_id_":9655,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9656":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3296,"skill_field_effect_id":742,"_id_":9656,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9657":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3297,"skill_field_effect_id":811,"_id_":9657,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9658":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3298,"skill_field_effect_id":742,"_id_":9658,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9659":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の連撃"},"optional_description":{"ja":""},"sequence_id":3299,"skill_field_effect_id":742,"_id_":9659,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9660":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"炎舞"},"optional_description":{"ja":""},"sequence_id":4660,"skill_field_effect_id":742,"_id_":9660,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9661":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":3301,"skill_field_effect_id":811,"_id_":9661,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9662":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"浄化の舞"},"optional_description":{"ja":""},"sequence_id":3302,"skill_field_effect_id":742,"_id_":9662,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9663":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"シャイニングホープ★ NEO"},"optional_description":{"ja":""},"sequence_id":4661,"skill_field_effect_id":742,"_id_":9663,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9665":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3479,"skill_field_effect_id":811,"_id_":9665,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9666":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3480,"skill_field_effect_id":811,"_id_":9666,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9667":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3481,"skill_field_effect_id":742,"_id_":9667,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9668":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3482,"skill_field_effect_id":742,"_id_":9668,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9669":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"防衛の協奏曲"},"optional_description":{"ja":""},"sequence_id":3483,"skill_field_effect_id":742,"_id_":9669,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10100,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[30,30,30,30,30]}]},"9670":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":4656,"skill_field_effect_id":742,"_id_":9670,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9671":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3485,"skill_field_effect_id":811,"_id_":9671,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9672":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"威光堂々　～銀河皇帝円舞曲～　NEO"},"optional_description":{"ja":""},"sequence_id":4657,"skill_field_effect_id":742,"_id_":9672,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9686":{"attribute_id":2,"cost":2,"icon_id":429,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Support","ja":"支援の斬撃","ko":"지원의 참격","zh_hant":"支援斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5374,"skill_field_effect_id":1376,"_id_":9686,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10422,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9687":{"attribute_id":2,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5375,"skill_field_effect_id":1377,"_id_":9687,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[4,4,4,4,4],"values":[50,50,50,50,50]},{"id":10347,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9688":{"attribute_id":2,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5376,"skill_field_effect_id":1378,"_id_":9688,"skill_options":[{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":10361,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[220,230,240,250,260]}]},"9689":{"attribute_id":2,"cost":2,"icon_id":417,"is_multiple_command_unique_skill":0,"name":{"en":"Dark Feast Encore","ja":"Dark feast Encore","ko":"Dark feast Encore","zh_hant":"Dark feast Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5377,"skill_field_effect_id":1379,"_id_":9689,"skill_options":[{"id":10345,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":624,"hit_rate":100,"target_id":6020,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9691":{"attribute_id":8,"cost":2,"icon_id":400,"is_multiple_command_unique_skill":0,"name":{"en":"Seal Flash","ja":"封印の一閃","ko":"봉인의 일섬","zh_hant":"封印閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5379,"skill_field_effect_id":1383,"_id_":9691,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10445,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9692":{"attribute_id":8,"cost":2,"icon_id":394,"is_multiple_command_unique_skill":0,"name":{"en":"Static Flash","ja":"鈍足の一閃","ko":"둔화의 일섬","zh_hant":"慢行閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5380,"skill_field_effect_id":1384,"_id_":9692,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10456,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[50,50,50,50,50]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9693":{"attribute_id":8,"cost":2,"icon_id":482,"is_multiple_command_unique_skill":0,"name":{"en":"Flash of Shortening","ja":"短縮の一閃","ko":"단축의 일섬","zh_hant":"縮短閃光"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5381,"skill_field_effect_id":1385,"_id_":9693,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[240,250,260,270,280]}]},"9694":{"attribute_id":8,"cost":2,"icon_id":479,"is_multiple_command_unique_skill":0,"name":{"en":"This Road Is Where We Part Encore","ja":"ここが別れの一本道 Encore","ko":"이곳이 이별의 외길 Encore","zh_hant":"此處即為離別的一人道 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5382,"skill_field_effect_id":1386,"_id_":9694,"skill_options":[{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":388,"hit_rate":100,"target_id":2002,"times":[15,15,15,15,15],"values":[410,420,430,440,450]},{"id":10433,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"9696":{"attribute_id":1,"cost":1,"icon_id":433,"is_multiple_command_unique_skill":0,"name":{"ja":"錯乱の斬撃"},"optional_description":{"ja":""},"sequence_id":5384,"skill_field_effect_id":1390,"_id_":9696,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10467,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10361,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9697":{"attribute_id":1,"cost":2,"icon_id":345,"is_multiple_command_unique_skill":0,"name":{"ja":"停止の斬撃"},"optional_description":{"ja":""},"sequence_id":5385,"skill_field_effect_id":1391,"_id_":9697,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10467,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10417,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9698":{"attribute_id":1,"cost":2,"icon_id":466,"is_multiple_command_unique_skill":0,"name":{"ja":"虚脱の斬撃"},"optional_description":{"ja":""},"sequence_id":5386,"skill_field_effect_id":1392,"_id_":9698,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10467,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9699":{"attribute_id":1,"cost":2,"icon_id":454,"is_multiple_command_unique_skill":0,"name":{"ja":"金色の魔法"},"optional_description":{"ja":""},"sequence_id":5387,"skill_field_effect_id":1393,"_id_":9699,"skill_options":[{"id":10454,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10468,"hit_rate":100,"target_id":2011,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9701":{"attribute_id":2,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"ja":"軽快な斬撃"},"optional_description":{"ja":""},"sequence_id":5389,"skill_field_effect_id":1397,"_id_":9701,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":20026,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":10438,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9702":{"attribute_id":2,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"ja":"疲労の斬撃"},"optional_description":{"ja":""},"sequence_id":5390,"skill_field_effect_id":1398,"_id_":9702,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9703":{"attribute_id":2,"cost":2,"icon_id":479,"is_multiple_command_unique_skill":0,"name":{"ja":"短縮の斬撃"},"optional_description":{"ja":""},"sequence_id":5391,"skill_field_effect_id":1399,"_id_":9703,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2114,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9704":{"attribute_id":2,"cost":2,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"ja":"気高き魂"},"optional_description":{"ja":""},"sequence_id":5392,"skill_field_effect_id":1400,"_id_":9704,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9706":{"attribute_id":8,"cost":2,"icon_id":398,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Superstrength","ja":"怪力の斬撃","ko":"괴력의 참격","zh_hant":"怪力斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5394,"skill_field_effect_id":1404,"_id_":9706,"skill_options":[{"id":10319,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10453,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10284,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9707":{"attribute_id":8,"cost":2,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5395,"skill_field_effect_id":1405,"_id_":9707,"skill_options":[{"id":89,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[20,20,20,20,20]},{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10284,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9708":{"attribute_id":8,"cost":2,"icon_id":365,"is_multiple_command_unique_skill":0,"name":{"en":"Fatal Slash","ja":"致命の斬撃","ko":"치명의 참격","zh_hant":"致命斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5396,"skill_field_effect_id":1406,"_id_":9708,"skill_options":[{"id":10282,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10283,"hit_rate":100,"target_id":1002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10446,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":471,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[30,30,30,30,30]},{"id":363,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[200,210,220,230,240]}]},"9709":{"attribute_id":8,"cost":2,"icon_id":360,"is_multiple_command_unique_skill":1,"name":{"en":"Glory of Rebirth Encore","ja":"蘇る栄光 Encore","ko":"되살아나는 영광 Encore","zh_hant":"重拾榮光 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5397,"skill_field_effect_id":1407,"_id_":9709,"skill_options":[{"id":10357,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[100,100,100,100,100]},{"id":10260,"hit_rate":100,"target_id":2111,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10349,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":363,"hit_rate":100,"target_id":6010,"times":[20,20,20,20,20],"values":[480,510,540,570,600]}]},"9711":{"attribute_id":9,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5399,"skill_field_effect_id":1411,"_id_":9711,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2112,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9712":{"attribute_id":9,"cost":1,"icon_id":479,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Shortening","ja":"短縮の斬撃","ko":"단축의 참격","zh_hant":"縮短斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5400,"skill_field_effect_id":1412,"_id_":9712,"skill_options":[{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2113,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9713":{"attribute_id":9,"cost":2,"icon_id":338,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Slash","ja":"重圧の斬撃","ko":"중압의 참격","zh_hant":"重壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5401,"skill_field_effect_id":1413,"_id_":9713,"skill_options":[{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10467,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2114,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[210,220,230,240,250]}]},"9714":{"attribute_id":9,"cost":2,"icon_id":487,"is_multiple_command_unique_skill":1,"name":{"en":"Love & Rebirth Judgement Encore","ja":"Love＆Rebirth Judgment Encore","ko":"Love & Rebirth Judgment Encore","zh_hant":"Love＆Rebirth Judgment Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5402,"skill_field_effect_id":1414,"_id_":9714,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":630,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10440,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[20,20,20,20,20]},{"id":310,"hit_rate":100,"target_id":2002,"times":[12,12,12,12,12],"values":[360,370,380,390,400]}]},"9731":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"狙撃"},"optional_description":{"ja":""},"sequence_id":2606,"skill_field_effect_id":0,"_id_":9731,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9732":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強狙撃"},"optional_description":{"ja":""},"sequence_id":2607,"skill_field_effect_id":0,"_id_":9732,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9733":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2608,"skill_field_effect_id":0,"_id_":9733,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9734":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":2609,"skill_field_effect_id":0,"_id_":9734,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9735":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の狙撃"},"optional_description":{"ja":""},"sequence_id":2610,"skill_field_effect_id":0,"_id_":9735,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9736":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2611,"skill_field_effect_id":0,"_id_":9736,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9737":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"闇炎の輪舞曲"},"optional_description":{"ja":""},"sequence_id":2612,"skill_field_effect_id":0,"_id_":9737,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9738":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"Eat me！ NEO"},"optional_description":{"ja":""},"sequence_id":2613,"skill_field_effect_id":0,"_id_":9738,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":55,"hit_rate":100,"target_id":2113,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9740":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":2614,"skill_field_effect_id":0,"_id_":9740,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9741":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2615,"skill_field_effect_id":0,"_id_":9741,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9742":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":2616,"skill_field_effect_id":0,"_id_":9742,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9743":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2617,"skill_field_effect_id":0,"_id_":9743,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9744":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2618,"skill_field_effect_id":0,"_id_":9744,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9745":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の連撃"},"optional_description":{"ja":""},"sequence_id":2619,"skill_field_effect_id":0,"_id_":9745,"skill_options":[{"id":82,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[170,170,170,170,170]}]},"9746":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":2620,"skill_field_effect_id":0,"_id_":9746,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9747":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"柔和の協奏曲"},"optional_description":{"ja":""},"sequence_id":2621,"skill_field_effect_id":0,"_id_":9747,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9748":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"惑いの協奏曲"},"optional_description":{"ja":""},"sequence_id":2622,"skill_field_effect_id":0,"_id_":9748,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9749":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"首はねの刑 NEO"},"optional_description":{"ja":""},"sequence_id":2623,"skill_field_effect_id":0,"_id_":9749,"skill_options":[{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9751":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3239,"skill_field_effect_id":0,"_id_":9751,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9752":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3240,"skill_field_effect_id":0,"_id_":9752,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9753":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3241,"skill_field_effect_id":0,"_id_":9753,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9754":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3242,"skill_field_effect_id":0,"_id_":9754,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9755":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3243,"skill_field_effect_id":0,"_id_":9755,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9756":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3244,"skill_field_effect_id":0,"_id_":9756,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9757":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の連撃"},"optional_description":{"ja":""},"sequence_id":3245,"skill_field_effect_id":0,"_id_":9757,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9758":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3246,"skill_field_effect_id":0,"_id_":9758,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9759":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"無力の協奏曲"},"optional_description":{"ja":""},"sequence_id":3247,"skill_field_effect_id":0,"_id_":9759,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9760":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"秘石が導く月光の秘蹟　NEO"},"optional_description":{"ja":""},"sequence_id":3248,"skill_field_effect_id":0,"_id_":9760,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9762":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強狙撃"},"optional_description":{"ja":""},"sequence_id":2641,"skill_field_effect_id":0,"_id_":9762,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9763":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":2642,"skill_field_effect_id":0,"_id_":9763,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9764":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強双撃"},"optional_description":{"ja":""},"sequence_id":2643,"skill_field_effect_id":0,"_id_":9764,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9765":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2644,"skill_field_effect_id":0,"_id_":9765,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9766":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":2645,"skill_field_effect_id":0,"_id_":9766,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9767":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の狙撃"},"optional_description":{"ja":""},"sequence_id":2646,"skill_field_effect_id":0,"_id_":9767,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9768":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2647,"skill_field_effect_id":0,"_id_":9768,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9769":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"闇炎の協奏曲"},"optional_description":{"ja":""},"sequence_id":2648,"skill_field_effect_id":0,"_id_":9769,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9770":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"Eat me！ NEO"},"optional_description":{"ja":""},"sequence_id":2649,"skill_field_effect_id":0,"_id_":9770,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9772":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":2650,"skill_field_effect_id":0,"_id_":9772,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9773":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2651,"skill_field_effect_id":0,"_id_":9773,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9774":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":2652,"skill_field_effect_id":0,"_id_":9774,"skill_options":[{"id":80,"hit_rate":100,"target_id":2112,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9775":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2653,"skill_field_effect_id":0,"_id_":9775,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9776":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2654,"skill_field_effect_id":0,"_id_":9776,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9777":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の連撃"},"optional_description":{"ja":""},"sequence_id":2655,"skill_field_effect_id":0,"_id_":9777,"skill_options":[{"id":82,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9778":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":2656,"skill_field_effect_id":0,"_id_":9778,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9779":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"柔和の協奏曲"},"optional_description":{"ja":""},"sequence_id":2657,"skill_field_effect_id":0,"_id_":9779,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9780":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"惑いの協奏曲"},"optional_description":{"ja":""},"sequence_id":2658,"skill_field_effect_id":0,"_id_":9780,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9781":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"首はねの刑 NEO"},"optional_description":{"ja":""},"sequence_id":2659,"skill_field_effect_id":0,"_id_":9781,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":75,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9783":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3275,"skill_field_effect_id":0,"_id_":9783,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9784":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":3276,"skill_field_effect_id":0,"_id_":9784,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9785":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3277,"skill_field_effect_id":0,"_id_":9785,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9786":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3278,"skill_field_effect_id":0,"_id_":9786,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9787":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3279,"skill_field_effect_id":0,"_id_":9787,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9788":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3280,"skill_field_effect_id":0,"_id_":9788,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9789":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の協奏曲"},"optional_description":{"ja":""},"sequence_id":3281,"skill_field_effect_id":0,"_id_":9789,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9790":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":3282,"skill_field_effect_id":0,"_id_":9790,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9791":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3283,"skill_field_effect_id":0,"_id_":9791,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9792":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"無力の協奏曲"},"optional_description":{"ja":""},"sequence_id":3284,"skill_field_effect_id":0,"_id_":9792,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9793":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"秘石が導く月光の秘蹟　NEO"},"optional_description":{"ja":""},"sequence_id":3285,"skill_field_effect_id":0,"_id_":9793,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":62,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]}]},"9795":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強狙撃"},"optional_description":{"ja":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":9795,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9796":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":9796,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9797":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":9797,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9798":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":9798,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9799":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の狙撃"},"optional_description":{"ja":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":9799,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9800":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":9800,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9801":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"闇炎の協奏曲"},"optional_description":{"ja":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":9801,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9802":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"Eat me！ NEO"},"optional_description":{"ja":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":9802,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9804":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":9804,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9805":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":9805,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9806":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":9806,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9807":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":9807,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9808":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":9808,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9809":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"追撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":9809,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9810":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":9810,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9811":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"柔和の協奏曲"},"optional_description":{"ja":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":9811,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9812":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"惑いの協奏曲"},"optional_description":{"ja":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":9812,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9813":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"首はねの刑 NEO"},"optional_description":{"ja":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":9813,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9815":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":9815,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9816":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":9816,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9817":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":9817,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9818":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":9818,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9819":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":9819,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9820":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":9820,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9821":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の協奏曲"},"optional_description":{"ja":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":9821,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9822":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":9822,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9823":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":9823,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9824":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"無力の協奏曲"},"optional_description":{"ja":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":9824,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9825":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"秘石が導く月光の秘蹟　NEO"},"optional_description":{"ja":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":9825,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9827":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強狙撃"},"optional_description":{"ja":""},"sequence_id":2678,"skill_field_effect_id":811,"_id_":9827,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9828":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2679,"skill_field_effect_id":811,"_id_":9828,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9829":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強参撃"},"optional_description":{"ja":""},"sequence_id":2680,"skill_field_effect_id":742,"_id_":9829,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9830":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2681,"skill_field_effect_id":742,"_id_":9830,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9831":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の狙撃"},"optional_description":{"ja":""},"sequence_id":2682,"skill_field_effect_id":742,"_id_":9831,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9832":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":2683,"skill_field_effect_id":811,"_id_":9832,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9833":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"闇炎の協奏曲"},"optional_description":{"ja":""},"sequence_id":5080,"skill_field_effect_id":742,"_id_":9833,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9834":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"Eat me！ NEO"},"optional_description":{"ja":""},"sequence_id":5081,"skill_field_effect_id":742,"_id_":9834,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9836":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":2686,"skill_field_effect_id":811,"_id_":9836,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9837":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の斬撃"},"optional_description":{"ja":""},"sequence_id":2687,"skill_field_effect_id":742,"_id_":9837,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9838":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":2688,"skill_field_effect_id":742,"_id_":9838,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9839":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":2689,"skill_field_effect_id":811,"_id_":9839,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9840":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2690,"skill_field_effect_id":742,"_id_":9840,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9841":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"追撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":2691,"skill_field_effect_id":742,"_id_":9841,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9842":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"堅守の舞"},"optional_description":{"ja":""},"sequence_id":2692,"skill_field_effect_id":811,"_id_":9842,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"9843":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"柔和の協奏曲"},"optional_description":{"ja":""},"sequence_id":2693,"skill_field_effect_id":742,"_id_":9843,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9844":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"惑いの協奏曲"},"optional_description":{"ja":""},"sequence_id":5082,"skill_field_effect_id":742,"_id_":9844,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9845":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"首はねの刑 NEO"},"optional_description":{"ja":""},"sequence_id":5083,"skill_field_effect_id":742,"_id_":9845,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10020,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9847":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"斬撃"},"optional_description":{"ja":""},"sequence_id":3314,"skill_field_effect_id":811,"_id_":9847,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9848":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"双撃"},"optional_description":{"ja":""},"sequence_id":3315,"skill_field_effect_id":811,"_id_":9848,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9849":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の双撃"},"optional_description":{"ja":""},"sequence_id":3316,"skill_field_effect_id":742,"_id_":9849,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9850":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"参撃"},"optional_description":{"ja":""},"sequence_id":3317,"skill_field_effect_id":742,"_id_":9850,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9851":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"強襲の参撃"},"optional_description":{"ja":""},"sequence_id":3318,"skill_field_effect_id":742,"_id_":9851,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9852":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"迎撃の協奏曲"},"optional_description":{"ja":""},"sequence_id":3319,"skill_field_effect_id":742,"_id_":9852,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9853":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"必中の協奏曲"},"optional_description":{"ja":""},"sequence_id":3320,"skill_field_effect_id":742,"_id_":9853,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9854":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"暗闇の炎花"},"optional_description":{"ja":""},"sequence_id":5084,"skill_field_effect_id":742,"_id_":9854,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9855":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"奮起の風"},"optional_description":{"ja":""},"sequence_id":3322,"skill_field_effect_id":811,"_id_":9855,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9856":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"無力の協奏曲"},"optional_description":{"ja":""},"sequence_id":3323,"skill_field_effect_id":742,"_id_":9856,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9857":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"ja":"秘石が導く月光の秘蹟　NEO"},"optional_description":{"ja":""},"sequence_id":5085,"skill_field_effect_id":742,"_id_":9857,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10030,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9859":{"attribute_id":9,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5404,"skill_field_effect_id":1418,"_id_":9859,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":387,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9860":{"attribute_id":9,"cost":2,"icon_id":453,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Fatigue","ja":"疲労の斬撃","ko":"피로의 참격","zh_hant":"疲勞斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5405,"skill_field_effect_id":1419,"_id_":9860,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":387,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9861":{"attribute_id":9,"cost":2,"icon_id":464,"is_multiple_command_unique_skill":0,"name":{"en":"Overpower Slash","ja":"威圧の斬撃","ko":"위압의 참격","zh_hant":"威壓斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5406,"skill_field_effect_id":1420,"_id_":9861,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2124,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":387,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9862":{"attribute_id":9,"cost":2,"icon_id":471,"is_multiple_command_unique_skill":0,"name":{"en":"This Road Is Where We Part Encore","ja":"ここが別れの一本道 Encore","ko":"이곳이 이별의 외길 Encore","zh_hant":"此處即為離別的一人道 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5407,"skill_field_effect_id":1421,"_id_":9862,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":629,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":387,"hit_rate":100,"target_id":2002,"times":[16,16,16,16,16],"values":[380,400,420,450,500]},{"id":10433,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[50,50,50,50,50]}]},"9864":{"attribute_id":8,"cost":1,"icon_id":419,"is_multiple_command_unique_skill":0,"name":{"en":"Happy Slash","ja":"軽快な斬撃","ko":"경쾌한 참격","zh_hant":"輕快斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5409,"skill_field_effect_id":1425,"_id_":9864,"skill_options":[{"id":10464,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10449,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[40,40,40,40,40]},{"id":10469,"hit_rate":100,"target_id":1002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2122,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":386,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9865":{"attribute_id":8,"cost":1,"icon_id":425,"is_multiple_command_unique_skill":0,"name":{"en":"Slash of Contraction","ja":"狭窄の斬撃","ko":"협착의 참격","zh_hant":"視野收窄斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5410,"skill_field_effect_id":1426,"_id_":9865,"skill_options":[{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10443,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2123,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":386,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9866":{"attribute_id":8,"cost":1,"icon_id":310,"is_multiple_command_unique_skill":0,"name":{"en":"Strengthening Slash","ja":"増強の斬撃","ko":"증강의 참격","zh_hant":"增強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5411,"skill_field_effect_id":1427,"_id_":9866,"skill_options":[{"id":572,"hit_rate":100,"target_id":1002,"times":[0,0,0,0,0],"values":[1,1,1,1,1]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[2,2,2,2,2]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10284,"hit_rate":100,"target_id":2124,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":386,"hit_rate":100,"target_id":2121,"times":[1,1,1,1,1],"values":[240,250,260,270,280]}]},"9867":{"attribute_id":8,"cost":1,"icon_id":464,"is_multiple_command_unique_skill":0,"name":{"en":"Karen Aijo—to the Next Stage! Encore","ja":"愛城華恋は次の舞台へ Encore","ko":"아이조 카렌은 다음 무대로 Encore","zh_hant":"愛城華戀即將邁向下一個舞台 Encore"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":5412,"skill_field_effect_id":1428,"_id_":9867,"skill_options":[{"id":10447,"hit_rate":100,"target_id":1002,"times":[1,1,1,1,1],"values":[50,50,50,50,50]},{"id":10457,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[4,4,4,4,4]},{"id":10461,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":629,"hit_rate":100,"target_id":2701,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":386,"hit_rate":100,"target_id":2002,"times":[16,16,16,16,16],"values":[380,400,420,450,500]}]},"9869":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2840,"skill_field_effect_id":0,"_id_":9869,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9870":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2841,"skill_field_effect_id":0,"_id_":9870,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9871":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2842,"skill_field_effect_id":0,"_id_":9871,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9872":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Flurry","ja":"連撃","ko":"연격","zh_hant":"連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2843,"skill_field_effect_id":0,"_id_":9872,"skill_options":[{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9873":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Rondo","ja":"無力の輪舞曲","ko":"무력의 윤무곡","zh_hant":"無力圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2844,"skill_field_effect_id":0,"_id_":9873,"skill_options":[{"id":21,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":23,"hit_rate":100,"target_id":2123,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9874":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2845,"skill_field_effect_id":0,"_id_":9874,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9875":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2846,"skill_field_effect_id":0,"_id_":9875,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9876":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2847,"skill_field_effect_id":0,"_id_":9876,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9878":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2624,"skill_field_effect_id":0,"_id_":9878,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9879":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2625,"skill_field_effect_id":0,"_id_":9879,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9880":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2626,"skill_field_effect_id":0,"_id_":9880,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9881":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2627,"skill_field_effect_id":0,"_id_":9881,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9882":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2628,"skill_field_effect_id":0,"_id_":9882,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9883":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2629,"skill_field_effect_id":0,"_id_":9883,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9884":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2630,"skill_field_effect_id":0,"_id_":9884,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9885":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2631,"skill_field_effect_id":0,"_id_":9885,"skill_options":[{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9887":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2874,"skill_field_effect_id":0,"_id_":9887,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9888":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2875,"skill_field_effect_id":0,"_id_":9888,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9889":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2876,"skill_field_effect_id":0,"_id_":9889,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9890":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2877,"skill_field_effect_id":0,"_id_":9890,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9891":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2878,"skill_field_effect_id":0,"_id_":9891,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9892":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2879,"skill_field_effect_id":0,"_id_":9892,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9893":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2880,"skill_field_effect_id":0,"_id_":9893,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":23,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9894":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2881,"skill_field_effect_id":0,"_id_":9894,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"9895":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2882,"skill_field_effect_id":0,"_id_":9895,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9896":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2883,"skill_field_effect_id":0,"_id_":9896,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9898":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2660,"skill_field_effect_id":0,"_id_":9898,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9899":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2661,"skill_field_effect_id":0,"_id_":9899,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9900":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2662,"skill_field_effect_id":0,"_id_":9900,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9901":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2663,"skill_field_effect_id":0,"_id_":9901,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9902":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2664,"skill_field_effect_id":0,"_id_":9902,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9903":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Rondo","ja":"減光の輪舞曲","ko":"감광의 윤무곡","zh_hant":"減光圓舞曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2665,"skill_field_effect_id":0,"_id_":9903,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":259,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9904":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2666,"skill_field_effect_id":0,"_id_":9904,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9905":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Drowsy Concerto","ja":"眠りの協奏曲","ko":"잠의 협주곡","zh_hant":"睡眠協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2667,"skill_field_effect_id":0,"_id_":9905,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9906":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2668,"skill_field_effect_id":0,"_id_":9906,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":58,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9908":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":9908,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9909":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":9909,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9910":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":9910,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9911":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":9911,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9912":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":9912,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9913":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":9913,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9914":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":9914,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9915":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":9915,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"9916":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":9916,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9917":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":9917,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9919":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":9919,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9920":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":9920,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9921":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":9921,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9922":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":9922,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9923":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":9923,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9924":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":9924,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9925":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":9925,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9926":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":9926,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9927":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":9927,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9929":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2910,"skill_field_effect_id":811,"_id_":9929,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9930":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2911,"skill_field_effect_id":742,"_id_":9930,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9931":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2912,"skill_field_effect_id":811,"_id_":9931,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9932":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2913,"skill_field_effect_id":742,"_id_":9932,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9933":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2914,"skill_field_effect_id":742,"_id_":9933,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9934":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2915,"skill_field_effect_id":742,"_id_":9934,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9935":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Helpless Concerto","ja":"無力の協奏曲","ko":"무력의 협주곡","zh_hant":"無力協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2916,"skill_field_effect_id":742,"_id_":9935,"skill_options":[{"id":21,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10308,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9936":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Evasion Dance","ja":"回避の舞","ko":"회피의 춤","zh_hant":"迴避之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2917,"skill_field_effect_id":811,"_id_":9936,"skill_options":[{"id":18,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[50,50,50,50,50]}]},"9937":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Flurry","ja":"必中の連撃","ko":"백발백중의 연격","zh_hant":"必中連擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4803,"skill_field_effect_id":742,"_id_":9937,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9938":{"attribute_id":5,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Cherry Blossom Quick-Draw NEO","ja":"桜花抜刀術　壱式 NEO","ko":"벚꽃발도술 일식 NEO","zh_hant":"櫻花拔刀術　壹式 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4804,"skill_field_effect_id":742,"_id_":9938,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10292,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9940":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2696,"skill_field_effect_id":811,"_id_":9940,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9941":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2697,"skill_field_effect_id":811,"_id_":9941,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9942":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2698,"skill_field_effect_id":742,"_id_":9942,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9943":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2699,"skill_field_effect_id":742,"_id_":9943,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9944":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pursuit Concerto","ja":"追撃の協奏曲","ko":"추격의 협주곡","zh_hant":"追擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2700,"skill_field_effect_id":742,"_id_":9944,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9945":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dim Concerto","ja":"減光の協奏曲","ko":"감광의 협주곡","zh_hant":"減光協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2701,"skill_field_effect_id":811,"_id_":9945,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":10300,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[60,65,70,75,80]}]},"9946":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2702,"skill_field_effect_id":742,"_id_":9946,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"9947":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Freezing Concerto","ja":"凍てつく協奏曲","ko":"얼어붙은 협주곡","zh_hant":"凍結的協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4805,"skill_field_effect_id":742,"_id_":9947,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9948":{"attribute_id":6,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Upside Down World NEO","ja":"逆転世界の開眼 NEO","ko":"역전세계의 개안 NEO","zh_hant":"翻轉世界的領悟 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4806,"skill_field_effect_id":742,"_id_":9948,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"9950":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2282,"skill_field_effect_id":0,"_id_":9950,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9951":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2283,"skill_field_effect_id":0,"_id_":9951,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9952":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2284,"skill_field_effect_id":0,"_id_":9952,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9953":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2285,"skill_field_effect_id":0,"_id_":9953,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9954":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2286,"skill_field_effect_id":0,"_id_":9954,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[5000,5000,5000,5000,5000]}]},"9955":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2287,"skill_field_effect_id":0,"_id_":9955,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"9956":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2288,"skill_field_effect_id":0,"_id_":9956,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9957":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2289,"skill_field_effect_id":0,"_id_":9957,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9958":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2290,"skill_field_effect_id":0,"_id_":9958,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":59,"hit_rate":100,"target_id":2123,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9960":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2291,"skill_field_effect_id":0,"_id_":9960,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9961":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2292,"skill_field_effect_id":0,"_id_":9961,"skill_options":[{"id":80,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9962":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2293,"skill_field_effect_id":0,"_id_":9962,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9963":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2294,"skill_field_effect_id":0,"_id_":9963,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9964":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2295,"skill_field_effect_id":0,"_id_":9964,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[180,180,180,180,180]}]},"9965":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2296,"skill_field_effect_id":0,"_id_":9965,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9966":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2297,"skill_field_effect_id":0,"_id_":9966,"skill_options":[{"id":224,"hit_rate":100,"target_id":2113,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9968":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1972,"skill_field_effect_id":0,"_id_":9968,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9969":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1973,"skill_field_effect_id":0,"_id_":9969,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9970":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1974,"skill_field_effect_id":0,"_id_":9970,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9971":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1975,"skill_field_effect_id":0,"_id_":9971,"skill_options":[{"id":1,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9972":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1976,"skill_field_effect_id":0,"_id_":9972,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9973":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1977,"skill_field_effect_id":0,"_id_":9973,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9974":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1978,"skill_field_effect_id":0,"_id_":9974,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"9975":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1979,"skill_field_effect_id":0,"_id_":9975,"skill_options":[{"id":55,"hit_rate":50,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9976":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1980,"skill_field_effect_id":0,"_id_":9976,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9977":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1981,"skill_field_effect_id":0,"_id_":9977,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9978":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":1982,"skill_field_effect_id":0,"_id_":9978,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"9980":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2318,"skill_field_effect_id":0,"_id_":9980,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9981":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2319,"skill_field_effect_id":0,"_id_":9981,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9982":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2320,"skill_field_effect_id":0,"_id_":9982,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"9983":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Dual Slash","ja":"強双撃","ko":"강한 쌍격","zh_hant":"強雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2321,"skill_field_effect_id":0,"_id_":9983,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"9984":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2322,"skill_field_effect_id":0,"_id_":9984,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9985":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2323,"skill_field_effect_id":0,"_id_":9985,"skill_options":[{"id":80,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9986":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2324,"skill_field_effect_id":0,"_id_":9986,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[7000,7000,7000,7000,7000]}]},"9987":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Strike","ja":"必中の一撃","ko":"백발백중의 일격","zh_hant":"必中一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2325,"skill_field_effect_id":0,"_id_":9987,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9988":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Wind","ja":"浄化の風","ko":"정화의 바람","zh_hant":"淨化之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2326,"skill_field_effect_id":0,"_id_":9988,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"9989":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2327,"skill_field_effect_id":0,"_id_":9989,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9990":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2328,"skill_field_effect_id":0,"_id_":9990,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":59,"hit_rate":50,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"9992":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2329,"skill_field_effect_id":0,"_id_":9992,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9993":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2330,"skill_field_effect_id":0,"_id_":9993,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"9994":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2331,"skill_field_effect_id":0,"_id_":9994,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"9995":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2332,"skill_field_effect_id":0,"_id_":9995,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"9996":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2333,"skill_field_effect_id":0,"_id_":9996,"skill_options":[{"id":35,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"9997":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2334,"skill_field_effect_id":0,"_id_":9997,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"9998":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2335,"skill_field_effect_id":0,"_id_":9998,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":224,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"10000":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Slash","ja":"斬撃","ko":"참격","zh_hant":"斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2010,"skill_field_effect_id":0,"_id_":10000,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10001":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2011,"skill_field_effect_id":0,"_id_":10001,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10002":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2012,"skill_field_effect_id":0,"_id_":10002,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"10003":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2013,"skill_field_effect_id":0,"_id_":10003,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"10004":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2014,"skill_field_effect_id":0,"_id_":10004,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10005":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2015,"skill_field_effect_id":0,"_id_":10005,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10006":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2016,"skill_field_effect_id":0,"_id_":10006,"skill_options":[{"id":8,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":20,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]},{"id":22,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[20,20,20,20,20]}]},"10007":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2017,"skill_field_effect_id":0,"_id_":10007,"skill_options":[{"id":55,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[3000,3000,3000,3000,3000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"10008":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2018,"skill_field_effect_id":0,"_id_":10008,"skill_options":[{"id":9,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"10009":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2019,"skill_field_effect_id":0,"_id_":10009,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[120,120,120,120,120]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"10010":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2020,"skill_field_effect_id":0,"_id_":10010,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":32,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[20,20,20,20,20]}]},"10012":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":811,"_id_":10012,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10013":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":10013,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10014":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":742,"_id_":10014,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10015":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":10015,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10016":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":10016,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10017":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":10017,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"10018":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":10018,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10019":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":10019,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"10020":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":10020,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10021":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":10021,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"10022":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":10022,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[99999,99999,99999,99999,99999]}]},"10024":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":10024,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10025":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":10025,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10026":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":10026,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10027":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":10027,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10028":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":10028,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"10029":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":10029,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10030":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":10030,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10031":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":10031,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10032":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":10032,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[250,250,250,250,250]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10034":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":10034,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10035":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":10035,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"10036":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":10036,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"10037":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":10037,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10038":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":10038,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10039":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":10039,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10040":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":10040,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"10041":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":10041,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":57,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"10042":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":10042,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10043":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":10043,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"10044":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":10044,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"10046":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strike","ja":"一撃","ko":"일격","zh_hant":"一擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2356,"skill_field_effect_id":742,"_id_":10046,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10047":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Slash","ja":"強斬撃","ko":"강한 참격","zh_hant":"強斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2357,"skill_field_effect_id":811,"_id_":10047,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10048":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2358,"skill_field_effect_id":811,"_id_":10048,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10049":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Slash","ja":"強参撃","ko":"강한 삼격","zh_hant":"強參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2359,"skill_field_effect_id":742,"_id_":10049,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10050":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2360,"skill_field_effect_id":742,"_id_":10050,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10051":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Ironclad Dance","ja":"堅守の舞","ko":"굳은 수호의 춤","zh_hant":"堅守之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2361,"skill_field_effect_id":811,"_id_":10051,"skill_options":[{"id":30,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]},{"id":31,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[10000,10000,10000,10000,10000]}]},"10052":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Perfect Aim Concerto","ja":"必中の協奏曲","ko":"백발백중의 협주곡","zh_hant":"必中協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2362,"skill_field_effect_id":742,"_id_":10052,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10053":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Purifying Dance","ja":"浄化の舞","ko":"정화의 춤","zh_hant":"淨化之舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2363,"skill_field_effect_id":742,"_id_":10053,"skill_options":[{"id":128,"hit_rate":100,"target_id":1001,"times":[0,0,0,0,0],"values":[0,0,0,0,0]},{"id":127,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[0,0,0,0,0]}]},"10054":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2364,"skill_field_effect_id":742,"_id_":10054,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":12,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10055":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Befuddling Concerto","ja":"惑いの協奏曲","ko":"미혹의 협주곡","zh_hant":"迷惑協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4615,"skill_field_effect_id":742,"_id_":10055,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10056":{"attribute_id":3,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Blue Days Pierce NEO","ja":"ブルーデイズの一刺し NEO","ko":"블루 데이즈의 일격찌르기 NEO","zh_hant":"藍天刺擊 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4616,"skill_field_effect_id":742,"_id_":10056,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[4,4,4,4,4],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10058":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Smash","ja":"打撃","ko":"타격","zh_hant":"敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2367,"skill_field_effect_id":811,"_id_":10058,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10059":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Smash","ja":"強打撃","ko":"강한 타격","zh_hant":"強敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2368,"skill_field_effect_id":742,"_id_":10059,"skill_options":[{"id":1,"hit_rate":100,"target_id":2011,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10060":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Smash","ja":"参打撃","ko":"삼타격","zh_hant":"參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2369,"skill_field_effect_id":742,"_id_":10060,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10061":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Strong Triple Smash","ja":"強参打撃","ko":"강한 삼타격","zh_hant":"強參敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2370,"skill_field_effect_id":811,"_id_":10061,"skill_options":[{"id":81,"hit_rate":100,"target_id":2113,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10062":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Accuracy Smash","ja":"必中の打撃","ko":"백발백중의 타격","zh_hant":"必中敲擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2371,"skill_field_effect_id":742,"_id_":10062,"skill_options":[{"id":10292,"hit_rate":100,"target_id":1001,"times":[1,1,1,1,1],"values":[0,0,0,0,0]},{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]}]},"10063":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2372,"skill_field_effect_id":742,"_id_":10063,"skill_options":[{"id":80,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10064":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Softening Concerto","ja":"柔和の協奏曲","ko":"유화의 협주곡","zh_hant":"柔和協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2373,"skill_field_effect_id":811,"_id_":10064,"skill_options":[{"id":11,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":13,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10065":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Pressure Concerto","ja":"重圧の協奏曲","ko":"중압의 협주곡","zh_hant":"重壓協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4617,"skill_field_effect_id":742,"_id_":10065,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[200,200,200,200,200]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10066":{"attribute_id":1,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Buttercup Carpet NEO","ja":"金鳳花の絨毯 NEO","ko":"미나리아재비의 양탄자 NEO","zh_hant":"毛茛地毯 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4618,"skill_field_effect_id":742,"_id_":10066,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10050,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]}]},"10068":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Slash","ja":"強襲の斬撃","ko":"강습의 참격","zh_hant":"強襲斬擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2050,"skill_field_effect_id":811,"_id_":10068,"skill_options":[{"id":1,"hit_rate":100,"target_id":2121,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10069":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Dual Slash","ja":"双撃","ko":"쌍격","zh_hant":"雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2051,"skill_field_effect_id":742,"_id_":10069,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[80,80,80,80,80]}]},"10070":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Dual Slash","ja":"強襲の双撃","ko":"강습의 쌍격","zh_hant":"強襲雙擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2052,"skill_field_effect_id":811,"_id_":10070,"skill_options":[{"id":80,"hit_rate":100,"target_id":2122,"times":[0,0,0,0,0],"values":[120,120,120,120,120]}]},"10071":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Triple Slash","ja":"参撃","ko":"삼격","zh_hant":"參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2053,"skill_field_effect_id":742,"_id_":10071,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[70,70,70,70,70]}]},"10072":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Violent Triple Slash","ja":"強襲の参撃","ko":"강습의 삼격","zh_hant":"強襲參擊"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2054,"skill_field_effect_id":742,"_id_":10072,"skill_options":[{"id":81,"hit_rate":100,"target_id":2123,"times":[0,0,0,0,0],"values":[100,100,100,100,100]}]},"10073":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Concerto","ja":"迎撃の協奏曲","ko":"요격의 협주곡","zh_hant":"迎擊協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2055,"skill_field_effect_id":742,"_id_":10073,"skill_options":[{"id":82,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]}]},"10074":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Inspiring Gust","ja":"奮起の風","ko":"분기의 바람","zh_hant":"奮起之風"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2056,"skill_field_effect_id":742,"_id_":10074,"skill_options":[{"id":10338,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[50,50,50,50,50]},{"id":10306,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]},{"id":10282,"hit_rate":100,"target_id":1001,"times":[3,3,3,3,3],"values":[30,30,30,30,30]}]},"10075":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Restraint Firedance","ja":"抑止の炎舞","ko":"억제의 염무","zh_hant":"抑止的炎舞"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2057,"skill_field_effect_id":742,"_id_":10075,"skill_options":[{"id":10010,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10291,"hit_rate":100,"target_id":2002,"times":[2,2,2,2,2],"values":[0,0,0,0,0]}]},"10076":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Weakening Concerto","ja":"脱力の協奏曲","ko":"탈력의 협주곡","zh_hant":"虛脫協奏曲"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":2058,"skill_field_effect_id":811,"_id_":10076,"skill_options":[{"id":10307,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[50,50,50,50,50]}]},"10077":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Counter Solo","ja":"反撃の独奏","ko":"반격의 독주","zh_hant":"反擊獨奏"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4619,"skill_field_effect_id":742,"_id_":10077,"skill_options":[{"id":81,"hit_rate":100,"target_id":2002,"times":[0,0,0,0,0],"values":[150,150,150,150,150]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]},"10078":{"attribute_id":2,"cost":2,"icon_id":1,"is_multiple_command_unique_skill":0,"name":{"en":"Tower's Conviction NEO","ja":"塔の断罪 NEO","ko":"탑의 단죄 NEO","zh_hant":"塔之定罪 NEO"},"optional_description":{"en":"","ja":"","ko":"","zh_hant":""},"sequence_id":4620,"skill_field_effect_id":742,"_id_":10078,"skill_options":[{"id":320,"hit_rate":100,"target_id":2002,"times":[3,3,3,3,3],"values":[99999,99999,99999,99999,99999]},{"id":10160,"hit_rate":100,"target_id":2002,"times":[1,1,1,1,1],"values":[99999,99999,99999,99999,99999]},{"id":10339,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]},{"id":10340,"hit_rate":100,"target_id":1001,"times":[2,2,2,2,2],"values":[30,30,30,30,30]}]}}"""
